(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3530,9526],{

/***/ 93494:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14759);


/* harmony default export */ __webpack_exports__["Z"] = ({
    poster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an image placeholder",
        labelDescription: "Image should keep youtube video aspect ratio (default 16:9)"
    },
    alt: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Description (alt)",
        translatable: true
    },
    videoId: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Youtube Video ID"
    },
    playButtonColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Play Button Color",
        possibleColors: Object.keys(_constants__WEBPACK_IMPORTED_MODULE_1__/* .buttonThemes */ .l)
    },
    playButtonSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Play Button Size",
        options: [
            {
                value: _constants__WEBPACK_IMPORTED_MODULE_1__.MD,
                text: "Medium"
            },
            {
                value: _constants__WEBPACK_IMPORTED_MODULE_1__.LG,
                text: "Large"
            }
        ]
    },
    showShadow: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show shadow"
    }
});


/***/ }),

/***/ 33530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ DynamicTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/templates/base-template.js + 61 modules
var base_template = __webpack_require__(50691);
// EXTERNAL MODULE: ./contexts/segment-context.js
var segment_context = __webpack_require__(39944);
// EXTERNAL MODULE: ./constants/element-ids.js
var element_ids = __webpack_require__(53219);
// EXTERNAL MODULE: ./components/enhancements/error-wrapper/error-state-constants.js
var error_state_constants = __webpack_require__(2395);
// EXTERNAL MODULE: ./utils/dynamicPage.js
var dynamicPage = __webpack_require__(34949);
// EXTERNAL MODULE: ./node_modules/react-error-boundary/dist/react-error-boundary.umd.js
var react_error_boundary_umd = __webpack_require__(35800);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./services/bigbrain-service.js + 1 modules
var bigbrain_service = __webpack_require__(95470);
// EXTERNAL MODULE: ./contexts/preview-base-segment-context.js + 5 modules
var preview_base_segment_context = __webpack_require__(69132);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/desktop/index.js + 19 modules
var desktop = __webpack_require__(29107);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(51529);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);
// EXTERNAL MODULE: ./utils/general.js
var general = __webpack_require__(56093);
// EXTERNAL MODULE: ./components/templates/dynamic-template/segments-layout-list/base-layout-segment/base-layout-segment-component.scss.js
var base_layout_segment_component_scss = __webpack_require__(19563);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/base-layout-segment/base-layout-segment-component.js





function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
















var shouldDisplayForSpecificCountry = function(countrySpecificDisplaySettings, cloudfrontViewerCountry, isPreview) {
    if (isPreview || !(countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.countryDisplayMode) || !(countrySpecificDisplaySettings === null || countrySpecificDisplaySettings === void 0 ? void 0 : countrySpecificDisplaySettings.country)) {
        return true;
    }
    var countryDisplayMode = countrySpecificDisplaySettings.countryDisplayMode, country = countrySpecificDisplaySettings.country;
    var isCountryIncluded;
    if (Array.isArray(country)) {
        var countries = country === null || country === void 0 ? void 0 : country.map(function(countryObject) {
            return countryObject.country;
        });
        isCountryIncluded = countries === null || countries === void 0 ? void 0 : countries.includes(cloudfrontViewerCountry);
    } else {
        isCountryIncluded = country === cloudfrontViewerCountry;
    }
    return countryDisplayMode === shared_advanced_fields_config/* COUNTRY_DISPLAY_MODE.INCLUDE */.Us.INCLUDE ? isCountryIncluded : !isCountryIncluded;
};
var PERCENTAGE_REGEX = /^\d+(\.\d+)?%$/;
var getGradientThemeStyles = function() {
    var gradientColors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var _getTheme, _gradientColors_;
    return {
        background: "linear-gradient(180deg, ".concat(gradientColors.map(function(param) {
            var color = param.color;
            var _getTheme;
            var backgroundColor = (_getTheme = (0,segments_service/* getTheme */.gh)(color)) === null || _getTheme === void 0 ? void 0 : _getTheme.background;
            return backgroundColor ? "".concat((0,general/* hexToRgba */.a7)(backgroundColor, 1)) : "";
        }).join(", "), ")"),
        color: (_getTheme = (0,segments_service/* getTheme */.gh)((_gradientColors_ = gradientColors[0]) === null || _gradientColors_ === void 0 ? void 0 : _gradientColors_.color)) === null || _getTheme === void 0 ? void 0 : _getTheme.color
    };
};
var BaseLayoutSegmentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(BaseLayoutSegmentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(BaseLayoutSegmentComponent);
    function BaseLayoutSegmentComponent(props) {
        (0,_class_call_check/* default */.Z)(this, BaseLayoutSegmentComponent);
        var _this;
        _this = _super.call(this, props);
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "onVisibilityChange", function(isVisible) {
            var _props = _this.props, index = _props.index, segment = _props.segment;
            var visibilityEvent = isVisible ? bigbrain_event_types.SEGMENT_VISIBLE_IN_VIEWPORT : bigbrain_event_types.SEGMENT_NOT_VISIBLE_IN_VIEWPORT;
            var ref = segment.props.visibilitySensorProps || {}, visibilityOffset = ref.visibilityOffset, useInfinitely = ref.useInfinitely;
            !useInfinitely && isVisible && _this.setState({
                isInView: true
            });
            useInfinitely && _this.setState({
                isInView: isVisible
            });
            (0,bigbrain_service.trackEvent)(visibilityEvent, {
                kind: segment.type,
                info1: visibilityOffset,
                info2: window.scrollY,
                placement: index
            });
        });
        _define_property((0,_assert_this_initialized/* default */.Z)(_this), "getOffset", function(offset) {
            var isOffsetInPercentages = PERCENTAGE_REGEX.test(offset);
            if (!(0,general/* isServerSide */.s$)() && isOffsetInPercentages) {
                return parseInt(offset) / 100 * window.innerHeight;
            }
            return parseInt(offset);
        });
        _this.state = {
            isInView: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(BaseLayoutSegmentComponent, [
        {
            key: "getSegmentComponent",
            value: function getSegmentComponent() {
                var _Segments_segment_type;
                var segment = this.props.segment;
                var segmentComponent = (_Segments_segment_type = desktop/* default */.Z[segment.type]) === null || _Segments_segment_type === void 0 ? void 0 : _Segments_segment_type.component;
                if (!segmentComponent) {
                    (0,bigbrain_service.trackEvent)(bigbrain_event_types.SEGMENT_LAYOUT_NOT_FOUND, {
                        kind: segment.type
                    });
                    return false;
                }
                return segmentComponent;
            }
        },
        {
            key: "getHtmlComponentElementFromDom",
            value: function getHtmlComponentElementFromDom() {
                var baseLayoutComponentClassName = this.getBaseLayoutComponentClassName();
                var ssrComponent = document.querySelector(".".concat(baseLayoutComponentClassName));
                return ssrComponent ? ssrComponent.innerHTML : null;
            }
        },
        {
            key: "getSegmentStyle",
            value: function getSegmentStyle(segmentProps) {
                var paddingTop = segmentProps.paddingTop, paddingBottom = segmentProps.paddingBottom, segmentMinHeight = segmentProps.segmentMinHeight;
                var isMobileOrTabletBrowser = this.props.isMobileOrTabletBrowser;
                var theme = segmentProps.theme, gradientTheme = segmentProps.gradientTheme, mobilePaddingTop = segmentProps.mobilePaddingTop, mobilePaddingBottom = segmentProps.mobilePaddingBottom, baseLayoutStyleProps = segmentProps.baseLayoutStyleProps;
                var themeStyles = (gradientTheme === null || gradientTheme === void 0 ? void 0 : gradientTheme.length) ? getGradientThemeStyles(gradientTheme) : segments_service/* themes */.np[theme];
                if (isMobileOrTabletBrowser) {
                    paddingTop = mobilePaddingTop || paddingTop;
                    paddingBottom = mobilePaddingBottom || paddingBottom;
                }
                return _object_spread_props(_object_spread({}, themeStyles, baseLayoutStyleProps), {
                    paddingTop: paddingTop,
                    paddingBottom: paddingBottom,
                    minHeight: segmentMinHeight
                });
            }
        },
        {
            key: "getBaseLayoutComponentClassName",
            value: function getBaseLayoutComponentClassName() {
                var index = this.props.index;
                return "base-layout-segment-component-".concat(index);
            }
        },
        {
            key: "getTriangleBorderStyle",
            value: function getTriangleBorderStyle(triangle) {
                var color = colors/* default */.Z[triangle === null || triangle === void 0 ? void 0 : triangle.color] || colors/* default */.Z[color_consts.SPACE_BLUE_COLOR_NAME];
                return "".concat(100 * base_layout_segment_component_scss/* triangleHeightFactor */._, "vw solid ").concat(color);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, segment = _props.segment, isUserLoggedIn = _props.isUserLoggedIn, extraProps = _props.extraProps, isMobileBrowser = _props.isMobileBrowser, dynamicProps = _props.dynamicProps, isPreview = _props.isPreview, cloudfrontViewerCountry = _props.cloudfrontViewerCountry;
                var isInView = this.state.isInView;
                if (!segment) return null;
                var _segment_props = segment.props, segmentId = _segment_props.segmentId, hideOnMobile = _segment_props.hideOnMobile, showOnDevice = _segment_props.showOnDevice, topTriangle = _segment_props.topTriangle, bottomTriangle = _segment_props.bottomTriangle, visibilitySensorProps = _segment_props.visibilitySensorProps, wrapInCard = _segment_props.wrapInCard, sticky = _segment_props.sticky, countrySpecificDisplaySettings = _segment_props.countrySpecificDisplaySettings, restSegmentProps = _object_without_properties(_segment_props, [
                    "segmentId",
                    "hideOnMobile",
                    "showOnDevice",
                    "topTriangle",
                    "bottomTriangle",
                    "visibilitySensorProps",
                    "wrapInCard",
                    "sticky",
                    "countrySpecificDisplaySettings"
                ]);
                var ref = sticky || {}, isSticky = ref.isSticky, stickyTopOffset = ref.stickyTopOffset;
                var ref1 = visibilitySensorProps || {}, useVisibilitySensor = ref1.useVisibilitySensor, visibilityOffset = ref1.visibilityOffset, easeInEffect = ref1.easeInEffect;
                if (showOnDevice) {
                    if (showOnDevice === "mobile" && !isMobileBrowser) {
                        return null;
                    }
                    if (showOnDevice === "desktop" && isMobileBrowser) {
                        return null;
                    }
                } else if (hideOnMobile && isMobileBrowser) {
                    return null;
                }
                var SegmentComponent = this.getSegmentComponent();
                if (!SegmentComponent) return null;
                var SegmentComponentWithGenericConfig = (0,generic_config_context/* withGenericConfig */.P)(SegmentComponent);
                var segmentStyle = this.getSegmentStyle(segment.props);
                var topTriangleBorderBottom = this.getTriangleBorderStyle(topTriangle);
                var bottomTriangleBorderTop = this.getTriangleBorderStyle(bottomTriangle);
                var parsedVisibilityOffset = this.getOffset(visibilityOffset);
                var shouldDisplaySegment = shouldDisplayForSpecificCountry(countrySpecificDisplaySettings, cloudfrontViewerCountry, isPreview);
                if (!shouldDisplaySegment) return null;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)((visibility_sensor_default()), {
                    offset: {
                        bottom: parsedVisibilityOffset || 0,
                        top: parsedVisibilityOffset || 0
                    },
                    partialVisibility: true,
                    onChange: this.onVisibilityChange,
                    active: !!useVisibilitySensor,
                    scrollCheck: !!useVisibilitySensor,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_layout_segment_component_scss/* StyledBaseLayoutSegmentComponent */.u, {
                        cardBackgroundColor: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardBackgroundColor,
                        cardBorderStyle: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardBorderStyle,
                        cardWidth: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardWidth,
                        cardPadding: wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardPadding,
                        stickyTopOffset: isSticky && stickyTopOffset,
                        id: segmentId,
                        className: classnames_default()("base-layout-segment-component", {
                            sticky: !!isSticky
                        }, {
                            "ease-in": easeInEffect
                        }, {
                            "ease-in-animation": isInView && easeInEffect
                        }, this.getBaseLayoutComponentClassName()),
                        style: segmentStyle,
                        children: [
                            (topTriangle === null || topTriangle === void 0 ? void 0 : topTriangle.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("triangle", "top", "bottom-left-corner"),
                                style: {
                                    borderBottom: topTriangleBorderBottom
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()("segment-wrapper", {
                                    card: !!(wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.active)
                                }),
                                children: [
                                    (wrapInCard === null || wrapInCard === void 0 ? void 0 : wrapInCard.cardAsset) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "background-asset",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, _object_spread({}, wrapInCard.cardAsset))
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentComponentWithGenericConfig, _object_spread_props(_object_spread({}, extraProps, restSegmentProps), {
                                        dynamicProps: dynamicProps,
                                        isUserLoggedIn: isUserLoggedIn,
                                        segmentType: segment.type,
                                        isInView: isInView
                                    }))
                                ]
                            }),
                            (bottomTriangle === null || bottomTriangle === void 0 ? void 0 : bottomTriangle.isVisible) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classnames_default()("triangle", "bottom", "top-right-corner"),
                                style: {
                                    borderTop: bottomTriangleBorderTop
                                }
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return BaseLayoutSegmentComponent;
}(react.PureComponent);
BaseLayoutSegmentComponent.defaultProps = {
    extraProps: {}
};
var BaseLayoutSegmentComponentContainer = function(props) {
    var Component = props.isPreview ? (0,preview_base_segment_context/* withPreviewBaseSegment */.I)(BaseLayoutSegmentComponent) : (0,generic_config_context/* withGenericConfig */.P)(BaseLayoutSegmentComponent);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, _object_spread({}, props));
};
/* harmony default export */ var base_layout_segment_component = (BaseLayoutSegmentComponentContainer);

// EXTERNAL MODULE: ./components/templates/dynamic-template/dynamic-template-service.js
var dynamic_template_service = __webpack_require__(87210);
;// CONCATENATED MODULE: ./components/templates/dynamic-template/segments-layout-list/segments-layout-list-component.js











var SegmentsLayoutListComponent = function(props) {
    var segments = props.segments;
    var components = segments;
    var mainContentComponents = (0,react.useMemo)(function() {
        return segments.filter(function(segment) {
            return (0,dynamic_template_service/* isMainContentComponent */.WC)(segment.type);
        });
    }, [
        segments
    ]);
    var withHeaderComponent = (0,react.useMemo)(function() {
        var firstComponentName = components.length > 0 ? components[0].type : "";
        return (0,dynamic_template_service/* isHeaderComponent */.kr)(firstComponentName);
    }, [
        components
    ]);
    var withFooterComponent = (0,react.useMemo)(function() {
        var lastComponentName = components.length > 0 ? components[components.length - 1].type : "";
        return (0,dynamic_template_service/* isFooterComponent */.LS)(lastComponentName);
    }, [
        components
    ]);
    var getSegmentNumber = function(index) {
        return withHeaderComponent ? index : index + 1;
    };
    var myErrorHandler = function(error, info, segment) {
        (0,bigbrain_service.trackEvent)(bigbrain_event_types.CLIENT_ERROR_STATE_CAUGHT, {
            placement: error_state_constants/* ERROR_GROUPS.SEGMENT_LAYOUT */.R.SEGMENT_LAYOUT,
            info1: segment === null || segment === void 0 ? void 0 : segment.type,
            info2: JSON.stringify((error === null || error === void 0 ? void 0 : error.message) || {}).substring(0, 500),
            info3: JSON.stringify((info === null || info === void 0 ? void 0 : info.componentStack) || {}).substring(0, 500),
            data: segment === null || segment === void 0 ? void 0 : segment.props
        });
    };
    var renderSegment = function(segment, index) {
        var isUserLoggedIn = props.isUserLoggedIn, extraProps = props.extraProps, segmentComponents = props.segmentComponents, isPreview = props.isPreview, isMobile = props.isMobile, dynamicData = props.dynamicData;
        var segmentComponent = segmentComponents[index];
        var segmentType = segment === null || segment === void 0 ? void 0 : segment.type;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(segment_context/* SegmentContext.Provider */.k.Provider, {
            value: {
                isFirstSegment: (mainContentComponents === null || mainContentComponents === void 0 ? void 0 : mainContentComponents[0]) === segment,
                segmentNumber: getSegmentNumber(index),
                segmentType: segmentType
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_error_boundary_umd.ErrorBoundary, {
                FallbackComponent: function() {
                    return null;
                },
                onError: function(error, info) {
                    return myErrorHandler(error, info, segment);
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(base_layout_segment_component, {
                    dynamicProps: (0,dynamicPage/* getDynamicPropsBySegmentLayoutId */.Fb)(dynamicData, segment.id),
                    isMobile: isMobile,
                    isPreview: isPreview,
                    index: index,
                    extraProps: extraProps,
                    segment: segment,
                    isUserLoggedIn: isUserLoggedIn,
                    segmentComponent: segmentComponent
                })
            })
        }, index);
    };
    var renderHeaderIfNeeded = function() {
        if (!withHeaderComponent) return null;
        var headerIndex = 0;
        return renderSegment(components[headerIndex], headerIndex);
    };
    var renderFooterIfNeeded = function() {
        if (!withFooterComponent) return null;
        var footerIndex = components.length - 1;
        return renderSegment(components[footerIndex], footerIndex);
    };
    var renderMainSegments = function() {
        return segments.map(function(s, index) {
            if (!(0,dynamic_template_service/* isHeaderComponent */.kr)(s.type) && !(0,dynamic_template_service/* isFooterComponent */.LS)(s.type)) {
                return renderSegment(s, index);
            }
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            renderHeaderIfNeeded(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                id: element_ids/* MAIN_ID */.k,
                children: renderMainSegments()
            }),
            renderFooterIfNeeded()
        ]
    });
};
/* harmony default export */ var segments_layout_list_component = (SegmentsLayoutListComponent);

// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/dynamic-template/dynamic-template.scss.js
var dynamic_template_scss = __webpack_require__(87292);
// EXTERNAL MODULE: ./devlink/DevLinkProvider.js
var DevLinkProvider = __webpack_require__(11379);
;// CONCATENATED MODULE: ./utils/webflow-fixes.js
// FIX: Prevent auto-scroll from Webflow tabs on page load
// PROBLEM: Webflow TabsWrapper calls nextTabHeader?.focus() during initialization,
// which triggers browser's scroll-into-view behavior, causing unwanted page scroll
// SOLUTION: Temporarily override focus() to use preventScroll:true for w-tab-link elements
// during the critical 100ms initialization window, then restore normal behavior
function webflow_fixes_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function webflow_fixes_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            webflow_fixes_define_property(target, key, source[key]);
        });
    }
    return target;
}
function webflow_fixes_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function webflow_fixes_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        webflow_fixes_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var preventWebflowTabsAutoScroll = function() {
    var originalFocus = HTMLElement.prototype.focus;
    HTMLElement.prototype.focus = function preventWebflowTabsAutoScroll() {
        var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        if (this.classList.contains("w-tab-link")) {
            return originalFocus.call(this, webflow_fixes_object_spread_props(webflow_fixes_object_spread({}, options), {
                preventScroll: true
            }));
        }
        return originalFocus.call(this, options);
    };
    setTimeout(function() {
        HTMLElement.prototype.focus = originalFocus;
    }, 100);
};

;// CONCATENATED MODULE: ./components/templates/dynamic-template/dynamic-template.js




function dynamic_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function dynamic_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function dynamic_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        dynamic_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}









var DynamicTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DynamicTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DynamicTemplate);
    function DynamicTemplate(props) {
        (0,_class_call_check/* default */.Z)(this, DynamicTemplate);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            rootEl: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(DynamicTemplate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                preventWebflowTabsAutoScroll();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var rootEl = this.state.rootEl;
                var _props = this.props, pageConfig = _props.pageConfig, segmentComponents = _props.segmentComponents, isPreview = _props.isPreview, exitPopup = _props.exitPopup, dynamicData = _props.dynamicData;
                var segments = pageConfig.segments, isMobile = pageConfig.isMobile, templateClassName = pageConfig.templateClassName, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(base_template/* default */.Z, dynamic_template_object_spread_props(dynamic_template_object_spread({}, this.props, pageConfig), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DevLinkProvider/* DevLinkProvider */.T, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(dynamic_template_scss/* StyledDynamicTemplate */.f, {
                            ref: function(el) {
                                return _this.setState({
                                    rootEl: el
                                });
                            },
                            className: classnames_default()("dynamic-template", templateClassName),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(segments_layout_list_component, {
                                    isMobile: isMobile,
                                    isPreview: isPreview,
                                    segments: segments,
                                    dynamicData: dynamicData,
                                    segmentComponents: segmentComponents,
                                    rootEl: rootEl
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                                    exitPopup: exitPopup,
                                    exitPopupConfig: exitPopupConfig
                                })
                            ]
                        })
                    })
                }));
            }
        }
    ]);
    return DynamicTemplate;
}(react.PureComponent);

DynamicTemplate.defaultProps = {
    exitPopup: true,
    segmentComponents: []
};


/***/ }),

/***/ 64265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nz": function() { return /* binding */ CUSTOMER_KEY_OSCAR; },
/* harmony export */   "bd": function() { return /* binding */ CUSTOMER_KEY_ZIPPO; },
/* harmony export */   "iV": function() { return /* binding */ CUSTOMER_KEY_THE_STUDENT_HOTEL; },
/* harmony export */   "tx": function() { return /* binding */ CUSTOMER_KEY_TELEFONICA; },
/* harmony export */   "vK": function() { return /* binding */ CUSTOMER_KEY_NISSAN; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14924);

var CUSTOMER_KEY_OSCAR = "oscar";
var CUSTOMER_KEY_THE_STUDENT_HOTEL = "theStudentHotel";
var CUSTOMER_KEY_TELEFONICA = "telefonica";
var CUSTOMER_KEY_ZIPPO = "zippo";
var CUSTOMER_KEY_NISSAN = "nissan";
var _obj;
/* harmony default export */ __webpack_exports__["ZP"] = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_OSCAR, {
    companyName: "Oscar",
    name: "Stefana Muller",
    jobDescription: "Senior Director, CTO Product and Program Office",
    quote: "monday.com Work OS saves us about 1,850 hrs of staff time and somewhere in the range of $50,000 a month."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_THE_STUDENT_HOTEL, {
    companyName: "The Student Hotel",
    name: "Charlie MacGregor",
    jobDescription: "Founder & CEO",
    quote: "Now that we have monday.com Work OS as the backbone of our organization I feel that I have an overview I can trust."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_TELEFONICA, {
    companyName: "Telefonica",
    name: "Tye Rapley-Hawkins",
    jobDescription: "Head of Delivery",
    quote: "With monday.com, we’re 30% more efficient at delivering hundreds of campaigns seen by millions of customers."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_ZIPPO, {
    companyName: "Zippo",
    name: "Chris Funk",
    jobDescription: "Director of Product Innovation",
    quote: "monday.com Work OS has enabled our group to launch more product categories and expand into more markets in way less time."
}), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, CUSTOMER_KEY_NISSAN, {
    companyName: "Nissan",
    name: "Kenny Wallace",
    jobDescription: "Vendor Tooling Engineer, Nissan North America",
    quote: "monday.com has given me the confidence because when I walk into the room I know that when upper management asks for a certain piece of information I’m able to quickly provide it for them."
}), _obj);


/***/ }),

/***/ 11379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* reexport safe */ _devlinkContext__WEBPACK_IMPORTED_MODULE_0__.T; }
/* harmony export */ });
/* harmony import */ var _devlinkContext__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4849);



/***/ }),

/***/ 59477:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * Webflow: Front-end site library
 * @license MIT
 * Inline scripts may access the api using an async handler:
 *   var Webflow = Webflow || [];
 *   Webflow.push(readyFunction);
 */ 
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    createIX2Engine: function() {
        return JF;
    },
    default: function() {
        return y1;
    }
});
var _defineProperty = (__webpack_require__(79361)["default"]);
var _instanceof = (__webpack_require__(96856)/* ["default"] */ .Z);
var _toConsumableArray = (__webpack_require__(53929)/* ["default"] */ .Z);
var _typeOf = (__webpack_require__(45753)["default"]);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var c = function(e, t) {
    return function() {
        return t || e((t = {
            exports: {}
        }).exports, t), t.exports;
    };
};
var lr = c(function(tq, mi) {
    var Zp = typeof __webpack_require__.g == "object" && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;
    mi.exports = Zp;
});
var W = c(function(rq, Ni) {
    var Jp = lr(), eE = typeof self == "object" && self && self.Object === Object && self, tE = Jp || eE || Function("return this")();
    Ni.exports = tE;
});
var _e = c(function(nq, Pi) {
    var rE = W(), nE = rE.Symbol;
    Pi.exports = nE;
});
var Mi = c(function(iq, Di) {
    var uE = function uE(e) {
        var t = iE.call(e, xe), r = e[xe];
        try {
            e[xe] = void 0;
            var n = !0;
        } catch (e1) {}
        var i = oE.call(e);
        return n && (t ? e[xe] = r : delete e[xe]), i;
    };
    var bi = _e(), Li = Object.prototype, iE = Li.hasOwnProperty, oE = Li.toString, xe = bi ? bi.toStringTag : void 0;
    Di.exports = uE;
});
var qi = c(function(oq, Fi) {
    var cE = function cE(e) {
        return sE.call(e);
    };
    var aE = Object.prototype, sE = aE.toString;
    Fi.exports = cE;
});
var ee = c(function(uq, Gi) {
    var EE = function EE(e) {
        return e == null ? e === void 0 ? pE : dE : xi && xi in Object(e) ? lE(e) : fE(e);
    };
    var wi = _e(), lE = Mi(), fE = qi(), dE = "[object Null]", pE = "[object Undefined]", xi = wi ? wi.toStringTag : void 0;
    Gi.exports = EE;
});
var fr = c(function(aq, Vi) {
    var _E = function _E(e, t) {
        return function(r) {
            return e(t(r));
        };
    };
    Vi.exports = _E;
});
var dr = c(function(sq, Xi) {
    var gE = fr(), IE = gE(Object.getPrototypeOf, Object);
    Xi.exports = IE;
});
var $ = c(function(cq, Ui) {
    var hE = function hE(e) {
        return e != null && typeof e == "object";
    };
    Ui.exports = hE;
});
var pr = c(function(lq, Wi) {
    var mE = function mE(e) {
        if (!OE(e) || TE(e) != vE) return !1;
        var t = yE(e);
        if (t === null) return !0;
        var r = CE.call(t, "constructor") && t.constructor;
        return typeof r == "function" && _instanceof(r, r) && Bi.call(r) == RE;
    };
    var TE = ee(), yE = dr(), OE = $(), vE = "[object Object]", AE = Function.prototype, SE = Object.prototype, Bi = AE.toString, CE = SE.hasOwnProperty, RE = Bi.call(Object);
    Wi.exports = mE;
});
var Hi = c(function(Er) {
    "use strict";
    var NE = function NE(e) {
        var t, r = e.Symbol;
        return typeof r == "function" ? r.observable ? t = r.observable : (t = r("observable"), r.observable = t) : t = "@@observable", t;
    };
    Object.defineProperty(Er, "__esModule", {
        value: !0
    });
    Er.default = NE;
});
var ji = c(function(gr, _r) {
    "use strict";
    var LE = function LE(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    Object.defineProperty(gr, "__esModule", {
        value: !0
    });
    var PE = Hi(), bE = LE(PE);
    var ge;
    (typeof self === "undefined" ? "undefined" : _typeOf(self)) < "u" ? ge = self :  true ? ge = window : 0;
    var DE = (0, bE.default)(ge);
    gr.default = DE;
});
var Ir = c(function(Ge) {
    "use strict";
    var zi = function zi(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    Ge.__esModule = !0;
    Ge.ActionTypes = void 0;
    Ge.default = ki;
    var ME = pr(), FE = zi(ME), qE = ji(), Ki = zi(qE);
    var Yi = Ge.ActionTypes = {
        INIT: "@@redux/INIT"
    };
    function ki(e, t, r) {
        var n;
        if (typeof t == "function" && (typeof r === "undefined" ? "undefined" : _typeOf(r)) > "u" && (r = t, t = void 0), (typeof r === "undefined" ? "undefined" : _typeOf(r)) < "u") {
            if (typeof r != "function") throw new Error("Expected the enhancer to be a function.");
            return r(ki)(e, t);
        }
        if (typeof e != "function") throw new Error("Expected the reducer to be a function.");
        var i = e, o = t, u = [], a = u, s = !1;
        function l() {
            a === u && (a = u.slice());
        }
        function d() {
            return o;
        }
        function p(_) {
            if (typeof _ != "function") throw new Error("Expected listener to be a function.");
            var h = !0;
            return l(), a.push(_), function() {
                if (h) {
                    h = !1, l();
                    var y = a.indexOf(_);
                    a.splice(y, 1);
                }
            };
        }
        function f(_) {
            if (!(0, FE.default)(_)) throw new Error("Actions must be plain objects. Use custom middleware for async actions.");
            if (_typeOf(_.type) > "u") throw new Error('Actions may not have an undefined "type" property. Have you misspelled a constant?');
            if (s) throw new Error("Reducers may not dispatch actions.");
            try {
                s = !0, o = i(o, _);
            } finally{
                s = !1;
            }
            for(var h = u = a, I = 0; I < h.length; I++)h[I]();
            return _;
        }
        function E(_) {
            if (typeof _ != "function") throw new Error("Expected the nextReducer to be a function.");
            i = _, f({
                type: Yi.INIT
            });
        }
        function g() {
            var _, h = p;
            return _ = {
                subscribe: function subscribe(y) {
                    if (typeof y != "object") throw new TypeError("Expected the observer to be an object.");
                    function A() {
                        y.next && y.next(d());
                    }
                    A();
                    var O = h(A);
                    return {
                        unsubscribe: O
                    };
                }
            }, _[Ki.default] = function() {
                return this;
            }, _;
        }
        return f({
            type: Yi.INIT
        }), n = {
            dispatch: f,
            subscribe: p,
            getState: d,
            replaceReducer: E
        }, n[Ki.default] = g, n;
    }
});
var Tr = c(function(hr) {
    "use strict";
    var wE = function wE(e) {
        (typeof console === "undefined" ? "undefined" : _typeOf(console)) < "u" && typeof console.error == "function" && console.error(e);
        try {
            throw new Error(e);
        } catch (e1) {}
    };
    hr.__esModule = !0;
    hr.default = wE;
});
var Zi = c(function(yr) {
    "use strict";
    var $i = function $i(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var VE = function VE(e, t) {
        var r = t && t.type, n = r && '"' + r.toString() + '"' || "an action";
        return "Given action " + n + ', reducer "' + e + '" returned undefined. To ignore an action, you must explicitly return the previous state.';
    };
    var XE = function XE(e) {
        Object.keys(e).forEach(function(t) {
            var r = e[t], n = r(void 0, {
                type: Qi.ActionTypes.INIT
            });
            if ((typeof n === "undefined" ? "undefined" : _typeOf(n)) > "u") throw new Error('Reducer "' + t + '" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined.');
            var i = "@@redux/PROBE_UNKNOWN_ACTION_" + Math.random().toString(36).substring(7).split("").join(".");
            if (_typeOf(r(void 0, {
                type: i
            })) > "u") throw new Error('Reducer "' + t + '" returned undefined when probed with a random type. ' + ("Don't try to handle " + Qi.ActionTypes.INIT + ' or other actions in "redux/*" ') + "namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined.");
        });
    };
    var UE = function UE(e) {
        for(var t = Object.keys(e), r = {}, n = 0; n < t.length; n++){
            var i = t[n];
            typeof e[i] == "function" && (r[i] = e[i]);
        }
        var o = Object.keys(r);
        if (false) { var u; }
        var a;
        try {
            XE(r);
        } catch (s) {
            a = s;
        }
        return function() {
            var l = arguments.length <= 0 || arguments[0] === void 0 ? {} : arguments[0], d = arguments[1];
            if (a) throw a;
            if (false) { var p; }
            for(var f = !1, E = {}, g = 0; g < o.length; g++){
                var _ = o[g], h = r[_], I = l[_], y = h(I, d);
                if ((typeof y === "undefined" ? "undefined" : _typeOf(y)) > "u") {
                    var A = VE(_, d);
                    throw new Error(A);
                }
                E[_] = y, f = f || y !== I;
            }
            return f ? E : l;
        };
    };
    yr.__esModule = !0;
    yr.default = UE;
    var Qi = Ir(), xE = pr(), Eq = $i(xE), GE = Tr(), _q = $i(GE);
});
var eo = c(function(Or) {
    "use strict";
    var Ji = function Ji(e, t) {
        return function() {
            return t(e.apply(void 0, arguments));
        };
    };
    var BE = function BE(e, t) {
        if (typeof e == "function") return Ji(e, t);
        if (typeof e != "object" || e === null) throw new Error("bindActionCreators expected an object or a function, instead received " + (e === null ? "null" : typeof e === "undefined" ? "undefined" : _typeOf(e)) + '. Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
        for(var r = Object.keys(e), n = {}, i = 0; i < r.length; i++){
            var o = r[i], u = e[o];
            typeof u == "function" && (n[o] = Ji(u, t));
        }
        return n;
    };
    Or.__esModule = !0;
    Or.default = BE;
});
var Ar = c(function(vr) {
    "use strict";
    var WE = function WE() {
        for(var e = arguments.length, t = Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        if (t.length === 0) return function(o) {
            return o;
        };
        if (t.length === 1) return t[0];
        var n = t[t.length - 1], i = t.slice(0, -1);
        return function() {
            return i.reduceRight(function(o, u) {
                return u(o);
            }, n.apply(void 0, arguments));
        };
    };
    vr.__esModule = !0;
    vr.default = WE;
});
var to = c(function(Sr) {
    "use strict";
    var YE = function YE(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var zE = function zE() {
        for(var e = arguments.length, t = Array(e), r = 0; r < e; r++)t[r] = arguments[r];
        return function(n) {
            return function(i, o, u) {
                var a = n(i, o, u), s = a.dispatch, l = [], d = {
                    getState: a.getState,
                    dispatch: function dispatch(f) {
                        return s(f);
                    }
                };
                return l = t.map(function(p) {
                    return p(d);
                }), s = KE.default.apply(void 0, l)(a.dispatch), HE({}, a, {
                    dispatch: s
                });
            };
        };
    };
    Sr.__esModule = !0;
    var HE = Object.assign || function(e) {
        for(var t = 1; t < arguments.length; t++){
            var r = arguments[t];
            for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
        return e;
    };
    Sr.default = zE;
    var jE = Ar(), KE = YE(jE);
});
var Cr = c(function(U) {
    "use strict";
    var Ie = function Ie(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    U.__esModule = !0;
    U.compose = U.applyMiddleware = U.bindActionCreators = U.combineReducers = U.createStore = void 0;
    var kE = Ir(), QE = Ie(kE), $E = Zi(), ZE = Ie($E), JE = eo(), e_ = Ie(JE), t_ = to(), r_ = Ie(t_), n_ = Ar(), i_ = Ie(n_), o_ = Tr(), yq = Ie(o_);
    U.createStore = QE.default;
    U.combineReducers = ZE.default;
    U.bindActionCreators = e_.default;
    U.applyMiddleware = r_.default;
    U.compose = i_.default;
});
var ro = c(function(Rr) {
    "use strict";
    var u_ = function u_(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(Rr, "__esModule", {
        value: !0
    });
    u_(Rr, {
        EventAppliesTo: function EventAppliesTo() {
            return s_;
        },
        EventBasedOn: function EventBasedOn() {
            return c_;
        },
        EventContinuousMouseAxes: function EventContinuousMouseAxes() {
            return l_;
        },
        EventLimitAffectedElements: function EventLimitAffectedElements() {
            return f_;
        },
        EventTypeConsts: function EventTypeConsts() {
            return a_;
        },
        QuickEffectDirectionConsts: function QuickEffectDirectionConsts() {
            return p_;
        },
        QuickEffectIds: function QuickEffectIds() {
            return d_;
        }
    });
    var a_ = {
        NAVBAR_OPEN: "NAVBAR_OPEN",
        NAVBAR_CLOSE: "NAVBAR_CLOSE",
        TAB_ACTIVE: "TAB_ACTIVE",
        TAB_INACTIVE: "TAB_INACTIVE",
        SLIDER_ACTIVE: "SLIDER_ACTIVE",
        SLIDER_INACTIVE: "SLIDER_INACTIVE",
        DROPDOWN_OPEN: "DROPDOWN_OPEN",
        DROPDOWN_CLOSE: "DROPDOWN_CLOSE",
        MOUSE_CLICK: "MOUSE_CLICK",
        MOUSE_SECOND_CLICK: "MOUSE_SECOND_CLICK",
        MOUSE_DOWN: "MOUSE_DOWN",
        MOUSE_UP: "MOUSE_UP",
        MOUSE_OVER: "MOUSE_OVER",
        MOUSE_OUT: "MOUSE_OUT",
        MOUSE_MOVE: "MOUSE_MOVE",
        MOUSE_MOVE_IN_VIEWPORT: "MOUSE_MOVE_IN_VIEWPORT",
        SCROLL_INTO_VIEW: "SCROLL_INTO_VIEW",
        SCROLL_OUT_OF_VIEW: "SCROLL_OUT_OF_VIEW",
        SCROLLING_IN_VIEW: "SCROLLING_IN_VIEW",
        ECOMMERCE_CART_OPEN: "ECOMMERCE_CART_OPEN",
        ECOMMERCE_CART_CLOSE: "ECOMMERCE_CART_CLOSE",
        PAGE_START: "PAGE_START",
        PAGE_FINISH: "PAGE_FINISH",
        PAGE_SCROLL_UP: "PAGE_SCROLL_UP",
        PAGE_SCROLL_DOWN: "PAGE_SCROLL_DOWN",
        PAGE_SCROLL: "PAGE_SCROLL"
    }, s_ = {
        ELEMENT: "ELEMENT",
        CLASS: "CLASS",
        PAGE: "PAGE"
    }, c_ = {
        ELEMENT: "ELEMENT",
        VIEWPORT: "VIEWPORT"
    }, l_ = {
        X_AXIS: "X_AXIS",
        Y_AXIS: "Y_AXIS"
    }, f_ = {
        CHILDREN: "CHILDREN",
        SIBLINGS: "SIBLINGS",
        IMMEDIATE_CHILDREN: "IMMEDIATE_CHILDREN"
    }, d_ = {
        FADE_EFFECT: "FADE_EFFECT",
        SLIDE_EFFECT: "SLIDE_EFFECT",
        GROW_EFFECT: "GROW_EFFECT",
        SHRINK_EFFECT: "SHRINK_EFFECT",
        SPIN_EFFECT: "SPIN_EFFECT",
        FLY_EFFECT: "FLY_EFFECT",
        POP_EFFECT: "POP_EFFECT",
        FLIP_EFFECT: "FLIP_EFFECT",
        JIGGLE_EFFECT: "JIGGLE_EFFECT",
        PULSE_EFFECT: "PULSE_EFFECT",
        DROP_EFFECT: "DROP_EFFECT",
        BLINK_EFFECT: "BLINK_EFFECT",
        BOUNCE_EFFECT: "BOUNCE_EFFECT",
        FLIP_LEFT_TO_RIGHT_EFFECT: "FLIP_LEFT_TO_RIGHT_EFFECT",
        FLIP_RIGHT_TO_LEFT_EFFECT: "FLIP_RIGHT_TO_LEFT_EFFECT",
        RUBBER_BAND_EFFECT: "RUBBER_BAND_EFFECT",
        JELLO_EFFECT: "JELLO_EFFECT",
        GROW_BIG_EFFECT: "GROW_BIG_EFFECT",
        SHRINK_BIG_EFFECT: "SHRINK_BIG_EFFECT",
        PLUGIN_LOTTIE_EFFECT: "PLUGIN_LOTTIE_EFFECT"
    }, p_ = {
        LEFT: "LEFT",
        RIGHT: "RIGHT",
        BOTTOM: "BOTTOM",
        TOP: "TOP",
        BOTTOM_LEFT: "BOTTOM_LEFT",
        BOTTOM_RIGHT: "BOTTOM_RIGHT",
        TOP_RIGHT: "TOP_RIGHT",
        TOP_LEFT: "TOP_LEFT",
        CLOCKWISE: "CLOCKWISE",
        COUNTER_CLOCKWISE: "COUNTER_CLOCKWISE"
    };
});
var Nr = c(function(mr) {
    "use strict";
    var E_ = function E_(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(mr, "__esModule", {
        value: !0
    });
    E_(mr, {
        ActionAppliesTo: function ActionAppliesTo() {
            return g_;
        },
        ActionTypeConsts: function ActionTypeConsts() {
            return __;
        }
    });
    var __ = {
        TRANSFORM_MOVE: "TRANSFORM_MOVE",
        TRANSFORM_SCALE: "TRANSFORM_SCALE",
        TRANSFORM_ROTATE: "TRANSFORM_ROTATE",
        TRANSFORM_SKEW: "TRANSFORM_SKEW",
        STYLE_OPACITY: "STYLE_OPACITY",
        STYLE_SIZE: "STYLE_SIZE",
        STYLE_FILTER: "STYLE_FILTER",
        STYLE_FONT_VARIATION: "STYLE_FONT_VARIATION",
        STYLE_BACKGROUND_COLOR: "STYLE_BACKGROUND_COLOR",
        STYLE_BORDER: "STYLE_BORDER",
        STYLE_TEXT_COLOR: "STYLE_TEXT_COLOR",
        OBJECT_VALUE: "OBJECT_VALUE",
        PLUGIN_LOTTIE: "PLUGIN_LOTTIE",
        PLUGIN_SPLINE: "PLUGIN_SPLINE",
        PLUGIN_RIVE: "PLUGIN_RIVE",
        PLUGIN_VARIABLE: "PLUGIN_VARIABLE",
        GENERAL_DISPLAY: "GENERAL_DISPLAY",
        GENERAL_START_ACTION: "GENERAL_START_ACTION",
        GENERAL_CONTINUOUS_ACTION: "GENERAL_CONTINUOUS_ACTION",
        GENERAL_COMBO_CLASS: "GENERAL_COMBO_CLASS",
        GENERAL_STOP_ACTION: "GENERAL_STOP_ACTION",
        GENERAL_LOOP: "GENERAL_LOOP",
        STYLE_BOX_SHADOW: "STYLE_BOX_SHADOW"
    }, g_ = {
        ELEMENT: "ELEMENT",
        ELEMENT_CLASS: "ELEMENT_CLASS",
        TRIGGER_ELEMENT: "TRIGGER_ELEMENT"
    };
});
var no = c(function(Pr) {
    "use strict";
    Object.defineProperty(Pr, "__esModule", {
        value: !0
    });
    Object.defineProperty(Pr, "InteractionTypeConsts", {
        enumerable: !0,
        get: function get() {
            return I_;
        }
    });
    var I_ = {
        MOUSE_CLICK_INTERACTION: "MOUSE_CLICK_INTERACTION",
        MOUSE_HOVER_INTERACTION: "MOUSE_HOVER_INTERACTION",
        MOUSE_MOVE_INTERACTION: "MOUSE_MOVE_INTERACTION",
        SCROLL_INTO_VIEW_INTERACTION: "SCROLL_INTO_VIEW_INTERACTION",
        SCROLLING_IN_VIEW_INTERACTION: "SCROLLING_IN_VIEW_INTERACTION",
        MOUSE_MOVE_IN_VIEWPORT_INTERACTION: "MOUSE_MOVE_IN_VIEWPORT_INTERACTION",
        PAGE_IS_SCROLLING_INTERACTION: "PAGE_IS_SCROLLING_INTERACTION",
        PAGE_LOAD_INTERACTION: "PAGE_LOAD_INTERACTION",
        PAGE_SCROLLED_INTERACTION: "PAGE_SCROLLED_INTERACTION",
        NAVBAR_INTERACTION: "NAVBAR_INTERACTION",
        DROPDOWN_INTERACTION: "DROPDOWN_INTERACTION",
        ECOMMERCE_CART_INTERACTION: "ECOMMERCE_CART_INTERACTION",
        TAB_INTERACTION: "TAB_INTERACTION",
        SLIDER_INTERACTION: "SLIDER_INTERACTION"
    };
});
var io = c(function(br) {
    "use strict";
    Object.defineProperty(br, "__esModule", {
        value: !0
    });
    Object.defineProperty(br, "ReducedMotionTypes", {
        enumerable: !0,
        get: function get() {
            return R_;
        }
    });
    var _obj;
    var h_ = Nr(), _ActionTypeConsts = h_.ActionTypeConsts, T_ = _ActionTypeConsts.TRANSFORM_MOVE, y_ = _ActionTypeConsts.TRANSFORM_SCALE, O_ = _ActionTypeConsts.TRANSFORM_ROTATE, v_ = _ActionTypeConsts.TRANSFORM_SKEW, A_ = _ActionTypeConsts.STYLE_SIZE, S_ = _ActionTypeConsts.STYLE_FILTER, C_ = _ActionTypeConsts.STYLE_FONT_VARIATION, R_ = (_obj = {}, _defineProperty(_obj, T_, !0), _defineProperty(_obj, y_, !0), _defineProperty(_obj, O_, !0), _defineProperty(_obj, v_, !0), _defineProperty(_obj, A_, !0), _defineProperty(_obj, S_, !0), _defineProperty(_obj, C_, !0), _obj);
});
var oo = c(function(Lr) {
    "use strict";
    var m_ = function m_(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(Lr, "__esModule", {
        value: !0
    });
    m_(Lr, {
        IX2_ACTION_LIST_PLAYBACK_CHANGED: function IX2_ACTION_LIST_PLAYBACK_CHANGED() {
            return H_;
        },
        IX2_ANIMATION_FRAME_CHANGED: function IX2_ANIMATION_FRAME_CHANGED() {
            return G_;
        },
        IX2_CLEAR_REQUESTED: function IX2_CLEAR_REQUESTED() {
            return q_;
        },
        IX2_ELEMENT_STATE_CHANGED: function IX2_ELEMENT_STATE_CHANGED() {
            return W_;
        },
        IX2_EVENT_LISTENER_ADDED: function IX2_EVENT_LISTENER_ADDED() {
            return w_;
        },
        IX2_EVENT_STATE_CHANGED: function IX2_EVENT_STATE_CHANGED() {
            return x_;
        },
        IX2_INSTANCE_ADDED: function IX2_INSTANCE_ADDED() {
            return X_;
        },
        IX2_INSTANCE_REMOVED: function IX2_INSTANCE_REMOVED() {
            return B_;
        },
        IX2_INSTANCE_STARTED: function IX2_INSTANCE_STARTED() {
            return U_;
        },
        IX2_MEDIA_QUERIES_DEFINED: function IX2_MEDIA_QUERIES_DEFINED() {
            return K_;
        },
        IX2_PARAMETER_CHANGED: function IX2_PARAMETER_CHANGED() {
            return V_;
        },
        IX2_PLAYBACK_REQUESTED: function IX2_PLAYBACK_REQUESTED() {
            return M_;
        },
        IX2_PREVIEW_REQUESTED: function IX2_PREVIEW_REQUESTED() {
            return D_;
        },
        IX2_RAW_DATA_IMPORTED: function IX2_RAW_DATA_IMPORTED() {
            return N_;
        },
        IX2_SESSION_INITIALIZED: function IX2_SESSION_INITIALIZED() {
            return P_;
        },
        IX2_SESSION_STARTED: function IX2_SESSION_STARTED() {
            return b_;
        },
        IX2_SESSION_STOPPED: function IX2_SESSION_STOPPED() {
            return L_;
        },
        IX2_STOP_REQUESTED: function IX2_STOP_REQUESTED() {
            return F_;
        },
        IX2_TEST_FRAME_RENDERED: function IX2_TEST_FRAME_RENDERED() {
            return Y_;
        },
        IX2_VIEWPORT_WIDTH_CHANGED: function IX2_VIEWPORT_WIDTH_CHANGED() {
            return j_;
        }
    });
    var N_ = "IX2_RAW_DATA_IMPORTED", P_ = "IX2_SESSION_INITIALIZED", b_ = "IX2_SESSION_STARTED", L_ = "IX2_SESSION_STOPPED", D_ = "IX2_PREVIEW_REQUESTED", M_ = "IX2_PLAYBACK_REQUESTED", F_ = "IX2_STOP_REQUESTED", q_ = "IX2_CLEAR_REQUESTED", w_ = "IX2_EVENT_LISTENER_ADDED", x_ = "IX2_EVENT_STATE_CHANGED", G_ = "IX2_ANIMATION_FRAME_CHANGED", V_ = "IX2_PARAMETER_CHANGED", X_ = "IX2_INSTANCE_ADDED", U_ = "IX2_INSTANCE_STARTED", B_ = "IX2_INSTANCE_REMOVED", W_ = "IX2_ELEMENT_STATE_CHANGED", H_ = "IX2_ACTION_LIST_PLAYBACK_CHANGED", j_ = "IX2_VIEWPORT_WIDTH_CHANGED", K_ = "IX2_MEDIA_QUERIES_DEFINED", Y_ = "IX2_TEST_FRAME_RENDERED";
});
var uo = c(function(Dr) {
    "use strict";
    var z_ = function z_(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(Dr, "__esModule", {
        value: !0
    });
    z_(Dr, {
        ABSTRACT_NODE: function ABSTRACT_NODE() {
            return Kg;
        },
        AUTO: function AUTO() {
            return qg;
        },
        BACKGROUND: function BACKGROUND() {
            return Pg;
        },
        BACKGROUND_COLOR: function BACKGROUND_COLOR() {
            return Ng;
        },
        BAR_DELIMITER: function BAR_DELIMITER() {
            return Gg;
        },
        BORDER_COLOR: function BORDER_COLOR() {
            return bg;
        },
        BOUNDARY_SELECTOR: function BOUNDARY_SELECTOR() {
            return J_;
        },
        CHILDREN: function CHILDREN() {
            return Vg;
        },
        COLON_DELIMITER: function COLON_DELIMITER() {
            return xg;
        },
        COLOR: function COLOR() {
            return Lg;
        },
        COMMA_DELIMITER: function COMMA_DELIMITER() {
            return wg;
        },
        CONFIG_UNIT: function CONFIG_UNIT() {
            return ag;
        },
        CONFIG_VALUE: function CONFIG_VALUE() {
            return ng;
        },
        CONFIG_X_UNIT: function CONFIG_X_UNIT() {
            return ig;
        },
        CONFIG_X_VALUE: function CONFIG_X_VALUE() {
            return eg;
        },
        CONFIG_Y_UNIT: function CONFIG_Y_UNIT() {
            return og;
        },
        CONFIG_Y_VALUE: function CONFIG_Y_VALUE() {
            return tg;
        },
        CONFIG_Z_UNIT: function CONFIG_Z_UNIT() {
            return ug;
        },
        CONFIG_Z_VALUE: function CONFIG_Z_VALUE() {
            return rg;
        },
        DISPLAY: function DISPLAY() {
            return Dg;
        },
        FILTER: function FILTER() {
            return Sg;
        },
        FLEX: function FLEX() {
            return Mg;
        },
        FONT_VARIATION_SETTINGS: function FONT_VARIATION_SETTINGS() {
            return Cg;
        },
        HEIGHT: function HEIGHT() {
            return mg;
        },
        HTML_ELEMENT: function HTML_ELEMENT() {
            return Hg;
        },
        IMMEDIATE_CHILDREN: function IMMEDIATE_CHILDREN() {
            return Xg;
        },
        IX2_ID_DELIMITER: function IX2_ID_DELIMITER() {
            return k_;
        },
        OPACITY: function OPACITY() {
            return Ag;
        },
        PARENT: function PARENT() {
            return Bg;
        },
        PLAIN_OBJECT: function PLAIN_OBJECT() {
            return jg;
        },
        PRESERVE_3D: function PRESERVE_3D() {
            return Wg;
        },
        RENDER_GENERAL: function RENDER_GENERAL() {
            return zg;
        },
        RENDER_PLUGIN: function RENDER_PLUGIN() {
            return Qg;
        },
        RENDER_STYLE: function RENDER_STYLE() {
            return kg;
        },
        RENDER_TRANSFORM: function RENDER_TRANSFORM() {
            return Yg;
        },
        ROTATE_X: function ROTATE_X() {
            return Ig;
        },
        ROTATE_Y: function ROTATE_Y() {
            return hg;
        },
        ROTATE_Z: function ROTATE_Z() {
            return Tg;
        },
        SCALE_3D: function SCALE_3D() {
            return gg;
        },
        SCALE_X: function SCALE_X() {
            return pg;
        },
        SCALE_Y: function SCALE_Y() {
            return Eg;
        },
        SCALE_Z: function SCALE_Z() {
            return _g;
        },
        SIBLINGS: function SIBLINGS() {
            return Ug;
        },
        SKEW: function SKEW() {
            return yg;
        },
        SKEW_X: function SKEW_X() {
            return Og;
        },
        SKEW_Y: function SKEW_Y() {
            return vg;
        },
        TRANSFORM: function TRANSFORM() {
            return sg;
        },
        TRANSLATE_3D: function TRANSLATE_3D() {
            return dg;
        },
        TRANSLATE_X: function TRANSLATE_X() {
            return cg;
        },
        TRANSLATE_Y: function TRANSLATE_Y() {
            return lg;
        },
        TRANSLATE_Z: function TRANSLATE_Z() {
            return fg;
        },
        WF_PAGE: function WF_PAGE() {
            return Q_;
        },
        WIDTH: function WIDTH() {
            return Rg;
        },
        WILL_CHANGE: function WILL_CHANGE() {
            return Fg;
        },
        W_MOD_IX: function W_MOD_IX() {
            return Z_;
        },
        W_MOD_JS: function W_MOD_JS() {
            return $_;
        }
    });
    var k_ = "|", Q_ = "data-wf-page", $_ = "w-mod-js", Z_ = "w-mod-ix", J_ = ".w-dyn-item", eg = "xValue", tg = "yValue", rg = "zValue", ng = "value", ig = "xUnit", og = "yUnit", ug = "zUnit", ag = "unit", sg = "transform", cg = "translateX", lg = "translateY", fg = "translateZ", dg = "translate3d", pg = "scaleX", Eg = "scaleY", _g = "scaleZ", gg = "scale3d", Ig = "rotateX", hg = "rotateY", Tg = "rotateZ", yg = "skew", Og = "skewX", vg = "skewY", Ag = "opacity", Sg = "filter", Cg = "font-variation-settings", Rg = "width", mg = "height", Ng = "backgroundColor", Pg = "background", bg = "borderColor", Lg = "color", Dg = "display", Mg = "flex", Fg = "willChange", qg = "AUTO", wg = ",", xg = ":", Gg = "|", Vg = "CHILDREN", Xg = "IMMEDIATE_CHILDREN", Ug = "SIBLINGS", Bg = "PARENT", Wg = "preserve-3d", Hg = "HTML_ELEMENT", jg = "PLAIN_OBJECT", Kg = "ABSTRACT_NODE", Yg = "RENDER_TRANSFORM", zg = "RENDER_GENERAL", kg = "RENDER_STYLE", Qg = "RENDER_PLUGIN";
});
var G = c(function(ue) {
    "use strict";
    var $g = function $g(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var at = function at(e, t) {
        return Object.keys(e).forEach(function(r) {
            r !== "default" && !Object.prototype.hasOwnProperty.call(t, r) && Object.defineProperty(t, r, {
                enumerable: !0,
                get: function get() {
                    return e[r];
                }
            });
        }), e;
    };
    var so = function so(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = ao(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    Object.defineProperty(ue, "__esModule", {
        value: !0
    });
    $g(ue, {
        ActionTypeConsts: function ActionTypeConsts() {
            return Jg.ActionTypeConsts;
        },
        IX2EngineActionTypes: function IX2EngineActionTypes() {
            return eI;
        },
        IX2EngineConstants: function IX2EngineConstants() {
            return tI;
        },
        QuickEffectIds: function QuickEffectIds() {
            return Zg.QuickEffectIds;
        }
    });
    var Zg = at(ro(), ue), Jg = at(Nr(), ue);
    at(no(), ue);
    at(io(), ue);
    var eI = so(oo()), tI = so(uo());
    function ao(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (ao = function ao(n) {
            return n ? r : t;
        })(e);
    }
});
var co = c(function(Mr) {
    "use strict";
    Object.defineProperty(Mr, "__esModule", {
        value: !0
    });
    Object.defineProperty(Mr, "ixData", {
        enumerable: !0,
        get: function get() {
            return iI;
        }
    });
    var rI = G(), _IX2EngineActionTypes = rI.IX2EngineActionTypes, nI = _IX2EngineActionTypes.IX2_RAW_DATA_IMPORTED, iI = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.freeze({}), t = arguments.length > 1 ? arguments[1] : void 0;
        switch(t.type){
            case nI:
                return t.payload.ixData || Object.freeze({});
            default:
                return e;
        }
    };
});
var he = c(function(D) {
    "use strict";
    var fo = function fo(e) {
        throw new Error(e);
    };
    var Fr = function Fr(e) {
        var t = Object.keys(e);
        return Object.getOwnPropertySymbols ? t.concat(Object.getOwnPropertySymbols(e)) : t;
    };
    var ct = function ct(e) {
        if (Array.isArray(e)) return e.slice();
        for(var t = Fr(e), r = {}, n = 0; n < t.length; n++){
            var i = t[n];
            r[i] = e[i];
        }
        return r;
    };
    var st = function st(e) {
        var t = (typeof e === "undefined" ? "undefined" : _typeOf(e)) > "u" ? "undefined" : oI(e);
        return e != null && (t === "object" || t === "function");
    };
    var po = function po(e, t) {
        return Array.isArray(t) ? e.concat(t) : e.concat([
            t
        ]);
    };
    var Eo = function Eo(e, t) {
        return Array.isArray(t) ? t.concat(e) : [
            t
        ].concat(e);
    };
    var _o = function _o(e) {
        return e.length ? e.slice(0, e.length - 1) : e;
    };
    var go = function go(e) {
        return e.length ? e.slice(1) : e;
    };
    var Io = function Io(e, t, r) {
        return e.slice(0, t).concat(Array.isArray(r) ? r : [
            r
        ]).concat(e.slice(t));
    };
    var ho = function ho(e, t) {
        return t >= e.length || t < 0 ? e : e.slice(0, t).concat(e.slice(t + 1));
    };
    var To = function To(e, t, r) {
        if (e[t] === r) return e;
        for(var n = e.length, i = Array(n), o = 0; o < n; o++)i[o] = e[o];
        return i[t] = r, i;
    };
    var lt = function lt(e, t) {
        if (!Array.isArray(t) && fo(lo), e != null) {
            for(var r = e, n = 0; n < t.length; n++){
                var i = t[n];
                if (r = r === null || r === void 0 ? void 0 : r[i], r === void 0) return r;
            }
            return r;
        }
    };
    var ft = function ft(e, t, r) {
        var n = typeof t == "number" ? [] : {}, i = e !== null && e !== void 0 ? e : n;
        if (i[t] === r) return i;
        var o = ct(i);
        return o[t] = r, o;
    };
    var dt = function dt(e, t, r) {
        return t.length ? yo(e, t, r, 0) : r;
    };
    var Oo = function Oo(e, t, r) {
        var n = e === null || e === void 0 ? void 0 : e[t], i = r(n);
        return ft(e, t, i);
    };
    var vo = function vo(e, t, r) {
        var n = lt(e, t), i = r(n);
        return dt(e, t, i);
    };
    var Ao = function Ao(e, t, r, n, i, o) {
        for(var u = arguments.length, a = Array(u > 6 ? u - 6 : 0), s = 6; s < u; s++)a[s - 6] = arguments[s];
        return a.length ? V.call.apply(V, [
            null,
            !1,
            !1,
            e,
            t,
            r,
            n,
            i,
            o
        ].concat(a)) : V(!1, !1, e, t, r, n, i, o);
    };
    var So = function So(e, t, r, n, i, o) {
        for(var u = arguments.length, a = Array(u > 6 ? u - 6 : 0), s = 6; s < u; s++)a[s - 6] = arguments[s];
        return a.length ? V.call.apply(V, [
            null,
            !1,
            !0,
            e,
            t,
            r,
            n,
            i,
            o
        ].concat(a)) : V(!1, !0, e, t, r, n, i, o);
    };
    var Co = function Co(e, t, r, n, i, o, u) {
        var a = lt(e, t);
        a == null && (a = {});
        for(var s = void 0, l = arguments.length, d = Array(l > 7 ? l - 7 : 0), p = 7; p < l; p++)d[p - 7] = arguments[p];
        return d.length ? s = V.call.apply(V, [
            null,
            !1,
            !1,
            a,
            r,
            n,
            i,
            o,
            u
        ].concat(d)) : s = V(!1, !1, a, r, n, i, o, u), dt(e, t, s);
    };
    var Ro = function Ro(e, t) {
        for(var r = Array.isArray(t) ? t : [
            t
        ], n = !1, i = 0; i < r.length; i++)if (uI.call(e, r[i])) {
            n = !0;
            break;
        }
        if (!n) return e;
        for(var o = {}, u = Fr(e), a = 0; a < u.length; a++){
            var s = u[a];
            r.indexOf(s) >= 0 || (o[s] = e[s]);
        }
        return o;
    };
    var mo = function mo(e, t, r, n, i, o) {
        for(var u = arguments.length, a = Array(u > 6 ? u - 6 : 0), s = 6; s < u; s++)a[s - 6] = arguments[s];
        return a.length ? V.call.apply(V, [
            null,
            !0,
            !1,
            e,
            t,
            r,
            n,
            i,
            o
        ].concat(a)) : V(!0, !1, e, t, r, n, i, o);
    };
    Object.defineProperty(D, "__esModule", {
        value: !0
    });
    var oI = typeof Symbol == "function" && _typeOf(Symbol.iterator) == "symbol" ? function oI(e) {
        return typeof e === "undefined" ? "undefined" : _typeOf(e);
    } : function(e) {
        return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e === "undefined" ? "undefined" : _typeOf(e);
    };
    D.clone = ct;
    D.addLast = po;
    D.addFirst = Eo;
    D.removeLast = _o;
    D.removeFirst = go;
    D.insert = Io;
    D.removeAt = ho;
    D.replaceAt = To;
    D.getIn = lt;
    D.set = ft;
    D.setIn = dt;
    D.update = Oo;
    D.updateIn = vo;
    D.merge = Ao;
    D.mergeDeep = So;
    D.mergeIn = Co;
    D.omit = Ro;
    D.addDefaults = mo;
    var lo = "INVALID_ARGS";
    var uI = {}.hasOwnProperty;
    function V(e, t, r) {
        var n = r;
        n == null && fo(lo);
        for(var i = !1, o = arguments.length, u = Array(o > 3 ? o - 3 : 0), a = 3; a < o; a++)u[a - 3] = arguments[a];
        for(var s = 0; s < u.length; s++){
            var l = u[s];
            if (l != null) {
                var d = Fr(l);
                if (d.length) for(var p = 0; p <= d.length; p++){
                    var f = d[p];
                    if (!(e && n[f] !== void 0)) {
                        var E = l[f];
                        t && st(n[f]) && st(E) && (E = V(e, t, n[f], E)), !(E === void 0 || E === n[f]) && (i || (i = !0, n = ct(n)), n[f] = E);
                    }
                }
            }
        }
        return n;
    }
    function yo(e, t, r, n) {
        var i = void 0, o = t[n];
        if (n === t.length - 1) i = r;
        else {
            var u = st(e) && st(e[o]) ? e[o] : typeof t[n + 1] == "number" ? [] : {};
            i = yo(u, t, r, n + 1);
        }
        return ft(e, o, i);
    }
    var aI = {
        clone: ct,
        addLast: po,
        addFirst: Eo,
        removeLast: _o,
        removeFirst: go,
        insert: Io,
        removeAt: ho,
        replaceAt: To,
        getIn: lt,
        set: ft,
        setIn: dt,
        update: Oo,
        updateIn: vo,
        merge: Ao,
        mergeDeep: So,
        mergeIn: Co,
        omit: Ro,
        addDefaults: mo
    };
    D.default = aI;
});
var Po = c(function(qr) {
    "use strict";
    Object.defineProperty(qr, "__esModule", {
        value: !0
    });
    Object.defineProperty(qr, "ixRequest", {
        enumerable: !0,
        get: function get() {
            return _I;
        }
    });
    var _obj;
    var sI = G(), cI = he(), _IX2EngineActionTypes = sI.IX2EngineActionTypes, lI = _IX2EngineActionTypes.IX2_PREVIEW_REQUESTED, fI = _IX2EngineActionTypes.IX2_PLAYBACK_REQUESTED, dI = _IX2EngineActionTypes.IX2_STOP_REQUESTED, pI = _IX2EngineActionTypes.IX2_CLEAR_REQUESTED, EI = {
        preview: {},
        playback: {},
        stop: {},
        clear: {}
    }, No = Object.create(null, (_obj = {}, _defineProperty(_obj, lI, {
        value: "preview"
    }), _defineProperty(_obj, fI, {
        value: "playback"
    }), _defineProperty(_obj, dI, {
        value: "stop"
    }), _defineProperty(_obj, pI, {
        value: "clear"
    }), _obj)), _I = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EI, t = arguments.length > 1 ? arguments[1] : void 0;
        if (t.type in No) {
            var r = [
                No[t.type]
            ];
            return (0, cI.setIn)(e, [
                r
            ], _object_spread({}, t.payload));
        }
        return e;
    };
});
var Lo = c(function(wr) {
    "use strict";
    Object.defineProperty(wr, "__esModule", {
        value: !0
    });
    Object.defineProperty(wr, "ixSession", {
        enumerable: !0,
        get: function get() {
            return NI;
        }
    });
    var gI = G(), j = he(), _IX2EngineActionTypes = gI.IX2EngineActionTypes, II = _IX2EngineActionTypes.IX2_SESSION_INITIALIZED, hI = _IX2EngineActionTypes.IX2_SESSION_STARTED, TI = _IX2EngineActionTypes.IX2_TEST_FRAME_RENDERED, yI = _IX2EngineActionTypes.IX2_SESSION_STOPPED, OI = _IX2EngineActionTypes.IX2_EVENT_LISTENER_ADDED, vI = _IX2EngineActionTypes.IX2_EVENT_STATE_CHANGED, AI = _IX2EngineActionTypes.IX2_ANIMATION_FRAME_CHANGED, SI = _IX2EngineActionTypes.IX2_ACTION_LIST_PLAYBACK_CHANGED, CI = _IX2EngineActionTypes.IX2_VIEWPORT_WIDTH_CHANGED, RI = _IX2EngineActionTypes.IX2_MEDIA_QUERIES_DEFINED, bo = {
        active: !1,
        tick: 0,
        eventListeners: [],
        eventState: {},
        playbackState: {},
        viewportWidth: 0,
        mediaQueryKey: null,
        hasBoundaryNodes: !1,
        hasDefinedMediaQueries: !1,
        reducedMotion: !1
    }, mI = 20, NI = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : bo, t = arguments.length > 1 ? arguments[1] : void 0;
        switch(t.type){
            case II:
                {
                    var _payload = t.payload, r = _payload.hasBoundaryNodes, n = _payload.reducedMotion;
                    return (0, j.merge)(e, {
                        hasBoundaryNodes: r,
                        reducedMotion: n
                    });
                }
            case hI:
                return (0, j.set)(e, "active", !0);
            case TI:
                {
                    var _payload1 = t.payload, tmp = _payload1.step, r1 = tmp === void 0 ? mI : tmp;
                    return (0, j.set)(e, "tick", e.tick + r1);
                }
            case yI:
                return bo;
            case AI:
                {
                    var _payload2 = t.payload, r2 = _payload2.now;
                    return (0, j.set)(e, "tick", r2);
                }
            case OI:
                {
                    var r3 = (0, j.addLast)(e.eventListeners, t.payload);
                    return (0, j.set)(e, "eventListeners", r3);
                }
            case vI:
                {
                    var _payload3 = t.payload, r4 = _payload3.stateKey, n1 = _payload3.newState;
                    return (0, j.setIn)(e, [
                        "eventState",
                        r4
                    ], n1);
                }
            case SI:
                {
                    var _payload4 = t.payload, r5 = _payload4.actionListId, n2 = _payload4.isPlaying;
                    return (0, j.setIn)(e, [
                        "playbackState",
                        r5
                    ], n2);
                }
            case CI:
                {
                    var _payload5 = t.payload, r6 = _payload5.width, n3 = _payload5.mediaQueries, i = n3.length, o = null;
                    for(var u = 0; u < i; u++){
                        var _u = n3[u], a = _u.key, s = _u.min, l = _u.max;
                        if (r6 >= s && r6 <= l) {
                            o = a;
                            break;
                        }
                    }
                    return (0, j.merge)(e, {
                        viewportWidth: r6,
                        mediaQueryKey: o
                    });
                }
            case RI:
                return (0, j.set)(e, "hasDefinedMediaQueries", !0);
            default:
                return e;
        }
    };
});
var Mo = c(function(Mq, Do) {
    var PI = function PI() {
        this.__data__ = [], this.size = 0;
    };
    Do.exports = PI;
});
var pt = c(function(Fq, Fo) {
    var bI = function bI(e, t) {
        return e === t || e !== e && t !== t;
    };
    Fo.exports = bI;
});
var Ve = c(function(qq, qo) {
    var DI = function DI(e, t) {
        for(var r = e.length; r--;)if (LI(e[r][0], t)) return r;
        return -1;
    };
    var LI = pt();
    qo.exports = DI;
});
var xo = c(function(wq, wo) {
    var wI = function wI(e) {
        var t = this.__data__, r = MI(t, e);
        if (r < 0) return !1;
        var n = t.length - 1;
        return r == n ? t.pop() : qI.call(t, r, 1), --this.size, !0;
    };
    var MI = Ve(), FI = Array.prototype, qI = FI.splice;
    wo.exports = wI;
});
var Vo = c(function(xq, Go) {
    var GI = function GI(e) {
        var t = this.__data__, r = xI(t, e);
        return r < 0 ? void 0 : t[r][1];
    };
    var xI = Ve();
    Go.exports = GI;
});
var Uo = c(function(Gq, Xo) {
    var XI = function XI(e) {
        return VI(this.__data__, e) > -1;
    };
    var VI = Ve();
    Xo.exports = XI;
});
var Wo = c(function(Vq, Bo) {
    var BI = function BI(e, t) {
        var r = this.__data__, n = UI(r, e);
        return n < 0 ? (++this.size, r.push([
            e,
            t
        ])) : r[n][1] = t, this;
    };
    var UI = Ve();
    Bo.exports = BI;
});
var Xe = c(function(Xq, Ho) {
    var Te = function Te(e) {
        var t = -1, r = e == null ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    };
    var WI = Mo(), HI = xo(), jI = Vo(), KI = Uo(), YI = Wo();
    Te.prototype.clear = WI;
    Te.prototype.delete = HI;
    Te.prototype.get = jI;
    Te.prototype.has = KI;
    Te.prototype.set = YI;
    Ho.exports = Te;
});
var Ko = c(function(Uq, jo) {
    var kI = function kI() {
        this.__data__ = new zI(), this.size = 0;
    };
    var zI = Xe();
    jo.exports = kI;
});
var zo = c(function(Bq, Yo) {
    var QI = function QI(e) {
        var t = this.__data__, r = t.delete(e);
        return this.size = t.size, r;
    };
    Yo.exports = QI;
});
var Qo = c(function(Wq, ko) {
    var $I = function $I(e) {
        return this.__data__.get(e);
    };
    ko.exports = $I;
});
var Zo = c(function(Hq, $o) {
    var ZI = function ZI(e) {
        return this.__data__.has(e);
    };
    $o.exports = ZI;
});
var K = c(function(jq, Jo) {
    var JI = function JI(e) {
        var t = typeof e === "undefined" ? "undefined" : _typeOf(e);
        return e != null && (t == "object" || t == "function");
    };
    Jo.exports = JI;
});
var xr = c(function(Kq, eu) {
    var uh = function uh(e) {
        if (!th(e)) return !1;
        var t = eh(e);
        return t == nh || t == ih || t == rh || t == oh;
    };
    var eh = ee(), th = K(), rh = "[object AsyncFunction]", nh = "[object Function]", ih = "[object GeneratorFunction]", oh = "[object Proxy]";
    eu.exports = uh;
});
var ru = c(function(Yq, tu) {
    var ah = W(), sh = ah["__core-js_shared__"];
    tu.exports = sh;
});
var ou = c(function(zq, iu) {
    var ch = function ch(e) {
        return !!nu && nu in e;
    };
    var Gr = ru(), nu = function() {
        var e = /[^.]+$/.exec(Gr && Gr.keys && Gr.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
    }();
    iu.exports = ch;
});
var Vr = c(function(kq, uu) {
    var dh = function dh(e) {
        if (e != null) {
            try {
                return fh.call(e);
            } catch (e1) {}
            try {
                return e + "";
            } catch (e2) {}
        }
        return "";
    };
    var lh = Function.prototype, fh = lh.toString;
    uu.exports = dh;
});
var su = c(function(Qq, au) {
    var Sh = function Sh(e) {
        if (!_h(e) || Eh(e)) return !1;
        var t = ph(e) ? Ah : hh;
        return t.test(gh(e));
    };
    var ph = xr(), Eh = ou(), _h = K(), gh = Vr(), Ih = /[\\^$.*+?()[\]{}|]/g, hh = /^\[object .+?Constructor\]$/, Th = Function.prototype, yh = Object.prototype, Oh = Th.toString, vh = yh.hasOwnProperty, Ah = RegExp("^" + Oh.call(vh).replace(Ih, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
    au.exports = Sh;
});
var lu = c(function($q, cu) {
    var Ch = function Ch(e, t) {
        return e === null || e === void 0 ? void 0 : e[t];
    };
    cu.exports = Ch;
});
var te = c(function(Zq, fu) {
    var Nh = function Nh(e, t) {
        var r = mh(e, t);
        return Rh(r) ? r : void 0;
    };
    var Rh = su(), mh = lu();
    fu.exports = Nh;
});
var Et = c(function(Jq, du) {
    var Ph = te(), bh = W(), Lh = Ph(bh, "Map");
    du.exports = Lh;
});
var Ue = c(function(ew, pu) {
    var Dh = te(), Mh = Dh(Object, "create");
    pu.exports = Mh;
});
var gu = c(function(tw, _u) {
    var Fh = function Fh() {
        this.__data__ = Eu ? Eu(null) : {}, this.size = 0;
    };
    var Eu = Ue();
    _u.exports = Fh;
});
var hu = c(function(rw, Iu) {
    var qh = function qh(e) {
        var t = this.has(e) && delete this.__data__[e];
        return this.size -= t ? 1 : 0, t;
    };
    Iu.exports = qh;
});
var yu = c(function(nw, Tu) {
    var Xh = function Xh(e) {
        var t = this.__data__;
        if (wh) {
            var r = t[e];
            return r === xh ? void 0 : r;
        }
        return Vh.call(t, e) ? t[e] : void 0;
    };
    var wh = Ue(), xh = "__lodash_hash_undefined__", Gh = Object.prototype, Vh = Gh.hasOwnProperty;
    Tu.exports = Xh;
});
var vu = c(function(iw, Ou) {
    var Hh = function Hh(e) {
        var t = this.__data__;
        return Uh ? t[e] !== void 0 : Wh.call(t, e);
    };
    var Uh = Ue(), Bh = Object.prototype, Wh = Bh.hasOwnProperty;
    Ou.exports = Hh;
});
var Su = c(function(ow, Au) {
    var Yh = function Yh(e, t) {
        var r = this.__data__;
        return this.size += this.has(e) ? 0 : 1, r[e] = jh && t === void 0 ? Kh : t, this;
    };
    var jh = Ue(), Kh = "__lodash_hash_undefined__";
    Au.exports = Yh;
});
var Ru = c(function(uw, Cu) {
    var ye = function ye(e) {
        var t = -1, r = e == null ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    };
    var zh = gu(), kh = hu(), Qh = yu(), $h = vu(), Zh = Su();
    ye.prototype.clear = zh;
    ye.prototype.delete = kh;
    ye.prototype.get = Qh;
    ye.prototype.has = $h;
    ye.prototype.set = Zh;
    Cu.exports = ye;
});
var Pu = c(function(aw, Nu) {
    var tT = function tT() {
        this.size = 0, this.__data__ = {
            hash: new mu(),
            map: new (eT || Jh)(),
            string: new mu()
        };
    };
    var mu = Ru(), Jh = Xe(), eT = Et();
    Nu.exports = tT;
});
var Lu = c(function(sw, bu) {
    var rT = function rT(e) {
        var t = typeof e === "undefined" ? "undefined" : _typeOf(e);
        return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
    };
    bu.exports = rT;
});
var Be = c(function(cw, Du) {
    var iT = function iT(e, t) {
        var r = e.__data__;
        return nT(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
    };
    var nT = Lu();
    Du.exports = iT;
});
var Fu = c(function(lw, Mu) {
    var uT = function uT(e) {
        var t = oT(this, e).delete(e);
        return this.size -= t ? 1 : 0, t;
    };
    var oT = Be();
    Mu.exports = uT;
});
var wu = c(function(fw, qu) {
    var sT = function sT(e) {
        return aT(this, e).get(e);
    };
    var aT = Be();
    qu.exports = sT;
});
var Gu = c(function(dw, xu) {
    var lT = function lT(e) {
        return cT(this, e).has(e);
    };
    var cT = Be();
    xu.exports = lT;
});
var Xu = c(function(pw, Vu) {
    var dT = function dT(e, t) {
        var r = fT(this, e), n = r.size;
        return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
    };
    var fT = Be();
    Vu.exports = dT;
});
var _t = c(function(Ew, Uu) {
    var Oe = function Oe(e) {
        var t = -1, r = e == null ? 0 : e.length;
        for(this.clear(); ++t < r;){
            var n = e[t];
            this.set(n[0], n[1]);
        }
    };
    var pT = Pu(), ET = Fu(), _T = wu(), gT = Gu(), IT = Xu();
    Oe.prototype.clear = pT;
    Oe.prototype.delete = ET;
    Oe.prototype.get = _T;
    Oe.prototype.has = gT;
    Oe.prototype.set = IT;
    Uu.exports = Oe;
});
var Wu = c(function(_w, Bu) {
    var vT = function vT(e, t) {
        var r = this.__data__;
        if (_instanceof(r, hT)) {
            var n = r.__data__;
            if (!TT || n.length < OT - 1) return n.push([
                e,
                t
            ]), this.size = ++r.size, this;
            r = this.__data__ = new yT(n);
        }
        return r.set(e, t), this.size = r.size, this;
    };
    var hT = Xe(), TT = Et(), yT = _t(), OT = 200;
    Bu.exports = vT;
});
var Xr = c(function(gw, Hu) {
    var ve = function ve(e) {
        var t = this.__data__ = new AT(e);
        this.size = t.size;
    };
    var AT = Xe(), ST = Ko(), CT = zo(), RT = Qo(), mT = Zo(), NT = Wu();
    ve.prototype.clear = ST;
    ve.prototype.delete = CT;
    ve.prototype.get = RT;
    ve.prototype.has = mT;
    ve.prototype.set = NT;
    Hu.exports = ve;
});
var Ku = c(function(Iw, ju) {
    var bT = function bT(e) {
        return this.__data__.set(e, PT), this;
    };
    var PT = "__lodash_hash_undefined__";
    ju.exports = bT;
});
var zu = c(function(hw, Yu) {
    var LT = function LT(e) {
        return this.__data__.has(e);
    };
    Yu.exports = LT;
});
var Qu = c(function(Tw, ku) {
    var gt = function gt(e) {
        var t = -1, r = e == null ? 0 : e.length;
        for(this.__data__ = new DT(); ++t < r;)this.add(e[t]);
    };
    var DT = _t(), MT = Ku(), FT = zu();
    gt.prototype.add = gt.prototype.push = MT;
    gt.prototype.has = FT;
    ku.exports = gt;
});
var Zu = c(function(yw, $u) {
    var qT = function qT(e, t) {
        for(var r = -1, n = e == null ? 0 : e.length; ++r < n;)if (t(e[r], r, e)) return !0;
        return !1;
    };
    $u.exports = qT;
});
var ea = c(function(Ow, Ju) {
    var wT = function wT(e, t) {
        return e.has(t);
    };
    Ju.exports = wT;
});
var Ur = c(function(vw, ta) {
    var BT = function BT(e, t, r, n, i, o) {
        var u = r & XT, a = e.length, s = t.length;
        if (a != s && !(u && s > a)) return !1;
        var l = o.get(e), d = o.get(t);
        if (l && d) return l == t && d == e;
        var p = -1, f = !0, E = r & UT ? new xT() : void 0;
        for(o.set(e, t), o.set(t, e); ++p < a;){
            var g = e[p], _ = t[p];
            if (n) var h = u ? n(_, g, p, t, e, o) : n(g, _, p, e, t, o);
            if (h !== void 0) {
                if (h) continue;
                f = !1;
                break;
            }
            if (E) {
                if (!GT(t, function(I, y) {
                    if (!VT(E, y) && (g === I || i(g, I, r, n, o))) return E.push(y);
                })) {
                    f = !1;
                    break;
                }
            } else if (!(g === _ || i(g, _, r, n, o))) {
                f = !1;
                break;
            }
        }
        return o.delete(e), o.delete(t), f;
    };
    var xT = Qu(), GT = Zu(), VT = ea(), XT = 1, UT = 2;
    ta.exports = BT;
});
var na = c(function(Aw, ra) {
    var WT = W(), HT = WT.Uint8Array;
    ra.exports = HT;
});
var oa = c(function(Sw, ia) {
    var jT = function jT(e) {
        var t = -1, r = Array(e.size);
        return e.forEach(function(n, i) {
            r[++t] = [
                i,
                n
            ];
        }), r;
    };
    ia.exports = jT;
});
var aa = c(function(Cw, ua) {
    var KT = function KT(e) {
        var t = -1, r = Array(e.size);
        return e.forEach(function(n) {
            r[++t] = n;
        }), r;
    };
    ua.exports = KT;
});
var da = c(function(Rw, fa) {
    var ly = function ly(e, t, r, n, i, o, u) {
        switch(r){
            case cy:
                if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset) return !1;
                e = e.buffer, t = t.buffer;
            case sy:
                return !(e.byteLength != t.byteLength || !o(new ca(e), new ca(t)));
            case JT:
            case ey:
            case ny:
                return YT(+e, +t);
            case ty:
                return e.name == t.name && e.message == t.message;
            case iy:
            case uy:
                return e == t + "";
            case ry:
                var a = kT;
            case oy:
                var s = n & $T;
                if (a || (a = QT), e.size != t.size && !s) return !1;
                var l = u.get(e);
                if (l) return l == t;
                n |= ZT, u.set(e, t);
                var d = zT(a(e), a(t), n, i, o, u);
                return u.delete(e), d;
            case ay:
                if (Br) return Br.call(e) == Br.call(t);
        }
        return !1;
    };
    var sa = _e(), ca = na(), YT = pt(), zT = Ur(), kT = oa(), QT = aa(), $T = 1, ZT = 2, JT = "[object Boolean]", ey = "[object Date]", ty = "[object Error]", ry = "[object Map]", ny = "[object Number]", iy = "[object RegExp]", oy = "[object Set]", uy = "[object String]", ay = "[object Symbol]", sy = "[object ArrayBuffer]", cy = "[object DataView]", la = sa ? sa.prototype : void 0, Br = la ? la.valueOf : void 0;
    fa.exports = ly;
});
var It = c(function(mw, pa) {
    var fy = function fy(e, t) {
        for(var r = -1, n = t.length, i = e.length; ++r < n;)e[i + r] = t[r];
        return e;
    };
    pa.exports = fy;
});
var w = c(function(Nw, Ea) {
    var dy = Array.isArray;
    Ea.exports = dy;
});
var Wr = c(function(Pw, _a) {
    var _y = function _y(e, t, r) {
        var n = t(e);
        return Ey(e) ? n : py(n, r(e));
    };
    var py = It(), Ey = w();
    _a.exports = _y;
});
var Ia = c(function(bw, ga) {
    var gy = function gy(e, t) {
        for(var r = -1, n = e == null ? 0 : e.length, i = 0, o = []; ++r < n;){
            var u = e[r];
            t(u, r, e) && (o[i++] = u);
        }
        return o;
    };
    ga.exports = gy;
});
var Hr = c(function(Lw, ha) {
    var Iy = function Iy() {
        return [];
    };
    ha.exports = Iy;
});
var jr = c(function(Dw, ya) {
    var hy = Ia(), Ty = Hr(), yy = Object.prototype, Oy = yy.propertyIsEnumerable, Ta = Object.getOwnPropertySymbols, vy = Ta ? function vy(e) {
        return e == null ? [] : (e = Object(e), hy(Ta(e), function(t) {
            return Oy.call(e, t);
        }));
    } : Ty;
    ya.exports = vy;
});
var va = c(function(Mw, Oa) {
    var Ay = function Ay(e, t) {
        for(var r = -1, n = Array(e); ++r < e;)n[r] = t(r);
        return n;
    };
    Oa.exports = Ay;
});
var Sa = c(function(Fw, Aa) {
    var my = function my(e) {
        return Cy(e) && Sy(e) == Ry;
    };
    var Sy = ee(), Cy = $(), Ry = "[object Arguments]";
    Aa.exports = my;
});
var We = c(function(qw, ma) {
    var Ca = Sa(), Ny = $(), Ra = Object.prototype, Py = Ra.hasOwnProperty, by = Ra.propertyIsEnumerable, Ly = Ca(function() {
        return arguments;
    }()) ? Ca : function Ly(e) {
        return Ny(e) && Py.call(e, "callee") && !by.call(e, "callee");
    };
    ma.exports = Ly;
});
var Pa = c(function(ww, Na) {
    var Dy = function Dy() {
        return !1;
    };
    Na.exports = Dy;
});
var ht = c(function(He, Ae) {
    var My = W(), Fy = Pa(), Da = typeof He == "object" && He && !He.nodeType && He, ba = Da && typeof Ae == "object" && Ae && !Ae.nodeType && Ae, qy = ba && ba.exports === Da, La = qy ? My.Buffer : void 0, wy = La ? La.isBuffer : void 0, xy = wy || Fy;
    Ae.exports = xy;
});
var Tt = c(function(xw, Ma) {
    var Xy = function Xy(e, t) {
        var r = typeof e === "undefined" ? "undefined" : _typeOf(e);
        return t = t !== null && t !== void 0 ? t : Gy, !!t && (r == "number" || r != "symbol" && Vy.test(e)) && e > -1 && e % 1 == 0 && e < t;
    };
    var Gy = 9007199254740991, Vy = /^(?:0|[1-9]\d*)$/;
    Ma.exports = Xy;
});
var yt = c(function(Gw, Fa) {
    var By = function By(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Uy;
    };
    var Uy = 9007199254740991;
    Fa.exports = By;
});
var wa = c(function(Vw, qa) {
    var gO = function gO(e) {
        return jy(e) && Hy(e.length) && !!L[Wy(e)];
    };
    var Wy = ee(), Hy = yt(), jy = $(), Ky = "[object Arguments]", Yy = "[object Array]", zy = "[object Boolean]", ky = "[object Date]", Qy = "[object Error]", $y = "[object Function]", Zy = "[object Map]", Jy = "[object Number]", eO = "[object Object]", tO = "[object RegExp]", rO = "[object Set]", nO = "[object String]", iO = "[object WeakMap]", oO = "[object ArrayBuffer]", uO = "[object DataView]", aO = "[object Float32Array]", sO = "[object Float64Array]", cO = "[object Int8Array]", lO = "[object Int16Array]", fO = "[object Int32Array]", dO = "[object Uint8Array]", pO = "[object Uint8ClampedArray]", EO = "[object Uint16Array]", _O = "[object Uint32Array]", L = {};
    L[aO] = L[sO] = L[cO] = L[lO] = L[fO] = L[dO] = L[pO] = L[EO] = L[_O] = !0;
    L[Ky] = L[Yy] = L[oO] = L[zy] = L[uO] = L[ky] = L[Qy] = L[$y] = L[Zy] = L[Jy] = L[eO] = L[tO] = L[rO] = L[nO] = L[iO] = !1;
    qa.exports = gO;
});
var Ga = c(function(Xw, xa) {
    var IO = function IO(e) {
        return function(t) {
            return e(t);
        };
    };
    xa.exports = IO;
});
var Xa = c(function(je, Se) {
    var hO = lr(), Va = typeof je == "object" && je && !je.nodeType && je, Ke = Va && typeof Se == "object" && Se && !Se.nodeType && Se, TO = Ke && Ke.exports === Va, Kr = TO && hO.process, yO = function() {
        try {
            var e = Ke && Ke.require && Ke.require("util").types;
            return e || Kr && Kr.binding && Kr.binding("util");
        } catch (e1) {}
    }();
    Se.exports = yO;
});
var Ot = c(function(Uw, Wa) {
    var OO = wa(), vO = Ga(), Ua = Xa(), Ba = Ua && Ua.isTypedArray, AO = Ba ? vO(Ba) : OO;
    Wa.exports = AO;
});
var Yr = c(function(Bw, Ha) {
    var DO = function DO(e, t) {
        var r = RO(e), n = !r && CO(e), i = !r && !n && mO(e), o = !r && !n && !i && PO(e), u = r || n || i || o, a = u ? SO(e.length, String) : [], s = a.length;
        for(var l in e)(t || LO.call(e, l)) && !(u && (l == "length" || i && (l == "offset" || l == "parent") || o && (l == "buffer" || l == "byteLength" || l == "byteOffset") || NO(l, s))) && a.push(l);
        return a;
    };
    var SO = va(), CO = We(), RO = w(), mO = ht(), NO = Tt(), PO = Ot(), bO = Object.prototype, LO = bO.hasOwnProperty;
    Ha.exports = DO;
});
var vt = c(function(Ww, ja) {
    var FO = function FO(e) {
        var t = e && e.constructor, r = typeof t == "function" && t.prototype || MO;
        return e === r;
    };
    var MO = Object.prototype;
    ja.exports = FO;
});
var Ya = c(function(Hw, Ka) {
    var qO = fr(), wO = qO(Object.keys, Object);
    Ka.exports = wO;
});
var At = c(function(jw, za) {
    var UO = function UO(e) {
        if (!xO(e)) return GO(e);
        var t = [];
        for(var r in Object(e))XO.call(e, r) && r != "constructor" && t.push(r);
        return t;
    };
    var xO = vt(), GO = Ya(), VO = Object.prototype, XO = VO.hasOwnProperty;
    za.exports = UO;
});
var ae = c(function(Kw, ka) {
    var HO = function HO(e) {
        return e != null && WO(e.length) && !BO(e);
    };
    var BO = xr(), WO = yt();
    ka.exports = HO;
});
var Ye = c(function(Yw, Qa) {
    var zO = function zO(e) {
        return YO(e) ? jO(e) : KO(e);
    };
    var jO = Yr(), KO = At(), YO = ae();
    Qa.exports = zO;
});
var Za = c(function(zw, $a) {
    var ZO = function ZO(e) {
        return kO(e, $O, QO);
    };
    var kO = Wr(), QO = jr(), $O = Ye();
    $a.exports = ZO;
});
var ts = c(function(kw, es) {
    var rv = function rv(e, t, r, n, i, o) {
        var u = r & JO, a = Ja(e), s = a.length, l = Ja(t), d = l.length;
        if (s != d && !u) return !1;
        for(var p = s; p--;){
            var f = a[p];
            if (!(u ? f in t : tv.call(t, f))) return !1;
        }
        var E = o.get(e), g = o.get(t);
        if (E && g) return E == t && g == e;
        var _ = !0;
        o.set(e, t), o.set(t, e);
        for(var h = u; ++p < s;){
            f = a[p];
            var I = e[f], y = t[f];
            if (n) var A = u ? n(y, I, f, t, e, o) : n(I, y, f, e, t, o);
            if (!(A === void 0 ? I === y || i(I, y, r, n, o) : A)) {
                _ = !1;
                break;
            }
            h || (h = f == "constructor");
        }
        if (_ && !h) {
            var O = e.constructor, C = t.constructor;
            O != C && "constructor" in e && "constructor" in t && !(typeof O == "function" && _instanceof(O, O) && typeof C == "function" && _instanceof(C, C)) && (_ = !1);
        }
        return o.delete(e), o.delete(t), _;
    };
    var Ja = Za(), JO = 1, ev = Object.prototype, tv = ev.hasOwnProperty;
    es.exports = rv;
});
var ns = c(function(Qw, rs) {
    var nv = te(), iv = W(), ov = nv(iv, "DataView");
    rs.exports = ov;
});
var os = c(function($w, is) {
    var uv = te(), av = W(), sv = uv(av, "Promise");
    is.exports = sv;
});
var as = c(function(Zw, us) {
    var cv = te(), lv = W(), fv = cv(lv, "Set");
    us.exports = fv;
});
var zr = c(function(Jw, ss) {
    var dv = te(), pv = W(), Ev = dv(pv, "WeakMap");
    ss.exports = Ev;
});
var St = c(function(ex, _s) {
    var kr = ns(), Qr = Et(), $r = os(), Zr = as(), Jr = zr(), Es = ee(), Ce = Vr(), cs = "[object Map]", _v = "[object Object]", ls = "[object Promise]", fs = "[object Set]", ds = "[object WeakMap]", ps = "[object DataView]", gv = Ce(kr), Iv = Ce(Qr), hv = Ce($r), Tv = Ce(Zr), yv = Ce(Jr), se = Es;
    (kr && se(new kr(new ArrayBuffer(1))) != ps || Qr && se(new Qr()) != cs || $r && se($r.resolve()) != ls || Zr && se(new Zr()) != fs || Jr && se(new Jr()) != ds) && (se = function se(e) {
        var t = Es(e), r = t == _v ? e.constructor : void 0, n = r ? Ce(r) : "";
        if (n) switch(n){
            case gv:
                return ps;
            case Iv:
                return cs;
            case hv:
                return ls;
            case Tv:
                return fs;
            case yv:
                return ds;
        }
        return t;
    });
    _s.exports = se;
});
var As = c(function(tx, vs) {
    var mv = function mv(e, t, r, n, i, o) {
        var u = Is(e), a = Is(t), s = u ? ys : gs(e), l = a ? ys : gs(t);
        s = s == Ts ? Ct : s, l = l == Ts ? Ct : l;
        var d = s == Ct, p = l == Ct, f = s == l;
        if (f && hs(e)) {
            if (!hs(t)) return !1;
            u = !0, d = !1;
        }
        if (f && !d) return o || (o = new en()), u || Sv(e) ? Ov(e, t, r, n, i, o) : vv(e, t, s, r, n, i, o);
        if (!(r & Cv)) {
            var E = d && Os.call(e, "__wrapped__"), g = p && Os.call(t, "__wrapped__");
            if (E || g) {
                var _ = E ? e.value() : e, h = g ? t.value() : t;
                return o || (o = new en()), i(_, h, r, n, o);
            }
        }
        return f ? (o || (o = new en()), Av(e, t, r, n, i, o)) : !1;
    };
    var en = Xr(), Ov = Ur(), vv = da(), Av = ts(), gs = St(), Is = w(), hs = ht(), Sv = Ot(), Cv = 1, Ts = "[object Arguments]", ys = "[object Array]", Ct = "[object Object]", Rv = Object.prototype, Os = Rv.hasOwnProperty;
    vs.exports = mv;
});
var tn = c(function(rx, Rs) {
    var Nv = As(), Ss = $();
    function Cs(e, t, r, n, i) {
        return e === t ? !0 : e == null || t == null || !Ss(e) && !Ss(t) ? e !== e && t !== t : Nv(e, t, r, n, Cs, i);
    }
    Rs.exports = Cs;
});
var Ns = c(function(nx, ms) {
    var Mv = function Mv(e, t, r, n) {
        var i = r.length, o = i, u = !n;
        if (e == null) return !o;
        for(e = Object(e); i--;){
            var a = r[i];
            if (u && a[2] ? a[1] !== e[a[0]] : !(a[0] in e)) return !1;
        }
        for(; ++i < o;){
            a = r[i];
            var s = a[0], l = e[s], d = a[1];
            if (u && a[2]) {
                if (l === void 0 && !(s in e)) return !1;
            } else {
                var p = new Pv();
                if (n) var f = n(l, d, s, e, t, p);
                if (!(f === void 0 ? bv(d, l, Lv | Dv, n, p) : f)) return !1;
            }
        }
        return !0;
    };
    var Pv = Xr(), bv = tn(), Lv = 1, Dv = 2;
    ms.exports = Mv;
});
var rn = c(function(ix, Ps) {
    var qv = function qv(e) {
        return e === e && !Fv(e);
    };
    var Fv = K();
    Ps.exports = qv;
});
var Ls = c(function(ox, bs) {
    var Gv = function Gv(e) {
        for(var t = xv(e), r = t.length; r--;){
            var n = t[r], i = e[n];
            t[r] = [
                n,
                i,
                wv(i)
            ];
        }
        return t;
    };
    var wv = rn(), xv = Ye();
    bs.exports = Gv;
});
var nn = c(function(ux, Ds) {
    var Vv = function Vv(e, t) {
        return function(r) {
            return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
        };
    };
    Ds.exports = Vv;
});
var Fs = c(function(ax, Ms) {
    var Wv = function Wv(e) {
        var t = Uv(e);
        return t.length == 1 && t[0][2] ? Bv(t[0][0], t[0][1]) : function(r) {
            return r === e || Xv(r, e, t);
        };
    };
    var Xv = Ns(), Uv = Ls(), Bv = nn();
    Ms.exports = Wv;
});
var ze = c(function(sx, qs) {
    var Yv = function Yv(e) {
        return (typeof e === "undefined" ? "undefined" : _typeOf(e)) == "symbol" || jv(e) && Hv(e) == Kv;
    };
    var Hv = ee(), jv = $(), Kv = "[object Symbol]";
    qs.exports = Yv;
});
var Rt = c(function(cx, ws) {
    var Zv = function Zv(e, t) {
        if (zv(e)) return !1;
        var r = typeof e === "undefined" ? "undefined" : _typeOf(e);
        return r == "number" || r == "symbol" || r == "boolean" || e == null || kv(e) ? !0 : $v.test(e) || !Qv.test(e) || t != null && e in Object(t);
    };
    var zv = w(), kv = ze(), Qv = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $v = /^\w*$/;
    ws.exports = Zv;
});
var Vs = c(function(lx, Gs) {
    var xs = _t(), Jv = "Expected a function";
    function on(e, t) {
        if (typeof e != "function" || t != null && typeof t != "function") throw new TypeError(Jv);
        var r = function() {
            var n = arguments, i = t ? t.apply(this, n) : n[0], o = r.cache;
            if (o.has(i)) return o.get(i);
            var u = e.apply(this, n);
            return r.cache = o.set(i, u) || o, u;
        };
        return r.cache = new (on.Cache || xs)(), r;
    }
    on.Cache = xs;
    Gs.exports = on;
});
var Us = c(function(fx, Xs) {
    var rA = function rA(e) {
        var t = eA(e, function(n) {
            return r.size === tA && r.clear(), n;
        }), r = t.cache;
        return t;
    };
    var eA = Vs(), tA = 500;
    Xs.exports = rA;
});
var Ws = c(function(dx, Bs) {
    var nA = Us(), iA = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, oA = /\\(\\)?/g, uA = nA(function(e) {
        var t = [];
        return e.charCodeAt(0) === 46 && t.push(""), e.replace(iA, function(r, n, i, o) {
            t.push(i ? o.replace(oA, "$1") : n || r);
        }), t;
    });
    Bs.exports = uA;
});
var un = c(function(px, Hs) {
    var aA = function aA(e, t) {
        for(var r = -1, n = e == null ? 0 : e.length, i = Array(n); ++r < n;)i[r] = t(e[r], r, e);
        return i;
    };
    Hs.exports = aA;
});
var Qs = c(function(Ex, ks) {
    var js = _e(), sA = un(), cA = w(), lA = ze(), fA = 1 / 0, Ks = js ? js.prototype : void 0, Ys = Ks ? Ks.toString : void 0;
    function zs(e) {
        if (typeof e == "string") return e;
        if (cA(e)) return sA(e, zs) + "";
        if (lA(e)) return Ys ? Ys.call(e) : "";
        var t = e + "";
        return t == "0" && 1 / e == -fA ? "-0" : t;
    }
    ks.exports = zs;
});
var Zs = c(function(_x, $s) {
    var pA = function pA(e) {
        return e == null ? "" : dA(e);
    };
    var dA = Qs();
    $s.exports = pA;
});
var ke = c(function(gx, Js) {
    var hA = function hA(e, t) {
        return EA(e) ? e : _A(e, t) ? [
            e
        ] : gA(IA(e));
    };
    var EA = w(), _A = Rt(), gA = Ws(), IA = Zs();
    Js.exports = hA;
});
var Re = c(function(Ix, ec) {
    var OA = function OA(e) {
        if (typeof e == "string" || TA(e)) return e;
        var t = e + "";
        return t == "0" && 1 / e == -yA ? "-0" : t;
    };
    var TA = ze(), yA = 1 / 0;
    ec.exports = OA;
});
var mt = c(function(hx, tc) {
    var SA = function SA(e, t) {
        t = vA(t, e);
        for(var r = 0, n = t.length; e != null && r < n;)e = e[AA(t[r++])];
        return r && r == n ? e : void 0;
    };
    var vA = ke(), AA = Re();
    tc.exports = SA;
});
var Nt = c(function(Tx, rc) {
    var RA = function RA(e, t, r) {
        var n = e == null ? void 0 : CA(e, t);
        return n === void 0 ? r : n;
    };
    var CA = mt();
    rc.exports = RA;
});
var ic = c(function(yx, nc) {
    var mA = function mA(e, t) {
        return e != null && t in Object(e);
    };
    nc.exports = mA;
});
var uc = c(function(Ox, oc) {
    var FA = function FA(e, t, r) {
        t = NA(t, e);
        for(var n = -1, i = t.length, o = !1; ++n < i;){
            var u = MA(t[n]);
            if (!(o = e != null && r(e, u))) break;
            e = e[u];
        }
        return o || ++n != i ? o : (i = e == null ? 0 : e.length, !!i && DA(i) && LA(u, i) && (bA(e) || PA(e)));
    };
    var NA = ke(), PA = We(), bA = w(), LA = Tt(), DA = yt(), MA = Re();
    oc.exports = FA;
});
var sc = c(function(vx, ac) {
    var xA = function xA(e, t) {
        return e != null && wA(e, t, qA);
    };
    var qA = ic(), wA = uc();
    ac.exports = xA;
});
var lc = c(function(Ax, cc) {
    var YA = function YA(e, t) {
        return UA(e) && BA(t) ? WA(HA(e), t) : function(r) {
            var n = VA(r, e);
            return n === void 0 && n === t ? XA(r, e) : GA(t, n, jA | KA);
        };
    };
    var GA = tn(), VA = Nt(), XA = sc(), UA = Rt(), BA = rn(), WA = nn(), HA = Re(), jA = 1, KA = 2;
    cc.exports = YA;
});
var Pt = c(function(Sx, fc) {
    var zA = function zA(e) {
        return e;
    };
    fc.exports = zA;
});
var an = c(function(Cx, dc) {
    var kA = function kA(e) {
        return function(t) {
            return t === null || t === void 0 ? void 0 : t[e];
        };
    };
    dc.exports = kA;
});
var Ec = c(function(Rx, pc) {
    var $A = function $A(e) {
        return function(t) {
            return QA(t, e);
        };
    };
    var QA = mt();
    pc.exports = $A;
});
var gc = c(function(mx, _c) {
    var rS = function rS(e) {
        return eS(e) ? ZA(tS(e)) : JA(e);
    };
    var ZA = an(), JA = Ec(), eS = Rt(), tS = Re();
    _c.exports = rS;
});
var re = c(function(Nx, Ic) {
    var sS = function sS(e) {
        return typeof e == "function" ? e : e == null ? oS : typeof e == "object" ? uS(e) ? iS(e[0], e[1]) : nS(e) : aS(e);
    };
    var nS = Fs(), iS = lc(), oS = Pt(), uS = w(), aS = gc();
    Ic.exports = sS;
});
var sn = c(function(Px, hc) {
    var dS = function dS(e) {
        return function(t, r, n) {
            var i = Object(t);
            if (!lS(t)) {
                var o = cS(r, 3);
                t = fS(t), r = function r(a) {
                    return o(i[a], a, i);
                };
            }
            var u = e(t, r, n);
            return u > -1 ? i[o ? t[u] : u] : void 0;
        };
    };
    var cS = re(), lS = ae(), fS = Ye();
    hc.exports = dS;
});
var cn = c(function(bx, Tc) {
    var pS = function pS(e, t, r, n) {
        for(var i = e.length, o = r + (n ? 1 : -1); n ? o-- : ++o < i;)if (t(e[o], o, e)) return o;
        return -1;
    };
    Tc.exports = pS;
});
var Oc = c(function(Lx, yc) {
    var _S = function _S(e) {
        for(var t = e.length; t-- && ES.test(e.charAt(t)););
        return t;
    };
    var ES = /\s/;
    yc.exports = _S;
});
var Ac = c(function(Dx, vc) {
    var hS = function hS(e) {
        return e && e.slice(0, gS(e) + 1).replace(IS, "");
    };
    var gS = Oc(), IS = /^\s+/;
    vc.exports = hS;
});
var bt = c(function(Mx, Rc) {
    var CS = function CS(e) {
        if (typeof e == "number") return e;
        if (yS(e)) return Cc;
        if (Sc(e)) {
            var t = typeof e.valueOf == "function" ? e.valueOf() : e;
            e = Sc(t) ? t + "" : t;
        }
        if (typeof e != "string") return e === 0 ? e : +e;
        e = TS(e);
        var r = vS.test(e);
        return r || AS.test(e) ? SS(e.slice(2), r ? 2 : 8) : OS.test(e) ? Cc : +e;
    };
    var TS = Ac(), Sc = K(), yS = ze(), Cc = 0 / 0, OS = /^[-+]0x[0-9a-f]+$/i, vS = /^0b[01]+$/i, AS = /^0o[0-7]+$/i, SS = parseInt;
    Rc.exports = CS;
});
var Pc = c(function(Fx, Nc) {
    var NS = function NS(e) {
        if (!e) return e === 0 ? e : 0;
        if (e = RS(e), e === mc || e === -mc) {
            var t = e < 0 ? -1 : 1;
            return t * mS;
        }
        return e === e ? e : 0;
    };
    var RS = bt(), mc = 1 / 0, mS = 17976931348623157e292;
    Nc.exports = NS;
});
var ln = c(function(qx, bc) {
    var bS = function bS(e) {
        var t = PS(e), r = t % 1;
        return t === t ? r ? t - r : t : 0;
    };
    var PS = Pc();
    bc.exports = bS;
});
var Dc = c(function(wx, Lc) {
    var qS = function qS(e, t, r) {
        var n = e == null ? 0 : e.length;
        if (!n) return -1;
        var i = r == null ? 0 : MS(r);
        return i < 0 && (i = FS(n + i, 0)), LS(e, DS(t, 3), i);
    };
    var LS = cn(), DS = re(), MS = ln(), FS = Math.max;
    Lc.exports = qS;
});
var fn = c(function(xx, Mc) {
    var wS = sn(), xS = Dc(), GS = wS(xS);
    Mc.exports = GS;
});
var Dt = c(function(dn) {
    "use strict";
    var VS = function VS(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var US = function US(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    Object.defineProperty(dn, "__esModule", {
        value: !0
    });
    VS(dn, {
        ELEMENT_MATCHES: function ELEMENT_MATCHES() {
            return BS;
        },
        FLEX_PREFIXED: function FLEX_PREFIXED() {
            return WS;
        },
        IS_BROWSER_ENV: function IS_BROWSER_ENV() {
            return qc;
        },
        TRANSFORM_PREFIXED: function TRANSFORM_PREFIXED() {
            return wc;
        },
        TRANSFORM_STYLE_PREFIXED: function TRANSFORM_STYLE_PREFIXED() {
            return HS;
        },
        withBrowser: function withBrowser() {
            return Lt;
        }
    });
    var XS = US(fn());
    var qc = "object" < "u", Lt = function(e, t) {
        return qc ? e() : t;
    }, BS = Lt(function() {
        return (0, XS.default)([
            "matches",
            "matchesSelector",
            "mozMatchesSelector",
            "msMatchesSelector",
            "oMatchesSelector",
            "webkitMatchesSelector"
        ], function(e) {
            return e in Element.prototype;
        });
    }), WS = Lt(function() {
        var e = document.createElement("i"), t = [
            "flex",
            "-webkit-flex",
            "-ms-flexbox",
            "-moz-box",
            "-webkit-box"
        ], r = "";
        try {
            var n = t.length;
            for(var i = 0; i < n; i++){
                var o = t[i];
                if (e.style.display = o, e.style.display === o) return o;
            }
            return r;
        } catch (e1) {
            return r;
        }
    }, "flex"), wc = Lt(function() {
        var e = document.createElement("i");
        if (e.style.transform == null) {
            var t = [
                "Webkit",
                "Moz",
                "ms"
            ], r = "Transform", n = t.length;
            for(var i = 0; i < n; i++){
                var o = t[i] + r;
                if (e.style[o] !== void 0) return o;
            }
        }
        return "transform";
    }, "transform"), Fc = wc.split("transform")[0], HS = Fc ? Fc + "TransformStyle" : "transformStyle";
});
var pn = c(function(Vx, Uc) {
    var xc = function xc(e, t) {
        return 1 - 3 * t + 3 * e;
    };
    var Gc = function Gc(e, t) {
        return 3 * t - 6 * e;
    };
    var Vc = function Vc(e) {
        return 3 * e;
    };
    var Ft = function Ft(e, t, r) {
        return ((xc(t, r) * e + Gc(t, r)) * e + Vc(t)) * e;
    };
    var Xc = function Xc(e, t, r) {
        return 3 * xc(t, r) * e * e + 2 * Gc(t, r) * e + Vc(t);
    };
    var QS = function QS(e, t, r, n, i) {
        var o, u, a = 0;
        do u = t + (r - t) / 2, o = Ft(u, n, i) - e, o > 0 ? r = u : t = u;
        while (Math.abs(o) > YS && ++a < zS);
        return u;
    };
    var $S = function $S(e, t, r, n) {
        for(var i = 0; i < jS; ++i){
            var o = Xc(t, r, n);
            if (o === 0) return t;
            var u = Ft(t, r, n) - e;
            t -= u / o;
        }
        return t;
    };
    var jS = 4, KS = 0.001, YS = 1e-7, zS = 10, Qe = 11, Mt = 1 / (Qe - 1), kS = typeof Float32Array == "function";
    Uc.exports = function(t, r, n, i) {
        var a = function a(s) {
            for(var l = 0, d = 1, p = Qe - 1; d !== p && o[d] <= s; ++d)l += Mt;
            --d;
            var f = (s - o[d]) / (o[d + 1] - o[d]), E = l + f * Mt, g = Xc(E, t, n);
            return g >= KS ? $S(s, E, t, n) : g === 0 ? E : QS(s, l, l + Mt, t, n);
        };
        if (!(0 <= t && t <= 1 && 0 <= n && n <= 1)) throw new Error("bezier x values must be in [0, 1] range");
        var o = kS ? new Float32Array(Qe) : new Array(Qe);
        if (t !== r || n !== i) for(var u = 0; u < Qe; ++u)o[u] = Ft(u * Mt, t, n);
        return function(l) {
            return t === r && n === i ? l : l === 0 ? 0 : l === 1 ? 1 : Ft(a(l), r, i);
        };
    };
});
var _n = c(function(En) {
    "use strict";
    var ZS = function ZS(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var JS = function JS(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var i0 = function i0(e) {
        return Math.pow(e, 2);
    };
    var o0 = function o0(e) {
        return -(Math.pow(e - 1, 2) - 1);
    };
    var u0 = function u0(e) {
        return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 2) : -0.5 * ((e -= 2) * e - 2);
    };
    var a0 = function a0(e) {
        return Math.pow(e, 3);
    };
    var s0 = function s0(e) {
        return Math.pow(e - 1, 3) + 1;
    };
    var c0 = function c0(e) {
        return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 3) : 0.5 * (Math.pow(e - 2, 3) + 2);
    };
    var l0 = function l0(e) {
        return Math.pow(e, 4);
    };
    var f0 = function f0(e) {
        return -(Math.pow(e - 1, 4) - 1);
    };
    var d0 = function d0(e) {
        return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 4) : -0.5 * ((e -= 2) * Math.pow(e, 3) - 2);
    };
    var p0 = function p0(e) {
        return Math.pow(e, 5);
    };
    var E0 = function E0(e) {
        return Math.pow(e - 1, 5) + 1;
    };
    var _0 = function _0(e) {
        return (e /= 0.5) < 1 ? 0.5 * Math.pow(e, 5) : 0.5 * (Math.pow(e - 2, 5) + 2);
    };
    var g0 = function g0(e) {
        return -Math.cos(e * (Math.PI / 2)) + 1;
    };
    var I0 = function I0(e) {
        return Math.sin(e * (Math.PI / 2));
    };
    var h0 = function h0(e) {
        return -0.5 * (Math.cos(Math.PI * e) - 1);
    };
    var T0 = function T0(e) {
        return e === 0 ? 0 : Math.pow(2, 10 * (e - 1));
    };
    var y0 = function y0(e) {
        return e === 1 ? 1 : -Math.pow(2, -10 * e) + 1;
    };
    var O0 = function O0(e) {
        return e === 0 ? 0 : e === 1 ? 1 : (e /= 0.5) < 1 ? 0.5 * Math.pow(2, 10 * (e - 1)) : 0.5 * (-Math.pow(2, -10 * --e) + 2);
    };
    var v0 = function v0(e) {
        return -(Math.sqrt(1 - e * e) - 1);
    };
    var A0 = function A0(e) {
        return Math.sqrt(1 - Math.pow(e - 1, 2));
    };
    var S0 = function S0(e) {
        return (e /= 0.5) < 1 ? -0.5 * (Math.sqrt(1 - e * e) - 1) : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
    };
    var C0 = function C0(e) {
        return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    };
    var R0 = function R0(e) {
        var t = Z;
        return e * e * ((t + 1) * e - t);
    };
    var m0 = function m0(e) {
        var t = Z;
        return (e -= 1) * e * ((t + 1) * e + t) + 1;
    };
    var N0 = function N0(e) {
        var t = Z;
        return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    };
    var P0 = function P0(e) {
        var t = Z, r = 0, n = 1;
        return e === 0 ? 0 : e === 1 ? 1 : (r || (r = 0.3), n < 1 ? (n = 1, t = r / 4) : t = r / (2 * Math.PI) * Math.asin(1 / n), -(n * Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / r)));
    };
    var b0 = function b0(e) {
        var t = Z, r = 0, n = 1;
        return e === 0 ? 0 : e === 1 ? 1 : (r || (r = 0.3), n < 1 ? (n = 1, t = r / 4) : t = r / (2 * Math.PI) * Math.asin(1 / n), n * Math.pow(2, -10 * e) * Math.sin((e - t) * (2 * Math.PI) / r) + 1);
    };
    var L0 = function L0(e) {
        var t = Z, r = 0, n = 1;
        return e === 0 ? 0 : (e /= 1 / 2) === 2 ? 1 : (r || (r = 0.3 * 1.5), n < 1 ? (n = 1, t = r / 4) : t = r / (2 * Math.PI) * Math.asin(1 / n), e < 1 ? -0.5 * (n * Math.pow(2, 10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / r)) : n * Math.pow(2, -10 * (e -= 1)) * Math.sin((e - t) * (2 * Math.PI) / r) * 0.5 + 1);
    };
    var D0 = function D0(e) {
        var t = Z;
        return (e /= 0.5) < 1 ? 0.5 * (e * e * (((t *= 1.525) + 1) * e - t)) : 0.5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
    };
    var M0 = function M0(e) {
        var t = Z;
        return e * e * ((t + 1) * e - t);
    };
    var F0 = function F0(e) {
        var t = Z;
        return (e -= 1) * e * ((t + 1) * e + t) + 1;
    };
    var q0 = function q0(e) {
        return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75 : e < 2.5 / 2.75 ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375 : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
    };
    var w0 = function w0(e) {
        return e < 1 / 2.75 ? 7.5625 * e * e : e < 2 / 2.75 ? 2 - (7.5625 * (e -= 1.5 / 2.75) * e + 0.75) : e < 2.5 / 2.75 ? 2 - (7.5625 * (e -= 2.25 / 2.75) * e + 0.9375) : 2 - (7.5625 * (e -= 2.625 / 2.75) * e + 0.984375);
    };
    Object.defineProperty(En, "__esModule", {
        value: !0
    });
    ZS(En, {
        bounce: function bounce() {
            return q0;
        },
        bouncePast: function bouncePast() {
            return w0;
        },
        ease: function ease() {
            return e0;
        },
        easeIn: function easeIn() {
            return t0;
        },
        easeInOut: function easeInOut() {
            return n0;
        },
        easeOut: function easeOut() {
            return r0;
        },
        inBack: function inBack() {
            return R0;
        },
        inCirc: function inCirc() {
            return v0;
        },
        inCubic: function inCubic() {
            return a0;
        },
        inElastic: function inElastic() {
            return P0;
        },
        inExpo: function inExpo() {
            return T0;
        },
        inOutBack: function inOutBack() {
            return N0;
        },
        inOutCirc: function inOutCirc() {
            return S0;
        },
        inOutCubic: function inOutCubic() {
            return c0;
        },
        inOutElastic: function inOutElastic() {
            return L0;
        },
        inOutExpo: function inOutExpo() {
            return O0;
        },
        inOutQuad: function inOutQuad() {
            return u0;
        },
        inOutQuart: function inOutQuart() {
            return d0;
        },
        inOutQuint: function inOutQuint() {
            return _0;
        },
        inOutSine: function inOutSine() {
            return h0;
        },
        inQuad: function inQuad() {
            return i0;
        },
        inQuart: function inQuart() {
            return l0;
        },
        inQuint: function inQuint() {
            return p0;
        },
        inSine: function inSine() {
            return g0;
        },
        outBack: function outBack() {
            return m0;
        },
        outBounce: function outBounce() {
            return C0;
        },
        outCirc: function outCirc() {
            return A0;
        },
        outCubic: function outCubic() {
            return s0;
        },
        outElastic: function outElastic() {
            return b0;
        },
        outExpo: function outExpo() {
            return y0;
        },
        outQuad: function outQuad() {
            return o0;
        },
        outQuart: function outQuart() {
            return f0;
        },
        outQuint: function outQuint() {
            return E0;
        },
        outSine: function outSine() {
            return I0;
        },
        swingFrom: function swingFrom() {
            return M0;
        },
        swingFromTo: function swingFromTo() {
            return D0;
        },
        swingTo: function swingTo() {
            return F0;
        }
    });
    var qt = JS(pn());
    var Z = 1.70158, e0 = (0, qt.default)(0.25, 0.1, 0.25, 1), t0 = (0, qt.default)(0.42, 0, 1, 1), r0 = (0, qt.default)(0, 0, 0.58, 1), n0 = (0, qt.default)(0.42, 0, 0.58, 1);
});
var hn = c(function(In) {
    "use strict";
    var x0 = function x0(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var V0 = function V0(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var X0 = function X0(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = Wc(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    var gn = function gn(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 5, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 10;
        var n = Math.pow(r, t), i = Number(Math.round(e * n) / n);
        return Math.abs(i) > 1e-4 ? i : 0;
    };
    var U0 = function U0(e) {
        return (0, G0.default).apply(this, _toConsumableArray(e));
    };
    var B0 = function B0(e, t, r) {
        return t === 0 ? 0 : t === 1 ? 1 : gn(r ? t > 0 ? r(t) : t : t > 0 && e && Bc[e] ? Bc[e](t) : t);
    };
    Object.defineProperty(In, "__esModule", {
        value: !0
    });
    x0(In, {
        applyEasing: function applyEasing() {
            return B0;
        },
        createBezierEasing: function createBezierEasing() {
            return U0;
        },
        optimizeFloat: function optimizeFloat() {
            return gn;
        }
    });
    var Bc = X0(_n()), G0 = V0(pn());
    function Wc(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (Wc = function Wc(n) {
            return n ? r : t;
        })(e);
    }
});
var Yc = c(function(yn) {
    "use strict";
    var W0 = function W0(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var Kc = function Kc(e, t, r, n, i) {
        var o = r === H0 ? (0, wt.getIn)(i, [
            "config",
            "target",
            "objectId"
        ]) : null;
        return (0, wt.mergeIn)(e, [
            n
        ], {
            id: n,
            ref: t,
            refId: o,
            refType: r
        });
    };
    var Tn = function Tn(e, t, r, n, i) {
        var o = oC(i), u = [
            t,
            rC,
            r
        ];
        return (0, wt.mergeIn)(e, u, n, o);
    };
    var oC = function oC(e) {
        var t = e.config;
        return iC.reduce(function(r, n) {
            var i = n[0], o = n[1], u = t[i], a = t[o];
            return u != null && a != null && (r[o] = a), r;
        }, {});
    };
    Object.defineProperty(yn, "__esModule", {
        value: !0
    });
    W0(yn, {
        createElementState: function createElementState() {
            return Kc;
        },
        ixElements: function ixElements() {
            return nC;
        },
        mergeActionState: function mergeActionState() {
            return Tn;
        }
    });
    var wt = he(), jc = G(), _IX2EngineConstants = jc.IX2EngineConstants, Bx = _IX2EngineConstants.HTML_ELEMENT, H0 = _IX2EngineConstants.PLAIN_OBJECT, Wx = _IX2EngineConstants.ABSTRACT_NODE, j0 = _IX2EngineConstants.CONFIG_X_VALUE, K0 = _IX2EngineConstants.CONFIG_Y_VALUE, Y0 = _IX2EngineConstants.CONFIG_Z_VALUE, z0 = _IX2EngineConstants.CONFIG_VALUE, k0 = _IX2EngineConstants.CONFIG_X_UNIT, Q0 = _IX2EngineConstants.CONFIG_Y_UNIT, $0 = _IX2EngineConstants.CONFIG_Z_UNIT, Z0 = _IX2EngineConstants.CONFIG_UNIT, _IX2EngineActionTypes = jc.IX2EngineActionTypes, J0 = _IX2EngineActionTypes.IX2_SESSION_STOPPED, eC = _IX2EngineActionTypes.IX2_INSTANCE_ADDED, tC = _IX2EngineActionTypes.IX2_ELEMENT_STATE_CHANGED, Hc = {}, rC = "refState", nC = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Hc, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        switch(t.type){
            case J0:
                return Hc;
            case eC:
                {
                    var _payload = t.payload, r = _payload.elementId, n = _payload.element, i = _payload.origin, o = _payload.actionItem, u = _payload.refType, a = o.actionTypeId, s = e;
                    return (0, wt.getIn)(s, [
                        r,
                        n
                    ]) !== n && (s = Kc(s, n, u, r, o)), Tn(s, r, a, i, o);
                }
            case tC:
                {
                    var _payload1 = t.payload, r1 = _payload1.elementId, n1 = _payload1.actionTypeId, i1 = _payload1.current, o1 = _payload1.actionItem;
                    return Tn(e, r1, n1, i1, o1);
                }
            default:
                return e;
        }
    };
    var iC = [
        [
            j0,
            k0
        ],
        [
            K0,
            Q0
        ],
        [
            Y0,
            $0
        ],
        [
            z0,
            Z0
        ]
    ];
});
var zc = c(function(On) {
    "use strict";
    var uC = function uC(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(On, "__esModule", {
        value: !0
    });
    uC(On, {
        clearPlugin: function clearPlugin() {
            return pC;
        },
        createPluginInstance: function createPluginInstance() {
            return fC;
        },
        getPluginConfig: function getPluginConfig() {
            return aC;
        },
        getPluginDestination: function getPluginDestination() {
            return lC;
        },
        getPluginDuration: function getPluginDuration() {
            return sC;
        },
        getPluginOrigin: function getPluginOrigin() {
            return cC;
        },
        renderPlugin: function renderPlugin() {
            return dC;
        }
    });
    var aC = function(e) {
        return e.value;
    }, sC = function(e, t) {
        if (t.config.duration !== "auto") return null;
        var r = parseFloat(e.getAttribute("data-duration"));
        return r > 0 ? r * 1e3 : parseFloat(e.getAttribute("data-default-duration")) * 1e3;
    }, cC = function(e) {
        return e || {
            value: 0
        };
    }, lC = function(e) {
        return {
            value: e.value
        };
    }, fC = function(e) {
        var t = window.Webflow.require("lottie");
        if (!t) return null;
        var r = t.createInstance(e);
        return r.stop(), r.setSubframe(!0), r;
    }, dC = function(e, t, r) {
        if (!e) return;
        var n = t[r.actionTypeId].value / 100;
        e.goToFrame(e.frames * n);
    }, pC = function(e) {
        var t = window.Webflow.require("lottie");
        t && t.createInstance(e).stop();
    };
});
var Qc = c(function(vn) {
    "use strict";
    var EC = function EC(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(vn, "__esModule", {
        value: !0
    });
    EC(vn, {
        clearPlugin: function clearPlugin() {
            return SC;
        },
        createPluginInstance: function createPluginInstance() {
            return vC;
        },
        getPluginConfig: function getPluginConfig() {
            return hC;
        },
        getPluginDestination: function getPluginDestination() {
            return OC;
        },
        getPluginDuration: function getPluginDuration() {
            return TC;
        },
        getPluginOrigin: function getPluginOrigin() {
            return yC;
        },
        renderPlugin: function renderPlugin() {
            return AC;
        }
    });
    var _C = function(e) {
        return document.querySelector('[data-w-id="'.concat(e, '"]'));
    }, gC = function() {
        return window.Webflow.require("spline");
    }, IC = function(e, t) {
        return e.filter(function(r) {
            return !t.includes(r);
        });
    }, hC = function(e, t) {
        return e.value[t];
    }, TC = function() {
        return null;
    }, kc = Object.freeze({
        positionX: 0,
        positionY: 0,
        positionZ: 0,
        rotationX: 0,
        rotationY: 0,
        rotationZ: 0,
        scaleX: 1,
        scaleY: 1,
        scaleZ: 1
    }), yC = function(e, t) {
        var r = t.config.value, n = Object.keys(r);
        if (e) {
            var o = Object.keys(e), u = IC(n, o);
            return u.length ? u.reduce(function(s, l) {
                return s[l] = kc[l], s;
            }, e) : e;
        }
        return n.reduce(function(o, u) {
            return o[u] = kc[u], o;
        }, {});
    }, OC = function(e) {
        return e.value;
    }, vC = function(e, t) {
        var _t_config_target, _t_config;
        var r = t === null || t === void 0 ? void 0 : (_t_config = t.config) === null || _t_config === void 0 ? void 0 : (_t_config_target = _t_config.target) === null || _t_config_target === void 0 ? void 0 : _t_config_target.pluginElement;
        return r ? _C(r) : null;
    }, AC = function(e, t, r) {
        var n = gC();
        if (!n) return;
        var i = n.getInstance(e), o = r.config.target.objectId, u = function(a) {
            if (!a) throw new Error("Invalid spline app passed to renderSpline");
            var s = o && a.findObjectById(o);
            if (!s) return;
            var l = t.PLUGIN_SPLINE;
            l.positionX != null && (s.position.x = l.positionX), l.positionY != null && (s.position.y = l.positionY), l.positionZ != null && (s.position.z = l.positionZ), l.rotationX != null && (s.rotation.x = l.rotationX), l.rotationY != null && (s.rotation.y = l.rotationY), l.rotationZ != null && (s.rotation.z = l.rotationZ), l.scaleX != null && (s.scale.x = l.scaleX), l.scaleY != null && (s.scale.y = l.scaleY), l.scaleZ != null && (s.scale.z = l.scaleZ);
        };
        i ? u(i.spline) : n.setLoadHandler(e, u);
    }, SC = function() {
        return null;
    };
});
var $c = c(function(Cn) {
    "use strict";
    var CC = function CC(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(Cn, "__esModule", {
        value: !0
    });
    CC(Cn, {
        clearPlugin: function clearPlugin() {
            return FC;
        },
        createPluginInstance: function createPluginInstance() {
            return DC;
        },
        getPluginConfig: function getPluginConfig() {
            return NC;
        },
        getPluginDestination: function getPluginDestination() {
            return LC;
        },
        getPluginDuration: function getPluginDuration() {
            return PC;
        },
        getPluginOrigin: function getPluginOrigin() {
            return bC;
        },
        renderPlugin: function renderPlugin() {
            return MC;
        }
    });
    var An = "--wf-rive-fit", Sn = "--wf-rive-alignment", RC = function(e) {
        return document.querySelector('[data-w-id="'.concat(e, '"]'));
    }, mC = function() {
        return window.Webflow.require("rive");
    }, NC = function(e, t) {
        return e.value.inputs[t];
    }, PC = function() {
        return null;
    }, bC = function(e, t) {
        if (e) return e;
        var r = {}, _value = t.config.value, tmp = _value.inputs, n = tmp === void 0 ? {} : tmp;
        for(var i in n)n[i] == null && (r[i] = 0);
        return r;
    }, LC = function(e) {
        var _e_value_inputs;
        return (_e_value_inputs = e.value.inputs) !== null && _e_value_inputs !== void 0 ? _e_value_inputs : {};
    }, DC = function(e, t) {
        var _t_config_target, _t_config, _t_config_target1, _t_config1;
        if ((((_t_config = t.config) === null || _t_config === void 0 ? void 0 : (_t_config_target = _t_config.target) === null || _t_config_target === void 0 ? void 0 : _t_config_target.selectorGuids) || []).length > 0) return e;
        var n = t === null || t === void 0 ? void 0 : (_t_config1 = t.config) === null || _t_config1 === void 0 ? void 0 : (_t_config_target1 = _t_config1.target) === null || _t_config_target1 === void 0 ? void 0 : _t_config_target1.pluginElement;
        return n ? RC(n) : null;
    }, MC = function(e, param, r) {
        var t = param.PLUGIN_RIVE;
        var s = function s(l) {
            if (l.loaded) d();
            else {
                var p = function() {
                    d(), l === null || l === void 0 ? void 0 : l.off("load", p);
                };
                l === null || l === void 0 ? void 0 : l.on("load", p);
            }
            function d() {
                var p = l.stateMachineInputs(u);
                if (p != null) {
                    var _loop = function(f1) {
                        if (f1 === An || f1 === Sn) return "continue";
                        var E = p.find(function(g) {
                            return g.name === f1;
                        });
                        if (E != null) switch(E.type){
                            case o.Boolean:
                                {
                                    if (a[f1] != null) {
                                        var g = !!a[f1];
                                        E.value = g;
                                    }
                                    break;
                                }
                            case o.Number:
                                {
                                    var g1 = t[f1];
                                    g1 != null && (E.value = g1);
                                    break;
                                }
                            case o.Trigger:
                                {
                                    a[f1] && E.fire();
                                    break;
                                }
                        }
                    };
                    if (l.isPlaying || l.play(u, !1), An in a || Sn in a) {
                        var _a_An, _a_Sn;
                        var f = l.layout, E = (_a_An = a[An]) !== null && _a_An !== void 0 ? _a_An : f.fit, g = (_a_Sn = a[Sn]) !== null && _a_Sn !== void 0 ? _a_Sn : f.alignment;
                        (E !== f.fit || g !== f.alignment) && (l.layout = f.copyWith({
                            fit: E,
                            alignment: g
                        }));
                    }
                    for(var f1 in a)_loop(f1);
                }
            }
        };
        var n = mC();
        if (!n) return;
        var i = n.getInstance(e), o = n.rive.StateMachineInputType, ref = r.config.value || {}, u = ref.name, tmp = ref.inputs, a = tmp === void 0 ? {} : tmp;
        (i === null || i === void 0 ? void 0 : i.rive) ? s(i.rive) : n.setLoadHandler(e, s);
    }, FC = function(e, t) {
        return null;
    };
});
var mn = c(function(Rn) {
    "use strict";
    var qC = function qC(e) {
        var t, r, n, i = 1, o = e.replace(/\s/g, "").toLowerCase(), a = (typeof Zc[o] == "string" ? Zc[o].toLowerCase() : null) || o;
        if (a.startsWith("#")) {
            var s = a.substring(1);
            s.length === 3 || s.length === 4 ? (t = parseInt(s[0] + s[0], 16), r = parseInt(s[1] + s[1], 16), n = parseInt(s[2] + s[2], 16), s.length === 4 && (i = parseInt(s[3] + s[3], 16) / 255)) : (s.length === 6 || s.length === 8) && (t = parseInt(s.substring(0, 2), 16), r = parseInt(s.substring(2, 4), 16), n = parseInt(s.substring(4, 6), 16), s.length === 8 && (i = parseInt(s.substring(6, 8), 16) / 255));
        } else if (a.startsWith("rgba")) {
            var s1 = a.match(/rgba\(([^)]+)\)/)[1].split(",");
            t = parseInt(s1[0], 10), r = parseInt(s1[1], 10), n = parseInt(s1[2], 10), i = parseFloat(s1[3]);
        } else if (a.startsWith("rgb")) {
            var s2 = a.match(/rgb\(([^)]+)\)/)[1].split(",");
            t = parseInt(s2[0], 10), r = parseInt(s2[1], 10), n = parseInt(s2[2], 10);
        } else if (a.startsWith("hsla")) {
            var s3 = a.match(/hsla\(([^)]+)\)/)[1].split(","), l = parseFloat(s3[0]), d = parseFloat(s3[1].replace("%", "")) / 100, p = parseFloat(s3[2].replace("%", "")) / 100;
            i = parseFloat(s3[3]);
            var f = (1 - Math.abs(2 * p - 1)) * d, E = f * (1 - Math.abs(l / 60 % 2 - 1)), g = p - f / 2, _, h, I;
            l >= 0 && l < 60 ? (_ = f, h = E, I = 0) : l >= 60 && l < 120 ? (_ = E, h = f, I = 0) : l >= 120 && l < 180 ? (_ = 0, h = f, I = E) : l >= 180 && l < 240 ? (_ = 0, h = E, I = f) : l >= 240 && l < 300 ? (_ = E, h = 0, I = f) : (_ = f, h = 0, I = E), t = Math.round((_ + g) * 255), r = Math.round((h + g) * 255), n = Math.round((I + g) * 255);
        } else if (a.startsWith("hsl")) {
            var s4 = a.match(/hsl\(([^)]+)\)/)[1].split(","), l1 = parseFloat(s4[0]), d1 = parseFloat(s4[1].replace("%", "")) / 100, p1 = parseFloat(s4[2].replace("%", "")) / 100, f1 = (1 - Math.abs(2 * p1 - 1)) * d1, E1 = f1 * (1 - Math.abs(l1 / 60 % 2 - 1)), g1 = p1 - f1 / 2, _1, h1, I1;
            l1 >= 0 && l1 < 60 ? (_1 = f1, h1 = E1, I1 = 0) : l1 >= 60 && l1 < 120 ? (_1 = E1, h1 = f1, I1 = 0) : l1 >= 120 && l1 < 180 ? (_1 = 0, h1 = f1, I1 = E1) : l1 >= 180 && l1 < 240 ? (_1 = 0, h1 = E1, I1 = f1) : l1 >= 240 && l1 < 300 ? (_1 = E1, h1 = 0, I1 = f1) : (_1 = f1, h1 = 0, I1 = E1), t = Math.round((_1 + g1) * 255), r = Math.round((h1 + g1) * 255), n = Math.round((I1 + g1) * 255);
        }
        if (Number.isNaN(t) || Number.isNaN(r) || Number.isNaN(n)) throw new Error("Invalid color in [ix2/shared/utils/normalizeColor.js] '".concat(e, "'"));
        return {
            red: t,
            green: r,
            blue: n,
            alpha: i
        };
    };
    Object.defineProperty(Rn, "__esModule", {
        value: !0
    });
    Object.defineProperty(Rn, "normalizeColor", {
        enumerable: !0,
        get: function get() {
            return qC;
        }
    });
    var Zc = {
        aliceblue: "#F0F8FF",
        antiquewhite: "#FAEBD7",
        aqua: "#00FFFF",
        aquamarine: "#7FFFD4",
        azure: "#F0FFFF",
        beige: "#F5F5DC",
        bisque: "#FFE4C4",
        black: "#000000",
        blanchedalmond: "#FFEBCD",
        blue: "#0000FF",
        blueviolet: "#8A2BE2",
        brown: "#A52A2A",
        burlywood: "#DEB887",
        cadetblue: "#5F9EA0",
        chartreuse: "#7FFF00",
        chocolate: "#D2691E",
        coral: "#FF7F50",
        cornflowerblue: "#6495ED",
        cornsilk: "#FFF8DC",
        crimson: "#DC143C",
        cyan: "#00FFFF",
        darkblue: "#00008B",
        darkcyan: "#008B8B",
        darkgoldenrod: "#B8860B",
        darkgray: "#A9A9A9",
        darkgreen: "#006400",
        darkgrey: "#A9A9A9",
        darkkhaki: "#BDB76B",
        darkmagenta: "#8B008B",
        darkolivegreen: "#556B2F",
        darkorange: "#FF8C00",
        darkorchid: "#9932CC",
        darkred: "#8B0000",
        darksalmon: "#E9967A",
        darkseagreen: "#8FBC8F",
        darkslateblue: "#483D8B",
        darkslategray: "#2F4F4F",
        darkslategrey: "#2F4F4F",
        darkturquoise: "#00CED1",
        darkviolet: "#9400D3",
        deeppink: "#FF1493",
        deepskyblue: "#00BFFF",
        dimgray: "#696969",
        dimgrey: "#696969",
        dodgerblue: "#1E90FF",
        firebrick: "#B22222",
        floralwhite: "#FFFAF0",
        forestgreen: "#228B22",
        fuchsia: "#FF00FF",
        gainsboro: "#DCDCDC",
        ghostwhite: "#F8F8FF",
        gold: "#FFD700",
        goldenrod: "#DAA520",
        gray: "#808080",
        green: "#008000",
        greenyellow: "#ADFF2F",
        grey: "#808080",
        honeydew: "#F0FFF0",
        hotpink: "#FF69B4",
        indianred: "#CD5C5C",
        indigo: "#4B0082",
        ivory: "#FFFFF0",
        khaki: "#F0E68C",
        lavender: "#E6E6FA",
        lavenderblush: "#FFF0F5",
        lawngreen: "#7CFC00",
        lemonchiffon: "#FFFACD",
        lightblue: "#ADD8E6",
        lightcoral: "#F08080",
        lightcyan: "#E0FFFF",
        lightgoldenrodyellow: "#FAFAD2",
        lightgray: "#D3D3D3",
        lightgreen: "#90EE90",
        lightgrey: "#D3D3D3",
        lightpink: "#FFB6C1",
        lightsalmon: "#FFA07A",
        lightseagreen: "#20B2AA",
        lightskyblue: "#87CEFA",
        lightslategray: "#778899",
        lightslategrey: "#778899",
        lightsteelblue: "#B0C4DE",
        lightyellow: "#FFFFE0",
        lime: "#00FF00",
        limegreen: "#32CD32",
        linen: "#FAF0E6",
        magenta: "#FF00FF",
        maroon: "#800000",
        mediumaquamarine: "#66CDAA",
        mediumblue: "#0000CD",
        mediumorchid: "#BA55D3",
        mediumpurple: "#9370DB",
        mediumseagreen: "#3CB371",
        mediumslateblue: "#7B68EE",
        mediumspringgreen: "#00FA9A",
        mediumturquoise: "#48D1CC",
        mediumvioletred: "#C71585",
        midnightblue: "#191970",
        mintcream: "#F5FFFA",
        mistyrose: "#FFE4E1",
        moccasin: "#FFE4B5",
        navajowhite: "#FFDEAD",
        navy: "#000080",
        oldlace: "#FDF5E6",
        olive: "#808000",
        olivedrab: "#6B8E23",
        orange: "#FFA500",
        orangered: "#FF4500",
        orchid: "#DA70D6",
        palegoldenrod: "#EEE8AA",
        palegreen: "#98FB98",
        paleturquoise: "#AFEEEE",
        palevioletred: "#DB7093",
        papayawhip: "#FFEFD5",
        peachpuff: "#FFDAB9",
        peru: "#CD853F",
        pink: "#FFC0CB",
        plum: "#DDA0DD",
        powderblue: "#B0E0E6",
        purple: "#800080",
        rebeccapurple: "#663399",
        red: "#FF0000",
        rosybrown: "#BC8F8F",
        royalblue: "#4169E1",
        saddlebrown: "#8B4513",
        salmon: "#FA8072",
        sandybrown: "#F4A460",
        seagreen: "#2E8B57",
        seashell: "#FFF5EE",
        sienna: "#A0522D",
        silver: "#C0C0C0",
        skyblue: "#87CEEB",
        slateblue: "#6A5ACD",
        slategray: "#708090",
        slategrey: "#708090",
        snow: "#FFFAFA",
        springgreen: "#00FF7F",
        steelblue: "#4682B4",
        tan: "#D2B48C",
        teal: "#008080",
        thistle: "#D8BFD8",
        tomato: "#FF6347",
        turquoise: "#40E0D0",
        violet: "#EE82EE",
        wheat: "#F5DEB3",
        white: "#FFFFFF",
        whitesmoke: "#F5F5F5",
        yellow: "#FFFF00",
        yellowgreen: "#9ACD32"
    };
});
var Jc = c(function(Nn) {
    "use strict";
    var wC = function wC(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(Nn, "__esModule", {
        value: !0
    });
    wC(Nn, {
        clearPlugin: function clearPlugin() {
            return jC;
        },
        createPluginInstance: function createPluginInstance() {
            return BC;
        },
        getPluginConfig: function getPluginConfig() {
            return GC;
        },
        getPluginDestination: function getPluginDestination() {
            return UC;
        },
        getPluginDuration: function getPluginDuration() {
            return VC;
        },
        getPluginOrigin: function getPluginOrigin() {
            return XC;
        },
        renderPlugin: function renderPlugin() {
            return HC;
        }
    });
    var xC = mn(), GC = function(e, t) {
        return e.value[t];
    }, VC = function() {
        return null;
    }, XC = function(e, t) {
        if (e) return e;
        var r = t.config.value, n = t.config.target.objectId, i = getComputedStyle(document.documentElement).getPropertyValue(n);
        if (r.size != null) return {
            size: parseInt(i, 10)
        };
        if (r.unit === "%" || r.unit === "-") return {
            size: parseFloat(i)
        };
        if (r.red != null && r.green != null && r.blue != null) return (0, xC.normalizeColor)(i);
    }, UC = function(e) {
        return e.value;
    }, BC = function() {
        return null;
    }, WC = {
        color: {
            match: function(param) {
                var e = param.red, t = param.green, r = param.blue, n = param.alpha;
                return [
                    e,
                    t,
                    r,
                    n
                ].every(function(i) {
                    return i != null;
                });
            },
            getValue: function(param) {
                var e = param.red, t = param.green, r = param.blue, n = param.alpha;
                return "rgba(".concat(e, ", ").concat(t, ", ").concat(r, ", ").concat(n, ")");
            }
        },
        size: {
            match: function(param) {
                var e = param.size;
                return e != null;
            },
            getValue: function(param, t) {
                var e = param.size;
                switch(t){
                    case "-":
                        return e;
                    default:
                        return "".concat(e).concat(t);
                }
            }
        }
    }, HC = function(e, t, r) {
        var _config = r.config, _target = _config.target, n = _target.objectId, _value = _config.value, i = _value.unit, o = t.PLUGIN_VARIABLE, u = Object.values(WC).find(function(a) {
            return a.match(o, i);
        });
        u && document.documentElement.style.setProperty(n, u.getValue(o, i));
    }, jC = function(e, t) {
        var r = t.config.target.objectId;
        document.documentElement.style.removeProperty(r);
    };
});
var tl = c(function(Pn) {
    "use strict";
    var Gt = function Gt(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = el(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    Object.defineProperty(Pn, "__esModule", {
        value: !0
    });
    Object.defineProperty(Pn, "pluginMethodMap", {
        enumerable: !0,
        get: function get() {
            return QC;
        }
    });
    var xt = G(), KC = Gt(zc()), YC = Gt(Qc()), zC = Gt($c()), kC = Gt(Jc());
    function el(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (el = function el(n) {
            return n ? r : t;
        })(e);
    }
    var QC = new Map([
        [
            xt.ActionTypeConsts.PLUGIN_LOTTIE,
            _object_spread({}, KC)
        ],
        [
            xt.ActionTypeConsts.PLUGIN_SPLINE,
            _object_spread({}, YC)
        ],
        [
            xt.ActionTypeConsts.PLUGIN_RIVE,
            _object_spread({}, zC)
        ],
        [
            xt.ActionTypeConsts.PLUGIN_VARIABLE,
            _object_spread({}, kC)
        ]
    ]);
});
var Ln = c(function(bn) {
    "use strict";
    var $C = function $C(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var JC = function JC(e) {
        return rl.pluginMethodMap.has(e);
    };
    Object.defineProperty(bn, "__esModule", {
        value: !0
    });
    $C(bn, {
        clearPlugin: function clearPlugin() {
            return uR;
        },
        createPluginInstance: function createPluginInstance() {
            return iR;
        },
        getPluginConfig: function getPluginConfig() {
            return eR;
        },
        getPluginDestination: function getPluginDestination() {
            return nR;
        },
        getPluginDuration: function getPluginDuration() {
            return rR;
        },
        getPluginOrigin: function getPluginOrigin() {
            return tR;
        },
        isPluginType: function isPluginType() {
            return JC;
        },
        renderPlugin: function renderPlugin() {
            return oR;
        }
    });
    var ZC = Dt(), rl = tl();
    var ce = function(e) {
        return function(t) {
            if (!ZC.IS_BROWSER_ENV) return function() {
                return null;
            };
            var r = rl.pluginMethodMap.get(t);
            if (!r) throw new Error("IX2 no plugin configured for: ".concat(t));
            var n = r[e];
            if (!n) throw new Error("IX2 invalid plugin method: ".concat(e));
            return n;
        };
    }, eR = ce("getPluginConfig"), tR = ce("getPluginOrigin"), rR = ce("getPluginDuration"), nR = ce("getPluginDestination"), iR = ce("createPluginInstance"), oR = ce("renderPlugin"), uR = ce("clearPlugin");
});
var il = c(function(Zx, nl) {
    var aR = function aR(e, t) {
        return e == null || e !== e ? t : e;
    };
    nl.exports = aR;
});
var ul = c(function(Jx, ol) {
    var sR = function sR(e, t, r, n) {
        var i = -1, o = e == null ? 0 : e.length;
        for(n && o && (r = e[++i]); ++i < o;)r = t(r, e[i], i, e);
        return r;
    };
    ol.exports = sR;
});
var sl = c(function(e2, al) {
    var cR = function cR(e) {
        return function(t, r, n) {
            for(var i = -1, o = Object(t), u = n(t), a = u.length; a--;){
                var s = u[e ? a : ++i];
                if (r(o[s], s, o) === !1) break;
            }
            return t;
        };
    };
    al.exports = cR;
});
var ll = c(function(t2, cl) {
    var lR = sl(), fR = lR();
    cl.exports = fR;
});
var Dn = c(function(r2, fl) {
    var ER = function ER(e, t) {
        return e && dR(e, t, pR);
    };
    var dR = ll(), pR = Ye();
    fl.exports = ER;
});
var pl = c(function(n2, dl) {
    var gR = function gR(e, t) {
        return function(r, n) {
            if (r == null) return r;
            if (!_R(r)) return e(r, n);
            for(var i = r.length, o = t ? i : -1, u = Object(r); (t ? o-- : ++o < i) && n(u[o], o, u) !== !1;);
            return r;
        };
    };
    var _R = ae();
    dl.exports = gR;
});
var Mn = c(function(i2, El) {
    var IR = Dn(), hR = pl(), TR = hR(IR);
    El.exports = TR;
});
var gl = c(function(o2, _l) {
    var yR = function yR(e, t, r, n, i) {
        return i(e, function(o, u, a) {
            r = n ? (n = !1, o) : t(r, o, u, a);
        }), r;
    };
    _l.exports = yR;
});
var hl = c(function(u2, Il) {
    var RR = function RR(e, t, r) {
        var n = CR(e) ? OR : SR, i = arguments.length < 3;
        return n(e, AR(t, 4), r, i, vR);
    };
    var OR = ul(), vR = Mn(), AR = re(), SR = gl(), CR = w();
    Il.exports = RR;
});
var yl = c(function(a2, Tl) {
    var DR = function DR(e, t, r) {
        var n = e == null ? 0 : e.length;
        if (!n) return -1;
        var i = n - 1;
        return r !== void 0 && (i = PR(r), i = r < 0 ? bR(n + i, 0) : LR(i, n - 1)), mR(e, NR(t, 3), i, !0);
    };
    var mR = cn(), NR = re(), PR = ln(), bR = Math.max, LR = Math.min;
    Tl.exports = DR;
});
var vl = c(function(s2, Ol) {
    var MR = sn(), FR = yl(), qR = MR(FR);
    Ol.exports = qR;
});
var Sl = c(function(Fn) {
    "use strict";
    var Al = function Al(e, t) {
        return e === t ? e !== 0 || t !== 0 || 1 / e === 1 / t : e !== e && t !== t;
    };
    var wR = function wR(e, t) {
        if (Al(e, t)) return !0;
        if (typeof e != "object" || e === null || typeof t != "object" || t === null) return !1;
        var r = Object.keys(e), n = Object.keys(t);
        if (r.length !== n.length) return !1;
        for(var i = 0; i < r.length; i++)if (!Object.hasOwn(t, r[i]) || !Al(e[r[i]], t[r[i]])) return !1;
        return !0;
    };
    Object.defineProperty(Fn, "__esModule", {
        value: !0
    });
    Object.defineProperty(Fn, "default", {
        enumerable: !0,
        get: function get() {
            return xR;
        }
    });
    var xR = wR;
});
var Wl = c(function(Wn) {
    "use strict";
    var GR = function GR(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var Bt = function Bt(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var nm = function nm() {
        Vt.clear();
    };
    var om = function om() {
        return "i" + im++;
    };
    var am = function am(e, t) {
        for(var r in e){
            var n = e[r];
            if (n && n.ref === t) return n.id;
        }
        return "e" + um++;
    };
    var sm = function sm() {
        var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, e = ref.events, t = ref.actionLists, r = ref.site;
        var n = (0, xn.default)(e, function(u, a) {
            var s = a.eventTypeId;
            return u[s] || (u[s] = {}), u[s][a.id] = a, u;
        }, {}), i = r && r.mediaQueries, o = [];
        return i ? o = i.map(function(u) {
            return u.key;
        }) : (i = [], console.warn("IX2 missing mediaQueries in site data")), {
            ixData: {
                events: e,
                actionLists: t,
                eventTypeMap: n,
                mediaQueries: i,
                mediaQueryKeys: o
            }
        };
    };
    var lm = function lm(param) {
        var e = param.store, t = param.select, r = param.onChange, tmp = param.comparator, n = tmp === void 0 ? cm : tmp;
        var i = e.getState, o = e.subscribe, u = o(s), a = t(i());
        function s() {
            var l = t(i());
            if (l == null) {
                u();
                return;
            }
            n(l, a) || (a = l, r(a, e));
        }
        return u;
    };
    var Nl = function Nl(e) {
        var t = typeof e === "undefined" ? "undefined" : _typeOf(e);
        if (t === "string") return {
            id: e
        };
        if (e != null && t === "object") {
            var r = e.id, n = e.objectId, i = e.selector, o = e.selectorGuids, u = e.appliesTo, a = e.useEventTarget;
            return {
                id: r,
                objectId: n,
                selector: i,
                selectorGuids: o,
                appliesTo: u,
                useEventTarget: a
            };
        }
        return {};
    };
    var fm = function fm(param) {
        var e = param.element, t = param.actionItem;
        if (!x.IS_BROWSER_ENV) return {};
        var r = t.actionTypeId;
        switch(r){
            case Le:
            case De:
            case Me:
            case Fe:
            case Wt:
                return window.getComputedStyle(e);
            default:
                return {};
        }
    };
    var Em = function Em(e) {
        var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 ? arguments[4] : void 0;
        var o = i.getStyle, u = n.actionTypeId;
        if ((0, k.isPluginType)(u)) return (0, k.getPluginOrigin)(u)(t[u], n);
        switch(n.actionTypeId){
            case Ne:
            case Pe:
            case be:
            case et:
                return t[n.actionTypeId] || Bn[n.actionTypeId];
            case tt:
                return dm(t[n.actionTypeId], n.config.filters);
            case rt:
                return pm(t[n.actionTypeId], n.config.fontVariations);
            case wl:
                return {
                    value: (0, ne.default)(parseFloat(o(e, Xt)), 1)
                };
            case Le:
                {
                    var a = o(e, Y), s = o(e, z), l, d;
                    return n.config.widthUnit === ie ? l = Pl.test(a) ? parseFloat(a) : parseFloat(r.width) : l = (0, ne.default)(parseFloat(a), parseFloat(r.width)), n.config.heightUnit === ie ? d = Pl.test(s) ? parseFloat(s) : parseFloat(r.height) : d = (0, ne.default)(parseFloat(s), parseFloat(r.height)), {
                        widthValue: l,
                        heightValue: d
                    };
                }
            case De:
            case Me:
            case Fe:
                return Mm({
                    element: e,
                    actionTypeId: n.actionTypeId,
                    computedStyle: r,
                    getStyle: o
                });
            case Wt:
                return {
                    value: (0, ne.default)(o(e, Ut), r.display)
                };
            case rm:
                return t[n.actionTypeId] || {
                    value: 0
                };
            default:
                return;
        }
    };
    var hm = function hm(param) {
        var e = param.element, t = param.actionItem, r = param.elementApi;
        if ((0, k.isPluginType)(t.actionTypeId)) return (0, k.getPluginDestination)(t.actionTypeId)(t.config);
        switch(t.actionTypeId){
            case Ne:
            case Pe:
            case be:
            case et:
                {
                    var _config = t.config, n = _config.xValue, i = _config.yValue, o = _config.zValue;
                    return {
                        xValue: n,
                        yValue: i,
                        zValue: o
                    };
                }
            case Le:
                {
                    var n1 = r.getStyle, i1 = r.setStyle, o1 = r.getProperty, _config1 = t.config, u = _config1.widthUnit, a = _config1.heightUnit, _config2 = t.config, s = _config2.widthValue, l = _config2.heightValue;
                    if (!x.IS_BROWSER_ENV) return {
                        widthValue: s,
                        heightValue: l
                    };
                    if (u === ie) {
                        var d = n1(e, Y);
                        i1(e, Y, ""), s = o1(e, "offsetWidth"), i1(e, Y, d);
                    }
                    if (a === ie) {
                        var d1 = n1(e, z);
                        i1(e, z, ""), l = o1(e, "offsetHeight"), i1(e, z, d1);
                    }
                    return {
                        widthValue: s,
                        heightValue: l
                    };
                }
            case De:
            case Me:
            case Fe:
                {
                    var _config3 = t.config, n2 = _config3.rValue, i2 = _config3.gValue, o2 = _config3.bValue, u1 = _config3.aValue, a1 = _config3.globalSwatchId;
                    if (a1 && a1.startsWith("--")) {
                        var s1 = r.getStyle, l1 = s1(e, a1), d2 = (0, XR.normalizeColor)(l1);
                        return {
                            rValue: d2.red,
                            gValue: d2.green,
                            bValue: d2.blue,
                            aValue: d2.alpha
                        };
                    }
                    return {
                        rValue: n2,
                        gValue: i2,
                        bValue: o2,
                        aValue: u1
                    };
                }
            case tt:
                return t.config.filters.reduce(_m, {});
            case rt:
                return t.config.fontVariations.reduce(gm, {});
            default:
                {
                    var _config4 = t.config, n3 = _config4.value;
                    return {
                        value: n3
                    };
                }
        }
    };
    var Vl = function Vl(e) {
        if (/^TRANSFORM_/.test(e)) return Fl;
        if (/^STYLE_/.test(e)) return Vn;
        if (/^GENERAL_/.test(e)) return Gn;
        if (/^PLUGIN_/.test(e)) return ql;
    };
    var Tm = function Tm(e, t) {
        return e === Vn ? t.replace("STYLE_", "").toLowerCase() : null;
    };
    var ym = function ym(e, t, r, n, i, o, u, a, s) {
        switch(a){
            case Fl:
                return Cm(e, t, r, i, u);
            case Vn:
                return Fm(e, t, r, i, o, u);
            case Gn:
                return qm(e, i, u);
            case ql:
                {
                    var l = i.actionTypeId;
                    if ((0, k.isPluginType)(l)) return (0, k.renderPlugin)(l)(s, t, i);
                }
        }
    };
    var Cm = function Cm(e, t, r, n, i) {
        var o = Sm.map(function(a) {
            var s = Bn[a], ref = t[a] || {}, tmp = ref.xValue, l = tmp === void 0 ? s.xValue : tmp, tmp1 = ref.yValue, d = tmp1 === void 0 ? s.yValue : tmp1, tmp2 = ref.zValue, p = tmp2 === void 0 ? s.zValue : tmp2, tmp3 = ref.xUnit, f = tmp3 === void 0 ? "" : tmp3, tmp4 = ref.yUnit, E = tmp4 === void 0 ? "" : tmp4, tmp5 = ref.zUnit, g = tmp5 === void 0 ? "" : tmp5;
            switch(a){
                case Ne:
                    return "".concat(WR, "(").concat(l).concat(f, ", ").concat(d).concat(E, ", ").concat(p).concat(g, ")");
                case Pe:
                    return "".concat(HR, "(").concat(l).concat(f, ", ").concat(d).concat(E, ", ").concat(p).concat(g, ")");
                case be:
                    return "".concat(jR, "(").concat(l).concat(f, ") ").concat(KR, "(").concat(d).concat(E, ") ").concat(YR, "(").concat(p).concat(g, ")");
                case et:
                    return "".concat(zR, "(").concat(l).concat(f, ", ").concat(d).concat(E, ")");
                default:
                    return "";
            }
        }).join(" "), u = i.setStyle;
        fe(e, x.TRANSFORM_PREFIXED, i), u(e, x.TRANSFORM_PREFIXED, o), Nm(n, r) && u(e, x.TRANSFORM_STYLE_PREFIXED, kR);
    };
    var Rm = function Rm(e, t, r, n) {
        var i = (0, xn.default)(t, function(u, a, s) {
            return "".concat(u, " ").concat(s, "(").concat(a).concat(Am(s, r), ")");
        }, ""), o = n.setStyle;
        fe(e, $e, n), o(e, $e, i);
    };
    var mm = function mm(e, t, r, n) {
        var i = (0, xn.default)(t, function(u, a, s) {
            return u.push('"'.concat(s, '" ').concat(a)), u;
        }, []).join(", "), o = n.setStyle;
        fe(e, Ze, n), o(e, Ze, i);
    };
    var Nm = function Nm(param, param1) {
        var e = param.actionTypeId, t = param1.xValue, r = param1.yValue, n = param1.zValue;
        return e === Ne && n !== void 0 || e === Pe && n !== void 0 || e === be && (t !== void 0 || r !== void 0);
    };
    var Dm = function Dm(e, t) {
        var r = e.exec(t);
        return r ? r[1] : "";
    };
    var Mm = function Mm(param) {
        var e = param.element, t = param.actionTypeId, r = param.computedStyle, n = param.getStyle;
        var i = Xn[t], o = n(e, i), u = bm.test(o) ? o : r[i], a = Dm(Lm, u).split(Je);
        return {
            rValue: (0, ne.default)(parseInt(a[0], 10), 255),
            gValue: (0, ne.default)(parseInt(a[1], 10), 255),
            bValue: (0, ne.default)(parseInt(a[2], 10), 255),
            aValue: (0, ne.default)(parseFloat(a[3]), 1)
        };
    };
    var Fm = function Fm(e, t, r, n, i, o) {
        var u = o.setStyle;
        switch(n.actionTypeId){
            case Le:
                {
                    var _config = n.config, tmp = _config.widthUnit, a = tmp === void 0 ? "" : tmp, tmp1 = _config.heightUnit, s = tmp1 === void 0 ? "" : tmp1, l = r.widthValue, d = r.heightValue;
                    l !== void 0 && (a === ie && (a = "px"), fe(e, Y, o), u(e, Y, l + a)), d !== void 0 && (s === ie && (s = "px"), fe(e, z, o), u(e, z, d + s));
                    break;
                }
            case tt:
                {
                    Rm(e, r, n.config, o);
                    break;
                }
            case rt:
                {
                    mm(e, r, n.config, o);
                    break;
                }
            case De:
            case Me:
            case Fe:
                {
                    var a1 = Xn[n.actionTypeId], s1 = Math.round(r.rValue), l1 = Math.round(r.gValue), d1 = Math.round(r.bValue), p = r.aValue;
                    fe(e, a1, o), u(e, a1, p >= 1 ? "rgb(".concat(s1, ",").concat(l1, ",").concat(d1, ")") : "rgba(".concat(s1, ",").concat(l1, ",").concat(d1, ",").concat(p, ")"));
                    break;
                }
            default:
                {
                    var _config1 = n.config, tmp2 = _config1.unit, a2 = tmp2 === void 0 ? "" : tmp2;
                    fe(e, i, o), u(e, i, r.value + a2);
                    break;
                }
        }
    };
    var qm = function qm(e, t, r) {
        var n = r.setStyle;
        switch(t.actionTypeId){
            case Wt:
                {
                    var _config = t.config, i = _config.value;
                    i === QR && x.IS_BROWSER_ENV ? n(e, Ut, x.FLEX_PREFIXED) : n(e, Ut, i);
                    return;
                }
        }
    };
    var fe = function fe(e, t, r) {
        if (!x.IS_BROWSER_ENV) return;
        var n = Gl[t];
        if (!n) return;
        var i = r.getStyle, o = r.setStyle, u = i(e, me);
        if (!u) {
            o(e, me, n);
            return;
        }
        var a = u.split(Je).map(xl);
        a.indexOf(n) === -1 && o(e, me, a.concat(n).join(Je));
    };
    var Xl = function Xl(e, t, r) {
        if (!x.IS_BROWSER_ENV) return;
        var n = Gl[t];
        if (!n) return;
        var i = r.getStyle, o = r.setStyle, u = i(e, me);
        !u || u.indexOf(n) === -1 || o(e, me, u.split(Je).map(xl).filter(function(a) {
            return a !== n;
        }).join(Je));
    };
    var wm = function wm(param) {
        var e = param.store, t = param.elementApi;
        var ref = e.getState(), r = ref.ixData, tmp = r.events, n = tmp === void 0 ? {} : tmp, tmp1 = r.actionLists, i = tmp1 === void 0 ? {} : tmp1;
        Object.keys(n).forEach(function(o) {
            var u = n[o], _action = u.action, a = _action.config, s = a.actionListId, l = i[s];
            l && bl({
                actionList: l,
                event: u,
                elementApi: t
            });
        }), Object.keys(i).forEach(function(o) {
            bl({
                actionList: i[o],
                elementApi: t
            });
        });
    };
    var bl = function bl(param) {
        var tmp = param.actionList, e = tmp === void 0 ? {} : tmp, t = param.event, r = param.elementApi;
        var n = e.actionItemGroups, i = e.continuousParameterGroups;
        n && n.forEach(function(o) {
            Ll({
                actionGroup: o,
                event: t,
                elementApi: r
            });
        }), i && i.forEach(function(o) {
            var u = o.continuousActionGroups;
            u.forEach(function(a) {
                Ll({
                    actionGroup: a,
                    event: t,
                    elementApi: r
                });
            });
        });
    };
    var Ll = function Ll(param) {
        var e = param.actionGroup, t = param.event, r = param.elementApi;
        var n = e.actionItems;
        n.forEach(function(i) {
            var o = i.actionTypeId, u = i.config, a;
            (0, k.isPluginType)(o) ? a = function(s) {
                return (0, k.clearPlugin)(o)(s, i);
            } : a = Ul({
                effect: Gm,
                actionTypeId: o,
                elementApi: r
            }), Un({
                config: u,
                event: t,
                elementApi: r
            }).forEach(a);
        });
    };
    var xm = function xm(e, t, r) {
        var n = r.setStyle, i = r.getStyle, o = t.actionTypeId;
        if (o === Le) {
            var u = t.config;
            u.widthUnit === ie && n(e, Y, ""), u.heightUnit === ie && n(e, z, "");
        }
        i(e, me) && Ul({
            effect: Xl,
            actionTypeId: o,
            elementApi: r
        })(e);
    };
    var Gm = function Gm(e, t, r) {
        var n = r.setStyle;
        Xl(e, t, r), n(e, t, ""), t === x.TRANSFORM_PREFIXED && n(e, x.TRANSFORM_STYLE_PREFIXED, "");
    };
    var Bl = function Bl(e) {
        var t = 0, r = 0;
        return e.forEach(function(n, i) {
            var o = n.config, u = o.delay + o.duration;
            u >= t && (t = u, r = i);
        }), r;
    };
    var Vm = function Vm(e, t) {
        var r = e.actionItemGroups, n = e.useFirstGroupAsInitialState, i = t.actionItem, tmp = t.verboseTimeElapsed, o = tmp === void 0 ? 0 : tmp, u = 0, a = 0;
        return r.forEach(function(s, l) {
            if (n && l === 0) return;
            var d = s.actionItems, p = d[Bl(d)], f = p.config, E = p.actionTypeId;
            i.id === p.id && (a = u + o);
            var g = Vl(E) === Gn ? 0 : f.duration;
            u += f.delay + g;
        }), u > 0 ? (0, VR.optimizeFloat)(a / u) : 0;
    };
    var Xm = function Xm(param) {
        var e = param.actionList, t = param.actionItemId, r = param.rawData;
        var n = e.actionItemGroups, i = e.continuousParameterGroups, o = [], u = function(a) {
            return o.push((0, Cl.mergeIn)(a, [
                "config"
            ], {
                delay: 0,
                duration: 0
            })), a.id === t;
        };
        return n && n.some(function(param) {
            var a = param.actionItems;
            return a.some(u);
        }), i && i.some(function(a) {
            var s = a.continuousActionGroups;
            return s.some(function(param) {
                var l = param.actionItems;
                return l.some(u);
            });
        }), (0, Cl.setIn)(r, [
            "actionLists"
        ], _defineProperty({}, e.id, {
            id: e.id,
            actionItemGroups: [
                {
                    actionItems: o
                }
            ]
        }));
    };
    var Um = function Um(e, param) {
        var t = param.basedOn;
        return e === le.EventTypeConsts.SCROLLING_IN_VIEW && (t === le.EventBasedOn.ELEMENT || t == null) || e === le.EventTypeConsts.MOUSE_MOVE && t === le.EventBasedOn.ELEMENT;
    };
    var Bm = function Bm(e, t) {
        return e + tm + t;
    };
    var Wm = function Wm(e, t) {
        return t == null ? !0 : e.indexOf(t) !== -1;
    };
    var Hm = function Hm(e, t) {
        return (0, Dl.default)(e && e.sort(), t && t.sort());
    };
    var jm = function jm(e) {
        if (typeof e == "string") return e;
        if (e.pluginElement && e.objectId) return e.pluginElement + qn + e.objectId;
        if (e.objectId) return e.objectId;
        var tmp = e.id, t = tmp === void 0 ? "" : tmp, tmp1 = e.selector, r = tmp1 === void 0 ? "" : tmp1, tmp2 = e.useEventTarget, n = tmp2 === void 0 ? "" : tmp2;
        return t + qn + r + qn + n;
    };
    Object.defineProperty(Wn, "__esModule", {
        value: !0
    });
    GR(Wn, {
        cleanupHTMLElement: function cleanupHTMLElement() {
            return xm;
        },
        clearAllStyles: function clearAllStyles() {
            return wm;
        },
        clearObjectCache: function clearObjectCache() {
            return nm;
        },
        getActionListProgress: function getActionListProgress() {
            return Vm;
        },
        getAffectedElements: function getAffectedElements() {
            return Un;
        },
        getComputedStyle: function getComputedStyle1() {
            return fm;
        },
        getDestinationValues: function getDestinationValues() {
            return hm;
        },
        getElementId: function getElementId() {
            return am;
        },
        getInstanceId: function getInstanceId() {
            return om;
        },
        getInstanceOrigin: function getInstanceOrigin() {
            return Em;
        },
        getItemConfigByKey: function getItemConfigByKey() {
            return Im;
        },
        getMaxDurationItemIndex: function getMaxDurationItemIndex() {
            return Bl;
        },
        getNamespacedParameterId: function getNamespacedParameterId() {
            return Bm;
        },
        getRenderType: function getRenderType() {
            return Vl;
        },
        getStyleProp: function getStyleProp() {
            return Tm;
        },
        mediaQueriesEqual: function mediaQueriesEqual() {
            return Hm;
        },
        observeStore: function observeStore() {
            return lm;
        },
        reduceListToGroup: function reduceListToGroup() {
            return Xm;
        },
        reifyState: function reifyState() {
            return sm;
        },
        renderHTMLElement: function renderHTMLElement() {
            return ym;
        },
        shallowEqual: function shallowEqual() {
            return Dl.default;
        },
        shouldAllowMediaQuery: function shouldAllowMediaQuery() {
            return Wm;
        },
        shouldNamespaceEventParameter: function shouldNamespaceEventParameter() {
            return Um;
        },
        stringifyTarget: function stringifyTarget() {
            return jm;
        }
    });
    var ne = Bt(il()), xn = Bt(hl()), wn = Bt(vl()), Cl = he(), le = G(), Dl = Bt(Sl()), VR = hn(), XR = mn(), k = Ln(), x = Dt();
    var _obj, _obj1;
    var _IX2EngineConstants = le.IX2EngineConstants, UR = _IX2EngineConstants.BACKGROUND, BR = _IX2EngineConstants.TRANSFORM, WR = _IX2EngineConstants.TRANSLATE_3D, HR = _IX2EngineConstants.SCALE_3D, jR = _IX2EngineConstants.ROTATE_X, KR = _IX2EngineConstants.ROTATE_Y, YR = _IX2EngineConstants.ROTATE_Z, zR = _IX2EngineConstants.SKEW, kR = _IX2EngineConstants.PRESERVE_3D, QR = _IX2EngineConstants.FLEX, Xt = _IX2EngineConstants.OPACITY, $e = _IX2EngineConstants.FILTER, Ze = _IX2EngineConstants.FONT_VARIATION_SETTINGS, Y = _IX2EngineConstants.WIDTH, z = _IX2EngineConstants.HEIGHT, Ml = _IX2EngineConstants.BACKGROUND_COLOR, $R = _IX2EngineConstants.BORDER_COLOR, ZR = _IX2EngineConstants.COLOR, Rl = _IX2EngineConstants.CHILDREN, JR = _IX2EngineConstants.IMMEDIATE_CHILDREN, ml = _IX2EngineConstants.SIBLINGS, em = _IX2EngineConstants.PARENT, Ut = _IX2EngineConstants.DISPLAY, me = _IX2EngineConstants.WILL_CHANGE, ie = _IX2EngineConstants.AUTO, Je = _IX2EngineConstants.COMMA_DELIMITER, tm = _IX2EngineConstants.COLON_DELIMITER, qn = _IX2EngineConstants.BAR_DELIMITER, Fl = _IX2EngineConstants.RENDER_TRANSFORM, Gn = _IX2EngineConstants.RENDER_GENERAL, Vn = _IX2EngineConstants.RENDER_STYLE, ql = _IX2EngineConstants.RENDER_PLUGIN, _ActionTypeConsts = le.ActionTypeConsts, Ne = _ActionTypeConsts.TRANSFORM_MOVE, Pe = _ActionTypeConsts.TRANSFORM_SCALE, be = _ActionTypeConsts.TRANSFORM_ROTATE, et = _ActionTypeConsts.TRANSFORM_SKEW, wl = _ActionTypeConsts.STYLE_OPACITY, tt = _ActionTypeConsts.STYLE_FILTER, rt = _ActionTypeConsts.STYLE_FONT_VARIATION, Le = _ActionTypeConsts.STYLE_SIZE, De = _ActionTypeConsts.STYLE_BACKGROUND_COLOR, Me = _ActionTypeConsts.STYLE_BORDER, Fe = _ActionTypeConsts.STYLE_TEXT_COLOR, Wt = _ActionTypeConsts.GENERAL_DISPLAY, rm = _ActionTypeConsts.OBJECT_VALUE, xl = function(e) {
        return e.trim();
    }, Xn = Object.freeze((_obj = {}, _defineProperty(_obj, De, Ml), _defineProperty(_obj, Me, $R), _defineProperty(_obj, Fe, ZR), _obj)), Gl = Object.freeze((_obj1 = {}, _defineProperty(_obj1, x.TRANSFORM_PREFIXED, BR), _defineProperty(_obj1, Ml, UR), _defineProperty(_obj1, Xt, Xt), _defineProperty(_obj1, $e, $e), _defineProperty(_obj1, Y, Y), _defineProperty(_obj1, z, z), _defineProperty(_obj1, Ze, Ze), _obj1)), Vt = new Map();
    var im = 1;
    var um = 1;
    var cm = function(e, t) {
        return e === t;
    };
    function Un(param) {
        var e = param.config, t = param.event, r = param.eventTarget, n = param.elementRoot, i = param.elementApi;
        var _t_action_config, _t_action;
        if (!i) throw new Error("IX2 missing elementApi");
        var o = e.targets;
        if (Array.isArray(o) && o.length > 0) return o.reduce(function(P, b) {
            return P.concat(Un({
                config: {
                    target: b
                },
                event: t,
                eventTarget: r,
                elementRoot: n,
                elementApi: i
            }));
        }, []);
        var u = i.getValidDocument, a = i.getQuerySelector, s = i.queryDocument, l = i.getChildElements, d = i.getSiblingElements, p = i.matchSelector, f = i.elementContains, E = i.isSiblingNode, g = e.target;
        if (!g) return [];
        var ref = Nl(g), _ = ref.id, h = ref.objectId, I = ref.selector, y = ref.selectorGuids, A = ref.appliesTo, O = ref.useEventTarget;
        if (h) return [
            Vt.has(h) ? Vt.get(h) : Vt.set(h, {}).get(h)
        ];
        if (A === le.EventAppliesTo.PAGE) {
            var P = u(_);
            return P ? [
                P
            ] : [];
        }
        var _t_action_config_affectedElements;
        var T = ((_t_action_config_affectedElements = t === null || t === void 0 ? void 0 : (_t_action = t.action) === null || _t_action === void 0 ? void 0 : (_t_action_config = _t_action.config) === null || _t_action_config === void 0 ? void 0 : _t_action_config.affectedElements) !== null && _t_action_config_affectedElements !== void 0 ? _t_action_config_affectedElements : {})[_ || I] || {}, S = !!(T.id || T.selector), v, R, m, N = t && a(Nl(t.target));
        if (S ? (v = T.limitAffectedElements, R = N, m = a(T)) : R = m = a({
            id: _,
            selector: I,
            selectorGuids: y
        }), t && O) {
            var P1 = r && (m || O === !0) ? [
                r
            ] : s(N);
            if (m) {
                if (O === em) return s(m).filter(function(b) {
                    return P1.some(function(q) {
                        return f(b, q);
                    });
                });
                if (O === Rl) return s(m).filter(function(b) {
                    return P1.some(function(q) {
                        return f(q, b);
                    });
                });
                if (O === ml) return s(m).filter(function(b) {
                    return P1.some(function(q) {
                        return E(q, b);
                    });
                });
            }
            return P1;
        }
        return R == null || m == null ? [] : x.IS_BROWSER_ENV && n ? s(m).filter(function(P) {
            return n.contains(P);
        }) : v === Rl ? s(R, m) : v === JR ? l(s(R)).filter(p(m)) : v === ml ? d(s(R)).filter(p(m)) : s(m);
    }
    var Pl = /px/, dm = function(e, t) {
        return t.reduce(function(r, n) {
            return r[n.type] == null && (r[n.type] = Om[n.type]), r;
        }, e || {});
    }, pm = function(e, t) {
        return t.reduce(function(r, n) {
            return r[n.type] == null && (r[n.type] = vm[n.type] || n.defaultValue || 0), r;
        }, e || {});
    };
    var _m = function(e, t) {
        return t && (e[t.type] = t.value || 0), e;
    }, gm = function(e, t) {
        return t && (e[t.type] = t.value || 0), e;
    }, Im = function(e, t, r) {
        if ((0, k.isPluginType)(e)) return (0, k.getPluginConfig)(e)(r, t);
        switch(e){
            case tt:
                {
                    var n = (0, wn.default)(r.filters, function(param) {
                        var i = param.type;
                        return i === t;
                    });
                    return n ? n.value : 0;
                }
            case rt:
                {
                    var n1 = (0, wn.default)(r.fontVariations, function(param) {
                        var i = param.type;
                        return i === t;
                    });
                    return n1 ? n1.value : 0;
                }
            default:
                return r[t];
        }
    };
    var _obj2;
    var Bn = (_obj2 = {}, _defineProperty(_obj2, Ne, Object.freeze({
        xValue: 0,
        yValue: 0,
        zValue: 0
    })), _defineProperty(_obj2, Pe, Object.freeze({
        xValue: 1,
        yValue: 1,
        zValue: 1
    })), _defineProperty(_obj2, be, Object.freeze({
        xValue: 0,
        yValue: 0,
        zValue: 0
    })), _defineProperty(_obj2, et, Object.freeze({
        xValue: 0,
        yValue: 0
    })), _obj2), Om = Object.freeze({
        blur: 0,
        "hue-rotate": 0,
        invert: 0,
        grayscale: 0,
        saturate: 100,
        sepia: 0,
        contrast: 100,
        brightness: 100
    }), vm = Object.freeze({
        wght: 0,
        opsz: 0,
        wdth: 0,
        slnt: 0
    }), Am = function(e, t) {
        var r = (0, wn.default)(t.filters, function(param) {
            var n = param.type;
            return n === e;
        });
        if (r && r.unit) return r.unit;
        switch(e){
            case "blur":
                return "px";
            case "hue-rotate":
                return "deg";
            default:
                return "%";
        }
    }, Sm = Object.keys(Bn);
    var Pm = "\\(([^)]+)\\)", bm = /^rgb/, Lm = RegExp("rgba?".concat(Pm));
    var Ul = function(param) {
        var e = param.effect, t = param.actionTypeId, r = param.elementApi;
        return function(n) {
            switch(t){
                case Ne:
                case Pe:
                case be:
                case et:
                    e(n, x.TRANSFORM_PREFIXED, r);
                    break;
                case tt:
                    e(n, $e, r);
                    break;
                case rt:
                    e(n, Ze, r);
                    break;
                case wl:
                    e(n, Xt, r);
                    break;
                case Le:
                    e(n, Y, r), e(n, z, r);
                    break;
                case De:
                case Me:
                case Fe:
                    e(n, Xn[t], r);
                    break;
                case Wt:
                    e(n, Ut, r);
                    break;
            }
        };
    };
});
var de = c(function(Hn) {
    "use strict";
    var Km = function Km(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var qe = function qe(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = Hl(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    Object.defineProperty(Hn, "__esModule", {
        value: !0
    });
    Km(Hn, {
        IX2BrowserSupport: function IX2BrowserSupport() {
            return Ym;
        },
        IX2EasingUtils: function IX2EasingUtils() {
            return km;
        },
        IX2Easings: function IX2Easings() {
            return zm;
        },
        IX2ElementsReducer: function IX2ElementsReducer() {
            return Qm;
        },
        IX2VanillaPlugins: function IX2VanillaPlugins() {
            return $m;
        },
        IX2VanillaUtils: function IX2VanillaUtils() {
            return Zm;
        }
    });
    var Ym = qe(Dt()), zm = qe(_n()), km = qe(hn()), Qm = qe(Yc()), $m = qe(Ln()), Zm = qe(Wl());
    function Hl(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (Hl = function Hl(n) {
            return n ? r : t;
        })(e);
    }
});
var zl = c(function(Kn) {
    "use strict";
    Object.defineProperty(Kn, "__esModule", {
        value: !0
    });
    Object.defineProperty(Kn, "ixInstances", {
        enumerable: !0,
        get: function get() {
            return fN;
        }
    });
    var jl = G(), Kl = de(), we = he(), _IX2EngineActionTypes = jl.IX2EngineActionTypes, Jm = _IX2EngineActionTypes.IX2_RAW_DATA_IMPORTED, eN = _IX2EngineActionTypes.IX2_SESSION_STOPPED, tN = _IX2EngineActionTypes.IX2_INSTANCE_ADDED, rN = _IX2EngineActionTypes.IX2_INSTANCE_STARTED, nN = _IX2EngineActionTypes.IX2_INSTANCE_REMOVED, iN = _IX2EngineActionTypes.IX2_ANIMATION_FRAME_CHANGED, _IX2EasingUtils = Kl.IX2EasingUtils, Ht = _IX2EasingUtils.optimizeFloat, Yl = _IX2EasingUtils.applyEasing, oN = _IX2EasingUtils.createBezierEasing, _IX2EngineConstants = jl.IX2EngineConstants, uN = _IX2EngineConstants.RENDER_GENERAL, _IX2VanillaUtils = Kl.IX2VanillaUtils, jn = _IX2VanillaUtils.getItemConfigByKey, aN = _IX2VanillaUtils.getRenderType, sN = _IX2VanillaUtils.getStyleProp, cN = function(e, t) {
        var r = e.position, n = e.parameterId, i = e.actionGroups, o = e.destinationKeys, u = e.smoothing, a = e.restingValue, s = e.actionTypeId, l = e.customEasingFn, d = e.skipMotion, p = e.skipToValue, _payload = t.payload, f = _payload.parameters, E = Math.max(1 - u, 0.01), g = f[n];
        g == null && (E = 1, g = a);
        var _ = Math.max(g, 0) || 0, h = Ht(_ - r), I = d ? p : Ht(r + h * E), y = I * 100;
        if (I === r && e.current) return e;
        var A, O, C, T;
        for(var v = 0, R = i.length; v < R; v++){
            var _v = i[v], m = _v.keyframe, N = _v.actionItems;
            if (v === 0 && (A = N[0]), y >= m) {
                A = N[0];
                var P = i[v + 1], b = P && y !== m;
                O = b ? P.actionItems[0] : null, b && (C = m / 100, T = (P.keyframe - m) / 100);
            }
        }
        var S = {};
        if (A && !O) for(var v1 = 0, R1 = o.length; v1 < R1; v1++){
            var m1 = o[v1];
            S[m1] = jn(s, m1, A.config);
        }
        else if (A && O && C !== void 0 && T !== void 0) {
            var v2 = (I - C) / T, R2 = A.config.easing, m2 = Yl(R2, v2, l);
            for(var N1 = 0, P1 = o.length; N1 < P1; N1++){
                var b1 = o[N1], q = jn(s, b1, A.config), cr = (jn(s, b1, O.config) - q) * m2 + q;
                S[b1] = cr;
            }
        }
        return (0, we.merge)(e, {
            position: I,
            current: S
        });
    }, lN = function(e, t) {
        var r = e.active, n = e.origin, i = e.start, o = e.immediate, u = e.renderType, a = e.verbose, s = e.actionItem, l = e.destination, d = e.destinationKeys, p = e.pluginDuration, f = e.instanceDelay, E = e.customEasingFn, g = e.skipMotion, _ = s.config.easing, _config = s.config, h = _config.duration, I = _config.delay;
        p != null && (h = p), I = f !== null && f !== void 0 ? f : I, u === uN ? h = 0 : (o || g) && (h = I = 0);
        var _payload = t.payload, y = _payload.now;
        if (r && n) {
            var A = y - (i + I);
            if (a) {
                var v = y - i, R = h + I, m = Ht(Math.min(Math.max(0, v / R), 1));
                e = (0, we.set)(e, "verboseTimeElapsed", R * m);
            }
            if (A < 0) return e;
            var O = Ht(Math.min(Math.max(0, A / h), 1)), C = Yl(_, O, E), T = {}, S = null;
            return d.length && (S = d.reduce(function(v, R) {
                var m = l[R], N = parseFloat(n[R]) || 0, b = (parseFloat(m) - N) * C + N;
                return v[R] = b, v;
            }, {})), T.current = S, T.position = O, O === 1 && (T.active = !1, T.complete = !0), (0, we.merge)(e, T);
        }
        return e;
    }, fN = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Object.freeze({}), t = arguments.length > 1 ? arguments[1] : void 0;
        switch(t.type){
            case Jm:
                return t.payload.ixInstances || Object.freeze({});
            case eN:
                return Object.freeze({});
            case tN:
                {
                    var _payload = t.payload, r = _payload.instanceId, n = _payload.elementId, i = _payload.actionItem, o = _payload.eventId, u = _payload.eventTarget, a = _payload.eventStateKey, s = _payload.actionListId, l = _payload.groupIndex, d = _payload.isCarrier, p = _payload.origin, f = _payload.destination, E = _payload.immediate, g = _payload.verbose, _ = _payload.continuous, h = _payload.parameterId, I = _payload.actionGroups, y = _payload.smoothing, A = _payload.restingValue, O = _payload.pluginInstance, C = _payload.pluginDuration, T = _payload.instanceDelay, S = _payload.skipMotion, v = _payload.skipToValue, R = i.actionTypeId, m = aN(R), N = sN(m, R), P = Object.keys(f).filter(function(q) {
                        return f[q] != null && typeof f[q] != "string";
                    }), _config = i.config, b = _config.easing;
                    return (0, we.set)(e, r, {
                        id: r,
                        elementId: n,
                        active: !1,
                        position: 0,
                        start: 0,
                        origin: p,
                        destination: f,
                        destinationKeys: P,
                        immediate: E,
                        verbose: g,
                        current: null,
                        actionItem: i,
                        actionTypeId: R,
                        eventId: o,
                        eventTarget: u,
                        eventStateKey: a,
                        actionListId: s,
                        groupIndex: l,
                        renderType: m,
                        isCarrier: d,
                        styleProp: N,
                        continuous: _,
                        parameterId: h,
                        actionGroups: I,
                        smoothing: y,
                        restingValue: A,
                        pluginInstance: O,
                        pluginDuration: C,
                        instanceDelay: T,
                        skipMotion: S,
                        skipToValue: v,
                        customEasingFn: Array.isArray(b) && b.length === 4 ? oN(b) : void 0
                    });
                }
            case rN:
                {
                    var _payload1 = t.payload, r1 = _payload1.instanceId, n1 = _payload1.time;
                    return (0, we.mergeIn)(e, [
                        r1
                    ], {
                        active: !0,
                        complete: !1,
                        start: n1
                    });
                }
            case nN:
                {
                    var _payload2 = t.payload, r2 = _payload2.instanceId;
                    if (!e[r2]) return e;
                    var n2 = {}, i1 = Object.keys(e), o1 = i1.length;
                    for(var u1 = 0; u1 < o1; u1++){
                        var a1 = i1[u1];
                        a1 !== r2 && (n2[a1] = e[a1]);
                    }
                    return n2;
                }
            case iN:
                {
                    var r3 = e, n3 = Object.keys(e), i2 = n3.length;
                    for(var o2 = 0; o2 < i2; o2++){
                        var u2 = n3[o2], a2 = e[u2], s1 = a2.continuous ? cN : lN;
                        r3 = (0, we.set)(r3, u2, s1(a2, t));
                    }
                    return r3;
                }
            default:
                return e;
        }
    };
});
var kl = c(function(Yn) {
    "use strict";
    Object.defineProperty(Yn, "__esModule", {
        value: !0
    });
    Object.defineProperty(Yn, "ixParameters", {
        enumerable: !0,
        get: function get() {
            return gN;
        }
    });
    var dN = G(), _IX2EngineActionTypes = dN.IX2EngineActionTypes, pN = _IX2EngineActionTypes.IX2_RAW_DATA_IMPORTED, EN = _IX2EngineActionTypes.IX2_SESSION_STOPPED, _N = _IX2EngineActionTypes.IX2_PARAMETER_CHANGED, gN = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 ? arguments[1] : void 0;
        switch(t.type){
            case pN:
                return t.payload.ixParameters || {};
            case EN:
                return {};
            case _N:
                {
                    var _payload = t.payload, r = _payload.key, n = _payload.value;
                    return e[r] = n, e;
                }
            default:
                return e;
        }
    };
});
var Ql = c(function(zn) {
    "use strict";
    Object.defineProperty(zn, "__esModule", {
        value: !0
    });
    Object.defineProperty(zn, "default", {
        enumerable: !0,
        get: function get() {
            return CN;
        }
    });
    var IN = Cr(), hN = co(), TN = Po(), yN = Lo(), ON = de(), vN = zl(), AN = kl(), _IX2ElementsReducer = ON.IX2ElementsReducer, SN = _IX2ElementsReducer.ixElements, CN = (0, IN.combineReducers)({
        ixData: hN.ixData,
        ixRequest: TN.ixRequest,
        ixSession: yN.ixSession,
        ixElements: SN,
        ixInstances: vN.ixInstances,
        ixParameters: AN.ixParameters
    });
});
var Zl = c(function(_2, $l) {
    var bN = function bN(e) {
        return typeof e == "string" || !mN(e) && NN(e) && RN(e) == PN;
    };
    var RN = ee(), mN = w(), NN = $(), PN = "[object String]";
    $l.exports = bN;
});
var ef = c(function(g2, Jl) {
    var LN = an(), DN = LN("length");
    Jl.exports = DN;
});
var rf = c(function(I2, tf) {
    var UN = function UN(e) {
        return XN.test(e);
    };
    var MN = "\ud800-\udfff", FN = "\\u0300-\\u036f", qN = "\\ufe20-\\ufe2f", wN = "\\u20d0-\\u20ff", xN = FN + qN + wN, GN = "\\ufe0e\\ufe0f", VN = "\\u200d", XN = RegExp("[" + VN + MN + xN + GN + "]");
    tf.exports = UN;
});
var df = c(function(h2, ff) {
    var JN = function JN(e) {
        for(var t = nf.lastIndex = 0; nf.test(e);)++t;
        return t;
    };
    var of = "\ud800-\udfff", BN = "\\u0300-\\u036f", WN = "\\ufe20-\\ufe2f", HN = "\\u20d0-\\u20ff", jN = BN + WN + HN, KN = "\\ufe0e\\ufe0f", YN = "[" + of + "]", kn = "[" + jN + "]", Qn = "\ud83c[\udffb-\udfff]", zN = "(?:" + kn + "|" + Qn + ")", uf = "[^" + of + "]", af = "(?:\ud83c[\udde6-\uddff]){2}", sf = "[\ud800-\udbff][\udc00-\udfff]", kN = "\\u200d", cf = zN + "?", lf = "[" + KN + "]?", QN = "(?:" + kN + "(?:" + [
        uf,
        af,
        sf
    ].join("|") + ")" + lf + cf + ")*", $N = lf + cf + QN, ZN = "(?:" + [
        uf + kn + "?",
        kn,
        af,
        sf,
        YN
    ].join("|") + ")", nf = RegExp(Qn + "(?=" + Qn + ")|" + ZN + $N, "g");
    ff.exports = JN;
});
var Ef = c(function(T2, pf) {
    var nP = function nP(e) {
        return tP(e) ? rP(e) : eP(e);
    };
    var eP = ef(), tP = rf(), rP = df();
    pf.exports = nP;
});
var gf = c(function(y2, _f) {
    var fP = function fP(e) {
        if (e == null) return 0;
        if (uP(e)) return aP(e) ? sP(e) : e.length;
        var t = oP(e);
        return t == cP || t == lP ? e.size : iP(e).length;
    };
    var iP = At(), oP = St(), uP = ae(), aP = Zl(), sP = Ef(), cP = "[object Map]", lP = "[object Set]";
    _f.exports = fP;
});
var hf = c(function(O2, If) {
    var pP = function pP(e) {
        if (typeof e != "function") throw new TypeError(dP);
        return function() {
            var t = arguments;
            switch(t.length){
                case 0:
                    return !e.call(this);
                case 1:
                    return !e.call(this, t[0]);
                case 2:
                    return !e.call(this, t[0], t[1]);
                case 3:
                    return !e.call(this, t[0], t[1], t[2]);
            }
            return !e.apply(this, t);
        };
    };
    var dP = "Expected a function";
    If.exports = pP;
});
var $n = c(function(v2, Tf) {
    var EP = te(), _P = function() {
        try {
            var e = EP(Object, "defineProperty");
            return e({}, "", {}), e;
        } catch (e1) {}
    }();
    Tf.exports = _P;
});
var Zn = c(function(A2, Of) {
    var gP = function gP(e, t, r) {
        t == "__proto__" && yf ? yf(e, t, {
            configurable: !0,
            enumerable: !0,
            value: r,
            writable: !0
        }) : e[t] = r;
    };
    var yf = $n();
    Of.exports = gP;
});
var Af = c(function(S2, vf) {
    var OP = function OP(e, t, r) {
        var n = e[t];
        (!(yP.call(e, t) && hP(n, r)) || r === void 0 && !(t in e)) && IP(e, t, r);
    };
    var IP = Zn(), hP = pt(), TP = Object.prototype, yP = TP.hasOwnProperty;
    vf.exports = OP;
});
var Rf = c(function(C2, Cf) {
    var RP = function RP(e, t, r, n) {
        if (!Sf(e)) return e;
        t = AP(t, e);
        for(var i = -1, o = t.length, u = o - 1, a = e; a != null && ++i < o;){
            var s = CP(t[i]), l = r;
            if (s === "__proto__" || s === "constructor" || s === "prototype") return e;
            if (i != u) {
                var d = a[s];
                l = n ? n(d, s, a) : void 0, l === void 0 && (l = Sf(d) ? d : SP(t[i + 1]) ? [] : {});
            }
            vP(a, s, l), a = a[s];
        }
        return e;
    };
    var vP = Af(), AP = ke(), SP = Tt(), Sf = K(), CP = Re();
    Cf.exports = RP;
});
var Nf = c(function(R2, mf) {
    var bP = function bP(e, t, r) {
        for(var n = -1, i = t.length, o = {}; ++n < i;){
            var u = t[n], a = mP(e, u);
            r(a, u) && NP(o, PP(u, e), a);
        }
        return o;
    };
    var mP = mt(), NP = Rf(), PP = ke();
    mf.exports = bP;
});
var bf = c(function(m2, Pf) {
    var LP = It(), DP = dr(), MP = jr(), FP = Hr(), qP = Object.getOwnPropertySymbols, wP = qP ? function wP(e) {
        for(var t = []; e;)LP(t, MP(e)), e = DP(e);
        return t;
    } : FP;
    Pf.exports = wP;
});
var Df = c(function(N2, Lf) {
    var xP = function xP(e) {
        var t = [];
        if (e != null) for(var r in Object(e))t.push(r);
        return t;
    };
    Lf.exports = xP;
});
var Ff = c(function(P2, Mf) {
    var WP = function WP(e) {
        if (!GP(e)) return XP(e);
        var t = VP(e), r = [];
        for(var n in e)n == "constructor" && (t || !BP.call(e, n)) || r.push(n);
        return r;
    };
    var GP = K(), VP = vt(), XP = Df(), UP = Object.prototype, BP = UP.hasOwnProperty;
    Mf.exports = WP;
});
var wf = c(function(b2, qf) {
    var YP = function YP(e) {
        return KP(e) ? HP(e, !0) : jP(e);
    };
    var HP = Yr(), jP = Ff(), KP = ae();
    qf.exports = YP;
});
var Gf = c(function(L2, xf) {
    var $P = function $P(e) {
        return zP(e, QP, kP);
    };
    var zP = Wr(), kP = bf(), QP = wf();
    xf.exports = $P;
});
var Xf = c(function(D2, Vf) {
    var rb = function rb(e, t) {
        if (e == null) return {};
        var r = ZP(tb(e), function(n) {
            return [
                n
            ];
        });
        return t = JP(t), eb(e, r, function(n, i) {
            return t(n, i[0]);
        });
    };
    var ZP = un(), JP = re(), eb = Nf(), tb = Gf();
    Vf.exports = rb;
});
var Bf = c(function(M2, Uf) {
    var ub = function ub(e, t) {
        return ob(e, ib(nb(t)));
    };
    var nb = re(), ib = hf(), ob = Xf();
    Uf.exports = ub;
});
var Hf = c(function(F2, Wf) {
    var Tb = function Tb(e) {
        if (e == null) return !0;
        if (fb(e) && (lb(e) || typeof e == "string" || typeof e.splice == "function" || db(e) || Eb(e) || cb(e))) return !e.length;
        var t = sb(e);
        if (t == _b || t == gb) return !e.size;
        if (pb(e)) return !ab(e).length;
        for(var r in e)if (hb.call(e, r)) return !1;
        return !0;
    };
    var ab = At(), sb = St(), cb = We(), lb = w(), fb = ae(), db = ht(), pb = vt(), Eb = Ot(), _b = "[object Map]", gb = "[object Set]", Ib = Object.prototype, hb = Ib.hasOwnProperty;
    Wf.exports = Tb;
});
var Kf = c(function(q2, jf) {
    var Ab = function Ab(e, t) {
        var r = {};
        return t = vb(t, 3), Ob(e, function(n, i, o) {
            yb(r, i, t(n, i, o));
        }), r;
    };
    var yb = Zn(), Ob = Dn(), vb = re();
    jf.exports = Ab;
});
var zf = c(function(w2, Yf) {
    var Sb = function Sb(e, t) {
        for(var r = -1, n = e == null ? 0 : e.length; ++r < n && t(e[r], r, e) !== !1;);
        return e;
    };
    Yf.exports = Sb;
});
var Qf = c(function(x2, kf) {
    var Rb = function Rb(e) {
        return typeof e == "function" ? e : Cb;
    };
    var Cb = Pt();
    kf.exports = Rb;
});
var Zf = c(function(G2, $f) {
    var Lb = function Lb(e, t) {
        var r = bb(e) ? mb : Nb;
        return r(e, Pb(t));
    };
    var mb = zf(), Nb = Mn(), Pb = Qf(), bb = w();
    $f.exports = Lb;
});
var ed = c(function(V2, Jf) {
    var Db = W(), Mb = function Mb() {
        return Db.Date.now();
    };
    Jf.exports = Mb;
});
var nd = c(function(X2, rd) {
    var Gb = function Gb(e, t, r) {
        var n, i, o, u, a, s, l = 0, d = !1, p = !1, f = !0;
        if (typeof e != "function") throw new TypeError(qb);
        t = td(t) || 0, Fb(r) && (d = !!r.leading, p = "maxWait" in r, o = p ? wb(td(r.maxWait) || 0, t) : o, f = "trailing" in r ? !!r.trailing : f);
        function E(T) {
            var S = n, v = i;
            return n = i = void 0, l = T, u = e.apply(v, S), u;
        }
        function g(T) {
            return l = T, a = setTimeout(I, t), d ? E(T) : u;
        }
        function _(T) {
            var S = T - s, v = T - l, R = t - S;
            return p ? xb(R, o - v) : R;
        }
        function h(T) {
            var S = T - s, v = T - l;
            return s === void 0 || S >= t || S < 0 || p && v >= o;
        }
        function I() {
            var T = Jn();
            if (h(T)) return y(T);
            a = setTimeout(I, _(T));
        }
        function y(T) {
            return a = void 0, f && n ? E(T) : (n = i = void 0, u);
        }
        function A() {
            a !== void 0 && clearTimeout(a), l = 0, n = s = i = a = void 0;
        }
        function O() {
            return a === void 0 ? u : y(Jn());
        }
        function C() {
            var T = Jn(), S = h(T);
            if (n = arguments, i = this, s = T, S) {
                if (a === void 0) return g(s);
                if (p) return clearTimeout(a), a = setTimeout(I, t), E(s);
            }
            return a === void 0 && (a = setTimeout(I, t)), u;
        }
        return C.cancel = A, C.flush = O, C;
    };
    var Fb = K(), Jn = ed(), td = bt(), qb = "Expected a function", wb = Math.max, xb = Math.min;
    rd.exports = Gb;
});
var od = c(function(U2, id) {
    var Bb = function Bb(e, t, r) {
        var n = !0, i = !0;
        if (typeof e != "function") throw new TypeError(Ub);
        return Xb(r) && (n = "leading" in r ? !!r.leading : n, i = "trailing" in r ? !!r.trailing : i), Vb(e, t, {
            leading: n,
            maxWait: t,
            trailing: i
        });
    };
    var Vb = nd(), Xb = K(), Ub = "Expected a function";
    id.exports = Bb;
});
var jt = c(function(ei) {
    "use strict";
    var Wb = function Wb(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    Object.defineProperty(ei, "__esModule", {
        value: !0
    });
    Wb(ei, {
        actionListPlaybackChanged: function actionListPlaybackChanged() {
            return PL;
        },
        animationFrameChanged: function animationFrameChanged() {
            return AL;
        },
        clearRequested: function clearRequested() {
            return TL;
        },
        elementStateChanged: function elementStateChanged() {
            return NL;
        },
        eventListenerAdded: function eventListenerAdded() {
            return yL;
        },
        eventStateChanged: function eventStateChanged() {
            return vL;
        },
        instanceAdded: function instanceAdded() {
            return CL;
        },
        instanceRemoved: function instanceRemoved() {
            return mL;
        },
        instanceStarted: function instanceStarted() {
            return RL;
        },
        mediaQueriesDefined: function mediaQueriesDefined() {
            return LL;
        },
        parameterChanged: function parameterChanged() {
            return SL;
        },
        playbackRequested: function playbackRequested() {
            return IL;
        },
        previewRequested: function previewRequested() {
            return gL;
        },
        rawDataImported: function rawDataImported() {
            return dL;
        },
        sessionInitialized: function sessionInitialized() {
            return pL;
        },
        sessionStarted: function sessionStarted() {
            return EL;
        },
        sessionStopped: function sessionStopped() {
            return _L;
        },
        stopRequested: function stopRequested() {
            return hL;
        },
        testFrameRendered: function testFrameRendered() {
            return OL;
        },
        viewportWidthChanged: function viewportWidthChanged() {
            return bL;
        }
    });
    var ud = G(), Hb = de(), _IX2EngineActionTypes = ud.IX2EngineActionTypes, jb = _IX2EngineActionTypes.IX2_RAW_DATA_IMPORTED, Kb = _IX2EngineActionTypes.IX2_SESSION_INITIALIZED, Yb = _IX2EngineActionTypes.IX2_SESSION_STARTED, zb = _IX2EngineActionTypes.IX2_SESSION_STOPPED, kb = _IX2EngineActionTypes.IX2_PREVIEW_REQUESTED, Qb = _IX2EngineActionTypes.IX2_PLAYBACK_REQUESTED, $b = _IX2EngineActionTypes.IX2_STOP_REQUESTED, Zb = _IX2EngineActionTypes.IX2_CLEAR_REQUESTED, Jb = _IX2EngineActionTypes.IX2_EVENT_LISTENER_ADDED, eL = _IX2EngineActionTypes.IX2_TEST_FRAME_RENDERED, tL = _IX2EngineActionTypes.IX2_EVENT_STATE_CHANGED, rL = _IX2EngineActionTypes.IX2_ANIMATION_FRAME_CHANGED, nL = _IX2EngineActionTypes.IX2_PARAMETER_CHANGED, iL = _IX2EngineActionTypes.IX2_INSTANCE_ADDED, oL = _IX2EngineActionTypes.IX2_INSTANCE_STARTED, uL = _IX2EngineActionTypes.IX2_INSTANCE_REMOVED, aL = _IX2EngineActionTypes.IX2_ELEMENT_STATE_CHANGED, sL = _IX2EngineActionTypes.IX2_ACTION_LIST_PLAYBACK_CHANGED, cL = _IX2EngineActionTypes.IX2_VIEWPORT_WIDTH_CHANGED, lL = _IX2EngineActionTypes.IX2_MEDIA_QUERIES_DEFINED, _IX2VanillaUtils = Hb.IX2VanillaUtils, fL = _IX2VanillaUtils.reifyState, dL = function(e) {
        return {
            type: jb,
            payload: _object_spread({}, fL(e))
        };
    }, pL = function(param) {
        var e = param.hasBoundaryNodes, t = param.reducedMotion;
        return {
            type: Kb,
            payload: {
                hasBoundaryNodes: e,
                reducedMotion: t
            }
        };
    }, EL = function() {
        return {
            type: Yb
        };
    }, _L = function() {
        return {
            type: zb
        };
    }, gL = function(param) {
        var e = param.rawData, t = param.defer;
        return {
            type: kb,
            payload: {
                defer: t,
                rawData: e
            }
        };
    }, IL = function(param) {
        var tmp = param.actionTypeId, e = tmp === void 0 ? ud.ActionTypeConsts.GENERAL_START_ACTION : tmp, t = param.actionListId, r = param.actionItemId, n = param.eventId, i = param.allowEvents, o = param.immediate, u = param.testManual, a = param.verbose, s = param.rawData;
        return {
            type: Qb,
            payload: {
                actionTypeId: e,
                actionListId: t,
                actionItemId: r,
                testManual: u,
                eventId: n,
                allowEvents: i,
                immediate: o,
                verbose: a,
                rawData: s
            }
        };
    }, hL = function(e) {
        return {
            type: $b,
            payload: {
                actionListId: e
            }
        };
    }, TL = function() {
        return {
            type: Zb
        };
    }, yL = function(e, t) {
        return {
            type: Jb,
            payload: {
                target: e,
                listenerParams: t
            }
        };
    }, OL = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        return {
            type: eL,
            payload: {
                step: e
            }
        };
    }, vL = function(e, t) {
        return {
            type: tL,
            payload: {
                stateKey: e,
                newState: t
            }
        };
    }, AL = function(e, t) {
        return {
            type: rL,
            payload: {
                now: e,
                parameters: t
            }
        };
    }, SL = function(e, t) {
        return {
            type: nL,
            payload: {
                key: e,
                value: t
            }
        };
    }, CL = function(e) {
        return {
            type: iL,
            payload: _object_spread({}, e)
        };
    }, RL = function(e, t) {
        return {
            type: oL,
            payload: {
                instanceId: e,
                time: t
            }
        };
    }, mL = function(e) {
        return {
            type: uL,
            payload: {
                instanceId: e
            }
        };
    }, NL = function(e, t, r, n) {
        return {
            type: aL,
            payload: {
                elementId: e,
                actionTypeId: t,
                current: r,
                actionItem: n
            }
        };
    }, PL = function(param) {
        var e = param.actionListId, t = param.isPlaying;
        return {
            type: sL,
            payload: {
                actionListId: e,
                isPlaying: t
            }
        };
    }, bL = function(param) {
        var e = param.width, t = param.mediaQueries;
        return {
            type: cL,
            payload: {
                width: e,
                mediaQueries: t
            }
        };
    }, LL = function() {
        return {
            type: lL
        };
    };
});
var cd = c(function(ri) {
    "use strict";
    var DL = function DL(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var xL = function xL(e, t, r) {
        e.style[t] = r;
    };
    var GL = function GL(e, t) {
        if (t.startsWith("--")) return window.getComputedStyle(document.documentElement).getPropertyValue(t);
        if (_instanceof(e.style, CSSStyleDeclaration)) return e.style[t];
    };
    var VL = function VL(e, t) {
        return e[t];
    };
    var XL = function XL(e) {
        return function(t) {
            return t[ti](e);
        };
    };
    var UL = function UL(param) {
        var e = param.id, t = param.selector;
        if (e) {
            var r = e;
            if (e.indexOf(ad) !== -1) {
                var n = e.split(ad), i = n[0];
                if (r = n[1], i !== document.documentElement.getAttribute(sd)) return null;
            }
            return '[data-w-id="'.concat(r, '"], [data-w-id^="').concat(r, '_instance"]');
        }
        return t;
    };
    var BL = function BL(e) {
        return e == null || e === document.documentElement.getAttribute(sd) ? document : null;
    };
    var WL = function WL(e, t) {
        return Array.prototype.slice.call(document.querySelectorAll(t ? e + " " + t : e));
    };
    var HL = function HL(e, t) {
        return e.contains(t);
    };
    var jL = function jL(e, t) {
        return e !== t && e.parentNode === t.parentNode;
    };
    var KL = function KL(e) {
        var t = [];
        for(var r = 0, ref = e || [], n = ref.length; r < n; r++){
            var _r = e[r], i = _r.children, o = i.length;
            if (o) for(var u = 0; u < o; u++)t.push(i[u]);
        }
        return t;
    };
    var YL = function YL() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
        var t = [], r = [];
        for(var n = 0, i = e.length; n < i; n++){
            var _n = e[n], o = _n.parentNode;
            if (!o || !o.children || !o.children.length || r.indexOf(o) !== -1) continue;
            r.push(o);
            var u = o.firstElementChild;
            for(; u != null;)e.indexOf(u) === -1 && t.push(u), u = u.nextElementSibling;
        }
        return t;
    };
    var kL = function kL(e) {
        return e != null && typeof e == "object" ? _instanceof(e, Element) ? qL : wL : null;
    };
    Object.defineProperty(ri, "__esModule", {
        value: !0
    });
    DL(ri, {
        elementContains: function elementContains() {
            return HL;
        },
        getChildElements: function getChildElements() {
            return KL;
        },
        getClosestElement: function getClosestElement() {
            return zL;
        },
        getProperty: function getProperty() {
            return VL;
        },
        getQuerySelector: function getQuerySelector() {
            return UL;
        },
        getRefType: function getRefType() {
            return kL;
        },
        getSiblingElements: function getSiblingElements() {
            return YL;
        },
        getStyle: function getStyle() {
            return GL;
        },
        getValidDocument: function getValidDocument() {
            return BL;
        },
        isSiblingNode: function isSiblingNode() {
            return jL;
        },
        matchSelector: function matchSelector() {
            return XL;
        },
        queryDocument: function queryDocument() {
            return WL;
        },
        setStyle: function setStyle() {
            return xL;
        }
    });
    var ML = de(), FL = G(), _IX2BrowserSupport = ML.IX2BrowserSupport, ti = _IX2BrowserSupport.ELEMENT_MATCHES, _IX2EngineConstants = FL.IX2EngineConstants, ad = _IX2EngineConstants.IX2_ID_DELIMITER, qL = _IX2EngineConstants.HTML_ELEMENT, wL = _IX2EngineConstants.PLAIN_OBJECT, sd = _IX2EngineConstants.WF_PAGE;
    var zL = Element.prototype.closest ? function(e, t) {
        return document.documentElement.contains(e) ? e.closest(t) : null;
    } : function(e, t) {
        if (!document.documentElement.contains(e)) return null;
        var r = e;
        do {
            if (r[ti] && r[ti](t)) return r;
            r = r.parentNode;
        }while (r != null);
        return null;
    };
});
var ni = c(function(H2, fd) {
    var QL = K(), ld = Object.create, $L = function() {
        var e = function e() {};
        return function(t) {
            if (!QL(t)) return {};
            if (ld) return ld(t);
            e.prototype = t;
            var r = new e();
            return e.prototype = void 0, r;
        };
    }();
    fd.exports = $L;
});
var Kt = c(function(j2, dd) {
    var ZL = function ZL() {};
    dd.exports = ZL;
});
var zt = c(function(K2, pd) {
    var Yt = function Yt(e, t) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!t, this.__index__ = 0, this.__values__ = void 0;
    };
    var JL = ni(), eD = Kt();
    Yt.prototype = JL(eD.prototype);
    Yt.prototype.constructor = Yt;
    pd.exports = Yt;
});
var Id = c(function(Y2, gd) {
    var nD = function nD(e) {
        return rD(e) || tD(e) || !!(_d && e && e[_d]);
    };
    var Ed = _e(), tD = We(), rD = w(), _d = Ed ? Ed.isConcatSpreadable : void 0;
    gd.exports = nD;
});
var yd = c(function(z2, Td) {
    var iD = It(), oD = Id();
    function hd(e, t, r, n, i) {
        var o = -1, u = e.length;
        for(r || (r = oD), i || (i = []); ++o < u;){
            var a = e[o];
            t > 0 && r(a) ? t > 1 ? hd(a, t - 1, r, n, i) : iD(i, a) : n || (i[i.length] = a);
        }
        return i;
    }
    Td.exports = hd;
});
var vd = c(function(k2, Od) {
    var aD = function aD(e) {
        var t = e == null ? 0 : e.length;
        return t ? uD(e, 1) : [];
    };
    var uD = yd();
    Od.exports = aD;
});
var Sd = c(function(Q2, Ad) {
    var sD = function sD(e, t, r) {
        switch(r.length){
            case 0:
                return e.call(t);
            case 1:
                return e.call(t, r[0]);
            case 2:
                return e.call(t, r[0], r[1]);
            case 3:
                return e.call(t, r[0], r[1], r[2]);
        }
        return e.apply(t, r);
    };
    Ad.exports = sD;
});
var md = c(function($2, Rd) {
    var lD = function lD(e, t, r) {
        return t = Cd(t === void 0 ? e.length - 1 : t, 0), function() {
            for(var n = arguments, i = -1, o = Cd(n.length - t, 0), u = Array(o); ++i < o;)u[i] = n[t + i];
            i = -1;
            for(var a = Array(t + 1); ++i < t;)a[i] = n[i];
            return a[t] = r(u), cD(e, this, a);
        };
    };
    var cD = Sd(), Cd = Math.max;
    Rd.exports = lD;
});
var Pd = c(function(Z2, Nd) {
    var fD = function fD(e) {
        return function() {
            return e;
        };
    };
    Nd.exports = fD;
});
var Dd = c(function(J2, Ld) {
    var dD = Pd(), bd = $n(), pD = Pt(), ED = bd ? function ED(e, t) {
        return bd(e, "toString", {
            configurable: !0,
            enumerable: !1,
            value: dD(t),
            writable: !0
        });
    } : pD;
    Ld.exports = ED;
});
var Fd = c(function(e1, Md) {
    var hD = function hD(e) {
        var t = 0, r = 0;
        return function() {
            var n = ID(), i = gD - (n - r);
            if (r = n, i > 0) {
                if (++t >= _D) return arguments[0];
            } else t = 0;
            return e.apply(void 0, arguments);
        };
    };
    var _D = 800, gD = 16, ID = Date.now;
    Md.exports = hD;
});
var wd = c(function(t1, qd) {
    var TD = Dd(), yD = Fd(), OD = yD(TD);
    qd.exports = OD;
});
var Gd = c(function(r1, xd) {
    var CD = function CD(e) {
        return SD(AD(e, void 0, vD), e + "");
    };
    var vD = vd(), AD = md(), SD = wd();
    xd.exports = CD;
});
var Ud = c(function(n1, Xd) {
    var Vd = zr(), RD = Vd && new Vd();
    Xd.exports = RD;
});
var Wd = c(function(i1, Bd) {
    var mD = function mD() {};
    Bd.exports = mD;
});
var ii = c(function(o1, jd) {
    var Hd = Ud(), ND = Wd(), PD = Hd ? function PD(e) {
        return Hd.get(e);
    } : ND;
    jd.exports = PD;
});
var Yd = c(function(u1, Kd) {
    var bD = {};
    Kd.exports = bD;
});
var oi = c(function(a1, kd) {
    var MD = function MD(e) {
        for(var t = e.name + "", r = zd[t], n = DD.call(zd, t) ? r.length : 0; n--;){
            var i = r[n], o = i.func;
            if (o == null || o == e) return i.name;
        }
        return t;
    };
    var zd = Yd(), LD = Object.prototype, DD = LD.hasOwnProperty;
    kd.exports = MD;
});
var Qt = c(function(s1, Qd) {
    var kt = function kt(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = wD, this.__views__ = [];
    };
    var FD = ni(), qD = Kt(), wD = 4294967295;
    kt.prototype = FD(qD.prototype);
    kt.prototype.constructor = kt;
    Qd.exports = kt;
});
var Zd = c(function(c1, $d) {
    var xD = function xD(e, t) {
        var r = -1, n = e.length;
        for(t || (t = Array(n)); ++r < n;)t[r] = e[r];
        return t;
    };
    $d.exports = xD;
});
var ep = c(function(l1, Jd) {
    var UD = function UD(e) {
        if (_instanceof(e, GD)) return e.clone();
        var t = new VD(e.__wrapped__, e.__chain__);
        return t.__actions__ = XD(e.__actions__), t.__index__ = e.__index__, t.__values__ = e.__values__, t;
    };
    var GD = Qt(), VD = zt(), XD = Zd();
    Jd.exports = UD;
});
var np = c(function(f1, rp) {
    var $t = function $t(e) {
        if (jD(e) && !HD(e) && !_instanceof(e, BD)) {
            if (_instanceof(e, tp)) return e;
            if (zD.call(e, "__wrapped__")) return KD(e);
        }
        return new tp(e);
    };
    var BD = Qt(), tp = zt(), WD = Kt(), HD = w(), jD = $(), KD = ep(), YD = Object.prototype, zD = YD.hasOwnProperty;
    $t.prototype = WD.prototype;
    $t.prototype.constructor = $t;
    rp.exports = $t;
});
var op = c(function(d1, ip) {
    var JD = function JD(e) {
        var t = $D(e), r = ZD[t];
        if (typeof r != "function" || !(t in kD.prototype)) return !1;
        if (e === r) return !0;
        var n = QD(r);
        return !!n && e === n[0];
    };
    var kD = Qt(), QD = ii(), $D = oi(), ZD = np();
    ip.exports = JD;
});
var cp = c(function(p1, sp) {
    var sM = function sM(e) {
        return eM(function(t) {
            var r = t.length, n = r, i = up.prototype.thru;
            for(e && t.reverse(); n--;){
                var o = t[n];
                if (typeof o != "function") throw new TypeError(nM);
                if (i && !u && ui(o) == "wrapper") var u = new up([], !0);
            }
            for(n = u ? n : r; ++n < r;){
                o = t[n];
                var a = ui(o), s = a == "wrapper" ? tM(o) : void 0;
                s && ap(s[0]) && s[1] == (uM | iM | oM | aM) && !s[4].length && s[9] == 1 ? u = u[ui(s[0])].apply(u, s[3]) : u = o.length == 1 && ap(o) ? u[a]() : u.thru(o);
            }
            return function() {
                var l = arguments, d = l[0];
                if (u && l.length == 1 && rM(d)) return u.plant(d).value();
                for(var p = 0, f = r ? t[p].apply(this, l) : d; ++p < r;)f = t[p].call(this, f);
                return f;
            };
        });
    };
    var up = zt(), eM = Gd(), tM = ii(), ui = oi(), rM = w(), ap = op(), nM = "Expected a function", iM = 8, oM = 32, uM = 128, aM = 256;
    sp.exports = sM;
});
var fp = c(function(E1, lp) {
    var cM = cp(), lM = cM();
    lp.exports = lM;
});
var pp = c(function(_1, dp) {
    var fM = function fM(e, t, r) {
        return e === e && (r !== void 0 && (e = e <= r ? e : r), t !== void 0 && (e = e >= t ? e : t)), e;
    };
    dp.exports = fM;
});
var _p = c(function(g1, Ep) {
    var pM = function pM(e, t, r) {
        return r === void 0 && (r = t, t = void 0), r !== void 0 && (r = ai(r), r = r === r ? r : 0), t !== void 0 && (t = ai(t), t = t === t ? t : 0), dM(ai(e), t, r);
    };
    var dM = pp(), ai = bt();
    Ep.exports = pM;
});
var Mp = c(function(pi) {
    "use strict";
    var di = function di(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    Object.defineProperty(pi, "__esModule", {
        value: !0
    });
    Object.defineProperty(pi, "default", {
        enumerable: !0,
        get: function get() {
            return kM;
        }
    });
    var EM = di(fp()), _M = di(Nt()), gM = di(_p()), pe = G(), si = Ei(), Zt = jt(), IM = de();
    var _obj;
    var _EventTypeConsts = pe.EventTypeConsts, hM = _EventTypeConsts.MOUSE_CLICK, TM = _EventTypeConsts.MOUSE_SECOND_CLICK, yM = _EventTypeConsts.MOUSE_DOWN, OM = _EventTypeConsts.MOUSE_UP, vM = _EventTypeConsts.MOUSE_OVER, AM = _EventTypeConsts.MOUSE_OUT, SM = _EventTypeConsts.DROPDOWN_CLOSE, CM = _EventTypeConsts.DROPDOWN_OPEN, RM = _EventTypeConsts.SLIDER_ACTIVE, mM = _EventTypeConsts.SLIDER_INACTIVE, NM = _EventTypeConsts.TAB_ACTIVE, PM = _EventTypeConsts.TAB_INACTIVE, bM = _EventTypeConsts.NAVBAR_CLOSE, LM = _EventTypeConsts.NAVBAR_OPEN, DM = _EventTypeConsts.MOUSE_MOVE, Sp = _EventTypeConsts.PAGE_SCROLL_DOWN, Cp = _EventTypeConsts.SCROLL_INTO_VIEW, MM = _EventTypeConsts.SCROLL_OUT_OF_VIEW, FM = _EventTypeConsts.PAGE_SCROLL_UP, qM = _EventTypeConsts.SCROLLING_IN_VIEW, Rp = _EventTypeConsts.PAGE_FINISH, wM = _EventTypeConsts.ECOMMERCE_CART_CLOSE, xM = _EventTypeConsts.ECOMMERCE_CART_OPEN, mp = _EventTypeConsts.PAGE_START, GM = _EventTypeConsts.PAGE_SCROLL, ci = "COMPONENT_ACTIVE", Np = "COMPONENT_INACTIVE", _IX2EngineConstants = pe.IX2EngineConstants, gp = _IX2EngineConstants.COLON_DELIMITER, _IX2VanillaUtils = IM.IX2VanillaUtils, Ip = _IX2VanillaUtils.getNamespacedParameterId, Pp = function(e) {
        return function(t) {
            return typeof t == "object" && e(t) ? !0 : t;
        };
    }, it = Pp(function(param) {
        var e = param.element, t = param.nativeEvent;
        return e === t.target;
    }), VM = Pp(function(param) {
        var e = param.element, t = param.nativeEvent;
        return e.contains(t.target);
    }), Q = (0, EM.default)([
        it,
        VM
    ]), bp = function(e, t) {
        if (t) {
            var ref = e.getState(), r = ref.ixData, n = r.events, i = n[t];
            if (i && !UM[i.eventTypeId]) return i;
        }
        return null;
    }, XM = function(param) {
        var e = param.store, t = param.event;
        var r = t.action, _config = r.config, n = _config.autoStopEventId;
        return !!bp(e, n);
    }, X = function(param, i) {
        var e = param.store, t = param.event, r = param.element, n = param.eventStateKey;
        var o = t.action, u = t.id, _config = o.config, a = _config.actionListId, s = _config.autoStopEventId, l = bp(e, s);
        return l && (0, si.stopActionGroup)({
            store: e,
            eventId: s,
            eventTarget: r,
            eventStateKey: s + gp + n.split(gp)[1],
            actionListId: (0, _M.default)(l, "action.config.actionListId")
        }), (0, si.stopActionGroup)({
            store: e,
            eventId: u,
            eventTarget: r,
            eventStateKey: n,
            actionListId: a
        }), (0, si.startActionGroup)({
            store: e,
            eventId: u,
            eventTarget: r,
            eventStateKey: n,
            actionListId: a
        }), i;
    }, H = function(e, t) {
        return function(r, n) {
            return e(r, n) === !0 ? t(r, n) : n;
        };
    }, ot = {
        handler: H(Q, X)
    }, Lp = _object_spread_props(_object_spread({}, ot), {
        types: [
            ci,
            Np
        ].join(" ")
    }), li = [
        {
            target: window,
            types: "resize orientationchange",
            throttle: !0
        },
        {
            target: document,
            types: "scroll wheel readystatechange IX2_PAGE_UPDATE",
            throttle: !0
        }
    ], hp = "mouseover mouseout", fi = {
        types: li
    }, UM = {
        PAGE_START: mp,
        PAGE_FINISH: Rp
    }, nt = function() {
        var e = window.pageXOffset !== void 0, r = document.compatMode === "CSS1Compat" ? document.documentElement : document.body;
        return function() {
            return {
                scrollLeft: e ? window.pageXOffset : r.scrollLeft,
                scrollTop: e ? window.pageYOffset : r.scrollTop,
                stiffScrollTop: (0, gM.default)(e ? window.pageYOffset : r.scrollTop, 0, r.scrollHeight - window.innerHeight),
                scrollWidth: r.scrollWidth,
                scrollHeight: r.scrollHeight,
                clientWidth: r.clientWidth,
                clientHeight: r.clientHeight,
                innerWidth: window.innerWidth,
                innerHeight: window.innerHeight
            };
        };
    }(), BM = function(e, t) {
        return !(e.left > t.right || e.right < t.left || e.top > t.bottom || e.bottom < t.top);
    }, WM = function(param) {
        var e = param.element, t = param.nativeEvent;
        var r = t.type, n = t.target, i = t.relatedTarget, o = e.contains(n);
        if (r === "mouseover" && o) return !0;
        var u = e.contains(i);
        return !!(r === "mouseout" && o && u);
    }, HM = function(e) {
        var t = e.element, _event = e.event, r = _event.config, ref = nt(), n = ref.clientWidth, i = ref.clientHeight, o = r.scrollOffsetValue, s = r.scrollOffsetUnit === "PX" ? o : i * (o || 0) / 100;
        return BM(t.getBoundingClientRect(), {
            left: 0,
            top: s,
            right: n,
            bottom: i - s
        });
    }, Dp = function(e) {
        return function(t, r) {
            var _nativeEvent = t.nativeEvent, n = _nativeEvent.type, i = [
                ci,
                Np
            ].indexOf(n) !== -1 ? n === ci : r.isActive, o = _object_spread_props(_object_spread({}, r), {
                isActive: i
            });
            return (!r || o.isActive !== r.isActive) && e(t, o) || o;
        };
    }, Tp = function(e) {
        return function(t, r) {
            var n = {
                elementHovered: WM(t)
            };
            return (r ? n.elementHovered !== r.elementHovered : n.elementHovered) && e(t, n) || n;
        };
    }, jM = function(e) {
        return function(t, r) {
            var n = _object_spread_props(_object_spread({}, r), {
                elementVisible: HM(t)
            });
            return (r ? n.elementVisible !== r.elementVisible : n.elementVisible) && e(t, n) || n;
        };
    }, yp = function(e) {
        return function(t) {
            var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            var ref = nt(), n = ref.stiffScrollTop, i = ref.scrollHeight, o = ref.innerHeight, _event = t.event, u = _event.config, a = _event.eventTypeId, s = u.scrollOffsetValue, l = u.scrollOffsetUnit, d = l === "PX", p = i - o, f = Number((n / p).toFixed(2));
            if (r && r.percentTop === f) return r;
            var E = (d ? s : o * (s || 0) / 100) / p, g, _, h = 0;
            r && (g = f > r.percentTop, _ = r.scrollingDown !== g, h = _ ? f : r.anchorTop);
            var I = a === Sp ? f >= h + E : f <= h - E, y = _object_spread_props(_object_spread({}, r), {
                percentTop: f,
                inBounds: I,
                anchorTop: h,
                scrollingDown: g
            });
            return r && I && (_ || y.inBounds !== r.inBounds) && e(t, y) || y;
        };
    }, KM = function(e, t) {
        return e.left > t.left && e.left < t.right && e.top > t.top && e.top < t.bottom;
    }, YM = function(e) {
        return function(t, r) {
            var n = {
                finished: document.readyState === "complete"
            };
            return n.finished && !(r && r.finshed) && e(t), n;
        };
    }, zM = function(e) {
        return function(t, r) {
            var n = {
                started: !0
            };
            return r || e(t), n;
        };
    }, Op = function(e) {
        return function(t) {
            var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                clickCount: 0
            };
            var n = {
                clickCount: r.clickCount % 2 + 1
            };
            return n.clickCount !== r.clickCount && e(t, n) || n;
        };
    }, Jt = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return _object_spread_props(_object_spread({}, Lp), {
            handler: H(e ? Q : it, Dp(function(t, r) {
                return r.isActive ? ot.handler(t, r) : r;
            }))
        });
    }, er = function() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
        return _object_spread_props(_object_spread({}, Lp), {
            handler: H(e ? Q : it, Dp(function(t, r) {
                return r.isActive ? r : ot.handler(t, r);
            }))
        });
    }, vp = _object_spread_props(_object_spread({}, fi), {
        handler: jM(function(e, t) {
            var r = t.elementVisible, n = e.event, i = e.store, ref = i.getState(), o = ref.ixData, u = o.events;
            return !u[n.action.config.autoStopEventId] && t.triggered ? t : n.eventTypeId === Cp === r ? (X(e), _object_spread_props(_object_spread({}, t), {
                triggered: !0
            })) : t;
        })
    }), Ap = 0.05, kM = (_obj = {}, _defineProperty(_obj, RM, Jt()), _defineProperty(_obj, mM, er()), _defineProperty(_obj, CM, Jt()), _defineProperty(_obj, SM, er()), _defineProperty(_obj, LM, Jt(!1)), _defineProperty(_obj, bM, er(!1)), _defineProperty(_obj, NM, Jt()), _defineProperty(_obj, PM, er()), _defineProperty(_obj, xM, {
        types: "ecommerce-cart-open",
        handler: H(Q, X)
    }), _defineProperty(_obj, wM, {
        types: "ecommerce-cart-close",
        handler: H(Q, X)
    }), _defineProperty(_obj, hM, {
        types: "click",
        handler: H(Q, Op(function(e, param) {
            var t = param.clickCount;
            XM(e) ? t === 1 && X(e) : X(e);
        }))
    }), _defineProperty(_obj, TM, {
        types: "click",
        handler: H(Q, Op(function(e, param) {
            var t = param.clickCount;
            t === 2 && X(e);
        }))
    }), _defineProperty(_obj, yM, _object_spread_props(_object_spread({}, ot), {
        types: "mousedown"
    })), _defineProperty(_obj, OM, _object_spread_props(_object_spread({}, ot), {
        types: "mouseup"
    })), _defineProperty(_obj, vM, {
        types: hp,
        handler: H(Q, Tp(function(e, t) {
            t.elementHovered && X(e);
        }))
    }), _defineProperty(_obj, AM, {
        types: hp,
        handler: H(Q, Tp(function(e, t) {
            t.elementHovered || X(e);
        }))
    }), _defineProperty(_obj, DM, {
        types: "mousemove mouseout scroll",
        handler: function(param) {
            var e = param.store, t = param.element, r = param.eventConfig, n = param.nativeEvent, i = param.eventStateKey, o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                clientX: 0,
                clientY: 0,
                pageX: 0,
                pageY: 0
            };
            var u = r.basedOn, a = r.selectedAxis, s = r.continuousParameterGroupId, l = r.reverse, tmp = r.restingState, d = tmp === void 0 ? 0 : tmp, tmp1 = n.clientX, p = tmp1 === void 0 ? o.clientX : tmp1, tmp2 = n.clientY, f = tmp2 === void 0 ? o.clientY : tmp2, tmp3 = n.pageX, E = tmp3 === void 0 ? o.pageX : tmp3, tmp4 = n.pageY, g = tmp4 === void 0 ? o.pageY : tmp4, _ = a === "X_AXIS", h = n.type === "mouseout", I = d / 100, y = s, A = !1;
            switch(u){
                case pe.EventBasedOn.VIEWPORT:
                    {
                        I = _ ? Math.min(p, window.innerWidth) / window.innerWidth : Math.min(f, window.innerHeight) / window.innerHeight;
                        break;
                    }
                case pe.EventBasedOn.PAGE:
                    {
                        var ref = nt(), O = ref.scrollLeft, C = ref.scrollTop, T = ref.scrollWidth, S = ref.scrollHeight;
                        I = _ ? Math.min(O + E, T) / T : Math.min(C + g, S) / S;
                        break;
                    }
                case pe.EventBasedOn.ELEMENT:
                default:
                    {
                        y = Ip(i, s);
                        var O1 = n.type.indexOf("mouse") === 0;
                        if (O1 && Q({
                            element: t,
                            nativeEvent: n
                        }) !== !0) break;
                        var C1 = t.getBoundingClientRect(), T1 = C1.left, S1 = C1.top, v = C1.width, R = C1.height;
                        if (!O1 && !KM({
                            left: p,
                            top: f
                        }, C1)) break;
                        A = !0, I = _ ? (p - T1) / v : (f - S1) / R;
                        break;
                    }
            }
            return h && (I > 1 - Ap || I < Ap) && (I = Math.round(I)), (u !== pe.EventBasedOn.ELEMENT || A || A !== o.elementHovered) && (I = l ? 1 - I : I, e.dispatch((0, Zt.parameterChanged)(y, I))), {
                elementHovered: A,
                clientX: p,
                clientY: f,
                pageX: E,
                pageY: g
            };
        }
    }), _defineProperty(_obj, GM, {
        types: li,
        handler: function(param) {
            var e = param.store, t = param.eventConfig;
            var r = t.continuousParameterGroupId, n = t.reverse, ref = nt(), i = ref.scrollTop, o = ref.scrollHeight, u = ref.clientHeight, a = i / (o - u);
            a = n ? 1 - a : a, e.dispatch((0, Zt.parameterChanged)(r, a));
        }
    }), _defineProperty(_obj, qM, {
        types: li,
        handler: function(param) {
            var e = param.element, t = param.store, r = param.eventConfig, n = param.eventStateKey, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
                scrollPercent: 0
            };
            var ref = nt(), o = ref.scrollLeft, u = ref.scrollTop, a = ref.scrollWidth, s = ref.scrollHeight, l = ref.clientHeight, d = r.basedOn, p = r.selectedAxis, f = r.continuousParameterGroupId, E = r.startsEntering, g = r.startsExiting, _ = r.addEndOffset, h = r.addStartOffset, tmp = r.addOffsetValue, I = tmp === void 0 ? 0 : tmp, tmp1 = r.endOffsetValue, y = tmp1 === void 0 ? 0 : tmp1, A = p === "X_AXIS";
            if (d === pe.EventBasedOn.VIEWPORT) {
                var O = A ? o / a : u / s;
                return O !== i.scrollPercent && t.dispatch((0, Zt.parameterChanged)(f, O)), {
                    scrollPercent: O
                };
            } else {
                var O1 = Ip(n, f), C = e.getBoundingClientRect(), T = (h ? I : 0) / 100, S = (_ ? y : 0) / 100;
                T = E ? T : 1 - T, S = g ? S : 1 - S;
                var v = C.top + Math.min(C.height * T, l), m = C.top + C.height * S - v, N = Math.min(l + m, s), b = Math.min(Math.max(0, l - v), N) / N;
                return b !== i.scrollPercent && t.dispatch((0, Zt.parameterChanged)(O1, b)), {
                    scrollPercent: b
                };
            }
        }
    }), _defineProperty(_obj, Cp, vp), _defineProperty(_obj, MM, vp), _defineProperty(_obj, Sp, _object_spread_props(_object_spread({}, fi), {
        handler: yp(function(e, t) {
            t.scrollingDown && X(e);
        })
    })), _defineProperty(_obj, FM, _object_spread_props(_object_spread({}, fi), {
        handler: yp(function(e, t) {
            t.scrollingDown || X(e);
        })
    })), _defineProperty(_obj, Rp, {
        types: "readystatechange IX2_PAGE_UPDATE",
        handler: H(it, YM(X))
    }), _defineProperty(_obj, mp, {
        types: "readystatechange IX2_PAGE_UPDATE",
        handler: H(it, zM(X))
    }), _obj);
});
var Ei = c(function(Ai) {
    "use strict";
    var QM = function QM(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var J = function J(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var iF = function iF(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = xp(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    var SF = function SF(e) {
        Ee({
            store: e,
            select: function(param) {
                var t = param.ixRequest;
                return t.preview;
            },
            onChange: mF
        }), Ee({
            store: e,
            select: function(param) {
                var t = param.ixRequest;
                return t.playback;
            },
            onChange: NF
        }), Ee({
            store: e,
            select: function(param) {
                var t = param.ixRequest;
                return t.stop;
            },
            onChange: PF
        }), Ee({
            store: e,
            select: function(param) {
                var t = param.ixRequest;
                return t.clear;
            },
            onChange: bF
        });
    };
    var CF = function CF(e) {
        Ee({
            store: e,
            select: function(param) {
                var t = param.ixSession;
                return t.mediaQueryKey;
            },
            onChange: function() {
                ur(e), Vp({
                    store: e,
                    elementApi: F
                }), or({
                    store: e,
                    allowEvents: !0
                }), Xp();
            }
        });
    };
    var RF = function RF(e, t) {
        var r = Ee({
            store: e,
            select: function(param) {
                var n = param.ixSession;
                return n.tick;
            },
            onChange: function(n) {
                t(n), r();
            }
        });
    };
    var mF = function mF(param, r) {
        var e = param.rawData, t = param.defer;
        var n = function() {
            or({
                store: r,
                rawData: e,
                allowEvents: !0
            }), Xp();
        };
        t ? setTimeout(n, 0) : n();
    };
    var Xp = function Xp() {
        document.dispatchEvent(new CustomEvent("IX2_PAGE_UPDATE"));
    };
    var NF = function NF(e, t) {
        var r = e.actionTypeId, n = e.actionListId, i = e.actionItemId, o = e.eventId, u = e.allowEvents, a = e.immediate, s = e.testManual, tmp = e.verbose, l = tmp === void 0 ? !0 : tmp, d = e.rawData;
        if (n && i && d && a) {
            var p = d.actionLists[n];
            p && (d = pF({
                actionList: p,
                actionItemId: i,
                rawData: d
            }));
        }
        if (or({
            store: t,
            rawData: d,
            allowEvents: u,
            testManual: s
        }), n && r === B.ActionTypeConsts.GENERAL_START_ACTION || _i(r)) {
            Ti({
                store: t,
                actionListId: n
            }), Bp({
                store: t,
                actionListId: n,
                eventId: o
            });
            var p1 = yi({
                store: t,
                eventId: o,
                actionListId: n,
                immediate: a,
                verbose: l
            });
            l && p1 && t.dispatch((0, M.actionListPlaybackChanged)({
                actionListId: n,
                isPlaying: !a
            }));
        }
    };
    var PF = function PF(param, t) {
        var e = param.actionListId;
        e ? Ti({
            store: t,
            actionListId: e
        }) : Wp({
            store: t
        }), ur(t);
    };
    var bF = function bF(e, t) {
        ur(t), Vp({
            store: t,
            elementApi: F
        });
    };
    var or = function or(param) {
        var e = param.store, t = param.rawData, r = param.allowEvents, n = param.testManual;
        var ref = e.getState(), i = ref.ixSession;
        t && e.dispatch((0, M.rawDataImported)(t)), i.active || (e.dispatch((0, M.sessionInitialized)({
            hasBoundaryNodes: !!document.querySelector(tr),
            reducedMotion: document.body.hasAttribute("data-wf-ix-vacation") && window.matchMedia("(prefers-reduced-motion)").matches
        })), r && (wF(e), LF(), e.getState().ixSession.hasDefinedMediaQueries && CF(e)), e.dispatch((0, M.sessionStarted)()), DF(e, n));
    };
    var LF = function LF() {
        var e = document.documentElement;
        e.className.indexOf(Fp) === -1 && (e.className += " ".concat(Fp));
    };
    var DF = function DF(e, t) {
        var r = function(n) {
            var ref = e.getState(), i = ref.ixSession, o = ref.ixParameters;
            i.active && (e.dispatch((0, M.animationFrameChanged)(n, o)), t ? RF(e, r) : requestAnimationFrame(r));
        };
        r(window.performance.now());
    };
    var ur = function ur(e) {
        var ref = e.getState(), t = ref.ixSession;
        if (t.active) {
            var r = t.eventListeners;
            r.forEach(MF), IF(), e.dispatch((0, M.sessionStopped)());
        }
    };
    var MF = function MF(param) {
        var e = param.target, t = param.listenerParams;
        e.removeEventListener.apply(e, t);
    };
    var FF = function FF(param) {
        var e = param.store, t = param.eventStateKey, r = param.eventTarget, n = param.eventId, i = param.eventConfig, o = param.actionListId, u = param.parameterGroup, a = param.smoothing, s = param.restingValue;
        var ref = e.getState(), l = ref.ixData, d = ref.ixSession, p = l.events, f = p[n], E = f.eventTypeId, g = {}, _ = {}, h = [], I = u.continuousActionGroups, y = u.id;
        EF(E, i) && (y = _F(t, y));
        var A = d.hasBoundaryNodes && r ? F.getClosestElement(r, tr) : null;
        I.forEach(function(O) {
            var C = O.keyframe, T = O.actionItems;
            T.forEach(function(S) {
                var v = S.actionTypeId, _config = S.config, R = _config.target;
                if (!R) return;
                var m = R.boundaryMode ? A : null, N = hF(R) + gi + v;
                if (_[N] = qF(_[N], C, S), !g[N]) {
                    g[N] = !0;
                    var P = S.config;
                    rr({
                        config: P,
                        event: f,
                        eventTarget: r,
                        elementRoot: m,
                        elementApi: F
                    }).forEach(function(b) {
                        h.push({
                            element: b,
                            key: N
                        });
                    });
                }
            });
        }), h.forEach(function(param) {
            var O = param.element, C = param.key;
            var _S_config_target, _S_config, _hi;
            var T = _[C], S = (0, oe.default)(T, "[0].actionItems[0]", {}), v = S.actionTypeId, m = (v === B.ActionTypeConsts.PLUGIN_RIVE ? (((_S_config = S.config) === null || _S_config === void 0 ? void 0 : (_S_config_target = _S_config.target) === null || _S_config_target === void 0 ? void 0 : _S_config_target.selectorGuids) || []).length === 0 : ir(v)) ? (_hi = hi(v)) === null || _hi === void 0 ? void 0 : _hi(O, S) : null, N = Ii({
                element: O,
                actionItem: S,
                elementApi: F
            }, m);
            Oi({
                store: e,
                element: O,
                eventId: n,
                actionListId: o,
                actionItem: S,
                destination: N,
                continuous: !0,
                parameterId: y,
                actionGroups: T,
                smoothing: a,
                restingValue: s,
                pluginInstance: m
            });
        });
    };
    var qF = function qF() {
        var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 ? arguments[1] : void 0, r = arguments.length > 2 ? arguments[2] : void 0;
        var n = _toConsumableArray(e), i;
        return n.some(function(o, u) {
            return o.keyframe === t ? (i = u, !0) : !1;
        }), i == null && (i = n.length, n.push({
            keyframe: t,
            actionItems: []
        })), n[i].actionItems.push(r), n;
    };
    var wF = function wF(e) {
        var ref = e.getState(), t = ref.ixData, r = t.eventTypeMap;
        Up(e), (0, ut.default)(r, function(i, o) {
            var u = nF.default[o];
            if (!u) {
                console.warn("IX2 event type not configured: ".concat(o));
                return;
            }
            BF({
                logic: u,
                store: e,
                events: i
            });
        });
        var ref1 = e.getState(), n = ref1.ixSession;
        n.eventListeners.length && GF(e);
    };
    var GF = function GF(e) {
        var t = function() {
            Up(e);
        };
        xF.forEach(function(r) {
            window.addEventListener(r, t), e.dispatch((0, M.eventListenerAdded)(window, [
                r,
                t
            ]));
        }), t();
    };
    var Up = function Up(e) {
        var ref = e.getState(), t = ref.ixSession, r = ref.ixData, n = window.innerWidth;
        if (n !== t.viewportWidth) {
            var i = r.mediaQueries;
            e.dispatch((0, M.viewportWidthChanged)({
                width: n,
                mediaQueries: i
            }));
        }
    };
    var BF = function BF(param) {
        var e = param.logic, t = param.store, r = param.events;
        WF(r);
        var n = e.types, i = e.handler, ref = t.getState(), o = ref.ixData, u = o.actionLists, a = VF(r, UF);
        if (!(0, ZM.default)(a)) return;
        (0, ut.default)(a, function(p, f) {
            var E = r[f], g = E.action, _ = E.id, tmp = E.mediaQueries, h = tmp === void 0 ? o.mediaQueryKeys : tmp, _config = g.config, I = _config.actionListId;
            TF(h, o.mediaQueryKeys) || t.dispatch((0, M.mediaQueriesDefined)()), g.actionTypeId === B.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION && (Array.isArray(E.config) ? E.config : [
                E.config
            ]).forEach(function(A) {
                var O = A.continuousParameterGroupId, C = (0, oe.default)(u, "".concat(I, ".continuousParameterGroups"), []), T = (0, $M.default)(C, function(param) {
                    var R = param.id;
                    return R === O;
                }), S = (A.smoothing || 0) / 100, v = (A.restingState || 0) / 100;
                T && p.forEach(function(R, m) {
                    var N = _ + gi + m;
                    FF({
                        store: t,
                        eventStateKey: N,
                        eventTarget: R,
                        eventId: _,
                        eventConfig: A,
                        actionListId: I,
                        parameterGroup: T,
                        smoothing: S,
                        restingValue: v
                    });
                });
            }), (g.actionTypeId === B.ActionTypeConsts.GENERAL_START_ACTION || _i(g.actionTypeId)) && Bp({
                store: t,
                actionListId: I,
                eventId: _
            });
        });
        var s = function(p) {
            var ref = t.getState(), f = ref.ixSession;
            XF(a, function(E, g, _) {
                var h = r[g], I = f.eventState[_], y = h.action, tmp = h.mediaQueries, A = tmp === void 0 ? o.mediaQueryKeys : tmp;
                if (!nr(A, f.mediaQueryKey)) return;
                var O = function() {
                    var C = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                    var T = i({
                        store: t,
                        element: E,
                        event: h,
                        eventConfig: C,
                        nativeEvent: p,
                        eventStateKey: _
                    }, I);
                    yF(T, I) || t.dispatch((0, M.eventStateChanged)(_, T));
                };
                y.actionTypeId === B.ActionTypeConsts.GENERAL_CONTINUOUS_ACTION ? (Array.isArray(h.config) ? h.config : [
                    h.config
                ]).forEach(O) : O();
            });
        }, l = (0, rF.default)(s, AF), d = function(param) {
            var tmp = param.target, p = tmp === void 0 ? document : tmp, f = param.types, E = param.throttle;
            f.split(" ").filter(Boolean).forEach(function(g) {
                var _ = E ? l : s;
                p.addEventListener(g, _), t.dispatch((0, M.eventListenerAdded)(p, [
                    g,
                    _
                ]));
            });
        };
        Array.isArray(n) ? n.forEach(d) : typeof n == "string" && d(e);
    };
    var WF = function WF(e) {
        if (!vF) return;
        var t = {}, r = "";
        for(var n in e){
            var _n = e[n], i = _n.eventTypeId, o = _n.target, u = F.getQuerySelector(o);
            t[u] || (i === B.EventTypeConsts.MOUSE_CLICK || i === B.EventTypeConsts.MOUSE_SECOND_CLICK) && (t[u] = !0, r += u + "{cursor: pointer;touch-action: manipulation;}");
        }
        if (r) {
            var n1 = document.createElement("style");
            n1.textContent = r, document.body.appendChild(n1);
        }
    };
    var Bp = function Bp(param) {
        var e = param.store, t = param.actionListId, r = param.eventId;
        var ref = e.getState(), n = ref.ixData, i = ref.ixSession, o = n.actionLists, u = n.events, a = u[r], s = o[t];
        if (s && s.useFirstGroupAsInitialState) {
            var l = (0, oe.default)(s, "actionItemGroups[0].actionItems", []), d = (0, oe.default)(a, "mediaQueries", n.mediaQueryKeys);
            if (!nr(d, i.mediaQueryKey)) return;
            l.forEach(function(p) {
                var _f_target, _f_target1;
                var f = p.config, E = p.actionTypeId, g = (f === null || f === void 0 ? void 0 : (_f_target = f.target) === null || _f_target === void 0 ? void 0 : _f_target.useEventTarget) === !0 && (f === null || f === void 0 ? void 0 : (_f_target1 = f.target) === null || _f_target1 === void 0 ? void 0 : _f_target1.objectId) == null ? {
                    target: a.target,
                    targets: a.targets
                } : f, _ = rr({
                    config: g,
                    event: a,
                    elementApi: F
                }), h = ir(E);
                _.forEach(function(I) {
                    var _hi;
                    var y = h ? (_hi = hi(E)) === null || _hi === void 0 ? void 0 : _hi(I, p) : null;
                    Oi({
                        destination: Ii({
                            element: I,
                            actionItem: p,
                            elementApi: F
                        }, y),
                        immediate: !0,
                        store: e,
                        element: I,
                        eventId: r,
                        actionItem: p,
                        actionListId: t,
                        pluginInstance: y
                    });
                });
            });
        }
    };
    var Wp = function Wp(param) {
        var e = param.store;
        var ref = e.getState(), t = ref.ixInstances;
        (0, ut.default)(t, function(r) {
            if (!r.continuous) {
                var n = r.actionListId, i = r.verbose;
                vi(r, e), i && e.dispatch((0, M.actionListPlaybackChanged)({
                    actionListId: n,
                    isPlaying: !1
                }));
            }
        });
    };
    var Ti = function Ti(param) {
        var e = param.store, t = param.eventId, r = param.eventTarget, n = param.eventStateKey, i = param.actionListId;
        var ref = e.getState(), o = ref.ixInstances, u = ref.ixSession, a = u.hasBoundaryNodes && r ? F.getClosestElement(r, tr) : null;
        (0, ut.default)(o, function(s) {
            var l = (0, oe.default)(s, "actionItem.config.target.boundaryMode"), d = n ? s.eventStateKey === n : !0;
            if (s.actionListId === i && s.eventId === t && d) {
                if (a && l && !F.elementContains(a, s.element)) return;
                vi(s, e), s.verbose && e.dispatch((0, M.actionListPlaybackChanged)({
                    actionListId: i,
                    isPlaying: !1
                }));
            }
        });
    };
    var yi = function yi(param) {
        var e = param.store, t = param.eventId, r = param.eventTarget, n = param.eventStateKey, i = param.actionListId, tmp = param.groupIndex, o = tmp === void 0 ? 0 : tmp, u = param.immediate, a = param.verbose;
        var _p_action;
        var ref = e.getState(), s = ref.ixData, l = ref.ixSession, d = s.events, p = d[t] || {}, tmp1 = p.mediaQueries, f = tmp1 === void 0 ? s.mediaQueryKeys : tmp1, E = (0, oe.default)(s, "actionLists.".concat(i), {}), g = E.actionItemGroups, _ = E.useFirstGroupAsInitialState;
        if (!g || !g.length) return !1;
        o >= g.length && (0, oe.default)(p, "config.loop") && (o = 0), o === 0 && _ && o++;
        var I = (o === 0 || o === 1 && _) && _i((_p_action = p.action) === null || _p_action === void 0 ? void 0 : _p_action.actionTypeId) ? p.config.delay : void 0, y = (0, oe.default)(g, [
            o,
            "actionItems"
        ], []);
        if (!y.length || !nr(f, l.mediaQueryKey)) return !1;
        var A = l.hasBoundaryNodes && r ? F.getClosestElement(r, tr) : null, O = lF(y), C = !1;
        return y.forEach(function(T, S) {
            var v = T.config, R = T.actionTypeId, m = ir(R), N = v.target;
            if (!N) return;
            var P = N.boundaryMode ? A : null;
            rr({
                config: v,
                event: p,
                eventTarget: r,
                elementRoot: P,
                elementApi: F
            }).forEach(function(q, Ri) {
                var _hi;
                var sr = m ? (_hi = hi(R)) === null || _hi === void 0 ? void 0 : _hi(q, T) : null, cr = m ? OF(R)(q, T) : null;
                C = !0;
                var kp = O === S && Ri === 0, Qp = fF({
                    element: q,
                    actionItem: T
                }), $p = Ii({
                    element: q,
                    actionItem: T,
                    elementApi: F
                }, sr);
                Oi({
                    store: e,
                    element: q,
                    actionItem: T,
                    eventId: t,
                    eventTarget: r,
                    eventStateKey: n,
                    actionListId: i,
                    groupIndex: o,
                    isCarrier: kp,
                    computedStyle: Qp,
                    destination: $p,
                    immediate: u,
                    verbose: a,
                    pluginInstance: sr,
                    pluginDuration: cr,
                    instanceDelay: I
                });
            });
        }), C;
    };
    var Oi = function Oi(e) {
        var __events_d;
        var t = e.store, r = e.computedStyle, n = _object_without_properties(e, [
            "store",
            "computedStyle"
        ]), i = n.element, o = n.actionItem, u = n.immediate, a = n.pluginInstance, s = n.continuous, l = n.restingValue, d = n.eventId, p = !s, f = sF(), ref = t.getState(), E = ref.ixElements, g = ref.ixSession, _ = ref.ixData, h = aF(E, i), ref1 = E[h] || {}, I = ref1.refState, y = F.getRefType(i), A = g.reducedMotion && B.ReducedMotionTypes[o.actionTypeId], O;
        if (A && s) switch((__events_d = _.events[d]) === null || __events_d === void 0 ? void 0 : __events_d.eventTypeId){
            case B.EventTypeConsts.MOUSE_MOVE:
            case B.EventTypeConsts.MOUSE_MOVE_IN_VIEWPORT:
                O = l;
                break;
            default:
                O = 0.5;
                break;
        }
        var C = dF(i, I, r, o, F, a);
        if (t.dispatch((0, M.instanceAdded)(_object_spread({
            instanceId: f,
            elementId: h,
            origin: C,
            refType: y,
            skipMotion: A,
            skipToValue: O
        }, n))), Hp(document.body, "ix2-animation-started", f), u) {
            HF(t, f);
            return;
        }
        Ee({
            store: t,
            select: function(param) {
                var T = param.ixInstances;
                return T[f];
            },
            onChange: jp
        }), p && t.dispatch((0, M.instanceStarted)(f, g.tick));
    };
    var vi = function vi(e, t) {
        Hp(document.body, "ix2-animation-stopping", {
            instanceId: e.id,
            state: t.getState()
        });
        var r = e.elementId, n = e.actionItem, ref = t.getState(), i = ref.ixElements, ref1 = i[r] || {}, o = ref1.ref, u = ref1.refType;
        u === Gp && gF(o, n, F), t.dispatch((0, M.instanceRemoved)(e.id));
    };
    var Hp = function Hp(e, t, r) {
        var n = document.createEvent("CustomEvent");
        n.initCustomEvent(t, !0, !0, r), e.dispatchEvent(n);
    };
    var HF = function HF(e, t) {
        var ref = e.getState(), r = ref.ixParameters;
        e.dispatch((0, M.instanceStarted)(t, 0)), e.dispatch((0, M.animationFrameChanged)(performance.now(), r));
        var ref1 = e.getState(), n = ref1.ixInstances;
        jp(n[t], e);
    };
    var jp = function jp(e, t) {
        var r = e.active, n = e.continuous, i = e.complete, o = e.elementId, u = e.actionItem, a = e.actionTypeId, s = e.renderType, l = e.current, d = e.groupIndex, p = e.eventId, f = e.eventTarget, E = e.eventStateKey, g = e.actionListId, _ = e.isCarrier, h = e.styleProp, I = e.verbose, y = e.pluginInstance, ref = t.getState(), A = ref.ixData, O = ref.ixSession, C = A.events, T = C && C[p] ? C[p] : {}, tmp = T.mediaQueries, S = tmp === void 0 ? A.mediaQueryKeys : tmp;
        if (nr(S, O.mediaQueryKey) && (n || r || i)) {
            if (l || s === uF && i) {
                t.dispatch((0, M.elementStateChanged)(o, a, l, u));
                var ref1 = t.getState(), v = ref1.ixElements, ref2 = v[o] || {}, R = ref2.ref, m = ref2.refType, N = ref2.refState, P = N && N[a];
                (m === Gp || ir(a)) && cF(R, N, P, p, u, h, F, s, y);
            }
            if (i) {
                if (_) {
                    var v1 = yi({
                        store: t,
                        eventId: p,
                        eventTarget: f,
                        eventStateKey: E,
                        actionListId: g,
                        groupIndex: d + 1,
                        verbose: I
                    });
                    I && !v1 && t.dispatch((0, M.actionListPlaybackChanged)({
                        actionListId: g,
                        isPlaying: !1
                    }));
                }
                vi(e, t);
            }
        }
    };
    Object.defineProperty(Ai, "__esModule", {
        value: !0
    });
    QM(Ai, {
        observeRequests: function observeRequests() {
            return SF;
        },
        startActionGroup: function startActionGroup() {
            return yi;
        },
        startEngine: function startEngine() {
            return or;
        },
        stopActionGroup: function stopActionGroup() {
            return Ti;
        },
        stopAllActionGroups: function stopAllActionGroups() {
            return Wp;
        },
        stopEngine: function stopEngine() {
            return ur;
        }
    });
    var $M = J(fn()), oe = J(Nt()), ZM = J(gf()), JM = J(Bf()), eF = J(Hf()), tF = J(Kf()), ut = J(Zf()), rF = J(od()), B = G(), wp = de(), M = jt(), F = iF(cd()), nF = J(Mp());
    function xp(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (xp = function xp(n) {
            return n ? r : t;
        })(e);
    }
    var oF = Object.keys(B.QuickEffectIds), _i = function(e) {
        return oF.includes(e);
    }, _IX2EngineConstants = B.IX2EngineConstants, gi = _IX2EngineConstants.COLON_DELIMITER, tr = _IX2EngineConstants.BOUNDARY_SELECTOR, Gp = _IX2EngineConstants.HTML_ELEMENT, uF = _IX2EngineConstants.RENDER_GENERAL, Fp = _IX2EngineConstants.W_MOD_IX, _IX2VanillaUtils = wp.IX2VanillaUtils, rr = _IX2VanillaUtils.getAffectedElements, aF = _IX2VanillaUtils.getElementId, Ii = _IX2VanillaUtils.getDestinationValues, Ee = _IX2VanillaUtils.observeStore, sF = _IX2VanillaUtils.getInstanceId, cF = _IX2VanillaUtils.renderHTMLElement, Vp = _IX2VanillaUtils.clearAllStyles, lF = _IX2VanillaUtils.getMaxDurationItemIndex, fF = _IX2VanillaUtils.getComputedStyle, dF = _IX2VanillaUtils.getInstanceOrigin, pF = _IX2VanillaUtils.reduceListToGroup, EF = _IX2VanillaUtils.shouldNamespaceEventParameter, _F = _IX2VanillaUtils.getNamespacedParameterId, nr = _IX2VanillaUtils.shouldAllowMediaQuery, gF = _IX2VanillaUtils.cleanupHTMLElement, IF = _IX2VanillaUtils.clearObjectCache, hF = _IX2VanillaUtils.stringifyTarget, TF = _IX2VanillaUtils.mediaQueriesEqual, yF = _IX2VanillaUtils.shallowEqual, _IX2VanillaPlugins = wp.IX2VanillaPlugins, ir = _IX2VanillaPlugins.isPluginType, hi = _IX2VanillaPlugins.createPluginInstance, OF = _IX2VanillaPlugins.getPluginDuration, qp = navigator.userAgent, vF = qp.match(/iPad/i) || qp.match(/iPhone/), AF = 12;
    var xF = [
        "resize",
        "orientationchange"
    ];
    var VF = function(e, t) {
        return (0, JM.default)((0, tF.default)(e, t), eF.default);
    }, XF = function(e, t) {
        (0, ut.default)(e, function(r, n) {
            r.forEach(function(i, o) {
                var u = n + gi + o;
                t(i, n, u);
            });
        });
    }, UF = function(e) {
        var t = {
            target: e.target,
            targets: e.targets
        };
        return rr({
            config: t,
            elementApi: F
        });
    };
});
var zp = c(function(Ci) {
    "use strict";
    var jF = function jF(e, t) {
        for(var r in t)Object.defineProperty(e, r, {
            enumerable: !0,
            get: t[r]
        });
    };
    var kF = function kF(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    };
    var QF = function QF(e, t) {
        if (!t && e && e.__esModule) return e;
        if (e === null || typeof e != "object" && typeof e != "function") return {
            default: e
        };
        var r = Kp(t);
        if (r && r.has(e)) return r.get(e);
        var n = {
            __proto__: null
        }, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
        for(var o in e)if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
            var u = i ? Object.getOwnPropertyDescriptor(e, o) : null;
            u && (u.get || u.set) ? Object.defineProperty(n, o, u) : n[o] = e[o];
        }
        return n.default = e, r && r.set(e, n), n;
    };
    var $F = function $F(e) {
        e() && (0, Si.observeRequests)(ar);
    };
    var ZF = function ZF(e) {
        Yp(), (0, Si.startEngine)({
            store: ar,
            rawData: e,
            allowEvents: !0
        });
    };
    var Yp = function Yp() {
        (0, Si.stopEngine)(ar);
    };
    Object.defineProperty(Ci, "__esModule", {
        value: !0
    });
    jF(Ci, {
        actions: function actions() {
            return zF;
        },
        destroy: function destroy() {
            return Yp;
        },
        init: function init() {
            return ZF;
        },
        setEnv: function setEnv() {
            return $F;
        },
        store: function store() {
            return ar;
        }
    });
    var KF = Cr(), YF = kF(Ql()), Si = Ei(), zF = QF(jt());
    function Kp(e) {
        if (typeof WeakMap != "function") return null;
        var t = new WeakMap(), r = new WeakMap();
        return (Kp = function Kp(n) {
            return n ? r : t;
        })(e);
    }
    var ar = (0, KF.createStore)(YF.default);
});
function JF() {
    var e = zp();
    return e.setEnv(function() {
        return !0;
    }), e;
}
var y1 = {
    createIX2Engine: JF
};
 /*! Bundled license information:

timm/lib/timm.js:
  (*!
   * Timm
   *
   * Immutability helpers with fast reads and acceptable writes.
   *
   * @copyright Guillermo Grau Panea 2016
   * @license MIT
   *)
*/ 

/***/ }),

/***/ 4849:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ DevLinkProvider; },
/* harmony export */   "_": function() { return /* binding */ DevLinkContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _interactions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60309);
/* harmony import */ var _devlink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59477);
/* harmony import */ var _devlink__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_devlink__WEBPACK_IMPORTED_MODULE_2__);
"use client";
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var DevLinkContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({});
var DevLinkProvider = function(_param) {
    var children = _param.children, context = _object_without_properties(_param, [
        "children"
    ]);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DevLinkContext.Provider, {
        value: context
    }, /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_interactions__WEBPACK_IMPORTED_MODULE_1__/* .InteractionsProvider */ .Df, {
        createEngine: _devlink__WEBPACK_IMPORTED_MODULE_2__.createIX2Engine
    }, children));
};


/***/ }),

/***/ 60309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Df": function() { return /* binding */ InteractionsProvider; },
/* harmony export */   "NI": function() { return /* binding */ useInteractions; },
/* harmony export */   "Q_": function() { return /* binding */ triggerIXEvent; },
/* harmony export */   "_Y": function() { return /* binding */ useIXEvent; }
/* harmony export */ });
/* unused harmony export IXContext */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28130);

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


var enhanceIXData = function(data, styles) {
    var newIXData = structuredClone(data);
    for(var id in newIXData.events){
        var _id = newIXData.events[id], target = _id.target, targets = _id.targets;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = [
                target
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(targets))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var t = _step.value;
                if (t.appliesTo !== "CLASS") continue;
                t.selector = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .replaceSelector */ .jQ)(t.selector, styles);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    for(var id1 in newIXData.actionLists){
        var _id1 = newIXData.actionLists[id1], actionItemGroups = _id1.actionItemGroups, continuousParameterGroups = _id1.continuousParameterGroups;
        if (actionItemGroups) {
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = actionItemGroups[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var actionItems = _step1.value.actionItems;
                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(var _iterator2 = actionItems[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            var config = _step2.value.config;
                            var selector = config.target.selector;
                            if (!selector) continue;
                            config.target.selector = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .replaceSelector */ .jQ)(selector, styles);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        if (continuousParameterGroups) {
            var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
            try {
                for(var _iterator3 = continuousParameterGroups[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                    var group = _step3.value;
                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                    try {
                        for(var _iterator4 = group.continuousActionGroups[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                            var actionItems1 = _step4.value.actionItems;
                            var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                            try {
                                for(var _iterator5 = actionItems1[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                    var config1 = _step5.value.config;
                                    var selector1 = config1.target.selector;
                                    if (!selector1) continue;
                                    config1.target.selector = (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .replaceSelector */ .jQ)(selector1, styles);
                                }
                            } catch (err) {
                                _didIteratorError5 = true;
                                _iteratorError5 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                        _iterator5.return();
                                    }
                                } finally{
                                    if (_didIteratorError5) {
                                        throw _iteratorError5;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError4 = true;
                        _iteratorError4 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                _iterator4.return();
                            }
                        } finally{
                            if (_didIteratorError4) {
                                throw _iteratorError4;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError3) {
                        throw _iteratorError3;
                    }
                }
            }
        }
    }
    return newIXData;
};
var IXContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createContext({
    initEngine: null,
    restartEngine: null
});
var InteractionsProvider = function(param) {
    var children = param.children, createEngine = param.createEngine;
    var ixData = react__WEBPACK_IMPORTED_MODULE_0__.useRef({});
    var ixStyles = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    var ixEngine = react__WEBPACK_IMPORTED_MODULE_0__.useRef();
    var debouncedInit = react__WEBPACK_IMPORTED_MODULE_0__.useRef((0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .debounce */ .Ds)(function(data, styles) {
        if (!ixEngine.current) ixEngine.current = createEngine();
        var newData = styles ? enhanceIXData(data, styles) : data;
        ixEngine.current.init(newData);
        (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .dispatchCustomEvent */ .hb)(document, "IX2_PAGE_UPDATE");
    }));
    var initEngine = react__WEBPACK_IMPORTED_MODULE_0__.useCallback(function(data, styles) {
        if (!ixData.current.site) {
            ixData.current.site = data.site;
        }
        ixData.current.events = _object_spread({}, ixData.current.events, data.events);
        ixData.current.actionLists = _object_spread({}, ixData.current.actionLists, data.actionLists);
        if (styles) {
            var _ixStyles_current;
            ixStyles.current = (_ixStyles_current = ixStyles.current) !== null && _ixStyles_current !== void 0 ? _ixStyles_current : {};
            for(var s in styles){
                var _ixStyles_current_s;
                if (!((_ixStyles_current_s = ixStyles.current[s]) === null || _ixStyles_current_s === void 0 ? void 0 : _ixStyles_current_s.includes(styles[s]))) {
                    var currentStyle = ixStyles.current[s];
                    ixStyles.current[s] = CSS.escape(styles[s]) + (currentStyle ? " ".concat(currentStyle) : "");
                }
            }
        }
        debouncedInit.current(ixData.current, ixStyles.current);
    }, []);
    return /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.createElement(IXContext.Provider, {
        value: {
            initEngine: initEngine,
            restartEngine: function() {
                return debouncedInit.current && debouncedInit.current(ixData.current, ixStyles.current);
            }
        }
    }, children);
};
var useInteractions = function(data, styles) {
    var initEngine = react__WEBPACK_IMPORTED_MODULE_0__.useContext(IXContext).initEngine;
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        if (initEngine) initEngine(data, styles);
    }, [
        initEngine,
        data,
        styles
    ]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var _document_querySelector;
        if ((_document_querySelector = document.querySelector("html")) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.hasAttribute("data-wf-page")) return;
        var hasPageInteractions = Object.values(data.events).some(function(event) {
            return event.target.appliesTo === "PAGE";
        });
        if (hasPageInteractions) {
            document.documentElement.setAttribute("data-wf-page", "wf-page-id");
            (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .dispatchCustomEvent */ .hb)(document, "IX2_PAGE_UPDATE");
        }
    }, [
        data.events
    ]);
};
function triggerIXEvent(element, active) {
    if (!element) return;
    (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .dispatchCustomEvent */ .hb)(element, active ? "COMPONENT_ACTIVE" : "COMPONENT_INACTIVE");
}
function useIXEvent(element, active) {
    (0,_utils__WEBPACK_IMPORTED_MODULE_1__/* .useLayoutEffect */ .bt)(function() {
        triggerIXEvent(element, active);
    }, [
        element,
        active
    ]);
}


/***/ }),

/***/ 28130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
var react__WEBPACK_IMPORTED_MODULE_0___namespace_cache;
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ds": function() { return /* binding */ debounce; },
/* harmony export */   "Iy": function() { return /* binding */ useClickOut; },
/* harmony export */   "Yp": function() { return /* binding */ removeUnescaped; },
/* harmony export */   "aF": function() { return /* binding */ extractElement; },
/* harmony export */   "bt": function() { return /* binding */ useLayoutEffect; },
/* harmony export */   "cj": function() { return /* binding */ cj; },
/* harmony export */   "cx": function() { return /* binding */ cx; },
/* harmony export */   "hb": function() { return /* binding */ dispatchCustomEvent; },
/* harmony export */   "jQ": function() { return /* binding */ replaceSelector; },
/* harmony export */   "nx": function() { return /* binding */ KEY_CODES; },
/* harmony export */   "pX": function() { return /* binding */ EASING_FUNCTIONS; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "yU": function() { return /* binding */ useResizeObserver; }
/* harmony export */ });
/* unused harmony exports formatNumber, isUrl, loadScript */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10253);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29815);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);



var cx = function(style) {
    for(var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        classNames[_key - 1] = arguments[_key];
    }
    return cj.apply(void 0, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(classNames.map(function(c) {
        var _style_c;
        return (_style_c = style[c]) !== null && _style_c !== void 0 ? _style_c : c;
    })));
};
var cj = function() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++){
        classNames[_key] = arguments[_key];
    }
    return classNames.filter(Boolean).join(" ");
};
var UNESCAPED_CHARS = /(\\b|\\f|\\r\\n|\\n|\\r|\\t|\\v)/gm;
var removeUnescaped = function(value) {
    return decodeURIComponent(value).replace(UNESCAPED_CHARS, "");
};
var clamp = function(lower, upper, n) {
    return Math.min(Math.max(lower, n), upper);
};
function clampPrecisionArg(precision) {
    return clamp(0, 8, precision);
}
var formatNumber = function(num, decimals) {
    if (typeof num !== "number") {
        return num;
    }
    if (typeof decimals !== "number" || decimals < 0) {
        return String(num);
    }
    return num.toFixed(clampPrecisionArg(Math.floor(decimals)));
};
var CSS_CLASS = /\.-?[_a-zA-Z]+[_a-zA-Z0-9-]*/g;
var WHITE_SPACE = /\s+/g;
var replaceSelector = function(selector, styles) {
    return selector.replace(new RegExp(CSS_CLASS), function(match) {
        var segment = styles[match.replace(".", "")];
        if (!segment) return match;
        if (new RegExp(WHITE_SPACE).test(segment)) {
            var segmentSelector = segment.split(WHITE_SPACE).map(function(w) {
                return "." + w;
            }).join(",");
            return ":is(".concat(segmentSelector, ")");
        }
        return ".".concat(segment);
    });
};
function debounce(func) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _this = this;
    var timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        clearTimeout(timer);
        timer = setTimeout(function() {
            func.apply(_this, args);
        }, timeout);
    };
}
var EASING_FUNCTIONS = {
    linear: "linear",
    ease: "ease",
    "ease-in": "ease-in",
    "ease-out": "ease--out",
    "ease-in-out": "ease-in-out",
    "ease-in-sine": "cubic-bezier(0.12, 0, 0.39, 0)",
    "ease-out-sine": "cubic-bezier(0.61, 1, 0.88, 1)",
    "ease-in-out-sine": "cubic-bezier(0.37, 0, 0.63, 1)",
    "ease-in-quad": "cubic-bezier(0.11, 0, 0.5, 0)",
    "ease-out-quad": "cubic-bezier(0.5, 1, 0.89, 1)",
    "ease-in-out-quad": "cubic-bezier(0.45, 0, 0.55, 1)",
    "ease-in-cubic": "cubic-bezier(0.32, 0, 0.67, 0)",
    "ease-out-cubic": "cubic-bezier(0.33, 1, 0.68, 1)",
    "ease-in-out-cubic": "cubic-bezier(0.65, 0, 0.35, 1)",
    "ease-in-quart": "cubic-bezier(0.5, 0, 0.75, 0)",
    "ease-out-quart": "cubic-bezier(0.25, 1, 0.5, 1)",
    "ease-in-out-quart": "cubic-bezier(0.76, 0, 0.24, 1)",
    "ease-in-quint": "cubic-bezier(0.64, 0, 0.78, 0)",
    "ease-out-quint": "cubic-bezier(0.22, 1, 0.36, 1)",
    "ease-in-out-quint": "cubic-bezier(0.83, 0, 0.17, 1)",
    "ease-in-expo": "cubic-bezier(0.7, 0, 0.84, 0)",
    "ease-out-expo": "cubic-bezier(0.16, 1, 0.3, 1)",
    "ease-in-out-expo": "cubic-bezier(0.87, 0, 0.13, 1)",
    "ease-in-circ": "cubic-bezier(0.55, 0, 1, 0.45)",
    "ease-out-circ": "cubic-bezier(0, 0.55, 0.45, 1)",
    "ease-in-out-circ": "cubic-bezier(0.85, 0, 0.15, 1)",
    "ease-in-back": "cubic-bezier(0.36, 0, 0.66, -0.56)",
    "ease-out-back": "cubic-bezier(0.34, 1.56, 0.64, 1)",
    "ease-in-out-back": "cubic-bezier(0.68, -0.6, 0.32, 1.6)"
};
var isServer = "object" === "undefined";
var useLayoutEffect = isServer ? function() {
    return undefined;
} : react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect;
function useResizeObserver(ref, fn, options) {
    var _ref_current;
    var _$ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_0__.useState(((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.clientWidth) || 0), 2), prevWidth = _$ref[0], setPrevWidth = _$ref[1];
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var _ref_current;
        if ((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.clientWidth) {
            setPrevWidth(ref.current.clientWidth);
        }
    }, [
        ref
    ]);
    var observer = react__WEBPACK_IMPORTED_MODULE_0__.useMemo(function() {
        return isServer ? null : new ResizeObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (options === null || options === void 0 ? void 0 : options.onlyWidth) {
                if (prevWidth !== entry.contentRect.width) {
                    setPrevWidth(function() {
                        fn(entry);
                        return entry.contentRect.width;
                    });
                }
            } else {
                fn(entry);
            }
        });
    }, [
        fn,
        prevWidth,
        options === null || options === void 0 ? void 0 : options.onlyWidth
    ]);
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var target = ref.current;
        if (!target) return;
        observer === null || observer === void 0 ? void 0 : observer.observe(ref.current);
        return function() {
            return observer === null || observer === void 0 ? void 0 : observer.unobserve(target);
        };
    }, [
        ref,
        observer
    ]);
}
function isUrl(str) {
    if (!str) {
        return false;
    }
    if (str.indexOf('"') >= 0 || str.indexOf("'") >= 0) {
        return false;
    }
    return /((http|https):\/\/)?[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:/~+#-]*[\w@?^=%&amp;/~+#-])?/i.test(str.trim());
}
function isScriptPresent(regex) {
    return Array.from(document.scripts).reduce(function(isPresent, script) {
        return isPresent ? isPresent : regex.test(script.src);
    }, false);
}
function loadScript(src, options) {
    return new Promise(function(resolve, reject) {
        try {
            var ref = options !== null && options !== void 0 ? options : {}, _async = ref.async, async = _async === void 0 ? true : _async, _type = ref.type, type = _type === void 0 ? "text/javascript" : _type, _defer = ref.defer, defer = _defer === void 0 ? true : _defer, cacheRegex = ref.cacheRegex;
            if (!src) return reject({
                loaded: false,
                error: true,
                message: "No src provided"
            });
            if (cacheRegex && isScriptPresent(cacheRegex)) return resolve({
                loaded: true,
                error: false
            });
            var tag = document.createElement("script");
            var container = document.head || document.body;
            tag.type = type;
            tag.async = async;
            tag.src = src;
            tag.defer = defer;
            tag.addEventListener("load", function() {
                resolve({
                    loaded: true,
                    error: false
                });
            });
            tag.addEventListener("error", function() {
                reject({
                    loaded: false,
                    error: true,
                    message: "Failed to load script with src ".concat(src)
                });
            });
            container.appendChild(tag);
        } catch (error) {
            reject(error);
        }
    });
}
var KEY_CODES = {
    ARROW_LEFT: "ArrowLeft",
    ARROW_UP: "ArrowUp",
    ARROW_RIGHT: "ArrowRight",
    ARROW_DOWN: "ArrowDown",
    SPACE: " ",
    ENTER: "Enter",
    HOME: "Home",
    END: "End",
    TAB: "Tab"
};
function dispatchCustomEvent(element, eventName) {
    element.dispatchEvent(new CustomEvent(eventName, {
        bubbles: true,
        cancelable: true
    }));
}
function useClickOut(ref, action) {
    react__WEBPACK_IMPORTED_MODULE_0__.useEffect(function() {
        var handleClickOutside = function handleClickOutside(event) {
            var _ref_current;
            if ((_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(event.target)) return;
            action();
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        ref,
        action
    ]);
}
function extractElement(elements, type) {
    var extracted;
    function removeElementByType(_elements) {
        return _elements.map(function(element) {
            var /*#__PURE__*/ _React;
            if (!/*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_0__.isValidElement(element)) {
                return element;
            }
            if (element.type === type) {
                extracted = element;
                return null;
            }
            var children = removeElementByType(react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(element.props.children));
            return (_React = /*#__PURE__*/ (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache || (react__WEBPACK_IMPORTED_MODULE_0___namespace_cache = __webpack_require__.t(react__WEBPACK_IMPORTED_MODULE_0__, 2)))).cloneElement.apply(_React, [
                element,
                element.props
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(children)));
        });
    }
    var tree = removeElementByType(elements);
    return {
        extracted: extracted,
        tree: tree
    };
}


/***/ }),

/***/ 58830:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/parallax-video-asset-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var video = fields_config/* default.video */.Z.video;
var topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, restOfConfig = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "mobileTextAlign",
    "textAlign",
    "textColor"
]);
/* harmony default export */ var parallax_video_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Parallax Video",
    fields: {
        asset: video,
        scrollThreshold: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Parallax scroll threshold"
        },
        marginBetweenSections: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between sections"
        },
        marginBetweenColumns: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Minimum margin between columns"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Center full paragraph",
            fields: _object_spread({
                topic: topic,
                buttonConfig: buttonConfig,
                mobileTextAlign: mobileTextAlign,
                textAlign: textAlign,
                textColor: textColor
            }, restOfConfig)
        },
        leftColumn: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Left column",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: restOfConfig
            }
        },
        rightColumn: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Right column",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: restOfConfig
            }
        },
        columnMarginLeft: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Column margin left"
        },
        columnMarginRight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Column margin right"
        },
        videoBrightness: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video brightness (0-1)",
            defaultValue: "0.4"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/parallax-video-asset-advanced-config.js
function parallax_video_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function parallax_video_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            parallax_video_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var parallax_video_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(parallax_video_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/parallax-video-asset/index.js

var ParallaxVideoAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4449).then(__webpack_require__.bind(__webpack_require__, 4449));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4449)
            ];
        }
    }
});


/* harmony default export */ var parallax_video_asset = ({
    ParallaxVideoAssetComponent: ParallaxVideoAssetComponent,
    ParallaxVideoAssetConfig: parallax_video_asset_config,
    ParallaxVideoAssetAdvancedConfig: parallax_video_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-config.js
function fade_in_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fade_in_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fade_in_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fade_in_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fade_in_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fade_in_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var fade_in_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Fade In",
    fields: fade_in_asset_config_object_spread_props(fade_in_asset_config_object_spread({}, theme_config/* default */.Z), {
        backgroundAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Background image",
            fields: fields_config/* default */.Z
        },
        fadeInAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Fade-in image",
            fields: fade_in_asset_config_object_spread({
                height: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Height"
                }
            }, fields_config/* default */.Z)
        }
    })
});

// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/fade-in-asset-advanced-config.js
function fade_in_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fade_in_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fade_in_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fade_in_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fade_in_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fade_in_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var fade_in_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: fade_in_asset_advanced_config_object_spread_props(fade_in_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        startingPosition: {
            label: "Starting asset Y position (default is 0)",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        animationDuration: {
            label: "Animation duration (in seconds)",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        advancedAssetConfig: {
            label: "Advanced asset config",
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: advanced_field_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/fade-in-asset/index.js

var FadeInAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8285).then(__webpack_require__.bind(__webpack_require__, 88285));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88285)
            ];
        }
    }
});


/* harmony default export */ var fade_in_asset = ({
    FadeInAssetComponent: FadeInAssetComponent,
    FadeInAssetConfig: fade_in_asset_config,
    FadeInAssetAdvancedConfig: fade_in_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/video-background-asset-config.js
function video_background_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_background_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_background_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function video_background_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function video_background_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        video_background_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var video_background_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Video Background",
    fields: video_background_asset_config_object_spread_props(video_background_asset_config_object_spread({}, theme_config/* default */.Z), {
        isCentrilizeContent: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Centrilize Content"
        },
        fullParagraphConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragrapph",
            fields: video_background_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        assetConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: video_background_asset_config_object_spread({}, fields_config/* default */.Z)
        },
        addDarkOverlay: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Add Dark Overlay On Video"
        },
        hideBlackBars: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide Black Bars"
        },
        logosProps: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Add logos",
            conditionalKeyName: "useLogos",
            options: [
                {
                    text: "Yes",
                    fieldsConfig: video_background_asset_config_object_spread_props(video_background_asset_config_object_spread({}, logos_title_fields_config/* default */.Z), {
                        logos: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            label: "Logos",
                            fields: logos_fields_config/* default */.Z
                        }
                    })
                }
            ]
        },
        videoBorderRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Border Radius"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var logos_advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/video-background-asset-advanced-config.js
function video_background_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function video_background_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            video_background_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function video_background_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function video_background_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        video_background_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var video_background_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: video_background_asset_advanced_config_object_spread_props(video_background_asset_advanced_config_object_spread({
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        segmentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Height"
        },
        segmentMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Min Height"
        },
        segmentMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Max Height"
        },
        videoPlayerWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Width"
        },
        videoPlayerMinWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Min Width"
        },
        videoPlayerHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Height"
        },
        videoPlayerPositionTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Position Top"
        },
        videoPlayerPositionLeft: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Player Position Left"
        },
        logosBottomMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Logos Bottom Margin"
        }
    }, shared_advanced_fields_config/* default */.ZP), {
        paragraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Props",
            fields: video_background_asset_advanced_config_object_spread_props(video_background_asset_advanced_config_object_spread({}, advanced_fields_config/* default */.Z), {
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin Top"
                },
                marginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin Bottom"
                }
            })
        },
        topLogosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: {
                textAndLogosMargin: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Space between text and logo"
                },
                logosAdvancedProps: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Logos Advanced Props",
                    fields: logos_advanced_fields_config/* default */.Z
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/video-background-asset/index.js



var VideoBackgroundAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(9754)]).then(__webpack_require__.bind(__webpack_require__, 94929));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94929)
            ];
        }
    }
});
/* harmony default export */ var video_background_asset = ({
    VideoBackgroundAssetComponent: VideoBackgroundAssetComponent,
    VideoBackgroundAssetConfig: video_background_asset_config,
    VideoBackgroundAssetAdvancedConfig: video_background_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-config.js
function carousel_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var carousel_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel",
    fields: carousel_asset_config_object_spread({
        disableCenterModeStyle: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable center mode style"
        },
        imageHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images height"
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images horizontal padding"
        },
        transitionSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Slides transition speed (in miliseconds)"
        }
    }, carousel_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/advanced-fields-config.js
var carousel_advanced_fields_config = __webpack_require__(1270);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/carousel-asset-advanced-config.js
function carousel_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var carousel_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_asset_advanced_config_object_spread({}, carousel_advanced_fields_config/* default */.Z, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/carousel-asset/index.js



var CarouselAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4387).then(__webpack_require__.bind(__webpack_require__, 64387));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64387)
            ];
        }
    }
});
/* harmony default export */ var carousel_asset = ({
    CarouselAssetComponent: CarouselAssetComponent,
    CarouselAssetConfig: carousel_asset_config,
    CarouselAssetAdvancedConfig: carousel_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/fields-config.js
var selectable_tags_grid_fields_config = __webpack_require__(1117);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/vertical-tags-with-images-asset-config.js
function vertical_tags_with_images_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tags_with_images_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tags_with_images_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var vertical_tags_with_images_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Vertical Tags with images",
    fields: vertical_tags_with_images_asset_config_object_spread({
        paragraphText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Fold paragraph",
            fields: vertical_tags_with_images_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        firstStateText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "First state paragraph",
            fields: vertical_tags_with_images_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        }
    }, selectable_tags_grid_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/vertical-tags-with-images-asset-advanced-config.js
function vertical_tags_with_images_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tags_with_images_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tags_with_images_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function vertical_tags_with_images_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function vertical_tags_with_images_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        vertical_tags_with_images_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var vertical_tags_with_images_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: vertical_tags_with_images_asset_advanced_config_object_spread_props(vertical_tags_with_images_asset_advanced_config_object_spread({
        withFirstStateArrow: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show first state arrow"
        },
        paragraphTagsPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Padding between Text and Tags"
        }
    }, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.ZP, paragraph_advanced_fields_config/* default */.Z), {
        titleWidth: title_advanced_field_config/* default.titleWidth */.Z.titleWidth
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/vertical-tags-with-images-asset/index.js



var VerticalTagsWithImagesAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5187).then(__webpack_require__.bind(__webpack_require__, 35187));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35187)
            ];
        }
    }
});
/* harmony default export */ var vertical_tags_with_images_asset = ({
    VerticalTagsWithImagesAssetComponent: VerticalTagsWithImagesAssetComponent,
    VerticalTagsWithImagesAssetConfig: vertical_tags_with_images_asset_config,
    VerticalTagsWithImagesAssetAdvancedConfig: vertical_tags_with_images_asset_advanced_config
});

// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/images-carousel-with-tags-grid-asset-config.js
function images_carousel_with_tags_grid_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_carousel_with_tags_grid_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_carousel_with_tags_grid_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var images_carousel_with_tags_grid_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Images Carousel With Tags Grid",
    fields: images_carousel_with_tags_grid_asset_config_object_spread({
        paragraphText: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: images_carousel_with_tags_grid_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z)
        },
        defaultImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Default image",
            fields: images_carousel_with_tags_grid_asset_config_object_spread({}, fields_config/* default.image.fields */.Z.image.fields)
        },
        showDefaultInGallery: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show default image in gallery"
        },
        tagsAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }, selectable_tags_grid_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/images-carousel-with-tags-grid-asset-advanced-config.js
function images_carousel_with_tags_grid_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_carousel_with_tags_grid_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_carousel_with_tags_grid_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function images_carousel_with_tags_grid_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function images_carousel_with_tags_grid_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        images_carousel_with_tags_grid_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var images_carousel_with_tags_grid_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: images_carousel_with_tags_grid_asset_advanced_config_object_spread_props(images_carousel_with_tags_grid_asset_advanced_config_object_spread({
        paragraphTagsPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Padding between Text and Tags"
        }
    }, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.ZP, paragraph_advanced_fields_config/* default */.Z), {
        titleWidth: title_advanced_field_config/* default.titleWidth */.Z.titleWidth
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/images-carousel-with-tags-grid-asset/index.js



var ImagesCarouselWithTagsGridAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4222), __webpack_require__.e(1059)]).then(__webpack_require__.bind(__webpack_require__, 71059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71059)
            ];
        }
    }
});
/* harmony default export */ var images_carousel_with_tags_grid_asset = ({
    ImagesCarouselWithTagsGridAssetComponent: ImagesCarouselWithTagsGridAssetComponent,
    ImagesCarouselWithTagsGridAssetConfig: images_carousel_with_tags_grid_asset_config,
    ImagesCarouselWithTagsGridAssetAdvancedConfig: images_carousel_with_tags_grid_asset_advanced_config
});

// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/fields-config.js
var youtube_video_with_poster_fields_config = __webpack_require__(93494);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-config.js
function embedded_youtube_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_youtube_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_youtube_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function embedded_youtube_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function embedded_youtube_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        embedded_youtube_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var embedded_youtube_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Embedded Youtube",
    fields: embedded_youtube_asset_config_object_spread_props(embedded_youtube_asset_config_object_spread({}, theme_config/* default */.Z, youtube_video_with_poster_fields_config/* default */.Z), {
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/embedded-youtube-asset-advanced-config.js
function embedded_youtube_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_youtube_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_youtube_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function embedded_youtube_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function embedded_youtube_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        embedded_youtube_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var embedded_youtube_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: embedded_youtube_asset_advanced_config_object_spread_props(embedded_youtube_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/embedded-youtube-asset/index.js



var EmbeddedYoutubeAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1977).then(__webpack_require__.bind(__webpack_require__, 11977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11977)
            ];
        }
    }
});
/* harmony default export */ var embedded_youtube_asset = ({
    EmbeddedYoutubeAssetComponent: EmbeddedYoutubeAssetComponent,
    EmbeddedYoutubeAssetConfig: embedded_youtube_asset_config,
    EmbeddedYoutubeAssetAdvancedConfig: embedded_youtube_asset_advanced_config
});

// EXTERNAL MODULE: ./constants/video-types.js
var video_types = __webpack_require__(39832);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/youtube-video-asset-config.js
function youtube_video_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_video_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_video_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_video_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var youtube_video_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube Video Popup",
    fields: youtube_video_asset_config_object_spread_props(youtube_video_asset_config_object_spread({}, theme_config/* default */.Z), {
        backgroundImg: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            defaultImagesKeys: [],
            label: "Select an image placeholder"
        },
        alt: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Description (alt)",
            translatable: true
        },
        videoPlaceholder: {
            type: template_field_type.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
            label: "Video placeholder",
            labelDescription: "Using this will override the image placeholder",
            videoType: video_types/* PARAGRAPH_AND_ASSET_VIDEOS */.rB
        },
        videoId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video ID"
        }
    })
});

// EXTERNAL MODULE: ./constants/cloudinary-asset-qualities.js
var cloudinary_asset_qualities = __webpack_require__(65832);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/youtube-video-asset-advanced-config.js
function youtube_video_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_video_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_video_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_video_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_video_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_video_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var youtube_video_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_video_asset_advanced_config_object_spread_props(youtube_video_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        assetQuality: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Asset Quality",
            options: [
                {
                    value: cloudinary_asset_qualities.AUTO,
                    text: "Auto"
                },
                {
                    value: cloudinary_asset_qualities.BEST,
                    text: "Best"
                },
                {
                    value: cloudinary_asset_qualities.GOOD,
                    text: "Good"
                },
                {
                    value: cloudinary_asset_qualities.ECO,
                    text: "Eco"
                },
                {
                    value: cloudinary_asset_qualities.LOW,
                    text: "Low"
                }
            ]
        },
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in desktop (% only)"
        },
        mobileWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset width in mobile (% only)"
        },
        fullWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable maximum width limitation (1440px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/youtube-video-asset/index.js



var YoutubeVideoAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9313).then(__webpack_require__.bind(__webpack_require__, 49313));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49313)
            ];
        }
    }
});
/* harmony default export */ var youtube_video_asset = ({
    YoutubeVideoAssetComponent: YoutubeVideoAssetComponent,
    YoutubeVideoAssetConfig: youtube_video_asset_config,
    YoutubeVideoAssetAdvancedConfig: youtube_video_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/asset/layouts/regular-asset/index.js + 2 modules
var regular_asset = __webpack_require__(95660);
;// CONCATENATED MODULE: ./segments/desktop/asset/layouts/index.js
// plop_marker:layouts_import









/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ParallaxVideoAsset: parallax_video_asset,
    FadeInAsset: fade_in_asset,
    VideoBackgroundAsset: video_background_asset,
    CarouselAsset: carousel_asset,
    VerticalTagsWithImagesAsset: vertical_tags_with_images_asset,
    ImagesCarouselWithTagsGridAsset: images_carousel_with_tags_grid_asset,
    EmbeddedYoutubeAsset: embedded_youtube_asset,
    YoutubeVideoAsset: youtube_video_asset,
    RegularAsset: regular_asset/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/asset/index.js

var ParallaxVideoAsset = layouts.ParallaxVideoAsset, FadeInAsset = layouts.FadeInAsset, VideoBackgroundAsset = layouts.VideoBackgroundAsset, CarouselAsset = layouts.CarouselAsset, VerticalTagsWithImagesAsset = layouts.VerticalTagsWithImagesAsset, ImagesCarouselWithTagsGridAsset = layouts.ImagesCarouselWithTagsGridAsset, EmbeddedYoutubeAsset = layouts.EmbeddedYoutubeAsset, YoutubeVideoAsset = layouts.YoutubeVideoAsset, RegularAsset = layouts.RegularAsset;
/* harmony default export */ var asset = ({
    // plop_marker:segment_index_add_layout
    ParallaxVideoAssetComponent: {
        type: "ParallaxVideoAssetComponent",
        title: "Parallax Video",
        imgSrc: "/static/img/segments/layouts/parallax-video-asset.png",
        config: ParallaxVideoAsset.ParallaxVideoAssetConfig,
        advancedConfig: ParallaxVideoAsset.ParallaxVideoAssetAdvancedConfig,
        component: ParallaxVideoAsset.ParallaxVideoAssetComponent
    },
    FadeInAssetComponent: {
        type: "FadeInAssetComponent",
        title: "Fade In",
        imgSrc: "/static/img/segments/layouts/fade-in-asset.png",
        config: FadeInAsset.FadeInAssetConfig,
        advancedConfig: FadeInAsset.FadeInAssetAdvancedConfig,
        component: FadeInAsset.FadeInAssetComponent
    },
    VideoBackgroundAssetComponent: {
        type: "VideoBackgroundAssetComponent",
        title: "Video Background",
        imgSrc: "/static/img/segments/layouts/video-background-asset.png",
        config: VideoBackgroundAsset.VideoBackgroundAssetConfig,
        advancedConfig: VideoBackgroundAsset.VideoBackgroundAssetAdvancedConfig,
        component: VideoBackgroundAsset.VideoBackgroundAssetComponent
    },
    CarouselAssetComponent: {
        type: "CarouselAssetComponent",
        title: "Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-asset.png",
        config: CarouselAsset.CarouselAssetConfig,
        advancedConfig: CarouselAsset.CarouselAssetAdvancedConfig,
        component: CarouselAsset.CarouselAssetComponent
    },
    VerticalTagsWithImagesAssetComponent: {
        type: "VerticalTagsWithImagesAssetComponent",
        title: "Vertical Tags With Images",
        imgSrc: "/static/img/segments/layouts/vertical-tags-with-images-asset.png",
        config: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetConfig,
        advancedConfig: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetAdvancedConfig,
        component: VerticalTagsWithImagesAsset.VerticalTagsWithImagesAssetComponent
    },
    ImagesCarouselWithTagsGridAssetComponent: {
        type: "ImagesCarouselWithTagsGridAssetComponent",
        title: "Images Carousel With Tags Grid",
        imgSrc: "/static/img/segments/layouts/images-carousel-with-tags-grid-asset.png",
        config: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetConfig,
        advancedConfig: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetAdvancedConfig,
        component: ImagesCarouselWithTagsGridAsset.ImagesCarouselWithTagsGridAssetComponent
    },
    EmbeddedYoutubeAssetComponent: {
        type: "EmbeddedYoutubeAssetComponent",
        title: "Embedded Youtube",
        imgSrc: "/static/img/segments/layouts/embedded-youtube-asset.png",
        config: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetConfig,
        advancedConfig: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetAdvancedConfig,
        component: EmbeddedYoutubeAsset.EmbeddedYoutubeAssetComponent
    },
    YoutubeVideoAssetComponent: {
        type: "YoutubeVideoAssetComponent",
        title: "Youtube Video Popup",
        imgSrc: "/static/img/segments/layouts/youtube-video-asset.png",
        config: YoutubeVideoAsset.YoutubeVideoAssetConfig,
        advancedConfig: YoutubeVideoAsset.YoutubeVideoAssetAdvancedConfig,
        component: YoutubeVideoAsset.YoutubeVideoAssetComponent
    },
    RegularAssetComponent: {
        type: "RegularAssetComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-asset.png",
        config: RegularAsset.RegularAssetConfig,
        advancedConfig: RegularAsset.RegularAssetAdvancedConfig,
        component: RegularAsset.RegularAssetComponent
    }
});


/***/ }),

/***/ 24646:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ blog; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-config.js

/* harmony default export */ var rich_text_blog_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rich Text",
    fields: {
        body: {
            type: template_field_type.FIELD_TYPES.RICH_TEXT,
            label: "Body"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/rich-text-blog-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var rich_text_blog_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Blog width in desktop (% only)"
        },
        align: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Alignment",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/rich-text-blog/index.js



var RichTextBlogComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1905).then(__webpack_require__.bind(__webpack_require__, 41905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(41905)
            ];
        }
    }
});
/* harmony default export */ var rich_text_blog = ({
    RichTextBlogComponent: RichTextBlogComponent,
    RichTextBlogConfig: rich_text_blog_config,
    RichTextBlogAdvancedConfig: rich_text_blog_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/blog/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    RichTextBlog: rich_text_blog
});

;// CONCATENATED MODULE: ./segments/desktop/blog/index.js

var RichTextBlog = layouts.RichTextBlog;
/* harmony default export */ var blog = ({
    // plop_marker:segment_index_add_layout
    RichTextBlogComponent: {
        type: "RichTextBlogComponent",
        title: "Rich Text",
        imgSrc: "/static/img/segments/layouts/rich-text-blog.png",
        config: RichTextBlog.RichTextBlogConfig,
        advancedConfig: RichTextBlog.RichTextBlogAdvancedConfig,
        component: RichTextBlog.RichTextBlogComponent
    }
});


/***/ }),

/***/ 3993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_button; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 7 modules
var fields_config = __webpack_require__(59440);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/basic-button-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var basic_button_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Basic Button",
    description: "Mind tests on signup form component",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        textAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Button Align",
            options: [
                {
                    value: "left",
                    text: "Left"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "right",
                    text: "Right"
                }
            ]
        },
        buttonConfig: fields_config/* default */.Z
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/basic-button-advanced-config.js
function basic_button_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function basic_button_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            basic_button_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var basic_button_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: basic_button_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/button/layouts/basic-button/index.js



var BasicButtonComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6988).then(__webpack_require__.bind(__webpack_require__, 16988));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16988)
            ];
        }
    }
});
/* harmony default export */ var basic_button = ({
    BasicButtonComponent: BasicButtonComponent,
    BasicButtonConfig: basic_button_config,
    BasicButtonAdvancedConfig: basic_button_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/button/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    BasicButton: basic_button
});

;// CONCATENATED MODULE: ./segments/desktop/button/index.js

var BasicButton = layouts.BasicButton;
/* harmony default export */ var desktop_button = ({
    // plop_marker:segment_index_add_layout
    BasicButtonComponent: {
        type: "BasicButtonComponent",
        title: "Basic",
        imgSrc: "/static/img/segments/layouts/basic-button.png",
        config: BasicButton.BasicButtonConfig,
        advancedConfig: BasicButton.BasicButtonAdvancedConfig,
        component: BasicButton.BasicButtonComponent
    }
});


/***/ }),

/***/ 33960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ careers; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/positions-careers/positions-careers-config.js
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var topic = full_paragraph_fields_config/* default.topic */.Z.topic, bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, fullParagraphConfig = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "bodyColor",
    "textColor"
]);
/* harmony default export */ var positions_careers_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Positions",
    fields: {
        emptyState: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Empty state",
            fields: {
                asset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: fields_config/* default */.Z
                },
                fullParagraph: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Full paragraph",
                    fields: fullParagraphConfig
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/positions-careers/positions-careers-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var positions_careers_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        emptyStateAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Empty state advanced config",
            fields: {
                assetAdvancedConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: advanced_field_config/* default */.Z
                },
                fullParagraphAdvancedConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Full paragraph",
                    fields: advanced_fields_config/* default */.Z
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./server/extensions/error-extensions.js
var error_extensions = __webpack_require__(5004);
// EXTERNAL MODULE: ./server/services/bigbrain-tracking-service/bigbrain-tracking-service.js
var bigbrain_tracking_service = __webpack_require__(75422);
// EXTERNAL MODULE: ./constants/bigbrain-event-types.js
var bigbrain_event_types = __webpack_require__(65023);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/positions-careers/positions-careers-dynamics-fetch.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}





var POSITION_TYPE_CATEGORY_NAME = "Publish Position";
var POSITION_TYPE_INTERNAL_VALUE = "Internal Career Site";
var POSITION_TYPE_INTERNAL = "internal";
var POSITION_TYPE_ALL = "all"; // Show both internal and external positions
var POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE = "Both";
var COMEET_COMPANY_UID = "41.00B"; // Used also in client side - fix
var COMEET_END_POINT = "https://www.comeet.co/careers-api/2.0/company/".concat(COMEET_COMPANY_UID, "/positions");
var getDataFromComeet = function() {
    var _ref = _async_to_generator(function() {
        var positionId, get, ref, COMEET_TOKEN, COMEET_PARAMS, url, options, response;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    positionId = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : null;
                    get = (__webpack_require__(61217).get);
                    return [
                        4,
                        get("comeet")
                    ];
                case 1:
                    ref = _state.sent(), COMEET_TOKEN = ref.api_token;
                    COMEET_PARAMS = "?token=".concat(COMEET_TOKEN, "&details=true");
                    url = positionId ? "".concat(COMEET_END_POINT, "/").concat(positionId).concat(COMEET_PARAMS) : "".concat(COMEET_END_POINT).concat(COMEET_PARAMS);
                    options = {
                        insecureHTTPParser: true
                    };
                    return [
                        4,
                        (0,bigbrain_tracking_service.trackBigBrainEventOnServer)(bigbrain_event_types.CAREER_POSITIONS_RETRIEVE_FROM_COMEET, {
                            kind: positionId ? "single_position" : "all_positions",
                            info1: positionId
                        })
                    ];
                case 2:
                    _state.sent();
                    return [
                        4,
                        fetch(url, options)
                    ];
                case 3:
                    response = _state.sent();
                    return [
                        4,
                        response.json()
                    ];
                case 4:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return function getDataFromComeet() {
        return _ref.apply(this, arguments);
    };
}();
var getPublishCategoryValue = function(position) {
    var publishCategory = position === null || position === void 0 ? void 0 : position.categories.find(function(category) {
        return category.name === POSITION_TYPE_CATEGORY_NAME;
    });
    return publishCategory && publishCategory.value;
};
var isPositionRelevantToType = function(position, positionsType) {
    var isMondayEmployee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var publishCategoryValue = getPublishCategoryValue(position);
    return publishedPositionFitsType(publishCategoryValue, positionsType, isMondayEmployee);
};
var publishedPositionFitsType = function(publishCategoryValue, requestedPositionsType) {
    var isMondayEmployee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    // If requesting all positions, show everything (both internal and external)
    if (requestedPositionsType === POSITION_TYPE_ALL) {
        return true;
    }
    if (requestedPositionsType === POSITION_TYPE_INTERNAL && publishCategoryValue) {
        return publishCategoryValue === POSITION_TYPE_INTERNAL_AND_EXTERNAL_VALUE || publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE;
    }
    // For external positions - show all external positions, plus internal-only to Monday employees
    if (publishCategoryValue === POSITION_TYPE_INTERNAL_VALUE) {
        return isMondayEmployee; // Show internal-only positions only to Monday employees
    }
    // Show all other positions (external, "Both", and any other values) to everyone
    return true;
};
var filterByPositionType = function(allPositionsData, positionsType) {
    var isMondayEmployee = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    return allPositionsData.filter(function(position) {
        return isPositionRelevantToType(position, positionsType, isMondayEmployee);
    });
};
var getPositions = function() {
    var _ref = _async_to_generator(function(query) {
        var req, res, rawPositionsType, positionsType, isMondayEmployee, getCookie, lastLoginAccount, allPositionsData, e;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : null, res = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : null;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    rawPositionsType = query.positionsType;
                    positionsType = rawPositionsType || "external";
                    isMondayEmployee = false;
                    // Read Monday employee status from cookies if req/res are available
                    if (req && res) {
                        try {
                            getCookie = (__webpack_require__(47041).getCookie);
                            lastLoginAccount = getCookie(cookies.LAST_ACCOUNT_SLUG, {
                                req: req,
                                res: res
                            });
                            isMondayEmployee = lastLoginAccount === "monday";
                        } catch (error) {
                        // Cookie reading failed, isMondayEmployee remains false
                        }
                    }
                    return [
                        4,
                        getDataFromComeet()
                    ];
                case 2:
                    allPositionsData = _state.sent();
                    if (!allPositionsData || allPositionsData.ERROR) {
                        throw new error_extensions.InternalServerError("error fetching positions data");
                    }
                    return [
                        2,
                        filterByPositionType(allPositionsData, positionsType, isMondayEmployee)
                    ];
                case 3:
                    e = _state.sent();
                    esm_exports/* captureException */.Tb(e);
                    esm_exports/* captureMessage */.uT("Failed to fetch career positions from Comeet");
                    return [
                        2,
                        []
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function getPositions(query) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var positions_careers_dynamics_fetch = ([
    {
        propsPropertyName: "positions",
        shouldFetch: function() {
            return false;
        },
        fetch: function() {
            var _ref = _async_to_generator(function(param) {
                var query, req, res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            query = param.query, req = param.req, res = param.res;
                            return [
                                4,
                                getPositions(query, req, res)
                            ];
                        case 1:
                            return [
                                2,
                                _state.sent()
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/positions-careers/index.js

var PositionsCareersComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(9432), __webpack_require__.e(1036), __webpack_require__.e(9949), __webpack_require__.e(945), __webpack_require__.e(8113), __webpack_require__.e(869)]).then(__webpack_require__.bind(__webpack_require__, 50869));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50869)
            ];
        }
    }
});



/* harmony default export */ var positions_careers = ({
    PositionsCareersComponent: PositionsCareersComponent,
    PositionsCareersConfig: positions_careers_config,
    PositionsCareersAdvancedConfig: positions_careers_advanced_config,
    PositionsCareersDynamicFetch: positions_careers_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/search-bar-careers-config.js

/* harmony default export */ var search_bar_careers_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "First Fold",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/search-bar-careers-advanced-config.js
function search_bar_careers_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function search_bar_careers_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            search_bar_careers_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var search_bar_careers_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: search_bar_careers_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/search-bar-careers/index.js



var SearchBarCareersComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3714), __webpack_require__.e(9432), __webpack_require__.e(1036), __webpack_require__.e(9949), __webpack_require__.e(945), __webpack_require__.e(8113), __webpack_require__.e(5544)]).then(__webpack_require__.bind(__webpack_require__, 35544));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(35544)
            ];
        }
    }
});
/* harmony default export */ var search_bar_careers = ({
    SearchBarCareersComponent: SearchBarCareersComponent,
    SearchBarCareersConfig: search_bar_careers_config,
    SearchBarCareersAdvancedConfig: search_bar_careers_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/careers/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    PositionsCareers: positions_careers,
    SearchBarCareers: search_bar_careers
});

;// CONCATENATED MODULE: ./segments/desktop/careers/index.js

var PositionsCareers = layouts.PositionsCareers, SearchBarCareers = layouts.SearchBarCareers;
/* harmony default export */ var careers = ({
    // plop_marker:segment_index_add_layout
    PositionsCareersComponent: {
        type: "PositionsCareersComponent",
        title: "Positions",
        imgSrc: "/static/img/segments/layouts/positions-careers.png",
        config: PositionsCareers.PositionsCareersConfig,
        advancedConfig: PositionsCareers.PositionsCareersAdvancedConfig,
        component: PositionsCareers.PositionsCareersComponent,
        dynamicsFetch: PositionsCareers.PositionsCareersDynamicFetch
    },
    SearchBarCareersComponent: {
        type: "SearchBarCareersComponent",
        title: "Search Bar Careers",
        imgSrc: "/static/img/segments/layouts/search-bar-careers.png",
        config: SearchBarCareers.SearchBarCareersConfig,
        advancedConfig: SearchBarCareers.SearchBarCareersAdvancedConfig,
        component: SearchBarCareers.SearchBarCareersComponent
    }
});


/***/ }),

/***/ 55209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    tabs: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 5,
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: {
                label: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                isMainTab: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
                    label: "Main Work-OS tab"
                },
                color: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
                    label: "Color"
                },
                tabImage: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Tab image"
                },
                tabImageSelected: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Tab Hover image"
                },
                asset: {
                    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: _object_spread({}, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)
                }
            }
        }
    }
});


/***/ }),

/***/ 24662:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    tagImg: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Image Tag",
        fields: {
            src: {
                type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select a Tag Image"
            }
        }
    },
    link: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Link"
    },
    tagText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Tag Text",
        translatable: true
    }
});


/***/ }),

/***/ 1270:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    itemScale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Item scale"
    },
    defaultIndex: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Default slide index"
    },
    swipeToSlide: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Swipe to slide"
    },
    pauseOnFocus: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Pause on focus"
    },
    showFocusEffect: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Show focus effect"
    },
    lazyLoad: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Lazy load slides"
    }
});


/***/ }),

/***/ 32377:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    height: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Height"
    },
    borderWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Border Width"
    },
    borderColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Border Color"
    },
    hideScrolling: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Hide scrollbars"
    }
});


/***/ }),

/***/ 53315:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    logosScale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Logos scale"
    },
    useSingleLine: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Single Line Layout"
    },
    paddingInlined: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Horizontal padding"
    },
    maxWidth: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Max width"
    }
});


/***/ }),

/***/ 97909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83971);


/* harmony default export */ __webpack_exports__["Z"] = ({
    numberOfCompanies: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Number Of Companies",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .SUPPORTED_LOGOS_NUMBER_OPTIONS */ .ly
    },
    companyField: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Company Field",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_COMPANY_FIELDS */ .QS
    },
    country: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Country",
        options: segments_desktop_core_components_logos_logos_const__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_COMPANY_COUNTRIES */ .kZ
    },
    personalizeUsingVisitorCountry: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Personalize using visitor's country"
    },
    grayscale: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Color",
        options: [
            {
                value: true,
                text: "B&W"
            },
            {
                value: false,
                text: "Normal"
            }
        ]
    }
});


/***/ }),

/***/ 81828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ({
    name: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Name"
    },
    jobDescription: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Job Description",
        textArea: true,
        translatable: true
    },
    color: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Text Color"
    }
});


/***/ }),

/***/ 82778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95947);
/* harmony import */ var _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13225);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    tagText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    tagSubtitleText: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Tag Subtitle Text",
        translatable: true
    },
    tagBackgroundColor: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Color",
        possibleColors: _constants_color_picker_constants__WEBPACK_IMPORTED_MODULE_1__.tagsSupportedColors
    },
    tagValue: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Key (DEPRECATED)",
        labelDescription: "Will be removed (copy to use case key)"
    },
    overridePageCluster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.CLUSTERS,
        label: "Cluster key",
        labelDescription: "Key which represents the selected tag cluster"
    },
    overridePageSubCluster: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.SUB_CLUSTERS,
        label: "Use Case key",
        labelDescription: "Key which represents the selected tag use case"
    },
    galleryImage: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Gallery image",
        labelDescription: "Images carousel component related only",
        fields: _object_spread({}, components_core_asset_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"].image.fields */ .Z.image.fields)
    },
    initiallySelected: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Initially selected"
    }
});


/***/ }),

/***/ 33129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54237);
/* harmony import */ var segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6690);



/* harmony default export */ __webpack_exports__["Z"] = ({
    withSecondaryButton: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With secondary button"
    },
    secondaryButtonConfig: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Secondary button",
        fields: segments_desktop_core_components_button_secondary_button_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },
    withYouTubeButton: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "With youtube button"
    },
    youTubeButtonConfig: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "YouTube button",
        fields: segments_desktop_core_components_button_youtube_popup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    },
    useMobileClusterTags: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Use mobile cluster tags"
    },
    sendClustersAsParams: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Send clusters as params"
    },
    clusterVariant: {
        type: _constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Cluster variant (with_benefits / with_ready)"
    }
});


/***/ }),

/***/ 1117:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_selectable_tag_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82778);
/* harmony import */ var segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96587);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60633);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), {
    darkMode: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
        label: "Dark mode"
    },
    width: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Max Width (%)"
    },
    gridSelectableTags: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Grid Selectable Tags",
        nestedConfig: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            fields: _object_spread({}, segments_desktop_core_components_selectable_tag_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)
        }
    },
    buttonConfig: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
        label: "Signup button config",
        fields: segments_desktop_core_components_button_signup_button_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
    },
    buttonTopMargin: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
        label: "Margin above button (default 32px)"
    }
}));


/***/ }),

/***/ 91841:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7484);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65832);


/* harmony default export */ __webpack_exports__["Z"] = ({
    contentClassName: "",
    swapTextAndAssetPosition: false,
    leftSizeWidth: null,
    rightSizeWidth: null,
    background: {},
    fullParagraph: segments_desktop_core_components_full_paragraph_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z,
    asset: {
        position: "center",
        fitToContainer: true,
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/f_auto,q_auto/remote_mondaycom_static/img/segment-layout-default-images/text-and-asset/board-with-dragged-column-in-circle.png"
        }
    },
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_1__.AUTO,
    withDynamicParagraphTitle: false,
    withDynamicParagraphSubtitle: false
});


/***/ }),

/***/ 59526:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(13211);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(861);
/* harmony import */ var _components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(24961);
/* harmony import */ var _services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95470);
/* harmony import */ var constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(65023);
/* harmony import */ var _side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99024);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91841);






function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}










var FULL_WIDTH = "100%";
var SideBySideTextAndAsset = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(SideBySideTextAndAsset, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(SideBySideTextAndAsset);
    function SideBySideTextAndAsset() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(this, SideBySideTextAndAsset);
        var _this;
        _this = _super.call.apply(_super, [
            this
        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(args)));
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "assetExist", function(asset) {
            var _asset_image, _asset_video;
            return (asset === null || asset === void 0 ? void 0 : (_asset_image = asset.image) === null || _asset_image === void 0 ? void 0 : _asset_image.src) || (asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : _asset_video.src);
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "onVideoStart", function() {
            var _asset_video_src_formats, _asset_video_src, _asset_video;
            var asset = _this.props.asset;
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.ASSET_COMPONENT_VIDEO_STARTED, {
                info1: asset === null || asset === void 0 ? void 0 : (_asset_video = asset.video) === null || _asset_video === void 0 ? void 0 : (_asset_video_src = _asset_video.src) === null || _asset_video_src === void 0 ? void 0 : (_asset_video_src_formats = _asset_video_src.formats) === null || _asset_video_src_formats === void 0 ? void 0 : _asset_video_src_formats[0]
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "renderAsset", function(asset) {
            var _props = _this.props, ReplaceAssetComponent = _props.replaceAssetComponent, replaceAssetComponentProps = _props.replaceAssetComponentProps, assetQuality = _props.assetQuality, useDynamicAsset = _props.useDynamicAsset, hideControls = _props.hideControls, useWindowMask = _props.useWindowMask, dynamicAssetParamPath = _props.dynamicAssetParamPath;
            if (ReplaceAssetComponent) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceAssetComponent, _object_spread({}, replaceAssetComponentProps));
            }
            var fitToContainer = asset.fitToContainer, assetHeight = asset.assetHeight, assetRestProps = _object_without_properties(asset, [
                "fitToContainer",
                "assetHeight"
            ]);
            var assetClassName = classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-asset", {
                "ignore-parent-height": !fitToContainer
            });
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_asset_asset_component__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _object_spread_props(_object_spread({}, assetRestProps), {
                assetQuality: assetQuality,
                useDynamicAsset: useDynamicAsset,
                hideControls: hideControls,
                useWindowMask: useWindowMask,
                dynamicAssetParamPath: dynamicAssetParamPath,
                convertGifToVideo: true,
                className: assetClassName,
                imageClassName: "text-and-asset-image",
                style: {
                    height: assetHeight
                },
                onStart: _this.onVideoStart
            }));
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getFullParagraphComponentStyle", function() {
            var _props = _this.props, leftSizeWidth = _props.leftSizeWidth, nestedBoardItems = _props.nestedBoardItems;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, fullParagraphMarginTop = ref.fullParagraphMarginTop, fullParagraphMarginBottom = ref.fullParagraphMarginBottom, fullParagraphDistanceFromTop = ref.fullParagraphDistanceFromTop, parallaxAsset = ref.parallaxAsset;
            var styleObj = {
                width: leftSizeWidth,
                marginTop: fullParagraphMarginTop,
                marginBottom: fullParagraphMarginBottom
            };
            if (_this.assetExist(parallaxAsset)) {
                styleObj = _object_spread_props(_object_spread({}, styleObj), {
                    top: fullParagraphDistanceFromTop
                });
            }
            return styleObj;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getImageWrapperStyle", function() {
            var _props = _this.props, rightSizeWidth = _props.rightSizeWidth, allowImageOverflow = _props.allowImageOverflow;
            var style = {
                width: rightSizeWidth
            };
            if (allowImageOverflow) {
                style = _object_spread_props(_object_spread({}, style), {
                    overflow: "visible"
                });
            }
            return style;
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "openLiveBoardExperience", function() {
            var _props = _this.props, nestedBoardItems = _props.nestedBoardItems, openLiveBoard = _props.openLiveBoard;
            var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, boardBannerText = ref.boardBannerText, embeddedBoardTitle = ref.embeddedBoardTitle, addSecondLiveBoardSignUpButton = ref.addSecondLiveBoardSignUpButton, liveBoardToolTipText = ref.liveBoardToolTipText;
            openLiveBoard({
                boardBannerText: boardBannerText,
                embeddedBoardTitle: embeddedBoardTitle,
                addSecondLiveBoardSignUpButton: addSecondLiveBoardSignUpButton,
                liveBoardToolTipText: liveBoardToolTipText
            });
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "imageClicked", function(index) {
            (0,_services_bigbrain_service__WEBPACK_IMPORTED_MODULE_6__.trackEvent)(constants_bigbrain_event_types__WEBPACK_IMPORTED_MODULE_14__.LIVE_BOARD_PARALLAX_ASSET_CLICKED, {
                kind: index !== undefined ? index : null
            });
            _this.openLiveBoardExperience();
        });
        _define_property((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_this), "getReplaceTextProps", function() {
            var _props = _this.props, bulletsConfig = _props.bulletsConfig, iconsConfig = _props.iconsConfig, titleSize = _props.titleSize, textSize = _props.textSize, spaceFromParagraph = _props.spaceFromParagraph, withDynamicParagraphTitle = _props.withDynamicParagraphTitle, withDynamicParagraphSubtitle = _props.withDynamicParagraphSubtitle, topicBottomMargin = _props.topicBottomMargin, buttonTopMargin = _props.buttonTopMargin;
            var replaceTextProps = {};
            if (bulletsConfig) replaceTextProps.bulletsConfig = bulletsConfig;
            if (iconsConfig) replaceTextProps.iconsConfig = iconsConfig;
            if (titleSize) replaceTextProps.titleSize = titleSize;
            if (textSize) replaceTextProps.textSize = textSize;
            if (spaceFromParagraph) replaceTextProps.spaceFromParagraph = spaceFromParagraph;
            if (withDynamicParagraphTitle) replaceTextProps.withDynamicParagraphTitle = withDynamicParagraphTitle;
            if (withDynamicParagraphSubtitle) replaceTextProps.withDynamicParagraphSubtitle = withDynamicParagraphSubtitle;
            if (topicBottomMargin) replaceTextProps.topicBottomMargin = topicBottomMargin;
            if (buttonTopMargin) replaceTextProps.buttonTopMargin = buttonTopMargin;
            return replaceTextProps;
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(SideBySideTextAndAsset, [
        {
            key: "getLeftSpaceStyle",
            value: function getLeftSpaceStyle() {
                var background = this.props.background;
                var color = background.color, width = background.width;
                if (!width) return {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                return _object_spread({}, themeStyles);
            }
        },
        {
            key: "getBackgroundStyle",
            value: function getBackgroundStyle() {
                var _props = this.props, background = _props.background, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset;
                var width = background.width, color = background.color, verticalPadding = background.verticalPadding;
                var backgroundStyle = verticalPadding ? {
                    paddingBottom: verticalPadding,
                    paddingTop: verticalPadding
                } : {};
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!width || !themeStyles) return backgroundStyle;
                var direction = swapTextAndAssetPosition ? "left" : "right";
                backgroundStyle = _object_spread_props(_object_spread({}, backgroundStyle), {
                    background: "linear-gradient(to ".concat(direction, ", ").concat(themeStyles.background, " ").concat(width, ", white 0)"),
                    color: themeStyles.color,
                    gap: spaceBetweenTextAndAsset
                });
                return backgroundStyle;
            }
        },
        {
            key: "getContentStyle",
            value: function getContentStyle() {
                var _props = this.props, spaceBetweenTextAndAsset = _props.spaceBetweenTextAndAsset, mobileSpaceBetweenTextAndAsset = _props.mobileSpaceBetweenTextAndAsset;
                var backgroundStyle = this.getBackgroundStyle();
                return _object_spread({
                    "--space-between-text-and-asset": spaceBetweenTextAndAsset,
                    "--mobile-space-between-text-and-asset": mobileSpaceBetweenTextAndAsset || 0
                }, backgroundStyle);
            }
        },
        {
            key: "getSideBySideComponentStyle",
            value: function getSideBySideComponentStyle() {
                var _background_backgroundImage;
                var background = this.props.background;
                var backgroundImage = background === null || background === void 0 ? void 0 : (_background_backgroundImage = background.backgroundImage) === null || _background_backgroundImage === void 0 ? void 0 : _background_backgroundImage.src;
                if (backgroundImage) {
                    var _background_backgroundImage1;
                    return {
                        background: "url(".concat(backgroundImage, ")"),
                        backgroundPosition: (background === null || background === void 0 ? void 0 : (_background_backgroundImage1 = background.backgroundImage) === null || _background_backgroundImage1 === void 0 ? void 0 : _background_backgroundImage1.backgroundPosition) || "center",
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "cover"
                    };
                }
                return null;
            }
        },
        {
            key: "getRightSpaceStyle",
            value: function getRightSpaceStyle() {
                var background = this.props.background;
                var width = background.width, color = background.color;
                var themeStyles = segments_segments_service__WEBPACK_IMPORTED_MODULE_4__/* .themes */ .np[color];
                if (!themeStyles) return {};
                return {
                    backgroundColor: width === FULL_WIDTH ? themeStyles.background : undefined
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, replaceTextComponent = _props.replaceTextComponent, replaceTextComponentProps = _props.replaceTextComponentProps, contentClassName = _props.contentClassName, fullParagraph = _props.fullParagraph, asset = _props.asset, swapTextAndAssetPosition = _props.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = _props.mobileSwapTextAndAssetPosition, background = _props.background, alignToLogo = _props.alignToLogo, paragraphVerticalAlignment = _props.paragraphVerticalAlignment, alignImageToScreenEdge = _props.alignImageToScreenEdge, hideParagraph = _props.hideParagraph, nestedBoardItems = _props.nestedBoardItems;
                var ref = nestedBoardItems !== null && nestedBoardItems !== void 0 ? nestedBoardItems : {}, addLiveBoardTextAndAsset = ref.addLiveBoardTextAndAsset, parallaxAsset = ref.parallaxAsset, gapBetweenAssets = ref.gapBetweenAssets;
                var parallaxAssetExists = this.assetExist(parallaxAsset);
                var leftSpaceStyle = swapTextAndAssetPosition ? this.getRightSpaceStyle() : this.getLeftSpaceStyle();
                var contentStyle = this.getContentStyle();
                var sideBySideComponentStyle = this.getSideBySideComponentStyle();
                var rightSpaceStyle = swapTextAndAssetPosition ? this.getLeftSpaceStyle() : this.getRightSpaceStyle();
                var ReplaceTextComponent = replaceTextComponent || segments_desktop_core_components_full_paragraph_full_paragraph__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP;
                var width = background.width;
                var isFullWidth = width === FULL_WIDTH;
                var renderImage = function(image, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("image-wrapper", asset === null || asset === void 0 ? void 0 : asset.position, (asset === null || asset === void 0 ? void 0 : asset.shadow) && "with-shadow", parallaxAssetExists && "inside-parallax"),
                        onClick: addLiveBoardTextAndAsset ? function() {
                            return _this.imageClicked(index);
                        } : null,
                        style: _this.getImageWrapperStyle(),
                        children: _this.renderAsset(image)
                    });
                };
                var assetsToRenderForParallax = [
                    asset,
                    parallaxAsset
                ];
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_side_by_side_text_and_asset_scss__WEBPACK_IMPORTED_MODULE_7__/* .StyledSideBySideTextAndAsset */ .I, {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-text-and-asset", {
                        "align-image-to-screen-edge": alignImageToScreenEdge,
                        "is-swap": swapTextAndAssetPosition,
                        "is-mobile-swap": mobileSwapTextAndAssetPosition
                    }),
                    style: sideBySideComponentStyle,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "left-space",
                            style: leftSpaceStyle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("side-by-side-content", paragraphVerticalAlignment, contentClassName, {
                                "is-swap": swapTextAndAssetPosition,
                                "is-mobile-swap": mobileSwapTextAndAssetPosition,
                                "is-full-width": isFullWidth,
                                "align-to-logo": !!alignToLogo,
                                "no-text-component": hideParagraph,
                                "add-live-board-experience": addLiveBoardTextAndAsset
                            }),
                            style: contentStyle,
                            children: [
                                !hideParagraph && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("full-paragraph-component-wrapper", parallaxAssetExists && "sticky"),
                                    style: this.getFullParagraphComponentStyle(),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ReplaceTextComponent, _object_spread_props(_object_spread({}, replaceTextComponentProps, fullParagraph, this.getReplaceTextProps()), {
                                        openLiveBoardExperience: addLiveBoardTextAndAsset ? this.openLiveBoardExperience : null
                                    }))
                                }),
                                parallaxAssetExists ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "parallax-wrapper",
                                    style: {
                                        gap: gapBetweenAssets
                                    },
                                    children: assetsToRenderForParallax.map(function(image, index) {
                                        return renderImage(image, index);
                                    })
                                }) : renderImage(asset)
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "right-space",
                            style: rightSpaceStyle
                        })
                    ]
                });
            }
        }
    ]);
    return SideBySideTextAndAsset;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAsset.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;


/***/ }),

/***/ 99024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ StyledSideBySideTextAndAsset; }
/* harmony export */ });
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77521);
/* harmony import */ var constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(698);
/* harmony import */ var segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72428);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73759);
/* harmony import */ var segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__);




var HEADER_LOGO_HORIZONTAL_PADDING = "".concat(segments_desktop_header_layouts_components_basic_header_constants__WEBPACK_IMPORTED_MODULE_2__/* ["default"].HEADER_CONTENT_HORIZONTAL_PADDING */ .Z.HEADER_CONTENT_HORIZONTAL_PADDING, "px");
var BODY_HORIZONTAL_PADDING = "".concat((segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3___default().BODY_CONTENT_HORIZONTAL_PADDING), "px");
var StyledSideBySideTextAndAsset = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    target: "e43lgw60"
})("height:100%;display:flex;justify-content:center;.left-space{flex-grow:1;}.side-by-side-content{width:100%;padding:0 ", BODY_HORIZONTAL_PADDING, ";max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px;flex-grow:1;position:relative;display:flex;align-items:center;gap:var(--space-between-text-and-asset);&.top{align-items:flex-start;}&.center{align-items:center;}&.bottom{align-items:flex-end;}&.is-swap{flex-direction:row-reverse;.full-paragraph-component-wrapper{padding:0 0 0 60px;}}&.align-to-logo{padding-left:", HEADER_LOGO_HORIZONTAL_PADDING, ";padding-right:", HEADER_LOGO_HORIZONTAL_PADDING, ";}.image-wrapper{position:relative;z-index:1;width:50%;}.full-paragraph-component-wrapper{position:relative;z-index:1;width:50%;&.sticky{position:sticky;align-self:flex-start;}}.image-wrapper.inside-parallax{width:100%;}.full-paragraph-component-wrapper{padding:0 60px 0 0;}.image-wrapper{overflow:hidden;display:flex;align-items:center;justify-content:center;&.with-shadow{", (0,segments_desktop_constants__WEBPACK_IMPORTED_MODULE_3__.getComponentShadow)(), '}&.top{align-self:flex-start;}&.center{align-self:center;}&.bottom{align-self:flex-end;}.side-by-side-asset{height:100%;width:100%;&.ignore-parent-height{height:auto;}.picture-component{width:100%;height:100%;display:block;&:before{content:"";display:inline-block;height:100%;vertical-align:middle;}}.text-and-asset-image{max-width:100%;max-height:100%;width:auto;height:auto;display:inline-block;vertical-align:middle;position:relative;left:50%;transform:translateX(-50%);}}}&.add-live-board-experience{.image-wrapper{cursor:pointer;}}}.right-space{flex-grow:1;}@media (min-width:', constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){&.align-image-to-screen-edge{.side-by-side-content{max-width:unset;&:not(.is-swap){padding-right:0;}&.is-swap{padding-left:0;}.image-wrapper{.side-by-side-asset{.text-and-asset-image{width:100%;}}}}&:not(.is-swap){.left-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}.right-space{display:none;}}&.is-swap{padding:0 96px 0 0;.left-space{display:none;}.right-space{min-width:calc((100vw - ", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH */ .Ld, "px) / 2);}}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .TABLET_QUERY_MAX_WIDTH */ .y, "){.side-by-side-content,.side-by-side-content.is-swap{flex-direction:column;gap:var(--mobile-space-between-text-and-asset);&.is-mobile-swap{flex-direction:column-reverse;}&.is-full-width{padding-top:30px;padding-bottom:45px;}.full-paragraph-component-wrapper,.image-wrapper{width:100% !important;}.full-paragraph-component-wrapper{padding:0 60px 60px 60px;}.image-wrapper{height:initial;padding-bottom:16px;}}}@media (max-width:", constants_vp_sizes__WEBPACK_IMPORTED_MODULE_1__/* .MOBILE_QUERY_MAX_WIDTH_M */ .TI, "){.side-by-side-content{padding:0;}.side-by-side-content,.side-by-side-content.is-swap{.full-paragraph-component-wrapper{padding:0 32px 40px 32px;}.image-wrapper{padding-left:32px !important;padding-right:32px !important;}}}.parallax-wrapper{width:50%;display:flex;flex-direction:column;}");


/***/ }),

/***/ 31110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ devlink; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/constants/devlink-component-types.js + 70 modules
var devlink_component_types = __webpack_require__(58975);
;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/dynamic-devlink-config.js



/* harmony default export */ var dynamic_devlink_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Dynamic Devlink",
    fields: {
        devlinkComponent: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Component Configuration",
            conditionalKeyName: "componentType",
            options: Object.entries(devlink_component_types/* DEVLINK_COMPONENT_CONFIGS */.N).map(function(param) {
                var _param = (0,_sliced_to_array/* default */.Z)(param, 2), componentName = _param[0], config = _param[1];
                // Namespace fields by component name to prevent translation key collisions
                var namespacedFields = {};
                var componentKey = componentName.toLowerCase();
                Object.entries(config.props || {}).forEach(function(param) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), propName = _param[0], propConfig = _param[1];
                    namespacedFields[componentKey] = namespacedFields[componentKey] || {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: componentName,
                        fields: {}
                    };
                    namespacedFields[componentKey].fields[propName] = propConfig;
                });
                return {
                    text: componentName,
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fieldsConfig: namespacedFields
                };
            })
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/dynamic-devlink-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var dynamic_devlink_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

// EXTERNAL MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/default-props.js
var default_props = __webpack_require__(16848);
;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/index.js

var DynamicDevlinkComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3461).then(__webpack_require__.bind(__webpack_require__, 93461));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93461)
            ];
        }
    }
});



// Attach defaultProps to the dynamic component so it can be accessed by the template generator
DynamicDevlinkComponent.defaultProps = default_props/* default */.Z;
/* harmony default export */ var dynamic_devlink = ({
    DynamicDevlinkComponent: DynamicDevlinkComponent,
    DynamicDevlinkConfig: dynamic_devlink_config,
    DynamicDevlinkAdvancedConfig: dynamic_devlink_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    DynamicDevlink: dynamic_devlink
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/index.js

var DynamicDevlink = layouts.DynamicDevlink;
/* harmony default export */ var devlink = ({
    // plop_marker:segment_index_add_layout
    DynamicDevlinkComponent: {
        type: "DynamicDevlinkComponent",
        title: "Dynamic",
        imgSrc: "/static/img/segments/layouts/dynamic-devlink.png",
        config: DynamicDevlink.DynamicDevlinkConfig,
        advancedConfig: DynamicDevlink.DynamicDevlinkAdvancedConfig,
        component: DynamicDevlink.DynamicDevlinkComponent
    }
});


/***/ }),

/***/ 58975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "N": function() { return /* binding */ DEVLINK_COMPONENT_CONFIGS; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./devlink/devlinkContext.js
var devlinkContext = __webpack_require__(4849);
// EXTERNAL MODULE: ./devlink/utils.js
var utils = __webpack_require__(28130);
;// CONCATENATED MODULE: ./devlink/_Builtin/Basic.js
"use client";


function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var Block = /*#__PURE__*/ react.forwardRef(function Block(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, props = _object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
var Span = /*#__PURE__*/ react.forwardRef(function Span(props, ref) {
    return /*#__PURE__*/ react.createElement("span", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
var Blockquote = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Blockquote(props, ref) {
    return /*#__PURE__*/ React.createElement("blockquote", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
})));
var Basic_Link = /*#__PURE__*/ react.forwardRef(function Link(_param, ref) {
    var _options = _param.options, options = _options === void 0 ? {
        href: "#"
    } : _options, _className = _param.className, className = _className === void 0 ? "" : _className, _button = _param.button, button = _button === void 0 ? false : _button, children = _param.children, _block = _param.block, block = _block === void 0 ? "" : _block, props = _object_without_properties(_param, [
        "options",
        "className",
        "button",
        "children",
        "block"
    ]);
    var _$ref = react.useContext(devlinkContext/* DevLinkContext */._), UserLink = _$ref.renderLink;
    if (button) className += " w-button";
    if (block === "inline") className += " w-inline-block";
    if (UserLink) {
        return /*#__PURE__*/ react.createElement(UserLink, _object_spread_props(_object_spread({
            className: className
        }, options, props), {
            ref: ref
        }), children);
    }
    var href = options.href, target = options.target, _preload = options.preload, preload = _preload === void 0 ? "none" : _preload;
    var shouldRenderResource = preload !== "none" && typeof href === "string" && !href.startsWith("#");
    return /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement("a", _object_spread_props(_object_spread({
        href: href,
        target: target,
        className: className
    }, props), {
        ref: ref
    }), children), shouldRenderResource && /*#__PURE__*/ react.createElement("link", {
        rel: preload,
        href: href
    }));
});
var List = /*#__PURE__*/ react.forwardRef(function List(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "ul" : _tag, _unstyled = _param.unstyled, unstyled = _unstyled === void 0 ? true : _unstyled, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "unstyled",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        role: "list",
        className: className + (unstyled ? " w-list-unstyled" : "")
    }, props), {
        ref: ref
    }));
});
var ListItem = /*#__PURE__*/ react.forwardRef(function ListItem(props, ref) {
    return /*#__PURE__*/ react.createElement("li", _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
var Image = /*#__PURE__*/ react.forwardRef(function Image(_param, ref) {
    var alt = _param.alt, props = _object_without_properties(_param, [
        "alt"
    ]);
    var _$ref = react.useContext(devlinkContext/* DevLinkContext */._), UserImage = _$ref.renderImage;
    return UserImage ? /*#__PURE__*/ react.createElement(UserImage, _object_spread_props(_object_spread({
        alt: alt || ""
    }, props), {
        ref: ref
    })) : /*#__PURE__*/ react.createElement("img", _object_spread_props(_object_spread({
        alt: alt || ""
    }, props), {
        ref: ref
    }));
});
var Section = /*#__PURE__*/ react.forwardRef(function Section(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "section" : _tag, props = _object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({}, props), {
        ref: ref
    }));
});
var Basic_Container = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Container(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread({
        className: className + " w-container",
        ref: ref
    }, props));
})));
var BlockContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function BlockContainer(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-blockcontainer"
    }, props), {
        ref: ref
    }));
})));
var HFlex = /*#__PURE__*/ react.forwardRef(function HFlex(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-hflex"
    }, props), {
        ref: ref
    }));
});
var VFlex = /*#__PURE__*/ react.forwardRef(function VFlex(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-vflex"
    }, props), {
        ref: ref
    }));
});
var Layout = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Layout(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-layout wf-layout-layout"
    }, props), {
        ref: ref
    }));
})));
var Cell = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Cell(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-cell"
    }, props), {
        ref: ref
    }));
})));
var HtmlEmbed = /*#__PURE__*/ react.forwardRef(function HtmlEmbed(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, _value = _param.value, value = _value === void 0 ? "" : _value, props = _object_without_properties(_param, [
        "tag",
        "className",
        "value"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-embed",
        dangerouslySetInnerHTML: {
            __html: utils/* removeUnescaped */.Yp(value)
        }
    }, props), {
        ref: ref
    }));
});
var Grid = /*#__PURE__*/ react.forwardRef(function Grid(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-layout-grid"
    }, props), {
        ref: ref
    }));
});
var Icon = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Icon(_param, ref) {
    var widget = _param.widget, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "widget",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", _object_spread_props(_object_spread({
        className: className + " w-icon-".concat(widget.icon)
    }, props), {
        ref: ref
    }));
})));
var Column = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Column(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, _columnClasses = _param.columnClasses, columnClasses = _columnClasses === void 0 ? "" : _columnClasses, props = _object_without_properties(_param, [
        "tag",
        "className",
        "columnClasses"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-col " + columnClasses
    }, props), {
        ref: ref
    }));
})));
var transformWidths = function(width, index) {
    var _width_split;
    var widths = (_width_split = width === null || width === void 0 ? void 0 : width.split("|")) !== null && _width_split !== void 0 ? _width_split : [];
    return widths.length > 1 ? widths[index] : width;
};
var columnClass = function(width, key) {
    if (/stack$/.test(width)) return "w-col-stack";
    if (/main$/.test(key)) return "w-col-".concat(width);
    return "w-col-".concat(key, "-").concat(width);
};
var Row = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Row(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, columns = _param.columns, children = _param.children, props = _object_without_properties(_param, [
        "tag",
        "className",
        "columns",
        "children"
    ]);
    return /*#__PURE__*/ React.createElement(tag, _object_spread_props(_object_spread({
        className: className + " w-row"
    }, props), {
        ref: ref
    }), columns ? React.Children.map(children, function(child, index) {
        if (child && typeof child === "object" && child.type !== Column) return child;
        var columnClasses = Object.entries(columns !== null && columns !== void 0 ? columns : {}).reduce(function(acc, param) {
            var _$_param = _sliced_to_array(param, 2), key = _$_param[0], value = _$_param[1];
            var width = transformWidths(value === "custom" ? "6|6" : value, index);
            acc.add(width ? columnClass(width, key) : "");
            return acc;
        }, new Set());
        return /*#__PURE__*/ React.cloneElement(child, _object_spread({
            columnClasses: _to_consumable_array(columnClasses).join(" ")
        }, child.props));
    }) : children);
})));
var DOM = /*#__PURE__*/ react.forwardRef(function DOM(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = _object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, _object_spread_props(_object_spread({
        className: className
    }, props), {
        ref: ref
    }));
});
var NotSupported = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function NotSupported(param, ref) {
    var __atom = param._atom, _atom = __atom === void 0 ? "" : __atom;
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref
    }, "This builtin is not currently supported: ".concat(_atom));
})));

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./devlink/interactions.js
var interactions = __webpack_require__(60309);
;// CONCATENATED MODULE: ./devlink/_Builtin/Tabs.js
"use client";

function Tabs_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Tabs_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Tabs_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Tabs_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Tabs_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Tabs_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Tabs_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Tabs_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Tabs_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var tabsContext = /*#__PURE__*/ react.createContext({
    current: "",
    onTabClick: function() {
        return undefined;
    },
    onLinkKeyDown: function() {
        return undefined;
    }
});
var TabsWrapper = /*#__PURE__*/ react.forwardRef(function TabsWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, fadeIn = _param.fadeIn, fadeOut = _param.fadeOut, easing = _param.easing, initialCurrent = _param.current, props = Tabs_object_without_properties(_param, [
        "className",
        "fadeIn",
        "fadeOut",
        "easing",
        "current"
    ]);
    var _$ref = (0,src_sliced_to_array/* default */.Z)(react.useState(""), 2), current = _$ref[0], setCurrent = _$ref[1];
    var changeTab = react.useCallback(function(next) {
        var updateTab = function updateTab() {
            setCurrent(function() {
                var nextTabHeader = document.querySelector('.w-tab-link[data-w-tab="'.concat(next, '"]'));
                nextTabHeader === null || nextTabHeader === void 0 ? void 0 : nextTabHeader.focus();
                return next;
            });
        };
        var currentTab = document.querySelector('.w-tab-pane[data-w-tab="'.concat(current, '"]'));
        var nextTab = document.querySelector('.w-tab-pane[data-w-tab="'.concat(next, '"]'));
        var _EASING_FUNCTIONS_easing;
        var easingFn = (_EASING_FUNCTIONS_easing = utils/* EASING_FUNCTIONS */.pX[easing]) !== null && _EASING_FUNCTIONS_easing !== void 0 ? _EASING_FUNCTIONS_easing : "ease";
        var animation = currentTab === null || currentTab === void 0 ? void 0 : currentTab.animate([
            {
                opacity: 1
            },
            {
                opacity: 0
            }
        ], {
            duration: fadeOut,
            fill: "forwards",
            easing: easingFn
        });
        if (animation) {
            animation.onfinish = function() {
                updateTab();
                nextTab === null || nextTab === void 0 ? void 0 : nextTab.animate([
                    {
                        opacity: 0
                    },
                    {
                        opacity: 1
                    }
                ], {
                    duration: fadeIn,
                    fill: "forwards",
                    easing: easingFn
                });
            };
        } else {
            updateTab();
        }
    }, [
        current,
        easing,
        fadeIn,
        fadeOut
    ]);
    var firstRender = react.useRef(true);
    (0,utils/* useLayoutEffect */.bt)(function() {
        if (!firstRender.current) return;
        firstRender.current = false;
        setTimeout(function() {
            changeTab(initialCurrent);
        }, 1);
    }, [
        changeTab,
        initialCurrent
    ]);
    var onTabClick = (0,utils/* debounce */.Ds)(changeTab);
    var onLinkKeyDown = (0,utils/* debounce */.Ds)(function(event) {
        event.preventDefault();
        var currentTab = document.querySelector('.w-tab-pane[data-w-tab="'.concat(current, '"]'));
        var allTabs = document.querySelectorAll(".w-tab-pane");
        var firstTab = allTabs[0];
        var lastTab = allTabs[allTabs.length - 1];
        var nextTab = function() {
            switch(event.key){
                case "ArrowUp":
                case "ArrowLeft":
                    var _currentTab_previousElementSibling;
                    return (_currentTab_previousElementSibling = currentTab.previousElementSibling) !== null && _currentTab_previousElementSibling !== void 0 ? _currentTab_previousElementSibling : lastTab;
                case "ArrowDown":
                case "ArrowRight":
                    var _currentTab_nextElementSibling;
                    return (_currentTab_nextElementSibling = currentTab.nextElementSibling) !== null && _currentTab_nextElementSibling !== void 0 ? _currentTab_nextElementSibling : firstTab;
                case "Home":
                    return firstTab;
                case "End":
                    return lastTab;
            }
        }();
        if (nextTab) changeTab(nextTab.getAttribute("data-w-tab"));
    });
    return /*#__PURE__*/ react.createElement(tabsContext.Provider, {
        value: {
            current: current,
            onTabClick: onTabClick,
            onLinkKeyDown: onLinkKeyDown
        }
    }, /*#__PURE__*/ react.createElement("div", Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-tabs"),
        ref: ref
    })));
});
var TabsMenu = /*#__PURE__*/ react.forwardRef(function TabsMenu(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Tabs_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-tab-menu"),
        role: "tablist",
        ref: ref
    }));
});
var TabsLink = /*#__PURE__*/ react.forwardRef(function TabsLink(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, props = Tabs_object_without_properties(_param, [
        "className",
        "children"
    ]);
    var _$ref = react.useContext(tabsContext), current = _$ref.current, onTabClick = _$ref.onTabClick, onLinkKeyDown = _$ref.onLinkKeyDown;
    var isCurrent = current === props["data-w-tab"];
    var innerRef = react.useCallback(function(node) {
        if (!node) return;
        (0,interactions/* triggerIXEvent */.Q_)(node, isCurrent);
        if (ref) {
            if (typeof ref === "function") {
                ref(node);
            } else {
                ref.current = node;
            }
        }
    }, [
        isCurrent,
        ref
    ]);
    return /*#__PURE__*/ react.createElement("a", Tabs_object_spread_props(Tabs_object_spread({}, props), {
        ref: innerRef,
        className: (0,utils.cj)(className, "w-inline-block w-tab-link", isCurrent && "w--current"),
        onClick: function() {
            return onTabClick(props["data-w-tab"]);
        },
        onKeyDown: onLinkKeyDown,
        role: "tab",
        tabIndex: isCurrent ? 0 : -1,
        "aria-selected": isCurrent,
        "aria-controls": props["data-w-tab"]
    }), children);
});
var TabsContent = /*#__PURE__*/ react.forwardRef(function TabsContent(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Tabs_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ react.createElement(tag, Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-tab-content"),
        ref: ref
    }));
});
var TabsPane = /*#__PURE__*/ react.forwardRef(function TabsPane(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Tabs_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var current = react.useContext(tabsContext).current;
    var isCurrent = current === props["data-w-tab"];
    return /*#__PURE__*/ react.createElement(tag, Tabs_object_spread_props(Tabs_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-tab-pane", isCurrent && "w--tab-active"),
        role: "tabpanel",
        "aria-labelledby": props["data-w-tab"],
        ref: ref
    }));
});

;// CONCATENATED MODULE: ./devlink/_Builtin/Navbar.js
"use client";


function Navbar_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Navbar_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Navbar_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Navbar_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Navbar_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Navbar_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Navbar_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Navbar_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Navbar_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var BREAKPOINTS = {
    medium: 991,
    small: 767,
    tiny: 479
};
function getLinksList(root) {
    return root.querySelectorAll(".w-nav-menu .w-nav-link");
}
var Navbar_NavbarContext = /*#__PURE__*/ react.createContext({
    animDirect: 1,
    animOver: false,
    animation: "animation",
    collapse: "medium",
    docHeight: false,
    duration: 400,
    easing2: "ease",
    easing: "ease",
    getBodyHeight: function() {
        return undefined;
    },
    getOverlayHeight: function() {
        return undefined;
    },
    isOpen: false,
    noScroll: false,
    toggleOpen: function() {
        return undefined;
    },
    navbarMounted: false,
    menu: undefined,
    root: undefined,
    setFocusedLink: function() {
        return undefined;
    }
});
function getAnimationKeyframes(param) {
    var _axis = param.axis, axis = _axis === void 0 ? "Y" : _axis, start = param.start, end = param.end;
    var t = "translate".concat(axis);
    return [
        {
            transform: "".concat(t, "(").concat(start, "px)")
        },
        {
            transform: "".concat(t, "(").concat(end, "px)")
        }
    ];
}
var NavbarWrapper = /*#__PURE__*/ react.forwardRef(function NavbarWrapper(props, ref) {
    var _config = props.config, animation = _config.animation, docHeight = _config.docHeight, easing = _config.easing, easing2 = _config.easing2, duration = _config.duration, noScroll = _config.noScroll;
    var root = react.useRef(null);
    var menu = react.useRef(null);
    var animOver = /^over/.test(animation);
    var animDirect = /left$/.test(animation) ? -1 : 1;
    var _$ref = (0,src_sliced_to_array/* default */.Z)(react.useState(-1), 2), focusedLink = _$ref[0], setFocusedLink = _$ref[1];
    react.useImperativeHandle(ref, function() {
        return root.current;
    });
    var getBodyHeight = react.useCallback(function() {
        if (utils/* isServer */.sk) return;
        return docHeight ? document.documentElement.scrollHeight : document.body.scrollHeight;
    }, [
        docHeight
    ]);
    var getOverlayHeight = react.useCallback(function() {
        if (utils/* isServer */.sk || !root.current) return;
        var height = getBodyHeight();
        if (!height) return;
        var style = getComputedStyle(root.current);
        if (!animOver && style.position !== "fixed") {
            height -= root.current.offsetHeight;
        }
        return height;
    }, [
        animOver,
        getBodyHeight
    ]);
    var getOffsetHeight = react.useCallback(function() {
        if (!root.current || !menu.current) return 0;
        return root.current.offsetHeight + menu.current.offsetHeight;
    }, []);
    var _$ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(false), 2), isOpen = _$ref1[0], setIsOpen = _$ref1[1];
    var toggleOpen = (0,utils/* debounce */.Ds)(function() {
        if (!menu.current) return;
        if (isOpen) {
            var keyframes = animOver ? getAnimationKeyframes({
                axis: "X",
                start: 0,
                end: animDirect * menu.current.offsetWidth
            }) : getAnimationKeyframes({
                start: 0,
                end: -getOffsetHeight()
            });
            var _EASING_FUNCTIONS_easing2;
            var anim = menu.current.animate(keyframes, {
                easing: (_EASING_FUNCTIONS_easing2 = utils/* EASING_FUNCTIONS */.pX[easing2]) !== null && _EASING_FUNCTIONS_easing2 !== void 0 ? _EASING_FUNCTIONS_easing2 : "ease",
                duration: duration,
                fill: "forwards"
            });
            anim.onfinish = function() {
                setIsOpen(!isOpen);
            };
            return;
        }
        setFocusedLink(-1);
        setIsOpen(!isOpen);
    });
    (0,utils/* useLayoutEffect */.bt)(function() {
        if (!menu.current) return;
        if (isOpen) {
            var keyframes = animOver ? getAnimationKeyframes({
                axis: "X",
                start: animDirect * menu.current.offsetWidth,
                end: 0
            }) : getAnimationKeyframes({
                start: -getOffsetHeight(),
                end: 0
            });
            var _EASING_FUNCTIONS_easing;
            menu.current.animate(keyframes, {
                easing: (_EASING_FUNCTIONS_easing = utils/* EASING_FUNCTIONS */.pX[easing]) !== null && _EASING_FUNCTIONS_easing !== void 0 ? _EASING_FUNCTIONS_easing : "ease",
                duration: duration,
                fill: "forwards"
            });
        }
    }, [
        animDirect,
        animOver,
        duration,
        easing,
        getBodyHeight,
        getOffsetHeight,
        isOpen
    ]);
    (0,utils/* useLayoutEffect */.bt)(function() {
        if (isOpen && noScroll) {
            document.body.style.overflowY = "hidden";
        } else {
            document.body.style.overflowY = "";
        }
        return function() {
            document.body.style.overflowY = "";
        };
    }, [
        isOpen,
        noScroll
    ]);
    var closeOnResize = react.useCallback(function() {
        return setIsOpen(false);
    }, [
        setIsOpen
    ]);
    (0,utils/* useResizeObserver */.yU)(root, closeOnResize, {
        onlyWidth: true
    });
    react.useEffect(function() {
        if (root.current) {
            var _links_;
            var links = getLinksList(root.current);
            (_links_ = links[focusedLink !== null && focusedLink !== void 0 ? focusedLink : 0]) === null || _links_ === void 0 ? void 0 : _links_.focus();
        }
    }, [
        focusedLink
    ]);
    return /*#__PURE__*/ react.createElement(Navbar_NavbarContext.Provider, {
        value: Navbar_object_spread_props(Navbar_object_spread({}, props.config), {
            root: root,
            menu: menu,
            animOver: animOver,
            animDirect: animDirect,
            getBodyHeight: getBodyHeight,
            getOverlayHeight: getOverlayHeight,
            isOpen: isOpen,
            toggleOpen: toggleOpen,
            navbarMounted: true,
            setFocusedLink: setFocusedLink
        })
    }, /*#__PURE__*/ react.createElement(Navbar, Navbar_object_spread({}, props)));
});
var maybeExtractChildMenu = function(children, isOpen) {
    if (!isOpen) return {
        childMenu: null,
        rest: children
    };
    var ref = (0,utils/* extractElement */.aF)(react.Children.toArray(children), NavbarMenu), extracted = ref.extracted, tree = ref.tree;
    return {
        childMenu: extracted,
        rest: tree
    };
};
function Navbar(_param) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, config = _param.config, props = Navbar_object_without_properties(_param, [
        "tag",
        "className",
        "children",
        "config"
    ]);
    var ref = react.useContext(Navbar_NavbarContext), root = ref.root, collapse = ref.collapse, setFocusedLink = ref.setFocusedLink;
    var ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(true), 2), shouldExtractMenu = ref1[0], setShouldExtractMenu = ref1[1];
    var extractMenuCallback = react.useCallback(function(entry) {
        setShouldExtractMenu(entry.contentRect.width <= BREAKPOINTS[collapse]);
    }, [
        setShouldExtractMenu
    ]);
    var bodyRef = react.useRef(typeof document !== "undefined" ? document.body : null);
    (0,utils/* useResizeObserver */.yU)(bodyRef, extractMenuCallback);
    var ref2 = react.useMemo(function() {
        return maybeExtractChildMenu(children, shouldExtractMenu);
    }, [
        children,
        shouldExtractMenu
    ]), childMenu = ref2.childMenu, rest = ref2.rest;
    var handleFocus = function(e) {
        var _document_activeElement;
        var inputFocused = ((_document_activeElement = document.activeElement) === null || _document_activeElement === void 0 ? void 0 : _document_activeElement.tagName.toLowerCase()) === "input";
        var linkList = root.current ? Array.from(getLinksList(root.current)) : [];
        var linkAmount = linkList.length;
        switch(e.key){
            case utils/* KEY_CODES.ARROW_LEFT */.nx.ARROW_LEFT:
            case utils/* KEY_CODES.ARROW_UP */.nx.ARROW_UP:
                {
                    if (!inputFocused) {
                        e.preventDefault();
                        setFocusedLink(function(prev) {
                            return Math.max(prev - 1, 0);
                        });
                    }
                    break;
                }
            case utils/* KEY_CODES.ARROW_RIGHT */.nx.ARROW_RIGHT:
            case utils/* KEY_CODES.ARROW_DOWN */.nx.ARROW_DOWN:
                {
                    if (!inputFocused) {
                        e.preventDefault();
                        setFocusedLink(function(prev) {
                            return Math.min(prev + 1, linkAmount - 1);
                        });
                    }
                    break;
                }
            case utils/* KEY_CODES.HOME */.nx.HOME:
                {
                    e.preventDefault();
                    setFocusedLink(0);
                    break;
                }
            case utils/* KEY_CODES.END */.nx.END:
                {
                    e.preventDefault();
                    setFocusedLink(linkAmount - 1);
                    break;
                }
            case utils/* KEY_CODES.TAB */.nx.TAB:
                {
                    setTimeout(function() {
                        setFocusedLink(linkList.findIndex(function(link) {
                            return link === document.activeElement;
                        }));
                    }, 0);
                    break;
                }
            case utils/* KEY_CODES.SPACE */.nx.SPACE:
                {
                    if (!inputFocused) {
                        e.preventDefault();
                    }
                    break;
                }
            default:
                {
                    return;
                }
        }
    };
    return /*#__PURE__*/ react.createElement(tag, Navbar_object_spread_props(Navbar_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-nav"),
        "data-collapse": config.collapse,
        "data-animation": config.animation,
        ref: root,
        onKeyDown: handleFocus
    }), /*#__PURE__*/ react.createElement(react.Fragment, null, rest, /*#__PURE__*/ react.createElement(NavbarOverlay, null, childMenu)));
}
function NavbarOverlay(param) {
    var children = param.children;
    var ref = react.useContext(Navbar_NavbarContext), isOpen = ref.isOpen, getOverlayHeight = ref.getOverlayHeight, toggleOpen = ref.toggleOpen;
    var overlayToggleOpen = react.useCallback(function(e) {
        if (e.target === e.currentTarget) {
            toggleOpen();
        }
    }, [
        toggleOpen
    ]);
    var overlayHeight = getOverlayHeight();
    return /*#__PURE__*/ react.createElement("div", {
        className: "w-nav-overlay",
        id: "w-nav-overlay",
        style: {
            display: isOpen ? "block" : "none",
            height: overlayHeight ? overlayHeight : undefined,
            width: isOpen ? "100%" : 0
        },
        onClick: overlayToggleOpen,
        onKeyDown: overlayToggleOpen
    }, children);
}
var NavbarContainer = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function NavbarContainer(_param, ref) {
    var children = _param.children, props = Navbar_object_without_properties(_param, [
        "children"
    ]);
    var innerRef = React.useRef(null);
    var isOpen = React.useContext(Navbar_NavbarContext).isOpen;
    React.useImperativeHandle(ref, function() {
        return innerRef.current;
    });
    var updateLinkStyles = React.useCallback(function(entry) {
        var _$ref = getComputedStyle(entry.target), containerMaxWidth = _$ref.maxWidth;
        document.querySelectorAll(".w-nav-menu>.w-dropdown,.w-nav-menu>.w-nav-link").forEach(function(node) {
            if (!_instanceof(node, HTMLElement)) return;
            if (!isOpen) {
                node.style.maxWidth = "";
                return;
            }
            var maxWidth = getComputedStyle(node).maxWidth;
            node.style.maxWidth = !maxWidth || maxWidth === "none" || maxWidth === containerMaxWidth ? containerMaxWidth : "";
        });
    }, [
        isOpen
    ]);
    useResizeObserver(innerRef, updateLinkStyles);
    return /*#__PURE__*/ React.createElement(Container, Navbar_object_spread_props(Navbar_object_spread({}, props), {
        ref: innerRef
    }), children);
})));
var NavbarBrand = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function NavbarBrand(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Navbar_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(Link, Navbar_object_spread_props(Navbar_object_spread({}, props), {
        className: cj(className, "w-nav-brand"),
        ref: ref
    }));
})));
var NavbarMenu = /*#__PURE__*/ react.forwardRef(function NavbarMenu(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "nav" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Navbar_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var _$ref = react.useContext(Navbar_NavbarContext), getBodyHeight = _$ref.getBodyHeight, animOver = _$ref.animOver, isOpen = _$ref.isOpen, menu = _$ref.menu;
    react.useImperativeHandle(ref, function() {
        return menu.current;
    });
    return /*#__PURE__*/ react.createElement(tag, Navbar_object_spread_props(Navbar_object_spread(Navbar_object_spread_props(Navbar_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-nav-menu")
    }), isOpen ? {
        "data-nav-menu-open": ""
    } : {}), {
        style: animOver ? {
            height: getBodyHeight()
        } : {},
        ref: menu
    }));
});
var NavbarLink = /*#__PURE__*/ react.forwardRef(function NavbarLink(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Navbar_object_without_properties(_param, [
        "className"
    ]);
    var isOpen = react.useContext(Navbar_NavbarContext).isOpen;
    return /*#__PURE__*/ react.createElement(Basic_Link, Navbar_object_spread_props(Navbar_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-nav-link", isOpen && "w--nav-link-open"),
        ref: ref
    }));
});
var NavbarButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function NavbarButton(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Navbar_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var _$ref = React.useContext(Navbar_NavbarContext), isOpen = _$ref.isOpen, toggleOpen = _$ref.toggleOpen;
    return /*#__PURE__*/ React.createElement(tag, Navbar_object_spread_props(Navbar_object_spread({}, props), {
        "aria-label": "menu",
        "aria-expanded": isOpen ? "true" : "false",
        "aria-haspopup": "menu",
        "aria-controls": "w-nav-overlay",
        role: "button",
        tabIndex: 0,
        className: cj(className, "w-nav-button", isOpen && "w--open"),
        onClick: toggleOpen,
        onKeyDown: function(e) {
            if (e.key === KEY_CODES.ENTER || e.key === KEY_CODES.SPACE) {
                e.preventDefault();
                toggleOpen();
            }
        },
        ref: ref
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Dropdown.js
"use client";

function Dropdown_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Dropdown_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Dropdown_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Dropdown_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Dropdown_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Dropdown_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Dropdown_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Dropdown_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Dropdown_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function Dropdown_getLinksList(root) {
    return root.querySelectorAll(".w-dropdown-list .w-dropdown-link");
}
var DropdownContext = /*#__PURE__*/ react.createContext({
    root: undefined,
    isOpen: false,
    toggleOpen: function() {
        return undefined;
    },
    setFocusedLink: function() {
        return undefined;
    },
    hover: false
});
var INITIAL_DROPDOWN_STATE = {
    isOpen: false,
    openingCount: 0
};
var DropdownWrapper = /*#__PURE__*/ react.forwardRef(function DropdownWrapper(_param, ref) {
    var delay = _param.delay, hover = _param.hover, props = Dropdown_object_without_properties(_param, [
        "delay",
        "hover"
    ]);
    var root = react.useRef(null);
    var _$ref = (0,src_sliced_to_array/* default */.Z)(react.useState(INITIAL_DROPDOWN_STATE), 2), isOpen = _$ref[0].isOpen, setIsOpen = _$ref[1];
    var _$ref1 = (0,src_sliced_to_array/* default */.Z)(react.useState(-1), 2), focusedLink = _$ref1[0], setFocusedLink = _$ref1[1];
    var closeTimeoutRef = react.useRef();
    react.useImperativeHandle(ref, function() {
        return root.current;
    });
    react.useEffect(function() {
        return function() {
            clearTimeout(closeTimeoutRef.current);
        };
    }, []);
    var toggleOpen = react.useCallback(function() {
        clearTimeout(closeTimeoutRef.current);
        setFocusedLink(-1);
        setIsOpen(function(_param) {
            var openingCount = _param.openingCount, rest = Dropdown_object_without_properties(_param, [
                "openingCount"
            ]);
            return Dropdown_object_spread_props(Dropdown_object_spread({}, rest), {
                openingCount: openingCount + 1
            });
        });
        if (delay > 0 && isOpen) {
            closeTimeoutRef.current = setTimeout(function() {
                setIsOpen(function(param) {
                    var openingCount = param.openingCount;
                    return {
                        openingCount: openingCount,
                        isOpen: openingCount % 2 === 1
                    };
                });
            }, delay);
        } else {
            setIsOpen(function(param) {
                var openingCount = param.openingCount;
                return {
                    openingCount: openingCount,
                    isOpen: openingCount % 2 === 1
                };
            });
        }
    }, [
        hover,
        isOpen,
        delay
    ]);
    var closeDropdown = react.useCallback(function() {
        return setIsOpen(INITIAL_DROPDOWN_STATE);
    }, [
        setIsOpen
    ]);
    (0,utils/* useClickOut */.Iy)(root, closeDropdown);
    (0,interactions/* useIXEvent */._Y)(root.current, isOpen);
    react.useEffect(function() {
        if (root.current) {
            var _links_;
            var links = Dropdown_getLinksList(root.current);
            (_links_ = links[focusedLink !== null && focusedLink !== void 0 ? focusedLink : 0]) === null || _links_ === void 0 ? void 0 : _links_.focus();
        }
    }, [
        focusedLink
    ]);
    return /*#__PURE__*/ react.createElement(DropdownContext.Provider, {
        value: {
            root: root,
            isOpen: isOpen,
            toggleOpen: toggleOpen,
            setFocusedLink: setFocusedLink,
            hover: hover
        }
    }, /*#__PURE__*/ react.createElement(Dropdown, Dropdown_object_spread({}, props)));
});
function Dropdown(_param) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Dropdown_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var ref = react.useContext(DropdownContext), root = ref.root, setFocusedLink = ref.setFocusedLink, hover = ref.hover, toggleOpen = ref.toggleOpen;
    var ref1 = react.useContext(Navbar_NavbarContext), isNavbarOpen = ref1.isOpen;
    var handleFocus = function(e) {
        var linkList = root.current ? Array.from(Dropdown_getLinksList(root.current)) : [];
        var linkAmount = linkList.length;
        switch(e.key){
            case utils/* KEY_CODES.ARROW_LEFT */.nx.ARROW_LEFT:
            case utils/* KEY_CODES.ARROW_UP */.nx.ARROW_UP:
                {
                    e.preventDefault();
                    setFocusedLink(function(prev) {
                        return Math.max(prev - 1, 0);
                    });
                    break;
                }
            case utils/* KEY_CODES.ARROW_RIGHT */.nx.ARROW_RIGHT:
            case utils/* KEY_CODES.ARROW_DOWN */.nx.ARROW_DOWN:
                {
                    e.preventDefault();
                    setFocusedLink(function(prev) {
                        return Math.min(prev + 1, linkAmount - 1);
                    });
                    break;
                }
            case utils/* KEY_CODES.HOME */.nx.HOME:
                {
                    e.preventDefault();
                    setFocusedLink(0);
                    break;
                }
            case utils/* KEY_CODES.END */.nx.END:
                {
                    e.preventDefault();
                    setFocusedLink(linkAmount - 1);
                    break;
                }
            case utils/* KEY_CODES.TAB */.nx.TAB:
                {
                    setTimeout(function() {
                        setFocusedLink(linkList.findIndex(function(link) {
                            return link === document.activeElement;
                        }));
                    }, 0);
                    break;
                }
            case utils/* KEY_CODES.SPACE */.nx.SPACE:
                {
                    e.preventDefault();
                    break;
                }
            default:
                {
                    return;
                }
        }
    };
    return /*#__PURE__*/ react.createElement(tag, Dropdown_object_spread_props(Dropdown_object_spread({}, props), {
        ref: root,
        onKeyDown: handleFocus,
        onMouseEnter: function() {
            if (hover) {
                toggleOpen();
            }
        },
        onMouseLeave: function() {
            if (hover) {
                toggleOpen();
            }
        },
        className: (0,utils.cj)(className, "w-dropdown", isNavbarOpen && "w--nav-dropdown-open")
    }));
}
var DropdownToggle = /*#__PURE__*/ react.forwardRef(function DropdownToggle(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Dropdown_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var _$ref = react.useContext(DropdownContext), isOpen = _$ref.isOpen, toggleOpen = _$ref.toggleOpen, hover = _$ref.hover;
    var _$ref1 = react.useContext(Navbar_NavbarContext), isNavbarOpen = _$ref1.isOpen;
    return /*#__PURE__*/ react.createElement(tag, Dropdown_object_spread_props(Dropdown_object_spread({}, props), {
        "aria-haspopup": "menu",
        "aria-expanded": isOpen,
        className: (0,utils.cj)(className, "w-dropdown-toggle", isNavbarOpen && "w--nav-dropdown-toggle-open"),
        onClick: function() {
            if (!hover) toggleOpen();
        },
        onKeyDown: function(e) {
            if (e.key === utils/* KEY_CODES.ENTER */.nx.ENTER || e.key === utils/* KEY_CODES.SPACE */.nx.SPACE) {
                toggleOpen();
                e.stopPropagation();
                return e.preventDefault();
            }
        },
        role: "button",
        tabIndex: 0,
        ref: ref
    }));
});
var DropdownList = /*#__PURE__*/ react.forwardRef(function DropdownList(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "nav" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Dropdown_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    var isOpen = react.useContext(DropdownContext).isOpen;
    var _$ref = react.useContext(Navbar_NavbarContext), isNavbarOpen = _$ref.isOpen;
    return /*#__PURE__*/ react.createElement(tag, Dropdown_object_spread_props(Dropdown_object_spread({}, props), {
        className: (0,utils.cj)(className, "w-dropdown-list", isOpen && "w--open", isNavbarOpen && "w--nav-dropdown-list-open"),
        ref: ref
    }));
});
var DropdownLink = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function DropdownLink(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Dropdown_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = React.useContext(NavbarContext), isNavbarOpen = _$ref.isOpen;
    return /*#__PURE__*/ React.createElement(Link, Dropdown_object_spread_props(Dropdown_object_spread({}, props), {
        className: cj(className, "w-dropdown-link", isNavbarOpen && "w--nav-link-open"),
        tabIndex: 0,
        ref: ref
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Facebook.js
"use client";
function Facebook_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Facebook_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Facebook_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Facebook_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Facebook_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Facebook_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Facebook_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Facebook_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Facebook_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var Facebook = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Facebook(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _layout = _param.layout, layout = _layout === void 0 ? "standard" : _layout, _width = _param.width, width = _width === void 0 ? 250 : _width, _height = _param.height, height = _height === void 0 ? 50 : _height, _url = _param.url, url = _url === void 0 ? "https://facebook.com/webflow" : _url, _locale = _param.locale, locale = _locale === void 0 ? "en_US" : _locale, props = Facebook_object_without_properties(_param, [
        "className",
        "layout",
        "width",
        "height",
        "url",
        "locale"
    ]);
    if (!isUrl(url)) {
        url = "https://facebook.com/webflow";
    }
    if (!/^http/.test(url)) {
        url = "http://" + url;
    }
    var params = {
        href: url,
        layout: layout,
        locale: locale,
        action: "like",
        show_faces: "false",
        share: "false"
    };
    var queryParams = Object.keys(params).map(function(key) {
        return "".concat(key, "=").concat(encodeURIComponent(params[key]));
    });
    var frameSrc = "https://www.facebook.com/plugins/like.php?".concat(queryParams.join("&"));
    return /*#__PURE__*/ React.createElement("div", Facebook_object_spread_props(Facebook_object_spread({}, props), {
        className: className + " w-widget w-widget-facebook",
        ref: ref
    }), /*#__PURE__*/ React.createElement("iframe", {
        title: "Facebook Like Button",
        src: frameSrc,
        style: {
            border: "none",
            overflow: "hidden",
            width: width,
            height: height
        }
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Typography.js
"use client";
function Typography_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Typography_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Typography_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Typography_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Typography_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Typography_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Typography_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Typography_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Typography_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

var Heading = /*#__PURE__*/ react.forwardRef(function Heading(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "h1" : _tag, props = Typography_object_without_properties(_param, [
        "tag"
    ]);
    return /*#__PURE__*/ react.createElement(tag, Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
});
var Paragraph = /*#__PURE__*/ react.forwardRef(function Paragraph(props, ref) {
    return /*#__PURE__*/ react.createElement("p", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
});
var Emphasized = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Emphasized(props, ref) {
    return /*#__PURE__*/ React.createElement("em", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
})));
var Strong = /*#__PURE__*/ react.forwardRef(function Strong(props, ref) {
    return /*#__PURE__*/ react.createElement("strong", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
});
var Figure = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Figure(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, figure = _param.figure, props = Typography_object_without_properties(_param, [
        "className",
        "figure"
    ]);
    var type = figure.type, align = figure.align;
    if (align) {
        className += "w-richtext-align-".concat(align, " ");
    }
    if (type) {
        className += "w-richtext-align-".concat(type, " ");
    }
    return /*#__PURE__*/ React.createElement("figure", Typography_object_spread_props(Typography_object_spread({
        className: className
    }, props), {
        ref: ref
    }));
})));
var Figcaption = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Figcaption(props, ref) {
    return /*#__PURE__*/ React.createElement("figcaption", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
})));
var Subscript = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Subscript(props, ref) {
    return /*#__PURE__*/ React.createElement("sub", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
})));
var Superscript = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Superrscript(props, ref) {
    return /*#__PURE__*/ React.createElement("sup", Typography_object_spread_props(Typography_object_spread({}, props), {
        ref: ref
    }));
})));
var RichText = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function RichText(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, props = Typography_object_without_properties(_param, [
        "tag",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(tag, Typography_object_spread_props(Typography_object_spread({
        className: className + " w-richtext"
    }, props), {
        ref: ref
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Twitter.js
"use client";
function Twitter_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Twitter_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Twitter_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Twitter_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Twitter_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Twitter_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Twitter_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Twitter_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Twitter_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var modeDict = {
    follow: "createFollowButton",
    tweet: "createShareButton"
};
var sizeDict = {
    m: "medium",
    l: "large"
};
var Twitter = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Twitter(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _url = _param.url, url = _url === void 0 ? "https://webflow.com" : _url, _mode = _param.mode, mode = _mode === void 0 ? "tweet" : _mode, _size = _param.size, size = _size === void 0 ? "m" : _size, _text = _param.text, text = _text === void 0 ? "Check out this site" : _text, props = Twitter_object_without_properties(_param, [
        "className",
        "url",
        "mode",
        "size",
        "text"
    ]);
    var innerRef = React.useRef(null);
    React.useImperativeHandle(ref, function() {
        return innerRef.current;
    });
    if (!isUrl(url)) {
        if (mode === "tweet") {
            url = "https://webflow.com/";
        } else if (mode === "follow") {
            url = "webflow";
        }
    }
    React.useEffect(function() {
        var isComponentMounted = true;
        loadScript("https://platform.twitter.com/widgets.js").then(function() {
            if (isComponentMounted) {
                if (window.twttr) {
                    var twitterButtonOption = window.twttr.widgets[modeDict[mode]];
                    if (twitterButtonOption) {
                        twitterButtonOption(url, innerRef === null || innerRef === void 0 ? void 0 : innerRef.current, {
                            size: sizeDict[size],
                            text: text
                        });
                    }
                }
            }
        });
        return function() {
            isComponentMounted = false;
        };
    }, []);
    return /*#__PURE__*/ React.createElement("div", Twitter_object_spread_props(Twitter_object_spread({}, props), {
        className: className + " w-widget w-widget-twitter",
        ref: innerRef
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Form.js
"use client";

function Form_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Form_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Form_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Form_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Form_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Form_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Form_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Form_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Form_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function onKeyDownInputHandlers(e) {
    e.stopPropagation();
}
var FormWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, tmp = _param.state, initialState = tmp === void 0 ? "normal" : tmp, onSubmit = _param.onSubmit, children = _param.children, props = Form_object_without_properties(_param, [
        "className",
        "state",
        "onSubmit",
        "children"
    ]);
    var _children_find;
    var _$ref = _sliced_to_array(React.useState(initialState), 2), state = _$ref[0], setState = _$ref[1];
    var _children_find_props_dataname;
    var formName = (_children_find_props_dataname = ((_children_find = children.find(function(c) {
        return c.type === FormForm;
    })) === null || _children_find === void 0 ? void 0 : _children_find.props)["data-name"]) !== null && _children_find_props_dataname !== void 0 ? _children_find_props_dataname : "Form";
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-form"
    }, props), {
        ref: ref
    }), React.Children.map(children, function(child) {
        if (child.type === FormForm) {
            var style = {};
            if (state === "success") {
                style.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, Form_object_spread_props(Form_object_spread({}, child.props), {
                style: style,
                onSubmit: function(e) {
                    try {
                        e.preventDefault();
                        if (window.grecaptcha) {
                            var _window_grecaptcha;
                            if (!((_window_grecaptcha = window.grecaptcha) === null || _window_grecaptcha === void 0 ? void 0 : _window_grecaptcha.getResponse())) {
                                alert("Please confirm you’re not a robot.");
                                return;
                            }
                        }
                        if (onSubmit) {
                            onSubmit(e);
                        }
                        setState("success");
                    } catch (err) {
                        setState("error");
                        throw err;
                    }
                },
                "aria-label": formName
            }));
        }
        if (child.type === FormSuccessMessage) {
            var style1 = {};
            if (state === "success") {
                style1.display = "block";
            }
            if (state === "error") {
                style1.display = "none";
            }
            return /*#__PURE__*/ React.cloneElement(child, Form_object_spread_props(Form_object_spread({}, child.props), {
                style: style1,
                tabIndex: -1,
                role: "region",
                "aria-label": "".concat(formName, " success")
            }));
        }
        if (child.type === FormErrorMessage) {
            var style2 = {};
            if (state === "success") {
                style2.display = "none";
            }
            if (state === "error") {
                style2.display = "block";
            }
            return /*#__PURE__*/ React.cloneElement(child, Form_object_spread_props(Form_object_spread({}, child.props), {
                tabIndex: -1,
                role: "region",
                "aria-label": "".concat(formName, " failure"),
                style: style2
            }));
        }
        return child;
    }));
})));
var FormForm = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormForm(props, ref) {
    return /*#__PURE__*/ React.createElement("form", Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref
    }));
})));
var FormBlockLabel = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormBlockLabel(props, ref) {
    return /*#__PURE__*/ React.createElement("label", Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref
    }));
})));
var FormTextInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormTextInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({}, props), {
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref: ref
    }));
})));
var FormTextarea = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormTextarea(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("textarea", Form_object_spread_props(Form_object_spread({}, props), {
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref: ref
    }));
})));
var FormInlineLabel = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormInlineLabel(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("span", Form_object_spread_props(Form_object_spread({
        className: className + " w-form-label"
    }, props), {
        ref: ref
    }));
})));
var FormCheckboxWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormCheckboxWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", Form_object_spread_props(Form_object_spread({
        className: className + " w-checkbox"
    }, props), {
        ref: ref
    }));
})));
var FormRadioWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormRadioWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", Form_object_spread_props(Form_object_spread({
        className: className + " w-radio"
    }, props), {
        ref: ref
    }));
})));
var HIDE_DEFAULT_INPUT_STYLES = {
    opacity: 0,
    position: "absolute",
    zIndex: -1
};
var CHECKED_CLASS = "w--redirected-checked";
var FOCUSED_CLASS = "w--redirected-focus";
var FOCUSED_VISIBLE_CLASS = "w--redirected-focus-visible";
var FormBooleanInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormBooleanInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _checked = _param.checked, checked = _checked === void 0 ? false : _checked, _type = _param.type, type = _type === void 0 ? "checkbox" : _type, inputType = _param.inputType, customClassName = _param.customClassName, props = Form_object_without_properties(_param, [
        "className",
        "checked",
        "type",
        "inputType",
        "customClassName"
    ]);
    var _$ref = _sliced_to_array(React.useState(checked), 2), isChecked = _$ref[0], setIsChecked = _$ref[1];
    var _$ref1 = _sliced_to_array(React.useState(false), 2), isFocused = _$ref1[0], setIsFocused = _$ref1[1];
    var _$ref2 = _sliced_to_array(React.useState(false), 2), isFocusedVisible = _$ref2[0], setIsFocusedVisible = _$ref2[1];
    var wasClicked = React.useRef(false);
    var inputProps = {
        checked: isChecked,
        type: type,
        onChange: function(e) {
            if (props.onChange) props.onChange(e);
            setIsChecked(function(prevIsChecked) {
                return !prevIsChecked;
            });
        },
        onClick: function(e) {
            if (props.onClick) props.onClick(e);
            wasClicked.current = true;
        },
        onFocus: function(e) {
            if (props.onFocus) props.onFocus(e);
            setIsFocused(true);
            if (!wasClicked.current) {
                setIsFocusedVisible(true);
            }
        },
        onBlur: function(e) {
            if (props.onBlur) props.onBlur(e);
            setIsFocused(false);
            setIsFocusedVisible(false);
            wasClicked.current = false;
        },
        onKeyDown: onKeyDownInputHandlers
    };
    if (inputType === "custom") {
        var pseudoModeClasses = "".concat(isChecked ? " ".concat(CHECKED_CLASS) : "").concat(isFocused ? " ".concat(FOCUSED_CLASS) : "").concat(isFocusedVisible ? " ".concat(FOCUSED_CLASS, " ").concat(FOCUSED_VISIBLE_CLASS) : "", " ").concat(customClassName !== null && customClassName !== void 0 ? customClassName : "");
        var currentClassName = "".concat(className).concat(pseudoModeClasses);
        return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            className: currentClassName
        }), /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({
            ref: ref
        }, props, inputProps), {
            style: HIDE_DEFAULT_INPUT_STYLES
        })));
    }
    return /*#__PURE__*/ React.createElement("input", Form_object_spread({
        ref: ref,
        className: className
    }, props, inputProps));
})));
var FormCheckboxInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormCheckboxInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(FormBooleanInput, Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref,
        type: "checkbox",
        className: className + " w-checkbox-input"
    }));
})));
var FormRadioInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormRadioInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement(FormBooleanInput, Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref,
        type: "radio",
        className: className + " w-radio-input"
    }));
})));
var MAX_FILE_SIZE_DEFAULT = 10485760;
var FileUploadContext = /*#__PURE__*/ react.createContext({
    files: null,
    error: null,
    maxSize: MAX_FILE_SIZE_DEFAULT,
    setFiles: function() {
        return undefined;
    },
    setError: function() {
        return undefined;
    }
});
var FormFileUploadWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadWrapper(_param, ref) {
    var _maxSize = _param.maxSize, maxSize = _maxSize === void 0 ? MAX_FILE_SIZE_DEFAULT : _maxSize, props = Form_object_without_properties(_param, [
        "maxSize"
    ]);
    var _$ref = _sliced_to_array(React.useState(null), 2), files = _$ref[0], setFiles = _$ref[1];
    var _$ref1 = _sliced_to_array(React.useState(null), 2), error = _$ref1[0], setError = _$ref1[1];
    return /*#__PURE__*/ React.createElement(FileUploadContext.Provider, {
        value: {
            files: files,
            setFiles: setFiles,
            error: error,
            setError: setError,
            maxSize: maxSize
        }
    }, /*#__PURE__*/ React.createElement(_FormFileUploadWrapper, Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref
    })));
})));
var _FormFileUploadWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function _FormFileUploadWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadDefault = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadDefault(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = React.useContext(FileUploadContext), files = _$ref.files, error = _$ref.error;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-default"
    }, props), {
        ref: ref,
        style: Form_object_spread_props(Form_object_spread({}, props.style), {
            display: !files || error ? "block" : "none"
        })
    }));
})));
var FormFileUploadInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = React.useContext(FileUploadContext), setFiles = _$ref.setFiles, setError = _$ref.setError, maxSize = _$ref.maxSize;
    return /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({}, props), {
        className: className + " w-file-upload-input",
        type: "file",
        onKeyDown: onKeyDownInputHandlers,
        onChange: function(e) {
            if (e.target.files) {
                if (e.target.files[0] && e.target.files[0].size <= maxSize) {
                    setError(null);
                    setFiles(e.target.files);
                } else setError("SIZE_ERROR");
            }
        },
        ref: ref
    }));
})));
var FormFileUploadLabel = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadLabel(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("label", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-label"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadText = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadText(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-inline-block"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadInfo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadInfo(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-info"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadUploading = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadUploading(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-uploading",
        style: Form_object_spread_props(Form_object_spread({}, props.style), {
            display: "none"
        })
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadUploadingBtn = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadUploadingBtn(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-uploading-btn"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadUploadingIcon = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadUploadingIcon(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("svg", Form_object_spread_props(Form_object_spread({
        className: className + " icon w-icon-file-upload-uploading"
    }, props), {
        ref: ref
    }), /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        opacity: ".2",
        d: "M15 30a15 15 0 1 1 0-30 15 15 0 0 1 0 30zm0-3a12 12 0 1 0 0-24 12 12 0 0 0 0 24z"
    }), /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        opacity: ".75",
        d: "M0 15A15 15 0 0 1 15 0v3A12 12 0 0 0 3 15H0z"
    }, /*#__PURE__*/ React.createElement("animateTransform", {
        attributeName: "transform",
        attributeType: "XML",
        dur: "0.6s",
        from: "0 15 15",
        repeatCount: "indefinite",
        to: "360 15 15",
        type: "rotate"
    }))));
})));
var FormFileUploadSuccess = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadSuccess(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = React.useContext(FileUploadContext), files = _$ref.files, error = _$ref.error;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-success"
    }, props), {
        ref: ref,
        style: Form_object_spread_props(Form_object_spread({}, props.style), {
            display: Boolean(files) && !error ? "block" : "none"
        })
    }));
})));
var FormFileUploadFile = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadFile(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-file"
    }, props), {
        ref: ref
    }));
})));
var FormFileUploadFileName = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadFileName(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var files = React.useContext(FileUploadContext).files;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-file-name"
    }, props), {
        ref: ref
    }), files && files[0].name);
})));
var FormFileUploadRemoveLink = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadRemoveLink(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var setFiles = React.useContext(FileUploadContext).setFiles;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-remove-link"
    }, props), {
        ref: ref,
        onClick: function() {
            setFiles(null);
        }
    }));
})));
var FormFileUploadError = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadError(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    var error = React.useContext(FileUploadContext).error;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-error"
    }, props), {
        ref: ref,
        style: Form_object_spread_props(Form_object_spread({}, props.style), {
            display: error ? "block" : "none"
        })
    }));
})));
var FormFileUploadErrorMsg = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormFileUploadErrorMsg(_param, ref) {
    var errors = _param.errors, _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "errors",
        "className"
    ]);
    var error = React.useContext(FileUploadContext).error;
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-file-upload-error-msg"
    }, props), {
        ref: ref
    }), errors[error !== null && error !== void 0 ? error : "GENERIC_ERROR"]);
})));
var FormButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormButton(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, value = _param.value, props = Form_object_without_properties(_param, [
        "className",
        "value"
    ]);
    return /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref,
        type: "submit",
        value: value !== null && value !== void 0 ? value : "",
        className: className + " w-button",
        onKeyDown: onKeyDownInputHandlers
    }));
})));
var SearchForm = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SearchForm(props, ref) {
    return /*#__PURE__*/ React.createElement("form", Form_object_spread_props(Form_object_spread({}, props), {
        ref: ref
    }));
})));
var SearchInput = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SearchInput(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({}, props), {
        type: "text",
        className: className + " w-input",
        onKeyDown: onKeyDownInputHandlers,
        ref: ref
    }));
})));
var SearchButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SearchButton(_param, ref) {
    var _value = _param.value, value = _value === void 0 ? "" : _value, _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "value",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("input", Form_object_spread_props(Form_object_spread({}, props), {
        type: "submit",
        value: value,
        className: className + " w-button",
        onKeyDown: onKeyDownInputHandlers,
        ref: ref
    }));
})));
var FormSuccessMessage = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormSuccessMessage(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-form-done"
    }, props), {
        ref: ref
    }));
})));
var FormErrorMessage = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormErrorMessage(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("div", Form_object_spread_props(Form_object_spread({
        className: className + " w-form-fail"
    }, props), {
        ref: ref
    }));
})));
function hasValue(str) {
    if (typeof str !== "string") return false;
    return str.replace(/^[s ]+|[s ]+$/g, "").length > 0;
}
var FormSelect = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormSelect(_param, ref) {
    var options = _param.options, _className = _param.className, className = _className === void 0 ? "" : _className, props = Form_object_without_properties(_param, [
        "options",
        "className"
    ]);
    return /*#__PURE__*/ React.createElement("select", Form_object_spread_props(Form_object_spread({
        className: className + " w-select"
    }, props), {
        ref: ref
    }), options.map(function(param, index) {
        var v = param.v, t = param.t;
        return /*#__PURE__*/ React.createElement("option", {
            key: index,
            value: hasValue(v) ? v : ""
        }, hasValue(t) ? t : "");
    }));
})));
var FormReCaptcha = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function FormReCaptcha(param, ref) {
    var _siteKey = param.siteKey, siteKey = _siteKey === void 0 ? "" : _siteKey, _theme = param.theme, theme = _theme === void 0 ? "light" : _theme, _size = param.size, size = _size === void 0 ? "normal" : _size;
    React.useEffect(function() {
        loadScript("https://www.google.com/recaptcha/api.js", {
            cacheRegex: /(http|https):\/\/(www)?.+\/recaptcha/
        });
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "g-recaptcha",
        "data-sitekey": siteKey,
        "data-theme": theme,
        "data-size": size
    });
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Map.js
"use client";
function Map_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Map_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Map_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Map_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Map_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Map_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Map_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Map_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Map_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


function buildTitle(title, tooltip) {
    var markerTitle = "Map pin";
    if (title && tooltip) {
        markerTitle = "Map pin on ".concat(title, " showing location of ").concat(tooltip);
    } else if (title && !tooltip) {
        markerTitle = "Map pin on ".concat(title);
    } else if (!title && tooltip) {
        markerTitle = "Map pin showing location of ".concat(tooltip);
    }
    return markerTitle;
}
var MapWidget = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function MapWidget(_param, ref) {
    var _apiKey = _param.apiKey, apiKey = _apiKey === void 0 ? "" : _apiKey, _mapStyle = _param.mapStyle, mapStyle = _mapStyle === void 0 ? "roadmap" : _mapStyle, _zoom = _param.zoom, zoom = _zoom === void 0 ? 12 : _zoom, _latlng = _param.latlng, latlng = _latlng === void 0 ? "51.511214,-0.119824" : _latlng, _tooltip = _param.tooltip, tooltip = _tooltip === void 0 ? "" : _tooltip, _title = _param.title, title = _title === void 0 ? "" : _title, _enableScroll = _param.enableScroll, enableScroll = _enableScroll === void 0 ? true : _enableScroll, _enableTouch = _param.enableTouch, enableTouch = _enableTouch === void 0 ? true : _enableTouch, _className = _param.className, className = _className === void 0 ? "" : _className, props = Map_object_without_properties(_param, [
        "apiKey",
        "mapStyle",
        "zoom",
        "latlng",
        "tooltip",
        "title",
        "enableScroll",
        "enableTouch",
        "className"
    ]);
    var mapRef = useRef(null);
    React.useImperativeHandle(ref, function() {
        return mapRef.current;
    });
    useEffect(function() {
        var loadMap = function() {
            var _window_google, _window;
            if (!mapRef.current) return;
            if (!((_window = window) === null || _window === void 0 ? void 0 : (_window_google = _window.google) === null || _window_google === void 0 ? void 0 : _window_google.maps)) return;
            var _maps = window.google.maps, Map = _maps.Map, Marker = _maps.Marker, InfoWindow = _maps.InfoWindow;
            var coords = latlng.split(",");
            var center = {
                lat: parseFloat(coords[0]),
                lng: parseFloat(coords[1])
            };
            var map = new Map(mapRef.current, {
                zoom: zoom,
                center: center,
                mapTypeId: mapStyle,
                mapTypeControl: false,
                panControl: false,
                streetViewControl: false,
                draggable: enableTouch,
                scrollwheel: enableScroll,
                zoomControl: true
            });
            var marker = new Marker({
                draggable: false,
                position: center,
                title: buildTitle(title, tooltip),
                map: map
            });
            if (tooltip) {
                new InfoWindow({
                    disableAutoPan: true,
                    content: tooltip,
                    position: center
                }).open({
                    anchor: marker,
                    map: map
                });
            }
            window.google.maps.event.addListener(marker, "click", function() {
                window.open("https://maps.google.com/?z=".concat(zoom, "&daddr=").concat(latlng));
            });
        };
        loadScript("https://maps.googleapis.com/maps/api/js?v=3.52.5&key=".concat(apiKey), {
            cacheRegex: /maps\.googleapis\.com\/maps\/api\/js\?v=3\.52\.5\&key=/gi
        }).then(loadMap);
    }, [
        apiKey,
        mapStyle,
        zoom,
        latlng,
        tooltip,
        title,
        enableScroll,
        enableTouch,
        mapRef
    ]);
    return /*#__PURE__*/ React.createElement("div", Map_object_spread_props(Map_object_spread({}, props), {
        className: cj(className, "w-widget w-widget-map"),
        role: "region",
        ref: mapRef
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Slider.js
"use client";


function Slider_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Slider_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Slider_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Slider_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Slider_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Slider_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Slider_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Slider_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Slider_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var DEFAULT_SLIDER_CONFIG = {
    navSpacing: 3,
    navShadow: false,
    autoplay: false,
    delay: 4000,
    iconArrows: true,
    animation: "slide",
    navNumbers: true,
    easing: "ease",
    navRound: true,
    hideArrows: false,
    disableSwipe: false,
    duration: 500,
    infinite: true,
    autoMax: 0,
    navInvert: false
};
var SliderContext = /*#__PURE__*/ react.createContext(Slider_object_spread_props(Slider_object_spread({}, DEFAULT_SLIDER_CONFIG), {
    slideAmount: 0,
    setSlideAmount: function() {
        return undefined;
    },
    setCurrentSlide: function() {
        return undefined;
    },
    goToNextSlide: function() {
        return undefined;
    },
    goToPreviousSlide: function() {
        return undefined;
    },
    slide: {
        current: 0,
        previous: 0
    },
    isAutoplayPaused: false,
    setAutoplayPause: function() {
        return undefined;
    }
}));
function useSwipe(param) {
    var onSwipeLeft = param.onSwipeLeft, onSwipeRight = param.onSwipeRight, config = param.config;
    var SWIPE_DELTA = 150;
    var ref = _sliced_to_array(React.useState(0), 2), touchStart = ref[0], setTouchStart = ref[1];
    var ref1 = _sliced_to_array(React.useState(0), 2), touchEnd = ref1[0], setTouchEnd = ref1[1];
    var handleTouchStart = function(e) {
        setTouchStart(e.touches[0].clientX);
    };
    var handleTouchMove = function(e) {
        setTouchEnd(e.touches[0].clientX);
    };
    var handleTouchEnd = function() {
        if (config === null || config === void 0 ? void 0 : config.disableSwipe) return;
        if (touchStart - touchEnd > SWIPE_DELTA) {
            onSwipeLeft();
        }
        if (touchStart - touchEnd < -SWIPE_DELTA) {
            onSwipeRight();
        }
    };
    return {
        onTouchStart: handleTouchStart,
        onTouchMove: handleTouchMove,
        onTouchEnd: handleTouchEnd
    };
}
var SliderWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SlideWrapper(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Slider_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = _sliced_to_array(React.useState(0), 2), slideAmount = _$ref[0], setSlideAmount = _$ref[1];
    var _$ref1 = _sliced_to_array(React.useState(0), 2), selectedSlide = _$ref1[0], setSelectedSlide = _$ref1[1];
    var _$ref2 = _sliced_to_array(React.useState(0), 2), prevSelectedSlide = _$ref2[0], setPrevSelectedSlide = _$ref2[1];
    var _$ref3 = _sliced_to_array(React.useState(false), 2), isAutoplayPaused = _$ref3[0], setAutoplayPause = _$ref3[1];
    var setCurrentSlide = debounce(function(value) {
        setSelectedSlide(function(prev) {
            setPrevSelectedSlide(prev);
            return value;
        });
    });
    var goToNextSlide = debounce(function() {
        if (selectedSlide === slideAmount - 1) {
            setCurrentSlide(0);
        } else {
            setCurrentSlide(selectedSlide + 1);
        }
    });
    var goToPreviousSlide = debounce(function() {
        if (selectedSlide === 0) {
            setCurrentSlide(slideAmount - 1);
        } else {
            setCurrentSlide(selectedSlide - 1);
        }
    });
    var swipeHandlers = useSwipe({
        onSwipeLeft: goToNextSlide,
        onSwipeRight: goToPreviousSlide
    });
    return /*#__PURE__*/ React.createElement(SliderContext.Provider, {
        value: Slider_object_spread_props(Slider_object_spread({}, props), {
            slideAmount: slideAmount,
            setSlideAmount: setSlideAmount,
            slide: {
                current: selectedSlide,
                previous: prevSelectedSlide
            },
            setCurrentSlide: setCurrentSlide,
            goToNextSlide: goToNextSlide,
            goToPreviousSlide: goToPreviousSlide,
            isAutoplayPaused: isAutoplayPaused,
            setAutoplayPause: setAutoplayPause
        })
    }, /*#__PURE__*/ React.createElement("div", Slider_object_spread_props(Slider_object_spread({}, swipeHandlers), {
        className: cj(className, "w-slider"),
        role: "region",
        "aria-label": "carousel",
        ref: ref
    }), props.children));
})));
function useAutoplay() {
    var ref = React.useContext(SliderContext), autoplay = ref.autoplay, delay = ref.delay, autoMax = ref.autoMax, isAutoplayPaused = ref.isAutoplayPaused, setAutoplayPause = ref.setAutoplayPause, goToNextSlide = ref.goToNextSlide;
    var ref1 = _sliced_to_array(React.useState(0), 2), autoMaxCount = ref1[0], setAutoMaxCount = ref1[1];
    var autoMaxReached = React.useMemo(function() {
        return autoMaxCount >= autoMax && autoMax > 0;
    }, [
        autoMax,
        autoMaxCount
    ]);
    React.useEffect(function() {
        var shouldAutoplay = autoplay && !autoMaxReached && !isAutoplayPaused;
        if (shouldAutoplay) {
            var interval = setInterval(function() {
                setAutoMaxCount(function(prev) {
                    return prev + 1;
                });
                goToNextSlide();
            }, delay);
            return function() {
                return clearInterval(interval);
            };
        }
    }, [
        autoplay,
        delay,
        goToNextSlide,
        autoMaxReached,
        isAutoplayPaused
    ]);
    var resumeAutoplay = function() {
        return setAutoplayPause(true);
    };
    var pauseAutoplay = function() {
        return setAutoplayPause(false);
    };
    return {
        resumeAutoplay: resumeAutoplay,
        pauseAutoplay: pauseAutoplay
    };
}
var SliderMask = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SliderMask(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, children = _param.children, props = Slider_object_without_properties(_param, [
        "className",
        "children"
    ]);
    var setSlideAmount = React.useContext(SliderContext).setSlideAmount;
    var _$ref = _sliced_to_array(React.useState(false), 2), isHovered = _$ref[0], setHovered = _$ref[1];
    var _$ref1 = _sliced_to_array(React.useState([]), 2), slides = _$ref1[0], setSlides = _$ref1[1];
    var _$ref2 = useAutoplay(), resumeAutoplay = _$ref2.resumeAutoplay, pauseAutoplay = _$ref2.pauseAutoplay;
    React.useEffect(function() {
        var extractNonFragmentChildren = function(_children) {
            var _childrenList_;
            var childrenList = React.Children.toArray(_children).filter(function(child) {
                return /*#__PURE__*/ React.isValidElement(child);
            });
            if (childrenList.length === 1 && ((_childrenList_ = childrenList[0]) === null || _childrenList_ === void 0 ? void 0 : _childrenList_.type) === React.Fragment) {
                return extractNonFragmentChildren(childrenList[0].props.children);
            } else {
                return childrenList;
            }
        };
        var _slides = extractNonFragmentChildren(children);
        setSlideAmount(_slides.length);
        setSlides(_slides);
    }, [
        children
    ]);
    return /*#__PURE__*/ React.createElement("div", Slider_object_spread_props(Slider_object_spread({}, props), {
        className: cj(className, "w-slider-mask"),
        onMouseEnter: function() {
            pauseAutoplay();
            setHovered(true);
        },
        onMouseLeave: function() {
            resumeAutoplay();
            setHovered(false);
        },
        onFocus: function() {
            return pauseAutoplay();
        },
        onBlur: function() {
            return resumeAutoplay();
        },
        ref: ref
    }), slides.map(function(child, index) {
        return /*#__PURE__*/ React.cloneElement(child, Slider_object_spread_props(Slider_object_spread({}, child.props), {
            index: index
        }));
    }), /*#__PURE__*/ React.createElement("div", {
        "aria-live": isHovered ? "polite" : "off",
        "aria-atomic": "true",
        className: "w-slider-aria-label"
    }));
})));
var SliderSlide = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SliderSlide(_param, ref) {
    var _tag = _param.tag, tag = _tag === void 0 ? "div" : _tag, _className = _param.className, className = _className === void 0 ? "" : _className, _style = _param.style, style = _style === void 0 ? {} : _style, index = _param.index, props = Slider_object_without_properties(_param, [
        "tag",
        "className",
        "style",
        "index"
    ]);
    var _$ref = React.useContext(SliderContext), animation = _$ref.animation, duration = _$ref.duration, easing = _$ref.easing, _slide = _$ref.slide, current = _slide.current, previous = _slide.previous, slideAmount = _$ref.slideAmount;
    var restartEngine = React.useContext(IXContext).restartEngine;
    React.useEffect(function() {
        restartEngine && restartEngine();
    }, [
        restartEngine
    ]);
    var isSlideActive = current === index;
    var isSlidePrevious = previous === index;
    var animationStyle = React.useMemo(function() {
        var base = {
            transform: "translateX(-".concat(current * 100, "%)"),
            transition: "transform ".concat(duration, "ms ").concat(EASING_FUNCTIONS[easing], " 0s")
        };
        if (animation === "slide") {
            return base;
        }
        if (animation === "cross") {
            return Slider_object_spread_props(Slider_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: "opacity ".concat(duration, "ms ").concat(EASING_FUNCTIONS[easing], " 0s, transform 1ms linear ").concat(isSlideActive ? 0 : duration, "ms")
            });
        }
        if (animation === "outin") {
            return Slider_object_spread_props(Slider_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: "opacity ".concat(duration / 2, "ms ").concat(EASING_FUNCTIONS[easing], " ").concat(isSlidePrevious ? 0 : duration / 2, "ms, transform 1ms linear ").concat(isSlidePrevious ? duration / 2 : 0, "ms")
            });
        }
        if (animation === "fade") {
            return Slider_object_spread_props(Slider_object_spread({}, base), {
                opacity: isSlideActive ? 1 : 0,
                transition: "opacity ".concat(duration, "ms ").concat(EASING_FUNCTIONS[easing], " 0s, transform 1ms linear ").concat(isSlideActive ? 0 : duration, "ms")
            });
        }
        if (animation === "over") {
            return Slider_object_spread_props(Slider_object_spread({}, base), {
                transition: "transform ".concat(duration, "ms ").concat(EASING_FUNCTIONS[easing], " ").concat(isSlidePrevious ? duration : 0, "ms"),
                zIndex: isSlideActive ? 1 : 0
            });
        }
        return base;
    }, [
        animation,
        duration,
        easing,
        current,
        isSlideActive,
        isSlidePrevious
    ]);
    var innerRef = React.useCallback(function(node) {
        triggerIXEvent(node, isSlideActive);
        if (ref) {
            if (typeof ref === "function") {
                ref(node);
            } else {
                ref.current = node;
            }
        }
    }, [
        isSlideActive,
        ref
    ]);
    return /*#__PURE__*/ React.createElement(tag, Slider_object_spread_props(Slider_object_spread({}, props), {
        className: cj(className, "w-slide"),
        style: Slider_object_spread({}, style, animationStyle),
        "aria-label": "".concat(index + 1, " of ").concat(slideAmount),
        role: "group",
        ref: innerRef,
        "aria-hidden": !isSlideActive ? "true" : "false"
    }));
})));
var SliderArrow = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SliderArrow(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, _dir = _param.dir, dir = _dir === void 0 ? "left" : _dir, children = _param.children, props = Slider_object_without_properties(_param, [
        "className",
        "dir",
        "children"
    ]);
    var _$ref = React.useContext(SliderContext), goToNextSlide = _$ref.goToNextSlide, goToPreviousSlide = _$ref.goToPreviousSlide, hideArrows = _$ref.hideArrows, slideAmount = _$ref.slideAmount, current = _$ref.slide.current;
    var handleSlideChange = debounce(function() {
        if (dir === "left") {
            goToPreviousSlide();
        } else {
            goToNextSlide();
        }
    });
    var isHidden = React.useMemo(function() {
        if (dir === "left" && hideArrows && current === 0) return true;
        if (dir === "right" && hideArrows && current === slideAmount - 1) return true;
        return false;
    }, [
        dir,
        hideArrows,
        current,
        slideAmount
    ]);
    return /*#__PURE__*/ React.createElement("div", Slider_object_spread_props(Slider_object_spread({}, props), {
        onClick: handleSlideChange,
        onKeyDown: function(e) {
            e.stopPropagation();
            if (e.key === KEY_CODES.ENTER || e.key === KEY_CODES.SPACE) {
                e.preventDefault();
                handleSlideChange();
            }
        },
        role: "button",
        tabIndex: 0,
        className: cj(className, "w-slider-arrow-".concat(dir)),
        "aria-label": "".concat(dir === "left" ? "previous" : "next", " slide"),
        style: {
            display: isHidden ? "none" : "block"
        },
        ref: ref
    }), children);
})));
var SliderNav = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SliderNav(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = Slider_object_without_properties(_param, [
        "className"
    ]);
    var _$ref = React.useContext(SliderContext), slideAmount = _$ref.slideAmount, navInvert = _$ref.navInvert, navNumbers = _$ref.navNumbers, navRound = _$ref.navRound, navShadow = _$ref.navShadow, setAutoplayPause = _$ref.setAutoplayPause, setCurrentSlide = _$ref.setCurrentSlide;
    var _$ref1 = _sliced_to_array(React.useState(null), 2), focusedDot = _$ref1[0], setFocusedDot = _$ref1[1];
    var handleFocus = function(e) {
        switch(e.key){
            case KEY_CODES.ENTER:
            case KEY_CODES.SPACE:
                {
                    e.preventDefault();
                    if (focusedDot !== null) {
                        setCurrentSlide(focusedDot);
                    }
                    break;
                }
            case KEY_CODES.ARROW_LEFT:
            case KEY_CODES.ARROW_UP:
                {
                    e.preventDefault();
                    setFocusedDot(function(prev) {
                        return Math.max((prev !== null && prev !== void 0 ? prev : 0) - 1, 0);
                    });
                    break;
                }
            case KEY_CODES.ARROW_RIGHT:
            case KEY_CODES.ARROW_DOWN:
                {
                    e.preventDefault();
                    setFocusedDot(function(prev) {
                        return Math.min((prev !== null && prev !== void 0 ? prev : 0) + 1, slideAmount - 1);
                    });
                    break;
                }
            case KEY_CODES.HOME:
                {
                    e.preventDefault();
                    setFocusedDot(0);
                    break;
                }
            case KEY_CODES.END:
                {
                    e.preventDefault();
                    setFocusedDot(slideAmount - 1);
                    break;
                }
            default:
                {
                    return;
                }
        }
    };
    var dots = _to_consumable_array(Array(slideAmount).keys()).map(function(_, i) {
        return /*#__PURE__*/ React.createElement(SliderDot, {
            key: i,
            index: i,
            focusedDot: focusedDot,
            handleFocus: handleFocus,
            setFocusedDot: setFocusedDot
        });
    });
    return /*#__PURE__*/ React.createElement("div", Slider_object_spread_props(Slider_object_spread({}, props), {
        onFocus: function(e) {
            e.stopPropagation();
            setAutoplayPause(true);
        },
        onBlur: function() {
            setAutoplayPause(false);
        },
        onMouseLeave: function(e) {
            return e.stopPropagation();
        },
        className: cj(className, "w-slider-nav ".concat(navInvert ? "w-slider-nav-invert" : "", " ").concat(navShadow ? "w-shadow" : "", " ").concat(navRound ? "w-round" : "", " ").concat(navNumbers ? "w-num" : "")),
        ref: ref
    }), dots);
})));
var SliderDot = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function SliderDot(param, ref) {
    var index = param.index, focusedDot = param.focusedDot, handleFocus = param.handleFocus, setFocusedDot = param.setFocusedDot;
    var _$ref = React.useContext(SliderContext), slideAmount = _$ref.slideAmount, navSpacing = _$ref.navSpacing, navNumbers = _$ref.navNumbers, _slide = _$ref.slide, selectedSlide = _slide.current, setCurrentSlide = _$ref.setCurrentSlide;
    var innerRef = React.useRef(null);
    React.useImperativeHandle(ref, function() {
        return innerRef.current;
    });
    React.useEffect(function() {
        if (focusedDot === index) {
            var _innerRef_current;
            (_innerRef_current = innerRef.current) === null || _innerRef_current === void 0 ? void 0 : _innerRef_current.focus();
        }
    }, [
        focusedDot,
        index
    ]);
    var isSlideActive = selectedSlide === index;
    var label = navNumbers ? index + 1 : "";
    return /*#__PURE__*/ React.createElement("div", {
        className: "w-slider-dot ".concat(isSlideActive ? "w-active" : ""),
        "aria-label": "Show slide ".concat(index + 1, " of ").concat(slideAmount),
        "aria-pressed": isSlideActive,
        role: "button",
        tabIndex: isSlideActive ? 0 : -1,
        style: {
            marginRight: "".concat(navSpacing, "px"),
            marginLeft: "".concat(navSpacing, "px")
        },
        onClick: function(e) {
            e.stopPropagation();
            setFocusedDot(index);
            setCurrentSlide(index);
        },
        ref: innerRef,
        onKeyDown: handleFocus
    }, label);
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/Video.js
"use client";
function Video_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function Video_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            Video_define_property(target, key, source[key]);
        });
    }
    return target;
}
function Video_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function Video_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        Video_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function Video_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = Video_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function Video_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var getAspectRatio = function(param) {
    var width = param.width, height = param.height;
    return height && width ? height / width : 0;
};
var Video = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function Video(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, options = _param.options, props = Video_object_without_properties(_param, [
        "className",
        "options"
    ]);
    var _$ref = options || {}, _height = _$ref.height, height = _height === void 0 ? 0 : _height, _width = _$ref.width, width = _width === void 0 ? 0 : _width, _title = _$ref.title, title = _title === void 0 ? "" : _title, _url = _$ref.url, url = _url === void 0 ? undefined : _url;
    var aspectRatio = getAspectRatio({
        width: width,
        height: height
    });
    return /*#__PURE__*/ React.createElement("div", Video_object_spread_props(Video_object_spread({}, props), {
        style: {
            paddingTop: "".concat(aspectRatio * 100, "%")
        },
        className: cj("w-video", "w-embed", className),
        ref: ref
    }), /*#__PURE__*/ React.createElement("iframe", {
        className: "embedly-embed",
        src: url,
        width: width,
        height: height,
        title: title,
        allowFullScreen: true,
        scrolling: "no",
        frameBorder: "0"
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/YouTubeVideo.js
"use client";

function YouTubeVideo_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function YouTubeVideo_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            YouTubeVideo_define_property(target, key, source[key]);
        });
    }
    return target;
}
function YouTubeVideo_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function YouTubeVideo_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        YouTubeVideo_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function YouTubeVideo_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = YouTubeVideo_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function YouTubeVideo_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var DEFAULT_16_9_RATIO = 0.5617021276595745;
var YouTubeVideo = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function YouTubeVideo(_param, ref) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, title = _param.title, videoId = _param.videoId, _aspectRatio = _param.aspectRatio, aspectRatio = _aspectRatio === void 0 ? DEFAULT_16_9_RATIO : _aspectRatio, _startAt = _param.startAt, startAt = _startAt === void 0 ? 0 : _startAt, _showAllRelatedVideos = _param.showAllRelatedVideos, showAllRelatedVideos = _showAllRelatedVideos === void 0 ? false : _showAllRelatedVideos, _controls = _param.controls, controls = _controls === void 0 ? true : _controls, _autoplay = _param.autoplay, autoplay = _autoplay === void 0 ? false : _autoplay, _muted = _param.muted, muted = _muted === void 0 ? false : _muted, _privacyMode = _param.privacyMode, privacyMode = _privacyMode === void 0 ? false : _privacyMode, props = YouTubeVideo_object_without_properties(_param, [
        "className",
        "title",
        "videoId",
        "aspectRatio",
        "startAt",
        "showAllRelatedVideos",
        "controls",
        "autoplay",
        "muted",
        "privacyMode"
    ]);
    var baseUrl = privacyMode ? "https://www.youtube-nocookie.com/embed" : "https://www.youtube.com/embed";
    var urlParams = Object.entries({
        startAt: startAt,
        showAllRelatedVideos: showAllRelatedVideos,
        controls: controls,
        autoplay: autoplay,
        muted: muted
    }).map(function(param) {
        var _$_param = _sliced_to_array(param, 2), k = _$_param[0], v = _$_param[1];
        return "".concat(k, "=").concat(Number(v));
    }).join("&");
    var iframeStyle = {
        position: "absolute",
        left: 0,
        top: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "auto"
    };
    return /*#__PURE__*/ React.createElement("div", YouTubeVideo_object_spread_props(YouTubeVideo_object_spread({}, props), {
        style: {
            paddingTop: "".concat(aspectRatio * 100, "%")
        },
        className: cj("w-embed-youtubevideo", className),
        ref: ref
    }), /*#__PURE__*/ React.createElement("iframe", {
        src: "".concat(baseUrl, "/").concat(videoId, "?").concat(urlParams),
        title: title,
        allowFullScreen: true,
        scrolling: "no",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
        style: iframeStyle
    }));
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/BackgroundVideo.js
"use client";



var BgVideoContext = /*#__PURE__*/ react.createContext({
    isPlaying: true,
    togglePlay: function() {
        return undefined;
    }
});
var BackgroundVideoWrapper = /*#__PURE__*/ react.forwardRef(function BackgroundVideoWrapper(param, ref) {
    var _tag = param.tag, tag = _tag === void 0 ? "div" : _tag, _className = param.className, className = _className === void 0 ? "" : _className, _autoPlay = param.autoPlay, autoPlay = _autoPlay === void 0 ? true : _autoPlay, _loop = param.loop, loop = _loop === void 0 ? true : _loop, _sources = param.sources, sources = _sources === void 0 ? [] : _sources, _posterImage = param.posterImage, posterImage = _posterImage === void 0 ? "" : _posterImage, children = param.children;
    var _$ref = (0,src_sliced_to_array/* default */.Z)(react.useState(autoPlay), 2), isPlaying = _$ref[0], setIsPlaying = _$ref[1];
    var video = react.useRef(null);
    react.useImperativeHandle(ref, function() {
        return video.current;
    });
    var togglePlay = (0,utils/* debounce */.Ds)(function() {
        setIsPlaying(!isPlaying);
        if (!(video === null || video === void 0 ? void 0 : video.current)) return;
        if (video.current.paused) {
            video.current.play();
        } else {
            video.current.pause();
        }
    });
    return /*#__PURE__*/ react.createElement(BgVideoContext.Provider, {
        value: {
            isPlaying: isPlaying,
            togglePlay: togglePlay
        }
    }, /*#__PURE__*/ react.createElement(tag, {
        className: (0,utils.cj)(className, "w-background-video", "w-background-video-atom")
    }, /*#__PURE__*/ react.createElement("video", {
        ref: video,
        autoPlay: autoPlay,
        loop: loop,
        style: posterImage ? {
            backgroundImage: 'url("'.concat(posterImage, '")')
        } : undefined,
        muted: true,
        playsInline: true
    }, sources.map(function(url) {
        return /*#__PURE__*/ react.createElement("source", {
            src: url,
            key: url
        });
    }))), children);
});
var BackgroundVideoPlayPauseButton = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function BackgroundVideoPlayPauseButton(param, ref) {
    var children = param.children, className = param.className;
    var togglePlay = React.useContext(BgVideoContext).togglePlay;
    return /*#__PURE__*/ React.createElement("div", {
        "aria-live": "polite"
    }, /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: cj(className, "w-backgroundvideo-backgroundvideoplaypausebutton", "w-background-video--control"),
        onClick: togglePlay,
        ref: ref
    }, children));
})));
var BackgroundVideoPlayPauseButtonPlaying = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function BackgroundVideoPlayPauseButtonPlaying(param, ref) {
    var children = param.children;
    var isPlaying = React.useContext(BgVideoContext).isPlaying;
    return /*#__PURE__*/ React.createElement("span", {
        hidden: !isPlaying,
        ref: ref
    }, children);
})));
var BackgroundVideoPlayPauseButtonPaused = /*#__PURE__*/ (/* unused pure expression or super */ null && (React.forwardRef(function BackgroundVideoPlayPauseButtonPaused(param, ref) {
    var children = param.children;
    var isPlaying = React.useContext(BgVideoContext).isPlaying;
    return /*#__PURE__*/ React.createElement("span", {
        hidden: isPlaying,
        ref: ref
    }, children);
})));

;// CONCATENATED MODULE: ./devlink/_Builtin/index.js
"use client";














// EXTERNAL MODULE: ./devlink/devlink.js
var devlink = __webpack_require__(59477);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./devlink/AiAgents.module.css
var AiAgents_module = __webpack_require__(49169);
var AiAgents_module_default = /*#__PURE__*/__webpack_require__.n(AiAgents_module);
;// CONCATENATED MODULE: ./devlink/AiAgents.js
"use client";






var _interactionsData = JSON.parse('{"events":{"e-16":{"id":"e-16","name":"","animationType":"custom","eventTypeId":"MOUSE_MOVE","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-20","affectedElements":{},"duration":0}},"mediaQueries":["main"],"target":{"selector":".sec-specialists","originalId":"d715d745-a5f3-a899-1935-09013a8a3c35","appliesTo":"CLASS"},"targets":[{"selector":".sec-specialists","originalId":"d715d745-a5f3-a899-1935-09013a8a3c35","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-20-p","selectedAxis":"X_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":96,"restingState":50},{"continuousParameterGroupId":"a-20-p-2","selectedAxis":"Y_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":96,"restingState":50}],"createdOn":1749633223520},"e-29":{"id":"e-29","name":"","animationType":"preset","eventTypeId":"MOUSE_MOVE","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-20","affectedElements":{},"duration":0}},"mediaQueries":["main"],"target":{"id":"6853e34886981d09931d6260|d715d745-a5f3-a899-1935-09013a8a3c87","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6853e34886981d09931d6260|d715d745-a5f3-a899-1935-09013a8a3c87","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-20-p","selectedAxis":"X_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":95,"restingState":50},{"continuousParameterGroupId":"a-20-p-2","selectedAxis":"Y_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":95,"restingState":50}],"createdOn":1750793817930},"e-34":{"id":"e-34","name":"","animationType":"preset","eventTypeId":"MOUSE_MOVE","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-20","affectedElements":{},"duration":0}},"mediaQueries":["main"],"target":{"id":"685ced661b0756caa401e4a4|d715d745-a5f3-a899-1935-09013a8a3c87","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|d715d745-a5f3-a899-1935-09013a8a3c87","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-20-p","selectedAxis":"X_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":95,"restingState":50},{"continuousParameterGroupId":"a-20-p-2","selectedAxis":"Y_AXIS","basedOn":"ELEMENT","reverse":false,"smoothing":95,"restingState":50}],"createdOn":1750920551192},"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-20":{"id":"a-20","title":"Agents 3","continuousParameterGroups":[{"id":"a-20-p","type":"MOUSE_X","parameterLabel":"Mouse X","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-20-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".comp_ai-spec-moving","selectorGuids":["f3c3ead6-b342-0916-05a9-cdd3b2415300"]},"xValue":48,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-20-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".comp_ai-spec-moving","selectorGuids":["f3c3ead6-b342-0916-05a9-cdd3b2415300"]},"xValue":-48,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]},{"id":"a-20-p-2","type":"MOUSE_Y","parameterLabel":"Mouse Y","continuousActionGroups":[]}],"createdOn":1749546287890},"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function AiAgents(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _comingSoon = param.comingSoon, comingSoon = _comingSoon === void 0 ? "Coming soon" : _comingSoon, _title = param.title, title = _title === void 0 ? "Meet your AI assistants" : _title, _subTitle = param.subTitle, subTitle = _subTitle === void 0 ? "Describe the job. Your custom AI assistant is created, ready to work 24/7." : _subTitle, _card1Title = param.card1Title, card1Title = _card1Title === void 0 ? "SDR Expert" : _card1Title, _card2Title = param.card2Title, card2Title = _card2Title === void 0 ? "Competitor Analyzer" : _card2Title, _card3Title = param.card3Title, card3Title = _card3Title === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "monday sidekick",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _card3Title, _card4Title = param.card4Title, card4Title = _card4Title === void 0 ? "Project Assistant" : _card4Title, _card5Title = param.card5Title, card5Title = _card5Title === void 0 ? "Service Agent" : _card5Title, _card6Title = param.card6Title, card6Title = _card6Title === void 0 ? "Scrum Master" : _card6Title, _card1Text = param.card1Text, card1Text = _card1Text === void 0 ? "Proactively sources, enriches, and scores new leads, 24/7." : _card1Text, _card2Text = param.card2Text, card2Text = _card2Text === void 0 ? "Generates market research and trend reports, daily." : _card2Text, _card3Text = param.card3Text, card3Text = _card3Text === void 0 ? "Just ask. The assistant handles your work for you." : _card3Text, _card4Text = param.card4Text, card4Text = _card4Text === void 0 ? "Flags risks and automates project processes, in real time." : _card4Text, _card5Text = param.card5Text, card5Text = _card5Text === void 0 ? "Automatically triages and resolves support tickets." : _card5Text, _card6Text = param.card6Text, card6Text = _card6Text === void 0 ? "Plans sprints, assigns work, and flags blockers." : _card6Text, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Get Started" : _buttonText, _secondButtonText = param.secondButtonText, secondButtonText = _secondButtonText === void 0 ? "Visit our AI Trust Center" : _secondButtonText, _card1ImageOnHover = param.card1ImageOnHover, card1ImageOnHover = _card1ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-1.avif" : _card1ImageOnHover, _card2ImageOnHover = param.card2ImageOnHover, card2ImageOnHover = _card2ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-2.avif" : _card2ImageOnHover, _card3ImageOnHover = param.card3ImageOnHover, card3ImageOnHover = _card3ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-4.avif" : _card3ImageOnHover, _card4ImageOnHover = param.card4ImageOnHover, card4ImageOnHover = _card4ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-3.avif" : _card4ImageOnHover, _card5ImageOnHover = param.card5ImageOnHover, card5ImageOnHover = _card5ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-5.avif" : _card5ImageOnHover, _card6ImageOnHover = param.card6ImageOnHover, card6ImageOnHover = _card6ImageOnHover === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-6.avif" : _card6ImageOnHover;
    interactions/* useInteractions */.NI(_interactionsData, (AiAgents_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((AiAgents_module_default()), "sec-specialists"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((AiAgents_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((AiAgents_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((AiAgents_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiAgents_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((AiAgents_module_default()), "labe-gradient-parent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "labe-gradient-inner"),
                                        tag: "div",
                                        children: comingSoon
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((AiAgents_module_default()), "fw1_section-headline-parent", "is--center"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                            className: utils.cx((AiAgents_module_default()), "fw1_section-title", "m_text-color-white"),
                                            tag: "h2",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                            className: utils.cx((AiAgents_module_default()), "sec-sub-center-par", "m_text-color-white"),
                                            children: subTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            value: "%3Cstyle%3E%0A%2F*%20Base%20transition%20rules%20-%20CRITICAL%20for%20animations%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%20%7B%0A%20%20transition%3A%20background-color%20600ms%20ease%2C%20width%20800ms%20ease%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-teams-card-title%22%5D%20%7B%0A%20%20transition%3A%20color%20600ms%20ease%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-teams-card-par%22%5D%5Bclass*%3D%22is-short%22%5D%20%7B%0A%20%20transition%3A%20color%20600ms%20ease%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-spec-card-img-before-parent%22%5D%20%7B%0A%20%20transition%3A%20opacity%20600ms%20ease%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-spec-card-img-after-parent%22%5D%20%7B%0A%20%20transition%3A%20opacity%20600ms%20ease%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D.is-active%20%5Bclass*%3D%22ai-spec-card-img-before-parent%22%5D%20%7B%0A%20%20opacity%3A%200%20!important%3B%0A%7D%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D.is-active%20%5Bclass*%3D%22ai-spec-card-img-after-parent%22%5D%20%7B%0A%20%20opacity%3A%201%20!important%3B%0A%7D%0A%0A%2F*%20Background%20color%20and%20width%20changes%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D.is-active%20%7B%0A%20%20width%3A%2036.5rem%20!important%3B%0A%20%20background-color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%5Bclass*%3D%22agent-card-6%22%5D.is-active%20%7B%0A%20%20background-color%3A%20var(--dev--primary)%20!important%3B%0A%20%20color%3A%20var(--brand--black)%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%5Bclass*%3D%22agent-card-5%22%5D.is-active%20%7B%0A%20%20background-color%3A%20var(--service--contrast)%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%5Bclass*%3D%22agent-card-3%22%5D.is-active%20%7B%0A%20%20background-color%3A%20var(--brand--working-orange)%20!important%3B%0A%20%20color%3A%20var(--brand--black)%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%5Bclass*%3D%22agent-card-2%22%5D.is-active%20%7B%0A%20%20background-color%3A%20var(--crm--dark)%20!important%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22ai-specialist-card%22%5D%5Bclass*%3D%22agent-card-1%22%5D.is-active%20%7B%0A%20%20background-color%3A%20var(--brand--primary-blue)%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((AiAgents_module_default()), "comp_ai-spec"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((AiAgents_module_default()), "comp_ai-spec-moving"),
                                tag: "div",
                                "data-interactive-selector": "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card", "agent-card-2"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card1Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short"),
                                                        children: card1Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751456399/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-2.png",
                                                    alt: "ai-agent-hp-2"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card1ImageOnHover,
                                                    alt: "ai-agent-board-2"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card", "agent-card-3"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card2Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short"),
                                                        children: card2Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751793879/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-3.png",
                                                    alt: "ai-agent-hp-3"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card2ImageOnHover,
                                                    alt: "ai-agent-board-6"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card", "agent-card-1", "is-active"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card3Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short-2"),
                                                        children: card3Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751456399/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-1.avif",
                                                    alt: "ai-agent-hp-1"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card3ImageOnHover,
                                                    alt: "ai-agent-board-1"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card4Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short"),
                                                        children: card4Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751793401/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-4.avif",
                                                    alt: "ai-agent-hp-4"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card4ImageOnHover,
                                                    alt: "ai-agent-board-6"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card", "agent-card-5"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card5Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short"),
                                                        children: card5Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751456399/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-5.png",
                                                    alt: "ai-agent-hp-5"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card5ImageOnHover,
                                                    alt: "ai-agent-board-6"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((AiAgents_module_default()), "ai-specialist-card", "agent-card-6"),
                                        tag: "div",
                                        "data-interactive-selector-item": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-teams-card-top"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-title"),
                                                        tag: "div",
                                                        children: card6Title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                        className: utils.cx((AiAgents_module_default()), "ai-teams-card-par", "is-short"),
                                                        children: card6Text
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-before-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-before"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1751456399/Generator_featured%20images/hp-2025/agents/before/hp-ai-agent-hp-6.png",
                                                    alt: "ai-agent-hp-6"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "ai-spec-card-img-after-parent"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((AiAgents_module_default()), "ai-teams-card-img-after"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: card6ImageOnHover,
                                                    alt: "ai-agent-board-6"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiAgents_module_default()), "fw1_button-combo", "for--agents"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                    className: utils.cx((AiAgents_module_default()), "m_button", "m_button-primary-white", "hero-btn-project"),
                                    tag: "a",
                                    slot: "",
                                    "data-button-type": "signup",
                                    href: "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            tag: "div",
                                            children: buttonText
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            className: utils.cx((AiAgents_module_default()), "m_button-arrow"),
                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                        className: utils.cx((AiAgents_module_default()), "m_button-link", "m_button-link-white"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/w/ai-trust-center",
                                            target: "_blank"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: secondButtonText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiAgents_module_default()), "m_link-underline", "link-underline-white"),
                                                tag: "div"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/AiTeamsImpact.module.css
var AiTeamsImpact_module = __webpack_require__(98516);
var AiTeamsImpact_module_default = /*#__PURE__*/__webpack_require__.n(AiTeamsImpact_module);
;// CONCATENATED MODULE: ./devlink/AiTeamsImpact.js
"use client";





function AiTeamsImpact(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? "Your teams’ impact. Multiplied by AI." : _title, _cta = param.cta, cta = _cta === void 0 ? "Learn more about monday's AI offering" : _cta, _sectionVisibility = param.sectionVisibility, sectionVisibility = _sectionVisibility === void 0 ? true : _sectionVisibility;
    return sectionVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((AiTeamsImpact_module_default()), "sec-teams"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((AiTeamsImpact_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((AiTeamsImpact_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((AiTeamsImpact_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiTeamsImpact_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-star"),
                                    loading: "lazy",
                                    width: "auto",
                                    height: "auto",
                                    alt: "",
                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6843441dbf070225912699df_ai-star.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((AiTeamsImpact_module_default()), "fw1_section-headline-parent"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                            className: utils.cx((AiTeamsImpact_module_default()), "fw1_section-title-lr", "is--shorter", "m_text-color-white"),
                                            tag: "h2",
                                            children: title
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            value: "%3Cstyle%3E%0A.comp_teams-tabs%20.splide__arrows%7B%0Adisplay%3Anone%3B%20%0A%7D%0A%0A%3C%2Fstyle%3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpact_module_default()), "fw1_button-parent", "for--impact"),
                                            id: utils.cx((AiTeamsImpact_module_default()), "w-node-_08c9486e-f209-18cb-67c7-4107f41fcc35-83da2f7a"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                className: utils.cx((AiTeamsImpact_module_default()), "m_button-link", "m_button-link-white"),
                                                button: false,
                                                block: "inline",
                                                options: {
                                                    href: "https://monday.com/w/ai",
                                                    target: "_blank"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        tag: "div",
                                                        children: cta
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((AiTeamsImpact_module_default()), "m_button-arrow"),
                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiTeamsImpact_module_default()), "m_link-underline", "link-underline-white"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiTeamsImpact_module_default()), "comp_teams-tabs"),
                            tag: "div",
                            "data-splide-type": "tabs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((AiTeamsImpact_module_default()), "hp_teams-fade"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-layout"),
                                    tag: "div",
                                    "data-splide-wrapper": "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-left"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-left-child"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((AiTeamsImpact_module_default()), "splide", "for--ai--teams"),
                                                    tag: "div",
                                                    "data-splide-role": "nav",
                                                    role: "tablist",
                                                    "aria-label": "Tab Navigation",
                                                    "data-focus": "left",
                                                    "data-gap": "1rem",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-tabs-menu", "splide__track"),
                                                        tag: "div",
                                                        "data-splide-element": "track",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-tabs-list", "splide__list"),
                                                            tag: "ul",
                                                            "aria-label": "Tab Navigation",
                                                            "data-splide-element": "list",
                                                            unstyled: false,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-parent", "splide__slide", "is-active"),
                                                                    role: "presentation",
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "0",
                                                                        id: "tab-teams-1",
                                                                        role: "tab",
                                                                        "aria-selected": "true",
                                                                        "aria-controls": "panel-1",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434427d01d8650b4b38dda_ai-impact-icon-1.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: "Predict risks early"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    role: "presentation",
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-2",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-2",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e840ff5d6bcbfba4c_ai-impact-icon-2.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: "Scale marketing output"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-3",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-3",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e314914781dd122a4_ai-impact-icon-3.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: "Boost sales velocity"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-4",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-4",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6ef93a6363a3b24abc_ai-impact-icon-4.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: "Resolve tickets faster"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-5",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-5",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpact_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e053354f15983318b_ai-impact-icon-5.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: "Drive quality sprints"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpact_module_default()), "ai-teams-right"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiTeamsImpact_module_default()), "splide", "_w--video"),
                                                tag: "div",
                                                "data-splide-role": "content",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((AiTeamsImpact_module_default()), "splide__track", "for--tabs-content"),
                                                    tag: "div",
                                                    "data-splide-element": "track",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((AiTeamsImpact_module_default()), "splide__list"),
                                                        tag: "div",
                                                        "data-splide-element": "list",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpact_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-1",
                                                                tabIndex: "0",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-blocks-vid-embed"),
                                                                    value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751884472%2F_AI_tab_WM_-_Risk-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751884472%2F_AI_tab_WM_-_Risk-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpact_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-2",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-blocks-vid-embed"),
                                                                    value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486626%2F_AI_tab_WM_-_Scale_marketing_output.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486626%2F_AI_tab_WM_-_Scale_marketing_output.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpact_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-3",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-blocks-vid-embed"),
                                                                    value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486625%2F_AI_tab_CRM.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486625%2F_AI_tab_CRM.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpact_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-4",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-4",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-blocks-vid-embed"),
                                                                    value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486623%2F_AI_tab_SERVICE.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486623%2F_AI_tab_SERVICE.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpact_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-5",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                    className: utils.cx((AiTeamsImpact_module_default()), "ai-blocks-vid-embed"),
                                                                    value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486622%2F_AI_tab_DEV.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751486622%2F_AI_tab_DEV.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }) : null;
}

// EXTERNAL MODULE: ./devlink/AiTeamsImpactLang.module.css
var AiTeamsImpactLang_module = __webpack_require__(96663);
var AiTeamsImpactLang_module_default = /*#__PURE__*/__webpack_require__.n(AiTeamsImpactLang_module);
;// CONCATENATED MODULE: ./devlink/AiTeamsImpactLang.js
"use client";





function AiTeamsImpactLang(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Block : tmp, _slide1Title = param.slide1Title, slide1Title = _slide1Title === void 0 ? "Predict risks early" : _slide1Title, _slide2Title = param.slide2Title, slide2Title = _slide2Title === void 0 ? "Scale marketing output" : _slide2Title, _slide3Title = param.slide3Title, slide3Title = _slide3Title === void 0 ? "Boost sales velocity" : _slide3Title, _slide4Title = param.slide4Title, slide4Title = _slide4Title === void 0 ? "Resolve tickets faster" : _slide4Title, _slide5Title = param.slide5Title, slide5Title = _slide5Title === void 0 ? "Drive quality sprints" : _slide5Title, _impactTitle = param.impactTitle, impactTitle = _impactTitle === void 0 ? "Your teams’ impact. Multiplied by AI." : _impactTitle, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Learn more about monday's AI offering" : _buttonText, _tab1Image = param.tab1Image, tab1Image = _tab1Image === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png" : _tab1Image, _tab2Image = param.tab2Image, tab2Image = _tab2Image === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png" : _tab2Image, _tab3Image = param.tab3Image, tab3Image = _tab3Image === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png" : _tab3Image, _tab4Image = param.tab4Image, tab4Image = _tab4Image === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png" : _tab4Image, _tab5Image = param.tab5Image, tab5Image = _tab5Image === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png" : _tab5Image, _sectionVisibility = param.sectionVisibility, sectionVisibility = _sectionVisibility === void 0 ? true : _sectionVisibility;
    return sectionVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((AiTeamsImpactLang_module_default()), "sec-teams"),
        tag: "div",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((AiTeamsImpactLang_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((AiTeamsImpactLang_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((AiTeamsImpactLang_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiTeamsImpactLang_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-star"),
                                    width: "auto",
                                    height: "auto",
                                    loading: "lazy",
                                    alt: "",
                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6843441dbf070225912699df_ai-star.svg"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((AiTeamsImpactLang_module_default()), "fw1_section-headline-parent"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                            className: utils.cx((AiTeamsImpactLang_module_default()), "fw1_section-title-lr", "is--shorter", "m_text-color-white"),
                                            tag: "h2",
                                            children: impactTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            value: "%3Cstyle%3E%0A.comp_teams-tabs%20.splide__arrows%7B%0Adisplay%3Anone%3B%20%0A%7D%0A%0A%3C%2Fstyle%3E"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpactLang_module_default()), "fw1_button-parent", "for--impact"),
                                            id: utils.cx((AiTeamsImpactLang_module_default()), "w-node-a09da984-2486-1b52-5bee-08a9cb2e2dc4-cb2e2dbb"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                className: utils.cx((AiTeamsImpactLang_module_default()), "m_button-link", "m_button-link-white"),
                                                button: false,
                                                block: "inline",
                                                options: {
                                                    href: "https://monday.com/w/ai",
                                                    target: "_blank"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        tag: "div",
                                                        children: buttonText
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "m_button-arrow"),
                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "m_link-underline", "link-underline-white"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((AiTeamsImpactLang_module_default()), "comp_teams-tabs"),
                            tag: "div",
                            "data-splide-type": "tabs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((AiTeamsImpactLang_module_default()), "hp_teams-fade"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-layout"),
                                    tag: "div",
                                    "data-splide-wrapper": "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-left"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-left-child"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "splide", "for--ai--teams"),
                                                    tag: "div",
                                                    "data-splide-role": "nav",
                                                    role: "tablist",
                                                    "aria-label": "Tab Navigation",
                                                    "data-focus": "left",
                                                    "data-gap": "1rem",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-tabs-menu", "splide__track"),
                                                        tag: "div",
                                                        "data-splide-element": "track",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-tabs-list", "splide__list"),
                                                            tag: "ul",
                                                            "aria-label": "Tab Navigation",
                                                            "data-splide-element": "list",
                                                            unstyled: false,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-parent", "splide__slide", "is-active"),
                                                                    role: "presentation",
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "0",
                                                                        id: "tab-teams-1",
                                                                        role: "tab",
                                                                        "aria-selected": "true",
                                                                        "aria-controls": "panel-1",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434427d01d8650b4b38dda_ai-impact-icon-1.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: slide1Title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    role: "presentation",
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-2",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-2",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e840ff5d6bcbfba4c_ai-impact-icon-2.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: slide2Title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-3",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-3",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e314914781dd122a4_ai-impact-icon-3.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: slide3Title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-4",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-4",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6ef93a6363a3b24abc_ai-impact-icon-4.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: slide4Title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-parent", "splide__slide"),
                                                                    "data-splide-element": "slide",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-inner"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        tabindex: "-1",
                                                                        id: "tab-teams-5",
                                                                        role: "tab",
                                                                        "aria-selected": "false",
                                                                        "aria-controls": "panel-5",
                                                                        "data-tab": "",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-link-child"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "ai_impact-icon"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68434b6e053354f15983318b_ai-impact-icon-5.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "ai-impact-tab-h"),
                                                                                    tag: "div",
                                                                                    children: slide5Title
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((AiTeamsImpactLang_module_default()), "ai-teams-right"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide", "for--impact-lang"),
                                                tag: "div",
                                                "data-splide-role": "content",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "splide__track", "for--tabs-content"),
                                                    tag: "div",
                                                    "data-splide-element": "track",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((AiTeamsImpactLang_module_default()), "splide__list"),
                                                        tag: "div",
                                                        "data-splide-element": "list",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-1",
                                                                tabIndex: "0",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-1",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "lang-impact-img"),
                                                                    loading: "lazy",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    alt: "",
                                                                    src: tab1Image
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-2",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-2",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "lang-impact-img"),
                                                                    loading: "lazy",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    alt: "",
                                                                    src: tab2Image
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-3",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-3",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "lang-impact-img"),
                                                                    loading: "lazy",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    alt: "",
                                                                    src: tab3Image
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-4",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-4",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "lang-impact-img"),
                                                                    loading: "lazy",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    alt: "",
                                                                    src: tab4Image
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((AiTeamsImpactLang_module_default()), "splide__slide", "for--tab-pane"),
                                                                tag: "div",
                                                                role: "tabpanel",
                                                                "aria-labelledby": "tab-5",
                                                                tabIndex: "-1",
                                                                "data-splide-element": "slide",
                                                                id: "team-spanel-5",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((AiTeamsImpactLang_module_default()), "lang-impact-img"),
                                                                    loading: "lazy",
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    alt: "",
                                                                    src: tab5Image
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }) : null;
}

// EXTERNAL MODULE: ./devlink/BrightHeroLeftPannel.module.css
var BrightHeroLeftPannel_module = __webpack_require__(51480);
var BrightHeroLeftPannel_module_default = /*#__PURE__*/__webpack_require__.n(BrightHeroLeftPannel_module);
;// CONCATENATED MODULE: ./devlink/BrightHeroLeftPannel.js
"use client";






var BrightHeroLeftPannel_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-69"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-73"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-82":{"id":"e-82","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-43","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".sec-hero","originalId":"6853e34886981d09931d6260|1f883a32-b6a8-3fec-7659-8c0c1a0c213a","appliesTo":"CLASS"},"targets":[{"selector":".sec-hero","originalId":"6853e34886981d09931d6260|1f883a32-b6a8-3fec-7659-8c0c1a0c213a","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-43-p","smoothing":95,"startsEntering":false,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1753636194346}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-43":{"id":"a-43","title":"Hero-stars 2","continuousParameterGroups":[{"id":"a-43-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-43-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-43-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-43-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":40,"actionItems":[{"id":"a-43-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":8,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":80,"actionItems":[{"id":"a-43-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-43-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1751525871949}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function BrightHeroLeftPannel(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(BrightHeroLeftPannel_interactionsData, (BrightHeroLeftPannel_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((BrightHeroLeftPannel_module_default()), "white-sec-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((BrightHeroLeftPannel_module_default()), "m_padding-global-big-cards", "m_padding-section-big-card"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_full-card-bright-hero"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                    className: utils.cx((BrightHeroLeftPannel_module_default()), "m_container-xl-w"),
                    tag: "div",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((BrightHeroLeftPannel_module_default()), "group_hero-center-all"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_hero-title-parent"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "fw1_hero-title-black"),
                                        tag: "h1",
                                        children: [
                                            "One AI work platform",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                            "for any kind of work"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "subtitle-white-test-max-width"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "fw1_hero-sub-black"),
                                            children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp-hero-btnsparent"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                            tag: "a",
                                            "data-button-type": "signup",
                                            href: "",
                                            "data-tabs-buttons": "hero",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    children: "Get Started"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_spacer-3rem"),
                                        tag: "div"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((BrightHeroLeftPannel_module_default()), "comp_hp-hero-tabs"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-star-1"),
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a47b0d4a0b1721883da4d6_AI-star.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-star-2-white"),
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a47b0d4a0b1721883da4d6_AI-star.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tabs-fu"),
                                        current: "Projects",
                                        easing: "ease-out-circ",
                                        fadeIn: 600,
                                        fadeOut: 0,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tabs-menu-white"),
                                                tag: "div",
                                                "data-hero-tabs": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "Projects",
                                                        "data-tab": "",
                                                        "data-tag-theme": "projects",
                                                        "data-cluster": "product_management",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-projects.png",
                                                                    alt: "hp-headshot-projects"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Projects"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "Marketing",
                                                        "data-tab": "",
                                                        "data-tag-theme": "marketing",
                                                        "data-cluster": "marketing",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-marketing.png",
                                                                    alt: "hp-headshot-sales"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Marketing"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "Sales",
                                                        "data-tab": "",
                                                        "data-tag-theme": "sales",
                                                        "data-tab-product": "crm",
                                                        "data-cluster": "crm",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-sales.png",
                                                                    alt: "hp-headshot-sales"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Sales"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "Operation",
                                                        "data-tab": "",
                                                        "data-tag-theme": "ops",
                                                        "data-cluster": "operations",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-ops.png",
                                                                    alt: "hp-headshot-ops"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Operations"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "Software",
                                                        "data-tab": "",
                                                        "data-tag-theme": "software",
                                                        "data-tab-product": "dev",
                                                        "data-cluster": "tech",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-software.png",
                                                                    alt: "hp-headshot-software"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Software"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-white"),
                                                        "data-w-tab": "IT & Support",
                                                        "data-tab": "",
                                                        "data-tag-theme": "it",
                                                        "data-tab-product": "service",
                                                        "data-cluster": "information_technology",
                                                        block: "inline",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-white"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-card-gradient-inner-headshot-white"),
                                                                    tag: "img",
                                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-support.png",
                                                                    alt: "hp-headshot-it"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "IT & Support"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tabs-content-fu"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "Projects",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a47f58100c114cd1138c4d_Projects-launch-planLotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431337-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        href: "",
                                                                        "data-cluster": "product_management",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "Marketing",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43133e-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a48384b618e4cd51344c3c_Marketing-campaign-Lotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431340-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        href: "",
                                                                        "data-cluster": "marketing",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "Sales",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431347-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a483840534d8b22979355a_Sales-leadsupdatedLotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431349-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        "data-product-id": "crm",
                                                                        href: "",
                                                                        "data-cluster": "crm",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "Operation",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431350-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a483831302a78eaf65085d_Operations-conference-planningupdatedLotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431352-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        href: "",
                                                                        "data-cluster": "operations",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "Software",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431359-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a48384b81a8a56e51e1724_Software-sprintupdatedLotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43135b-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        "data-product-id": "dev",
                                                                        href: "",
                                                                        "data-cluster": "tech",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "IT & Support",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-inner"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white-fu"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431362-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp_hero-tab-board-parent-white"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "eager",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68a483847e966ef692651bdc_SupportandIT-ticketsupdatedLotem.webp"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((BrightHeroLeftPannel_module_default()), "hero_tabs-btn-parent-white"),
                                                                    id: utils.cx((BrightHeroLeftPannel_module_default()), "w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431364-1b4312fb"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                        tag: "a",
                                                                        "data-button-type": "signup",
                                                                        "data-tabs-buttons": "tabs",
                                                                        "data-product-id": "service",
                                                                        href: "",
                                                                        "data-cluster": "information_technology",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "m_button-arrow"),
                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((BrightHeroLeftPannel_module_default()), "hp-hero-tabs-menu-top-white"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((BrightHeroLeftPannel_module_default()), "hero-tabs-menu-top-h-white"),
                                                tag: "div",
                                                children: "What would you like to manage?"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                value: "%3Cstyle%3E%0A%40keyframes%20swoosh%20%7B%0A%20%200%25%20%7B%0A%20%20%20%20background-position%3A%20200%25%3B%0A%20%20%0A%20%20%7D%0A%20%20100%25%20%7B%0A%20%20%20%20background-position%3A%20-200%25%3B%0A%20%20%7D%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22what--span%22%5D%20%7B%0A%20%20background-size%3A%20200%25%3B%0A%20%20background-position%3A%20-200%25%3B%0A%20%20animation%3A%20swoosh%206s%20cubic-bezier(0.4%2C%200%2C%200.2%2C%201)%20infinite%3B%0A%7D%0A%3C%2Fstyle%3E"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                value: "%3Cstyle%3E%0A.hero-tab-gradient.is-active%20.hero-card-gradient-inner%20%7B%0A%20%20background-color%3A%20white%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%207px%3B%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22m_tab-arrow%22%5D%20%7B%0A%20%20opacity%3A%201%3B%0A%7D%0A%3C%2Fstyle%3E"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/CaseStudies.module.css
var CaseStudies_module = __webpack_require__(64122);
var CaseStudies_module_default = /*#__PURE__*/__webpack_require__.n(CaseStudies_module);
;// CONCATENATED MODULE: ./devlink/CaseStudies.js
"use client";






var CaseStudies_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function CaseStudies(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? "Leading brands drive efficient growth with monday.com" : _title, _buttonText = param.buttonText, buttonText = _buttonText === void 0 ? "Contact sales" : _buttonText, _case1Logo = param.case1Logo, case1Logo = _case1Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734d99fde1ee8d76038_logo-height-mcdonalds.svg" : _case1Logo, _case2Logo = param.case2Logo, case2Logo = _case2Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg" : _case2Logo, _case3Logo = param.case3Logo, case3Logo = _case3Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg" : _case3Logo, _case4Logo = param.case4Logo, case4Logo = _case4Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg" : _case4Logo, _case5Logo = param.case5Logo, case5Logo = _case5Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997346fd24ab09e1a1264_logo-height-universal.svg" : _case5Logo, _case6Logo = param.case6Logo, case6Logo = _case6Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734e774c48a76e64d64_logo-height-compass.svg" : _case6Logo, _case7Logo = param.case7Logo, case7Logo = _case7Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg" : _case7Logo, _case8Logo = param.case8Logo, case8Logo = _case8Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734626e8d76fb98b8ef_logo-height-callbox.svg" : _case8Logo, _case9Logo = param.case9Logo, case9Logo = _case9Logo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997344e69395c270955c1_logo-height-deezer.svg" : _case9Logo, _case1Link = param.case1Link, case1Link = _case1Link === void 0 ? "See the case study" : _case1Link, _case2Link = param.case2Link, case2Link = _case2Link === void 0 ? "See the case study" : _case2Link, _case3Link = param.case3Link, case3Link = _case3Link === void 0 ? "See the case study" : _case3Link, _case4Link = param.case4Link, case4Link = _case4Link === void 0 ? "See the case study" : _case4Link, _case5Link = param.case5Link, case5Link = _case5Link === void 0 ? "See the case study" : _case5Link, _case6Link = param.case6Link, case6Link = _case6Link === void 0 ? "See the case study" : _case6Link, _case7Link = param.case7Link, case7Link = _case7Link === void 0 ? "See the case study" : _case7Link, _case8Link = param.case8Link, case8Link = _case8Link === void 0 ? "See the case study" : _case8Link, _case9Link = param.case9Link, case9Link = _case9Link === void 0 ? "See the case study" : _case9Link, _case1Number = param.case1Number, case1Number = _case1Number === void 0 ? "615%" : _case1Number, _case2Number = param.case2Number, case2Number = _case2Number === void 0 ? "105K" : _case2Number, _case3Number = param.case3Number, case3Number = _case3Number === void 0 ? "300%" : _case3Number, _case4Number = param.case4Number, case4Number = _case4Number === void 0 ? "28%" : _case4Number, _case5Number = param.case5Number, case5Number = _case5Number === void 0 ? "517%" : _case5Number, _case6Number = param.case6Number, case6Number = _case6Number === void 0 ? "$173K" : _case6Number, _case7Number = param.case7Number, case7Number = _case7Number === void 0 ? "$250K" : _case7Number, _case8Number = param.case8Number, case8Number = _case8Number === void 0 ? "66%" : _case8Number, _case9Number = param.case9Number, case9Number = _case9Number === void 0 ? "142%" : _case9Number, _case9Text = param.case9Text, case9Text = _case9Text === void 0 ? "More weekly campaigns" : _case9Text, _case8Text = param.case8Text, case8Text = _case8Text === void 0 ? "Decrease in post-release bugs" : _case8Text, _case7Text = param.case7Text, case7Text = _case7Text === void 0 ? "Saved yearly to reinvest" : _case7Text, _case6Text = param.case6Text, case6Text = _case6Text === void 0 ? "Saved per month" : _case6Text, _case5Text = param.case5Text, case5Text = _case5Text === void 0 ? "Growth in annual accounts" : _case5Text, _case4Text = param.case4Text, case4Text = _case4Text === void 0 ? "Faster time to market" : _case4Text, _case3Text = param.case3Text, case3Text = _case3Text === void 0 ? "Saved yearly to reinvest" : _case3Text, _case2Text = param.case2Text, case2Text = _case2Text === void 0 ? "Hours saved annually " : _case2Text, _case1Tag = param.case1Tag, case1Tag = _case1Tag === void 0 ? "Retail & CPG" : _case1Tag, _case2Tag = param.case2Tag, case2Tag = _case2Tag === void 0 ? "Manufacturing" : _case2Tag, _case3Tag = param.case3Tag, case3Tag = _case3Tag === void 0 ? "Advertising" : _case3Tag, _case4Tag = param.case4Tag, case4Tag = _case4Tag === void 0 ? "Technology" : _case4Tag, _case5Tag = param.case5Tag, case5Tag = _case5Tag === void 0 ? "Entertainment" : _case5Tag, _case6Tag = param.case6Tag, case6Tag = _case6Tag === void 0 ? "Real estate" : _case6Tag, _case7Tag = param.case7Tag, case7Tag = _case7Tag === void 0 ? "Advertising" : _case7Tag, _case8Tag = param.case8Tag, case8Tag = _case8Tag === void 0 ? "Technology" : _case8Tag, _case9Tag = param.case9Tag, case9Tag = _case9Tag === void 0 ? "Technology" : _case9Tag, _case2UrlLink = param.case2UrlLink, case2UrlLink = _case2UrlLink === void 0 ? {
        href: "https://www.youtube.com/watch?v=OU1IVTMX4ZI",
        target: "_blank"
    } : _case2UrlLink, _case3UrlLink = param.case3UrlLink, case3UrlLink = _case3UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/canva",
        target: "_blank"
    } : _case3UrlLink, _case4UrlLink = param.case4UrlLink, case4UrlLink = _case4UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/vistra",
        target: "_blank"
    } : _case4UrlLink, _case5UrlLink = param.case5UrlLink, case5UrlLink = _case5UrlLink === void 0 ? {
        href: "https://www.youtube.com/watch?v=qytqG3VwLlg",
        target: "_blank"
    } : _case5UrlLink, _case6UrlLink = param.case6UrlLink, case6UrlLink = _case6UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/compass",
        target: "_blank"
    } : _case6UrlLink, _case7UrlLink = param.case7UrlLink, case7UrlLink = _case7UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/vml",
        target: "_blank"
    } : _case7UrlLink, _case8UrlLink = param.case8UrlLink, case8UrlLink = _case8UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/call-box",
        target: "_blank"
    } : _case8UrlLink, _case9UrlLink = param.case9UrlLink, case9UrlLink = _case9UrlLink === void 0 ? {
        href: "https://monday.com/w/customer-stories/deezer",
        target: "_blank"
    } : _case9UrlLink, _case1Image = param.case1Image, case1Image = _case1Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-1.avif" : _case1Image, _case2Image = param.case2Image, case2Image = _case2Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-2.avif" : _case2Image, _case4Image = param.case4Image, case4Image = _case4Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-4.avif" : _case4Image, _case5Image = param.case5Image, case5Image = _case5Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-5.avif" : _case5Image, _case3Image = param.case3Image, case3Image = _case3Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-3.avif" : _case3Image, _case6Image = param.case6Image, case6Image = _case6Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-6.avif" : _case6Image, _case7Image = param.case7Image, case7Image = _case7Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-7.avif" : _case7Image, _case8Image = param.case8Image, case8Image = _case8Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-8.avif" : _case8Image, _case9Image = param.case9Image, case9Image = _case9Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-9.avif" : _case9Image;
    interactions/* useInteractions */.NI(CaseStudies_interactionsData, (CaseStudies_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((CaseStudies_module_default()), "sec-case-studies"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((CaseStudies_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((CaseStudies_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((CaseStudies_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((CaseStudies_module_default()), "group_sec-h-sbs", "for-quotes"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((CaseStudies_module_default()), "sec-h-sbs-start"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        className: utils.cx((CaseStudies_module_default()), "fw1_section-title", "is--short"),
                                        tag: "h2",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                    value: "%3C!--%2F%2F--%3E%0A%3Cstyle%3E%0A%2F*%20Overide%20default%20styles%20so%20all%20slides%20are%20visible%20*%2F%0A%5Bclass*%3D%22sec-case-studies%22%5D%20%5Bclass*%3D%22splide__track%22%5D%20%7B%0A%20overflow%3A%20visible%3B%0A%20touch-action%3A%20pan-y%3B%20%2F*%20Prevents%20scrolling%20conflicts%20*%2F%0A%7D%0A%0A%5Bclass*%3D%22sec-case-studies%22%5D%20%5Bclass*%3D%22splide%22%5D%20button%5Bdisabled%5D%20%7B%0A%20%20opacity%3A%200.2%3B%0A%20%20cursor%3A%20none%3B%0A%7D%0A%5Bclass*%3D%22sec-case-studies%22%5D%20%5Bclass*%3D%22splide__pagination%22%5D%20%7B%0A%09display%3A%20none%3B%0A%7D%0A%3C%2Fstyle%3E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((CaseStudies_module_default()), "sec-h-sbs-end"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((CaseStudies_module_default()), "fw1_button-combo"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                            className: utils.cx((CaseStudies_module_default()), "m_button"),
                                            id: utils.cx((CaseStudies_module_default()), "w-node-_6a9d9fd9-a184-bbcb-60b9-4a53d48c7416-d48c740c"),
                                            button: false,
                                            "data-button-type": "homepage-contact-sales",
                                            block: "inline",
                                            options: {
                                                href: "#"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    children: buttonText
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                    className: utils.cx((CaseStudies_module_default()), "m_button-arrow"),
                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((CaseStudies_module_default()), "splide", "_w--arrow-bottom", "slider1"),
                            tag: "div",
                            "data-splide-type": "slider",
                            "data-splide-component-name": "case-studeis",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((CaseStudies_module_default()), "splide__track"),
                                    tag: "div",
                                    "data-splide-element": "track",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((CaseStudies_module_default()), "splide__list"),
                                        tag: "div",
                                        "data-splide-element": "list",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case1Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: {
                                                                    href: "https://monday.com/w/customer-stories/mcdonalds",
                                                                    target: "_blank"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case1Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case1Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case1Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: "Return on investment"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case1Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case2Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case2UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case2Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case2Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case2Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case2Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case2Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case3Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case3UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case3Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case3Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case3Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case3Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case3Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case4Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case4UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case4Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case4Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case4Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case4Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case4Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case5Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case5UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case5Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case5Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case5Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case5Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case5Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case6Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case6UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case6Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case6Image,
                                                        alt: "customer story cover"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case6Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case6Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case6Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case7Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case7UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case7Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case7Image,
                                                        alt: "customer story cover of mcdonalds"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case7Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case7Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case7Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case8Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case8UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case8Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case8Image,
                                                        alt: "customer story cover of mcdonalds"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case8Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case8Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case8Tag
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card", "splide__slide"),
                                                tag: "div",
                                                "data-splide-element": "slide",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((CaseStudies_module_default()), "hp_tab-customer-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: case9Logo
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((CaseStudies_module_default()), "m_button-link-small"),
                                                                button: false,
                                                                block: "inline",
                                                                options: case9UrlLink,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: case9Link
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((CaseStudies_module_default()), "m_link-underline"),
                                                                        tag: "div"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-cover"),
                                                        slot: "",
                                                        tag: "img",
                                                        src: case9Image,
                                                        alt: "customer story cover of mcdonalds"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "group_case-card-number"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number"),
                                                                tag: "div",
                                                                children: case9Number
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CaseStudies_module_default()), "fw1_case-card-number-text"),
                                                                tag: "div",
                                                                children: case9Text
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CaseStudies_module_default()), "fw1_case-card-bottom"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((CaseStudies_module_default()), "fw1_case-card-industry-label"),
                                                            tag: "div",
                                                            children: case9Tag
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((CaseStudies_module_default()), "splide__arrows", "custom-arrows-1"),
                                    tag: "div",
                                    "data-splide-element": "arrows",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((CaseStudies_module_default()), "splide__arrow", "custom-arrow", "splide__arrow--prev", "custom-arrow-prev"),
                                            tag: "button",
                                            slot: "",
                                            "data-splide-element": "arrow",
                                            "data-splide-arrow-type": "prev",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((CaseStudies_module_default()), "splide-arrow-icon", "is--left"),
                                                loading: "lazy",
                                                width: "auto",
                                                height: "auto",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/684558cb976d76b06507fbe3_arrow-r.svg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((CaseStudies_module_default()), "splide__arrow", "custom-arrow", "splide__arrow--next", "custom-arrow-next"),
                                            tag: "button",
                                            slot: "",
                                            "data-splide-element": "arrow",
                                            "data-splide-arrow-type": "next",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((CaseStudies_module_default()), "splide-arrow-icon"),
                                                loading: "lazy",
                                                width: "auto",
                                                height: "auto",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/684558cb976d76b06507fbe3_arrow-r.svg"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/Closer.module.css
var Closer_module = __webpack_require__(94302);
var Closer_module_default = /*#__PURE__*/__webpack_require__.n(Closer_module);
;// CONCATENATED MODULE: ./devlink/Closer.js
"use client";






var Closer_interactionsData = JSON.parse('{"events":{"e-21":{"id":"e-21","name":"","animationType":"custom","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-22"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"9e8038b7-c991-e8dc-10ce-de463640a443","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"9e8038b7-c991-e8dc-10ce-de463640a443","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":30,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1750317510645},"e-22":{"id":"e-22","name":"","animationType":"custom","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-17","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-21"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"9e8038b7-c991-e8dc-10ce-de463640a443","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"9e8038b7-c991-e8dc-10ce-de463640a443","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1750317510646},"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-16":{"id":"a-16","title":"show closer headshots","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":-9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-13","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":-3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":-6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-16-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-14","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-12","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750317522859},"a-17":{"id":"a-17","title":"show closer headshots 2","actionItemGroups":[{"actionItems":[{"id":"a-17-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":-9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":-3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-17-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":-6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1750317522859},"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Closer(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(Closer_interactionsData, (Closer_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((Closer_module_default()), "sec-closer", "_w--video"),
        "data-w-id": "9e8038b7-c991-e8dc-10ce-de463640a443",
        grid: {
            type: "section"
        },
        tag: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                className: utils.cx((Closer_module_default()), "hp-closer-video-parent", "play-video-onscroll"),
                value: "%3Cvideo%20class%3D%22hp-closer-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751488475%2F_Closer_no_texts.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751488475%2F_Closer_no_texts.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751488475%2F_Closer_no_texts.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((Closer_module_default()), "group_sec-h-center-closer"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((Closer_module_default()), "fw1_section-headline-parent"),
                        tag: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            className: utils.cx((Closer_module_default()), "fw1_section-title-lr", "m_text-color-white", "for--cta"),
                            tag: "h2",
                            children: "The AI work platform your team will love to use"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((Closer_module_default()), "fw1_button-combo"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                className: utils.cx((Closer_module_default()), "m_button", "m_button-primary-white", "hero-btn-project"),
                                tag: "a",
                                slot: "",
                                "data-button-type": "signup",
                                href: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        tag: "div",
                                        children: "Get Started"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        className: utils.cx((Closer_module_default()), "m_button-arrow"),
                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((Closer_module_default()), "m_button-outline", "m_button-outline-white"),
                                id: utils.cx((Closer_module_default()), "w-node-_9e8038b7-c991-e8dc-10ce-de463640a45b-3640a443"),
                                button: false,
                                "data-button-type": "homepage-contact-sales",
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    tag: "div",
                                    children: "Contact Sales"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/CloserLlama.module.css
var CloserLlama_module = __webpack_require__(3715);
var CloserLlama_module_default = /*#__PURE__*/__webpack_require__.n(CloserLlama_module);
;// CONCATENATED MODULE: ./devlink/CloserLlama.js
"use client";






var CloserLlama_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-91":{"id":"e-91","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-52","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-92"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3094b515-2cda-d411-aab6-f2004b18a51e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3094b515-2cda-d411-aab6-f2004b18a51e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":30,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1756978135101},"e-92":{"id":"e-92","name":"","animationType":"preset","eventTypeId":"SCROLL_OUT_OF_VIEW","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-53","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-91"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"3094b515-2cda-d411-aab6-f2004b18a51e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"3094b515-2cda-d411-aab6-f2004b18a51e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1756978135101}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-52":{"id":"a-52","title":"show closer headshots 5","actionItemGroups":[{"actionItems":[{"id":"a-52-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":-9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":-3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":-6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-52-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-11","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-12","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-13","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-52-n-14","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuint","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750317522859},"a-53":{"id":"a-53","title":"show closer headshots 6","actionItemGroups":[{"actionItems":[{"id":"a-53-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-7","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","b80bd754-ba62-4ed8-1d17-0f9f8ee7fe50"]},"xValue":-9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-4","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","044d81a3-b441-527f-7b8d-9717591a64e5"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-1","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","5ac112e8-593b-1469-6c9f-9534b0b6cb63"]},"xValue":9.75,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-2","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","31f56d7c-63c1-9e54-f873-454acd56edbd"]},"xValue":6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-3","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","1fac00d7-2c29-cb54-262d-c9fc53e471ca"]},"xValue":3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-5","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","bce738b1-2fcb-ee72-ba81-f3ffaadfd786"]},"xValue":-3.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-53-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".ai-cta-closer-headshot.closer-headshot-6","selectorGuids":["072d575b-6d92-0641-774b-737de1afa2aa","010a99af-4a29-21b8-c91c-e6298297ddd8"]},"xValue":-6.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1750317522859}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function CloserLlama(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? "The AI work platform your team will love to use" : _title, _blackButtonText = param.blackButtonText, blackButtonText = _blackButtonText === void 0 ? "Contact Sales" : _blackButtonText, _blackButtonLink = param.blackButtonLink, blackButtonLink = _blackButtonLink === void 0 ? {
        href: "/sales/contact-us"
    } : _blackButtonLink, _whiteButtonText = param.whiteButtonText, whiteButtonText = _whiteButtonText === void 0 ? "Get Started" : _whiteButtonText;
    interactions/* useInteractions */.NI(CloserLlama_interactionsData, (CloserLlama_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((CloserLlama_module_default()), "sec-closer", "_w--video-llama"),
        "data-w-id": "3094b515-2cda-d411-aab6-f2004b18a51e",
        tag: "section",
        grid: {
            type: "section"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                className: utils.cx((CloserLlama_module_default()), "hp-closer-video-parent", "play-video-onscroll"),
                value: "%3Cvideo%20class%3D%22hp-closer-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1756978287%2FGenerator_featured%2520images%2Fhp-2025%2Fcloser%2F_Closer_w_llama_no_texts.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1756978287%2FGenerator_featured%2520images%2Fhp-2025%2Fcloser%2F_Closer_w_llama_no_texts.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1756978287%2FGenerator_featured%2520images%2Fhp-2025%2Fcloser%2F_Closer_w_llama_no_texts.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((CloserLlama_module_default()), "group_sec-h-llama-closer-absolute"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((CloserLlama_module_default()), "fw1_section-headline-parent"),
                        tag: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                            className: utils.cx((CloserLlama_module_default()), "fw1_section-title-lr", "m_text-color-white", "for--cta", "is-smaller-headline"),
                            tag: "h2",
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((CloserLlama_module_default()), "fw1_button-combo"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                className: utils.cx((CloserLlama_module_default()), "m_button", "m_button-primary-white", "hero-btn-project"),
                                tag: "a",
                                slot: "",
                                "data-button-type": "signup",
                                href: "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        tag: "div",
                                        children: whiteButtonText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        className: utils.cx((CloserLlama_module_default()), "m_button-arrow"),
                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((CloserLlama_module_default()), "m_button-outline", "m_button-outline-white"),
                                id: utils.cx((CloserLlama_module_default()), "w-node-_3094b515-2cda-d411-aab6-f2004b18a529-4b18a51e"),
                                button: false,
                                "data-button-type": "homepage-contact-sales",
                                block: "inline",
                                options: blackButtonLink,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    tag: "div",
                                    children: blackButtonText
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/CrmNav.module.css
var CrmNav_module = __webpack_require__(45998);
var CrmNav_module_default = /*#__PURE__*/__webpack_require__.n(CrmNav_module);
;// CONCATENATED MODULE: ./devlink/CrmNav.js
"use client";






var CrmNav_interactionsData = JSON.parse('{"events":{"e-109":{"id":"e-109","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-63","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-372"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"},"targets":[{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691946734681},"e-106":{"id":"e-106","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-60","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-371"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"},"targets":[{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691946734683},"e-111":{"id":"e-111","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-68","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-108"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-108":{"id":"e-108","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-65","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-111"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-110":{"id":"e-110","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-61","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-103"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-103":{"id":"e-103","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-57","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-110"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-102":{"id":"e-102","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-67","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-107"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-107":{"id":"e-107","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-59","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-102"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-105":{"id":"e-105","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-62","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-100"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"},"targets":[{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1704622700196},"e-100":{"id":"e-100","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-58","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"},"targets":[{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1704622700196},"e-104":{"id":"e-104","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-66","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-101"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"},"targets":[{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757848624549},"e-101":{"id":"e-101","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-64","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-104"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"},"targets":[{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757848624554},"e-112":{"id":"e-112","name":"","animationType":"custom","eventTypeId":"PAGE_SCROLL_UP","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-64","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-113"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1757849432554},"e-113":{"id":"e-113","name":"","animationType":"custom","eventTypeId":"PAGE_SCROLL_DOWN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-66","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-112"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1757849432555},"e-114":{"id":"e-114","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-69","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-115"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757921635436},"e-115":{"id":"e-115","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-70","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-114"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757921635437},"e-116":{"id":"e-116","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-71","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-117"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757922492685},"e-117":{"id":"e-117","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-72","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-116"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757922492686},"e-186":{"id":"e-186","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-94","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-187"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-187":{"id":"e-187","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-95","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-186"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-188":{"id":"e-188","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-96","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-189"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-189":{"id":"e-189","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-97","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-188"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318}},"actionLists":{"a-63":{"id":"a-63","title":"nav-buttom-hover 2","actionItemGroups":[{"actionItems":[{"id":"a-63-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-63-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{},"xValue":5,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1681971285006},"a-60":{"id":"a-60","title":"nav-buttom-hover-out 2","actionItemGroups":[{"actionItems":[{"id":"a-60-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"66b9bd20afcdc23ad40847b7|6bad2d21-334c-6ad2-6948-c7f9081a394d"},"xValue":null,"yValue":750,"xUnit":"px","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1681971285006},"a-68":{"id":"a-68","title":"--- Nav menu - open ---","actionItemGroups":[{"actionItems":[{"id":"a-68-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-68-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-68-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-68-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{},"value":0,"unit":""}},{"id":"a-68-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-68-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-68-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-68-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-68-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-65":{"id":"a-65","title":"--- Nav menu - close ---","actionItemGroups":[{"actionItems":[{"id":"a-65-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-65-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-65-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-65-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-65-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-65-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-65-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-61":{"id":"a-61","title":"--- Nav menu - open --- 4","actionItemGroups":[{"actionItems":[{"id":"a-61-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-61-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-61-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-61-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":0,"unit":""}},{"id":"a-61-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-61-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-61-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-61-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-61-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-57":{"id":"a-57","title":"--- Nav menu - close --- 4","actionItemGroups":[{"actionItems":[{"id":"a-57-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-57-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-57-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-57-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-57-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-57-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-57-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-67":{"id":"a-67","title":"--- Nav menu - open --- 10","actionItemGroups":[{"actionItems":[{"id":"a-67-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-67-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-67-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-67-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":0,"unit":""}},{"id":"a-67-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-67-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-67-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-67-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-67-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-59":{"id":"a-59","title":"--- Nav menu - close --- 10","actionItemGroups":[{"actionItems":[{"id":"a-59-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-59-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-59-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-59-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-59-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-59-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-59-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-62":{"id":"a-62","title":"--- Nav menu - open --- 8","actionItemGroups":[{"actionItems":[{"id":"a-62-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":0,"unit":""}},{"id":"a-62-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"none"}}]},{"actionItems":[{"id":"a-62-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":1,"unit":""}},{"id":"a-62-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6676"]},"value":0,"unit":""}},{"id":"a-62-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-62-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"flex"}},{"id":"a-62-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-62-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-62-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-58":{"id":"a-58","title":"--- Nav menu - close --- 8","actionItemGroups":[{"actionItems":[{"id":"a-58-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":0,"unit":""}},{"id":"a-58-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-58-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-58-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-58-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-58-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6676"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-58-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-66":{"id":"a-66","title":"--- minisite nav - down --- 2","actionItemGroups":[{"actionItems":[{"id":"a-66-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":5,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-66-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"none"}},{"id":"a-66-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-66-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"flex"}},{"id":"a-66-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":0,"target":{},"value":0,"unit":""}},{"id":"a-66-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".shadow-on-nav","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6629"]},"value":1,"unit":""}},{"id":"a-66-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-general","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce667b"]},"value":"none"}},{"id":"a-66-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":1,"unit":""}},{"id":"a-66-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-66-n-10","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662e"]},"value":"none"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1708450928626},"a-64":{"id":"a-64","title":"--- minisite nav - up --- 3","actionItemGroups":[{"actionItems":[{"id":"a-64-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"none"}},{"id":"a-64-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".shadow-on-nav","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6629"]},"value":0,"unit":""}},{"id":"a-64-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{},"value":1,"unit":""}},{"id":"a-64-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-general","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce667b"]},"value":"flex"}},{"id":"a-64-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":0,"unit":""}},{"id":"a-64-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":5,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-64-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662e"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1708450928626},"a-69":{"id":"a-69","title":"Tablet-dd-products","actionItemGroups":[{"actionItems":[{"id":"a-69-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"none"}},{"id":"a-69-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-69-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"block"}},{"id":"a-69-n-6","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-69-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-69-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-70":{"id":"a-70","title":"Tablet-dd-products 2","actionItemGroups":[{"actionItems":[{"id":"a-70-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-70-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-70-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-70-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-71":{"id":"a-71","title":"Tablet-dd-pricing","actionItemGroups":[{"actionItems":[{"id":"a-71-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"none"}},{"id":"a-71-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-71-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"block"}},{"id":"a-71-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-71-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-71-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-72":{"id":"a-72","title":"Tablet-dd-pricing 3","actionItemGroups":[{"actionItems":[{"id":"a-72-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-72-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-72-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-72-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-94":{"id":"a-94","title":"Tablet-dd-overview","actionItemGroups":[{"actionItems":[{"id":"a-94-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"none"}},{"id":"a-94-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-94-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"block"}},{"id":"a-94-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-94-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-94-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-95":{"id":"a-95","title":"Tablet-dd-overview 2","actionItemGroups":[{"actionItems":[{"id":"a-95-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-95-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-95-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-95-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-96":{"id":"a-96","title":"Tablet-dd-learn","actionItemGroups":[{"actionItems":[{"id":"a-96-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"none"}},{"id":"a-96-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-96-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"block"}},{"id":"a-96-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-96-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-96-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-97":{"id":"a-97","title":"Tablet-dd-learn 2","actionItemGroups":[{"actionItems":[{"id":"a-97-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-97-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-97-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-97-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function CrmNav(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Block : tmp;
    interactions/* useInteractions */.NI(CrmNav_interactionsData, (CrmNav_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((CrmNav_module_default()), "crm-nav-component", "is-sticky"),
        tag: "div",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((CrmNav_module_default()), "crm-nav-component", "is-sticky"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((CrmNav_module_default()), "position-fixed"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                className: utils.cx((CrmNav_module_default()), "m_mandatory-css"),
                                value: "%3Cstyle%3E%20%5Bclass*%3D%22mobile_menu-group-h%22%5D%5Bclass*%3D%22is-active%22%5D%20%5Bclass*%3D%22chevron%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22m_dt-nav-link%22%5D%3Ahover%20%5Bclass*%3D%22m_dt-nav-link-icon-parent%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22w-dropdown-toggle%22%5D%5Bclass*%3D%22w--open%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22w--open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20~%20%5Bclass*%3D%22group_nav-full-wrap%22%5D%7B%20display%3A%20flex%3B%20%7D%20%5Bclass*%3D%22m_button-link%22%5D%3Ahover%20%5Bclass*%3D%22m_button-arrow%22%5D%7B%20transform%3A%20translateX(.25rem)%3B%20%7D%20%3C%2Fstyle%3E%0A%0A%3Cstyle%3E%0A%2F*%20Rotate%20chevron%20when%20mobile%20group%20is%20active%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22mobile_menu-group-h%22%5D%5Bclass*%3D%22is-active%22%5D%20%5Bclass*%3D%22chevron%22%5D%20%7B%0A%20%20transform%3A%20rotate(180deg)%20!important%3B%0A%20%20color%3A%20var(--brand--primary)%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_50-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2048.75rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_23-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2026.5rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_28-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2054.75rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_24-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2025.25rem%3B%0A%7D%0A%0A%2F*%20Active%20full%20nav%20link%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Hover%20state%20for%20dt%20nav%20link%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_dt-nav-link%22%5D%3Ahover%20%5Bclass*%3D%22m_dt-nav-link-icon-parent%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Dropdown%20open%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22w-dropdown-toggle%22%5D%5Bclass*%3D%22w--open%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Chevron%20rotation%20on%20open%20links%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%2C%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22w--open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%20%7B%0A%20%20transform%3A%20rotate(180deg)%20!important%3B%0A%7D%0A%0A%2F*%20Show%20nested%20nav%20when%20open%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20~%20%5Bclass*%3D%22group_nav-full-wrap%22%5D%20%7B%0A%20%20display%3A%20flex%20!important%3B%0A%7D%0A%0A%2F*%20Arrow%20hover%20effect%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_button-link%22%5D%3Ahover%20%5Bclass*%3D%22m_button-arrow%22%5D%20%7B%0A%20%20transform%3A%20translateX(.25rem)%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                value: "%3Cstyle%3E%20%40media%20screen%20and%20(max-width%3A%201230px)%20%7B%20%5Bclass*%3D%22minisite-nav%22%5D%7B%20display%3A%20none%3B%20%7D%20%5Bclass*%3D%22minisite-nav-mb%22%5D%7B%20display%3A%20block%3B%20%7D%20%7D%20%3C%2Fstyle%3E%0A%0A%3Cstyle%3E%0A%40media%20(max-width%3A%201230px)%20%7B%0A%20%20.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22minisite-nav%22%5D%20%7B%0A%20%20%20%20display%3A%20none%20!important%3B%0A%20%20%7D%0A%0A%20%20.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22minisite-nav-mb%22%5D%20%7B%0A%20%20%20%20display%3A%20block%20!important%3B%0A%20%20%7D%0A%7D%0A%3C%2Fstyle%3E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "minisite-nav", "is-static"),
                                tag: "header",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                        className: utils.cx((CrmNav_module_default()), "nav-full-minisite", "for-general"),
                                        tag: "div",
                                        config: {
                                            easing: "ease",
                                            easing2: "ease",
                                            duration: 400,
                                            docHeight: false,
                                            noScroll: false,
                                            animation: "default",
                                            collapse: "medium"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "shadow-on-nav"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "m_nav-container-full"),
                                                tag: "div",
                                                "data-header": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((CrmNav_module_default()), "m_header-logo-desktop"),
                                                        button: false,
                                                        "data-picture-with-link": "",
                                                        block: "inline",
                                                        options: {
                                                            href: "https://www.monday.com"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://uploads-ssl.webflow.com/64d0dd4b31aeec4c6cd8e685/64d0dd4b31aeec4c6cd8e6f4_monday.com.png"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "group_nav-full-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "nav-full-content-start"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((CrmNav_module_default()), "m_nav_link-full-parent"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((CrmNav_module_default()), "m_nav_link-full"),
                                                                                tag: "button",
                                                                                slot: "",
                                                                                id: "",
                                                                                "data-link-item-with-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        "data-link-item-text": "",
                                                                                        children: "Products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-full-wrap"),
                                                                                tag: "div",
                                                                                "data-header-item-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-full-child"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "shadow-on-list"),
                                                                                                tag: "div"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-top"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "The platform"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/features/dashboards"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222.32292%22%20y%3D%223.23966%22%20width%3D%2215.3542%22%20height%3D%2213.5208%22%20rx%3D%221.26042%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.14583%22%2F%3E%3Cline%20x1%3D%221.75%22%20y1%3D%226.67708%22%20x2%3D%2218.25%22%20y2%3D%226.67708%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.14583%22%2F%3E%3Cpath%20d%3D%22M14.2399%2010C14.2399%209.68359%2013.9834%209.42708%2013.667%209.42708C13.3506%209.42708%2013.0941%209.68359%2013.0941%2010L14.2399%2010ZM13.0941%2010L13.0941%2016.4167L14.2399%2016.4167L14.2399%2010L13.0941%2010Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M10.5729%2010.9167C10.5729%2010.6003%2010.3164%2010.3438%2010%2010.3438C9.68359%2010.3438%209.42708%2010.6003%209.42708%2010.9167L10.5729%2010.9167ZM9.42708%2010.9167L9.42708%2016.4167L10.5729%2016.4167L10.5729%2010.9167L9.42708%2010.9167Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M6.90592%2012.75C6.90592%2012.4336%206.64942%2012.1771%206.33301%2012.1771C6.01659%2012.1771%205.76009%2012.4336%205.76009%2012.75L6.90592%2012.75ZM5.76009%2012.75L5.76009%2016.4167L6.90592%2016.4167L6.90592%2012.75L5.76009%2012.75Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Dashboards & reporting"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/integrations"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3100)%22%3E%3Cpath%20d%3D%22M3.84863%2012.293L8.18694%2016.5269C8.84001%2017.1643%209.88612%2017.1516%2010.5235%2016.4985L13.2608%2013.6938L15.9981%2010.889C16.6355%2010.2359%2016.6227%209.18982%2015.9697%208.55246L11.6314%204.31848%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M2.65137%2013.5205L12.8288%203.09233%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5918%202.11961C6.34477%201.87852%205.94908%201.88333%205.70799%202.13036C5.4669%202.37739%205.47171%202.77309%205.71874%203.01418L6.5918%202.11961ZM5.71874%203.01418L9.39928%206.60621L10.2723%205.71163L6.5918%202.11961L5.71874%203.01418Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M12.9609%2014.0007L16.6415%2017.5928%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.40137%206.41404C2.15434%206.17295%201.75865%206.17777%201.51756%206.4248C1.27647%206.67183%201.28128%207.06753%201.52831%207.30862L2.40137%206.41404ZM1.52831%207.30862L5.20885%2010.9006L6.08191%2010.0061L2.40137%206.41404L1.52831%207.30862Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3100%22%3E%3Crect%20width%3D%2220%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Integrations"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/features/automations"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%224.3329%22%20y%3D%226.55556%22%20width%3D%2211.3333%22%20height%3D%229.55556%22%20rx%3D%221.22222%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M15.333%209.55542H16.2219C17.2037%209.55542%2017.9997%2010.3514%2017.9997%2011.3332V12.2221C17.9997%2013.2039%2017.2037%2013.9999%2016.2219%2013.9999H15.333%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M4.66699%209.55542H3.7781C2.79626%209.55542%202.00032%2010.3514%202.00032%2011.3332V12.2221C2.00032%2013.2039%202.79626%2013.9999%203.7781%2013.9999H4.66699%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M12.2227%2010.4443L12.2227%2011.7777%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.77734%2010.4443L7.77734%2011.7777%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.5556%203.33325C10.5556%203.02643%2010.3068%202.7777%2010%202.7777C9.69318%202.7777%209.44444%203.02643%209.44444%203.33325L10.5556%203.33325ZM9.44444%203.33325L9.44444%206.88881L10.5556%206.88881L10.5556%203.33325L9.44444%203.33325Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Automations"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/ai"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmask%20id%3D%22path-1-inside-1_589_3088%22%20fill%3D%22white%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.7196%203.83214L17.0691%204.2596C17.1738%204.29261%2017.2451%204.38989%2017.2451%204.49985C17.2451%204.60981%2017.1738%204.7068%2017.0691%204.74011L15.7196%205.16786C15.5737%205.21414%2015.4594%205.32852%2015.4131%205.47444L14.9854%206.82401C14.9523%206.92866%2014.8551%207%2014.7451%207C14.6352%207%2014.5382%206.92866%2014.5049%206.82401L14.0772%205.47444C14.0309%205.32852%2013.9165%205.21414%2013.7706%205.16786L12.4211%204.74011C12.3165%204.70709%2012.2451%204.60952%2012.2451%204.49985C12.2451%204.39019%2012.3165%204.29291%2012.4211%204.2596L13.7706%203.83214C13.9165%203.78586%2014.0309%203.67148%2014.0772%203.52556L14.5049%202.17599C14.5379%202.07134%2014.6352%202%2014.7451%202C14.8551%202%2014.952%202.07134%2014.9854%202.17599L15.4131%203.52556C15.4594%203.67148%2015.5737%203.78586%2015.7196%203.83214ZM11.4327%2010.0881L14.8032%2011.1557C15.0645%2011.2381%2015.2427%2011.4811%2015.2427%2011.7557C15.2427%2012.0304%2015.0645%2012.2726%2014.8032%2012.3558L11.4327%2013.4241C11.0683%2013.5397%2010.7827%2013.8254%2010.6671%2014.1898L9.5988%2017.5605C9.51635%2017.8218%209.27339%2018%208.99878%2018C8.72417%2018%208.48196%2017.8218%208.39877%2017.5605L7.33051%2014.1898C7.21492%2013.8254%206.92926%2013.5397%206.56483%2013.4241L3.19441%2012.3558C2.93305%2012.2733%202.75488%2012.0296%202.75488%2011.7557C2.75488%2011.4818%202.93305%2011.2389%203.19441%2011.1557L6.56483%2010.0881C6.92926%209.97251%207.21492%209.68683%207.33051%209.32238L8.39877%205.95176C8.48122%205.69038%208.72417%205.51221%208.99878%205.51221C9.27339%205.51221%209.51561%205.69038%209.5988%205.95176L10.6671%209.32238C10.7827%209.68683%2011.0683%209.97251%2011.4327%2010.0881Z%22%2F%3E%3C%2Fmask%3E%3Cpath%20d%3D%22M17.0691%204.2596L16.6917%205.45125L16.693%205.45167L17.0691%204.2596ZM15.7196%203.83214L15.3417%205.02364L15.3422%205.02379L15.7196%203.83214ZM17.0691%204.74011L17.4468%205.93168L17.4483%205.93122L17.0691%204.74011ZM15.7196%205.16786L15.342%203.97628L15.3417%203.97636L15.7196%205.16786ZM15.4131%205.47444L14.2216%205.09655L14.2215%205.09679L15.4131%205.47444ZM14.9854%206.82401L13.7938%206.44635L13.7933%206.44794L14.9854%206.82401ZM14.5049%206.82401L13.3133%207.20166L13.3138%207.20312L14.5049%206.82401ZM14.0772%205.47444L15.2687%205.09679L15.2687%205.09654L14.0772%205.47444ZM13.7706%205.16786L14.1485%203.97636L14.1483%203.97628L13.7706%205.16786ZM12.4211%204.74011L12.7988%203.54853L12.7972%203.54804L12.4211%204.74011ZM12.4211%204.2596L12.0436%203.06795L12.0419%203.06849L12.4211%204.2596ZM13.7706%203.83214L14.148%205.02379L14.1485%205.02364L13.7706%203.83214ZM14.0772%203.52556L15.2687%203.90346L15.2687%203.90321L14.0772%203.52556ZM14.5049%202.17599L15.6965%202.55364L15.697%202.55206L14.5049%202.17599ZM14.9854%202.17599L16.1769%201.79834L16.1765%201.79687L14.9854%202.17599ZM15.4131%203.52556L14.2215%203.90321L14.2216%203.90345L15.4131%203.52556ZM14.8032%2011.1557L14.4257%2012.3473L14.4271%2012.3478L14.8032%2011.1557ZM11.4327%2010.0881L11.0548%2011.2796L11.0553%2011.2797L11.4327%2010.0881ZM14.8032%2012.3558L15.1809%2013.5474L15.1823%2013.5469L14.8032%2012.3558ZM11.4327%2013.4241L11.055%2012.2325L11.0548%2012.2326L11.4327%2013.4241ZM10.6671%2014.1898L9.47555%2013.8119L9.47548%2013.8122L10.6671%2014.1898ZM9.5988%2017.5605L8.40722%2017.1828L8.40672%2017.1844L9.5988%2017.5605ZM8.39877%2017.5605L7.20718%2017.9381L7.20765%2017.9396L8.39877%2017.5605ZM7.33051%2014.1898L8.52209%2013.8122L8.52202%2013.8119L7.33051%2014.1898ZM6.56483%2013.4241L6.94277%2012.2326L6.94253%2012.2325L6.56483%2013.4241ZM3.19441%2012.3558L3.5721%2011.1642L3.57052%2011.1637L3.19441%2012.3558ZM3.19441%2011.1557L2.81695%209.96403L2.81524%209.96458L3.19441%2011.1557ZM6.56483%2010.0881L6.94229%2011.2797L6.94277%2011.2796L6.56483%2010.0881ZM7.33051%209.32238L8.52202%209.70027L8.52209%209.70003L7.33051%209.32238ZM8.39877%205.95176L9.59035%206.32941L9.59085%206.32783L8.39877%205.95176ZM9.5988%205.95176L10.7904%205.57411L10.7899%205.57263L9.5988%205.95176ZM10.6671%209.32238L9.47548%209.70003L9.47555%209.70027L10.6671%209.32238ZM17.4466%203.06795L16.0971%202.6405L15.3422%205.02379L16.6917%205.45124L17.4466%203.06795ZM18.4951%204.49985C18.4951%203.84494%2018.0706%203.26482%2017.4453%203.06752L16.693%205.45167C16.277%205.3204%2015.9951%204.93484%2015.9951%204.49985H18.4951ZM17.4483%205.93122C18.0687%205.73371%2018.4951%205.15708%2018.4951%204.49985H15.9951C15.9951%204.06254%2016.2788%203.67988%2016.69%203.549L17.4483%205.93122ZM16.0973%206.35943L17.4468%205.93168L16.6914%203.54854L15.342%203.97628L16.0973%206.35943ZM16.6046%205.85233C16.528%206.09371%2016.339%206.28278%2016.0976%206.35935L15.3417%203.97636C14.8085%204.1455%2014.3907%204.56333%2014.2216%205.09655L16.6046%205.85233ZM16.1769%207.20166L16.6047%205.85209L14.2215%205.09679L13.7938%206.44636L16.1769%207.20166ZM14.7451%208.25C15.4001%208.25%2015.9802%207.82535%2016.1774%207.20007L13.7933%206.44794C13.9245%206.03197%2014.31%205.75%2014.7451%205.75V8.25ZM13.3138%207.20312C13.5112%207.82349%2014.0878%208.25%2014.7451%208.25V5.75C15.1826%205.75%2015.5652%206.03383%2015.696%206.44489L13.3138%207.20312ZM12.8856%205.85209L13.3133%207.20166L15.6965%206.44636L15.2687%205.09679L12.8856%205.85209ZM13.3927%206.35935C13.1512%206.28278%2012.9622%206.09371%2012.8856%205.85234L15.2687%205.09654C15.0996%204.56333%2014.6818%204.1455%2014.1485%203.97636L13.3927%206.35935ZM12.0434%205.93168L13.3929%206.35943L14.1483%203.97628L12.7988%203.54854L12.0434%205.93168ZM10.9951%204.49985C10.9951%205.15361%2011.4188%205.73463%2012.045%205.93218L12.7972%203.54804C13.2141%203.67956%2013.4951%204.06542%2013.4951%204.49985H10.9951ZM12.0419%203.06849C11.4207%203.26625%2010.9951%203.84377%2010.9951%204.49985H13.4951C13.4951%204.93661%2013.2122%205.31956%2012.8003%205.4507L12.0419%203.06849ZM13.3931%202.6405L12.0436%203.06795L12.7986%205.45124L14.148%205.02379L13.3931%202.6405ZM12.8856%203.14766C12.9622%202.90629%2013.1512%202.71722%2013.3927%202.64065L14.1485%205.02364C14.6818%204.8545%2015.0996%204.43667%2015.2687%203.90346L12.8856%203.14766ZM13.3133%201.79834L12.8856%203.14791L15.2687%203.90321L15.6965%202.55364L13.3133%201.79834ZM14.7451%200.75C14.0901%200.75%2013.51%201.17467%2013.3128%201.79993L15.697%202.55206C15.5657%202.96801%2015.1802%203.25%2014.7451%203.25V0.75ZM16.1765%201.79687C15.979%201.17649%2015.4024%200.75%2014.7451%200.75V3.25C14.3077%203.25%2013.9251%202.96619%2013.7942%202.55512L16.1765%201.79687ZM16.6047%203.14791L16.1769%201.79834L13.7938%202.55364L14.2215%203.90321L16.6047%203.14791ZM16.0976%202.64065C16.339%202.71722%2016.528%202.90629%2016.6046%203.14767L14.2216%203.90345C14.3907%204.43667%2014.8085%204.8545%2015.3417%205.02364L16.0976%202.64065ZM15.1806%209.96404L11.8102%208.89645L11.0553%2011.2797L14.4257%2012.3473L15.1806%209.96404ZM16.4927%2011.7557C16.4927%2010.9362%2015.9613%2010.2104%2015.1793%209.96361L14.4271%2012.3478C14.1677%2012.2659%2013.9927%2012.0261%2013.9927%2011.7557H16.4927ZM15.1823%2013.5469C15.9595%2013.2995%2016.4927%2012.5776%2016.4927%2011.7557H13.9927C13.9927%2011.4831%2014.1696%2011.2457%2014.424%2011.1647L15.1823%2013.5469ZM11.8104%2014.6157L15.1809%2013.5474L14.4255%2011.1642L11.055%2012.2325L11.8104%2014.6157ZM11.8586%2014.5677C11.8513%2014.5906%2011.8336%2014.6084%2011.8107%2014.6156L11.0548%2012.2326C10.303%2012.4711%209.71397%2013.0602%209.47555%2013.8119L11.8586%2014.5677ZM10.7904%2017.9381L11.8587%2014.5675L9.47548%2013.8122L8.40722%2017.1828L10.7904%2017.9381ZM8.99878%2019.25C9.81845%2019.25%2010.5442%2018.7185%2010.7909%2017.9365L8.40672%2017.1844C8.4885%2016.9251%208.72834%2016.75%208.99878%2016.75V19.25ZM7.20765%2017.9396C7.45499%2018.7167%208.17677%2019.25%208.99878%2019.25V16.75C9.27157%2016.75%209.50893%2016.927%209.58989%2017.1813L7.20765%2017.9396ZM6.13892%2014.5675L7.20718%2017.9381L9.59035%2017.1828L8.52209%2013.8122L6.13892%2014.5675ZM6.1869%2014.6156C6.164%2014.6084%206.14624%2014.5906%206.139%2014.5677L8.52202%2013.8119C8.2836%2013.0602%207.69452%2012.4711%206.94277%2012.2326L6.1869%2014.6156ZM2.81671%2013.5474L6.18714%2014.6157L6.94253%2012.2325L3.5721%2011.1642L2.81671%2013.5474ZM1.50488%2011.7557C1.50488%2012.5737%202.03544%2013.3009%202.81829%2013.5479L3.57052%2011.1637C3.83065%2011.2458%204.00488%2011.4855%204.00488%2011.7557H1.50488ZM2.81524%209.96458C2.03728%2010.2122%201.50488%2010.9354%201.50488%2011.7557H4.00488C4.00488%2012.0283%203.82881%2012.2655%203.57357%2012.3468L2.81524%209.96458ZM6.18738%208.89645L2.81695%209.96404L3.57186%2012.3473L6.94229%2011.2797L6.18738%208.89645ZM6.139%208.94449C6.14624%208.92165%206.164%208.90386%206.1869%208.8966L6.94277%2011.2796C7.69452%2011.0411%208.2836%2010.452%208.52202%209.70027L6.139%208.94449ZM7.20718%205.57411L6.13892%208.94473L8.52209%209.70003L9.59035%206.32941L7.20718%205.57411ZM8.99878%204.26221C8.17909%204.26221%207.45337%204.79372%207.20668%205.57568L9.59085%206.32783C9.50908%206.58705%209.26925%206.76221%208.99878%206.76221V4.26221ZM10.7899%205.57263C10.5426%204.79553%209.82077%204.26221%208.99878%204.26221V6.76221C8.72602%206.76221%208.48864%206.58523%208.40769%206.33088L10.7899%205.57263ZM11.8587%208.94473L10.7904%205.57411L8.40722%206.32941L9.47548%209.70003L11.8587%208.94473ZM11.8107%208.8966C11.8336%208.90386%2011.8513%208.92165%2011.8586%208.94449L9.47555%209.70027C9.71397%2010.452%2010.303%2011.0411%2011.0548%2011.2796L11.8107%208.8966Z%22%20fill%3D%22currentcolor%22%20mask%3D%22url(%23path-1-inside-1_589_3088)%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "AI"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/mcp"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_792_2516)%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.6763%203.01819C11.9491%202.30546%2010.7854%202.30546%2010.0582%203.01819L3.0618%209.88364C2.81453%2010.1164%202.43635%2010.1164%202.18907%209.88364C1.95635%209.65091%201.9418%209.27273%202.18907%209.04L9.18544%202.16C10.4073%200.981822%2012.3418%200.981822%2013.5636%202.16C14.2473%202.82909%2014.5818%203.78909%2014.4363%204.73455C15.3963%204.60364%2016.3709%204.90909%2017.0545%205.59273L17.0836%205.63637C18.2618%206.78546%2018.2909%208.67637%2017.1418%209.86909C17.1273%209.88364%2017.0982%209.91273%2017.0836%209.92728L10.7563%2016.1382C10.6836%2016.2109%2010.6691%2016.3418%2010.7563%2016.4145L12.0509%2017.6945C12.2836%2017.9273%2012.2982%2018.3055%2012.0509%2018.5382C11.8036%2018.7709%2011.4254%2018.7709%2011.1782%2018.5382L9.88362%2017.2582C9.33089%2016.72%209.31635%2015.8327%209.85453%2015.28C9.85453%2015.28%209.86907%2015.2655%209.88362%2015.2509L16.2109%209.04C16.9236%208.34182%2016.9382%207.20728%2016.24%206.49455L16.2109%206.46546L16.1818%206.43637C15.4545%205.72364%2014.2909%205.72364%2013.5636%206.43637L8.3418%2011.5564L8.26907%2011.6291C8.0218%2011.8618%207.64362%2011.8618%207.39635%2011.6291C7.16362%2011.3964%207.14908%2011.0182%207.39635%2010.7855L12.6909%205.59273C13.4036%204.89455%2013.4182%203.76%2012.72%203.04728C12.72%203.04728%2012.7054%203.03273%2012.6909%203.01819H12.6763Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11.8036%204.73449C12.0363%204.50176%2012.0509%204.12358%2011.8036%203.89085C11.5563%203.65813%2011.1782%203.65813%2010.9309%203.89085L5.75271%208.96722C4.57453%2010.1163%204.54544%2012.0072%205.69453%2013.1999C5.70907%2013.2145%205.73817%2013.2436%205.75271%2013.2581C6.97453%2014.4363%208.90907%2014.4363%2010.1309%2013.2581L15.3091%208.18176C15.5418%207.94904%2015.5563%207.57085%2015.3091%207.33813C15.0618%207.1054%2014.6836%207.1054%2014.4363%207.33813L9.25817%2012.4145C8.53089%2013.1272%207.36726%2013.1272%206.63998%2012.4145C5.92726%2011.7163%205.91271%2010.5818%206.61089%209.86904L6.63998%209.83994L11.8182%204.76358L11.8036%204.73449Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_792_2516%22%3E%3Crect%20width%3D%2216%22%20height%3D%2217.4545%22%20fill%3D%22currentcolor%22%20transform%3D%22translate(2%201.27271)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "monday MCP"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/mondaydb"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.75%206.25007C3.75%206.91313%204.4085%207.54904%205.58064%208.01789C6.75277%208.48675%208.34253%208.75015%2010.0002%208.75015C11.6578%208.75015%2013.2476%208.48675%2014.4197%208.01789C15.5919%207.54904%2016.2504%206.91313%2016.2504%206.25007C16.2504%205.58701%2015.5919%204.95111%2014.4197%204.48225C13.2476%204.0134%2011.6578%203.75%2010.0002%203.75C8.34253%203.75%206.75277%204.0134%205.58064%204.48225C4.4085%204.95111%203.75%205.58701%203.75%206.25007Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.75%206.25V9.99955C3.75%2011.3802%206.54842%2012.4996%2010.0002%2012.4996C13.452%2012.4996%2016.2504%2011.3807%2016.2504%209.99955V6.25%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.75%209.99951V13.7496C3.75%2015.1302%206.54842%2016.2497%2010.0002%2016.2497C13.452%2016.2497%2016.2504%2015.1302%2016.2504%2013.7496V9.99951%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Our infrastructure"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent", "is-products-end"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h", "for-product"),
                                                                                                                tag: "div",
                                                                                                                children: "Products"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col"),
                                                                                                                tag: "div"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "grid_nav-products"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707127e-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/work-management"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228.08909%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cpath%20d%3D%22M23.6134%2027.0611C25.382%2027.0611%2026.8158%2025.6274%2026.8158%2023.8588C26.8158%2022.0902%2025.382%2020.6565%2023.6134%2020.6565C21.8449%2020.6565%2020.4111%2022.0902%2020.4111%2023.8588C20.4111%2025.6274%2021.8449%2027.0611%2023.6134%2027.0611Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M23.6134%2016.078C25.382%2016.078%2026.8158%2014.6442%2026.8158%2012.8757C26.8158%2011.1071%2025.382%209.67334%2023.6134%209.67334C21.8449%209.67334%2020.4111%2011.1071%2020.4111%2012.8757C20.4111%2014.6442%2021.8449%2016.078%2023.6134%2016.078Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M13.1652%2023.669C14.9338%2023.669%2016.3675%2022.2353%2016.3675%2020.4667C16.3675%2018.6981%2014.9338%2017.2644%2013.1652%2017.2644C11.3966%2017.2644%209.96289%2018.6981%209.96289%2020.4667C9.96289%2022.2353%2011.3966%2023.669%2013.1652%2023.669Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M17.1545%2035.9488C18.9231%2035.9488%2020.3568%2034.5151%2020.3568%2032.7465C20.3568%2030.9779%2018.9231%2029.5442%2017.1545%2029.5442C15.3859%2029.5442%2013.9521%2030.9779%2013.9521%2032.7465C13.9521%2034.5151%2015.3859%2035.9488%2017.1545%2035.9488Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M30.0656%2035.9488C31.8342%2035.9488%2033.2679%2034.5151%2033.2679%2032.7465C33.2679%2030.9779%2031.8342%2029.5442%2030.0656%2029.5442C28.297%2029.5442%2026.8633%2030.9779%2026.8633%2032.7465C26.8633%2034.5151%2028.297%2035.9488%2030.0656%2035.9488Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M34.0597%2023.669C35.8283%2023.669%2037.2621%2022.2353%2037.2621%2020.4667C37.2621%2018.6981%2035.8283%2017.2644%2034.0597%2017.2644C32.2911%2017.2644%2030.8574%2018.6981%2030.8574%2020.4667C30.8574%2022.2353%2032.2911%2023.669%2034.0597%2023.669Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "monday work management"
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "For projects & tasks"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071285-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/crm"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%2300D2D2%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.1191%2033.3844C23.4528%2032.8913%2022.8451%2032.3152%2022.3121%2031.6657C21.0172%2030.0879%2020.233%2028.1619%2020.0508%2026.1428L30.1529%2026.1427C30.6563%2026.1424%2031.0642%2025.7343%2031.0642%2025.2309C31.0642%2023.1705%2030.5318%2021.1326%2029.5028%2019.321C28.6751%2017.8636%2027.5569%2016.6074%2026.23%2015.6224C27.2036%2015.3011%2028.2443%2015.1272%2029.3257%2015.1272C34.7769%2015.1272%2039.1959%2019.5463%2039.1959%2024.9975C39.1959%2030.4487%2034.7769%2034.8677%2029.3257%2034.8677C27.4147%2034.8677%2025.6305%2034.3246%2024.1191%2033.3844Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.87793%2025.2303C8.87793%2019.6285%2013.4191%2015.0874%2019.0208%2015.0874C20.8485%2015.0874%2022.5608%2015.57%2024.0401%2016.4142C24.0569%2016.4254%2024.0741%2016.4362%2024.0918%2016.4463C25.6464%2017.3439%2026.9437%2018.6434%2027.8397%2020.2208C28.5597%2021.4884%2028.9928%2022.8867%2029.122%2024.3186H19.0204C18.5168%2024.3186%2018.1087%2024.7268%2018.1087%2025.2304C18.1087%2027.9988%2019.0686%2030.6817%2020.8249%2032.8218C21.3919%2033.5127%2022.0306%2034.1332%2022.727%2034.675C21.5796%2035.1256%2020.3298%2035.3732%2019.0208%2035.3732C13.4191%2035.3732%208.87793%2030.8321%208.87793%2025.2303Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "monday CRM"
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "For customer-facing teams"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707128c-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/dev"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%2300C875%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M23.0823%2018.6854C20.5179%2018.735%2018.4564%2020.8272%2018.4564%2023.4035C18.4564%2025.9776%2020.5142%2028.0683%2023.0754%2028.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002%2028.1415%2037.8758%2028.2482%2038.1023%2028.4736L40.3903%2030.7488C40.8499%2031.2059%2040.8499%2031.9497%2040.3903%2032.4069L38.1023%2034.6821C37.8288%2034.9541%2037.4838%2035.0534%2037.1581%2035.0175H23.1755C23.1434%2035.0175%2023.1113%2035.0174%2023.0793%2035.0171L23.0184%2035.0174L22.9874%2035.0175H22.1198C15.174%2034.1911%2012.5243%2028.596%2011.9373%2026.2484L11.9138%2026.2543C11.6837%2025.3422%2011.5615%2024.3872%2011.5615%2023.4035C11.5615%2017.1265%2016.5381%2012.0145%2022.7619%2011.7968C22.8364%2011.792%2022.9116%2011.7896%2022.9874%2011.7896C23.0195%2011.7896%2023.0516%2011.7897%2023.0837%2011.7899C23.1142%2011.7897%2023.1448%2011.7896%2023.1755%2011.7896C23.2504%2011.7896%2023.3248%2011.792%2023.3986%2011.7967C29.6235%2012.0132%2034.6014%2017.1257%2034.6014%2023.4035C34.6014%2024.3701%2034.4833%2025.309%2034.261%2026.2068H26.7847C27.364%2025.4231%2027.7064%2024.4535%2027.7064%2023.4035C27.7064%2020.8277%2025.6459%2018.7359%2023.0823%2018.6854ZM10.5349%2028.1225H10.1848C8.28079%2028.1225%206.7373%2029.666%206.7373%2031.57C6.7373%2033.474%208.28079%2035.0175%2010.1848%2035.0175H16.2326C13.0984%2033.1003%2011.3599%2030.2109%2010.5349%2028.1225Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "monday dev"
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "For product & dev teams"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071293-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/service"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%23FA4270%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.661%2014.8509C13.2565%2015.8638%2012.084%2018.3982%2013.1735%2020.9858C14.5822%2024.3309%2020.7807%2026.2303%2021.0722%2026.2728C21.334%2026.3133%2021.6404%2026.1622%2021.6404%2025.8728C21.6404%2025.5834%2021.0722%2023.1797%2021.0722%2023.0094C21.0722%2022.8392%2021.168%2022.686%2021.3318%2022.6179C21.4957%2022.5498%2028.6837%2019.5026%2031.0669%2018.5003C33.4502%2017.4981%2034.5801%2014.7999%2033.5544%2012.3655C32.5288%209.93115%2029.8157%208.86931%2027.4197%209.87795C25.0237%2010.8866%2018.0655%2013.8402%2015.661%2014.8509Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M32.3122%2033.1464C34.7167%2032.1335%2035.8892%2029.5992%2034.7997%2027.0116C33.391%2023.6665%2027.1925%2021.7795%2026.901%2021.7369C26.6392%2021.6965%2026.3328%2021.8476%2026.3328%2022.1369C26.3328%2022.4263%2026.901%2024.8177%2026.901%2024.9879C26.901%2025.1582%2026.8052%2025.3114%2026.6414%2025.3795C26.4775%2025.4476%2019.2895%2028.4948%2016.9063%2029.497C14.523%2030.4993%2013.3931%2033.1975%2014.4188%2035.6319C15.4444%2038.0684%2018.1575%2039.1281%2020.5535%2038.1194C22.9516%2037.1108%2029.9077%2034.1572%2032.3122%2033.1464Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "monday service "
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "For IT & support"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-footer"),
                                                                                                tag: "div",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "group_header-buttons"),
                                                                                                    tag: "div",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "signup",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "#"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Get Started"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "header-links-divider"),
                                                                                                            tag: "div"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "homepage-contact-sales",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "https://monday.com/sales/contact-us"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Contact sales"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "close-trig"),
                                                                                        tag: "div"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((CrmNav_module_default()), "m_nav_link-full-parent"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((CrmNav_module_default()), "m_nav_link-full"),
                                                                                tag: "button",
                                                                                slot: "",
                                                                                id: "",
                                                                                "data-link-item-with-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        "data-link-item-text": "",
                                                                                        children: "Solutions"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-full-wrap"),
                                                                                tag: "div",
                                                                                "data-header-item-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-full-child"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "shadow-on-list"),
                                                                                                tag: "div"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-top"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent", "is-solutions-start"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Company size"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col"),
                                                                                                                tag: "div"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "grid_nav-products", "_w-one-col"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712b4-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/enterprise"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%226.73684%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cg%20clip-path%3D%22url(%23clip0_506_4041)%22%3E%3Cpath%20d%3D%22M19.4766%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M31.3445%2017.1292V33.3693H16.3535V17.1292%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M29.2623%2017.1291V14.6306H18.4355V17.1291%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M33.2182%2033.3691H14.4795%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M32.3855%2017.1292H15.3125%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2029.6216V30.4544%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2029.6216V30.4544%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M25.5149%2033.3693V31.2872C25.5149%2030.3711%2024.7654%2029.6216%2023.8493%2029.6216C22.9331%2029.6216%2022.1836%2030.3711%2022.1836%2031.2872V33.3693%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_506_4041%22%3E%3Crect%20width%3D%2219.9879%22%20height%3D%2219.9879%22%20fill%3D%22white%22%20transform%3D%22translate(13.8545%2014.0059)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title", "is-compani-size"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "Enterprise"
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub", "_w-br"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "Gain visibility and control at scale"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712bb-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/smb"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                                value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%226.73684%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cg%20clip-path%3D%22url(%23clip0_506_4029)%22%3E%3Cpath%20d%3D%22M31.5694%2022.9025L29.7935%2021.5225V17.09H26.4215V18.98L23.4241%2016.73L15.2789%2022.9025C15.1091%2023.0574%2015.0068%2023.2729%2014.9941%2023.5025V32.855C14.9941%2033.0539%2015.0731%2033.2447%2015.2136%2033.3853C15.3541%2033.5259%2015.5447%2033.605%2015.7435%2033.605H31.1198C31.3186%2033.605%2031.5091%2033.5259%2031.6497%2033.3853C31.7902%2033.2447%2031.8691%2033.0539%2031.8691%2032.855V23.465C31.8432%2023.2465%2031.7362%2023.0457%2031.5694%2022.9025Z%22%20stroke%3D%22white%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_506_4029%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20transform%3D%22translate(14.4316%2016.1675)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: [
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-title", "is-compani-size"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "SMB"
                                                                                                                                    }),
                                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-sub", "_w-br"),
                                                                                                                                        tag: "div",
                                                                                                                                        children: "Run your entire business in one place"
                                                                                                                                    })
                                                                                                                                ]
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent", "is-solutions-center"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Teams"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "grid_nav-teams"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712c6-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/work-management/marketing"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3129)%22%3E%3Cpath%20d%3D%22M11.0518%201.37988L17.1317%2011.9105%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M16.8157%2011.3578L1.8281%2014.8379L0.868164%2013.1751L11.3759%201.93555%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.08789%2014.0794L5.91317%2015.5088C6.21256%2016.022%206.70352%2016.3952%207.27807%2016.5463C7.85259%2016.6973%208.46364%2016.6141%208.97676%2016.3146C9.4899%2016.0153%209.86308%2015.5244%2010.0142%2014.9498C10.1653%2014.3753%2010.0821%2013.7642%209.78267%2013.2511L9.6505%2013.0222%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3129%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Marketing"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ca-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/work-management/pmo"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1%203.37903C1%202.93252%201.36196%202.57056%201.80847%202.57056H10.2397C10.6862%202.57056%2011.0481%202.93252%2011.0481%203.37903C11.0481%203.82553%2010.6862%204.1875%2010.2397%204.1875H1.80847C1.36196%204.1875%201%203.82553%201%203.37903ZM4.23353%208.99982C4.23353%208.55332%204.5955%208.19135%205.042%208.19135H13.4732C13.9197%208.19135%2014.2817%208.55332%2014.2817%208.99982C14.2817%209.44633%2013.9197%209.80829%2013.4732%209.80829H5.042C4.5955%209.80829%204.23353%209.44633%204.23353%208.99982ZM6.3898%2014.6208C6.3898%2014.1742%206.75176%2013.8123%207.19827%2013.8123H16.1915C16.638%2013.8123%2017%2014.1742%2017%2014.6208C17%2015.0673%2016.638%2015.4292%2016.1915%2015.4292H7.19827C6.75176%2015.4292%206.3898%2015.0673%206.3898%2014.6208Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "PMO"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ce-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/crm"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1754)%22%3E%3Cpath%20d%3D%22M0.5625%2017.4375H17.4375%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.5%2012.1875H2.25C2.10142%2012.1894%201.95947%2012.2493%201.8544%2012.3544C1.74933%2012.4595%201.68944%2012.6014%201.6875%2012.75V17.4375H5.0625V12.75C5.06056%2012.6014%205.00067%2012.4595%204.8956%2012.3544C4.79053%2012.2493%204.64858%2012.1894%204.5%2012.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.125%209.1875H7.875C7.72642%209.18944%207.58447%209.24933%207.4794%209.3544C7.37433%209.45947%207.31444%209.60142%207.3125%209.75V17.4375H10.6875V9.75C10.6856%209.60142%2010.6257%209.45947%2010.5206%209.3544C10.4155%209.24933%2010.2736%209.18944%2010.125%209.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.75%206.1875H13.5C13.3514%206.18944%2013.2095%206.24933%2013.1044%206.3544C12.9993%206.45947%2012.9394%206.60142%2012.9375%206.75V17.4375H16.3125V6.75C16.3106%206.60142%2016.2507%206.45947%2016.1456%206.3544C16.0405%206.24933%2015.8986%206.18944%2015.75%206.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.13525%206.93008L15.1878%201.45508%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.2947%203.8475L15.1872%201.455L12.8022%200.5625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1754%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Sales"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d2-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/operations"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1783)%22%3E%3Cpath%20d%3D%22M7.90944%201.8284C8.04707%201.98118%208.21526%202.10333%208.40312%202.18694C8.59098%202.27055%208.79431%202.31376%208.99994%202.31376C9.20557%202.31376%209.4089%202.27055%209.59676%202.18694C9.78461%202.10333%209.95281%201.98118%2010.0904%201.8284L10.7999%201.0499C11.0033%200.82486%2011.2713%200.66826%2011.5672%200.601599C11.8631%200.534938%2012.1723%200.561483%2012.4525%200.677589C12.7327%200.793696%2012.9701%200.993674%2013.1321%201.25008C13.2942%201.50648%2013.3729%201.80674%2013.3574%202.10965L13.3042%203.15965C13.2939%203.36448%2013.3266%203.5692%2013.4002%203.76062C13.4739%203.95203%2013.5868%204.1259%2013.7317%204.27103C13.8766%204.41615%2014.0503%204.52932%2014.2416%204.60323C14.4329%204.67714%2014.6376%204.71015%2014.8424%204.70015L15.8924%204.6469C16.1952%204.63198%2016.4951%204.71104%2016.7511%204.87325C17.0071%205.03545%2017.2067%205.27287%2017.3225%205.55295C17.4384%205.83304%2017.4647%206.14209%2017.398%206.43774C17.3313%206.73339%2017.1748%207.00118%2016.9499%207.2044L16.1684%207.9094C16.0159%208.04723%2015.8939%208.21553%2015.8104%208.40343C15.7269%208.59134%2015.6838%208.79466%2015.6838%209.00028C15.6838%209.20589%2015.7269%209.40922%2015.8104%209.59713C15.8939%209.78503%2016.0159%209.95333%2016.1684%2010.0912L16.9499%2010.7962C17.175%2010.9995%2017.3316%2011.2675%2017.3982%2011.5634C17.4649%2011.8593%2017.4384%2012.1685%2017.3223%2012.4487C17.2061%2012.7289%2017.0062%2012.9663%2016.7498%2013.1284C16.4934%2013.2904%2016.1931%2013.3691%2015.8902%2013.3537L14.8402%2013.3004C14.6349%2013.2898%2014.4297%2013.3225%2014.2378%2013.3963C14.046%2013.47%2013.8717%2013.5832%2013.7264%2013.7286C13.581%2013.8739%2013.4678%2014.0482%2013.394%2014.24C13.3203%2014.4319%2013.2876%2014.6371%2013.2982%2014.8424L13.3514%2015.8924C13.3649%2016.1938%2013.2852%2016.492%2013.1232%2016.7465C12.9613%2017.0011%2012.7249%2017.1996%2012.4462%2017.3151C12.1675%2017.4306%2011.86%2017.4575%2011.5655%2017.3922C11.2709%2017.3268%2011.0037%2017.1724%2010.7999%2016.9499L10.0942%2016.1692C9.95643%2016.0166%209.7882%2015.8946%209.60036%2015.8111C9.41251%2015.7277%209.20924%2015.6845%209.00369%2015.6845C8.79813%2015.6845%208.59487%2015.7277%208.40702%2015.8111C8.21918%2015.8946%208.05094%2016.0166%207.91319%2016.1692L7.20444%2016.9499C7.00105%2017.1735%206.73366%2017.3289%206.43872%2017.3949C6.14379%2017.461%205.83566%2017.4344%205.55635%2017.319C5.27703%2017.2035%205.04012%2017.0047%204.87792%2016.7497C4.71571%2016.4947%204.6361%2016.1958%204.64994%2015.8939L4.70394%2014.8439C4.7145%2014.6386%204.68184%2014.4334%204.60809%2014.2415C4.53433%2014.0497%204.42111%2013.8754%204.27576%2013.7301C4.13041%2013.5847%203.95617%2013.4715%203.7643%2013.3978C3.57244%2013.324%203.36722%2013.2913%203.16194%2013.3019L2.11194%2013.3552C1.80915%2013.371%201.5089%2013.2927%201.25239%2013.131C0.99589%2012.9693%200.795715%2012.7322%200.679351%2012.4522C0.562987%2012.1723%200.536139%2011.8631%200.602492%2011.5673C0.668845%2011.2714%200.825147%2011.0034%201.04994%2010.7999L1.83069%2010.0949C1.98327%209.95708%202.10525%209.78878%202.18873%209.60088C2.27222%209.41297%202.31535%209.20964%202.31535%209.00403C2.31535%208.79841%202.27222%208.59509%202.18873%208.40718C2.10525%208.21928%201.98327%208.05098%201.83069%207.91315L1.04994%207.2044C0.825876%207.00116%200.670051%206.73367%200.603765%206.43851C0.537479%206.14334%200.563966%205.83491%200.679606%205.55538C0.795246%205.27584%200.994395%205.03883%201.24983%204.87676C1.50527%204.71469%201.80452%204.63546%202.10669%204.6499L3.15669%204.70315C3.36236%204.71397%203.56801%204.6814%203.76027%204.60756C3.95254%204.53372%204.12712%204.42027%204.27268%204.27456C4.41824%204.12886%204.53153%203.95417%204.60518%203.76183C4.67883%203.56949%204.7112%203.36382%204.70019%203.15815L4.64994%202.1074C4.63577%201.80535%204.71514%201.50628%204.87722%201.25101C5.0393%200.995735%205.2762%200.796687%205.55559%200.681026C5.83498%200.565366%206.14325%200.538727%206.43834%200.604744C6.73343%200.670761%207.00097%200.826218%207.20444%201.0499L7.90944%201.8284Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.625%209.00073C5.625%209.89584%205.98058%2010.7543%206.61351%2011.3872C7.24645%2012.0202%208.10489%2012.3757%209%2012.3757C9.89511%2012.3757%2010.7535%2012.0202%2011.3865%2011.3872C12.0194%2010.7543%2012.375%209.89584%2012.375%209.00073C12.375%208.10563%2012.0194%207.24718%2011.3865%206.61425C10.7535%205.98131%209.89511%205.62573%209%205.62573C8.10489%205.62573%207.24645%205.98131%206.61351%206.61425C5.98058%207.24718%205.625%208.10563%205.625%209.00073Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1783%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Operations"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d6-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/dev"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1764)%22%3E%3Cpath%20d%3D%22M5.81348%2014.925H2.06348C1.66565%2014.925%201.28412%2014.767%201.00282%2014.4858C0.721512%2014.2044%200.563477%2013.8229%200.563477%2013.425V2.07983C0.563477%201.68201%200.721512%201.30048%201.00282%201.01918C1.28412%200.737869%201.66565%200.579834%202.06348%200.579834H15.5635C15.9613%200.579834%2016.3428%200.737869%2016.6241%201.01918C16.9055%201.30048%2017.0635%201.68201%2017.0635%202.07983V7.05008%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.563477%204.16626H17.0635%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.4385%2015.4921L12.9385%2017.4204V12.2776L17.4385%2010.3494V15.4921Z%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43799%2015.4921L12.938%2017.4204V12.2776L8.43799%2010.3494V15.4921Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.938%208.42017L17.438%2010.3492L12.938%2012.2774L8.43799%2010.3492L12.938%208.42017Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1764%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Product"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712da-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/service"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1788)%22%3E%3Cpath%20d%3D%22M17.3569%2010.2858V13.5001C17.3569%2013.6706%2017.2891%2013.8341%2017.1686%2013.9547C17.048%2014.0752%2016.8845%2014.143%2016.714%2014.143H1.28544C1.11494%2014.143%200.951426%2014.0752%200.830867%2013.9547C0.710307%2013.8341%200.642578%2013.6706%200.642578%2013.5001V3.21439C0.642578%203.04389%200.710307%202.88037%200.830867%202.75983C0.951426%202.63926%201.11494%202.57153%201.28544%202.57153H3.85686%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.71443%2014.1428L6.42871%2017.3571%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2852%2014.1428L11.5709%2017.3571%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.14258%2017.3572H12.8569%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.07129%207.07139H10.9284V9.64282L14.7856%207.07139H17.357V0.642822H7.07129V7.07139Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1788%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "IT"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712de-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/dev"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1772)%22%3E%3Cpath%20d%3D%22M16.875%2016.3147C16.875%2016.6131%2016.7565%2016.8992%2016.5455%2017.1102C16.3345%2017.3212%2016.0484%2017.4397%2015.75%2017.4397H2.25C1.95163%2017.4397%201.66548%2017.3212%201.4545%2017.1102C1.24353%2016.8992%201.125%2016.6131%201.125%2016.3147V1.6897C1.125%201.39133%201.24353%201.10518%201.4545%200.894202C1.66548%200.683224%201.95163%200.564697%202.25%200.564697H13.5338C13.8275%200.564732%2014.1096%200.67967%2014.3198%200.884947L16.536%203.04645C16.6434%203.15131%2016.7287%203.2766%2016.7869%203.41493C16.8451%203.55327%2016.8751%203.70186%2016.875%203.85195V16.3147Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.7212%206.7522L13.5337%209.5647L10.7212%2012.3772%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.34619%206.7522L4.53369%209.5647L7.34619%2012.3772%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1772%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "R&D"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        id: utils.cx((CrmNav_module_default()), "w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712e2-d0e88002"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/use-cases/hr-management-software"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6.42864%208.35679C8.20384%208.35679%209.64293%206.91771%209.64293%205.14251C9.64293%203.36731%208.20384%201.92822%206.42864%201.92822C4.65344%201.92822%203.21436%203.36731%203.21436%205.14251C3.21436%206.91771%204.65344%208.35679%206.42864%208.35679Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.643066%2017.3569H12.2145V16.6599C12.2043%2015.6799%2011.9458%2014.7185%2011.4633%2013.8655C10.9808%2013.0124%2010.2899%2012.2957%209.45526%2011.782C8.6206%2011.2684%207.66938%2010.9747%206.69045%2010.9283C6.60317%2010.9242%206.51593%2010.9221%206.42878%2010.9219C6.34163%2010.9221%206.25439%2010.9242%206.16711%2010.9283C5.18818%2010.9747%204.23696%2011.2684%203.4023%2011.782C2.56765%2012.2957%201.8768%2013.0124%201.39427%2013.8655C0.911751%2014.7185%200.653302%2015.6799%200.643066%2016.6599V17.3569Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.5718%208.35679C13.347%208.35679%2014.7861%206.91771%2014.7861%205.14251C14.7861%203.36731%2013.347%201.92822%2011.5718%201.92822%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.786%2017.3568H17.3574V16.6596C17.3471%2015.6797%2017.0887%2014.7182%2016.6062%2013.8653C16.1237%2013.0122%2015.4328%2012.2954%2014.5982%2011.7818C14.0587%2011.4498%2013.4703%2011.2097%2012.8574%2011.0688%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "HR"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col"),
                                                                                                                tag: "div"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent", "is-solutions-end"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Industries"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/industries/retail"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1809)%22%3E%3Cpath%20d%3D%22M13.5%2014.625H6.06C5.79405%2014.6251%205.53657%2014.5311%205.33332%2014.3594C5.13015%2014.1878%204.99432%2013.9497%204.95%2013.6875L3%202.06243C2.95492%201.795%202.81467%201.55286%202.6052%201.3806C2.39572%201.20833%202.13112%201.11754%201.86%201.12493H1.11%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.1396%2016.8823C12.295%2016.8823%2012.4209%2016.7564%2012.4209%2016.6011C12.4209%2016.4457%2012.295%2016.3198%2012.1396%2016.3198%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M12.1396%2016.8823C11.9843%2016.8823%2011.8584%2016.7564%2011.8584%2016.6011C11.8584%2016.4457%2011.9843%2016.3198%2012.1396%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M6.46094%2016.8823C6.61626%2016.8823%206.74219%2016.7564%206.74219%2016.6011C6.74219%2016.4457%206.61626%2016.3198%206.46094%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M6.46094%2016.8823C6.30561%2016.8823%206.17969%2016.7564%206.17969%2016.6011C6.17969%2016.4457%206.30561%2016.3198%206.46094%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M4.4996%2011.25H13.5896C14.0872%2011.2451%2014.5692%2011.0753%2014.96%2010.7672C15.3508%2010.4591%2015.6285%2010.0302%2015.7496%209.5475L16.8596%205.1975C16.8785%205.11469%2016.8788%205.02874%2016.8607%204.94578C16.8425%204.8628%2016.8063%204.78486%2016.7546%204.7175C16.7022%204.65002%2016.6351%204.59537%2016.5584%204.55768C16.4818%204.52%2016.3975%204.50027%2016.3121%204.5H3.3896%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.50014%204.50022L7.31264%201.68772C7.57806%201.42483%207.93657%201.27734%208.31014%201.27734C8.68372%201.27734%209.04222%201.42483%209.30764%201.68772L12.1201%204.50022%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.1175%202.50477L13.4175%201.53727C13.5943%201.48451%2013.7798%201.46734%2013.9632%201.48675C14.1467%201.50616%2014.3245%201.56176%2014.4863%201.65035C14.6481%201.73893%2014.7908%201.85874%2014.906%202.00283C15.0212%202.14691%2015.1067%202.31242%2015.1575%202.48977L15.75%204.49977%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1809%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20transform%3D%22matrix(-1%200%200%201%2018%200)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Retail"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/industries/media"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3598)%22%3E%3Cpath%20d%3D%22M2.5%201.5H15.5C15.5%201.5%2016.5%201.5%2016.5%202.5V15.5C16.5%2015.5%2016.5%2016.5%2015.5%2016.5H2.5C2.5%2016.5%201.5%2016.5%201.5%2015.5V2.5C1.5%202.5%201.5%201.5%202.5%201.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.82533%2011.44C7.73833%2011.4833%207.64169%2011.5038%207.54457%2011.4993C7.44745%2011.4949%207.35307%2011.4657%207.2704%2011.4146C7.18773%2011.3634%207.11949%2011.292%207.07217%2011.2071C7.02485%2011.1221%207.00001%2011.0265%207%2010.9293V7.07064C7.00001%206.97342%207.02485%206.87781%207.07217%206.79288C7.11949%206.70796%207.18773%206.63653%207.2704%206.58538C7.35307%206.53422%207.44745%206.50504%207.54457%206.5006C7.64169%206.49615%207.73833%206.51658%207.82533%206.55997L11.6847%208.49C11.7795%208.53726%2011.8591%208.61006%2011.9149%208.70013C11.9706%208.7902%2012.0001%208.89406%2012.0001%209C12.0001%209.10586%2011.9706%209.20973%2011.9149%209.2998C11.8591%209.38986%2011.7795%209.46266%2011.6847%209.51L7.82533%2011.44Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%204H16.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%2014H16.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3598%22%3E%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%20transform%3D%22translate(1%201)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Media"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/construction"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3199)%22%3E%3Cpath%20d%3D%22M15.5%2017.4999C14.5787%2014.8211%2012.0197%2012.8635%209.05118%2012.8635C6.08268%2012.8635%203.42126%2014.8211%202.5%2017.4999%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.94837%203.59091V0.5M3.31836%206.57878H14.5782M4.75143%207.71212C4.85379%209.97879%206.6963%2011.8333%208.94827%2011.8333C11.3026%2011.8333%2013.1451%209.97879%2013.1451%207.60909V5.75455C13.1451%203.38485%2011.3026%201.5303%208.94827%201.5303C6.6963%201.5303%204.85379%203.38485%204.75143%205.65152V7.71212Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3199%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Construction"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-footer"),
                                                                                                tag: "div",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "group_header-buttons"),
                                                                                                    tag: "div",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "signup",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "#"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Get Started"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "header-links-divider"),
                                                                                                            tag: "div"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "homepage-contact-sales",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "https://monday.com/sales/contact-us"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Contact sales"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "close-trig"),
                                                                                        tag: "div"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((CrmNav_module_default()), "m_nav_link-full-parent"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((CrmNav_module_default()), "m_nav_link-full"),
                                                                                tag: "button",
                                                                                slot: "",
                                                                                id: "",
                                                                                "data-link-item-with-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        "data-link-item-text": "",
                                                                                        children: "Resources"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-full-wrap"),
                                                                                tag: "div",
                                                                                "data-header-item-menu": "",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-full-child"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "shadow-on-list"),
                                                                                                tag: "div"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-top"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Learn"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/p/about/"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2220%22%20height%3D%2218%22%20viewBox%3D%220%200%2020%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.48346%2014.2369C2.67081%2014.2361%201.92258%2013.813%201.52927%2013.1316C1.13596%2012.4503%201.15953%2011.6182%201.59083%2010.9583L5.61505%204.80302C6.02839%204.13279%206.78876%203.73021%207.601%203.75154C8.41324%203.77287%209.14944%204.21477%209.52383%204.90569C9.89822%205.59661%209.85184%206.42775%209.40269%207.07648L5.38086%2013.2318C4.9718%2013.858%204.25458%2014.238%203.48346%2014.2369Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M9.84016%2014.2369C9.02884%2014.2361%208.28183%2013.814%207.88916%2013.1343C7.4965%2012.4546%207.52003%2011.6244%207.95063%2010.9661L11.9671%204.82543C12.3739%204.14542%2013.137%203.7332%2013.9553%203.75131C14.7736%203.76941%2015.516%204.21493%2015.8896%204.9122C16.2632%205.60947%2016.2081%206.44659%2015.7461%207.09349L11.7297%2013.2342C11.3222%2013.8576%2010.6083%2014.2364%209.84016%2014.2369V14.2369Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M16.5247%2014.2495C17.7538%2014.2495%2018.7501%2013.2549%2018.7501%2012.0279C18.7501%2010.801%2017.7538%209.8064%2016.5247%209.8064C15.2957%209.8064%2014.2993%2010.801%2014.2993%2012.0279C14.2993%2013.2549%2015.2957%2014.2495%2016.5247%2014.2495Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "About us"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/whats-new"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1921)%22%3E%3Cpath%20d%3D%22M2.25%2011.8125V6.1875L4.5%2011.8125V6.1875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2011.8125H7.875C7.57663%2011.8125%207.29048%2011.694%207.0795%2011.483C6.86853%2011.272%206.75%2010.9859%206.75%2010.6875V7.3125C6.75%207.01413%206.86853%206.72798%207.0795%206.517C7.29048%206.30603%207.57663%206.1875%207.875%206.1875H9%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.75%209.5625H9%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.25%206.1875V7.70025C11.2498%208.5589%2011.4137%209.40967%2011.733%2010.2068L12.375%2011.8125L13.5%207.875L14.625%2011.8125L15.267%2010.2068C15.586%209.40957%2015.7499%208.55887%2015.75%207.70025V6.1875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.4375%2014.0625V16.3125C17.4375%2016.6109%2017.319%2016.897%2017.108%2017.108C16.897%2017.319%2016.6109%2017.4375%2016.3125%2017.4375H1.6875C1.38913%2017.4375%201.10298%2017.319%200.892005%2017.108C0.681026%2016.897%200.5625%2016.6109%200.5625%2016.3125V14.0625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.5625%203.9375V1.6875C0.5625%201.38913%200.681026%201.10298%200.892005%200.892005C1.10298%200.681026%201.38913%200.5625%201.6875%200.5625H16.3125C16.6109%200.5625%2016.897%200.681026%2017.108%200.892005C17.319%201.10298%2017.4375%201.38913%2017.4375%201.6875V3.9375%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1921%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "What's new"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/blog"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1930)%22%3E%3Cpath%20d%3D%22M14.8861%2013.7731L8.4308%208.89062L7.4873%206.18237L10.3501%206.35262L16.8046%2011.2351C16.9707%2011.3608%2017.1105%2011.5179%2017.2159%2011.6976C17.3214%2011.8773%2017.3904%2012.076%2017.419%2012.2824C17.4476%2012.4888%2017.4353%2012.6987%2017.3828%2012.9003C17.3302%2013.1019%2017.2385%2013.2912%2017.1128%2013.4574L17.1068%2013.4649C16.8532%2013.8002%2016.4767%2014.0211%2016.0603%2014.0789C15.6438%2014.1367%2015.2214%2014.0267%2014.8861%2013.7731Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.8096%204.53149V2.28149C11.8096%201.98313%2011.691%201.69698%2011.4801%201.486C11.2691%201.27502%2010.9829%201.15649%2010.6846%201.15649H1.68457C1.3862%201.15649%201.10005%201.27502%200.889075%201.486C0.678097%201.69698%200.55957%201.98313%200.55957%202.28149V13.5315C0.55957%2013.8299%200.678097%2014.116%200.889075%2014.327C1.10005%2014.538%201.3862%2014.6565%201.68457%2014.6565H6.93457L9.55957%2016.9065V14.6565H10.6846C10.8935%2014.6566%2011.0984%2014.5984%2011.2761%2014.4886C11.4539%2014.3788%2011.5976%2014.2216%2011.6911%2014.0347%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%203.40649H6.18457%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.49707%203.40649V6.78149%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%209.59399H5.62207%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%2011.844H7.30957%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1930%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Blog"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/p/certificate/"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1939)%22%3E%3Cpath%20d%3D%22M16.2628%207.04254C16.1938%207.29575%2016.0534%207.5238%2015.8585%207.69954L15.1295%208.35804C14.9871%208.48658%2014.8733%208.64359%2014.7953%208.8189C14.7174%208.99422%2014.6771%209.18393%2014.6771%209.37579C14.6771%209.56764%2014.7174%209.75736%2014.7953%209.93267C14.8733%2010.108%2014.9871%2010.265%2015.1295%2010.3935L15.8585%2011.052C16.0689%2011.2417%2016.2153%2011.4919%2016.2776%2011.7682C16.34%2012.0445%2016.3153%2012.3333%2016.2069%2012.595C16.0984%2012.8566%2015.9116%2013.0783%2015.6721%2013.2295C15.4326%2013.3807%2015.1521%2013.454%2014.8693%2013.4393L13.8883%2013.389C13.6967%2013.3793%2013.5053%2013.4099%2013.3263%2013.4789C13.1474%2013.5478%2012.9849%2013.6535%2012.8493%2013.7891C12.7137%2013.9247%2012.6081%2014.0873%2012.5393%2014.2663C12.4705%2014.4453%2012.44%2014.6368%2012.4498%2014.8283L12.5%2015.8093C12.5152%2016.0924%2012.4423%2016.3733%2012.2912%2016.6133C12.1401%2016.8533%2011.9183%2017.0405%2011.6564%2017.1491C11.3945%2017.2578%2011.1053%2017.2826%2010.8287%2017.2201C10.5521%2017.1575%2010.3017%2017.0108%2010.112%2016.8L9.45353%2016.071C9.32498%2015.9286%209.16798%2015.8148%208.99266%2015.7368C8.81735%2015.6589%208.62763%2015.6186%208.43578%2015.6186C8.24393%2015.6186%208.05421%2015.6589%207.87889%2015.7368C7.70358%2015.8148%207.54657%2015.9286%207.41803%2016.071L6.75953%2016.8C6.56975%2017.0105%206.31942%2017.157%206.04298%2017.2193C5.76654%2017.2817%205.47757%2017.2568%205.21583%2017.1482C4.95409%2017.0396%204.73244%2016.8525%204.58138%2016.6127C4.43032%2016.373%204.35727%2016.0923%204.37228%2015.8093L4.42478%2014.8283C4.43458%2014.6367%204.40406%2014.4452%204.3352%2014.2661C4.26634%2014.0871%204.16066%2013.9245%204.02501%2013.7888C3.88936%2013.6531%203.72675%2013.5475%203.54769%2013.4786C3.36864%2013.4098%203.17712%2013.3792%202.98553%2013.389L2.00453%2013.4393C1.72167%2013.454%201.44121%2013.3807%201.2017%2013.2295C0.962181%2013.0783%200.77537%2012.8566%200.66694%2012.595C0.55851%2012.3333%200.533783%2012.0445%200.596158%2011.7682C0.658533%2011.4919%200.804948%2011.2417%201.01528%2011.052L1.74428%2010.3935C1.8867%2010.265%202.00056%2010.108%202.07848%209.93267C2.15641%209.75736%202.19668%209.56764%202.19668%209.37579C2.19668%209.18393%202.15641%208.99422%202.07848%208.8189C2.00056%208.64359%201.8867%208.48658%201.74428%208.35804L1.01528%207.69954C0.805136%207.50996%200.658814%207.25999%200.596395%206.98394C0.533975%206.70789%200.558518%206.41928%200.666653%206.15774C0.774789%205.89619%200.961218%205.67452%201.20035%205.52315C1.43949%205.37177%201.71961%205.29812%202.00228%205.31229L2.98328%205.36254C3.17505%205.37266%203.36682%205.34239%203.54614%205.27367C3.72547%205.20496%203.88836%205.09933%204.02426%204.96364C4.16016%204.82796%204.26604%204.66523%204.33503%204.48601C4.40403%204.30679%204.43461%204.11508%204.42478%203.92329L4.37228%202.94229C4.35693%202.65917%204.42974%202.37826%204.58067%202.13824C4.73161%201.89822%204.95324%201.7109%205.21506%201.60207C5.47688%201.49325%205.766%201.46828%206.0426%201.53059C6.3192%201.59291%206.56967%201.73945%206.75953%201.95004L7.41803%202.67904C7.54645%202.82167%207.70341%202.93571%207.87874%203.01377C8.05407%203.09184%208.24386%203.13218%208.43578%203.13218C8.6277%203.13218%208.81748%203.09184%208.99281%203.01377C9.16814%202.93571%209.32511%202.82167%209.45353%202.67904L10.112%201.95004C10.3022%201.7404%2010.5525%201.59472%2010.8287%201.53295C11.1049%201.47119%2011.3935%201.49637%2011.6548%201.60504%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.7002%207.98073L7.58495%2010.494C7.68654%2010.6294%207.81737%2010.7401%207.96769%2010.8179C8.11801%2010.8957%208.28394%2010.9385%208.45313%2010.9433C8.62232%2010.948%208.7904%2010.9146%208.94486%2010.8453C9.09931%2010.7761%209.23616%2010.6729%209.3452%2010.5435L17.4362%200.938232%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1939%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Get certified"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/customers"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1944)%22%3E%3Cpath%20d%3D%22M8.4375%2011.8125H10.6875V15.1875L14.0625%2011.8125H16.3125C16.6108%2011.8125%2016.897%2011.694%2017.108%2011.483C17.319%2011.2721%2017.4375%2010.9858%2017.4375%2010.6875V1.6875C17.4375%201.38914%2017.319%201.10298%2017.108%200.892005C16.897%200.681026%2016.6108%200.5625%2016.3125%200.5625H7.3125C7.01414%200.5625%206.72798%200.681026%206.517%200.892005C6.30603%201.10298%206.1875%201.38914%206.1875%201.6875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%205.0625C1.125%205.65924%201.36205%206.23153%201.78401%206.65349C2.20597%207.07545%202.77826%207.3125%203.375%207.3125C3.97174%207.3125%204.54403%207.07545%204.96599%206.65349C5.38795%206.23153%205.625%205.65924%205.625%205.0625C5.625%204.46576%205.38795%203.89347%204.96599%203.47151C4.54403%203.04955%203.97174%202.8125%203.375%202.8125C2.77826%202.8125%202.20597%203.04955%201.78401%203.47151C1.36205%203.89347%201.125%204.46576%201.125%205.0625Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.7153%204.18188L11.5403%207.08738C11.4919%207.15179%2011.4302%207.20507%2011.3595%207.24359C11.2887%207.28212%2011.2106%207.305%2011.1302%207.3107C11.0498%207.31638%2010.9692%207.30475%2010.8937%207.27657C10.8182%207.24839%2010.7497%207.20434%2010.6927%207.14738L9.56775%206.02238M6.1875%2012.9374V11.2499C6.1875%2010.504%205.89118%209.78856%205.36374%209.26116C4.83629%208.73369%204.12092%208.43736%203.375%208.43736C2.62908%208.43736%201.91371%208.73369%201.38626%209.26116C0.858818%209.78856%200.5625%2010.504%200.5625%2011.2499V12.9374H1.6875L2.25%2017.4374H4.5L5.0625%2012.9374H6.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1944%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Customer stories"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Support"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/helpcenter/"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3565)%22%3E%3Cpath%20d%3D%22M16.3125%2011.8125V14.0625%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.6875%2014.0625V6.1875C1.6875%205.88914%201.80603%205.60298%202.01701%205.39201C2.22798%205.18103%202.51414%205.0625%202.8125%205.0625H5.625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.938%2014.0625C10.7428%2014.4042%2010.4607%2014.6882%2010.1204%2014.8857C9.78%2015.0833%209.39352%2015.1873%209%2015.1873C8.60648%2015.1873%208.22%2015.0833%207.87965%2014.8857C7.5393%2014.6882%207.25721%2014.4042%207.062%2014.0625H0.5625V15.1875C0.5625%2015.7842%200.799553%2016.3565%201.22151%2016.7785C1.64347%2017.2004%202.21576%2017.4375%202.8125%2017.4375H15.1875C15.7842%2017.4375%2016.3565%2017.2004%2016.7785%2016.7785C17.2004%2016.3565%2017.4375%2015.7842%2017.4375%2015.1875V14.0625H10.938Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.0666%200.762293C13.184%200.498585%2012.2441%200.495875%2011.3602%200.754485C10.4762%201.0131%209.68596%201.52199%209.08476%202.21975C8.48356%202.91752%208.09716%203.77433%207.97206%204.68683C7.84704%205.59934%207.98871%206.52853%208.38006%207.36229L6.83203%2010.5041L10.3743%209.53655C10.6868%209.71558%2011.0186%209.85823%2011.3636%209.9618C12.5764%2010.2972%2013.8725%2010.1422%2014.9721%209.53033C16.0718%208.91848%2016.8867%207.89878%2017.2412%206.69135C17.5955%205.4839%2017.461%204.18551%2016.8665%203.0764C16.272%201.96729%2015.2653%201.1364%2014.0636%200.763043L14.0666%200.762293Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.3281%204.24683C11.3281%203.96869%2011.4106%203.69681%2011.5651%203.46556C11.7196%203.2343%2011.9393%203.05405%2012.1962%202.94762C12.4532%202.84119%2012.736%202.81333%2013.0087%202.8676C13.2815%202.92186%2013.5321%203.0558%2013.7287%203.25246C13.9255%203.44913%2014.0593%203.6997%2014.1136%203.97248C14.1679%204.24526%2014.14%204.52801%2014.0336%204.78498C13.9272%205.04194%2013.7469%205.26156%2013.5157%205.41608C13.2844%205.5706%2013.0125%205.65307%2012.7344%205.65307%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.7344%207.90311C12.579%207.90311%2012.4531%207.77719%2012.4531%207.62186C12.4531%207.4665%2012.579%207.34058%2012.7344%207.34058%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3Cpath%20d%3D%22M12.7344%207.90311C12.8897%207.90311%2013.0156%207.77719%2013.0156%207.62186C13.0156%207.4665%2012.8897%207.34058%2012.7344%207.34058%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3565%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Help center"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/helpcenter/contact-support"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3573)%22%3E%3Cpath%20d%3D%22M3.375%2013.5H2.8125C2.21576%2013.5%201.64347%2013.2629%201.22151%2012.841C0.799553%2012.419%200.5625%2011.8467%200.5625%2011.25V9C0.5625%208.4033%200.799553%207.83098%201.22151%207.40901C1.64347%206.98705%202.21576%206.75%202.8125%206.75H3.375C3.52418%206.75%203.66726%206.80927%203.77275%206.91475C3.87824%207.02024%203.9375%207.16332%203.9375%207.3125V12.9375C3.9375%2013.0867%203.87824%2013.2298%203.77275%2013.3352C3.66726%2013.4408%203.52418%2013.5%203.375%2013.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.1875%2013.5H14.625C14.4758%2013.5%2014.3327%2013.4408%2014.2273%2013.3352C14.1217%2013.2298%2014.0625%2013.0867%2014.0625%2012.9375V7.3125C14.0625%207.16332%2014.1217%207.02024%2014.2273%206.91475C14.3327%206.80927%2014.4758%206.75%2014.625%206.75H15.1875C15.7842%206.75%2016.3565%206.98705%2016.7785%207.40901C17.2004%207.83098%2017.4375%208.4033%2017.4375%209V11.25C17.4375%2011.8467%2017.2004%2012.419%2016.7785%2012.841C16.3565%2013.2629%2015.7842%2013.5%2015.1875%2013.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.8125%206.75C2.8125%205.10897%203.46439%203.53515%204.62478%202.37478C5.78515%201.21439%207.35897%200.5625%209%200.5625C10.641%200.5625%2012.2149%201.21439%2013.3752%202.37478C14.5356%203.53515%2015.1875%205.10897%2015.1875%206.75%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.25%2016.3125H12.9375C13.5342%2016.3125%2014.1065%2016.0754%2014.5285%2015.6535C14.9504%2015.2315%2015.1875%2014.6592%2015.1875%2014.0625V13.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.125%2017.4375H9C8.70165%2017.4375%208.41545%2017.319%208.20447%2017.108C7.9935%2016.897%207.875%2016.6108%207.875%2016.3125C7.875%2016.0142%207.9935%2015.728%208.20447%2015.517C8.41545%2015.306%208.70165%2015.1875%209%2015.1875H10.125C10.4233%2015.1875%2010.7096%2015.306%2010.9205%2015.517C11.1315%2015.728%2011.25%2016.0142%2011.25%2016.3125C11.25%2016.6108%2011.1315%2016.897%2010.9205%2017.108C10.7096%2017.319%2010.4233%2017.4375%2010.125%2017.4375Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.75%206.18756C6.75008%205.77508%206.86354%205.37056%207.07799%205.01821C7.29244%204.66586%207.5996%204.37924%207.96597%204.18967C8.33227%204.00011%208.74372%203.91489%209.15517%203.94335C9.5667%203.9718%209.96247%204.11282%2010.2992%204.351C10.636%204.58917%2010.9008%204.91534%2011.0647%205.29385C11.2286%205.67236%2011.2853%206.08865%2011.2286%206.49721C11.1719%206.90577%2011.0041%207.2909%2010.7433%207.6105C10.4825%207.93008%2010.1389%208.1718%209.75%208.30928C9.53055%208.3869%209.34057%208.5306%209.20625%208.72065C9.07192%208.91078%208.99985%209.1378%209%209.37053V9.56253%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2012.375C8.84467%2012.375%208.71875%2012.2491%208.71875%2012.0938C8.71875%2011.9384%208.84467%2011.8125%209%2011.8125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3Cpath%20d%3D%22M9%2012.375C9.15533%2012.375%209.28125%2012.2491%209.28125%2012.0938C9.28125%2011.9384%209.15533%2011.8125%209%2011.8125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3573%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "24/7 support"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/w/partnership"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3558)%22%3E%3Cpath%20d%3D%22M8.4375%2016.875C6.34892%2016.875%204.34588%2016.0454%202.86904%2014.5685C1.39219%2013.0916%200.5625%2011.0886%200.5625%209C0.5625%206.91142%201.39219%204.90838%202.86904%203.43153C4.34588%201.95469%206.34892%201.125%208.4375%201.125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.4375%201.125C8.4375%201.125%204.5%203.375%204.5%209C4.5%2014.625%208.4375%2016.875%208.4375%2016.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43707%205.625H1.32031%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43707%2012.375H1.32031%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.8125%203.375C11.8125%203.97174%2012.0496%204.54403%2012.4715%204.96599C12.8935%205.38795%2013.4658%205.625%2014.0625%205.625C14.6592%205.625%2015.2315%205.38795%2015.6535%204.96599C16.0754%204.54403%2016.3125%203.97174%2016.3125%203.375C16.3125%202.77826%2016.0754%202.20597%2015.6535%201.78401C15.2315%201.36205%2014.6592%201.125%2014.0625%201.125C13.4658%201.125%2012.8935%201.36205%2012.4715%201.78401C12.0496%202.20597%2011.8125%202.77826%2011.8125%203.375Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M16.02%207.38452L14.0625%2010.125L12.105%207.38452C11.6672%207.69516%2011.3102%208.10594%2011.0636%208.58271C10.817%209.05941%2010.688%209.58824%2010.6875%2010.125V12.375C10.6875%2012.6734%2010.806%2012.9596%2011.017%2013.1705C11.2279%2013.3815%2011.5142%2013.5%2011.8125%2013.5H12.375V15.75C12.375%2016.0484%2012.4935%2016.3346%2012.7045%2016.5455C12.9155%2016.7565%2013.2017%2016.875%2013.5%2016.875H14.625C14.9233%2016.875%2015.2095%2016.7565%2015.4205%2016.5455C15.6315%2016.3346%2015.75%2016.0484%2015.75%2015.75V13.5H16.3125C16.6108%2013.5%2016.897%2013.3815%2017.108%2013.1705C17.319%2012.9596%2017.4375%2012.6734%2017.4375%2012.375V10.125C17.437%209.58824%2017.308%209.05941%2017.0614%208.58271C16.8149%208.10594%2016.4578%207.69516%2016.02%207.38452Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3558%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Partners"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "group_nav-col-parent", "is-products-end"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "nav-group-col-h"),
                                                                                                                tag: "div",
                                                                                                                children: "Build"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                                tag: "div",
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/templates"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3582)%22%3E%3Cpath%20d%3D%22M2.25%201.1228H15.75C15.75%201.1228%2016.875%201.1228%2016.875%202.2478V15.7478C16.875%2015.7478%2016.875%2016.8728%2015.75%2016.8728H2.25C2.25%2016.8728%201.125%2016.8728%201.125%2015.7478V2.2478C1.125%202.2478%201.125%201.1228%202.25%201.1228Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%205.6228H16.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2016.8728V5.6228%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%2011.2478H16.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3582%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "Template center"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                        className: utils.cx((CrmNav_module_default()), "m_dt-nav-link"),
                                                                                                                        button: false,
                                                                                                                        "data-header-sub-menu-link": "",
                                                                                                                        block: "inline",
                                                                                                                        options: {
                                                                                                                            href: "https://monday.com/appdeveloper"
                                                                                                                        },
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                                className: utils.cx((CrmNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                                value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1968)%22%3E%3Cpath%20d%3D%22M10.1496%2012.2625L15.8084%2011.8313C16.0139%2011.8155%2016.22%2011.8546%2016.4056%2011.9445C16.5912%2012.0344%2016.7496%2012.1719%2016.8647%2012.343C16.9797%2012.5141%2017.0473%2012.7127%2017.0606%2012.9185C17.0738%2013.1242%2017.0323%2013.3298%2016.9401%2013.5143C16.8081%2013.7773%2016.5818%2013.9808%2016.3064%2014.0843L8.48085%2017.0183C7.99885%2017.1994%207.46922%2017.2092%206.98085%2017.046L0.985352%2015.048%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.92285%2012.798H9.26385C9.47386%2012.798%209.67853%2012.7319%209.84893%2012.6092C10.0193%2012.4864%2010.1468%2012.3132%2010.2134%2012.114C10.2563%2011.9849%2010.2724%2011.8484%2010.2609%2011.7128C10.2493%2011.5773%2010.2102%2011.4455%2010.1459%2011.3255C10.0817%2011.2056%209.99372%2011.1%209.88732%2011.0152C9.78092%2010.9304%209.65835%2010.8681%209.5271%2010.8323L5.0736%209.61803C4.60361%209.48943%204.11139%209.46384%203.6306%209.54303L0.985352%209.98403%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.54735%202.22461L3.79785%204.28711L6.54735%206.34961%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.4229%202.22461L16.1731%204.28711L13.4229%206.34961%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.6726%200.849121L9.29785%207.72437%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1968%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                tag: "div",
                                                                                                                                children: "App development"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "group-nav-content-footer"),
                                                                                                tag: "div",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "group_header-buttons"),
                                                                                                    tag: "div",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "signup",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "#"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Get Started"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "header-links-divider"),
                                                                                                            tag: "div"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                            className: utils.cx((CrmNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                            button: false,
                                                                                                            "data-button-type": "homepage-contact-sales",
                                                                                                            block: "inline",
                                                                                                            options: {
                                                                                                                href: "https://monday.com/sales/contact-us"
                                                                                                            },
                                                                                                            children: [
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                    tag: "div",
                                                                                                                    children: "Contact sales"
                                                                                                                }),
                                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                    className: utils.cx((CrmNav_module_default()), "m_button-arrow"),
                                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                                })
                                                                                                            ]
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "close-trig"),
                                                                                        tag: "div"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full"),
                                                                        "data-header-link": "",
                                                                        options: {
                                                                            href: "https://monday.com/w/enterprise"
                                                                        },
                                                                        children: "Enterprise"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "nav-full-content-end"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full"),
                                                                        "data-button-type": "login",
                                                                        options: {
                                                                            href: "https://auth.monday.com/auth/login_monday/"
                                                                        },
                                                                        children: "Log in"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full", "is-header-cs"),
                                                                        "data-button-type": "homepage-contact-sales",
                                                                        options: {
                                                                            href: "https://monday.com/sales/contact-us"
                                                                        },
                                                                        children: "Request a demo"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                        className: utils.cx((CrmNav_module_default()), "primary-button-10", "_w-arrow", "in-nav"),
                                                                        button: false,
                                                                        "data-button-type": "signup",
                                                                        "data-product-id": "crm",
                                                                        "data-existing-account-cta-override": "Go to my account",
                                                                        "data-existing-account-url-override": "/",
                                                                        block: "inline",
                                                                        options: {
                                                                            href: "#"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                "data-signup-button-text": "",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "", "arrow-embed-full"),
                                                                                value: "%3Csvg%20class%3D%22btn-arrow%22%20width%3D%2212%22%20height%3D%22auto%22%20fill%3D%22currentcolor%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "comp_switcher", "light-103"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "switcher-toggle", "light-24"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "icon_switcher", "light-65"),
                                                                                    value: "%3Cimg%20alt%3D%22switcher%20icon%20hp%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fremote_mondaycom_static%2Fuploads%2FYotam_Ron%2Fswitcher-icon-hp.png%22%3E"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "switcher-list", "light-26"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-h", "light-107"),
                                                                                        tag: "div",
                                                                                        children: "Explore featured products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/work-management"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Work%20Management%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FWM.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Work management"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22CRM%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FCRM.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "CRM"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/dev"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Dev%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FDEV.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Dev"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/service"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Service%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FSVC.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Service "
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "group_switcher-bottom", "light-116"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-h", "light-107", "is--grey", "light-97"),
                                                                                                tag: "div",
                                                                                                children: "More products"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-bottom-end", "light-118"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                        button: false,
                                                                                                        block: "inline",
                                                                                                        options: {
                                                                                                            href: "https://workforms.com/"
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                                value: "%3Cimg%20alt%3D%22WorkForms%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fforms.png%22%3E"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                tag: "div",
                                                                                                                children: "WorkForms"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                        button: false,
                                                                                                        block: "inline",
                                                                                                        options: {
                                                                                                            href: "https://workcanvas.com/"
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                                value: "%3Cimg%20alt%3D%22WorkCanvas%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fcanvas.png%22%3E"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                tag: "div",
                                                                                                                children: "WorkCanvas"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "mobile-menu-trigger", "is-shown"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-top"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-middle"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-bottom"),
                                                                tag: "div"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                        className: utils.cx((CrmNav_module_default()), "nav-full-minisite", "for-ms"),
                                        tag: "div",
                                        config: {
                                            easing: "ease",
                                            easing2: "ease",
                                            duration: 400,
                                            docHeight: false,
                                            noScroll: false,
                                            animation: "default",
                                            collapse: "medium"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "shadow-on-nav"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "nav-container-full"),
                                                tag: "div",
                                                "data-header": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((CrmNav_module_default()), "header-logo-link", "for-minisite", "for--svc"),
                                                        button: false,
                                                        block: "inline",
                                                        options: {
                                                            href: "https://monday.com/crm"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((CrmNav_module_default()), "minisite-logo", "is--large"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/656da6fea306219773d04208/682a0ca78db5a3b2791f1bac_CRM-oneliner-box.svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "nav-full-content", "for--crm"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "nav-full-content-start", "for-minisite"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-top-parent"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-full", "is-drop"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "CRM products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-list", "for--top"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                        children: "monday"
                                                                                                    }),
                                                                                                    " CRM"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/crm/campaigns"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                        children: "monday"
                                                                                                    }),
                                                                                                    " campaigns"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-top-parent"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-full", "is-drop"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Overview"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-list", "for--top"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm/features"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Features"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm/marketplace"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Templates"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm/overview/integrations"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Integrations"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-parent"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Learn"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-list"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm/whats-new"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "What’s new?"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/blog/crm-and-sales"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Blog"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://support.monday.com/hc/en-us/p/crm"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Knowledge base"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/academy/catalog?type=Lesson&monday_products=CRM"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "CRM academy"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://www.youtube.com/@mondayCRMofficial"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Webinars & videos"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/p/events-hub/?solutions=sales_crm&solutions=marketing_creative%EF%BB%BF&display=all_events"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Events"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/lp/state-of-sales"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "Guides"
                                                                                        })
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://www.crmcare.org"
                                                                                        },
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                            tag: "div",
                                                                                            children: "CRM care"
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full"),
                                                                        button: false,
                                                                        block: "",
                                                                        options: {
                                                                            href: "#"
                                                                        },
                                                                        children: "Partners"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-top-parent"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-full", "is-drop"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Pricing"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                        value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "nav_link-list", "for--top", "is--wider"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm/pricing"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                        children: "monday"
                                                                                                    }),
                                                                                                    " CRM pricing"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                        children: "monday"
                                                                                                    }),
                                                                                                    " campaigns pricing"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "nav-full-content-end"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full"),
                                                                        "data-button-type": "login",
                                                                        options: {
                                                                            href: "https://auth.monday.com/auth/login_monday/"
                                                                        },
                                                                        children: "Log in"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-full", "is-header-cs"),
                                                                        "data-button-type": "homepage-contact-sales",
                                                                        options: {
                                                                            href: "https://monday.com/sales/contact-us"
                                                                        },
                                                                        children: "Request a demo"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                        className: utils.cx((CrmNav_module_default()), "primary-button-10", "_w-arrow", "in-nav"),
                                                                        button: false,
                                                                        "data-button-type": "signup",
                                                                        block: "inline",
                                                                        options: {
                                                                            href: "#"
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                "signup-button-text-position": "header-main",
                                                                                children: "Get Started"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "", "arrow-embed-full"),
                                                                                value: "%3Csvg%20class%3D%22btn-arrow%22%20width%3D%2212%22%20height%3D%22auto%22%20fill%3D%22currentcolor%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                        className: utils.cx((CrmNav_module_default()), "comp_switcher", "light-103"),
                                                                        tag: "div",
                                                                        delay: 0,
                                                                        hover: false,
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle, {
                                                                                className: utils.cx((CrmNav_module_default()), "switcher-toggle", "light-24"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "icon_switcher", "light-65"),
                                                                                    value: "%3Cimg%20alt%3D%22switcher%20icon%20hp%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fremote_mondaycom_static%2Fuploads%2FYotam_Ron%2Fswitcher-icon-hp.png%22%3E"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                                className: utils.cx((CrmNav_module_default()), "switcher-list", "light-26"),
                                                                                tag: "nav",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-h", "light-107"),
                                                                                        tag: "div",
                                                                                        children: "Explore featured products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/work-management"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Work%20Management%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FWM.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Work management"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/crm"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22CRM%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FCRM.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "CRM"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/dev"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Dev%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FDEV.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Dev"
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                        button: false,
                                                                                        block: "inline",
                                                                                        options: {
                                                                                            href: "https://monday.com/w/service"
                                                                                        },
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                                value: "%3Cimg%20alt%3D%22Service%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FSVC.svg%22%3E"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Service "
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "group_switcher-bottom", "light-116"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-h", "light-107", "is--grey", "light-97"),
                                                                                                tag: "div",
                                                                                                children: "More products"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-bottom-end", "light-118"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                        button: false,
                                                                                                        block: "inline",
                                                                                                        options: {
                                                                                                            href: "https://workforms.com/"
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                                value: "%3Cimg%20alt%3D%22WorkForms%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fforms.png%22%3E"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                tag: "div",
                                                                                                                children: "WorkForms"
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                        className: utils.cx((CrmNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                        button: false,
                                                                                                        block: "inline",
                                                                                                        options: {
                                                                                                            href: "https://workcanvas.com/"
                                                                                                        },
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                className: utils.cx((CrmNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                                value: "%3Cimg%20alt%3D%22WorkCanvas%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fcanvas.png%22%3E"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                tag: "div",
                                                                                                                children: "WorkCanvas"
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "mobile-menu-trigger", "is-shown"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-top"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-middle"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-2", "is-bottom"),
                                                                tag: "div"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((CrmNav_module_default()), "nav-full-minisite-bottom"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "nav-container-full"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "nav-minisite-group"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((CrmNav_module_default()), "minisite-logo-link"),
                                                        button: false,
                                                        block: "inline",
                                                        options: {
                                                            href: "https://monday.com/crm"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((CrmNav_module_default()), "minisite-logo"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/656da6fea306219773d04208/682a0ca78db5a3b2791f1bac_CRM-oneliner-box.svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "minisite-links-group"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-parent"),
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "CRM products"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-list"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "eager",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                children: "monday"
                                                                                            }),
                                                                                            " CRM"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/crm/campaigns"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "eager",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                children: "monday"
                                                                                            }),
                                                                                            " campaigns"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-parent"),
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Overview"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-list"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/features"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Features"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/marketplace"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Templates"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/overview/integrations"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Integrations"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                className: utils.cx((CrmNav_module_default()), "nav_link-ms-dd-parent"),
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Learn"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-list"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/whats-new"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "What’s new?"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/blog/crm-and-sales"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Blog"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://support.monday.com/hc/en-us/p/crm"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Knowledge base"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/academy/catalog?type=Lesson&monday_products=CRM"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "CRM academy"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://www.youtube.com/@mondayCRMofficial"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Webinars & videos"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/p/events-hub/?solutions=sales_crm&solutions=marketing_creative%EF%BB%BF&display=all_events"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Events"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/lp/state-of-sales"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "Guides"
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://www.crmcare.org"
                                                                                },
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                    tag: "div",
                                                                                    children: "CRM care"
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((CrmNav_module_default()), "nav_link-ms"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "https://monday.com/w/crm/partnership"
                                                                },
                                                                children: "Partners"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownToggle, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                children: "Pricing"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((CrmNav_module_default()), "nav_link-list", "is--wider"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/pricing"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                children: "monday"
                                                                                            }),
                                                                                            " CRM pricing"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm/campaigns/pricing"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                                                                children: "monday"
                                                                                            }),
                                                                                            " campaigns pricing"
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "minisite-nav-mb", "is-static", "is-100vw"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                        className: utils.cx((CrmNav_module_default()), "mobile-nav-ms"),
                                        tag: "div",
                                        config: {
                                            easing: "ease",
                                            easing2: "ease",
                                            duration: 400,
                                            docHeight: false,
                                            noScroll: false,
                                            animation: "default",
                                            collapse: "all"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "nav-container-lp"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((CrmNav_module_default()), "header-logo-link-mb"),
                                                        button: false,
                                                        block: "inline",
                                                        options: {
                                                            href: "https://monday.com/crm"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((CrmNav_module_default()), "minisite-logo-mb"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/656da6fea306219773d04208/682a0ca78db5a3b2791f1bac_CRM-oneliner-box.svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "nav_menu-mobile"),
                                                        tag: "div",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((CrmNav_module_default()), "nav_menu-mobile-content"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-text"),
                                                                                    tag: "div",
                                                                                    children: "Products"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "chevron"),
                                                                                    value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "group-child", "_23-rem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "Tailored to your teams' needs"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "_w-icon"),
                                                                                            button: false,
                                                                                            block: "inline",
                                                                                            options: {
                                                                                                href: "https://monday.com/work-management"
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "mobile-menu-ucon"),
                                                                                                    width: "auto",
                                                                                                    height: "auto",
                                                                                                    loading: "lazy",
                                                                                                    alt: "",
                                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b574_WM_Symbol.svg"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "monday work management"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "_w-icon"),
                                                                                            button: false,
                                                                                            block: "inline",
                                                                                            options: {
                                                                                                href: "https://monday.com/crm"
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "mobile-menu-ucon"),
                                                                                                    width: "auto",
                                                                                                    height: "auto",
                                                                                                    loading: "lazy",
                                                                                                    alt: "",
                                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b573_CRM_Symbol.svg"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "monday CRM"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "_w-icon"),
                                                                                            button: false,
                                                                                            block: "inline",
                                                                                            options: {
                                                                                                href: "https://monday.com/w/dev"
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "mobile-menu-ucon"),
                                                                                                    width: "auto",
                                                                                                    height: "auto",
                                                                                                    loading: "lazy",
                                                                                                    alt: "",
                                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b572_DEV_Symbol.svg"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "monday dev"
                                                                                                })
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "_w-icon"),
                                                                                            button: false,
                                                                                            block: "inline",
                                                                                            options: {
                                                                                                href: "/w/service"
                                                                                            },
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                    className: utils.cx((CrmNav_module_default()), "mobile-menu-ucon"),
                                                                                                    width: "auto",
                                                                                                    height: "auto",
                                                                                                    loading: "lazy",
                                                                                                    alt: "",
                                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b571_SVC_Symbol.svg"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "monday service"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "More by monday.com"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#",
                                                                                                target: "_blank"
                                                                                            },
                                                                                            children: "WorkForms"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#",
                                                                                                target: "_blank"
                                                                                            },
                                                                                            children: "WorkCanvas"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-text"),
                                                                                    tag: "div",
                                                                                    children: "Teams"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "chevron"),
                                                                                    value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "group-child", "_28-rem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "By team"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Marketing"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Project management"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Sales"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Product development"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Operations"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "IT"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "HR"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "By business size"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Enterprise"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Small business"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Nonprofit"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "By industry"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Retail"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Media"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Construction"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Government"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-text"),
                                                                                    tag: "div",
                                                                                    children: "Features"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "chevron"),
                                                                                    value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "group-child", "_24-rem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Dashboards"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Integrations"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Automations"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "AI"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Gantt"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Kanban"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Docs"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                        className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                        button: false,
                                                                                        block: "",
                                                                                        options: {
                                                                                            href: "#"
                                                                                        },
                                                                                        children: "Forms"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-text"),
                                                                                    tag: "div",
                                                                                    children: "Resources"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "chevron"),
                                                                                    value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "group-child", "_50-rem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "Learn"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Help center"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "What's new"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "About us"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Blog"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Certifications"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "Connect"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "24/7 support"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Partners"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Global events"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Community"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((CrmNav_module_default()), "sub-group", "bottom-margin"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link", "is-title"),
                                                                                            tag: "div",
                                                                                            children: "Build"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "App development"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Template center"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                            className: utils.cx((CrmNav_module_default()), "mobile-link"),
                                                                                            button: false,
                                                                                            block: "",
                                                                                            options: {
                                                                                                href: "#"
                                                                                            },
                                                                                            children: "Spaces"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom", "_w--icon"),
                                                                    button: false,
                                                                    block: "inline",
                                                                    options: {
                                                                        href: "#"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: "Discover AI"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((CrmNav_module_default()), "mb-menu-ai-icon"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/656da6fea306219773d04208/680793b5784dff59f274e76d_icon-ai.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                                    button: false,
                                                                    block: "",
                                                                    options: {
                                                                        href: "https://monday.com/pricing"
                                                                    },
                                                                    children: "Pricing"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                                    button: false,
                                                                    "data-button-type": "homepage-contact-sales",
                                                                    block: "",
                                                                    options: {
                                                                        href: "https://monday.com/sales/contact-us?from=header&source=Website%20-%20Contact%20Sales"
                                                                    },
                                                                    children: "Contact sales"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                    className: utils.cx((CrmNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                                    button: false,
                                                                    block: "",
                                                                    options: {
                                                                        href: "https://auth.monday.com/login"
                                                                    },
                                                                    children: "Log in"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((CrmNav_module_default()), "appstore-wrap"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((CrmNav_module_default()), "badges-wrap"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((CrmNav_module_default()), "appstore-badge"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "https://apps.apple.com/us/app/monday-com-work-management/id1290128888",
                                                                                        target: "_blank"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((CrmNav_module_default()), "appstore-badge-img"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b570_appstore.svg"
                                                                                    })
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((CrmNav_module_default()), "appstore-badge"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "https://play.google.com/store/apps/details?id=com.monday.monday&hl=en&gl=US",
                                                                                        target: "_blank"
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((CrmNav_module_default()), "appstore-badge-img"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b56f_Play.svg"
                                                                                    })
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                            className: utils.cx((CrmNav_module_default()), "go-to-hp-btn"),
                                                                            button: false,
                                                                            block: "inline",
                                                                            options: {
                                                                                href: "https://monday.com/"
                                                                            },
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "go-to-hp-logo"),
                                                                                    value: "%3Cimg%20alt%3D%22Monday%22%20class%3D%22jsx-4212101279%22%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fmobile_menu%2FMonday.png%22%3E"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    tag: "div",
                                                                                    children: "Go to homepage"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                    className: utils.cx((CrmNav_module_default()), "go-to-hp-arrow"),
                                                                                    value: "%3Csvg%20width%3D%2212%22%20height%3D%2214%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((CrmNav_module_default()), "full_mobile-menu-trigger", "is-open"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-full", "is-top"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-full", "is-middle"),
                                                                tag: "div"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((CrmNav_module_default()), "hamburger-dash-full", "is-bottom"),
                                                                tag: "div"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "shadow-on-nav"),
                                                tag: "div"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((CrmNav_module_default()), "overflow-x-auto"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "minisite-links-group", "is-crm"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                    className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd", "for--products"),
                                                    tag: "div",
                                                    slot: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "CRM Products"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                            value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                    className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd", "for--overview"),
                                                    "data-w-id": "5fc65d0a-04a2-e85e-e4b1-d64237071511",
                                                    tag: "div",
                                                    slot: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Overview"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                            value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                    className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd", "for--resources"),
                                                    "data-w-id": "5fc65d0a-04a2-e85e-e4b1-d64237071515",
                                                    tag: "div",
                                                    slot: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Learn"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                            value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                    className: utils.cx((CrmNav_module_default()), "nav_link-ms"),
                                                    button: false,
                                                    block: "",
                                                    options: {
                                                        href: "https://monday.com/w/crm/partnership"
                                                    },
                                                    children: "Partners"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                    className: utils.cx((CrmNav_module_default()), "nav_link-ms", "for--dd", "for-pricing"),
                                                    tag: "div",
                                                    slot: "",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Pricing"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((CrmNav_module_default()), "chevron-down", "for--dd"),
                                                            value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "nav_link-list-tb", "for--products"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                        children: "monday"
                                                    }),
                                                    " CRM"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/w/crm/campaigns"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                        children: "monday"
                                                    }),
                                                    " campaigns"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "nav_link-list-tb", "for--pricing"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm/pricing"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                        children: "monday"
                                                    }),
                                                    " CRM pricing"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm/campaigns/pricing"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                        children: "monday"
                                                    }),
                                                    " campaigns pricing"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "nav_link-list-tb", "for--overview"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm/features"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Features"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm/marketplace"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Templates"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Integrations"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((CrmNav_module_default()), "nav_link-list-tb", "for--resources"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/crm/whats-new"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "What’s new?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "https://monday.com/blog/crm-and-sales"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Blog"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Knowledge base"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "CRM academy"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Webinars & videos"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Events"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "Guides"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-2"),
                                        button: false,
                                        block: "inline",
                                        options: {
                                            href: "#"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((CrmNav_module_default()), "dropdown-link-inner-text"),
                                            tag: "div",
                                            children: "CRM care"
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((CrmNav_module_default()), "nav-spacer"),
                        tag: "div"
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/Departments.module.css
var Departments_module = __webpack_require__(65789);
var Departments_module_default = /*#__PURE__*/__webpack_require__.n(Departments_module);
;// CONCATENATED MODULE: ./devlink/Departments.js
"use client";






var Departments_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Departments(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _tab1Title = param.tab1Title, tab1Title = _tab1Title === void 0 ? "Drive execution at scale" : _tab1Title, _tab2Title = param.tab2Title, tab2Title = _tab2Title === void 0 ? "Accelerate revenue growth" : _tab2Title, _tab3Title = param.tab3Title, tab3Title = _tab3Title === void 0 ? "Amplify marketing impact" : _tab3Title, _tab4Title = param.tab4Title, tab4Title = _tab4Title === void 0 ? "Scale exceptional service" : _tab4Title, _tab5Title = param.tab5Title, tab5Title = _tab5Title === void 0 ? "Launch quality products faster" : _tab5Title, _tab6Title = param.tab6Title, tab6Title = _tab6Title === void 0 ? "Lead with clear foresight" : _tab6Title, _tab1Text = param.tab1Text, tab1Text = _tab1Text === void 0 ? "Deliver projects, programs, and portfolios with full resource visibility and AI-powered risk detection." : _tab1Text, _tab2Text = param.tab2Text, tab2Text = _tab2Text === void 0 ? "Free your teams from data entry to focus on sales and nurture, with AI actions and code-free automations." : _tab2Text, _tab3Text = param.tab3Text, tab3Text = _tab3Text === void 0 ? "Align marketing around shared goals with AI that streamlines briefs, flags delays, and drives campaign impact." : _tab3Text, _tab4Text = param.tab4Text, tab4Text = _tab4Text === void 0 ? "Empower teams to resolve requests faster with AI that triages, routes, and guides each issue to resolution." : _tab4Text, _tab5Text = param.tab5Text, tab5Text = _tab5Text === void 0 ? "Plan roadmaps, execute sprints, and ship with precision using AI-powered guidance." : _tab5Text, _tab6Text = param.tab6Text, tab6Text = _tab6Text === void 0 ? "Keep strategic goals on track with AI risk flagging and cross-org data to make real-time decisions." : _tab6Text, _tab1TextButton = param.tab1TextButton, tab1TextButton = _tab1TextButton === void 0 ? "Get Started" : _tab1TextButton, _tab2TextButton = param.tab2TextButton, tab2TextButton = _tab2TextButton === void 0 ? "Get Started" : _tab2TextButton, _tab3TextButton = param.tab3TextButton, tab3TextButton = _tab3TextButton === void 0 ? "Get Started" : _tab3TextButton, _tab4TextButton = param.tab4TextButton, tab4TextButton = _tab4TextButton === void 0 ? "Get Started" : _tab4TextButton, _tab5TextButton = param.tab5TextButton, tab5TextButton = _tab5TextButton === void 0 ? "Get Started" : _tab5TextButton, _tab6TextButton = param.tab6TextButton, tab6TextButton = _tab6TextButton === void 0 ? "Get Started" : _tab6TextButton, _tab1ClientLogo = param.tab1ClientLogo, tab1ClientLogo = _tab1ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg" : _tab1ClientLogo, _tab2ClientLogo = param.tab2ClientLogo, tab2ClientLogo = _tab2ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860e2ec0f057ce07046a649_logo-height-kc.png" : _tab2ClientLogo, _tab3ClientLogo = param.tab3ClientLogo, tab3ClientLogo = _tab3ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg" : _tab3ClientLogo, _tab4ClientLogo = param.tab4ClientLogo, tab4ClientLogo = _tab4ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f49dd0c89f06fbf3217c_logo-height-zopa.png" : _tab4ClientLogo, _tab5ClientLogo = param.tab5ClientLogo, tab5ClientLogo = _tab5ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg" : _tab5ClientLogo, _tab6ClientLogo = param.tab6ClientLogo, tab6ClientLogo = _tab6ClientLogo === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg" : _tab6ClientLogo, _tab1QuoteClient = param.tab1QuoteClient, tab1QuoteClient = _tab1QuoteClient === void 0 ? "“monday.com gives us the visibility to get everyone on the same page and track all the moving parts of our projects.”" : _tab1QuoteClient, _tab2QuoteClient = param.tab2QuoteClient, tab2QuoteClient = _tab2QuoteClient === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "“As a VP, trying to look at a 30,000-ft view, I can see the percentage of successful opportunities and know-how to analyze the market.”",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _tab2QuoteClient, _tab3QuoteClient = param.tab3QuoteClient, tab3QuoteClient = _tab3QuoteClient === void 0 ? "“monday.com isn’t just another tool in the mix, but a work operating system that supports our need for efficiency at scale.”" : _tab3QuoteClient, _tab4QuoteClient = param.tab4QuoteClient, tab4QuoteClient = _tab4QuoteClient === void 0 ? '"With monday service, 98% of our tickets are automatically categorized and assigned by AI. We resolve each 6-7 mins faster."' : _tab4QuoteClient, _tab5QuoteClient = param.tab5QuoteClient, tab5QuoteClient = _tab5QuoteClient === void 0 ? '"monday dev ensures clear alignment between what we’re building and market demand. Does it help us move faster? Without a doubt."' : _tab5QuoteClient, _tab6QuoteClient = param.tab6QuoteClient, tab6QuoteClient = _tab6QuoteClient === void 0 ? "“Now in real-time, we can identify health metrics and risks, whether they’re coming from our side or the client side.”" : _tab6QuoteClient, _tab1ClientHeadshot = param.tab1ClientHeadshot, tab1ClientHeadshot = _tab1ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/687362114a8e19b70c857667_Jason.png" : _tab1ClientHeadshot, _tab2ClientHeadshot = param.tab2ClientHeadshot, tab2ClientHeadshot = _tab2ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6873627106c54dca6fa8aeaa_Christopher.png" : _tab2ClientHeadshot, _tab4ClientHeadshot = param.tab4ClientHeadshot, tab4ClientHeadshot = _tab4ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f221b5a054ab91f528af_image.png" : _tab4ClientHeadshot, _tab5ClientHeadshot = param.tab5ClientHeadshot, tab5ClientHeadshot = _tab5ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/686f8152e8fbbe7cb4f5c720_departments-headshot-6.png" : _tab5ClientHeadshot, _tab6ClientHeadshot = param.tab6ClientHeadshot, tab6ClientHeadshot = _tab6ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6840979a2eb950be4600b697_VML-avatar.png" : _tab6ClientHeadshot, _tab1NameClient = param.tab1NameClient, tab1NameClient = _tab1NameClient === void 0 ? "Jason Doan" : _tab1NameClient, _tab2NameClient = param.tab2NameClient, tab2NameClient = _tab2NameClient === void 0 ? "Christopher Stone" : _tab2NameClient, _tab3NameClient = param.tab3NameClient, tab3NameClient = _tab3NameClient === void 0 ? "Vic Diesta" : _tab3NameClient, _tab4NameClient = param.tab4NameClient, tab4NameClient = _tab4NameClient === void 0 ? "Clive Camilleri" : _tab4NameClient, _tab5NameClient = param.tab5NameClient, tab5NameClient = _tab5NameClient === void 0 ? "Alan Schmoll" : _tab5NameClient, _tab6NameClient = param.tab6NameClient, tab6NameClient = _tab6NameClient === void 0 ? "Paul Willie" : _tab6NameClient, _tab6TitleClient = param.tab6TitleClient, tab6TitleClient = _tab6TitleClient === void 0 ? "COO, VML" : _tab6TitleClient, _tab5TitleClient = param.tab5TitleClient, tab5TitleClient = _tab5TitleClient === void 0 ? "Executive VP, Vistra Platform" : _tab5TitleClient, _tab4TitleClient = param.tab4TitleClient, tab4TitleClient = _tab4TitleClient === void 0 ? "Head of People & Ops, Zopa Bank" : _tab4TitleClient, _tab3TitleClient = param.tab3TitleClient, tab3TitleClient = _tab3TitleClient === void 0 ? "Creative Operations Lead, Canva" : _tab3TitleClient, _tab2TitleClient = param.tab2TitleClient, tab2TitleClient = _tab2TitleClient === void 0 ? "VP Business Development, KC Petroleum" : _tab2TitleClient, _tab1TitleClient = param.tab1TitleClient, tab1TitleClient = _tab1TitleClient === void 0 ? "VP of Operations, HOLT CAT" : _tab1TitleClient, _mainTitle = param.mainTitle, mainTitle = _mainTitle === void 0 ? "Solutions for every team. Powered by one platform." : _mainTitle, _tab1ImageUrl = param.tab1ImageUrl, tab1ImageUrl = _tab1ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050978/Generator_featured%20images/hp-2025/departments/bento/drive-execution-at-scale-v4.png" : _tab1ImageUrl, _tab2ImageUrl = param.tab2ImageUrl, tab2ImageUrl = _tab2ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050977/Generator_featured%20images/hp-2025/departments/bento/accelerate-revenue-growth-v4.png" : _tab2ImageUrl, _tab3ImageUrl = param.tab3ImageUrl, tab3ImageUrl = _tab3ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050983/Generator_featured%20images/hp-2025/departments/bento/unify-marketing-to-amplify-impact-v4.png" : _tab3ImageUrl, _tab4ImageUrl = param.tab4ImageUrl, tab4ImageUrl = _tab4ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050985/Generator_featured%20images/hp-2025/departments/bento/scale-exceptiona-service-v4.png" : _tab4ImageUrl, _tab5ImageUrl = param.tab5ImageUrl, tab5ImageUrl = _tab5ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050979/Generator_featured%20images/hp-2025/departments/bento/launch-quality-products-faster-v4.png" : _tab5ImageUrl, _tab6ImageUrl = param.tab6ImageUrl, tab6ImageUrl = _tab6ImageUrl === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1752050981/Generator_featured%20images/hp-2025/departments/bento/lead-with-clear-foresight-v4.webp" : _tab6ImageUrl, _tab3ClientHeadshot = param.tab3ClientHeadshot, tab3ClientHeadshot = _tab3ClientHeadshot === void 0 ? "https://cdn.prod.website-files.com/65b62e80a3a89609079c247a/670ba85ec4442a965eb743d8_Vic%20Diesta.jpeg" : _tab3ClientHeadshot, _tab2ImageAlt = param.tab2ImageAlt, tab2ImageAlt = _tab2ImageAlt === void 0 ? "Accelerate revenue growth" : _tab2ImageAlt, _tab3ImageAlt = param.tab3ImageAlt, tab3ImageAlt = _tab3ImageAlt === void 0 ? "Amplify marketing impact" : _tab3ImageAlt, _tab4ImageAlt = param.tab4ImageAlt, tab4ImageAlt = _tab4ImageAlt === void 0 ? "Scale exceptional service" : _tab4ImageAlt, _tab5ImageAlt = param.tab5ImageAlt, tab5ImageAlt = _tab5ImageAlt === void 0 ? "Launch quality products faster" : _tab5ImageAlt, _tab6ImageAlt = param.tab6ImageAlt, tab6ImageAlt = _tab6ImageAlt === void 0 ? "Lead with clear foresight" : _tab6ImageAlt, _tab1ImageAlt = param.tab1ImageAlt, tab1ImageAlt = _tab1ImageAlt === void 0 ? "Drive execution at scale" : _tab1ImageAlt, _client1Stat = param.client1Stat, client1Stat = _client1Stat === void 0 ? "$4M saved with optimized processes" : _client1Stat, _client2Stat = param.client2Stat, client2Stat = _client2Stat === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "18x ROI achieved",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "inthe first year"
        ]
    }) : _client2Stat, _client3Stat = param.client3Stat, client3Stat = _client3Stat === void 0 ? "300% increase in creative output" : _client3Stat, _client4Stat = param.client4Stat, client4Stat = _client4Stat === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "55 hours saved",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "per month",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _client4Stat, _client5Stat = param.client5Stat, client5Stat = _client5Stat === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "28% faster time ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "to market"
        ]
    }) : _client5Stat, _client6Stat = param.client6Stat, client6Stat = _client6Stat === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "11% efficiency gained",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "per month"
        ]
    }) : _client6Stat;
    interactions/* useInteractions */.NI(Departments_interactionsData, (Departments_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Departments_module_default()), "sec-departments"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Departments_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Departments_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((Departments_module_default()), "m_container-large", "for--departments"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((Departments_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Departments_module_default()), "fw1_section-headline-parent"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        className: utils.cx((Departments_module_default()), "fw1_section-title", "is--short"),
                                        tag: "h2",
                                        children: mainTitle
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%5Bclass*%3D%22comp_products%22%5D%20%5Bclass*%3D%22splide__arrows%22%5D%20%7B%0A%20%20display%3A%20none%3B%0A%7D%0A%0A%40media%20screen%20and%20(min-width%3A%20992px)%20and%20(max-width%3A%201140px)%20%7B%0A%20%20%5Bclass*%3D%22group-hp-tab-content%22%5D%20%7B%0A%20%20%20%20gap%3A%201rem%3B%0A%20%20%20%20grid-template-columns%3A%201fr%201fr%3B%0A%20%20%7D%0A%0A%20%20%2F*%20For%20the%20Webflow-generated%20ID%20selectors%20%E2%80%94%20these%20must%20stay%20as-is%2C%0A%20%20%20%20%20since%20they%20are%20exact%20IDs%20and%20not%20class%20names%20*%2F%0A%20%20%23w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30d6-1885c9b1%2C%0A%20%20%23w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4d9-1885c9b1%2C%0A%20%20%23w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc42-1885c9b1%2C%0A%20%20%23w-node-_2c0611a3-724d-48c2-5870-1877aef88c47-1885c9b1%2C%0A%20%20%23w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d774-1885c9b1%2C%0A%20%20%23w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc831-1885c9b1%20%7B%0A%20%20%20%20grid-column%3A%20span%202%3B%0A%20%20%20%20grid-row%3A%20span%202%3B%0A%20%20%7D%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((Departments_module_default()), "comp_products"),
                            tag: "div",
                            "data-splide-wrapper": "",
                            "data-splide-type": "tabs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((Departments_module_default()), "splide", "for--tabs"),
                                    tag: "div",
                                    "data-splide-role": "nav",
                                    role: "tablist",
                                    "aria-label": "Tab Navigation",
                                    "data-focus": "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Departments_module_default()), "products_tabs-menu", "splide__track"),
                                        tag: "div",
                                        "data-splide-element": "track",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                            className: utils.cx((Departments_module_default()), "tabs_nav-list", "splide__list"),
                                            tag: "ul",
                                            "aria-label": "Tab Navigation",
                                            "data-splide-element": "list",
                                            unstyled: false,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "for--pmo", "splide__slide", "is-active"),
                                                    role: "presentation",
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-2",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-2",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Projects"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "for--sales", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-3",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-3",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Sales"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "for--marketing", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-4",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-4",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Marketing"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "for--service", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-5",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-5",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "IT & Ops"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "for--dev", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-6",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-6",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Product & Engineering"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((Departments_module_default()), "product_tab-link", "splide__slide"),
                                                    role: "presentation",
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Departments_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "0",
                                                        id: "tab-product-1",
                                                        role: "tab",
                                                        "aria-selected": "true",
                                                        "aria-controls": "panel-1",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Leadership"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((Departments_module_default()), "splide", "for--tab-content"),
                                    tag: "div",
                                    "data-splide-role": "content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Departments_module_default()), "splide__track", "for--tabs-content"),
                                        tag: "div",
                                        "data-splide-element": "track",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Departments_module_default()), "splide__list"),
                                            tag: "div",
                                            "data-splide-element": "list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-2",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big", "is--primary"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4d9-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                slot: "",
                                                                                tag: "img",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-wm-1.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h", "is--short"),
                                                                                tag: "h3",
                                                                                children: tab1Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab1Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e0-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "work-management",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab1TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab1ImageUrl,
                                                                            alt: tab1ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e6-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab1ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client1Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4ec-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: tab1QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: tab1ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab1NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab1TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-3",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big", "is--crm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc42-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                slot: "",
                                                                                tag: "img",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-crm.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: tab2Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab2Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-_3059929e-be66-5200-04cb-01b96a9f9f91-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "crm",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab2TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab2ImageUrl,
                                                                            alt: tab2ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc4f-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab2ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client2Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc55-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: tab2QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: tab2ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab2NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab2TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-4",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big", "is--marketing"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_2c0611a3-724d-48c2-5870-1877aef88c47-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-wm-1.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: tab3Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab3Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-_2c0611a3-724d-48c2-5870-1877aef88c4e-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "work-management",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab3TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab3ImageUrl,
                                                                            alt: tab3ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_2c0611a3-724d-48c2-5870-1877aef88c54-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab3ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client3Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_2c0611a3-724d-48c2-5870-1877aef88c5a-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: tab3QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    id: utils.cx((Departments_module_default()), "w-node-_2c0611a3-724d-48c2-5870-1877aef88c5f-1885c9b1"),
                                                                                    slot: "",
                                                                                    tag: "img",
                                                                                    src: tab3ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab3NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab3TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-5",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big", "is--svc"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d774-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                slot: "",
                                                                                tag: "img",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-svc.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: tab4Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab4Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d77b-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "service",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab4TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab4ImageUrl,
                                                                            alt: tab4ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d781-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab4ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client4Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d78a-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote", "is--small"),
                                                                        children: tab4QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: tab4ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab4NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab4TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-6",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big", "is--dev"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc831-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                slot: "",
                                                                                tag: "img",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-dev.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: tab5Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab5Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc838-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "dev",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab5TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab5ImageUrl,
                                                                            alt: tab5ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc83e-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab5ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client5Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc846-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote", "is--small"),
                                                                        children: tab5QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: tab5ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab5NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab5TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Departments_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-1",
                                                    tabIndex: "0",
                                                    "data-splide-element": "slide",
                                                    id: "panel-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Departments_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-big"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30d6-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-product-logo"),
                                                                                slot: "",
                                                                                tag: "img",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1751447997/Generator_featured%20images/hp-2025/departments/logo-product-suit-v3.avif",
                                                                                alt: "logo-product-suit"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: tab6Title
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-par"),
                                                                                children: tab6Text
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((Departments_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((Departments_module_default()), "w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30dd-1885c9b1"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: tab6TextButton
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((Departments_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            slot: "",
                                                                            tag: "img",
                                                                            src: tab6ImageUrl,
                                                                            alt: tab6ImageAlt
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30e3-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: tab6ClientLogo
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: client6Stat
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Departments_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((Departments_module_default()), "w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30eb-1885c9b1"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: tab6QuoteClient
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((Departments_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((Departments_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((Departments_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: tab6ClientHeadshot
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((Departments_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: tab6NameClient
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((Departments_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: tab6TitleClient
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/DepartmentsProjectsTest.module.css
var DepartmentsProjectsTest_module = __webpack_require__(81973);
var DepartmentsProjectsTest_module_default = /*#__PURE__*/__webpack_require__.n(DepartmentsProjectsTest_module);
;// CONCATENATED MODULE: ./devlink/DepartmentsProjectsTest.js
"use client";






var DepartmentsProjectsTest_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function DepartmentsProjectsTest(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(DepartmentsProjectsTest_interactionsData, (DepartmentsProjectsTest_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((DepartmentsProjectsTest_module_default()), "sec-departments"),
        tag: "section",
        grid: {
            type: "section"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((DepartmentsProjectsTest_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((DepartmentsProjectsTest_module_default()), "m_container-large", "for--departments"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((DepartmentsProjectsTest_module_default()), "fw1_section-headline-parent"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "fw1_section-title", "is--short"),
                                        tag: "h2",
                                        children: "Solutions for every team. Powered by one platform."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%5Bclass*%3D%22comp_products%22%5D%20%5Bclass*%3D%22splide__arrows%22%5D%20%7B%0A%20%20display%3A%20none%3B%0A%7D%0A%0A%40media%20screen%20and%20(min-width%3A%20992px)%20and%20(max-width%3A%201140px)%20%7B%0A%20%20%5Bclass*%3D%22group-hp-tab-content%22%5D%20%7B%0A%20%20%20%20gap%3A%201rem%3B%0A%20%20%20%20grid-template-columns%3A%201fr%201fr%3B%0A%20%20%7D%0A%0A%20%20%2F*%20For%20the%20Webflow-generated%20ID%20selectors%20%E2%80%94%20these%20must%20stay%20as-is%2C%0A%20%20%20%20%20since%20they%20are%20exact%20IDs%20and%20not%20class%20names%20*%2F%0A%20%20%23w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30d6-1885c9b1%2C%0A%20%20%23w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4d9-1885c9b1%2C%0A%20%20%23w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc42-1885c9b1%2C%0A%20%20%23w-node-_2c0611a3-724d-48c2-5870-1877aef88c47-1885c9b1%2C%0A%20%20%23w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d774-1885c9b1%2C%0A%20%20%23w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc831-1885c9b1%20%7B%0A%20%20%20%20grid-column%3A%20span%202%3B%0A%20%20%20%20grid-row%3A%20span%202%3B%0A%20%20%7D%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((DepartmentsProjectsTest_module_default()), "comp_products"),
                            tag: "div",
                            "data-splide-wrapper": "",
                            "data-splide-type": "tabs",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide", "for--tabs"),
                                    tag: "div",
                                    "data-splide-role": "nav",
                                    role: "tablist",
                                    "aria-label": "Tab Navigation",
                                    "data-focus": "center",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "products_tabs-menu", "splide__track"),
                                        tag: "div",
                                        "data-splide-element": "track",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(List, {
                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "tabs_nav-list", "splide__list"),
                                            tag: "ul",
                                            "aria-label": "Tab Navigation",
                                            "data-splide-element": "list",
                                            unstyled: false,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--pmo", "splide__slide", "is-active"),
                                                    role: "presentation",
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-2",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-2",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Projects"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--sales", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-3",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-3",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Sales"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--marketing", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-4",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-4",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Marketing"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--service", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-5",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-5",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "IT & Ops"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--dev", "splide__slide"),
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "-1",
                                                        id: "tab-product-6",
                                                        role: "tab",
                                                        "aria-selected": "false",
                                                        "aria-controls": "panel-6",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Product & Engineering"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ListItem, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link", "for--leadership", "splide__slide"),
                                                    role: "presentation",
                                                    "data-splide-element": "slide",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "product_tab-link-button"),
                                                        tag: "button",
                                                        slot: "",
                                                        tabindex: "0",
                                                        id: "tab-product-1",
                                                        role: "tab",
                                                        "aria-selected": "true",
                                                        "aria-controls": "panel-1",
                                                        "data-tab": "",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Leadership"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide", "for--tab-content"),
                                    tag: "div",
                                    "data-splide-role": "content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__track", "for--tabs-content"),
                                        tag: "div",
                                        "data-splide-element": "track",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__list"),
                                            tag: "div",
                                            "data-splide-element": "list",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-2",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big", "is--primary"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1729-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-wm-1.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h", "is--short"),
                                                                                tag: "h3",
                                                                                children: "Drive execution at scale"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Deliver projects, programs, and portfolios with full resource visibility and AI-powered risk detection."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1730-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "work-management",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752050978/Generator_featured%20images/hp-2025/departments/bento/drive-execution-at-scale-v4.png",
                                                                            alt: "Drive execution at scale"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1736-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "$4M saved"
                                                                            }),
                                                                            " with optimized processes"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec173c-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: "“monday.com gives us the visibility to get everyone on the same page and track all the moving parts of our projects.”"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/687362114a8e19b70c857667_Jason.png"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Jason Doan"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "VP of Operations, HOLT CAT"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-3",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-3",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big", "is--crm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec176b-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-crm.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: "Accelerate revenue growth"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Free your teams from data entry to focus on sales and nurture, with AI actions and code-free automations."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1772-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "crm",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752394262/Generator_featured%20images/hp-2025/departments/bento/accelerate-revenue-growth-v5.png",
                                                                            alt: "Accelerate revenue growth"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1778-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860e2ec0f057ce07046a649_logo-height-kc.png"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "18x"
                                                                            }),
                                                                            " ROI achieved",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            "inthe first year"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1780-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: [
                                                                            "“As a VP, trying to look at a 30,000-ft view, I can see the percentage of successful opportunities and know-how to analyze the market.”",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6873627106c54dca6fa8aeaa_Christopher.png"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Christopher Stone"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "VP Business Development, KC Petroleum"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-4",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-4",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big", "is--marketing"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec178e-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-wm-1.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: "Amplify marketing impact"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Align marketing around shared goals with AI that streamlines briefs, flags delays, and drives campaign impact."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1795-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "work-management",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752050983/Generator_featured%20images/hp-2025/departments/bento/unify-marketing-to-amplify-impact-v4.png",
                                                                            alt: "Amplify marketing impact"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec179b-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "300%"
                                                                            }),
                                                                            " increase in creative output"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a1-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: "“monday.com isn’t just another tool in the mix, but a work operating system that supports our need for efficiency at scale.”"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a6-50ec16ff"),
                                                                                    tag: "img",
                                                                                    slot: "",
                                                                                    src: "https://cdn.prod.website-files.com/65b62e80a3a89609079c247a/670ba85ec4442a965eb743d8_Vic%20Diesta.jpeg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Vic Diesta"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "Creative Operations Lead, Canva"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-5",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big", "is--svc"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17ae-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-svc.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: "Scale exceptional service"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Empower teams to resolve requests faster with AI that triages, routes, and guides each issue to resolution."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17b5-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "service",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752050985/Generator_featured%20images/hp-2025/departments/bento/scale-exceptiona-service-v4.png",
                                                                            alt: "Scale exceptional service"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17bb-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f49dd0c89f06fbf3217c_logo-height-zopa.png"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "55 hours"
                                                                            }),
                                                                            " saved",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            "per month",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17c4-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote", "is--small"),
                                                                        children: '"With monday service, 98% of our tickets are automatically categorized and assigned by AI. We resolve each 6-7 mins faster."'
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f221b5a054ab91f528af_image.png"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Clive Camilleri"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "Head of People & Ops, Zopa Bank"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-6",
                                                    tabIndex: "-1",
                                                    "data-splide-element": "slide",
                                                    id: "panel-6",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big", "is--dev"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d1-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749108242/growth-marketing/web-experience/hp-jun-25/hp-bento-logo-dev.png",
                                                                                alt: "logo of monday work management"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: "Launch quality products faster"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Plan roadmaps, execute sprints, and ship with precision using AI-powered guidance."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d8-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                "data-product-id": "dev",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752050979/Generator_featured%20images/hp-2025/departments/bento/launch-quality-products-faster-v4.png",
                                                                            alt: "Launch quality products faster"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17de-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "28%"
                                                                            }),
                                                                            " faster time ",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            "to market"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec17e6-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote", "is--small"),
                                                                        children: '"monday dev ensures clear alignment between what we’re building and market demand. Does it help us move faster? Without a doubt."'
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/686f8152e8fbbe7cb4f5c720_departments-headshot-6.png"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Alan Schmoll"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "Executive VP, Vistra Platform"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "splide__slide", "for--tab-pane"),
                                                    tag: "div",
                                                    role: "tabpanel",
                                                    "aria-labelledby": "tab-1",
                                                    tabIndex: "0",
                                                    "data-splide-element": "slide",
                                                    id: "panel-1",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "group-hp-tab-content"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1749-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-big-left"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-product-logo"),
                                                                                tag: "img",
                                                                                slot: "",
                                                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1751447997/Generator_featured%20images/hp-2025/departments/logo-product-suit-v3.avif",
                                                                                alt: "logo-product-suit"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-h"),
                                                                                tag: "h3",
                                                                                children: "Lead with clear foresight"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-par"),
                                                                                children: "Keep strategic goals on track with AI risk flagging and cross-org data to make real-time decisions."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button", "m_button-primary-white"),
                                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1750-50ec16ff"),
                                                                                button: false,
                                                                                "data-button-type": "signup",
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-right"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1752050981/Generator_featured%20images/hp-2025/departments/bento/lead-with-clear-foresight-v4.webp",
                                                                            alt: "Lead with clear foresight"
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec1756-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-customer-logo"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-h"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "span--semi"),
                                                                                children: "11% efficiency"
                                                                            }),
                                                                            " gained",
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                            "per month"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-sm", "is--bottom"),
                                                                id: utils.cx((DepartmentsProjectsTest_module_default()), "w-node-cad196ad-ae9a-45db-5b94-7b2950ec175e-50ec16ff"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote"),
                                                                        children: "“Now in real-time, we can identify health metrics and risks, whether they’re coming from our side or the client side.”"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-logo-quote-bottom"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "hp_tab-bento-headshot"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6840979a2eb950be4600b697_VML-avatar.png"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((DepartmentsProjectsTest_module_default()), "group-bento-headshot-data"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-name"),
                                                                                            tag: "div",
                                                                                            children: "Paul Willie"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((DepartmentsProjectsTest_module_default()), "quote-headshot-title"),
                                                                                            tag: "div",
                                                                                            children: "COO, VML"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/DevLinkProvider.js
var DevLinkProvider = __webpack_require__(11379);
// EXTERNAL MODULE: ./devlink/Gartner.module.css
var Gartner_module = __webpack_require__(75572);
var Gartner_module_default = /*#__PURE__*/__webpack_require__.n(Gartner_module);
;// CONCATENATED MODULE: ./devlink/Gartner.js
"use client";





function Gartner(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Gartner_module_default()), "gartner"),
        tag: "section",
        grid: {
            type: "section"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Gartner_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Gartner_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                    className: utils.cx((Gartner_module_default()), "m_container-large"),
                    tag: "div",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((Gartner_module_default()), "gartner-banner"),
                        id: utils.cx((Gartner_module_default()), "w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dc9-bb0a1dc5"),
                        tag: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                            className: utils.cx((Gartner_module_default()), "gartner-card-wrapper"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((Gartner_module_default()), "max-width-gartner-logo"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        className: utils.cx((Gartner_module_default()), "gartner-svg-logo"),
                                        value: "%3Csvg%20width%3D%22232%22%20height%3D%2252%22%20viewBox%3D%220%200%20232%2052%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%0A%3Cpath%20d%3D%22M230.804%2016.8942L230.136%2024.7976H226.861C221.633%2024.7976%20218.915%2028.9285%20218.915%2032.8873V50.7375H209.649V16.8942H218.426L218.625%2021.1183C220.467%2018.2216%20223.69%2016.8942%20227.664%2016.8942H230.804ZM166.559%2050.7372H157.284V32.8461C157.284%2029.0992%20156.955%2024.3834%20151.609%2024.3834C146.459%2024.3834%20144.408%2028.0463%20144.408%2032.3114V50.7372H135.136V16.8939H143.732L143.929%2021.2204C145.771%2018.3238%20149.203%2016.0683%20154.265%2016.0683C163.61%2016.0683%20166.559%2022.6442%20166.559%2029.4874V50.7372ZM131.092%2042.8315L130.443%2050.5321C128.219%2051.12%20126.245%2051.331%20123.856%2051.331C115.117%2051.331%20112.582%2047.3814%20112.582%2039.4432V7.35031H121.856V16.8946H131.084L130.443%2024.7969H121.856V38.7559C121.856%2041.9414%20122.742%2043.6622%20126.058%2043.6622C127.499%2043.6622%20129.103%2043.4911%20131.092%2042.8315ZM109.537%2016.8942L108.819%2024.7976H106.299C101.081%2024.7976%2098.4857%2028.9233%2098.4857%2032.8873V50.7375H89.2107V16.8942H97.9921L98.175%2021.1183C100.027%2018.2216%20103.25%2016.8942%20107.229%2016.8942H109.537ZM47.3586%2046.9878C41.0681%2050.3045%2034.7849%2052.2178%2026.4857%2051.9802C11.1%2051.5172%200%2042.101%200%2026.1959C0%2010.3604%2011.207%200.24259%2026.493%200.00495585C34.2414%20-0.111813%2041.1751%201.82614%2046.5947%206.5399L40.0663%2013.0492C36.7127%2010.2314%2031.7785%208.58435%2025.8819%208.8476C16.2618%209.28906%2010.465%2016.1794%2010.3372%2025.653C10.2114%2035.9174%2016.5975%2042.9911%2026.5803%2043.2492C31.2776%2043.3649%2034.6426%2042.7432%2037.5545%2041.4546V30.9629H27.1789L27.8793%2022.3579H47.3586V46.9878ZM205.507%2037.032H180.08C180.805%2041.3565%20184.254%2043.9582%20188.549%2044.076C192.725%2044.1876%20195.061%2042.9442%20198.115%2039.8959L204.166%2044.4437C199.866%2049.6645%20194.705%2051.5645%20188.826%2051.5645C178.486%2051.5645%20170.74%2044.4386%20170.74%2033.8147C170.74%2023.2021%20178.448%2016.068%20188.44%2016.068C199.452%2016.068%20205.507%2022.6439%20205.507%2034.3166V37.032ZM196.216%2029.9562C195.932%2025.6809%20192.682%2022.9778%20188.206%2023.1499C183.701%2023.3179%20180.702%2026.2094%20180.08%2029.9562H196.216ZM83.3721%2028.5757V50.7371H75.1955L74.9928%2047.4C72.4841%2050.4626%2068.4114%2051.5648%2064.2181%2051.5648C57.9038%2051.5648%2051.9376%2048.496%2051.8129%2041.3485C51.6248%2030.1142%2064.6411%2029.3163%2072.8156%2029.3163H74.4493V28.8717C74.4493%2025.1567%2071.9552%2023.1501%2067.2589%2023.1501C63.8876%2023.1501%2060.56%2024.4827%2058.0991%2026.7566L52.7482%2021.3985C57.6066%2017.5165%2062.6614%2016.0682%2068.0466%2016.0682C78.6831%2016.0682%2083.3721%2020.9131%2083.3721%2028.5757ZM74.4493%2035.9782H73.1596C68.7689%2035.9874%2061.0568%2036.2005%2061.0859%2040.7258C61.1275%2047.1009%2074.4493%2045.0749%2074.4493%2037.3866V35.9782ZM223.57%2046.8004C223.57%2044.6463%20225.219%2043.0228%20227.334%2043.0228C229.423%2043.0228%20231.075%2044.6463%20231.075%2046.8004C231.075%2048.9924%20229.423%2050.6107%20227.334%2050.6107C225.219%2050.6107%20223.57%2048.9924%20223.57%2046.8004ZM227.334%2051.3677C229.852%2051.3677%20232%2049.44%20232%2046.8004C232%2044.1875%20229.852%2042.2638%20227.334%2042.2638C224.793%2042.2638%20222.643%2044.1875%20222.643%2046.8004C222.643%2049.44%20224.793%2051.3677%20227.334%2051.3677ZM226.356%2047.165H227.286L228.688%2049.44H229.594L228.08%2047.1281C228.863%2047.0339%20229.46%2046.6201%20229.46%2045.6808C229.46%2044.6463%20228.838%2044.1874%20227.578%2044.1874H225.552V49.44H226.356V47.165ZM226.356%2046.488V44.8645H227.454C228.018%2044.8645%20228.616%2044.9843%20228.616%2045.6348C228.616%2046.4409%20228.005%2046.488%20227.323%2046.488H226.356Z%22%20fill%3D%22white%22%2F%3E%0A%3C%2Fsvg%3E"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(VFlex, {
                                    className: utils.cx((Gartner_module_default()), "gartner-text-wrapper"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Gartner_module_default()), "m_text-color-white", "m_fontweight-semibold"),
                                            tag: "div",
                                            children: "For the 3rd year in a row"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Gartner_module_default()), "m_text-color-white", "m_text-style-22"),
                                            tag: "div",
                                            children: [
                                                "Gartner\xae has named monday.com a 2025 Magic Quadrant™ Leader for ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                                    className: utils.cx((Gartner_module_default()), "m_fontweight-semibold"),
                                                    children: "Collaborative Work Management"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Gartner_module_default()), "m_spacer-1rem"),
                                            tag: "div"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                            className: utils.cx((Gartner_module_default()), "m_button-outline", "m_button-outline-white"),
                                            id: utils.cx((Gartner_module_default()), "w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dd5-bb0a1dc5"),
                                            button: false,
                                            block: "inline",
                                            options: {
                                                href: "https://monday.com/w/gartner-mq/cwm-2025-g"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get the report"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/Hero.module.css
var Hero_module = __webpack_require__(27805);
var Hero_module_default = /*#__PURE__*/__webpack_require__.n(Hero_module);
;// CONCATENATED MODULE: ./devlink/Hero.js
"use client";






var Hero_interactionsData = JSON.parse('{"events":{"e-35":{"id":"e-35","name":"","animationType":"custom","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-25","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".sec-hero","originalId":"5d3f1e2f-e7c3-70e1-c38c-47af7019405f","appliesTo":"CLASS"},"targets":[{"selector":".sec-hero","originalId":"5d3f1e2f-e7c3-70e1-c38c-47af7019405f","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-25-p","smoothing":95,"startsEntering":false,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1751525863187},"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-69"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-73"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-25":{"id":"a-25","title":"Hero-stars","continuousParameterGroups":[{"id":"a-25-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-25-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-25-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-25-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":40,"actionItems":[{"id":"a-25-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":8,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":80,"actionItems":[{"id":"a-25-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-25-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1751525871949},"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Hero(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _buttonBottomLabel = param.buttonBottomLabel, buttonBottomLabel = _buttonBottomLabel === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "No credit card needed ✦ Unlimited time on Free plan",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _buttonBottomLabel, _buttonLabelVisibility = param.buttonLabelVisibility, buttonLabelVisibility = _buttonLabelVisibility === void 0 ? true : _buttonLabelVisibility;
    interactions/* useInteractions */.NI(Hero_interactionsData, (Hero_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Hero_module_default()), "sec-hero"),
        grid: {
            type: "section"
        },
        tag: "section",
        "data-hero-section": "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Hero_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((Hero_module_default()), "m_container-large"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A.dynamic-devlink-component%20.w--current%20%5Bclass*%3D%22Hero_hero-card-gradient-inner__%22%5D%20%7B%0A%20%20background-color%3A%20white%20!important%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%207px%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((Hero_module_default()), "fw1_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((Hero_module_default()), "fw1_hero-title-white"),
                                tag: "h1",
                                children: [
                                    "One AI platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                className: utils.cx((Hero_module_default()), "fw1_hero-sub-white"),
                                children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Hero_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((Hero_module_default()), "m_button", "m_button-primary-white", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    }),
                                    buttonLabelVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Hero_module_default()), "hp-hero-btn-label"),
                                        tag: "div",
                                        editable: true,
                                        children: buttonBottomLabel
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((Hero_module_default()), "comp_hp-hero-tabs"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((Hero_module_default()), "hero-star-1"),
                                loading: "lazy",
                                width: "auto",
                                height: "auto",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/684ae7f47c69f87c209a5bc5_hp-star-1.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((Hero_module_default()), "hero-star-2"),
                                loading: "lazy",
                                width: "auto",
                                height: "auto",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/684ea4b42bf1fd7779889b12_hp-star-2.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((Hero_module_default()), "hero-star-3"),
                                loading: "lazy",
                                width: "auto",
                                height: "auto",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6852b6d0f8fb1352254a83ca_hero-star-3.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Hero_module_default()), "hp-hero-tabs-menu-top"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Hero_module_default()), "hero-tabs-menu-top-h"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                            className: utils.cx((Hero_module_default()), "what--span"),
                                            children: "What would you like to manage?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%40keyframes%20swoosh%20%7B%0A%20%200%25%20%7B%0A%20%20%20%20background-position%3A%20200%25%3B%0A%20%20%0A%20%20%7D%0A%20%20100%25%20%7B%0A%20%20%20%20background-position%3A%20-200%25%3B%0A%20%20%7D%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22what--span%22%5D%20%7B%0A%20%20background-size%3A%20200%25%3B%0A%20%20background-position%3A%20-200%25%3B%0A%20%20animation%3A%20swoosh%206s%20cubic-bezier(0.4%2C%200%2C%200.2%2C%201)%20infinite%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A.hero-tab-gradient.is-active%20.hero-card-gradient-inner%20%7B%0A%20%20background-color%3A%20white%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%207px%3B%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22m_tab-arrow%22%5D%20%7B%0A%20%20opacity%3A%201%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                className: utils.cx((Hero_module_default()), "hp_hero-tabs", "tabs-trigger"),
                                current: "Projects",
                                easing: "ease",
                                fadeIn: 0,
                                fadeOut: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                        className: utils.cx((Hero_module_default()), "hp_hero-tabs-menu"),
                                        tag: "div",
                                        "data-hero-tabs": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "Projects",
                                                "data-tab": "",
                                                "data-tag-theme": "projects",
                                                "data-cluster": "product_management",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1751524278/Generator_featured%20images/hp-2025/hero/Headshots/hp-headshot-projects-1.avif",
                                                            alt: "hp-headshot-projects"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Projects"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "Marketing",
                                                "data-tab": "",
                                                "data-tag-theme": "marketing",
                                                "data-cluster": "marketing",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749740950/growth-marketing/web-experience/hp-jun-25/hero/hp-headshot-marketing.avif",
                                                            alt: "hp-headshot-sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Marketing"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "Sales",
                                                "data-tab": "",
                                                "data-tag-theme": "sales",
                                                "data-tab-product": "crm",
                                                "data-cluster": "crm",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749740950/growth-marketing/web-experience/hp-jun-25/hero/hp-headshot-sales.avif",
                                                            alt: "hp-headshot-sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "Operation",
                                                "data-tab": "",
                                                "data-tag-theme": "ops",
                                                "data-cluster": "operations",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749740950/growth-marketing/web-experience/hp-jun-25/hero/hp-headshot-ops.avif",
                                                            alt: "hp-headshot-ops"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Operations"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "Software",
                                                "data-tab": "",
                                                "data-tag-theme": "software",
                                                "data-tab-product": "dev",
                                                "data-cluster": "tech",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1751524275/Generator_featured%20images/hp-2025/hero/Headshots/hp-headshot-software-1.png",
                                                            alt: "hp-headshot-software"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Software"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((Hero_module_default()), "hero-card-gradient"),
                                                "data-w-tab": "IT & Support",
                                                "data-tab": "",
                                                "data-tag-theme": "it",
                                                "data-tab-product": "service",
                                                "data-cluster": "information_technology",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hero-card-gradient-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((Hero_module_default()), "hero-card-gradient-inner-headshot"),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1751524276/Generator_featured%20images/hp-2025/hero/Headshots/hp-headshot-IT-1.png",
                                                            alt: "hp-headshot-it"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "IT & Support"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Hero_module_default()), "m_tab-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                        className: utils.cx((Hero_module_default()), "hp_hero-tabs-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "Projects",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a7-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fso_0%2Fv1751998946%2Fhero_tab-projects-v2.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751998946%2Fhero_tab-projects-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751998946%2Fhero_tab-projects-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a9-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "product_management",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "Marketing",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b0-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751998944%2Fhero_tab-marketing-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751372615%2Fhero_tab-marketing-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b2-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "marketing",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "Sales",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b9-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751998944%2Fhero_tab-sales-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751998944%2Fhero_tab-sales-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3bb-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "crm",
                                                                href: "",
                                                                "data-cluster": "crm",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "Operation",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c2-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751535479%2Fhero_tab-ops-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751535479%2Fhero_tab-ops-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c4-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "operations",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "Software",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cb-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751785729%2Fhero_tab-dev-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751785729%2Fhero_tab-dev-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cd-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "dev",
                                                                href: "",
                                                                "data-cluster": "tech",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((Hero_module_default()), "hp_hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "IT & Support",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((Hero_module_default()), "hp_hero-tab-inner"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hp_hero-tab-board-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d4-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                className: utils.cx((Hero_module_default()), "ai-blocks-vid-embed"),
                                                                value: "%3Cvideo%20class%3D%22hp-hero-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20muted%20loop%20poster%3D%22%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751535430%2Fhero_tab-svc-v2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751535430%2Fhero_tab-svc-v2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((Hero_module_default()), "hero_tabs-btn-parent"),
                                                            id: utils.cx((Hero_module_default()), "w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d6-7019405f"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Hero_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "service",
                                                                href: "",
                                                                "data-cluster": "information_technology",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Hero_module_default()), "m_button-arrow"),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Hero_module_default()), "hp-hero-tabs-menu-top"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Hero_module_default()), "hero-tabs-menu-top-h"),
                                        tag: "div",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Span, {
                                            className: utils.cx((Hero_module_default()), "what--span"),
                                            children: "What would you like to manage?"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%40keyframes%20swoosh%20%7B%0A%20%200%25%20%7B%0A%20%20%20%20background-position%3A%20200%25%3B%0A%20%20%0A%20%20%7D%0A%20%20100%25%20%7B%0A%20%20%20%20background-position%3A%20-200%25%3B%0A%20%20%7D%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22what--span%22%5D%20%7B%0A%20%20background-size%3A%20200%25%3B%0A%20%20background-position%3A%20-200%25%3B%0A%20%20animation%3A%20swoosh%206s%20cubic-bezier(0.4%2C%200%2C%200.2%2C%201)%20infinite%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A.hero-tab-gradient.is-active%20.hero-card-gradient-inner%20%7B%0A%20%20background-color%3A%20white%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%207px%3B%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22m_tab-arrow%22%5D%20%7B%0A%20%20opacity%3A%201%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/HeroEldadVarB.module.css
var HeroEldadVarB_module = __webpack_require__(66172);
var HeroEldadVarB_module_default = /*#__PURE__*/__webpack_require__.n(HeroEldadVarB_module);
;// CONCATENATED MODULE: ./devlink/HeroEldadVarB.js
"use client";






var HeroEldadVarB_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-120":{"id":"e-120","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-121"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018688},"e-121":{"id":"e-121","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-120"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018689},"e-122":{"id":"e-122","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-123"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453976},"e-123":{"id":"e-123","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-122"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453977},"e-124":{"id":"e-124","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-125"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500182},"e-125":{"id":"e-125","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500183},"e-126":{"id":"e-126","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-127"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519052},"e-127":{"id":"e-127","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519053},"e-128":{"id":"e-128","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536671},"e-129":{"id":"e-129","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536672},"e-130":{"id":"e-130","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575804},"e-131":{"id":"e-131","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575805},"e-140":{"id":"e-140","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-141"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986154},"e-141":{"id":"e-141","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-78","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-140"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986155},"e-144":{"id":"e-144","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-145"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-145":{"id":"e-145","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-144"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-146":{"id":"e-146","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-147"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-147":{"id":"e-147","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-146"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-148":{"id":"e-148","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-149"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-149":{"id":"e-149","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-148"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-150":{"id":"e-150","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-151"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-151":{"id":"e-151","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-150"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-152":{"id":"e-152","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-153"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-153":{"id":"e-153","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-152"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-154":{"id":"e-154","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-155"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-155":{"id":"e-155","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-154"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-160":{"id":"e-160","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-161"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-161":{"id":"e-161","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-160"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-162":{"id":"e-162","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-163"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-163":{"id":"e-163","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-162"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-164":{"id":"e-164","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-165"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-165":{"id":"e-165","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-164"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-166":{"id":"e-166","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-167"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-167":{"id":"e-167","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-166"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-168":{"id":"e-168","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-169"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-169":{"id":"e-169","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-168"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-170":{"id":"e-170","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-171"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-170"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-172":{"id":"e-172","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-173"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999af9","appliesTo":"CLASS"},"targets":[{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999af9","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761208742122},"e-174":{"id":"e-174","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-175"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999adf","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217380260},"e-175":{"id":"e-175","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-174"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999adf","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217380262},"e-176":{"id":"e-176","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-177"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"0821ab80-634c-ffa5-56e8-b55ec47ae1ee","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217638629},"e-177":{"id":"e-177","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-176"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"0821ab80-634c-ffa5-56e8-b55ec47ae1ee","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217638630}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-75":{"id":"a-75","title":"tab-lotem-hero-hover-marketing","actionItemGroups":[{"actionItems":[{"id":"a-75-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-75-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-75-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-75-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-76":{"id":"a-76","title":"tab-lotem-hero-hover-marketing-out","actionItemGroups":[{"actionItems":[{"id":"a-76-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-76-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-77":{"id":"a-77","title":"tab-change-animation-start","actionItemGroups":[{"actionItems":[{"id":"a-77-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004570088},"a-78":{"id":"a-78","title":"tab-change-animation-stop","actionItemGroups":[{"actionItems":[{"id":"a-78-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004716592},"a-81":{"id":"a-81","title":"tab-lotem-hero-hover-marketing 2","actionItemGroups":[{"actionItems":[{"id":"a-81-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-81-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-81-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-81-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-82":{"id":"a-82","title":"tab-lotem-hero-hover-marketing-out 2","actionItemGroups":[{"actionItems":[{"id":"a-82-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-82-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-87":{"id":"a-87","title":"tab-lotem-hero-hover-marketing 3","actionItemGroups":[{"actionItems":[{"id":"a-87-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-87-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-87-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-87-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-88":{"id":"a-88","title":"tab-lotem-hero-hover-marketing-out 3","actionItemGroups":[{"actionItems":[{"id":"a-88-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-88-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function HeroEldadVarB(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(HeroEldadVarB_interactionsData, (HeroEldadVarB_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((HeroEldadVarB_module_default()), "group_hero-center-all"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((HeroEldadVarB_module_default()), "m_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((HeroEldadVarB_module_default()), "fw1_hero-title-black-lotem"),
                                tag: "h1",
                                children: [
                                    "One AI work platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroEldadVarB_module_default()), "subtitle-white-test-max-width"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    className: utils.cx((HeroEldadVarB_module_default()), "fw1_hero-sub-black"),
                                    children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroEldadVarB_module_default()), "fw1_button-parent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-3rem"),
                                tag: "div"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A%2F*.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23ffffff%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%3Ahover%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Anot(%3Ahover)%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((HeroEldadVarB_module_default()), "lotem-tabs-parent"),
                        tag: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tabs-holder"),
                            current: "projects",
                            easing: "ease-in",
                            fadeIn: 300,
                            fadeOut: 100,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                    className: utils.cx((HeroEldadVarB_module_default()), "tabs-group-lotem-hero"),
                                    tag: "div",
                                    "data-hero-tabs": "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "projects",
                                            "data-tab": "",
                                            "data-tag-theme": "projects",
                                            "data-cluster": "projects",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fe13d57acb113eb68_project-thumbnail-tab.png"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem", "projects"),
                                                    tag: "div",
                                                    children: [
                                                        "Projects",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& Tasks"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "marketing",
                                            "data-tab": "",
                                            "data-tag-theme": "marketing",
                                            "data-cluster": "marketing",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem"),
                                                    tag: "div",
                                                    children: [
                                                        "Marketing",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& Design"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "sales",
                                            "data-tab": "",
                                            "data-tag-theme": "sales",
                                            "data-tab-product": "crm",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fcc2cafe49f1d58f5_sales-thumbnail-tab.png"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem", "sales"),
                                                    tag: "div",
                                                    children: [
                                                        "Sales",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& CRM"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "operations",
                                            "data-tab": "",
                                            "data-tag-theme": "operations",
                                            "data-cluster": "operations",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f3823d6d605a96925_ops-thumbnail-tab.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video"),
                                                                    tag: "div",
                                                                    sources: [
                                                                        "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                        "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                    ],
                                                                    posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                    autoPlay: true,
                                                                    loop: true
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "lazy",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem", "operations"),
                                                    tag: "div",
                                                    children: [
                                                        "Operations",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& Logistics"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "software",
                                            "data-tab": "",
                                            "data-tag-theme": "software",
                                            "data-tab-product": "dev",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f9e86e93016c29fa4_dev-thumbnail-tab.png"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem", "sftware"),
                                                    tag: "div",
                                                    children: [
                                                        "Product",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& Software"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "tab-lotem-hero-hover"),
                                            "data-w-tab": "support and it",
                                            "data-tab": "",
                                            "data-tag-theme": "it",
                                            "data-tab-product": "service",
                                            block: "inline",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "headshot-hero-video", "hide"),
                                                            tag: "div",
                                                            sources: [
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.webm",
                                                                "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.mp4"
                                                            ],
                                                            posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-poster-00001.jpg",
                                                            autoPlay: true,
                                                            loop: true
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((HeroEldadVarB_module_default()), "thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f8402902bc5c6b9e2_it-thumbnail-tab.png"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroEldadVarB_module_default()), "tab-hero-text-lotem", "it"),
                                                    tag: "div",
                                                    children: [
                                                        "Support ",
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                        "& IT"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                    className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-content"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "projects",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b1edcf2745fc7b409_Projectslotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Deliver projects and tasks on time with AI-powered planning and risk visibility."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    href: "",
                                                                                    "data-cluster": "product_management",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "marketing",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766bbf067937d471973f_Marketinglotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Create high-impact campaigns with AI that drives execution, insights, and performance."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "marketing",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "sales",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b8f66d4769aa59149_Saleslotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    "Accelerate revenue growth with the AI-first CRM that finds and engages contacts.",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "crm",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "operations",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f9de3af0a77b7ca7b87cf0_Operations%20%26%20Logistics.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "operations",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "software",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b5757592666bc2ede_Softwarelotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    "Ship quality products faster with AI-optimized sprints and roadmap planning.",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "dev",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "support and it",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b59cf441a15392587_ITlotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarB_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarB_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarB_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "service",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarB_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarB_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarB_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarB_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroEldadVarB_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroEldadVarB_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/HeroEldadVarC.module.css
var HeroEldadVarC_module = __webpack_require__(52716);
var HeroEldadVarC_module_default = /*#__PURE__*/__webpack_require__.n(HeroEldadVarC_module);
;// CONCATENATED MODULE: ./devlink/HeroEldadVarC.js
"use client";






var HeroEldadVarC_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-120":{"id":"e-120","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-121"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018688},"e-121":{"id":"e-121","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-120"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018689},"e-122":{"id":"e-122","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-123"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453976},"e-123":{"id":"e-123","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-122"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453977},"e-124":{"id":"e-124","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-125"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500182},"e-125":{"id":"e-125","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500183},"e-126":{"id":"e-126","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-127"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519052},"e-127":{"id":"e-127","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519053},"e-128":{"id":"e-128","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536671},"e-129":{"id":"e-129","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536672},"e-130":{"id":"e-130","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575804},"e-131":{"id":"e-131","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575805},"e-140":{"id":"e-140","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-141"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986154},"e-141":{"id":"e-141","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-78","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-140"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986155},"e-144":{"id":"e-144","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-145"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-145":{"id":"e-145","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-144"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-146":{"id":"e-146","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-147"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-147":{"id":"e-147","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-146"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-148":{"id":"e-148","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-149"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-149":{"id":"e-149","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-148"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-150":{"id":"e-150","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-151"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-151":{"id":"e-151","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-150"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-152":{"id":"e-152","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-153"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-153":{"id":"e-153","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-152"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-154":{"id":"e-154","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-155"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-155":{"id":"e-155","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-154"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-160":{"id":"e-160","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-161"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-161":{"id":"e-161","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-160"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-162":{"id":"e-162","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-163"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-163":{"id":"e-163","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-162"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-164":{"id":"e-164","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-165"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-165":{"id":"e-165","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-164"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-166":{"id":"e-166","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-167"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-167":{"id":"e-167","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-166"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-168":{"id":"e-168","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-169"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-169":{"id":"e-169","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-168"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-170":{"id":"e-170","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-171"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-170"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-172":{"id":"e-172","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-173"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999af9","appliesTo":"CLASS"},"targets":[{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999af9","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761208742122},"e-174":{"id":"e-174","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-175"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999adf","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217380260},"e-175":{"id":"e-175","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-174"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab_eldad-hero-hover","originalId":"f8115015-deac-99ad-18b4-8183a4999adf","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217380262},"e-176":{"id":"e-176","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-177"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"0821ab80-634c-ffa5-56e8-b55ec47ae1ee","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217638629},"e-177":{"id":"e-177","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-176"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"0821ab80-634c-ffa5-56e8-b55ec47ae1ee","appliesTo":"CLASS"},"targets":[],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761217638630}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-75":{"id":"a-75","title":"tab-lotem-hero-hover-marketing","actionItemGroups":[{"actionItems":[{"id":"a-75-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-75-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-75-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-75-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-76":{"id":"a-76","title":"tab-lotem-hero-hover-marketing-out","actionItemGroups":[{"actionItems":[{"id":"a-76-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-76-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-77":{"id":"a-77","title":"tab-change-animation-start","actionItemGroups":[{"actionItems":[{"id":"a-77-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004570088},"a-78":{"id":"a-78","title":"tab-change-animation-stop","actionItemGroups":[{"actionItems":[{"id":"a-78-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004716592},"a-81":{"id":"a-81","title":"tab-lotem-hero-hover-marketing 2","actionItemGroups":[{"actionItems":[{"id":"a-81-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-81-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-81-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-81-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-82":{"id":"a-82","title":"tab-lotem-hero-hover-marketing-out 2","actionItemGroups":[{"actionItems":[{"id":"a-82-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-82-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-87":{"id":"a-87","title":"tab-lotem-hero-hover-marketing 3","actionItemGroups":[{"actionItems":[{"id":"a-87-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-87-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-87-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-87-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-88":{"id":"a-88","title":"tab-lotem-hero-hover-marketing-out 3","actionItemGroups":[{"actionItems":[{"id":"a-88-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-88-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function HeroEldadVarC(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(HeroEldadVarC_interactionsData, (HeroEldadVarC_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((HeroEldadVarC_module_default()), "group_hero-center-all"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((HeroEldadVarC_module_default()), "m_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((HeroEldadVarC_module_default()), "fw1_hero-title-black-lotem"),
                                tag: "h1",
                                children: [
                                    "One AI work platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((HeroEldadVarC_module_default()), "subtitle-white-test-max-width"),
                                tag: "div",
                                "data-scroll": "enchor",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((HeroEldadVarC_module_default()), "fw1_hero-sub-black"),
                                        children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23ffffff%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%3Ahover%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Anot(%3Ahover)%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A%2F*%201.%20This%20rule%20ensures%20the%20video%20is%20always%20visible%20on%20the%20current%20tab.%20*%2F%0A.tab-lotem-hero-hover.w--current%20.headshot-hero-video%20%7B%0A%20%20opacity%3A%201%20!important%3B%0A%7D%0A%0A%2F*%202.%20This%20rule%20hides%20the%20video%20on%20the%20current%20tab%20when%20you%20hover%20over%20a%20different%20tab.%20*%2F%0A.tab-lotem-hero-hover%3Anot(.w--current)%3Ahover%20~%20.tab-lotem-hero-hover.w--current%20.headshot-hero-video%20%7B%0A%20%20opacity%3A%200%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroEldadVarC_module_default()), "fw1_button-parent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-3rem"),
                                tag: "div"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A%2F*%5Bclass*%3D%22tab_eldad-hero-hover%22%5D%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22tab_eldad-inner%22%5D%3Ahover%7B%0Abackground-color%3A%20%23F0F3FF%3B%0A%7D*%2F%0A%5Bclass*%3D%22tab_eldad-hero-hover%22%5D%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22tab_eldad-inner%22%5D%7B%0Abackground-color%3A%20%23F0F3FF%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                        className: utils.cx((HeroEldadVarC_module_default()), "lotem-tabs-parent"),
                        tag: "div",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tabs-holder"),
                            current: "projects",
                            easing: "ease-in",
                            fadeIn: 300,
                            fadeOut: 100,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                    className: utils.cx((HeroEldadVarC_module_default()), "tabs-group-lotem-hero"),
                                    tag: "div",
                                    "data-hero-tabs": "",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "projects",
                                            "data-tab": "",
                                            "data-tag-theme": "projects",
                                            "data-cluster": "projects",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fe13d57acb113eb68_project-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem"),
                                                        tag: "div",
                                                        children: [
                                                            "Projects",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& Tasks"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "marketing",
                                            "data-tab": "",
                                            "data-tag-theme": "marketing",
                                            "data-cluster": "marketing",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem"),
                                                        tag: "div",
                                                        children: [
                                                            "Marketing",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& Design"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "sales",
                                            "data-tab": "",
                                            "data-tag-theme": "sales",
                                            "data-tab-product": "crm",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fcc2cafe49f1d58f5_sales-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem", "sales"),
                                                        tag: "div",
                                                        children: [
                                                            "Sales",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& CRM"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "operations",
                                            "data-tab": "",
                                            "data-tag-theme": "operations",
                                            "data-cluster": "operations",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f3823d6d605a96925_ops-thumbnail-tab.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video"),
                                                                        tag: "div",
                                                                        sources: [
                                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                        ],
                                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                        autoPlay: true,
                                                                        loop: true
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem", "operations"),
                                                        tag: "div",
                                                        children: [
                                                            "Operations",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& Logistics"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "software",
                                            "data-tab": "",
                                            "data-tag-theme": "software",
                                            "data-tab-product": "dev",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f9e86e93016c29fa4_dev-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem", "sftware"),
                                                        tag: "div",
                                                        children: [
                                                            "Product",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& Software"
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-hero-hover"),
                                            "data-w-tab": "support and it",
                                            "data-tab": "",
                                            "data-tag-theme": "it",
                                            "data-tab-product": "service",
                                            block: "inline",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "tab_eldad-inner"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f8402902bc5c6b9e2_it-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "tab-hero-text-lotem", "it"),
                                                        tag: "div",
                                                        children: [
                                                            "Support ",
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                            "& IT"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                    className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-content"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "projects",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b1edcf2745fc7b409_Projectslotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Deliver projects and tasks on time with AI-powered planning and risk visibility."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    href: "",
                                                                                    "data-cluster": "product_management",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "marketing",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766bbf067937d471973f_Marketinglotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Create high-impact campaigns with AI that drives execution, insights, and performance."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "marketing",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "sales",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b8f66d4769aa59149_Saleslotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    "Accelerate revenue growth with the AI-first CRM that finds and engages contacts.",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "crm",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "operations",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f9de3af0a77b7ca7b87cf0_Operations%20%26%20Logistics.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "operations",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "software",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b5757592666bc2ede_Softwarelotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    "Ship quality products faster with AI-optimized sprints and roadmap planning.",
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "dev",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-tab-pane"),
                                            tag: "div",
                                            "data-w-tab": "support and it",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-flexbox"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "asset-image-lotem-hero"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "eager",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b59cf441a15392587_ITlotem-hero.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((HeroEldadVarC_module_default()), "right-pane-lotem-hero"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Recommended product"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "logo-svg"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "m_spacer-2rem"),
                                                                        tag: "div"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-info-text"),
                                                                                tag: "div",
                                                                                children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((HeroEldadVarC_module_default()), "hp-hero-btnsparent"),
                                                                                tag: "div",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                    className: utils.cx((HeroEldadVarC_module_default()), "m_button", "hero-btn-purple"),
                                                                                    tag: "a",
                                                                                    slot: "",
                                                                                    "data-button-type": "signup",
                                                                                    href: "",
                                                                                    "data-tabs-buttons": "tabs",
                                                                                    "data-product-id": "service",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "Get Started"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                            className: utils.cx((HeroEldadVarC_module_default()), "m_button-arrow"),
                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((HeroEldadVarC_module_default()), "right-pane-top-hero-lotem"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroEldadVarC_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "lotem-hero-asset-tiny-text"),
                                                                            tag: "div",
                                                                            children: "Part of the monday product suite"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                            className: utils.cx((HeroEldadVarC_module_default()), "products-logos-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroEldadVarC_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroEldadVarC_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/HeroFu.module.css
var HeroFu_module = __webpack_require__(32860);
var HeroFu_module_default = /*#__PURE__*/__webpack_require__.n(HeroFu_module);
;// CONCATENATED MODULE: ./devlink/HeroFu.js
"use client";






var HeroFu_interactionsData = JSON.parse('{"events":{"e-35":{"id":"e-35","name":"","animationType":"custom","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-25","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".sec-hero","originalId":"5d3f1e2f-e7c3-70e1-c38c-47af7019405f","appliesTo":"CLASS"},"targets":[{"selector":".sec-hero","originalId":"5d3f1e2f-e7c3-70e1-c38c-47af7019405f","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-25-p","smoothing":95,"startsEntering":false,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1751525863187},"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-69"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-73"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-82":{"id":"e-82","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-43","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".sec-hero","originalId":"6853e34886981d09931d6260|1f883a32-b6a8-3fec-7659-8c0c1a0c213a","appliesTo":"CLASS"},"targets":[{"selector":".sec-hero","originalId":"6853e34886981d09931d6260|1f883a32-b6a8-3fec-7659-8c0c1a0c213a","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-43-p","smoothing":95,"startsEntering":false,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1753636194346},"e-83":{"id":"e-83","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-44","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".sec-hero","originalId":"cc333ce5-50da-6e72-d1c6-dca738036462","appliesTo":"CLASS"},"targets":[{"selector":".sec-hero","originalId":"cc333ce5-50da-6e72-d1c6-dca738036462","appliesTo":"CLASS"}],"config":[{"continuousParameterGroupId":"a-44-p","smoothing":95,"startsEntering":false,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1753776887363}},"actionLists":{"a-25":{"id":"a-25","title":"Hero-stars","continuousParameterGroups":[{"id":"a-25-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-25-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f7"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-25-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f8"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-25-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f9"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":40,"actionItems":[{"id":"a-25-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f7"},"xValue":8,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":80,"actionItems":[{"id":"a-25-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f8"},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-25-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"09de1879-513c-794e-e87f-83785065a9f9"},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1751525871949},"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-43":{"id":"a-43","title":"Hero-stars 2","continuousParameterGroups":[{"id":"a-43-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-43-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-43-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-43-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":40,"actionItems":[{"id":"a-43-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-1","selectorGuids":["784cde2f-c046-6835-3b79-9eb2d5071a84"]},"xValue":8,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":80,"actionItems":[{"id":"a-43-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-2","selectorGuids":["6ff0b41b-ae8d-135d-3c0d-64be9e873e29"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-43-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hero-star-3","selectorGuids":["d6a75f38-0b1f-c10c-66a3-8b985ab0beb3"]},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1751525871949},"a-44":{"id":"a-44","title":"Hero-stars 3","continuousParameterGroups":[{"id":"a-44-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":0,"actionItems":[{"id":"a-44-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f7"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-44-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f8"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-44-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f9"},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":40,"actionItems":[{"id":"a-44-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f7"},"xValue":8,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":80,"actionItems":[{"id":"a-44-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f8"},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-44-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"684083d9882d1c433a4d9611|09de1879-513c-794e-e87f-83785065a9f9"},"xValue":4,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1751525871949}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function HeroFu(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _variant = param.variant, variant = _variant === void 0 ? "Base" : _variant;
    interactions/* useInteractions */.NI(HeroFu_interactionsData, (HeroFu_module_default()));
    var _styleVariantMap = {
        Base: "",
        PurpleCTA: "w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a"
    };
    var _activeStyleVariant = _styleVariantMap[variant];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((HeroFu_module_default()), "sec-hero", _activeStyleVariant),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((HeroFu_module_default()), "m_padding-global", _activeStyleVariant),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((HeroFu_module_default()), "m_container-large", _activeStyleVariant),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A.dynamic-devlink-component%20.w--current%20%5Bclass*%3D%22Hero_hero-card-gradient-inner__%22%5D%20%7B%0A%20%20background-color%3A%20white%20!important%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%208px%3B%0A%7D%0A%0A%5Bclass*%3D%22hero-card-gradient-fu%22%5D%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22hero-card-gradient-inner-headshot-fu%22%5D%7B%0Awidth%3A%203.25rem%3B%0Aheight%3A%203.25rem%3B%0A%7D%0A%0A%0A%40media%20screen%20and%20(min-width%3A%201440px)%20%7B%0A%20%20%5Bclass*%3D%22hero-card-gradient-fu%22%5D%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22hero-card-gradient-inner-headshot-fu%22%5D%7B%0Awidth%3A%203.625rem%3B%0Aheight%3A%203.625rem%3B%0A%7D%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((HeroFu_module_default()), "fw1_hero-title-parent", _activeStyleVariant),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((HeroFu_module_default()), "fw1_hero-title-white", _activeStyleVariant),
                                tag: "h1",
                                children: [
                                    "One AI platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                className: utils.cx((HeroFu_module_default()), "fw1_hero-sub-white", _activeStyleVariant),
                                children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((HeroFu_module_default()), "hp-hero-btnsparent", _activeStyleVariant),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                    className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary-white", "hero-btn-project", "is-visible", _activeStyleVariant),
                                    tag: "a",
                                    "data-button-type": "signup",
                                    href: "",
                                    "data-tabs-buttons": "hero",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            tag: "div",
                                            children: "Get Started"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((HeroFu_module_default()), "comp_hp-hero-tabs", _activeStyleVariant),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((HeroFu_module_default()), "hp-hero-tabs-blur", _activeStyleVariant),
                                width: "auto",
                                height: "auto",
                                loading: "lazy",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68866a80c2ad5470f8326221_eclipse-blur.png"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((HeroFu_module_default()), "hero-star-1", _activeStyleVariant),
                                width: "auto",
                                height: "auto",
                                loading: "lazy",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/684ae7f47c69f87c209a5bc5_hp-star-1.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                className: utils.cx((HeroFu_module_default()), "hero-star-2", _activeStyleVariant),
                                width: "auto",
                                height: "auto",
                                loading: "lazy",
                                alt: "",
                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68886c3f715129a46f5fa43b_star2.svg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                className: utils.cx((HeroFu_module_default()), "hp_hero-tabs-fu", _activeStyleVariant),
                                current: "Projects",
                                easing: "ease",
                                fadeIn: 0,
                                fadeOut: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                        className: utils.cx((HeroFu_module_default()), "hp_hero-tabs-menu-fu", _activeStyleVariant),
                                        tag: "div",
                                        "data-hero-tabs": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "Projects",
                                                "data-tab": "",
                                                "data-tag-theme": "projects",
                                                "data-cluster": "product_management",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-projects.png",
                                                            alt: "hp-headshot-projects"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Projects"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "Marketing",
                                                "data-tab": "",
                                                "data-tag-theme": "marketing",
                                                "data-cluster": "marketing",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-marketing.png",
                                                            alt: "hp-headshot-sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Marketing"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "Sales",
                                                "data-tab": "",
                                                "data-tag-theme": "sales",
                                                "data-tab-product": "crm",
                                                "data-cluster": "crm",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-sales.png",
                                                            alt: "hp-headshot-sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "Operation",
                                                "data-tab": "",
                                                "data-tag-theme": "ops",
                                                "data-cluster": "operations",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-ops.png",
                                                            alt: "hp-headshot-ops"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Operations"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "Software",
                                                "data-tab": "",
                                                "data-tag-theme": "software",
                                                "data-tab-product": "dev",
                                                "data-cluster": "tech",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-software.png",
                                                            alt: "hp-headshot-software"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Software"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsLink, {
                                                className: utils.cx((HeroFu_module_default()), "hero-card-gradient-fu", _activeStyleVariant),
                                                "data-w-tab": "IT & Support",
                                                "data-tab": "",
                                                "data-tag-theme": "it",
                                                "data-tab-product": "service",
                                                "data-cluster": "information_technology",
                                                block: "inline",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-fu", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                            className: utils.cx((HeroFu_module_default()), "hero-card-gradient-inner-headshot-fu", _activeStyleVariant),
                                                            tag: "img",
                                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1753769923/Generator_featured%20images/hp-2025/hero/headshots-fu/Headshot-support.png",
                                                            alt: "hp-headshot-it"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "IT & Support"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((HeroFu_module_default()), "m_tab-arrow", _activeStyleVariant),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2216%22%20height%3D%2215%22%20viewBox%3D%220%200%2016%2015%22%20fill%3D%22none%22%3E%0A%20%20%3Cpath%20d%3D%22M7.86816%201.14709C8.19776%200.817673%208.73193%200.817665%209.06152%201.14709L15.2764%207.36193C15.5734%207.65901%2015.5734%208.14103%2015.2764%208.43811L9.06152%2014.6529C8.73194%2014.9823%208.19775%2014.9823%207.86816%2014.6529C7.53853%2014.3233%207.53853%2013.7883%207.86816%2013.4586L12.582%208.74475H1.39648C0.930492%208.74453%200.552734%208.36704%200.552734%207.901C0.552793%207.435%200.930528%207.05747%201.39648%207.05725H12.584L7.86816%202.34143C7.53853%202.01179%207.53853%201.47673%207.86816%201.14709Z%22%20fill%3D%22%23676879%22%2F%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                        className: utils.cx((HeroFu_module_default()), "hp_hero-tabs-content-fu", _activeStyleVariant),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "Projects",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364a2-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ac3f600007c686c6585a_Projects-launch-planupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364a4-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "product_management",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "Marketing",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364ab-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ac3fa7466a4c208a839e_Marketing-campaign-planupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364ad-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "marketing",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "Sales",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364b4-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ac3fb7dc6f39dfe76181_Sales-leadsupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364b6-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "crm",
                                                                href: "",
                                                                "data-cluster": "crm",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "Operation",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364bd-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ac3f73fac740fbe4b80c_Operations-conference-planningupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364bf-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                href: "",
                                                                "data-cluster": "operations",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "Software",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364c6-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ad161d14b5f0b0ae1a7a_AUG-Software-sprintupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364c8-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "dev",
                                                                href: "",
                                                                "data-cluster": "tech",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-pane", _activeStyleVariant),
                                                tag: "div",
                                                "data-w-tab": "IT & Support",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((HeroFu_module_default()), "hp_hero-tab-inner", _activeStyleVariant),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364cf-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroFu_module_default()), "hp_hero-tab-board-parent-fu-ouline", _activeStyleVariant),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6894ac3f14c8b8435c6f6baa_SupportandIT-ticketsupdated.webp"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((HeroFu_module_default()), "hero_tabs-btn-parent-fu", _activeStyleVariant),
                                                            id: utils.cx((HeroFu_module_default()), "w-node-cc333ce5-50da-6e72-d1c6-dca7380364d1-38036462"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((HeroFu_module_default()), "m_button", "m_button-primary", "for--hero", _activeStyleVariant),
                                                                tag: "a",
                                                                "data-button-type": "signup",
                                                                "data-tabs-buttons": "tabs",
                                                                "data-product-id": "service",
                                                                href: "",
                                                                "data-cluster": "information_technology",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((HeroFu_module_default()), "m_button-arrow", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((HeroFu_module_default()), "hp-hero-tabs-menu-top-fu", _activeStyleVariant),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((HeroFu_module_default()), "hero-tabs-menu-top-h-fu", _activeStyleVariant),
                                        tag: "div",
                                        children: "What would you like to manage?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%40keyframes%20swoosh%20%7B%0A%20%200%25%20%7B%0A%20%20%20%20background-position%3A%20200%25%3B%0A%20%20%0A%20%20%7D%0A%20%20100%25%20%7B%0A%20%20%20%20background-position%3A%20-200%25%3B%0A%20%20%7D%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22what--span%22%5D%20%7B%0A%20%20background-size%3A%20200%25%3B%0A%20%20background-position%3A%20-200%25%3B%0A%20%20animation%3A%20swoosh%206s%20cubic-bezier(0.4%2C%200%2C%200.2%2C%201)%20infinite%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A.hero-tab-gradient.is-active%20.hero-card-gradient-inner%20%7B%0A%20%20background-color%3A%20white%3B%0A%20%20border-color%3A%20white%3B%0A%20%20border-radius%3A%207px%3B%0A%7D%0A%0A%5Bclass*%3D%22comp_hp-hero-tabs%22%5D%20%5Bclass*%3D%22w--current%22%5D%20%5Bclass*%3D%22m_tab-arrow%22%5D%20%7B%0A%20%20opacity%3A%201%3B%0A%7D%0A%3C%2Fstyle%3E"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/HeroV8LeftPannel.module.css
var HeroV8LeftPannel_module = __webpack_require__(71433);
var HeroV8LeftPannel_module_default = /*#__PURE__*/__webpack_require__.n(HeroV8LeftPannel_module);
;// CONCATENATED MODULE: ./devlink/HeroV8LeftPannel.js
"use client";






var HeroV8LeftPannel_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function HeroV8LeftPannel(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(HeroV8LeftPannel_interactionsData, (HeroV8LeftPannel_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((HeroV8LeftPannel_module_default()), "m_padding-global"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((HeroV8LeftPannel_module_default()), "group_hero-center-all"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((HeroV8LeftPannel_module_default()), "m_hero-title-parent"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "fw1_hero-title-black-lotem"),
                                    tag: "h1",
                                    children: [
                                        "One AI work platform",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "for any kind of work"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "subtitle-white-test-max-width"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((HeroV8LeftPannel_module_default()), "fw2_hero-sub-black"),
                                        children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-1rem"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                    tag: "div",
                                    children: [
                                        "No credit card needed ✦ Unlimited time on Free plan",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                    tag: "div"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((HeroV8LeftPannel_module_default()), "m_container-xlarge"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((HeroV8LeftPannel_module_default()), "tabs-shorter-hero-wrapper-2"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((HeroV8LeftPannel_module_default()), "opening-question"),
                                        tag: "div",
                                        children: "Where would you like to start?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                        current: "projects",
                                        easing: "ease-in",
                                        fadeIn: 300,
                                        fadeOut: 100,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                className: utils.cx((HeroV8LeftPannel_module_default()), "tabs-group-lotem-hero-wide"),
                                                tag: "div",
                                                "data-hero-tabs": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "projects",
                                                        "data-tab": "",
                                                        "data-tag-theme": "projects",
                                                        "data-cluster": "projects",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd01ef32bc74f8d96a3_project-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Projects"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "marketing",
                                                        "data-tab": "",
                                                        "data-tag-theme": "marketing",
                                                        "data-cluster": "marketing",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0c0ed5b52de6b3220_marketing-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Marketing"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "sales",
                                                        "data-tab": "",
                                                        "data-tag-theme": "sales",
                                                        "data-tab-product": "crm",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0bbd92df017e31365_sales-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Sales"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "operations",
                                                        "data-tab": "",
                                                        "data-tag-theme": "operations",
                                                        "data-cluster": "operations",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd04641d45e8f5aa26a_ops-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Operations"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "software",
                                                        "data-tab": "",
                                                        "data-tag-theme": "software",
                                                        "data-tab-product": "dev",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd03d01ce5331f60d62_dev-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Software"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "support and it",
                                                        "data-tab": "",
                                                        "data-tag-theme": "it",
                                                        "data-tab-product": "service",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0300c7fa50d3388b2_it-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Support & IT"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-content", "no-top-radius-corners"),
                                                tag: "div",
                                                id: "tab-pane",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "projects",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                href: "",
                                                                                                "data-cluster": "product_management",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6908856099898eaef22fd9e2_updated-content-Projects.png"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "marketing",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "marketing",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3f19283a6c0d361de_Marketinglotem-hero.webp"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "sales",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "crm",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3502474988301a736_Saleslotem-hero.webp"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "operations",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "operations",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69088560a79c99471cd9ce48_updated-content-Operations.png"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "software",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "dev",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d36d671f8ef1c70f37_Softwarelotem-hero.webp"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "support and it",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "left-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "service",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8LeftPannel_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8LeftPannel_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8LeftPannel_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8LeftPannel_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3eeb3cfcdc11f09b9_ITlotem-hero.webp"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroV8LeftPannel_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroV8LeftPannel_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/HeroV8OldImages.module.css
var HeroV8OldImages_module = __webpack_require__(94285);
var HeroV8OldImages_module_default = /*#__PURE__*/__webpack_require__.n(HeroV8OldImages_module);
;// CONCATENATED MODULE: ./devlink/HeroV8OldImages.js
"use client";






var HeroV8OldImages_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function HeroV8OldImages(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(HeroV8OldImages_interactionsData, (HeroV8OldImages_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((HeroV8OldImages_module_default()), "m_padding-global"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((HeroV8OldImages_module_default()), "group_hero-center-all"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((HeroV8OldImages_module_default()), "m_hero-title-parent"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "fw1_hero-title-black-lotem"),
                                    tag: "h1",
                                    children: [
                                        "One AI work platform",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "for any kind of work"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "subtitle-white-test-max-width"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((HeroV8OldImages_module_default()), "fw2_hero-sub-black"),
                                        children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-1rem"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                    tag: "div",
                                    children: [
                                        "No credit card needed ✦ Unlimited time on Free plan",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                    tag: "div"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((HeroV8OldImages_module_default()), "m_container-xlarge"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((HeroV8OldImages_module_default()), "tabs-shorter-hero-wrapper-2"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((HeroV8OldImages_module_default()), "opening-question"),
                                        tag: "div",
                                        children: "Where would you like to start?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                        current: "projects",
                                        easing: "ease-in",
                                        fadeIn: 300,
                                        fadeOut: 100,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                className: utils.cx((HeroV8OldImages_module_default()), "tabs-group-lotem-hero-wide"),
                                                tag: "div",
                                                "data-hero-tabs": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "projects",
                                                        "data-tab": "",
                                                        "data-tag-theme": "projects",
                                                        "data-cluster": "projects",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd01ef32bc74f8d96a3_project-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Projects"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "marketing",
                                                        "data-tab": "",
                                                        "data-tag-theme": "marketing",
                                                        "data-cluster": "marketing",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0c0ed5b52de6b3220_marketing-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Marketing"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "sales",
                                                        "data-tab": "",
                                                        "data-tag-theme": "sales",
                                                        "data-tab-product": "crm",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0bbd92df017e31365_sales-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Sales"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "operations",
                                                        "data-tab": "",
                                                        "data-tag-theme": "operations",
                                                        "data-cluster": "operations",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd04641d45e8f5aa26a_ops-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Operations"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "software",
                                                        "data-tab": "",
                                                        "data-tag-theme": "software",
                                                        "data-tab-product": "dev",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd03d01ce5331f60d62_dev-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Software"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "support and it",
                                                        "data-tab": "",
                                                        "data-tag-theme": "it",
                                                        "data-tab-product": "service",
                                                        "data-tab-scroll-target": "tab-pane",
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((HeroV8OldImages_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0300c7fa50d3388b2_it-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Support & IT"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-content", "no-top-radius-corners"),
                                                tag: "div",
                                                id: "tab-pane",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "projects",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed7d5f78fd098b740c6_Projectsv8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                href: "",
                                                                                                "data-cluster": "product_management",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "marketing",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed7b2ec1fdd285667ca_Marketingv8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "marketing",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "sales",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed765e13428c28bb1a2_Salesv8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "crm",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "operations",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed737ca4fdf95242368_Operationsv8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "operations",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "software",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed7f592d76fca549ef3_Softwarev8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "dev",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "support and it",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((HeroV8OldImages_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/691b0ed767ffe694aec1eee4_Support%20%26%20ITv8.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((HeroV8OldImages_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((HeroV8OldImages_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((HeroV8OldImages_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "service",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((HeroV8OldImages_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((HeroV8OldImages_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((HeroV8OldImages_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroV8OldImages_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((HeroV8OldImages_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/LHeroHover.module.css
var LHeroHover_module = __webpack_require__(85294);
var LHeroHover_module_default = /*#__PURE__*/__webpack_require__.n(LHeroHover_module);
;// CONCATENATED MODULE: ./devlink/LHeroHover.js
"use client";






var LHeroHover_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-120":{"id":"e-120","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-121"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018688},"e-121":{"id":"e-121","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-120"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018689},"e-122":{"id":"e-122","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-123"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453976},"e-123":{"id":"e-123","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-122"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453977},"e-124":{"id":"e-124","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-125"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500182},"e-125":{"id":"e-125","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500183},"e-126":{"id":"e-126","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-127"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519052},"e-127":{"id":"e-127","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519053},"e-128":{"id":"e-128","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536671},"e-129":{"id":"e-129","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536672},"e-130":{"id":"e-130","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575804},"e-131":{"id":"e-131","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575805},"e-140":{"id":"e-140","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-141"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986154},"e-141":{"id":"e-141","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-78","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-140"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986155},"e-142":{"id":"e-142","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-79","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-79-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1758008534967},"e-143":{"id":"e-143","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-80","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-80-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1758008534967},"e-144":{"id":"e-144","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-145"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-145":{"id":"e-145","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-144"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-146":{"id":"e-146","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-147"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-147":{"id":"e-147","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-146"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-148":{"id":"e-148","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-149"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-149":{"id":"e-149","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-148"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-150":{"id":"e-150","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-151"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-151":{"id":"e-151","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-150"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-152":{"id":"e-152","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-153"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-153":{"id":"e-153","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-152"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-154":{"id":"e-154","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-155"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-155":{"id":"e-155","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-154"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-160":{"id":"e-160","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-161"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-161":{"id":"e-161","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-160"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-162":{"id":"e-162","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-163"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-163":{"id":"e-163","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-162"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-164":{"id":"e-164","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-165"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-165":{"id":"e-165","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-164"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-166":{"id":"e-166","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-167"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-167":{"id":"e-167","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-166"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-168":{"id":"e-168","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-169"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-169":{"id":"e-169","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-168"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-170":{"id":"e-170","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-171"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-170"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-75":{"id":"a-75","title":"tab-lotem-hero-hover-marketing","actionItemGroups":[{"actionItems":[{"id":"a-75-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-75-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-75-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-75-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-76":{"id":"a-76","title":"tab-lotem-hero-hover-marketing-out","actionItemGroups":[{"actionItems":[{"id":"a-76-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-76-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-77":{"id":"a-77","title":"tab-change-animation-start","actionItemGroups":[{"actionItems":[{"id":"a-77-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004570088},"a-78":{"id":"a-78","title":"tab-change-animation-stop","actionItemGroups":[{"actionItems":[{"id":"a-78-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004716592},"a-79":{"id":"a-79","title":"lotem-hero-stars 3","continuousParameterGroups":[{"id":"a-79-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":58,"actionItems":[{"id":"a-79-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607b"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-79-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607b"},"xValue":100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994303250},"a-80":{"id":"a-80","title":"lotem-star-2 3","continuousParameterGroups":[{"id":"a-80-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":83,"actionItems":[{"id":"a-80-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607c"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-80-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"e806fe2c-e771-2f2f-5869-d7c0b53d607c"},"xValue":40,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994368122},"a-81":{"id":"a-81","title":"tab-lotem-hero-hover-marketing 2","actionItemGroups":[{"actionItems":[{"id":"a-81-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-81-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-81-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-81-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-82":{"id":"a-82","title":"tab-lotem-hero-hover-marketing-out 2","actionItemGroups":[{"actionItems":[{"id":"a-82-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-82-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-87":{"id":"a-87","title":"tab-lotem-hero-hover-marketing 3","actionItemGroups":[{"actionItems":[{"id":"a-87-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-87-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-87-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-87-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-88":{"id":"a-88","title":"tab-lotem-hero-hover-marketing-out 3","actionItemGroups":[{"actionItems":[{"id":"a-88-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-88-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function LHeroHover(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _creditCardVisibility = param.creditCardVisibility, creditCardVisibility = _creditCardVisibility === void 0 ? false : _creditCardVisibility, _whatWouldVisibility = param.whatWouldVisibility, whatWouldVisibility = _whatWouldVisibility === void 0 ? false : _whatWouldVisibility;
    interactions/* useInteractions */.NI(LHeroHover_interactionsData, (LHeroHover_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((LHeroHover_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((LHeroHover_module_default()), "group_hero-center-all"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((LHeroHover_module_default()), "m_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((LHeroHover_module_default()), "fw1_hero-title-black-lotem"),
                                tag: "h1",
                                children: [
                                    "One AI work platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroHover_module_default()), "subtitle-white-test-max-width"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    className: utils.cx((LHeroHover_module_default()), "fw1_hero-sub-black"),
                                    children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((LHeroHover_module_default()), "fw1_button-parent"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                            className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                            tag: "a",
                                            slot: "",
                                            "data-button-type": "signup",
                                            href: "",
                                            "data-tabs-buttons": "hero",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    children: "Get Started"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                    className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                })
                                            ]
                                        }),
                                        creditCardVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((LHeroHover_module_default()), "no-credit-label"),
                                            tag: "div",
                                            children: "No credit card needed ✦ Unlimited time on Free plan"
                                        }) : null
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroHover_module_default()), "m_spacer-3rem"),
                                tag: "div"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23ffffff%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%3Ahover%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Anot(%3Ahover)%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((LHeroHover_module_default()), "lotem-tabs-parent"),
                        tag: "div",
                        children: [
                            whatWouldVisibility ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroHover_module_default()), "lotem-tabs-what-would"),
                                tag: "div",
                                children: "Where would you like to start?"
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tabs-holder"),
                                current: "projects",
                                easing: "ease-in",
                                fadeIn: 300,
                                fadeOut: 100,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                        className: utils.cx((LHeroHover_module_default()), "tabs-group-lotem-hero"),
                                        tag: "div",
                                        "data-hero-tabs": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5fa3",
                                                "data-w-tab": "projects",
                                                "data-tab": "",
                                                "data-tag-theme": "projects",
                                                "data-cluster": "projects",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fe13d57acb113eb68_project-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem", "projects"),
                                                        tag: "div",
                                                        children: "Projects"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5fa9",
                                                "data-w-tab": "marketing",
                                                "data-tab": "",
                                                "data-tag-theme": "marketing",
                                                "data-cluster": "marketing",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem"),
                                                        tag: "div",
                                                        children: "Marketing"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5faf",
                                                "data-w-tab": "sales",
                                                "data-tab": "",
                                                "data-tag-theme": "sales",
                                                "data-tab-product": "crm",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fcc2cafe49f1d58f5_sales-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem", "sales"),
                                                        tag: "div",
                                                        children: "Sales"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5fb5",
                                                "data-w-tab": "operations",
                                                "data-tab": "",
                                                "data-tag-theme": "operations",
                                                "data-cluster": "operations",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c910e94cfdbf636cf83ed4_sharpmove-ops-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f3823d6d605a96925_ops-thumbnail-tab.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                        className: utils.cx((LHeroHover_module_default()), "headshot-hero-video"),
                                                                        tag: "div",
                                                                        sources: [
                                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                        ],
                                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                        autoPlay: true,
                                                                        loop: true
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem", "operations"),
                                                        tag: "div",
                                                        children: "Operations"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5fbe",
                                                "data-w-tab": "software",
                                                "data-tab": "",
                                                "data-tag-theme": "software",
                                                "data-tab-product": "dev",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f9e86e93016c29fa4_dev-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem", "sftware"),
                                                        tag: "div",
                                                        children: "Software"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                className: utils.cx((LHeroHover_module_default()), "tab-lotem-hero-hover"),
                                                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d5fc4",
                                                "data-w-tab": "support and it",
                                                "data-tab": "",
                                                "data-tag-theme": "it",
                                                "data-tab-product": "service",
                                                block: "inline",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroHover_module_default()), "headshot-hero-video", "hide"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroHover_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f8402902bc5c6b9e2_it-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((LHeroHover_module_default()), "tab-hero-text-lotem", "it"),
                                                        tag: "div",
                                                        children: "Support & IT"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                        className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "projects",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b1edcf2745fc7b409_Projectslotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        href: "",
                                                                                        "data-cluster": "product_management",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "marketing",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766bbf067937d471973f_Marketinglotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        href: "",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        "data-product-id": "marketing",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "sales",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b8f66d4769aa59149_Saleslotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        href: "",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        "data-product-id": "crm",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "operations",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b5b8e4654ee9d5205_Operationslotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        href: "",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        "data-product-id": "operations",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "software",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b5757592666bc2ede_Softwarelotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        href: "",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        "data-product-id": "dev",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-tab-pane"),
                                                tag: "div",
                                                "data-w-tab": "support and it",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-flexbox"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((LHeroHover_module_default()), "asset-image-lotem-hero"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "eager",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68da766b59cf441a15392587_ITlotem-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroHover_module_default()), "right-pane-lotem-hero"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Recommended product"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "logo-svg"),
                                                                                    width: "auto",
                                                                                    height: "auto",
                                                                                    loading: "lazy",
                                                                                    alt: "",
                                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "m_spacer-2rem"),
                                                                            tag: "div"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-info-text"),
                                                                                    tag: "div",
                                                                                    children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((LHeroHover_module_default()), "hp-hero-btnsparent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                        className: utils.cx((LHeroHover_module_default()), "m_button", "hero-btn-purple"),
                                                                                        tag: "a",
                                                                                        slot: "",
                                                                                        "data-button-type": "signup",
                                                                                        href: "",
                                                                                        "data-tabs-buttons": "tabs",
                                                                                        "data-product-id": "service",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                tag: "div",
                                                                                                children: "Get Started"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                className: utils.cx((LHeroHover_module_default()), "m_button-arrow"),
                                                                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroHover_module_default()), "right-pane-top-hero-lotem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((LHeroHover_module_default()), "logo-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((LHeroHover_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                tag: "div",
                                                                                children: "Part of the monday product suite"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                className: utils.cx((LHeroHover_module_default()), "products-logos-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LHeroHover_module_default()), "ai-star-hero"),
                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d607b",
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LHeroHover_module_default()), "ai-star-hero-2"),
                "data-w-id": "e806fe2c-e771-2f2f-5869-d7c0b53d607c",
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/LHeroVideos.module.css
var LHeroVideos_module = __webpack_require__(41050);
var LHeroVideos_module_default = /*#__PURE__*/__webpack_require__.n(LHeroVideos_module);
;// CONCATENATED MODULE: ./devlink/LHeroVideos.js
"use client";






var LHeroVideos_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-120":{"id":"e-120","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-121"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018688},"e-121":{"id":"e-121","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-120"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df723","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757929018689},"e-122":{"id":"e-122","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-123"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453976},"e-123":{"id":"e-123","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-122"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df727","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935453977},"e-124":{"id":"e-124","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-125"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500182},"e-125":{"id":"e-125","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-124"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935500183},"e-126":{"id":"e-126","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-127"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519052},"e-127":{"id":"e-127","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-126"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935519053},"e-128":{"id":"e-128","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-129"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536671},"e-129":{"id":"e-129","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-128"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df733","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935536672},"e-130":{"id":"e-130","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-75","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-131"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575804},"e-131":{"id":"e-131","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-76","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-130"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"b9a67d05-c806-b654-44c9-20108d6df71f","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757935575805},"e-140":{"id":"e-140","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-77","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-141"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986154},"e-141":{"id":"e-141","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-78","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-140"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"},"targets":[{"selector":".tab-lotem-hero-hover","originalId":"b9a67d05-c806-b654-44c9-20108d6df72f","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758006986155},"e-144":{"id":"e-144","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-145"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-145":{"id":"e-145","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-144"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-146":{"id":"e-146","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-147"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-147":{"id":"e-147","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-146"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5faf","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-148":{"id":"e-148","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-149"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-149":{"id":"e-149","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-148"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fb5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-150":{"id":"e-150","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-151"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-151":{"id":"e-151","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-150"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fbe","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-152":{"id":"e-152","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-153"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-153":{"id":"e-153","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-152"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fc4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-154":{"id":"e-154","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-81","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-155"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-155":{"id":"e-155","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-82","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-154"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"e806fe2c-e771-2f2f-5869-d7c0b53d5fa3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758008534967},"e-158":{"id":"e-158","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-85","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c5","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c5","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-85-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1758009279972},"e-159":{"id":"e-159","name":"","animationType":"preset","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-86","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-86-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1758009279972},"e-160":{"id":"e-160","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-161"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-161":{"id":"e-161","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-160"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-162":{"id":"e-162","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-163"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-163":{"id":"e-163","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-162"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0f9","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-164":{"id":"e-164","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-165"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-165":{"id":"e-165","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-164"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ff","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-166":{"id":"e-166","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-167"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-167":{"id":"e-167","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-166"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e108","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-168":{"id":"e-168","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-169"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-169":{"id":"e-169","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-168"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e10e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-170":{"id":"e-170","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-87","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-171"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972},"e-171":{"id":"e-171","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-88","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-170"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"8ad6ac56-f2bd-9748-5f58-816277d7e0ed","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1758009279972}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-75":{"id":"a-75","title":"tab-lotem-hero-hover-marketing","actionItemGroups":[{"actionItems":[{"id":"a-75-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-75-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-75-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-75-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-76":{"id":"a-76","title":"tab-lotem-hero-hover-marketing-out","actionItemGroups":[{"actionItems":[{"id":"a-76-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-76-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-77":{"id":"a-77","title":"tab-change-animation-start","actionItemGroups":[{"actionItems":[{"id":"a-77-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004570088},"a-78":{"id":"a-78","title":"tab-change-animation-stop","actionItemGroups":[{"actionItems":[{"id":"a-78-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".headshot-hero-video","selectorGuids":["cd33e8e8-8c2d-ddf9-6a1c-565ab1b0238b"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1758004716592},"a-81":{"id":"a-81","title":"tab-lotem-hero-hover-marketing 2","actionItemGroups":[{"actionItems":[{"id":"a-81-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-81-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-81-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-81-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-82":{"id":"a-82","title":"tab-lotem-hero-hover-marketing-out 2","actionItemGroups":[{"actionItems":[{"id":"a-82-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-82-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-85":{"id":"a-85","title":"lotem-hero-stars 4","continuousParameterGroups":[{"id":"a-85-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":58,"actionItems":[{"id":"a-85-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c5"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-85-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c5"},"xValue":100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994303250},"a-86":{"id":"a-86","title":"lotem-star-2 4","continuousParameterGroups":[{"id":"a-86-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":83,"actionItems":[{"id":"a-86-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c6"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-86-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"8ad6ac56-f2bd-9748-5f58-816277d7e1c6"},"xValue":40,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994368122},"a-87":{"id":"a-87","title":"tab-lotem-hero-hover-marketing 3","actionItemGroups":[{"actionItems":[{"id":"a-87-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":0.4,"unit":""}},{"id":"a-87-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeOut","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-87-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":0.5,"unit":""}},{"id":"a-87-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930},"a-88":{"id":"a-88","title":"tab-lotem-hero-hover-marketing-out 3","actionItemGroups":[{"actionItems":[{"id":"a-88-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":200,"target":{"selector":".tab-hero-text-lotem","selectorGuids":["eb91e9da-7e35-b074-9e95-f1261a799a2a"]},"value":1,"unit":""}},{"id":"a-88-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".thumbnail-tab-image","selectorGuids":["0be0b368-98c2-a257-0cd2-527621bf9ba9"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757929027930}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function LHeroVideos(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(LHeroVideos_interactionsData, (LHeroVideos_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((LHeroVideos_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((LHeroVideos_module_default()), "group_hero-center-all"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((LHeroVideos_module_default()), "m_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((LHeroVideos_module_default()), "fw1_hero-title-black-lotem"),
                                tag: "h1",
                                children: [
                                    "One AI work platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroVideos_module_default()), "subtitle-white-test-max-width"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    className: utils.cx((LHeroVideos_module_default()), "fw1_hero-sub-black"),
                                    children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                    className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                    tag: "a",
                                    slot: "",
                                    "data-button-type": "signup",
                                    href: "",
                                    "data-tabs-buttons": "hero",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            tag: "div",
                                            children: "Get Started"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LHeroVideos_module_default()), "m_spacer-3rem"),
                                tag: "div"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23ffffff%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Ahover%20.tab-lotem-hero-hover.w--current%3Ahover%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A.w-tab-menu%3Anot(%3Ahover)%20.tab-lotem-hero-hover.w--current%20%7B%0A%20%20border-color%3A%20%23D0D4E4%20!important%3B%0A%7D%0A%0A%2F*%201.%20This%20rule%20ensures%20the%20video%20is%20always%20visible%20on%20the%20current%20tab.%20*%2F%0A.tab-lotem-hero-hover.w--current%20.headshot-hero-video%20%7B%0A%20%20opacity%3A%201%20!important%3B%0A%7D%0A%0A%2F*%202.%20This%20rule%20hides%20the%20video%20on%20the%20current%20tab%20when%20you%20hover%20over%20a%20different%20tab.%20*%2F%0A.tab-lotem-hero-hover%3Anot(.w--current)%3Ahover%20~%20.tab-lotem-hero-hover.w--current%20.headshot-hero-video%20%7B%0A%20%20opacity%3A%200%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tabs-holder"),
                        current: "projects",
                        easing: "ease-in",
                        fadeIn: 100,
                        fadeOut: 100,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                className: utils.cx((LHeroVideos_module_default()), "tabs-group-lotem-hero"),
                                tag: "div",
                                "data-hero-tabs": "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e0ed",
                                        "data-w-tab": "projects",
                                        "data-tab": "",
                                        "data-tag-theme": "projects",
                                        "data-cluster": "projects",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fe13d57acb113eb68_project-thumbnail-tab.png"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem", "projects"),
                                                tag: "div",
                                                children: "Projects"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e0f3",
                                        "data-w-tab": "marketing",
                                        "data-tab": "",
                                        "data-tag-theme": "marketing",
                                        "data-cluster": "marketing",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8170e9346359542e267ea_marketing-animation-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem"),
                                                tag: "div",
                                                children: "Marketing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e0f9",
                                        "data-w-tab": "sales",
                                        "data-tab": "",
                                        "data-tag-theme": "sales",
                                        "data-tab-product": "crm",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c911416859f9f8e217c109_1sharpermove-sales-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fcc2cafe49f1d58f5_sales-thumbnail-tab.png"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem", "sales"),
                                                tag: "div",
                                                children: "Sales"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e0ff",
                                        "data-w-tab": "operations",
                                        "data-tab": "",
                                        "data-tag-theme": "operations",
                                        "data-cluster": "operations",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c962787fb60bb854728c0c_2updated-ops-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c962787fb60bb854728c0c_2updated-ops-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c962787fb60bb854728c0c_2updated-ops-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f3823d6d605a96925_ops-thumbnail-tab.png"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                                className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                                tag: "div",
                                                                sources: [
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.webm",
                                                                    "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-transcode.mp4"
                                                                ],
                                                                posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c80b5a2632a260ae517286_project-animation-poster-00001.jpg",
                                                                autoPlay: true,
                                                                loop: true
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem", "operations"),
                                                tag: "div",
                                                children: "Operations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e108",
                                        "data-w-tab": "software",
                                        "data-tab": "",
                                        "data-tag-theme": "software",
                                        "data-tab-product": "dev",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8181acd67c0ed905136d1_dev-animation-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f9e86e93016c29fa4_dev-thumbnail-tab.png"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem", "sftware"),
                                                tag: "div",
                                                children: "Software"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LHeroVideos_module_default()), "tab-lotem-hero-hover"),
                                        "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e10e",
                                        "data-w-tab": "support and it",
                                        "data-tab": "",
                                        "data-tag-theme": "it",
                                        "data-tab-product": "service",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundVideoWrapper, {
                                                        className: utils.cx((LHeroVideos_module_default()), "headshot-hero-video"),
                                                        tag: "div",
                                                        sources: [
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.webm",
                                                            "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-transcode.mp4"
                                                        ],
                                                        posterImage: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6%2F68c8183c80253efe73ac26cf_IT-animation-poster-00001.jpg",
                                                        autoPlay: true,
                                                        loop: true
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                        className: utils.cx((LHeroVideos_module_default()), "thumbnail-tab-image"),
                                                        width: "auto",
                                                        height: "auto",
                                                        loading: "lazy",
                                                        alt: "",
                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f8402902bc5c6b9e2_it-thumbnail-tab.png"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((LHeroVideos_module_default()), "tab-hero-text-lotem", "it"),
                                                tag: "div",
                                                children: "Support & IT"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-content"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "projects",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b992dc77d00f0712f5c7e7_Projects.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                "data-tabs-buttons": "tabs",
                                                                                href: "",
                                                                                "data-cluster": "product_management",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "marketing",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3f19283a6c0d361de_Marketinglotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "marketing",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "sales",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3502474988301a736_Saleslotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: [
                                                                                "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "crm",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "operations",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c186724e0e29abca6cd2f4_hp-sep10-Operations.avif"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "operations",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "software",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d36d671f8ef1c70f37_Softwarelotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: [
                                                                                "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "dev",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "support and it",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LHeroVideos_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3eeb3cfcdc11f09b9_ITlotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LHeroVideos_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LHeroVideos_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LHeroVideos_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                slot: "",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "service",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LHeroVideos_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LHeroVideos_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LHeroVideos_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LHeroVideos_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LHeroVideos_module_default()), "ai-star-hero"),
                "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e1c5",
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LHeroVideos_module_default()), "ai-star-hero-2"),
                "data-w-id": "8ad6ac56-f2bd-9748-5f58-816277d7e1c6",
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/Logos.module.css
var Logos_module = __webpack_require__(62463);
var Logos_module_default = /*#__PURE__*/__webpack_require__.n(Logos_module);
;// CONCATENATED MODULE: ./devlink/Logos.js
"use client";






var Logos_interactionsData = JSON.parse('{"events":{"e-23":{"id":"e-23","name":"","animationType":"preset","eventTypeId":"PAGE_START","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-24"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":true,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1750328136976}},"actionLists":{"a-15":{"id":"a-15","title":"logos-marquee","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-15-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":40000,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":-74.625,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-15-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".fw1_hero-logos-moving","selectorGuids":["31e1c642-c21a-e7c7-c336-ca93dec6c935"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750273292078}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Logos(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(Logos_interactionsData, (Logos_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Logos_module_default()), "sec-logos"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Logos_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Logos_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                    className: utils.cx((Logos_module_default()), "m_container-large"),
                    tag: "div",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((Logos_module_default()), "comp_hp-logos"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Logos_module_default()), "fw1_trusted-label"),
                                tag: "div",
                                children: [
                                    "Trusted by over 60% of the Fortune 500",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Logos_module_default()), "fw1_hero-logos-mask"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Logos_module_default()), "fw1_hero-logos-moving"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Logos_module_default()), "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Logos_module_default()), "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Logos_module_default()), "fw1_hero-logos-slide"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2645b8b2407432d177_logo-white-canva.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d263ed398c6ee1a0879_logo-white-cc.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d26cc793700826baef4_logo-white-vistra.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d274745b6ddab6e01cf_logo-white-universal.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d260d55571f1d408d8b_logo-white-holt.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685d7d2687b579f3f034a572_logo-white-lionsgate.svg"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Logos_module_default()), "fw1_hero-logo"),
                                                    loading: "lazy",
                                                    width: "auto",
                                                    height: "auto",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6853b39db00d43009126c353_logo-white-carrefour.svg"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Logos_module_default()), "hp_logos-fade"),
                                tag: "div"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Logos_module_default()), "hp_logos-fade", "is--right"),
                                tag: "div"
                            })
                        ]
                    })
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/LotemHero.module.css
var LotemHero_module = __webpack_require__(95507);
var LotemHero_module_default = /*#__PURE__*/__webpack_require__.n(LotemHero_module);
;// CONCATENATED MODULE: ./devlink/LotemHero.js
"use client";






var LotemHero_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-69"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-73"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-98":{"id":"e-98","name":"","animationType":"custom","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-55","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"73127d56-7552-480d-8afa-9a64efea9c07","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"73127d56-7552-480d-8afa-9a64efea9c07","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-55-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1756994270582},"e-99":{"id":"e-99","name":"","animationType":"custom","eventTypeId":"SCROLLING_IN_VIEW","action":{"id":"","actionTypeId":"GENERAL_CONTINUOUS_ACTION","config":{"actionListId":"a-56","affectedElements":{},"duration":0}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"73127d56-7552-480d-8afa-9a64efea9c08","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"73127d56-7552-480d-8afa-9a64efea9c08","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":[{"continuousParameterGroupId":"a-56-p","smoothing":50,"startsEntering":true,"addStartOffset":false,"addOffsetValue":50,"startsExiting":false,"addEndOffset":false,"endOffsetValue":50}],"createdOn":1756994346612}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-55":{"id":"a-55","title":"lotem-hero-stars","continuousParameterGroups":[{"id":"a-55-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":58,"actionItems":[{"id":"a-55-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"73127d56-7552-480d-8afa-9a64efea9c07"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-55-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"73127d56-7552-480d-8afa-9a64efea9c07"},"xValue":100,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994303250},"a-56":{"id":"a-56","title":"lotem-star-2","continuousParameterGroups":[{"id":"a-56-p","type":"SCROLL_PROGRESS","parameterLabel":"Scroll","continuousActionGroups":[{"keyframe":83,"actionItems":[{"id":"a-56-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"73127d56-7552-480d-8afa-9a64efea9c08"},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"keyframe":100,"actionItems":[{"id":"a-56-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"73127d56-7552-480d-8afa-9a64efea9c08"},"xValue":40,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}]}],"createdOn":1756994368122}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function LotemHero(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(LotemHero_interactionsData, (LotemHero_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((LotemHero_module_default()), "lotem-hero"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((LotemHero_module_default()), "group_hero-center-all"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((LotemHero_module_default()), "m_hero-title-parent"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                className: utils.cx((LotemHero_module_default()), "fw1_hero-title-black-lotem"),
                                tag: "h1",
                                children: [
                                    "One AI work platform",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "for any kind of work"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LotemHero_module_default()), "subtitle-white-test-max-width"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                    className: utils.cx((LotemHero_module_default()), "fw1_hero-sub-black"),
                                    children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                    className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                    tag: "a",
                                    "data-button-type": "signup",
                                    href: "",
                                    "data-tabs-buttons": "hero",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            tag: "div",
                                            children: "Get Started"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                            className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((LotemHero_module_default()), "m_spacer-3rem"),
                                tag: "div"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tabs-holder"),
                        current: "projects",
                        easing: "ease-in",
                        fadeIn: 300,
                        fadeOut: 100,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                className: utils.cx((LotemHero_module_default()), "tabs-group-lotem-hero"),
                                tag: "div",
                                "data-tabs": "",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "projects",
                                        "data-tab": "",
                                        "data-tag-theme": "projects",
                                        "data-cluster": "projects",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fe13d57acb113eb68_project-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Projects"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "marketing",
                                        "data-tab": "",
                                        "data-tag-theme": "marketing",
                                        "data-cluster": "marketing",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fec75524e6abce720_marketing-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Marketing"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "sales",
                                        "data-tab": "",
                                        "data-tag-theme": "sales",
                                        "data-tab-product": "crm",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2fcc2cafe49f1d58f5_sales-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Sales"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "operations",
                                        "data-tab": "",
                                        "data-tag-theme": "operations",
                                        "data-cluster": "operations",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f3823d6d605a96925_ops-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Operations"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "software",
                                        "data-tab": "",
                                        "data-tag-theme": "software",
                                        "data-tab-product": "dev",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f9e86e93016c29fa4_dev-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Software"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                        className: utils.cx((LotemHero_module_default()), "tab-lotem-hero"),
                                        "data-w-tab": "support and it",
                                        "data-tab": "",
                                        "data-tag-theme": "it",
                                        "data-tab-product": "service",
                                        block: "inline",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                className: utils.cx((LotemHero_module_default()), "thumbnail-tab-image"),
                                                width: "auto",
                                                height: "auto",
                                                loading: "lazy",
                                                alt: "",
                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b98f2f8402902bc5c6b9e2_it-thumbnail-tab.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Support & IT"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-content"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "projects",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b992dc77d00f0712f5c7e7_Projects.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "product_management",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "marketing",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3f19283a6c0d361de_Marketinglotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "marketing",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "sales",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3502474988301a736_Saleslotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: [
                                                                                "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "crm",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "operations",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c186724e0e29abca6cd2f4_hp-sep10-Operations.avif"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "operations",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "software",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d36d671f8ef1c70f37_Softwarelotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: [
                                                                                "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "dev",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-tab-pane"),
                                        tag: "div",
                                        "data-w-tab": "support and it",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-flexbox"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((LotemHero_module_default()), "asset-image-lotem-hero"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "eager",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3eeb3cfcdc11f09b9_ITlotem-hero.webp"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((LotemHero_module_default()), "right-pane-lotem-hero"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Recommended product"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                            className: utils.cx((LotemHero_module_default()), "logo-svg"),
                                                                            width: "auto",
                                                                            height: "auto",
                                                                            loading: "lazy",
                                                                            alt: "",
                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "m_spacer-2rem"),
                                                                    tag: "div"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-info-text"),
                                                                            tag: "div",
                                                                            children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((LotemHero_module_default()), "hp-hero-btnsparent"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                className: utils.cx((LotemHero_module_default()), "m_button", "hero-btn-purple"),
                                                                                tag: "a",
                                                                                "data-button-type": "signup",
                                                                                href: "",
                                                                                "data-tabs-buttons": "tabs",
                                                                                "data-product-id": "service",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Get Started"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((LotemHero_module_default()), "m_button-arrow"),
                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((LotemHero_module_default()), "right-pane-top-hero-lotem"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((LotemHero_module_default()), "logo-wrapper"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((LotemHero_module_default()), "lotem-hero-asset-tiny-text"),
                                                                        tag: "div",
                                                                        children: "Part of the monday product suite"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                        className: utils.cx((LotemHero_module_default()), "products-logos-wrapper"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LotemHero_module_default()), "ai-star-hero"),
                "data-w-id": "73127d56-7552-480d-8afa-9a64efea9c07",
                loading: "lazy",
                width: "auto",
                height: "auto",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((LotemHero_module_default()), "ai-star-hero-2"),
                "data-w-id": "73127d56-7552-480d-8afa-9a64efea9c08",
                loading: "lazy",
                width: "auto",
                height: "auto",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/Magic.module.css
var Magic_module = __webpack_require__(81374);
var Magic_module_default = /*#__PURE__*/__webpack_require__.n(Magic_module);
;// CONCATENATED MODULE: ./devlink/Magic.js
"use client";






var Magic_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-69"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-73"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107},"e-89":{"id":"e-89","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-50","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-90"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tag-test-2","originalId":"65f2ea7a9caa7a189c7fd1b9|1f266d1f-e888-3b22-a616-9508dd3571ac","appliesTo":"CLASS"},"targets":[{"selector":".tag-test-2","originalId":"65f2ea7a9caa7a189c7fd1b9|1f266d1f-e888-3b22-a616-9508dd3571ac","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1693382795674},"e-90":{"id":"e-90","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-51","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-89"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tag-test-2","originalId":"65f2ea7a9caa7a189c7fd1b9|1f266d1f-e888-3b22-a616-9508dd3571ac","appliesTo":"CLASS"},"targets":[{"selector":".tag-test-2","originalId":"65f2ea7a9caa7a189c7fd1b9|1f266d1f-e888-3b22-a616-9508dd3571ac","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1693382795674}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019},"a-50":{"id":"a-50","title":"--- hover 0n tags","actionItemGroups":[{"actionItems":[{"id":"a-50-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".hover-on-tag","selectorGuids":["eedb9b75-badf-3f53-acf0-1ae36a63e217"]},"yValue":-65,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1693382809899},"a-51":{"id":"a-51","title":"--- hover 0n tags 2","actionItemGroups":[{"actionItems":[{"id":"a-51-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"inOutQuart","duration":400,"target":{"useEventTarget":"CHILDREN","selector":".hover-on-tag","selectorGuids":["eedb9b75-badf-3f53-acf0-1ae36a63e217"]},"yValue":-150,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]},{"actionItems":[{"id":"a-51-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".hover-on-tag","selectorGuids":["eedb9b75-badf-3f53-acf0-1ae36a63e217"]},"yValue":0,"xUnit":"PX","yUnit":"%","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1693382809899}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Magic(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, runningPrompts = param.runningPrompts, _ctaText = param.ctaText, ctaText = _ctaText === void 0 ? "Get Started" : _ctaText, _mainHeadlineText = param.mainHeadlineText, mainHeadlineText = _mainHeadlineText === void 0 ? "Main headline" : _mainHeadlineText, _subHeadline = param.subHeadline, subHeadline = _subHeadline === void 0 ? "Sub headline" : _subHeadline, _tagsTitle = param.tagsTitle, tagsTitle = _tagsTitle === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Or start with a pre-built prompt:",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _tagsTitle, _tag1Text = param.tag1Text, tag1Text = _tag1Text === void 0 ? "Project Management" : _tag1Text, tag1Prompt = param.tag1Prompt, _tag1Visibility = param.tag1Visibility, tag1Visibility = _tag1Visibility === void 0 ? false : _tag1Visibility, _tag2Text = param.tag2Text, tag2Text = _tag2Text === void 0 ? "Project Management" : _tag2Text, tag2Prompt = param.tag2Prompt, _tag2Visibility = param.tag2Visibility, tag2Visibility = _tag2Visibility === void 0 ? false : _tag2Visibility, _tag3Text = param.tag3Text, tag3Text = _tag3Text === void 0 ? "Project Management" : _tag3Text, tag3Prompt = param.tag3Prompt, _tag3Visibility = param.tag3Visibility, tag3Visibility = _tag3Visibility === void 0 ? false : _tag3Visibility, _tag4Text = param.tag4Text, tag4Text = _tag4Text === void 0 ? "Project Management" : _tag4Text, tag4Prompt = param.tag4Prompt, _tag4Visibility = param.tag4Visibility, tag4Visibility = _tag4Visibility === void 0 ? false : _tag4Visibility, _tag5Text = param.tag5Text, tag5Text = _tag5Text === void 0 ? "Project Management" : _tag5Text, _tag5Visibility = param.tag5Visibility, tag5Visibility = _tag5Visibility === void 0 ? false : _tag5Visibility, tag5Prompt = param.tag5Prompt, _tag6Text = param.tag6Text, tag6Text = _tag6Text === void 0 ? "Project Management" : _tag6Text, tag6Prompt = param.tag6Prompt, _tag6Visibility = param.tag6Visibility, tag6Visibility = _tag6Visibility === void 0 ? false : _tag6Visibility, _tag7Text = param.tag7Text, tag7Text = _tag7Text === void 0 ? "Project Management" : _tag7Text, tag7Prompt = param.tag7Prompt, _tag7Visibility = param.tag7Visibility, tag7Visibility = _tag7Visibility === void 0 ? false : _tag7Visibility, _tag8Text = param.tag8Text, tag8Text = _tag8Text === void 0 ? "Project Management" : _tag8Text, tag8Prompt = param.tag8Prompt, _tag8Visibility = param.tag8Visibility, tag8Visibility = _tag8Visibility === void 0 ? false : _tag8Visibility, _tag9Text = param.tag9Text, tag9Text = _tag9Text === void 0 ? "Project Management" : _tag9Text, tag9Prompt = param.tag9Prompt, _tag9Visibility = param.tag9Visibility, tag9Visibility = _tag9Visibility === void 0 ? false : _tag9Visibility, _tag10Text = param.tag10Text, tag10Text = _tag10Text === void 0 ? "Project Management" : _tag10Text, tag10Prompt = param.tag10Prompt, _tag10Visibility = param.tag10Visibility, tag10Visibility = _tag10Visibility === void 0 ? false : _tag10Visibility, _tag11Text = param.tag11Text, tag11Text = _tag11Text === void 0 ? "Project Management" : _tag11Text, tag11Prompt = param.tag11Prompt, _tag11Visibility = param.tag11Visibility, tag11Visibility = _tag11Visibility === void 0 ? false : _tag11Visibility, _termOfService = param.termOfService, termOfService = _termOfService === void 0 ? {
        href: "#",
        target: "_blank"
    } : _termOfService, _termsAndConditions = param.termsAndConditions, termsAndConditions = _termsAndConditions === void 0 ? {
        href: "#",
        target: "_blank"
    } : _termsAndConditions, _privacyPolicy = param.privacyPolicy, privacyPolicy = _privacyPolicy === void 0 ? {
        href: "#",
        target: "_blank"
    } : _privacyPolicy, _variant = param.variant, variant = _variant === void 0 ? "Base" : _variant;
    interactions/* useInteractions */.NI(Magic_interactionsData, (Magic_module_default()));
    var _styleVariantMap = {
        Base: "",
        Purple: "w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da"
    };
    var _activeStyleVariant = _styleVariantMap[variant];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Magic_module_default()), "ap-gragient-sec", _activeStyleVariant),
        tag: "section",
        grid: {
            type: "section"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Magic_module_default()), "m_padding-global", "m_padding-section-small", _activeStyleVariant),
            tag: "div",
            "data-magic": "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((Magic_module_default()), "fw1_container-large", _activeStyleVariant),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((Magic_module_default()), "magic_hero-content", _activeStyleVariant),
                        tag: "div",
                        "data-selectable-tags-grid": "",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Magic_module_default()), "group_magic-top", _activeStyleVariant),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        className: utils.cx((Magic_module_default()), "magic_main-h", _activeStyleVariant),
                                        tag: "h1",
                                        children: mainHeadlineText
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((Magic_module_default()), "magic_sub-h", "length-1", _activeStyleVariant),
                                        children: subHeadline
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                        value: "%3Cstyle%3E%0A%5Bclass*%3D%22magic_prompt-parent%22%5D%20button%5Bdisabled%5D%20%7B%0A%20%20cursor%3A%20not-allowed%3B%0A%7D%0A%0A%0A%0A%5Bclass*%3D%22magic_textarea%22%5D%7B%0A%20%20resize%3A%20none%3B%0A%20%20user-select%3A%20none%3B%0A%20%20-webkit-user-drag%3A%20none%3B%0A%20%20border%3A%20none%3B%0A%7D%0A%0A%5Bclass*%3D%22magic-cb%22%5D%5Bclass*%3D%22is-active%22%5D%20%5Bclass*%3D%22magic-cb-inner%22%5D%7B%0Abackground-color%3A%20white%3B%0A%7D%0A%0A%5Bclass*%3D%22magic-cb%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20border-color%3A%20rgb(97%2C%2097%2C%20255)%3B%0A%20%20background-color%3A%20rgb(219%2C%20219%2C%20255)%3B%0A%20%20background-image%3A%20linear-gradient(90deg%2C%20rgb(255%2C%20204%2C%200)%2C%20rgb(253%2C%20171%2C%2061)%2020%25%2C%20rgb(255%2C%2090%2C%20196)%2050%25%2C%20rgb(157%2C%2080%2C%20221)%2075%25%2C%20rgb(0%2C%20202%2C%20114)%2090%25%2C%20rgb(102%2C%20204%2C%20255))%3B%0A%20%20box-shadow%3A%20rgba(0%2C%200%2C%200%2C%200.2)%200px%202px%205px%200px%3B%0A%20%20color%3A%20rgb(97%2C%2097%2C%20255)%3B%0A%7D%0A%0A%2F*%0A%5Bclass*%3D%22magic_textarea%22%5D%3A%3A-webkit-input-placeholder%20%7B%0A%20%20color%3A%20black%3B%0A%7D%0A%0A%5Bclass*%3D%22magic_textarea%22%5D%3A-moz-placeholder%20%7B%0A%20%20color%3A%20black%3B%0A%7D%0A%0A%5Bclass*%3D%22magic_textarea%22%5D%3A%3A-moz-placeholder%20%7B%0A%20%20color%3A%20black%3B%0A%7D%0A%0A%5Bclass*%3D%22magic_textarea%22%5D%3A-ms-input-placeholder%20%7B%0A%20%20color%3A%20black%3B%0A%7D%0A%0A%5Bclass*%3D%22magic_textarea%22%5D%3A%3Aplaceholder%20%7B%0A%20%20color%3A%20black%3B%0A%7D%0A*%2F%0A%0A%0A%3C%2Fstyle%3E"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic_prompt-parent", _activeStyleVariant),
                                        tag: "div",
                                        "data-magic-input-container": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic_prompt-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                        className: utils.cx((Magic_module_default()), "magic_textarea", _activeStyleVariant),
                                                        tag: "textarea",
                                                        placeholder: "What would you like to manage...",
                                                        id: "magicInput",
                                                        "data-magic-input": "",
                                                        "data-default-prompts": runningPrompts
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Magic_module_default()), "magic_button-parent", _activeStyleVariant),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((Magic_module_default()), "magic_disclaimer", _activeStyleVariant),
                                                                tag: "div",
                                                                children: [
                                                                    "By proceeding, you agree to monday.com’s ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                        className: utils.cx((Magic_module_default()), "magic_disclaimer-link", _activeStyleVariant),
                                                                        button: false,
                                                                        block: "",
                                                                        options: termOfService,
                                                                        children: "Terms of Service"
                                                                    }),
                                                                    ", monday AI ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                        className: utils.cx((Magic_module_default()), "magic_disclaimer-link", _activeStyleVariant),
                                                                        button: false,
                                                                        block: "",
                                                                        options: termsAndConditions,
                                                                        children: "Terms and Conditions"
                                                                    }),
                                                                    " and ",
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                        className: utils.cx((Magic_module_default()), "magic_disclaimer-link", _activeStyleVariant),
                                                                        button: false,
                                                                        block: "",
                                                                        options: privacyPolicy,
                                                                        children: "Privacy Policy"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                className: utils.cx((Magic_module_default()), "m_button", "for--magic", _activeStyleVariant),
                                                                tag: "button",
                                                                id: "magicButton",
                                                                "data-button-type": "magic",
                                                                "data-disabled-button": "",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        children: ctaText
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                        className: utils.cx((Magic_module_default()), "magic-btn-icon", _activeStyleVariant),
                                                                        width: "auto",
                                                                        height: "auto",
                                                                        loading: "lazy",
                                                                        alt: "",
                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6877f54beca467f50680b088_magic-btn-icon.svg"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((Magic_module_default()), "m_button-arrow", "for--magic", _activeStyleVariant),
                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Magic_module_default()), "magic-clear", _activeStyleVariant),
                                                tag: "button",
                                                id: "clearButton",
                                                "data-clear-button": "",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((Magic_module_default()), "magic-clear-icon", _activeStyleVariant),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "lazy",
                                                    alt: "",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6877f54beca467f50680b087_Close.svg"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                className: utils.cx((Magic_module_default()), "paragraph", _activeStyleVariant),
                                children: tagsTitle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Magic_module_default()), "spacer-1rem", _activeStyleVariant),
                                tag: "div"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((Magic_module_default()), "nagic_tags-wrap", _activeStyleVariant),
                                tag: "div",
                                children: [
                                    tag1Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag1Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag1Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag2Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag2Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag2Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag3Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag3Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag3Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag4Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag4Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag4Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag5Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag5Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag5Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag6Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag6Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag6Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag7Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag7Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag7Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag8Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag8Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag8Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag9Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag9Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag9Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag10Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag10Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag10Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null,
                                    tag11Visibility ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Magic_module_default()), "magic-cb", _activeStyleVariant),
                                        tag: "div",
                                        "data-tag-prompt": tag11Prompt,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "magic-cb-inner", _activeStyleVariant),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    "data-tag-text": "",
                                                    children: tag11Text
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Magic_module_default()), "hover-on-tag", _activeStyleVariant),
                                                tag: "div"
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        className: utils.cx((Magic_module_default()), "hero-star-1-2", _activeStyleVariant),
                        width: "auto",
                        height: "auto",
                        loading: "lazy",
                        alt: "",
                        src: "https://cdn.prod.website-files.com/63bd15a406b2101a5dbb3e8f/6874850bbcbc2bbd3b11392f_hp-star-1.svg"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                        className: utils.cx((Magic_module_default()), "hero-star-2-2", _activeStyleVariant),
                        width: "auto",
                        height: "auto",
                        loading: "lazy",
                        alt: "",
                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6877f54beca467f50680b089_hero-star2.png"
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/MondayDifference.module.css
var MondayDifference_module = __webpack_require__(46945);
var MondayDifference_module_default = /*#__PURE__*/__webpack_require__.n(MondayDifference_module);
;// CONCATENATED MODULE: ./devlink/MondayDifference.js
"use client";






var MondayDifference_interactionsData = JSON.parse('{"events":{"e-17":{"id":"e-17","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-13","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-18"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hp-difference-item","originalId":"c21a2de5-40c8-4872-5aa0-462f65097398","appliesTo":"CLASS"},"targets":[{"selector":".hp-difference-item","originalId":"c21a2de5-40c8-4872-5aa0-462f65097398","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1750231003171},"e-18":{"id":"e-18","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-14","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-17"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hp-difference-item","originalId":"c21a2de5-40c8-4872-5aa0-462f65097398","appliesTo":"CLASS"},"targets":[{"selector":".hp-difference-item","originalId":"c21a2de5-40c8-4872-5aa0-462f65097398","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1750231003171},"e-62":{"id":"e-62","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-41","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-63"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hp-difference-item","originalId":"685ced661b0756caa401e4a4|67f0e813-1c3c-d6c9-c4c2-db9a7f93015d","appliesTo":"CLASS"},"targets":[{"selector":".hp-difference-item","originalId":"685ced661b0756caa401e4a4|67f0e813-1c3c-d6c9-c4c2-db9a7f93015d","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752047542213},"e-63":{"id":"e-63","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-42","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-62"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hp-difference-item","originalId":"685ced661b0756caa401e4a4|67f0e813-1c3c-d6c9-c4c2-db9a7f93015d","appliesTo":"CLASS"},"targets":[{"selector":".hp-difference-item","originalId":"685ced661b0756caa401e4a4|67f0e813-1c3c-d6c9-c4c2-db9a7f93015d","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752047542213}},"actionLists":{"a-13":{"id":"a-13","title":"Flip to back","actionItemGroups":[{"actionItems":[{"id":"a-13-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-13-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]},{"actionItems":[{"id":"a-13-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutQuad","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":180,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-13-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutQuad","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":180,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750226272119},"a-14":{"id":"a-14","title":"Flip to back 2","actionItemGroups":[{"actionItems":[{"id":"a-14-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutCubic","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-14-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutCubic","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1750226272119},"a-41":{"id":"a-41","title":"Flip to back 3","actionItemGroups":[{"actionItems":[{"id":"a-41-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-41-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]},{"actionItems":[{"id":"a-41-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutQuad","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":180,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-41-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutQuad","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":180,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1750226272119},"a-42":{"id":"a-42","title":"Flip to back 4","actionItemGroups":[{"actionItems":[{"id":"a-42-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutCubic","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent","selectorGuids":["cec98320-d258-c31c-78f1-78a789182226"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}},{"id":"a-42-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"inOutCubic","duration":800,"target":{"useEventTarget":"CHILDREN","selector":".hp-difference-card-parent-small","selectorGuids":["13fb3653-b39e-236e-ce98-dc8731e4a278"]},"xValue":0,"xUnit":"deg","yUnit":"DEG","zUnit":"DEG"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1750226272119}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function MondayDifference(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? "The monday.com difference" : _title, _card1Title = param.card1Title, card1Title = _card1Title === void 0 ? "Flexible yet standardized" : _card1Title, _card1Text = param.card1Text, card1Text = _card1Text === void 0 ? "Build custom workflows with a no-code interface, while defining admin controls to maintain cross-org consistency." : _card1Text, _card2Title = param.card2Title, card2Title = _card2Title === void 0 ? "Products teams love to use" : _card2Title, _card2Text = param.card2Text, card2Text = _card2Text === void 0 ? "Onboard your entire organization with intuitive products they’ll love to use." : _card2Text, _card3Title = param.card3Title, card3Title = _card3Title === void 0 ? "Fast time to value" : _card3Title, _card3Text = param.card3Text, card3Text = _card3Text === void 0 ? "See value fast with products that are quick to implement and even easier to learn." : _card3Text, _card1Name = param.card1Name, card1Name = _card1Name === void 0 ? "" : _card1Name, _card1ClientTitle = param.card1ClientTitle, card1ClientTitle = _card1ClientTitle === void 0 ? "Senior Director of Product Innovation, Zippo" : _card1ClientTitle, _card2ClientTitle = param.card2ClientTitle, card2ClientTitle = _card2ClientTitle === void 0 ? "Global Client Solutions Director, Black Mountain" : _card2ClientTitle, _card3ClientTitle = param.card3ClientTitle, card3ClientTitle = _card3ClientTitle === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Director of Treasury, Citizens Bank",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _card3ClientTitle, _card2Name = param.card2Name, card2Name = _card2Name === void 0 ? "" : _card2Name, _card3Name = param.card3Name, card3Name = _card3Name === void 0 ? "" : _card3Name, _card1Testimonial = param.card1Testimonial, card1Testimonial = _card1Testimonial === void 0 ? ' It’ll take its shape and wrap around whatever you need it to do."' : _card1Testimonial, _card2Testimonial = param.card2Testimonial, card2Testimonial = _card2Testimonial === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            " Almost immediately, we hear ",
            ' and how much value it brings."'
        ]
    }) : _card2Testimonial, _card3Testimonial = param.card3Testimonial, card3Testimonial = _card3Testimonial === void 0 ? " It's like an iPhone in a way in that you just know how and what you want to do next.\"" : _card3Testimonial, _customer1Logo = param.customer1Logo, customer1Logo = _customer1Logo === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-1.png" : _customer1Logo, _customer2Logo = param.customer2Logo, customer2Logo = _customer2Logo === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-2.png" : _customer2Logo, _customer3Logo = param.customer3Logo, customer3Logo = _customer3Logo === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-3.png" : _customer3Logo, _customer1Headshot = param.customer1Headshot, customer1Headshot = _customer1Headshot === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-3.png" : _customer1Headshot, _customer2Headshot = param.customer2Headshot, customer2Headshot = _customer2Headshot === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-2.png" : _customer2Headshot, _customer3Headshot = param.customer3Headshot, customer3Headshot = _customer3Headshot === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-1.png" : _customer3Headshot;
    interactions/* useInteractions */.NI(MondayDifference_interactionsData, (MondayDifference_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((MondayDifference_module_default()), "sec-difference"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((MondayDifference_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((MondayDifference_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((MondayDifference_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((MondayDifference_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((MondayDifference_module_default()), "fw1_section-headline-parent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    className: utils.cx((MondayDifference_module_default()), "fw1_section-title"),
                                    tag: "h2",
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((MondayDifference_module_default()), "conp_hp-difference"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((MondayDifference_module_default()), "hp-difference-item"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent-small"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--sm"),
                                                    tag: "div",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((MondayDifference_module_default()), "hp_diff-vid"),
                                                        value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20autoplay%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1750596452%2F1_Flexible_yet_standardized.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1750596452%2F1_Flexible_yet_standardized.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1750596452%2F1_Flexible_yet_standardized.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front", "is--green", "is--child-1"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-number", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f6509739b-6509738e"),
                                                            tag: "div",
                                                            children: "6,970"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-sm-after-par", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f6509739d-6509738e"),
                                                            children: "hours saved per month"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--green"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-h", "is--black"),
                                                            tag: "div",
                                                            children: card1Title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-par", "is--short", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973b5-6509738e"),
                                                            children: card1Text
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-quote-parent"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((MondayDifference_module_default()), "group-diff-headshot"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            className: utils.cx((MondayDifference_module_default()), "hp_tab-bento-headshot"),
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: customer1Headshot,
                                                                            alt: "customer-headshot-1"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((MondayDifference_module_default()), "group-bento-headshot-data"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-name"),
                                                                                    tag: "div",
                                                                                    children: card1Name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-title"),
                                                                                    tag: "div",
                                                                                    children: card1ClientTitle
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                    className: utils.cx((MondayDifference_module_default()), "difference-after-quote"),
                                                                    children: card1Testimonial
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-logo-parent"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973b0-6509738e"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                className: utils.cx((MondayDifference_module_default()), "difference-after-logo"),
                                                                slot: "",
                                                                tag: "img",
                                                                src: customer1Logo,
                                                                alt: "customer-logo-1"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((MondayDifference_module_default()), "hp-difference-item"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--primary"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-h"),
                                                            tag: "div",
                                                            children: card2Title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-par"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973bc-6509738e"),
                                                            children: card2Text
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-quote-parent"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((MondayDifference_module_default()), "group-diff-headshot"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            className: utils.cx((MondayDifference_module_default()), "hp_tab-bento-headshot"),
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: customer2Headshot,
                                                                            alt: "customer-headshot-2"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((MondayDifference_module_default()), "group-bento-headshot-data"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-name"),
                                                                                    tag: "div",
                                                                                    children: card2Name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-title"),
                                                                                    tag: "div",
                                                                                    children: card2ClientTitle
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                    className: utils.cx((MondayDifference_module_default()), "difference-after-quote"),
                                                                    children: card2Testimonial
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-logo-parent"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973cc-6509738e"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                className: utils.cx((MondayDifference_module_default()), "difference-after-logo"),
                                                                slot: "",
                                                                tag: "img",
                                                                src: customer2Logo,
                                                                alt: "customer-logo-2"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent-small"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--sm"),
                                                    tag: "div",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((MondayDifference_module_default()), "hp_diff-vid"),
                                                        value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20autoplay%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751888837%2F2_Products_teams_love_to_use.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751888837%2F2_Products_teams_love_to_use.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1751888837%2F2_Products_teams_love_to_use.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front", "is--primary", "is-child-2"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-number"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973d0-6509738e"),
                                                            tag: "div",
                                                            children: "+15%"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-sm-after-par"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973d2-6509738e"),
                                                            children: "conversion rate increase"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((MondayDifference_module_default()), "hp-difference-item"),
                                    id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973d6-6509738e"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent-small"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--sm"),
                                                    tag: "div",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((MondayDifference_module_default()), "hp_diff-vid"),
                                                        value: "%3Cvideo%20class%3D%22hp-video%22%20width%3D%22100%25%22%20height%3D%22100%25%22%20playsinline%20autoplay%20muted%20loop%20poster%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1752492882%2F3_Fast_time_to_value_opt2.jpg%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1752492882%2F3_Fast_time_to_value_opt2.mp4%22%20type%3D%22video%2Fmp4%22%3E%0A%20%20%3Csource%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fvideo%2Fupload%2Fv1752492882%2F3_Fast_time_to_value_opt2.webm%22%20type%3D%22video%2Fwebm%22%3E%0AYour%20browser%20does%20not%20support%20the%20video%20tag.%0A%3C%2Fvideo%3E"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front", "is--pink", "is-child-3"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-number", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973d9-6509738e"),
                                                            tag: "div",
                                                            children: "28,000"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-sm-after-par", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973db-6509738e"),
                                                            children: "manual actions saved per month"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((MondayDifference_module_default()), "hp-difference-card-parent"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-back", "is--pink"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-h", "is--short", "is--black"),
                                                            tag: "div",
                                                            children: card3Title
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-before-par", "is--shorter", "is--black"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973e3-6509738e"),
                                                            children: card3Text
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((MondayDifference_module_default()), "difference-item-card-front"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-quote-parent"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((MondayDifference_module_default()), "group-diff-headshot"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                            className: utils.cx((MondayDifference_module_default()), "hp_tab-bento-headshot"),
                                                                            tag: "img",
                                                                            slot: "",
                                                                            src: customer3Headshot,
                                                                            alt: "customer-headshot-3"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((MondayDifference_module_default()), "group-bento-headshot-data"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-name"),
                                                                                    tag: "div",
                                                                                    children: card3Name
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((MondayDifference_module_default()), "quote-headshot-title"),
                                                                                    tag: "div",
                                                                                    children: card3ClientTitle
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                    className: utils.cx((MondayDifference_module_default()), "difference-after-quote"),
                                                                    children: card3Testimonial
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            className: utils.cx((MondayDifference_module_default()), "difference-after-logo-parent"),
                                                            id: utils.cx((MondayDifference_module_default()), "w-node-c21a2de5-40c8-4872-5aa0-462f650973f3-6509738e"),
                                                            tag: "div",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                className: utils.cx((MondayDifference_module_default()), "difference-after-logo"),
                                                                slot: "",
                                                                tag: "img",
                                                                src: customer3Logo,
                                                                alt: "customer-logo-3"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var src_define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./devlink/Products.module.css
var Products_module = __webpack_require__(62090);
var Products_module_default = /*#__PURE__*/__webpack_require__.n(Products_module);
;// CONCATENATED MODULE: ./devlink/Products.js
"use client";







var Products_interactionsData = JSON.parse('{"events":{"e-2":{"id":"e-2","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-2","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-111"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"},"targets":[{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749127407772},"e-3":{"id":"e-3","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-3","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-2"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"},"targets":[{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749127407772},"e-4":{"id":"e-4","name":"","animationType":"custom","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-4","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-110"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".ai-powered-tab-link","originalId":"684083d9882d1c433a4d9611|48fc067f-15c7-d1bc-55a7-22c0d8cdb766","appliesTo":"CLASS"},"targets":[{"selector":".ai-powered-tab-link","originalId":"684083d9882d1c433a4d9611|48fc067f-15c7-d1bc-55a7-22c0d8cdb766","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749130572242},"e-5":{"id":"e-5","name":"","animationType":"custom","eventTypeId":"TAB_INACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-5","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-108"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".ai-powered-tab-link","originalId":"684083d9882d1c433a4d9611|48fc067f-15c7-d1bc-55a7-22c0d8cdb766","appliesTo":"CLASS"},"targets":[{"selector":".ai-powered-tab-link","originalId":"684083d9882d1c433a4d9611|48fc067f-15c7-d1bc-55a7-22c0d8cdb766","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749130572242},"e-6":{"id":"e-6","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-6","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-7"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"},"targets":[{"selector":".ai-powered-card-parent","originalId":"684083d9882d1c433a4d9611|724fba1d-4165-cc28-7e45-4cf5e6e3643e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749143375123},"e-8":{"id":"e-8","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-9"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".close-modal-trigger","originalId":"684083d9882d1c433a4d9611|4da3a035-128d-c413-b933-9a052fadc92c","appliesTo":"CLASS"},"targets":[{"selector":".close-modal-trigger","originalId":"684083d9882d1c433a4d9611|4da3a035-128d-c413-b933-9a052fadc92c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749144084982},"e-10":{"id":"e-10","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-7","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-11"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".modal-close-icon","originalId":"684083d9882d1c433a4d9611|faa62c60-70b2-3d8e-9fa5-4d840e3b0763","appliesTo":"CLASS"},"targets":[{"selector":".modal-close-icon","originalId":"684083d9882d1c433a4d9611|faa62c60-70b2-3d8e-9fa5-4d840e3b0763","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1749147747207},"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-2":{"id":"a-2","title":"gradient-hover","actionItemGroups":[{"actionItems":[{"id":"a-2-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-gradient","selectorGuids":["07a256eb-c4ac-7953-e241-c2db7e76e040"]},"value":0,"unit":""}},{"id":"a-2-n-3","actionTypeId":"STYLE_BORDER","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-content","selectorGuids":["9571d615-938f-2def-e365-f20afe530bfb"]},"globalSwatchId":"--brand--border","rValue":208,"bValue":228,"gValue":212,"aValue":1}}]},{"actionItems":[{"id":"a-2-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-gradient","selectorGuids":["07a256eb-c4ac-7953-e241-c2db7e76e040"]},"value":1,"unit":""}},{"id":"a-2-n-4","actionTypeId":"STYLE_BORDER","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-content","selectorGuids":["9571d615-938f-2def-e365-f20afe530bfb"]},"globalSwatchId":"--brand--white","rValue":255,"bValue":255,"gValue":255,"aValue":1}}]}],"useFirstGroupAsInitialState":true,"createdOn":1749127419231},"a-3":{"id":"a-3","title":"gradient-hover-out","actionItemGroups":[{"actionItems":[{"id":"a-3-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-gradient","selectorGuids":["07a256eb-c4ac-7953-e241-c2db7e76e040"]},"value":0,"unit":""}},{"id":"a-3-n-3","actionTypeId":"STYLE_BORDER","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-card-content","selectorGuids":["9571d615-938f-2def-e365-f20afe530bfb"]},"globalSwatchId":"--brand--border","rValue":208,"bValue":228,"gValue":212,"aValue":1}}]}],"useFirstGroupAsInitialState":false,"createdOn":1749127419231},"a-4":{"id":"a-4","title":"ai-poered-tab-in","actionItemGroups":[{"actionItems":[{"id":"a-4-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"xValue":-1.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-4-n-7","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-body","selectorGuids":["5c718186-038c-a7f0-bbeb-424e4bc82231"]},"heightValue":0,"widthUnit":"PX","heightUnit":"rem","locked":false}},{"id":"a-4-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-h","selectorGuids":["5a2f80cc-b2f6-89fa-a3b0-017f5ceab10d"]},"xValue":-2.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-4-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-4-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-4-n-8","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-body","selectorGuids":["5c718186-038c-a7f0-bbeb-424e4bc82231"]},"widthUnit":"PX","heightUnit":"AUTO","locked":false}},{"id":"a-4-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"value":1,"unit":""}},{"id":"a-4-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-h","selectorGuids":["5a2f80cc-b2f6-89fa-a3b0-017f5ceab10d"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1749130581773},"a-5":{"id":"a-5","title":"ai-poered-tab-in 2","actionItemGroups":[{"actionItems":[{"id":"a-5-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"xValue":-1.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-5-n-8","actionTypeId":"STYLE_SIZE","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-body","selectorGuids":["5c718186-038c-a7f0-bbeb-424e4bc82231"]},"heightValue":0,"widthUnit":"PX","heightUnit":"px","locked":false}},{"id":"a-5-n-9","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-arrow","selectorGuids":["071dd4f1-1a18-9d39-5ed7-da79176850ff"]},"value":0,"unit":""}},{"id":"a-5-n-10","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-tab-h","selectorGuids":["5a2f80cc-b2f6-89fa-a3b0-017f5ceab10d"]},"xValue":-2.25,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1749130581773},"a-6":{"id":"a-6","title":"ai-powered-modal","actionItemGroups":[{"actionItems":[{"id":"a-6-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":"none"}},{"id":"a-6-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"yValue":3,"xUnit":"PX","yUnit":"rem","zUnit":"PX"}},{"id":"a-6-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-6-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"inOutCubic","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":"flex"}},{"id":"a-6-n-8","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"yValue":0,"xUnit":"PX","yUnit":"rem","zUnit":"PX"}},{"id":"a-6-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1749143398355},"a-7":{"id":"a-7","title":"ai-powered-modal-clode","actionItemGroups":[{"actionItems":[{"id":"a-7-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{"useEventTarget":"PARENT","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":0,"unit":""}},{"id":"a-7-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"PARENT","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"yValue":3,"xUnit":"PX","yUnit":"rem","zUnit":"PX"}}]},{"actionItems":[{"id":"a-7-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"PARENT","selector":".ai-powered-modal","selectorGuids":["517c7ef3-3988-cbb7-44e5-c509d7e660f6"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1749143398355},"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function Products(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Solve work challenges",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "with AI-first products"
        ]
    }) : _title, _wmText = param.wmText, wmText = _wmText === void 0 ? "Drive projects and processes forward with AI insights" : _wmText, _wmButtonText = param.wmButtonText, wmButtonText = _wmButtonText === void 0 ? "Learn more" : _wmButtonText, _crmText = param.crmText, crmText = _crmText === void 0 ? "Automate full customer journeys with AI actions" : _crmText, _crmButtonText = param.crmButtonText, crmButtonText = _crmButtonText === void 0 ? "Learn more" : _crmButtonText, _devText = param.devText, devText = _devText === void 0 ? "Ship quality software with AI-guided sprints" : _devText, _devButtonText = param.devButtonText, devButtonText = _devButtonText === void 0 ? "Learn more" : _devButtonText, _servText = param.servText, servText = _servText === void 0 ? "Deliver standout service with AI ticket handling" : _servText, _servButtonText = param.servButtonText, servButtonText = _servButtonText === void 0 ? "Learn more" : _servButtonText, _wmTitle = param.wmTitle, wmTitle = _wmTitle === void 0 ? "Drive projects and processes forward with AI insights" : _wmTitle, _wmBold1 = param.wmBold1, wmBold1 = _wmBold1 === void 0 ? "AI-powered risk identification" : _wmBold1, _wmBold2 = param.wmBold2, wmBold2 = _wmBold2 === void 0 ? "Project and portfolio management" : _wmBold2, _wmBold3 = param.wmBold3, wmBold3 = _wmBold3 === void 0 ? "Resource management" : _wmBold3, _wmText1 = param.wmText1, wmText1 = _wmText1 === void 0 ? "Use AI to flag risks early to make informed decisions across your entire portfolio." : _wmText1, _wmText2 = param.wmText2, wmText2 = _wmText2 === void 0 ? "Gain visibility into risks and dependencies to ensure fast and precise project delivery." : _wmText2, _wmText3 = param.wmText3, wmText3 = _wmText3 === void 0 ? "Use AI to assign the right people to every project based on skills, availability, and real-time capacity." : _wmText3, _wmLink = param.wmLink, wmLink = _wmLink === void 0 ? {
        href: "#"
    } : _wmLink, _crmTitle = param.crmTitle, crmTitle = _crmTitle === void 0 ? "Automate full customer journeys with AI actions" : _crmTitle, _crmBold1 = param.crmBold1, crmBold1 = _crmBold1 === void 0 ? "AI deal prioritization" : _crmBold1, _crmBold2 = param.crmBold2, crmBold2 = _crmBold2 === void 0 ? "Connected communication" : _crmBold2, _crmBold3 = param.crmBold3, crmBold3 = _crmBold3 === void 0 ? "Post-sales & account management" : _crmBold3, _crmText1 = param.crmText1, crmText1 = _crmText1 === void 0 ? "Score deal health and close probability with monday CRM, so teams can focus on converting." : _crmText1, _crmText2 = param.crmText2, crmText2 = _crmText2 === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Centralize outreach, lead activity, and performance analytics, so nothing falls through the cracks.",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _crmText2, _crmText3 = param.crmText3, crmText3 = _crmText3 === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Monitor account health, communicate and engage",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "with clients to nurture key relationships."
        ]
    }) : _crmText3, _crmPopupButtonText = param.crmPopupButtonText, crmPopupButtonText = _crmPopupButtonText === void 0 ? "Get Started" : _crmPopupButtonText, _crmLink = param.crmLink, crmLink = _crmLink === void 0 ? {
        href: "#"
    } : _crmLink, _devTitle = param.devTitle, devTitle = _devTitle === void 0 ? "Ship quality software with AI-guided sprints" : _devTitle, _devBold1 = param.devBold1, devBold1 = _devBold1 === void 0 ? "AI developer assistance" : _devBold1, _devBold2 = param.devBold2, devBold2 = _devBold2 === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Multi-method execution",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
        ]
    }) : _devBold2, _devBold3 = param.devBold3, devBold3 = _devBold3 === void 0 ? "Agile insights" : _devBold3, _devText1 = param.devText1, devText1 = _devText1 === void 0 ? "Resolve bugs and incidents faster with AI-surfaced context on related code, tasks, and documentation." : _devText1, _devText2 = param.devText2, devText2 = _devText2 === void 0 ? "Run sprints with Scrum, Kanban, or hybrid methods to move faster without admin blocks." : _devText2, _devText3 = param.devText3, devText3 = _devText3 === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Get real-time metrics like cycle time and sprint",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "velocity to ensure predictable delivery."
        ]
    }) : _devText3, _devPopupButtonText = param.devPopupButtonText, devPopupButtonText = _devPopupButtonText === void 0 ? "Get Started" : _devPopupButtonText, _devLink = param.devLink, devLink = _devLink === void 0 ? {
        href: "#"
    } : _devLink, _servTitle = param.servTitle, servTitle = _servTitle === void 0 ? "Deliver standout service with AI ticket handling" : _servTitle, _servBold1 = param.servBold1, servBold1 = _servBold1 === void 0 ? "AI ticket triage" : _servBold1, _servBold2 = param.servBold2, servBold2 = _servBold2 === void 0 ? "AI ticket resolutions" : _servBold2, _servBold3 = param.servBold3, servBold3 = _servBold3 === void 0 ? "Customer portal" : _servBold3, _servText3 = param.servText3, servText3 = _servText3 === void 0 ? "Launch a dynamic portal for users to submit requests, track tickets, and access self-serve resources." : _servText3, _servText2 = param.servText2, servText2 = _servText2 === void 0 ? "Resolve repetitive requests instantly with AI-powered auto-replies based on past cases." : _servText2, _servText1 = param.servText1, servText1 = _servText1 === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Automatically categorize, prioritize, and route tickets",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "with AI to speed up resolution times."
        ]
    }) : _servText1, _svcPopupButtonText = param.svcPopupButtonText, svcPopupButtonText = _svcPopupButtonText === void 0 ? "Get Started" : _svcPopupButtonText, _servLink = param.servLink, servLink = _servLink === void 0 ? {
        href: "#"
    } : _servLink, _tag1 = param.tag1, tag1 = _tag1 === void 0 ? "Sales" : _tag1, _tag2 = param.tag2, tag2 = _tag2 === void 0 ? "Engineering" : _tag2, _tag3 = param.tag3, tag3 = _tag3 === void 0 ? "IT" : _tag3, _tag4 = param.tag4, tag4 = _tag4 === void 0 ? "Marketing" : _tag4, _subTitle = param.subTitle, subTitle = _subTitle === void 0 ? "Each product solves departmental needs, and together, they power seamless operations across your organization." : _subTitle, _blackButtonText = param.blackButtonText, blackButtonText = _blackButtonText === void 0 ? "Get Started" : _blackButtonText, _whitebuttonText = param.whitebuttonText, whitebuttonText = _whitebuttonText === void 0 ? "Request a demo" : _whitebuttonText, _blackButtonLink = param.blackButtonLink, blackButtonLink = _blackButtonLink === void 0 ? {
        href: "#"
    } : _blackButtonLink, _whiteButtonLink = param.whiteButtonLink, whiteButtonLink = _whiteButtonLink === void 0 ? {
        href: "/sales/contact-us"
    } : _whiteButtonLink, _wmPopupButtonText = param.wmPopupButtonText, wmPopupButtonText = _wmPopupButtonText === void 0 ? "Get Started" : _wmPopupButtonText, _wmPopupTab1Image = param.wmPopupTab1Image, wmPopupTab1Image = _wmPopupTab1Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/ai-powered-risk-identification-v2.avif" : _wmPopupTab1Image, _crmPopupTab3Image = param.crmPopupTab3Image, crmPopupTab3Image = _crmPopupTab3Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Post-sales_account_management.avif" : _crmPopupTab3Image, _crmPopupTab2Image = param.crmPopupTab2Image, crmPopupTab2Image = _crmPopupTab2Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Connected_communication.avif" : _crmPopupTab2Image, _crmPopupTab1Image = param.crmPopupTab1Image, crmPopupTab1Image = _crmPopupTab1Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/AI_deal_prioritization.avif" : _crmPopupTab1Image, _wmPopupTab2Image = param.wmPopupTab2Image, wmPopupTab2Image = _wmPopupTab2Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751885711/Generator_featured%20images/hp-2025/products/popup-assets/Project_and_portfolio_management-v3-.avif" : _wmPopupTab2Image, _wmPopupTab3Image = param.wmPopupTab3Image, wmPopupTab3Image = _wmPopupTab3Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751538698/Generator_featured%20images/hp-2025/products/popup-assets/resource-managment-v4.avif" : _wmPopupTab3Image, _devPopupTab1Image = param.devPopupTab1Image, devPopupTab1Image = _devPopupTab1Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/AI_developer_assistant.avif" : _devPopupTab1Image, _devPopupTab2Image = param.devPopupTab2Image, devPopupTab2Image = _devPopupTab2Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Sprint_management.avif" : _devPopupTab2Image, _devPopupTab3Image = param.devPopupTab3Image, devPopupTab3Image = _devPopupTab3Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Agile_insights.avif" : _devPopupTab3Image, _svcPopupTab1Image = param.svcPopupTab1Image, svcPopupTab1Image = _svcPopupTab1Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/triage-v2.avif" : _svcPopupTab1Image, _svcPopupTab2Image = param.svcPopupTab2Image, svcPopupTab2Image = _svcPopupTab2Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751885866/Generator_featured%20images/hp-2025/products/popup-assets/AI_ticket_resolutions-v2.avif" : _svcPopupTab2Image, _svcPopupTab3Image = param.svcPopupTab3Image, svcPopupTab3Image = _svcPopupTab3Image === void 0 ? "https://dapulse-res.cloudinary.com/image/upload/v1751528122/Generator_featured%20images/hp-2025/products/Customer_portal.avif" : _svcPopupTab3Image;
    interactions/* useInteractions */.NI(Products_interactionsData, (Products_module_default()));
    var _obj, _obj1, _obj2, _obj3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Products_module_default()), "sec-products"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Products_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Products_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((Products_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((Products_module_default()), "group_sec-h-sbs"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((Products_module_default()), "sec-h-sbs-start"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                        className: utils.cx((Products_module_default()), "fw1_section-title", "is--short"),
                                        tag: "h2",
                                        children: title
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Products_module_default()), "sec-h-sbs-end"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                            className: utils.cx((Products_module_default()), "sec-h-sbs-par"),
                                            children: subTitle
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Products_module_default()), "fw1_button-combo"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                    className: utils.cx((Products_module_default()), "m_button"),
                                                    id: utils.cx((Products_module_default()), "w-node-cf2d881b-657f-37eb-bd70-d4947c946ebe-7c946eb0"),
                                                    button: false,
                                                    "data-button-type": "signup",
                                                    block: "inline",
                                                    options: blackButtonLink,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: blackButtonText
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                            className: utils.cx((Products_module_default()), "m_button-arrow"),
                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                    className: utils.cx((Products_module_default()), "m_button-outline"),
                                                    id: utils.cx((Products_module_default()), "w-node-cf2d881b-657f-37eb-bd70-d4947c946ec2-7c946eb0"),
                                                    button: false,
                                                    "data-button-type": "homepage-contact-sales",
                                                    block: "inline",
                                                    options: whiteButtonLink,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        tag: "div",
                                                        children: whitebuttonText
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                            className: utils.cx((Products_module_default()), "comp_ai-powered"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, (_obj = {
                                    className: utils.cx((Products_module_default()), "ai-powered-card-parent"),
                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be6f0-7c946eb0"),
                                    tag: "button",
                                    slot: ""
                                }, (0,src_define_property/* default */.Z)(_obj, "id", ""), (0,src_define_property/* default */.Z)(_obj, "data-button-type", "secondary"), (0,src_define_property/* default */.Z)(_obj, "data-event-identifier", "work-management"), (0,src_define_property/* default */.Z)(_obj, "children", [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-gradient"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Products_module_default()), "ai-powered-product-logo"),
                                                tag: "img",
                                                slot: "",
                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749146340/growth-marketing/web-experience/hp-jun-25/WM-2liner-black.png"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-card-text"),
                                                tag: "div",
                                                children: wmText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "m_button-link", "push-to-bottom"),
                                                tag: "div",
                                                children: wmButtonText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-modal"),
                                        tag: "div",
                                        "aria-modal": "true",
                                        role: "dialog",
                                        "aria-labelledby": "modal-wm-title",
                                        id: "modal-wm",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "close-modal-trigger"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-modal-content"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-product-modal-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685266a3dea23640529c527d_WM-oneliner-box%20(2).svg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-h"),
                                                                tag: "div",
                                                                children: wmTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-bottom"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-tabs"),
                                                                "data-tabs": "",
                                                                current: "Resource management",
                                                                easing: "ease",
                                                                fadeIn: 300,
                                                                fadeOut: 100,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-menu"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "AI-powered risk identification",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: wmBold1
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par", "ch-option-1"),
                                                                                            children: wmText1
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Project and portfolio management",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: wmBold2
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par", "ch-option-2"),
                                                                                            children: wmText2
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link", "last--child"),
                                                                                "data-w-tab": "Resource management",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: wmBold3
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par", "ch-option-2"),
                                                                                            children: wmText3
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-content"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "AI-powered risk identification",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: wmPopupTab1Image,
                                                                                        alt: "AI-powered risk identification"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Project and portfolio management",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: wmPopupTab2Image,
                                                                                        alt: "Project and portfolio management"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Resource management",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: wmPopupTab3Image,
                                                                                        alt: "Resource management"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "popup-btn-parent"),
                                                                id: utils.cx((Products_module_default()), "w-node-_8b01caa0-89de-ef3b-dafc-52ade8070e76-7c946eb0"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((Products_module_default()), "m_button", "m_button-primary"),
                                                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be722-7c946eb0"),
                                                                    button: false,
                                                                    "data-button-type": "signup",
                                                                    "data-product-id": "work-management",
                                                                    block: "inline",
                                                                    options: wmLink,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: wmPopupButtonText
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((Products_module_default()), "m_button-arrow"),
                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Products_module_default()), "modal-close-icon"),
                                                        tag: "div",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": "Close modal",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            loading: "lazy",
                                                            width: "auto",
                                                            height: "auto",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6841dfec75f02f43993a4574_Close.svg"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]), _obj)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, (_obj1 = {
                                    className: utils.cx((Products_module_default()), "ai-powered-card-parent"),
                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be728-7c946eb0"),
                                    tag: "button",
                                    slot: ""
                                }, (0,src_define_property/* default */.Z)(_obj1, "id", ""), (0,src_define_property/* default */.Z)(_obj1, "data-button-type", "secondary"), (0,src_define_property/* default */.Z)(_obj1, "data-event-identifier", "crm"), (0,src_define_property/* default */.Z)(_obj1, "children", [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-gradient"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Products_module_default()), "ai-powered-product-logo"),
                                                tag: "img",
                                                slot: "",
                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749646353/Generator_featured%20images/Webflow/CRM-logo-2-lines.avif"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-card-text"),
                                                tag: "div",
                                                children: crmText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "m_button-link", "push-to-bottom"),
                                                tag: "div",
                                                children: crmButtonText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-modal"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "close-modal-trigger"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-modal-content"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-product-modal-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68593d05905f3f396feec910_CRM-oneliner-box.svg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-h"),
                                                                tag: "div",
                                                                children: crmTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-bottom"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-tabs"),
                                                                "data-tabs": "",
                                                                current: "Tab 1",
                                                                easing: "ease",
                                                                fadeIn: 300,
                                                                fadeOut: 100,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-menu"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Tab 1",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: crmBold1
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par", "ch-option-3"),
                                                                                            children: crmText1
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Tab 2",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: crmBold2
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: crmText2
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link", "last--child"),
                                                                                "data-w-tab": "Tab 3",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: crmBold3
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: crmText3
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-content", "for--crm"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent", "is--crm"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 1",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: crmPopupTab1Image,
                                                                                        alt: "AI deal prioritization"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: crmPopupTab2Image,
                                                                                        alt: "Connected communication"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 3",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: crmPopupTab3Image,
                                                                                        alt: "Post-sales & account management"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "popup-btn-parent"),
                                                                id: utils.cx((Products_module_default()), "w-node-bc2ce7a2-ee27-55be-e04a-11cc37ce6c7c-7c946eb0"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((Products_module_default()), "m_button", "m_button-crm"),
                                                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be75a-7c946eb0"),
                                                                    button: false,
                                                                    "data-button-type": "signup",
                                                                    "data-product-id": "crm",
                                                                    block: "inline",
                                                                    options: crmLink,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: crmPopupButtonText
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((Products_module_default()), "m_button-arrow"),
                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Products_module_default()), "modal-close-icon"),
                                                        tag: "div",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": "Close modal",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            loading: "lazy",
                                                            width: "auto",
                                                            height: "auto",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6841dfec75f02f43993a4574_Close.svg"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]), _obj1)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Products_module_default()), "comp_ai-powered-img-parent"),
                                    id: utils.cx((Products_module_default()), "w-node-_53f028b6-b1c8-5885-6d49-c4ac62b4ff88-7c946eb0"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((Products_module_default()), "comp_ai-powered-img"),
                                            id: utils.cx((Products_module_default()), "w-node-_6fe3afdd-fe16-05b3-6cd1-68686862e69d-7c946eb0"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1751790795/Generator_featured%20images/hp-2025/products/products-main-img.png"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Products_module_default()), "ai-powered-label", "is--sales"),
                                            tag: "div",
                                            children: tag1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Products_module_default()), "ai-powered-label", "is--engeeniring"),
                                            tag: "div",
                                            children: tag2
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Products_module_default()), "ai-powered-label", "is--it"),
                                            tag: "div",
                                            children: tag3
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Products_module_default()), "ai-powered-label", "is--marketing"),
                                            tag: "div",
                                            children: tag4
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, (_obj2 = {
                                    className: utils.cx((Products_module_default()), "ai-powered-card-parent"),
                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be761-7c946eb0"),
                                    tag: "button",
                                    slot: ""
                                }, (0,src_define_property/* default */.Z)(_obj2, "id", ""), (0,src_define_property/* default */.Z)(_obj2, "data-button-type", "secondary"), (0,src_define_property/* default */.Z)(_obj2, "data-event-identifier", "dev"), (0,src_define_property/* default */.Z)(_obj2, "children", [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-gradient"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Products_module_default()), "ai-powered-product-logo"),
                                                tag: "img",
                                                slot: "",
                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749646353/Generator_featured%20images/Webflow/DEV-logo-2-lines.avif"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-card-text", "is--short"),
                                                tag: "div",
                                                children: devText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "m_button-link", "push-to-bottom"),
                                                tag: "div",
                                                children: devButtonText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-modal"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "close-modal-trigger"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-modal-content"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-product-modal-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68593cbc856fdce412fc318e_DEV-oneliner-box.svg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-h"),
                                                                tag: "div",
                                                                children: devTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-bottom"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-tabs"),
                                                                "data-tabs": "",
                                                                current: "Tab 2",
                                                                easing: "ease",
                                                                fadeIn: 300,
                                                                fadeOut: 100,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-menu"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Tab 3",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: devBold1
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: devText1
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Tab 1",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: devBold2
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: devText2
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Tab 2",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: devBold3
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: devText3
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-content", "for--dev"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 3",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: devPopupTab1Image,
                                                                                        alt: "AI developer assistant"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 1",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: devPopupTab2Image,
                                                                                        alt: "Sprint management"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Tab 2",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: devPopupTab3Image,
                                                                                        alt: "Agile insights"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "popup-btn-parent"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((Products_module_default()), "m_button", "m_button-dev"),
                                                                    id: utils.cx((Products_module_default()), "w-node-_8020e102-67aa-5ef2-df13-b91c8b1a2b0b-7c946eb0"),
                                                                    button: false,
                                                                    "data-button-type": "signup",
                                                                    "data-product-id": "dev",
                                                                    block: "inline",
                                                                    options: devLink,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: devPopupButtonText
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((Products_module_default()), "m_button-arrow"),
                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Products_module_default()), "modal-close-icon"),
                                                        tag: "div",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": "Close modal",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            loading: "lazy",
                                                            width: "auto",
                                                            height: "auto",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6841dfec75f02f43993a4574_Close.svg"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]), _obj2)),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, (_obj3 = {
                                    className: utils.cx((Products_module_default()), "ai-powered-card-parent"),
                                    id: utils.cx((Products_module_default()), "w-node-_7b1e2cad-e967-be08-6698-cc19ff5be799-7c946eb0"),
                                    tag: "button",
                                    slot: ""
                                }, (0,src_define_property/* default */.Z)(_obj3, "id", ""), (0,src_define_property/* default */.Z)(_obj3, "data-button-type", "secondary"), (0,src_define_property/* default */.Z)(_obj3, "data-event-identifier", "service"), (0,src_define_property/* default */.Z)(_obj3, "children", [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-gradient"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-card-content"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Products_module_default()), "ai-powered-product-logo"),
                                                tag: "img",
                                                slot: "",
                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749646353/Generator_featured%20images/Webflow/SVC-logo-2-lines.avif"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-card-text"),
                                                tag: "div",
                                                children: servText
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "m_button-link", "push-to-bottom"),
                                                tag: "div",
                                                children: servButtonText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((Products_module_default()), "ai-powered-modal"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((Products_module_default()), "close-modal-trigger"),
                                                tag: "div"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((Products_module_default()), "ai-powered-modal-content"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-top"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-product-modal-logo"),
                                                                loading: "lazy",
                                                                width: "auto",
                                                                height: "auto",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68593beefe69a3ac564dd445_SVC-oneliner-box.svg"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-h"),
                                                                tag: "div",
                                                                children: servTitle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-bottom"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-tabs"),
                                                                "data-tabs": "",
                                                                current: "AI ticket triage",
                                                                easing: "ease",
                                                                fadeIn: 300,
                                                                fadeOut: 100,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-menu"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "AI ticket triage",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: servBold1
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: servText1
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "AI ticket resolutions",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: servBold2
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: servText2
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-link"),
                                                                                "data-w-tab": "Customer portal",
                                                                                block: "inline",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-header"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-arrow"),
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68419c2d121e4de1c640535e_arrow-right-7.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                className: utils.cx((Products_module_default()), "ai-powered-tab-h"),
                                                                                                tag: "div",
                                                                                                children: servBold3
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((Products_module_default()), "ai-powered-tab-body"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                                                            className: utils.cx((Products_module_default()), "ai-powered-tab-par"),
                                                                                            children: servText3
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                                        className: utils.cx((Products_module_default()), "ai-powered-modal-tab-content", "for--svc"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "AI ticket triage",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: svcPopupTab1Image,
                                                                                        alt: "AI-powered risk identification"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "AI ticket resolutions",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: svcPopupTab2Image,
                                                                                        alt: "AI-powered risk identification"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                                                className: utils.cx((Products_module_default()), "ai-powered-modal-img-parent"),
                                                                                tag: "div",
                                                                                "data-w-tab": "Customer portal",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((Products_module_default()), "product_acc-img-parent"),
                                                                                    tag: "div",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                                                        className: utils.cx((Products_module_default()), "product_acc-img"),
                                                                                        tag: "img",
                                                                                        slot: "",
                                                                                        src: svcPopupTab3Image,
                                                                                        alt: "AI-powered risk identification"
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                className: utils.cx((Products_module_default()), "popup-btn-parent"),
                                                                id: utils.cx((Products_module_default()), "w-node-d8a64295-5013-1751-e509-9f790321a065-7c946eb0"),
                                                                tag: "div",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((Products_module_default()), "m_button"),
                                                                    id: utils.cx((Products_module_default()), "w-node-f126183e-c5c8-5d35-05e8-2994c0106aa2-7c946eb0"),
                                                                    button: false,
                                                                    "data-button-type": "signup",
                                                                    "data-product-id": "service",
                                                                    block: "inline",
                                                                    options: servLink,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: svcPopupButtonText
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((Products_module_default()), "m_button-arrow"),
                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Products_module_default()), "modal-close-icon"),
                                                        tag: "div",
                                                        role: "button",
                                                        tabIndex: "0",
                                                        "aria-label": "Close modal",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((Products_module_default()), "modal-close-img"),
                                                            loading: "lazy",
                                                            width: "auto",
                                                            height: "auto",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6841dfec75f02f43993a4574_Close.svg"
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]), _obj3))
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/Security.module.css
var Security_module = __webpack_require__(57343);
var Security_module_default = /*#__PURE__*/__webpack_require__.n(Security_module);
;// CONCATENATED MODULE: ./devlink/Security.js
"use client";





function Security(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _title = param.title, title = _title === void 0 ? "Enterprise-grade security" : _title, _text = param.text, text = _text === void 0 ? "Keep your company's data secure and compliant with industry-leading security standards and certifications." : _text, _linktext = param.linktext, linktext = _linktext === void 0 ? "Explore our Trust Center" : _linktext, _link = param.link, link = _link === void 0 ? {
        href: "https://monday.com/trustcenter",
        target: "_blank"
    } : _link;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Security_module_default()), "sec-security"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Security_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Security_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((Security_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((Security_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Security_module_default()), "fw1_section-headline-parent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    className: utils.cx((Security_module_default()), "fw1_section-title"),
                                    tag: "h2",
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((Security_module_default()), "comp_hp-security"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Security_module_default()), "group_security-logos"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((Security_module_default()), "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749471604/growth-marketing/web-experience/hp-jun-25/security/logo-gdpr.png",
                                            alt: "logo GDPR"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((Security_module_default()), "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472274/growth-marketing/web-experience/hp-jun-25/security/logo-soc2-v2.png",
                                            alt: "logo soc2"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((Security_module_default()), "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472155/growth-marketing/web-experience/hp-jun-25/security/logo-iso-27001.png",
                                            alt: "logo iso"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                            className: utils.cx((Security_module_default()), "hp_security-logo"),
                                            tag: "img",
                                            slot: "",
                                            src: "https://dapulse-res.cloudinary.com/image/upload/v1749472267/growth-marketing/web-experience/hp-jun-25/security/logo-hipaa-v2.png",
                                            alt: "logo hipaa"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Security_module_default()), "group_security-content"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                            className: utils.cx((Security_module_default()), "security-content-par"),
                                            children: text
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                            className: utils.cx((Security_module_default()), "m_button-link"),
                                            button: false,
                                            block: "inline",
                                            options: link,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    tag: "div",
                                                    children: linktext
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                    className: utils.cx((Security_module_default()), "m_button-arrow"),
                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                    className: utils.cx((Security_module_default()), "m_link-underline"),
                                                    tag: "div"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/ShorterHero1.module.css
var ShorterHero1_module = __webpack_require__(81819);
var ShorterHero1_module_default = /*#__PURE__*/__webpack_require__.n(ShorterHero1_module);
;// CONCATENATED MODULE: ./devlink/ShorterHero1.js
"use client";






var ShorterHero1_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function ShorterHero1(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp;
    interactions/* useInteractions */.NI(ShorterHero1_interactionsData, (ShorterHero1_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((ShorterHero1_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((ShorterHero1_module_default()), "m_padding-global"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((ShorterHero1_module_default()), "group_hero-center-all"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((ShorterHero1_module_default()), "m_hero-title-parent"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    className: utils.cx((ShorterHero1_module_default()), "fw1_hero-title-black-lotem"),
                                    tag: "h1",
                                    children: [
                                        "One AI work platform",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "for any kind of work"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "subtitle-white-test-max-width"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((ShorterHero1_module_default()), "fw2_hero-sub-black"),
                                        children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "m_spacer-1rem"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                    tag: "div",
                                    children: [
                                        "No credit card needed ✦ Unlimited time on Free plan",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                    tag: "div"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((ShorterHero1_module_default()), "m_container-xlarge"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero1_module_default()), "opening-question-2"),
                                    tag: "div",
                                    children: "Where would you like to start?"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tabs-holder"),
                                    current: "projects",
                                    easing: "ease-in",
                                    fadeIn: 300,
                                    fadeOut: 100,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                            className: utils.cx((ShorterHero1_module_default()), "tabs-group-lotem-hero-wide-2"),
                                            tag: "div",
                                            "data-hero-tabs": "",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-1"),
                                                    "data-w-tab": "projects",
                                                    "data-tab": "",
                                                    "data-tag-theme": "projects",
                                                    "data-cluster": "projects",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd01ef32bc74f8d96a3_project-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Projects"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-2"),
                                                    "data-w-tab": "marketing",
                                                    "data-tab": "",
                                                    "data-tag-theme": "marketing",
                                                    "data-cluster": "marketing",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0c0ed5b52de6b3220_marketing-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Marketing"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-3"),
                                                    "data-w-tab": "sales",
                                                    "data-tab": "",
                                                    "data-tag-theme": "sales",
                                                    "data-tab-product": "crm",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0bbd92df017e31365_sales-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Sales"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-4"),
                                                    "data-w-tab": "operations",
                                                    "data-tab": "",
                                                    "data-tag-theme": "operations",
                                                    "data-cluster": "operations",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd04641d45e8f5aa26a_ops-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Operations"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-5"),
                                                    "data-w-tab": "software",
                                                    "data-tab": "",
                                                    "data-tag-theme": "software",
                                                    "data-tab-product": "dev",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd03d01ce5331f60d62_dev-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Software"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                    className: utils.cx((ShorterHero1_module_default()), "short-hero-tab", "short-hero-tab-6"),
                                                    "data-w-tab": "support and it",
                                                    "data-tab": "",
                                                    "data-tag-theme": "it",
                                                    "data-tab-product": "service",
                                                    "data-tab-scroll-target": "tab-pane",
                                                    block: "inline",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                            className: utils.cx((ShorterHero1_module_default()), "short-thumbnail-tab-image"),
                                                            width: "auto",
                                                            height: "auto",
                                                            loading: "lazy",
                                                            alt: "",
                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0300c7fa50d3388b2_it-thumbnail-tabshort-hero.png"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                            tag: "div",
                                                            children: "Support & IT"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                            className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-content"),
                                            tag: "div",
                                            id: "tab-pane",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "projects",
                                                    id: "Projects",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6908856099898eaef22fd9e2_updated-content-Projects.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            href: "",
                                                                                            "data-cluster": "product_management",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "marketing",
                                                    id: "Marketing",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3f19283a6c0d361de_Marketinglotem-hero.webp"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            href: "",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            "data-product-id": "marketing",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "sales",
                                                    id: "Sales",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3502474988301a736_Saleslotem-hero.webp"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            href: "",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            "data-product-id": "crm",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "operations",
                                                    id: "Operations",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69088560a79c99471cd9ce48_updated-content-Operations.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            href: "",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            "data-product-id": "operations",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "software",
                                                    id: "Software",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d36d671f8ef1c70f37_Softwarelotem-hero.webp"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            href: "",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            "data-product-id": "dev",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-tab-pane"),
                                                    tag: "div",
                                                    "data-w-tab": "support and it",
                                                    id: "Support",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-flexbox"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero1_module_default()), "asset-image-lotem-hero"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "eager",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3eeb3cfcdc11f09b9_ITlotem-hero.webp"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((ShorterHero1_module_default()), "right-pane-lotem-hero-shorter"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Recommended product"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "logo-svg"),
                                                                                        width: "auto",
                                                                                        height: "auto",
                                                                                        loading: "lazy",
                                                                                        alt: "",
                                                                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "m_spacer-2rem"),
                                                                                tag: "div"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-info-text"),
                                                                                        tag: "div",
                                                                                        children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero1_module_default()), "hp-hero-btnsparent"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                            className: utils.cx((ShorterHero1_module_default()), "m_button", "hero-btn-purple"),
                                                                                            tag: "a",
                                                                                            slot: "",
                                                                                            "data-button-type": "signup",
                                                                                            href: "",
                                                                                            "data-tabs-buttons": "tabs",
                                                                                            "data-product-id": "service",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    tag: "div",
                                                                                                    children: "Get Started"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                    className: utils.cx((ShorterHero1_module_default()), "m_button-arrow"),
                                                                                                    value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        className: utils.cx((ShorterHero1_module_default()), "right-pane-top-hero-lotem"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero1_module_default()), "logo-wrapper"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                    tag: "div",
                                                                                    children: "Part of the monday product suite"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                    className: utils.cx((ShorterHero1_module_default()), "products-logos-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((ShorterHero1_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((ShorterHero1_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-1%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23FC527D%3B%0A%7D%0A%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-2%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23579BFC%3B%20%0A%7D%0A%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-3%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23007F9B%3B%20%0A%7D%0A%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-4%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%235559DF%3B%20%0A%7D%0A%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-5%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%2300C875%3B%20%0A%7D%0A%0A.base-layout-segment-component%20.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-6%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23FF703E%3B%20%0A%7D%0A%3C%2Fstyle%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%0A%5Bclass*%3D%22short-hero-tab-1%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23FC527D%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-2%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23579BFC%3B%20%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-3%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23007F9B%3B%20%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-4%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%235559DF%3B%20%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-5%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%2300C875%3B%20%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-6%22%5D%5Bclass*%3D%22w--current%22%5D%20%7B%0A%20%20background-color%3A%20%23FF703E%3B%20%0A%7D%0A*%2F%0A%3C%2Fstyle%3E"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/ShorterHero2.module.css
var ShorterHero2_module = __webpack_require__(9815);
var ShorterHero2_module_default = /*#__PURE__*/__webpack_require__.n(ShorterHero2_module);
;// CONCATENATED MODULE: ./devlink/ShorterHero2.js
"use client";






var ShorterHero2_interactionsData = JSON.parse('{"events":{"e-64":{"id":"e-64","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-39","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-65"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e95","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-66":{"id":"e-66","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-35","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-67"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4e9b","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-68":{"id":"e-68","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-28","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-109"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea1","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-70":{"id":"e-70","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-37","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-71"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ea7","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-72":{"id":"e-72","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-30","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4ead","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-74":{"id":"e-74","name":"","animationType":"preset","eventTypeId":"TAB_ACTIVE","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-32","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-75"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"685ced661b0756caa401e4a4|1c6c04d9-3895-168d-2d53-42376a1d4eb3","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752052960874},"e-76":{"id":"e-76","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-34","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-77"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"},"targets":[{"selector":".hero-tab-gradient.splide__slide","originalId":"88b8b365-df31-2bb0-6a84-1378fd800c5e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1752061708107}},"actionLists":{"a-39":{"id":"a-39","title":"Show btn - projects","actionItemGroups":[{"actionItems":[{"id":"a-39-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-39-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"flex"}},{"id":"a-39-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-39-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-39-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-39-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-35":{"id":"a-35","title":"Show btn - marketing","actionItemGroups":[{"actionItems":[{"id":"a-35-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"flex"}},{"id":"a-35-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}},{"id":"a-35-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-35-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-35-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-35-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-28":{"id":"a-28","title":"Show btn - CRM","actionItemGroups":[{"actionItems":[{"id":"a-28-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"flex"}},{"id":"a-28-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-28-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-28-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-28-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-28-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-37":{"id":"a-37","title":"Show btn - ops","actionItemGroups":[{"actionItems":[{"id":"a-37-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"flex"}},{"id":"a-37-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-37-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-37-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-37-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-37-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-30":{"id":"a-30","title":"Show btn - Dev","actionItemGroups":[{"actionItems":[{"id":"a-30-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"flex"}},{"id":"a-30-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"none"}},{"id":"a-30-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-30-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-30-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-30-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-32":{"id":"a-32","title":"Show btn - Service","actionItemGroups":[{"actionItems":[{"id":"a-32-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-svc","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","aee06aa3-fea4-461c-711e-257ec138b1e3"]},"value":"flex"}},{"id":"a-32-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-dev","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","f7813b09-b117-b6ec-cf2f-cc5dc009db15"]},"value":"none"}},{"id":"a-32-n-5","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-ops","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","b50e2e62-dc25-2106-291e-642fcdff9342"]},"value":"none"}},{"id":"a-32-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-crm","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","66959e88-8739-5d6b-70c7-3c89d0643d9f"]},"value":"none"}},{"id":"a-32-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-marketing","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","942ad9a7-fc5a-eb5a-5d5d-7087898b05b6"]},"value":"none"}},{"id":"a-32-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".m_button.m_button-primary-white.hero-btn-project","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d","a4ed3d58-dc62-5d8d-365b-a20268f985a1","cc614322-7194-bf7b-e626-e3fe210a5034"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751982781086},"a-34":{"id":"a-34","title":"btn-breath","actionItemGroups":[{"actionItems":[{"id":"a-34-n","actionTypeId":"TRANSFORM_SCALE","config":{"delay":100,"easing":"inOutCubic","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1.05,"yValue":1.05,"locked":true}}]},{"actionItems":[{"id":"a-34-n-2","actionTypeId":"TRANSFORM_SCALE","config":{"delay":0,"easing":"ease","duration":200,"target":{"selector":".m_button","selectorGuids":["a4ed3d58-dc62-5d8d-365b-a20268f9859d"]},"xValue":1,"yValue":1,"locked":true}}]}],"useFirstGroupAsInitialState":false,"createdOn":1751983821019}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function ShorterHero2(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _target = param.target, target = _target === void 0 ? "tab-pane" : _target;
    interactions/* useInteractions */.NI(ShorterHero2_interactionsData, (ShorterHero2_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((ShorterHero2_module_default()), "lotem-hero"),
        tag: "section",
        grid: {
            type: "section"
        },
        "data-hero-section": "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((ShorterHero2_module_default()), "m_padding-global"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((ShorterHero2_module_default()), "group_hero-center-all"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((ShorterHero2_module_default()), "m_hero-title-parent"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Heading, {
                                    className: utils.cx((ShorterHero2_module_default()), "fw1_hero-title-black-lotem"),
                                    tag: "h1",
                                    children: [
                                        "One AI work platform",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                        "for any kind of work"
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero2_module_default()), "subtitle-white-test-max-width"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                        className: utils.cx((ShorterHero2_module_default()), "fw2_hero-sub-black"),
                                        children: "Plan and execute work across projects, sales, marketing, IT, and engineering with a unified, AI-first product suite."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                        className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple", "hero-btn-project", "is-visible"),
                                        tag: "a",
                                        slot: "",
                                        "data-button-type": "signup",
                                        href: "",
                                        "data-tabs-buttons": "hero",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                tag: "div",
                                                children: "Get Started"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-1rem"),
                                    tag: "div"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                    tag: "div",
                                    children: [
                                        "No credit card needed ✦ Unlimited time on Free plan",
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                    tag: "div"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((ShorterHero2_module_default()), "m_container-xlarge"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((ShorterHero2_module_default()), "tabs-shorter-hero-wrapper-2"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((ShorterHero2_module_default()), "opening-question"),
                                        tag: "div",
                                        children: "Where would you like to start?"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsWrapper, {
                                        current: "projects",
                                        easing: "ease-in",
                                        fadeIn: 300,
                                        fadeOut: 100,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsMenu, {
                                                className: utils.cx((ShorterHero2_module_default()), "tabs-group-lotem-hero-wide"),
                                                tag: "div",
                                                "data-hero-tabs": "",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "projects",
                                                        "data-tab": "",
                                                        "data-tag-theme": "projects",
                                                        "data-cluster": "projects",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd01ef32bc74f8d96a3_project-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Projects"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "marketing",
                                                        "data-tab": "",
                                                        "data-tag-theme": "marketing",
                                                        "data-cluster": "marketing",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0c0ed5b52de6b3220_marketing-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Marketing"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "sales",
                                                        "data-tab": "",
                                                        "data-tag-theme": "sales",
                                                        "data-tab-product": "crm",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0bbd92df017e31365_sales-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Sales"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "operations",
                                                        "data-tab": "",
                                                        "data-tag-theme": "operations",
                                                        "data-cluster": "operations",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd04641d45e8f5aa26a_ops-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Operations"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "software",
                                                        "data-tab": "",
                                                        "data-tag-theme": "software",
                                                        "data-tab-product": "dev",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd03d01ce5331f60d62_dev-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Software"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsLink, {
                                                        className: utils.cx((ShorterHero2_module_default()), "short-hero-tab-stroke"),
                                                        "data-w-tab": "support and it",
                                                        "data-tab": "",
                                                        "data-tag-theme": "it",
                                                        "data-tab-product": "service",
                                                        "data-tab-scroll-target": target,
                                                        block: "inline",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                className: utils.cx((ShorterHero2_module_default()), "short-thumbnail-tab-image"),
                                                                width: "auto",
                                                                height: "auto",
                                                                loading: "lazy",
                                                                alt: "",
                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69032dd0300c7fa50d3388b2_it-thumbnail-tabshort-hero.png"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                tag: "div",
                                                                children: "Support & IT"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TabsContent, {
                                                className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-content", "no-top-radius-corners"),
                                                tag: "div",
                                                id: "tab-pane",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "projects",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "short-lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6908856099898eaef22fd9e2_updated-content-Projects.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver projects on time with AI-powered planning and risk visibility."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "m_button-primary", "for--hero"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                href: "",
                                                                                                "data-cluster": "product_management",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "marketing",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3f19283a6c0d361de_Marketinglotem-hero.webp"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Run high-impact campaigns with AI that drives execution, insights, and performance."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "marketing",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "sales",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3502474988301a736_Saleslotem-hero.webp"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82828f19164c1c762106_CRMleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Accelerate revenue growth with the AI-first CRM that finds and enriches leads.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "crm",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "operations",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/69088560a79c99471cd9ce48_updated-content-Operations.png"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b995b04654a2b82bec8bf0_WM-logo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Streamline operations with AI that manages logistics, resources, and planning at scale."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "operations",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "software",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d36d671f8ef1c70f37_Softwarelotem-hero.webp"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be82825df0bdf1f9000dd5_DEVleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                "Ship quality software faster with AI-optimized sprints and roadmap planning.",
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {})
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "dev",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997052e889dfdd2daac18_SVCtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TabsPane, {
                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-tab-pane"),
                                                        tag: "div",
                                                        "data-w-tab": "support and it",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-flexbox"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "asset-image-lotem-hero"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "eager",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be77d3eeb3cfcdc11f09b9_ITlotem-hero.webp"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((ShorterHero2_module_default()), "right-pane-lotem-hero-shorter"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Recommended product"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "logo-svg"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68be8282e92cc1be0b3a0bef_SVCleftlogo.svg"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "m_spacer-2rem"),
                                                                                    tag: "div"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                    className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                    tag: "div",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-info-text"),
                                                                                            tag: "div",
                                                                                            children: "Deliver standout service with AI-powered ticket handling and incident support."
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            className: utils.cx((ShorterHero2_module_default()), "hp-hero-btnsparent"),
                                                                                            tag: "div",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                                                className: utils.cx((ShorterHero2_module_default()), "m_button", "hero-btn-purple"),
                                                                                                tag: "a",
                                                                                                slot: "",
                                                                                                "data-button-type": "signup",
                                                                                                href: "",
                                                                                                "data-tabs-buttons": "tabs",
                                                                                                "data-product-id": "service",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "Get Started"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((ShorterHero2_module_default()), "m_button-arrow"),
                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((ShorterHero2_module_default()), "right-pane-top-hero-lotem"),
                                                                            tag: "div",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((ShorterHero2_module_default()), "logo-wrapper"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "lotem-hero-asset-tiny-text"),
                                                                                        tag: "div",
                                                                                        children: "Part of the monday product suite"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(HFlex, {
                                                                                        className: utils.cx((ShorterHero2_module_default()), "products-logos-wrapper"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b99705cb1a4433f9a489a2_WMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997050649e8e78907fb7c_CRMtiny.svg"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                                width: "auto",
                                                                                                height: "auto",
                                                                                                loading: "lazy",
                                                                                                alt: "",
                                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997058610707d7039da47_DEVtiny.svg"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((ShorterHero2_module_default()), "ai-star-hero"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                className: utils.cx((ShorterHero2_module_default()), "ai-star-hero-2"),
                width: "auto",
                height: "auto",
                loading: "lazy",
                alt: "",
                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68b997bfe698f3f734b4f313_lotemstar.svg"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                value: "%3Cstyle%3E%0A%2F*%20Base%20(inactive)%20state%20*%2F%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%20%7B%0A%20%20background%3A%20rgba(255%2C%20255%2C%20255%2C%200.5)%3B%0A%20%20border%3A%201.5px%20solid%20%23e9edf3%3B%0A%20%20border-radius%3A%208px%3B%0A%20%20transition%3A%20all%200.3s%20ease%3B%0A%20%20position%3A%20relative%3B%0A%7D%0A%0A%5Bclass*%3D%22short-hero-tab-stroke%22%5D%5Bclass*%3D%22w--current%22%5D%7B%0A%20%20border-color%3A%20transparent%3B%0A%20%20background%3A%0A%20%20%20%20linear-gradient(%23fff%2C%20%23fff)%20padding-box%2C%0A%20%20%20%20%2F*%20Extended%20gradient%20so%20first%20%26%20last%20colors%20stay%20visible%20*%2F%0A%20%20%20%20linear-gradient(%0A%20%20%20%20%20%2045deg%2C%0A%20%20%20%20%20%20%238181FF%200%25%2C%20%20%20%2F*%20orange%20start%20*%2F%0A%20%20%20%20%20%20%238181FF%2010%25%2C%20%20%2F*%20hold%20orange%20longer%20*%2F%0A%20%20%20%20%20%20%2333DBDB%2025%25%2C%0A%20%20%20%20%20%20%2333D58E%2045%25%2C%0A%20%20%20%20%20%20%23FFD633%2065%25%2C%0A%20%20%20%20%20%20%23FC527D%2085%25%2C%0A%20%20%20%20%20%20%238181FF%20100%25%20%20%2F*%20repeat%20start%20color%20to%20close%20the%20loop%20*%2F%0A%20%20%20%20)%20border-box%3B%0A%20%20background-clip%3A%20padding-box%2C%20border-box%3B%0A%7D%0A%3C%2Fstyle%3E"
            })
        ]
    });
}

// EXTERNAL MODULE: ./devlink/Trust.module.css
var Trust_module = __webpack_require__(27213);
var Trust_module_default = /*#__PURE__*/__webpack_require__.n(Trust_module);
;// CONCATENATED MODULE: ./devlink/Trust.js
"use client";





function Trust(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Section : tmp, _gartnerText = param.gartnerText, gartnerText = _gartnerText === void 0 ? "The only Leader in 3 Work Management Gartner\xae Magic Quadrant™ reports." : _gartnerText, _gartnerLinkLink = param.gartnerLinkLink, gartnerLinkLink = _gartnerLinkLink === void 0 ? {
        href: "https://monday.com/w/gartner-mq/leader-3x",
        target: "_blank"
    } : _gartnerLinkLink, _title = param.title, title = _title === void 0 ? "A leader you can trust" : _title, _forresterLink = param.forresterLink, forresterLink = _forresterLink === void 0 ? {
        href: "https://monday.com/lp/motorola-forrester-report",
        target: "_blank"
    } : _forresterLink, _gartnerLinkText = param.gartnerLinkText, gartnerLinkText = _gartnerLinkText === void 0 ? "Learn more" : _gartnerLinkText, _forresterLinkText = param.forresterLinkText, forresterLinkText = _forresterLinkText === void 0 ? "Learn more" : _forresterLinkText, _forresterText = param.forresterText, forresterText = _forresterText === void 0 ? "Motorola achieved 346% ROI according to Forrester’s Total Economic Impact™ research." : _forresterText, _g2Text = param.g2Text, g2Text = _g2Text === void 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "Leader in the",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
            "G2 Enterprise Grid\xae Report Spring 2025"
        ]
    }) : _g2Text;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(_Component, {
        className: utils.cx((Trust_module_default()), "sec-trust"),
        grid: {
            type: "section"
        },
        tag: "section",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
            className: utils.cx((Trust_module_default()), "m_padding-global"),
            tag: "div",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((Trust_module_default()), "m_padding-section-large"),
                tag: "div",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                    className: utils.cx((Trust_module_default()), "m_container-large"),
                    tag: "div",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                            className: utils.cx((Trust_module_default()), "group_sec-h-center"),
                            tag: "div",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((Trust_module_default()), "fw1_section-headline-parent"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading, {
                                    className: utils.cx((Trust_module_default()), "fw1_section-title"),
                                    tag: "h2",
                                    children: title
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                            className: utils.cx((Trust_module_default()), "comp_hp-trust"),
                            tag: "div",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Trust_module_default()), "fw1_trust-card", "is--gartner"),
                                    id: utils.cx((Trust_module_default()), "w-node-_1661ab17-4844-04ac-e260-5b7c5c2708a5-5c27089b"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-top"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-logo"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1750526307/Generator_featured%20images/hp-2025/hp_gartner.png",
                                                    alt: "logo of Gartner"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-par"),
                                                    children: gartnerText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-bottom"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                className: utils.cx((Trust_module_default()), "m_button-link"),
                                                button: false,
                                                "data-button-type": "secondary",
                                                block: "inline",
                                                options: gartnerLinkLink,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        tag: "div",
                                                        children: gartnerLinkText
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((Trust_module_default()), "m_button-arrow"),
                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Trust_module_default()), "m_link-underline"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Trust_module_default()), "fw1_trust-card", "is--g2"),
                                    id: utils.cx((Trust_module_default()), "w-node-_1661ab17-4844-04ac-e260-5b7c5c2708b0-5c27089b"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-top"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-badge"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1749472388/growth-marketing/web-experience/hp-jun-25/security/g2-badge-sprint-2025-grid-ent.webp",
                                                    alt: "g2 grid leader for enterprise bagde"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-par"),
                                                    children: g2Text
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-bottom"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                className: utils.cx((Trust_module_default()), "hp_trust-card-g2-logo"),
                                                tag: "img",
                                                slot: "",
                                                src: "https://dapulse-res.cloudinary.com/image/upload/v1749472601/growth-marketing/web-experience/hp-jun-25/security/g2-logo-bw.webp",
                                                alt: "g2 logo black and white"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                    className: utils.cx((Trust_module_default()), "fw1_trust-card", "is--forrester"),
                                    id: utils.cx((Trust_module_default()), "w-node-_1661ab17-4844-04ac-e260-5b7c5c2708bc-5c27089b"),
                                    tag: "div",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-top"),
                                            tag: "div",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DOM, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-logo"),
                                                    tag: "img",
                                                    slot: "",
                                                    src: "https://dapulse-res.cloudinary.com/image/upload/v1750526307/Generator_featured%20images/hp-2025/hp_forrester.png",
                                                    alt: "logo of forrester"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph, {
                                                    className: utils.cx((Trust_module_default()), "hp_trust-card-par"),
                                                    children: forresterText
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                            className: utils.cx((Trust_module_default()), "fw1_trust-card-bottom"),
                                            tag: "div",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                className: utils.cx((Trust_module_default()), "m_button-link"),
                                                button: false,
                                                "data-button-type": "secondary",
                                                block: "inline",
                                                options: forresterLink,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        tag: "div",
                                                        children: forresterLinkText
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                        className: utils.cx((Trust_module_default()), "m_button-arrow"),
                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((Trust_module_default()), "m_link-underline"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./devlink/TrustNav.module.css
var TrustNav_module = __webpack_require__(35898);
var TrustNav_module_default = /*#__PURE__*/__webpack_require__.n(TrustNav_module);
;// CONCATENATED MODULE: ./devlink/TrustNav.js
"use client";






var TrustNav_interactionsData = JSON.parse('{"events":{"e-109":{"id":"e-109","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-63","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-372"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"},"targets":[{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691946734681},"e-106":{"id":"e-106","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-60","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-371"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"},"targets":[{"selector":".primary-button-10._w-arrow","originalId":"64be3a57d474374353a51a1c|5c67b656-75ac-6b0a-fe2f-59ffc81407fe","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691946734683},"e-111":{"id":"e-111","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-68","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-108"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-108":{"id":"e-108","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-65","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-111"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"6639239af0e677c49531798c|47f3c4f3-8659-fa05-5c84-21e9c0f468d4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-110":{"id":"e-110","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-61","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-103"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-103":{"id":"e-103","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-57","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-110"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-102":{"id":"e-102","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-67","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-107"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300446},"e-107":{"id":"e-107","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-59","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-102"}},"mediaQueries":["medium","small","tiny"],"target":{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"},"targets":[{"selector":".mobile-menu-trigger","originalId":"64e30ab12169dbd1fa1a8c0c|50b594ab-ec1f-0d74-b51a-c05ed050f60c","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1691955300447},"e-105":{"id":"e-105","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-62","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-100"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"},"targets":[{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1704622700196},"e-100":{"id":"e-100","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-58","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-105"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"},"targets":[{"selector":".full_mobile-menu-trigger","originalId":"d30525c8-f8ec-8b75-339b-17b033c06a96","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1704622700196},"e-104":{"id":"e-104","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-66","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-101"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"},"targets":[{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757848624549},"e-101":{"id":"e-101","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-64","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-104"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"},"targets":[{"selector":".menu-int","originalId":"68c6a6fa3517c4af35c06f73|d6e75347-9836-e833-fc11-3e73ac793669","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757848624554},"e-112":{"id":"e-112","name":"","animationType":"custom","eventTypeId":"PAGE_SCROLL_UP","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-64","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-113"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1757849432554},"e-113":{"id":"e-113","name":"","animationType":"custom","eventTypeId":"PAGE_SCROLL_DOWN","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-66","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-112"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]},"targets":[{"id":"wf-page-id","appliesTo":"PAGE","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":null,"direction":null,"effectIn":null},"createdOn":1757849432555},"e-114":{"id":"e-114","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-69","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-115"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757921635436},"e-115":{"id":"e-115","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-70","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-114"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for--products","originalId":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757921635437},"e-116":{"id":"e-116","name":"","animationType":"custom","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-71","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-117"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757922492685},"e-117":{"id":"e-117","name":"","animationType":"custom","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-72","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-116"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"},"targets":[{"selector":".nav_link-ms.for--dd.for-pricing","originalId":"68c6a6fa3517c4af35c06f73|4e7a9ab5-7b90-8608-1118-742dccee258e","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1757922492686},"e-186":{"id":"e-186","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-94","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-187"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-187":{"id":"e-187","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-95","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-186"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071511","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-188":{"id":"e-188","name":"","animationType":"preset","eventTypeId":"MOUSE_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-96","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-189"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318},"e-189":{"id":"e-189","name":"","animationType":"preset","eventTypeId":"MOUSE_SECOND_CLICK","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-97","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-188"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"5fc65d0a-04a2-e85e-e4b1-d64237071515","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1761752707318}},"actionLists":{"a-63":{"id":"a-63","title":"nav-buttom-hover 2","actionItemGroups":[{"actionItems":[{"id":"a-63-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{},"xValue":0,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"id":"a-63-n-2","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{},"xValue":5,"xUnit":"px","yUnit":"PX","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1681971285006},"a-60":{"id":"a-60","title":"nav-buttom-hover-out 2","actionItemGroups":[{"actionItems":[{"id":"a-60-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"id":"66b9bd20afcdc23ad40847b7|6bad2d21-334c-6ad2-6948-c7f9081a394d"},"xValue":null,"yValue":750,"xUnit":"px","yUnit":"px","zUnit":"PX"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1681971285006},"a-68":{"id":"a-68","title":"--- Nav menu - open ---","actionItemGroups":[{"actionItems":[{"id":"a-68-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-68-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-68-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-68-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{},"value":0,"unit":""}},{"id":"a-68-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-68-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-68-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-68-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-68-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-65":{"id":"a-65","title":"--- Nav menu - close ---","actionItemGroups":[{"actionItems":[{"id":"a-65-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-65-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-65-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-65-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-65-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-65-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-65-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-61":{"id":"a-61","title":"--- Nav menu - open --- 4","actionItemGroups":[{"actionItems":[{"id":"a-61-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-61-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-61-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-61-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":0,"unit":""}},{"id":"a-61-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-61-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-61-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-61-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-61-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-57":{"id":"a-57","title":"--- Nav menu - close --- 4","actionItemGroups":[{"actionItems":[{"id":"a-57-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-57-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-57-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-57-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce665a"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-57-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-57-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-57-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-67":{"id":"a-67","title":"--- Nav menu - open --- 10","actionItemGroups":[{"actionItems":[{"id":"a-67-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-67-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]},{"actionItems":[{"id":"a-67-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":1,"unit":""}},{"id":"a-67-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":0,"unit":""}},{"id":"a-67-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-67-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"flex"}},{"id":"a-67-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-67-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-67-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-59":{"id":"a-59","title":"--- Nav menu - close --- 10","actionItemGroups":[{"actionItems":[{"id":"a-59-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{},"value":0,"unit":""}},{"id":"a-59-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-59-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-59-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-59-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce6680"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-59-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-2.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce663e","ddb23e79-3d34-5afd-a7c6-33c5b7ce668b"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-59-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-62":{"id":"a-62","title":"--- Nav menu - open --- 8","actionItemGroups":[{"actionItems":[{"id":"a-62-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":0,"unit":""}},{"id":"a-62-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"none"}}]},{"actionItems":[{"id":"a-62-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":1,"unit":""}},{"id":"a-62-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6676"]},"value":0,"unit":""}},{"id":"a-62-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"xValue":null,"yValue":0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-62-n-6","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"flex"}},{"id":"a-62-n-7","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"xValue":null,"yValue":-0.625,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-62-n-8","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"zValue":-45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-62-n-9","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"zValue":45,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1691955316834},"a-58":{"id":"a-58","title":"--- Nav menu - close --- 8","actionItemGroups":[{"actionItems":[{"id":"a-58-n","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":500,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":0,"unit":""}},{"id":"a-58-n-2","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-58-n-3","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":200,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}}]},{"actionItems":[{"id":"a-58-n-4","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce666d"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-58-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-top","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6684"]},"xValue":null,"yValue":0,"xUnit":"rem","yUnit":"rem","zUnit":"PX"}},{"id":"a-58-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".hamburger-dash-full.is-middle","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6643","ddb23e79-3d34-5afd-a7c6-33c5b7ce6676"]},"value":1,"unit":""}}]},{"actionItems":[{"id":"a-58-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"SIBLINGS","selector":".nav_menu-mobile","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6615"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1691955316834},"a-66":{"id":"a-66","title":"--- minisite nav - down --- 2","actionItemGroups":[{"actionItems":[{"id":"a-66-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":5,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-66-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"none"}},{"id":"a-66-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-66-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"flex"}},{"id":"a-66-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":0,"target":{},"value":0,"unit":""}},{"id":"a-66-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".shadow-on-nav","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6629"]},"value":1,"unit":""}},{"id":"a-66-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-general","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce667b"]},"value":"none"}},{"id":"a-66-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":1,"unit":""}},{"id":"a-66-n-9","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"ease","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":0,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-66-n-10","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662e"]},"value":"none"}}]}],"useFirstGroupAsInitialState":true,"createdOn":1708450928626},"a-64":{"id":"a-64","title":"--- minisite nav - up --- 3","actionItemGroups":[{"actionItems":[{"id":"a-64-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-ms","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce6677"]},"value":"none"}},{"id":"a-64-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".shadow-on-nav","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6629"]},"value":0,"unit":""}},{"id":"a-64-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"ease","duration":300,"target":{},"value":1,"unit":""}},{"id":"a-64-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite.for-general","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662d","ddb23e79-3d34-5afd-a7c6-33c5b7ce667b"]},"value":"flex"}},{"id":"a-64-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"easeIn","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"value":0,"unit":""}},{"id":"a-64-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"easeIn","duration":400,"target":{"selector":".nav-full-content-start.for-minisite","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6611","ddb23e79-3d34-5afd-a7c6-33c5b7ce6675"]},"yValue":5,"xUnit":"PX","yUnit":"px","zUnit":"PX"}},{"id":"a-64-n-7","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav-full-minisite-bottom","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce662e"]},"value":"flex"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1708450928626},"a-69":{"id":"a-69","title":"Tablet-dd-products","actionItemGroups":[{"actionItems":[{"id":"a-69-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"none"}},{"id":"a-69-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-69-n-2","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"block"}},{"id":"a-69-n-6","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-69-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-69-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-70":{"id":"a-70","title":"Tablet-dd-products 2","actionItemGroups":[{"actionItems":[{"id":"a-70-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-70-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-70-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-70-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--products","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","11c7e3fc-aac8-05a2-d074-b4a9da3010f4"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-71":{"id":"a-71","title":"Tablet-dd-pricing","actionItemGroups":[{"actionItems":[{"id":"a-71-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"none"}},{"id":"a-71-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-71-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"block"}},{"id":"a-71-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-71-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-71-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-72":{"id":"a-72","title":"Tablet-dd-pricing 3","actionItemGroups":[{"actionItems":[{"id":"a-72-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-72-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-72-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-72-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--pricing","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","9d7d3caa-3e83-eca1-6863-2b7bf24f380c"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-94":{"id":"a-94","title":"Tablet-dd-overview","actionItemGroups":[{"actionItems":[{"id":"a-94-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"none"}},{"id":"a-94-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-94-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"block"}},{"id":"a-94-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-94-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-94-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-95":{"id":"a-95","title":"Tablet-dd-overview 2","actionItemGroups":[{"actionItems":[{"id":"a-95-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-95-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-95-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-95-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--overview","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","f03bc88f-a369-0f63-cea6-edcc0cda56b3"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346},"a-96":{"id":"a-96","title":"Tablet-dd-learn","actionItemGroups":[{"actionItems":[{"id":"a-96-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"none"}},{"id":"a-96-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-96-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"block"}},{"id":"a-96-n-4","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":180,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-96-n-5","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"--brand--primary","rValue":97,"bValue":255,"gValue":97,"aValue":1}},{"id":"a-96-n-6","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1757921645346},"a-97":{"id":"a-97","title":"Tablet-dd-learn 2","actionItemGroups":[{"actionItems":[{"id":"a-97-n","actionTypeId":"TRANSFORM_ROTATE","config":{"delay":0,"easing":"ease","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".chevron-down.for--dd","selectorGuids":["ddb23e79-3d34-5afd-a7c6-33c5b7ce6603","ddb23e79-3d34-5afd-a7c6-33c5b7ce665e"]},"zValue":0,"xUnit":"DEG","yUnit":"DEG","zUnit":"deg"}},{"id":"a-97-n-2","actionTypeId":"STYLE_TEXT_COLOR","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":true,"id":"68c6a6fa3517c4af35c06f73|9d37d713-7d7f-f0a3-0720-1cbc15a13d42"},"globalSwatchId":"","rValue":83,"bValue":104,"gValue":87,"aValue":1}},{"id":"a-97-n-3","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":200,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-97-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"selector":".nav_link-list-tb.for--resources","selectorGuids":["fc0abbed-c853-ed3a-13b9-170a8267cb55","2d128a08-b19c-2ef2-0a35-02a14ef6e80a"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1757921645346}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}');
function TrustNav(param) {
    var tmp = param.as, _Component = tmp === void 0 ? Block : tmp;
    interactions/* useInteractions */.NI(TrustNav_interactionsData, (TrustNav_module_default()));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(_Component, {
        className: utils.cx((TrustNav_module_default()), "trust-nav-component"),
        tag: "div",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                className: utils.cx((TrustNav_module_default()), "position-fixed"),
                tag: "div",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        className: utils.cx((TrustNav_module_default()), "m_mandatory-css"),
                        value: "%3Cstyle%3E%20%5Bclass*%3D%22mobile_menu-group-h%22%5D%5Bclass*%3D%22is-active%22%5D%20%5Bclass*%3D%22chevron%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22m_dt-nav-link%22%5D%3Ahover%20%5Bclass*%3D%22m_dt-nav-link-icon-parent%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22w-dropdown-toggle%22%5D%5Bclass*%3D%22w--open%22%5D%7B%20color%3A%20var(--brand--primary)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22w--open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%7B%20transform%3A%20rotate(180deg)%3B%20%7D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20~%20%5Bclass*%3D%22group_nav-full-wrap%22%5D%7B%20display%3A%20flex%3B%20%7D%20%5Bclass*%3D%22m_button-link%22%5D%3Ahover%20%5Bclass*%3D%22m_button-arrow%22%5D%7B%20transform%3A%20translateX(.25rem)%3B%20%7D%20%3C%2Fstyle%3E%0A%0A%3Cstyle%3E%0A%2F*%20Rotate%20chevron%20when%20mobile%20group%20is%20active%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22mobile_menu-group-h%22%5D%5Bclass*%3D%22is-active%22%5D%20%5Bclass*%3D%22chevron%22%5D%20%7B%0A%20%20transform%3A%20rotate(180deg)%20!important%3B%0A%20%20color%3A%20var(--brand--primary)%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_50-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2048.75rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_23-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2026.5rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_28-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2054.75rem%3B%0A%7D%0A%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22group-child%22%5D%5Bclass*%3D%22_24-rem%22%5D%5Bclass*%3D%22is-active%22%5D%20%7B%0A%20%20height%3A%2025.25rem%3B%0A%7D%0A%0A%2F*%20Active%20full%20nav%20link%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Hover%20state%20for%20dt%20nav%20link%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_dt-nav-link%22%5D%3Ahover%20%5Bclass*%3D%22m_dt-nav-link-icon-parent%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Dropdown%20open%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22w-dropdown-toggle%22%5D%5Bclass*%3D%22w--open%22%5D%20%7B%0A%20%20color%3A%20var(--brand--primary)%20!important%3B%0A%7D%0A%0A%2F*%20Chevron%20rotation%20on%20open%20links%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%2C%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22w--open%22%5D%20%5Bclass*%3D%22chevron-down%22%5D%20%7B%0A%20%20transform%3A%20rotate(180deg)%20!important%3B%0A%7D%0A%0A%2F*%20Show%20nested%20nav%20when%20open%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_nav_link-full%22%5D%5Bclass*%3D%22is-open%22%5D%20~%20%5Bclass*%3D%22group_nav-full-wrap%22%5D%20%7B%0A%20%20display%3A%20flex%20!important%3B%0A%7D%0A%0A%2F*%20Arrow%20hover%20effect%20*%2F%0A.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22m_button-link%22%5D%3Ahover%20%5Bclass*%3D%22m_button-arrow%22%5D%20%7B%0A%20%20transform%3A%20translateX(.25rem)%20!important%3B%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                        value: "%3Cstyle%3E%20%40media%20screen%20and%20(max-width%3A%201230px)%20%7B%20%5Bclass*%3D%22minisite-nav%22%5D%7B%20display%3A%20none%3B%20%7D%20%5Bclass*%3D%22minisite-nav-mb%22%5D%7B%20display%3A%20block%3B%20%7D%20%7D%20%3C%2Fstyle%3E%0A%0A%3Cstyle%3E%0A%40media%20(max-width%3A%201230px)%20%7B%0A%20%20.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22minisite-nav%22%5D%20%7B%0A%20%20%20%20display%3A%20none%20!important%3B%0A%20%20%7D%0A%0A%20%20.dynamic-devlink-component%20%5Bclass*%3D%22crm-nav-component%22%5D%20%5Bclass*%3D%22minisite-nav-mb%22%5D%20%7B%0A%20%20%20%20display%3A%20block%20!important%3B%0A%20%20%7D%0A%7D%0A%3C%2Fstyle%3E"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "minisite-nav", "is-static"),
                        tag: "header",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                className: utils.cx((TrustNav_module_default()), "nav-full-minisite", "for-general"),
                                tag: "div",
                                config: {
                                    easing: "ease",
                                    easing2: "ease",
                                    duration: 400,
                                    docHeight: false,
                                    noScroll: false,
                                    animation: "default",
                                    collapse: "medium"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "shadow-on-nav"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "m_nav-container-full"),
                                        tag: "div",
                                        "data-header": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                className: utils.cx((TrustNav_module_default()), "m_header-logo-desktop"),
                                                button: false,
                                                "data-picture-with-link": "",
                                                block: "inline",
                                                options: {
                                                    href: "https://www.monday.com"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "lazy",
                                                    alt: "",
                                                    src: "https://uploads-ssl.webflow.com/64d0dd4b31aeec4c6cd8e685/64d0dd4b31aeec4c6cd8e6f4_monday.com.png"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "group_nav-full-content"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "nav-full-content-start"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((TrustNav_module_default()), "m_nav_link-full-parent"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((TrustNav_module_default()), "m_nav_link-full"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        id: "",
                                                                        "data-link-item-with-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                "data-link-item-text": "",
                                                                                children: "Products"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((TrustNav_module_default()), "chevron-down"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-full-wrap"),
                                                                        tag: "div",
                                                                        "data-header-item-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-full-child"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "shadow-on-list"),
                                                                                        tag: "div"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-top"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "The platform"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/features/dashboards"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%222.32292%22%20y%3D%223.23966%22%20width%3D%2215.3542%22%20height%3D%2213.5208%22%20rx%3D%221.26042%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.14583%22%2F%3E%3Cline%20x1%3D%221.75%22%20y1%3D%226.67708%22%20x2%3D%2218.25%22%20y2%3D%226.67708%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.14583%22%2F%3E%3Cpath%20d%3D%22M14.2399%2010C14.2399%209.68359%2013.9834%209.42708%2013.667%209.42708C13.3506%209.42708%2013.0941%209.68359%2013.0941%2010L14.2399%2010ZM13.0941%2010L13.0941%2016.4167L14.2399%2016.4167L14.2399%2010L13.0941%2010Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M10.5729%2010.9167C10.5729%2010.6003%2010.3164%2010.3438%2010%2010.3438C9.68359%2010.3438%209.42708%2010.6003%209.42708%2010.9167L10.5729%2010.9167ZM9.42708%2010.9167L9.42708%2016.4167L10.5729%2016.4167L10.5729%2010.9167L9.42708%2010.9167Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M6.90592%2012.75C6.90592%2012.4336%206.64942%2012.1771%206.33301%2012.1771C6.01659%2012.1771%205.76009%2012.4336%205.76009%2012.75L6.90592%2012.75ZM5.76009%2012.75L5.76009%2016.4167L6.90592%2016.4167L6.90592%2012.75L5.76009%2012.75Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Dashboards & reporting"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/integrations"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3100)%22%3E%3Cpath%20d%3D%22M3.84863%2012.293L8.18694%2016.5269C8.84001%2017.1643%209.88612%2017.1516%2010.5235%2016.4985L13.2608%2013.6938L15.9981%2010.889C16.6355%2010.2359%2016.6227%209.18982%2015.9697%208.55246L11.6314%204.31848%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M2.65137%2013.5205L12.8288%203.09233%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.5918%202.11961C6.34477%201.87852%205.94908%201.88333%205.70799%202.13036C5.4669%202.37739%205.47171%202.77309%205.71874%203.01418L6.5918%202.11961ZM5.71874%203.01418L9.39928%206.60621L10.2723%205.71163L6.5918%202.11961L5.71874%203.01418Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20d%3D%22M12.9609%2014.0007L16.6415%2017.5928%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.40137%206.41404C2.15434%206.17295%201.75865%206.17777%201.51756%206.4248C1.27647%206.67183%201.28128%207.06753%201.52831%207.30862L2.40137%206.41404ZM1.52831%207.30862L5.20885%2010.9006L6.08191%2010.0061L2.40137%206.41404L1.52831%207.30862Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3100%22%3E%3Crect%20width%3D%2220%22%20height%3D%2220%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Integrations"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/features/automations"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20x%3D%224.3329%22%20y%3D%226.55556%22%20width%3D%2211.3333%22%20height%3D%229.55556%22%20rx%3D%221.22222%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M15.333%209.55542H16.2219C17.2037%209.55542%2017.9997%2010.3514%2017.9997%2011.3332V12.2221C17.9997%2013.2039%2017.2037%2013.9999%2016.2219%2013.9999H15.333%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M4.66699%209.55542H3.7781C2.79626%209.55542%202.00032%2010.3514%202.00032%2011.3332V12.2221C2.00032%2013.2039%202.79626%2013.9999%203.7781%2013.9999H4.66699%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%2F%3E%3Cpath%20d%3D%22M12.2227%2010.4443L12.2227%2011.7777%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.77734%2010.4443L7.77734%2011.7777%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.11111%22%20stroke-linecap%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.5556%203.33325C10.5556%203.02643%2010.3068%202.7777%2010%202.7777C9.69318%202.7777%209.44444%203.02643%209.44444%203.33325L10.5556%203.33325ZM9.44444%203.33325L9.44444%206.88881L10.5556%206.88881L10.5556%203.33325L9.44444%203.33325Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Automations"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/ai"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cmask%20id%3D%22path-1-inside-1_589_3088%22%20fill%3D%22white%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.7196%203.83214L17.0691%204.2596C17.1738%204.29261%2017.2451%204.38989%2017.2451%204.49985C17.2451%204.60981%2017.1738%204.7068%2017.0691%204.74011L15.7196%205.16786C15.5737%205.21414%2015.4594%205.32852%2015.4131%205.47444L14.9854%206.82401C14.9523%206.92866%2014.8551%207%2014.7451%207C14.6352%207%2014.5382%206.92866%2014.5049%206.82401L14.0772%205.47444C14.0309%205.32852%2013.9165%205.21414%2013.7706%205.16786L12.4211%204.74011C12.3165%204.70709%2012.2451%204.60952%2012.2451%204.49985C12.2451%204.39019%2012.3165%204.29291%2012.4211%204.2596L13.7706%203.83214C13.9165%203.78586%2014.0309%203.67148%2014.0772%203.52556L14.5049%202.17599C14.5379%202.07134%2014.6352%202%2014.7451%202C14.8551%202%2014.952%202.07134%2014.9854%202.17599L15.4131%203.52556C15.4594%203.67148%2015.5737%203.78586%2015.7196%203.83214ZM11.4327%2010.0881L14.8032%2011.1557C15.0645%2011.2381%2015.2427%2011.4811%2015.2427%2011.7557C15.2427%2012.0304%2015.0645%2012.2726%2014.8032%2012.3558L11.4327%2013.4241C11.0683%2013.5397%2010.7827%2013.8254%2010.6671%2014.1898L9.5988%2017.5605C9.51635%2017.8218%209.27339%2018%208.99878%2018C8.72417%2018%208.48196%2017.8218%208.39877%2017.5605L7.33051%2014.1898C7.21492%2013.8254%206.92926%2013.5397%206.56483%2013.4241L3.19441%2012.3558C2.93305%2012.2733%202.75488%2012.0296%202.75488%2011.7557C2.75488%2011.4818%202.93305%2011.2389%203.19441%2011.1557L6.56483%2010.0881C6.92926%209.97251%207.21492%209.68683%207.33051%209.32238L8.39877%205.95176C8.48122%205.69038%208.72417%205.51221%208.99878%205.51221C9.27339%205.51221%209.51561%205.69038%209.5988%205.95176L10.6671%209.32238C10.7827%209.68683%2011.0683%209.97251%2011.4327%2010.0881Z%22%2F%3E%3C%2Fmask%3E%3Cpath%20d%3D%22M17.0691%204.2596L16.6917%205.45125L16.693%205.45167L17.0691%204.2596ZM15.7196%203.83214L15.3417%205.02364L15.3422%205.02379L15.7196%203.83214ZM17.0691%204.74011L17.4468%205.93168L17.4483%205.93122L17.0691%204.74011ZM15.7196%205.16786L15.342%203.97628L15.3417%203.97636L15.7196%205.16786ZM15.4131%205.47444L14.2216%205.09655L14.2215%205.09679L15.4131%205.47444ZM14.9854%206.82401L13.7938%206.44635L13.7933%206.44794L14.9854%206.82401ZM14.5049%206.82401L13.3133%207.20166L13.3138%207.20312L14.5049%206.82401ZM14.0772%205.47444L15.2687%205.09679L15.2687%205.09654L14.0772%205.47444ZM13.7706%205.16786L14.1485%203.97636L14.1483%203.97628L13.7706%205.16786ZM12.4211%204.74011L12.7988%203.54853L12.7972%203.54804L12.4211%204.74011ZM12.4211%204.2596L12.0436%203.06795L12.0419%203.06849L12.4211%204.2596ZM13.7706%203.83214L14.148%205.02379L14.1485%205.02364L13.7706%203.83214ZM14.0772%203.52556L15.2687%203.90346L15.2687%203.90321L14.0772%203.52556ZM14.5049%202.17599L15.6965%202.55364L15.697%202.55206L14.5049%202.17599ZM14.9854%202.17599L16.1769%201.79834L16.1765%201.79687L14.9854%202.17599ZM15.4131%203.52556L14.2215%203.90321L14.2216%203.90345L15.4131%203.52556ZM14.8032%2011.1557L14.4257%2012.3473L14.4271%2012.3478L14.8032%2011.1557ZM11.4327%2010.0881L11.0548%2011.2796L11.0553%2011.2797L11.4327%2010.0881ZM14.8032%2012.3558L15.1809%2013.5474L15.1823%2013.5469L14.8032%2012.3558ZM11.4327%2013.4241L11.055%2012.2325L11.0548%2012.2326L11.4327%2013.4241ZM10.6671%2014.1898L9.47555%2013.8119L9.47548%2013.8122L10.6671%2014.1898ZM9.5988%2017.5605L8.40722%2017.1828L8.40672%2017.1844L9.5988%2017.5605ZM8.39877%2017.5605L7.20718%2017.9381L7.20765%2017.9396L8.39877%2017.5605ZM7.33051%2014.1898L8.52209%2013.8122L8.52202%2013.8119L7.33051%2014.1898ZM6.56483%2013.4241L6.94277%2012.2326L6.94253%2012.2325L6.56483%2013.4241ZM3.19441%2012.3558L3.5721%2011.1642L3.57052%2011.1637L3.19441%2012.3558ZM3.19441%2011.1557L2.81695%209.96403L2.81524%209.96458L3.19441%2011.1557ZM6.56483%2010.0881L6.94229%2011.2797L6.94277%2011.2796L6.56483%2010.0881ZM7.33051%209.32238L8.52202%209.70027L8.52209%209.70003L7.33051%209.32238ZM8.39877%205.95176L9.59035%206.32941L9.59085%206.32783L8.39877%205.95176ZM9.5988%205.95176L10.7904%205.57411L10.7899%205.57263L9.5988%205.95176ZM10.6671%209.32238L9.47548%209.70003L9.47555%209.70027L10.6671%209.32238ZM17.4466%203.06795L16.0971%202.6405L15.3422%205.02379L16.6917%205.45124L17.4466%203.06795ZM18.4951%204.49985C18.4951%203.84494%2018.0706%203.26482%2017.4453%203.06752L16.693%205.45167C16.277%205.3204%2015.9951%204.93484%2015.9951%204.49985H18.4951ZM17.4483%205.93122C18.0687%205.73371%2018.4951%205.15708%2018.4951%204.49985H15.9951C15.9951%204.06254%2016.2788%203.67988%2016.69%203.549L17.4483%205.93122ZM16.0973%206.35943L17.4468%205.93168L16.6914%203.54854L15.342%203.97628L16.0973%206.35943ZM16.6046%205.85233C16.528%206.09371%2016.339%206.28278%2016.0976%206.35935L15.3417%203.97636C14.8085%204.1455%2014.3907%204.56333%2014.2216%205.09655L16.6046%205.85233ZM16.1769%207.20166L16.6047%205.85209L14.2215%205.09679L13.7938%206.44636L16.1769%207.20166ZM14.7451%208.25C15.4001%208.25%2015.9802%207.82535%2016.1774%207.20007L13.7933%206.44794C13.9245%206.03197%2014.31%205.75%2014.7451%205.75V8.25ZM13.3138%207.20312C13.5112%207.82349%2014.0878%208.25%2014.7451%208.25V5.75C15.1826%205.75%2015.5652%206.03383%2015.696%206.44489L13.3138%207.20312ZM12.8856%205.85209L13.3133%207.20166L15.6965%206.44636L15.2687%205.09679L12.8856%205.85209ZM13.3927%206.35935C13.1512%206.28278%2012.9622%206.09371%2012.8856%205.85234L15.2687%205.09654C15.0996%204.56333%2014.6818%204.1455%2014.1485%203.97636L13.3927%206.35935ZM12.0434%205.93168L13.3929%206.35943L14.1483%203.97628L12.7988%203.54854L12.0434%205.93168ZM10.9951%204.49985C10.9951%205.15361%2011.4188%205.73463%2012.045%205.93218L12.7972%203.54804C13.2141%203.67956%2013.4951%204.06542%2013.4951%204.49985H10.9951ZM12.0419%203.06849C11.4207%203.26625%2010.9951%203.84377%2010.9951%204.49985H13.4951C13.4951%204.93661%2013.2122%205.31956%2012.8003%205.4507L12.0419%203.06849ZM13.3931%202.6405L12.0436%203.06795L12.7986%205.45124L14.148%205.02379L13.3931%202.6405ZM12.8856%203.14766C12.9622%202.90629%2013.1512%202.71722%2013.3927%202.64065L14.1485%205.02364C14.6818%204.8545%2015.0996%204.43667%2015.2687%203.90346L12.8856%203.14766ZM13.3133%201.79834L12.8856%203.14791L15.2687%203.90321L15.6965%202.55364L13.3133%201.79834ZM14.7451%200.75C14.0901%200.75%2013.51%201.17467%2013.3128%201.79993L15.697%202.55206C15.5657%202.96801%2015.1802%203.25%2014.7451%203.25V0.75ZM16.1765%201.79687C15.979%201.17649%2015.4024%200.75%2014.7451%200.75V3.25C14.3077%203.25%2013.9251%202.96619%2013.7942%202.55512L16.1765%201.79687ZM16.6047%203.14791L16.1769%201.79834L13.7938%202.55364L14.2215%203.90321L16.6047%203.14791ZM16.0976%202.64065C16.339%202.71722%2016.528%202.90629%2016.6046%203.14767L14.2216%203.90345C14.3907%204.43667%2014.8085%204.8545%2015.3417%205.02364L16.0976%202.64065ZM15.1806%209.96404L11.8102%208.89645L11.0553%2011.2797L14.4257%2012.3473L15.1806%209.96404ZM16.4927%2011.7557C16.4927%2010.9362%2015.9613%2010.2104%2015.1793%209.96361L14.4271%2012.3478C14.1677%2012.2659%2013.9927%2012.0261%2013.9927%2011.7557H16.4927ZM15.1823%2013.5469C15.9595%2013.2995%2016.4927%2012.5776%2016.4927%2011.7557H13.9927C13.9927%2011.4831%2014.1696%2011.2457%2014.424%2011.1647L15.1823%2013.5469ZM11.8104%2014.6157L15.1809%2013.5474L14.4255%2011.1642L11.055%2012.2325L11.8104%2014.6157ZM11.8586%2014.5677C11.8513%2014.5906%2011.8336%2014.6084%2011.8107%2014.6156L11.0548%2012.2326C10.303%2012.4711%209.71397%2013.0602%209.47555%2013.8119L11.8586%2014.5677ZM10.7904%2017.9381L11.8587%2014.5675L9.47548%2013.8122L8.40722%2017.1828L10.7904%2017.9381ZM8.99878%2019.25C9.81845%2019.25%2010.5442%2018.7185%2010.7909%2017.9365L8.40672%2017.1844C8.4885%2016.9251%208.72834%2016.75%208.99878%2016.75V19.25ZM7.20765%2017.9396C7.45499%2018.7167%208.17677%2019.25%208.99878%2019.25V16.75C9.27157%2016.75%209.50893%2016.927%209.58989%2017.1813L7.20765%2017.9396ZM6.13892%2014.5675L7.20718%2017.9381L9.59035%2017.1828L8.52209%2013.8122L6.13892%2014.5675ZM6.1869%2014.6156C6.164%2014.6084%206.14624%2014.5906%206.139%2014.5677L8.52202%2013.8119C8.2836%2013.0602%207.69452%2012.4711%206.94277%2012.2326L6.1869%2014.6156ZM2.81671%2013.5474L6.18714%2014.6157L6.94253%2012.2325L3.5721%2011.1642L2.81671%2013.5474ZM1.50488%2011.7557C1.50488%2012.5737%202.03544%2013.3009%202.81829%2013.5479L3.57052%2011.1637C3.83065%2011.2458%204.00488%2011.4855%204.00488%2011.7557H1.50488ZM2.81524%209.96458C2.03728%2010.2122%201.50488%2010.9354%201.50488%2011.7557H4.00488C4.00488%2012.0283%203.82881%2012.2655%203.57357%2012.3468L2.81524%209.96458ZM6.18738%208.89645L2.81695%209.96404L3.57186%2012.3473L6.94229%2011.2797L6.18738%208.89645ZM6.139%208.94449C6.14624%208.92165%206.164%208.90386%206.1869%208.8966L6.94277%2011.2796C7.69452%2011.0411%208.2836%2010.452%208.52202%209.70027L6.139%208.94449ZM7.20718%205.57411L6.13892%208.94473L8.52209%209.70003L9.59035%206.32941L7.20718%205.57411ZM8.99878%204.26221C8.17909%204.26221%207.45337%204.79372%207.20668%205.57568L9.59085%206.32783C9.50908%206.58705%209.26925%206.76221%208.99878%206.76221V4.26221ZM10.7899%205.57263C10.5426%204.79553%209.82077%204.26221%208.99878%204.26221V6.76221C8.72602%206.76221%208.48864%206.58523%208.40769%206.33088L10.7899%205.57263ZM11.8587%208.94473L10.7904%205.57411L8.40722%206.32941L9.47548%209.70003L11.8587%208.94473ZM11.8107%208.8966C11.8336%208.90386%2011.8513%208.92165%2011.8586%208.94449L9.47555%209.70027C9.71397%2010.452%2010.303%2011.0411%2011.0548%2011.2796L11.8107%208.8966Z%22%20fill%3D%22currentcolor%22%20mask%3D%22url(%23path-1-inside-1_589_3088)%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "AI"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/mcp"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_792_2516)%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M12.6763%203.01819C11.9491%202.30546%2010.7854%202.30546%2010.0582%203.01819L3.0618%209.88364C2.81453%2010.1164%202.43635%2010.1164%202.18907%209.88364C1.95635%209.65091%201.9418%209.27273%202.18907%209.04L9.18544%202.16C10.4073%200.981822%2012.3418%200.981822%2013.5636%202.16C14.2473%202.82909%2014.5818%203.78909%2014.4363%204.73455C15.3963%204.60364%2016.3709%204.90909%2017.0545%205.59273L17.0836%205.63637C18.2618%206.78546%2018.2909%208.67637%2017.1418%209.86909C17.1273%209.88364%2017.0982%209.91273%2017.0836%209.92728L10.7563%2016.1382C10.6836%2016.2109%2010.6691%2016.3418%2010.7563%2016.4145L12.0509%2017.6945C12.2836%2017.9273%2012.2982%2018.3055%2012.0509%2018.5382C11.8036%2018.7709%2011.4254%2018.7709%2011.1782%2018.5382L9.88362%2017.2582C9.33089%2016.72%209.31635%2015.8327%209.85453%2015.28C9.85453%2015.28%209.86907%2015.2655%209.88362%2015.2509L16.2109%209.04C16.9236%208.34182%2016.9382%207.20728%2016.24%206.49455L16.2109%206.46546L16.1818%206.43637C15.4545%205.72364%2014.2909%205.72364%2013.5636%206.43637L8.3418%2011.5564L8.26907%2011.6291C8.0218%2011.8618%207.64362%2011.8618%207.39635%2011.6291C7.16362%2011.3964%207.14908%2011.0182%207.39635%2010.7855L12.6909%205.59273C13.4036%204.89455%2013.4182%203.76%2012.72%203.04728C12.72%203.04728%2012.7054%203.03273%2012.6909%203.01819H12.6763Z%22%20fill%3D%22currentcolor%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M11.8036%204.73449C12.0363%204.50176%2012.0509%204.12358%2011.8036%203.89085C11.5563%203.65813%2011.1782%203.65813%2010.9309%203.89085L5.75271%208.96722C4.57453%2010.1163%204.54544%2012.0072%205.69453%2013.1999C5.70907%2013.2145%205.73817%2013.2436%205.75271%2013.2581C6.97453%2014.4363%208.90907%2014.4363%2010.1309%2013.2581L15.3091%208.18176C15.5418%207.94904%2015.5563%207.57085%2015.3091%207.33813C15.0618%207.1054%2014.6836%207.1054%2014.4363%207.33813L9.25817%2012.4145C8.53089%2013.1272%207.36726%2013.1272%206.63998%2012.4145C5.92726%2011.7163%205.91271%2010.5818%206.61089%209.86904L6.63998%209.83994L11.8182%204.76358L11.8036%204.73449Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_792_2516%22%3E%3Crect%20width%3D%2216%22%20height%3D%2217.4545%22%20fill%3D%22currentcolor%22%20transform%3D%22translate(2%201.27271)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "monday MCP"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/mondaydb"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2220%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.75%206.25007C3.75%206.91313%204.4085%207.54904%205.58064%208.01789C6.75277%208.48675%208.34253%208.75015%2010.0002%208.75015C11.6578%208.75015%2013.2476%208.48675%2014.4197%208.01789C15.5919%207.54904%2016.2504%206.91313%2016.2504%206.25007C16.2504%205.58701%2015.5919%204.95111%2014.4197%204.48225C13.2476%204.0134%2011.6578%203.75%2010.0002%203.75C8.34253%203.75%206.75277%204.0134%205.58064%204.48225C4.4085%204.95111%203.75%205.58701%203.75%206.25007Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.75%206.25V9.99955C3.75%2011.3802%206.54842%2012.4996%2010.0002%2012.4996C13.452%2012.4996%2016.2504%2011.3807%2016.2504%209.99955V6.25%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.75%209.99951V13.7496C3.75%2015.1302%206.54842%2016.2497%2010.0002%2016.2497C13.452%2016.2497%2016.2504%2015.1302%2016.2504%2013.7496V9.99951%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25004%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Our infrastructure"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent", "is-products-end"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h", "for-product"),
                                                                                                        tag: "div",
                                                                                                        children: "Products"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col"),
                                                                                                        tag: "div"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "grid_nav-products"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220a3-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/work-management"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228.08909%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cpath%20d%3D%22M23.6134%2027.0611C25.382%2027.0611%2026.8158%2025.6274%2026.8158%2023.8588C26.8158%2022.0902%2025.382%2020.6565%2023.6134%2020.6565C21.8449%2020.6565%2020.4111%2022.0902%2020.4111%2023.8588C20.4111%2025.6274%2021.8449%2027.0611%2023.6134%2027.0611Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M23.6134%2016.078C25.382%2016.078%2026.8158%2014.6442%2026.8158%2012.8757C26.8158%2011.1071%2025.382%209.67334%2023.6134%209.67334C21.8449%209.67334%2020.4111%2011.1071%2020.4111%2012.8757C20.4111%2014.6442%2021.8449%2016.078%2023.6134%2016.078Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M13.1652%2023.669C14.9338%2023.669%2016.3675%2022.2353%2016.3675%2020.4667C16.3675%2018.6981%2014.9338%2017.2644%2013.1652%2017.2644C11.3966%2017.2644%209.96289%2018.6981%209.96289%2020.4667C9.96289%2022.2353%2011.3966%2023.669%2013.1652%2023.669Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M17.1545%2035.9488C18.9231%2035.9488%2020.3568%2034.5151%2020.3568%2032.7465C20.3568%2030.9779%2018.9231%2029.5442%2017.1545%2029.5442C15.3859%2029.5442%2013.9521%2030.9779%2013.9521%2032.7465C13.9521%2034.5151%2015.3859%2035.9488%2017.1545%2035.9488Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M30.0656%2035.9488C31.8342%2035.9488%2033.2679%2034.5151%2033.2679%2032.7465C33.2679%2030.9779%2031.8342%2029.5442%2030.0656%2029.5442C28.297%2029.5442%2026.8633%2030.9779%2026.8633%2032.7465C26.8633%2034.5151%2028.297%2035.9488%2030.0656%2035.9488Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20d%3D%22M34.0597%2023.669C35.8283%2023.669%2037.2621%2022.2353%2037.2621%2020.4667C37.2621%2018.6981%2035.8283%2017.2644%2034.0597%2017.2644C32.2911%2017.2644%2030.8574%2018.6981%2030.8574%2020.4667C30.8574%2022.2353%2032.2911%2023.669%2034.0597%2023.669Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                tag: "div",
                                                                                                                                children: "monday work management"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                tag: "div",
                                                                                                                                children: "For projects & tasks"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220aa-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/crm"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%2300D2D2%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M24.1191%2033.3844C23.4528%2032.8913%2022.8451%2032.3152%2022.3121%2031.6657C21.0172%2030.0879%2020.233%2028.1619%2020.0508%2026.1428L30.1529%2026.1427C30.6563%2026.1424%2031.0642%2025.7343%2031.0642%2025.2309C31.0642%2023.1705%2030.5318%2021.1326%2029.5028%2019.321C28.6751%2017.8636%2027.5569%2016.6074%2026.23%2015.6224C27.2036%2015.3011%2028.2443%2015.1272%2029.3257%2015.1272C34.7769%2015.1272%2039.1959%2019.5463%2039.1959%2024.9975C39.1959%2030.4487%2034.7769%2034.8677%2029.3257%2034.8677C27.4147%2034.8677%2025.6305%2034.3246%2024.1191%2033.3844Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M8.87793%2025.2303C8.87793%2019.6285%2013.4191%2015.0874%2019.0208%2015.0874C20.8485%2015.0874%2022.5608%2015.57%2024.0401%2016.4142C24.0569%2016.4254%2024.0741%2016.4362%2024.0918%2016.4463C25.6464%2017.3439%2026.9437%2018.6434%2027.8397%2020.2208C28.5597%2021.4884%2028.9928%2022.8867%2029.122%2024.3186H19.0204C18.5168%2024.3186%2018.1087%2024.7268%2018.1087%2025.2304C18.1087%2027.9988%2019.0686%2030.6817%2020.8249%2032.8218C21.3919%2033.5127%2022.0306%2034.1332%2022.727%2034.675C21.5796%2035.1256%2020.3298%2035.3732%2019.0208%2035.3732C13.4191%2035.3732%208.87793%2030.8321%208.87793%2025.2303Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                tag: "div",
                                                                                                                                children: "monday CRM"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                tag: "div",
                                                                                                                                children: "For customer-facing teams"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b1-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/dev"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%2300C875%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M23.0823%2018.6854C20.5179%2018.735%2018.4564%2020.8272%2018.4564%2023.4035C18.4564%2025.9776%2020.5142%2028.0683%2023.0754%2028.1215V28.1265H36.7881V28.1226H37.3272V28.1318C37.6002%2028.1415%2037.8758%2028.2482%2038.1023%2028.4736L40.3903%2030.7488C40.8499%2031.2059%2040.8499%2031.9497%2040.3903%2032.4069L38.1023%2034.6821C37.8288%2034.9541%2037.4838%2035.0534%2037.1581%2035.0175H23.1755C23.1434%2035.0175%2023.1113%2035.0174%2023.0793%2035.0171L23.0184%2035.0174L22.9874%2035.0175H22.1198C15.174%2034.1911%2012.5243%2028.596%2011.9373%2026.2484L11.9138%2026.2543C11.6837%2025.3422%2011.5615%2024.3872%2011.5615%2023.4035C11.5615%2017.1265%2016.5381%2012.0145%2022.7619%2011.7968C22.8364%2011.792%2022.9116%2011.7896%2022.9874%2011.7896C23.0195%2011.7896%2023.0516%2011.7897%2023.0837%2011.7899C23.1142%2011.7897%2023.1448%2011.7896%2023.1755%2011.7896C23.2504%2011.7896%2023.3248%2011.792%2023.3986%2011.7967C29.6235%2012.0132%2034.6014%2017.1257%2034.6014%2023.4035C34.6014%2024.3701%2034.4833%2025.309%2034.261%2026.2068H26.7847C27.364%2025.4231%2027.7064%2024.4535%2027.7064%2023.4035C27.7064%2020.8277%2025.6459%2018.7359%2023.0823%2018.6854ZM10.5349%2028.1225H10.1848C8.28079%2028.1225%206.7373%2029.666%206.7373%2031.57C6.7373%2033.474%208.28079%2035.0175%2010.1848%2035.0175H16.2326C13.0984%2033.1003%2011.3599%2030.2109%2010.5349%2028.1225Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                tag: "div",
                                                                                                                                children: "monday dev"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                tag: "div",
                                                                                                                                children: "For product & dev teams"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b8-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/service"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%228%22%20fill%3D%22%23FA4270%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M15.661%2014.8509C13.2565%2015.8638%2012.084%2018.3982%2013.1735%2020.9858C14.5822%2024.3309%2020.7807%2026.2303%2021.0722%2026.2728C21.334%2026.3133%2021.6404%2026.1622%2021.6404%2025.8728C21.6404%2025.5834%2021.0722%2023.1797%2021.0722%2023.0094C21.0722%2022.8392%2021.168%2022.686%2021.3318%2022.6179C21.4957%2022.5498%2028.6837%2019.5026%2031.0669%2018.5003C33.4502%2017.4981%2034.5801%2014.7999%2033.5544%2012.3655C32.5288%209.93115%2029.8157%208.86931%2027.4197%209.87795C25.0237%2010.8866%2018.0655%2013.8402%2015.661%2014.8509Z%22%20fill%3D%22white%22%2F%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M32.3122%2033.1464C34.7167%2032.1335%2035.8892%2029.5992%2034.7997%2027.0116C33.391%2023.6665%2027.1925%2021.7795%2026.901%2021.7369C26.6392%2021.6965%2026.3328%2021.8476%2026.3328%2022.1369C26.3328%2022.4263%2026.901%2024.8177%2026.901%2024.9879C26.901%2025.1582%2026.8052%2025.3114%2026.6414%2025.3795C26.4775%2025.4476%2019.2895%2028.4948%2016.9063%2029.497C14.523%2030.4993%2013.3931%2033.1975%2014.4188%2035.6319C15.4444%2038.0684%2018.1575%2039.1281%2020.5535%2038.1194C22.9516%2037.1108%2029.9077%2034.1572%2032.3122%2033.1464Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title"),
                                                                                                                                tag: "div",
                                                                                                                                children: "monday service "
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub"),
                                                                                                                                tag: "div",
                                                                                                                                children: "For IT & support"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-footer"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((TrustNav_module_default()), "group_header-buttons"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "signup",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "#"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Get Started"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "header-links-divider"),
                                                                                                    tag: "div"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "homepage-contact-sales",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "https://monday.com/sales/contact-us"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Contact sales"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "close-trig"),
                                                                                tag: "div"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((TrustNav_module_default()), "m_nav_link-full-parent"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((TrustNav_module_default()), "m_nav_link-full"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        id: "",
                                                                        "data-link-item-with-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                "data-link-item-text": "",
                                                                                children: "Solutions"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((TrustNav_module_default()), "chevron-down"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-full-wrap"),
                                                                        tag: "div",
                                                                        "data-header-item-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-full-child"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "shadow-on-list"),
                                                                                        tag: "div"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-top"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent", "is-solutions-start"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Company size"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col"),
                                                                                                        tag: "div"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "grid_nav-products", "_w-one-col"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220d9-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/enterprise"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%226.73684%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cg%20clip-path%3D%22url(%23clip0_506_4041)%22%3E%3Cpath%20d%3D%22M19.4766%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M23.8486%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2019.6274V20.4603%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2022.959V23.7918%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2026.2903V27.1231%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M31.3445%2017.1292V33.3693H16.3535V17.1292%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M29.2623%2017.1291V14.6306H18.4355V17.1291%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M33.2182%2033.3691H14.4795%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M32.3855%2017.1292H15.3125%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M19.4766%2029.6216V30.4544%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M28.2207%2029.6216V30.4544%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M25.5149%2033.3693V31.2872C25.5149%2030.3711%2024.7654%2029.6216%2023.8493%2029.6216C22.9331%2029.6216%2022.1836%2030.3711%2022.1836%2031.2872V33.3693%22%20stroke%3D%22white%22%20stroke-width%3D%221.24925%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_506_4041%22%3E%3Crect%20width%3D%2219.9879%22%20height%3D%2219.9879%22%20fill%3D%22white%22%20transform%3D%22translate(13.8545%2014.0059)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title", "is-compani-size"),
                                                                                                                                tag: "div",
                                                                                                                                children: "Enterprise"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub", "_w-br"),
                                                                                                                                tag: "div",
                                                                                                                                children: "Gain visibility and control at scale"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220e0-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/smb"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent", "is-product"),
                                                                                                                        value: "%3Csvg%20width%3D%2248%22%20height%3D%2248%22%20viewBox%3D%220%200%2048%2048%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Crect%20width%3D%2248%22%20height%3D%2248%22%20rx%3D%226.73684%22%20fill%3D%22%236C6CFF%22%2F%3E%3Cg%20clip-path%3D%22url(%23clip0_506_4029)%22%3E%3Cpath%20d%3D%22M31.5694%2022.9025L29.7935%2021.5225V17.09H26.4215V18.98L23.4241%2016.73L15.2789%2022.9025C15.1091%2023.0574%2015.0068%2023.2729%2014.9941%2023.5025V32.855C14.9941%2033.0539%2015.0731%2033.2447%2015.2136%2033.3853C15.3541%2033.5259%2015.5447%2033.605%2015.7435%2033.605H31.1198C31.3186%2033.605%2031.5091%2033.5259%2031.6497%2033.3853C31.7902%2033.2447%2031.8691%2033.0539%2031.8691%2032.855V23.465C31.8432%2023.2465%2031.7362%2023.0457%2031.5694%2022.9025Z%22%20stroke%3D%22white%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_506_4029%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20transform%3D%22translate(14.4316%2016.1675)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: [
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-title", "is-compani-size"),
                                                                                                                                tag: "div",
                                                                                                                                children: "SMB"
                                                                                                                            }),
                                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-sub", "_w-br"),
                                                                                                                                tag: "div",
                                                                                                                                children: "Run your entire business in one place"
                                                                                                                            })
                                                                                                                        ]
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent", "is-solutions-center"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Teams"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "grid_nav-teams"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220eb-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/work-management/marketing"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3129)%22%3E%3Cpath%20d%3D%22M11.0518%201.37988L17.1317%2011.9105%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M16.8157%2011.3578L1.8281%2014.8379L0.868164%2013.1751L11.3759%201.93555%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.08789%2014.0794L5.91317%2015.5088C6.21256%2016.022%206.70352%2016.3952%207.27807%2016.5463C7.85259%2016.6973%208.46364%2016.6141%208.97676%2016.3146C9.4899%2016.0153%209.86308%2015.5244%2010.0142%2014.9498C10.1653%2014.3753%2010.0821%2013.7642%209.78267%2013.2511L9.6505%2013.0222%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.43882%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3129%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Marketing"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ef-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/work-management/pmo"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M1%203.37903C1%202.93252%201.36196%202.57056%201.80847%202.57056H10.2397C10.6862%202.57056%2011.0481%202.93252%2011.0481%203.37903C11.0481%203.82553%2010.6862%204.1875%2010.2397%204.1875H1.80847C1.36196%204.1875%201%203.82553%201%203.37903ZM4.23353%208.99982C4.23353%208.55332%204.5955%208.19135%205.042%208.19135H13.4732C13.9197%208.19135%2014.2817%208.55332%2014.2817%208.99982C14.2817%209.44633%2013.9197%209.80829%2013.4732%209.80829H5.042C4.5955%209.80829%204.23353%209.44633%204.23353%208.99982ZM6.3898%2014.6208C6.3898%2014.1742%206.75176%2013.8123%207.19827%2013.8123H16.1915C16.638%2013.8123%2017%2014.1742%2017%2014.6208C17%2015.0673%2016.638%2015.4292%2016.1915%2015.4292H7.19827C6.75176%2015.4292%206.3898%2015.0673%206.3898%2014.6208Z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "PMO"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f3-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/crm"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1754)%22%3E%3Cpath%20d%3D%22M0.5625%2017.4375H17.4375%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.5%2012.1875H2.25C2.10142%2012.1894%201.95947%2012.2493%201.8544%2012.3544C1.74933%2012.4595%201.68944%2012.6014%201.6875%2012.75V17.4375H5.0625V12.75C5.06056%2012.6014%205.00067%2012.4595%204.8956%2012.3544C4.79053%2012.2493%204.64858%2012.1894%204.5%2012.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.125%209.1875H7.875C7.72642%209.18944%207.58447%209.24933%207.4794%209.3544C7.37433%209.45947%207.31444%209.60142%207.3125%209.75V17.4375H10.6875V9.75C10.6856%209.60142%2010.6257%209.45947%2010.5206%209.3544C10.4155%209.24933%2010.2736%209.18944%2010.125%209.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.75%206.1875H13.5C13.3514%206.18944%2013.2095%206.24933%2013.1044%206.3544C12.9993%206.45947%2012.9394%206.60142%2012.9375%206.75V17.4375H16.3125V6.75C16.3106%206.60142%2016.2507%206.45947%2016.1456%206.3544C16.0405%206.24933%2015.8986%206.18944%2015.75%206.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M3.13525%206.93008L15.1878%201.45508%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.2947%203.8475L15.1872%201.455L12.8022%200.5625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1754%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Sales"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f7-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/operations"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1783)%22%3E%3Cpath%20d%3D%22M7.90944%201.8284C8.04707%201.98118%208.21526%202.10333%208.40312%202.18694C8.59098%202.27055%208.79431%202.31376%208.99994%202.31376C9.20557%202.31376%209.4089%202.27055%209.59676%202.18694C9.78461%202.10333%209.95281%201.98118%2010.0904%201.8284L10.7999%201.0499C11.0033%200.82486%2011.2713%200.66826%2011.5672%200.601599C11.8631%200.534938%2012.1723%200.561483%2012.4525%200.677589C12.7327%200.793696%2012.9701%200.993674%2013.1321%201.25008C13.2942%201.50648%2013.3729%201.80674%2013.3574%202.10965L13.3042%203.15965C13.2939%203.36448%2013.3266%203.5692%2013.4002%203.76062C13.4739%203.95203%2013.5868%204.1259%2013.7317%204.27103C13.8766%204.41615%2014.0503%204.52932%2014.2416%204.60323C14.4329%204.67714%2014.6376%204.71015%2014.8424%204.70015L15.8924%204.6469C16.1952%204.63198%2016.4951%204.71104%2016.7511%204.87325C17.0071%205.03545%2017.2067%205.27287%2017.3225%205.55295C17.4384%205.83304%2017.4647%206.14209%2017.398%206.43774C17.3313%206.73339%2017.1748%207.00118%2016.9499%207.2044L16.1684%207.9094C16.0159%208.04723%2015.8939%208.21553%2015.8104%208.40343C15.7269%208.59134%2015.6838%208.79466%2015.6838%209.00028C15.6838%209.20589%2015.7269%209.40922%2015.8104%209.59713C15.8939%209.78503%2016.0159%209.95333%2016.1684%2010.0912L16.9499%2010.7962C17.175%2010.9995%2017.3316%2011.2675%2017.3982%2011.5634C17.4649%2011.8593%2017.4384%2012.1685%2017.3223%2012.4487C17.2061%2012.7289%2017.0062%2012.9663%2016.7498%2013.1284C16.4934%2013.2904%2016.1931%2013.3691%2015.8902%2013.3537L14.8402%2013.3004C14.6349%2013.2898%2014.4297%2013.3225%2014.2378%2013.3963C14.046%2013.47%2013.8717%2013.5832%2013.7264%2013.7286C13.581%2013.8739%2013.4678%2014.0482%2013.394%2014.24C13.3203%2014.4319%2013.2876%2014.6371%2013.2982%2014.8424L13.3514%2015.8924C13.3649%2016.1938%2013.2852%2016.492%2013.1232%2016.7465C12.9613%2017.0011%2012.7249%2017.1996%2012.4462%2017.3151C12.1675%2017.4306%2011.86%2017.4575%2011.5655%2017.3922C11.2709%2017.3268%2011.0037%2017.1724%2010.7999%2016.9499L10.0942%2016.1692C9.95643%2016.0166%209.7882%2015.8946%209.60036%2015.8111C9.41251%2015.7277%209.20924%2015.6845%209.00369%2015.6845C8.79813%2015.6845%208.59487%2015.7277%208.40702%2015.8111C8.21918%2015.8946%208.05094%2016.0166%207.91319%2016.1692L7.20444%2016.9499C7.00105%2017.1735%206.73366%2017.3289%206.43872%2017.3949C6.14379%2017.461%205.83566%2017.4344%205.55635%2017.319C5.27703%2017.2035%205.04012%2017.0047%204.87792%2016.7497C4.71571%2016.4947%204.6361%2016.1958%204.64994%2015.8939L4.70394%2014.8439C4.7145%2014.6386%204.68184%2014.4334%204.60809%2014.2415C4.53433%2014.0497%204.42111%2013.8754%204.27576%2013.7301C4.13041%2013.5847%203.95617%2013.4715%203.7643%2013.3978C3.57244%2013.324%203.36722%2013.2913%203.16194%2013.3019L2.11194%2013.3552C1.80915%2013.371%201.5089%2013.2927%201.25239%2013.131C0.99589%2012.9693%200.795715%2012.7322%200.679351%2012.4522C0.562987%2012.1723%200.536139%2011.8631%200.602492%2011.5673C0.668845%2011.2714%200.825147%2011.0034%201.04994%2010.7999L1.83069%2010.0949C1.98327%209.95708%202.10525%209.78878%202.18873%209.60088C2.27222%209.41297%202.31535%209.20964%202.31535%209.00403C2.31535%208.79841%202.27222%208.59509%202.18873%208.40718C2.10525%208.21928%201.98327%208.05098%201.83069%207.91315L1.04994%207.2044C0.825876%207.00116%200.670051%206.73367%200.603765%206.43851C0.537479%206.14334%200.563966%205.83491%200.679606%205.55538C0.795246%205.27584%200.994395%205.03883%201.24983%204.87676C1.50527%204.71469%201.80452%204.63546%202.10669%204.6499L3.15669%204.70315C3.36236%204.71397%203.56801%204.6814%203.76027%204.60756C3.95254%204.53372%204.12712%204.42027%204.27268%204.27456C4.41824%204.12886%204.53153%203.95417%204.60518%203.76183C4.67883%203.56949%204.7112%203.36382%204.70019%203.15815L4.64994%202.1074C4.63577%201.80535%204.71514%201.50628%204.87722%201.25101C5.0393%200.995735%205.2762%200.796687%205.55559%200.681026C5.83498%200.565366%206.14325%200.538727%206.43834%200.604744C6.73343%200.670761%207.00097%200.826218%207.20444%201.0499L7.90944%201.8284Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.625%209.00073C5.625%209.89584%205.98058%2010.7543%206.61351%2011.3872C7.24645%2012.0202%208.10489%2012.3757%209%2012.3757C9.89511%2012.3757%2010.7535%2012.0202%2011.3865%2011.3872C12.0194%2010.7543%2012.375%209.89584%2012.375%209.00073C12.375%208.10563%2012.0194%207.24718%2011.3865%206.61425C10.7535%205.98131%209.89511%205.62573%209%205.62573C8.10489%205.62573%207.24645%205.98131%206.61351%206.61425C5.98058%207.24718%205.625%208.10563%205.625%209.00073Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1783%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Operations"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220fb-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/dev"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1764)%22%3E%3Cpath%20d%3D%22M5.81348%2014.925H2.06348C1.66565%2014.925%201.28412%2014.767%201.00282%2014.4858C0.721512%2014.2044%200.563477%2013.8229%200.563477%2013.425V2.07983C0.563477%201.68201%200.721512%201.30048%201.00282%201.01918C1.28412%200.737869%201.66565%200.579834%202.06348%200.579834H15.5635C15.9613%200.579834%2016.3428%200.737869%2016.6241%201.01918C16.9055%201.30048%2017.0635%201.68201%2017.0635%202.07983V7.05008%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.563477%204.16626H17.0635%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.4385%2015.4921L12.9385%2017.4204V12.2776L17.4385%2010.3494V15.4921Z%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43799%2015.4921L12.938%2017.4204V12.2776L8.43799%2010.3494V15.4921Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.938%208.42017L17.438%2010.3492L12.938%2012.2774L8.43799%2010.3492L12.938%208.42017Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1764%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Product"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ff-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/service"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1788)%22%3E%3Cpath%20d%3D%22M17.3569%2010.2858V13.5001C17.3569%2013.6706%2017.2891%2013.8341%2017.1686%2013.9547C17.048%2014.0752%2016.8845%2014.143%2016.714%2014.143H1.28544C1.11494%2014.143%200.951426%2014.0752%200.830867%2013.9547C0.710307%2013.8341%200.642578%2013.6706%200.642578%2013.5001V3.21439C0.642578%203.04389%200.710307%202.88037%200.830867%202.75983C0.951426%202.63926%201.11494%202.57153%201.28544%202.57153H3.85686%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.71443%2014.1428L6.42871%2017.3571%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.2852%2014.1428L11.5709%2017.3571%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.14258%2017.3572H12.8569%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.07129%207.07139H10.9284V9.64282L14.7856%207.07139H17.357V0.642822H7.07129V7.07139Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1788%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "IT"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d8422103-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/dev"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1772)%22%3E%3Cpath%20d%3D%22M16.875%2016.3147C16.875%2016.6131%2016.7565%2016.8992%2016.5455%2017.1102C16.3345%2017.3212%2016.0484%2017.4397%2015.75%2017.4397H2.25C1.95163%2017.4397%201.66548%2017.3212%201.4545%2017.1102C1.24353%2016.8992%201.125%2016.6131%201.125%2016.3147V1.6897C1.125%201.39133%201.24353%201.10518%201.4545%200.894202C1.66548%200.683224%201.95163%200.564697%202.25%200.564697H13.5338C13.8275%200.564732%2014.1096%200.67967%2014.3198%200.884947L16.536%203.04645C16.6434%203.15131%2016.7287%203.2766%2016.7869%203.41493C16.8451%203.55327%2016.8751%203.70186%2016.875%203.85195V16.3147Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.7212%206.7522L13.5337%209.5647L10.7212%2012.3772%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.34619%206.7522L4.53369%209.5647L7.34619%2012.3772%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1772%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "R&D"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                id: utils.cx((TrustNav_module_default()), "w-node-ec4bbef8-f006-61da-6e6f-65d4d8422107-d842206d"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/use-cases/hr-management-software"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M6.42864%208.35679C8.20384%208.35679%209.64293%206.91771%209.64293%205.14251C9.64293%203.36731%208.20384%201.92822%206.42864%201.92822C4.65344%201.92822%203.21436%203.36731%203.21436%205.14251C3.21436%206.91771%204.65344%208.35679%206.42864%208.35679Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.643066%2017.3569H12.2145V16.6599C12.2043%2015.6799%2011.9458%2014.7185%2011.4633%2013.8655C10.9808%2013.0124%2010.2899%2012.2957%209.45526%2011.782C8.6206%2011.2684%207.66938%2010.9747%206.69045%2010.9283C6.60317%2010.9242%206.51593%2010.9221%206.42878%2010.9219C6.34163%2010.9221%206.25439%2010.9242%206.16711%2010.9283C5.18818%2010.9747%204.23696%2011.2684%203.4023%2011.782C2.56765%2012.2957%201.8768%2013.0124%201.39427%2013.8655C0.911751%2014.7185%200.653302%2015.6799%200.643066%2016.6599V17.3569Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.5718%208.35679C13.347%208.35679%2014.7861%206.91771%2014.7861%205.14251C14.7861%203.36731%2013.347%201.92822%2011.5718%201.92822%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.786%2017.3568H17.3574V16.6596C17.3471%2015.6797%2017.0887%2014.7182%2016.6062%2013.8653C16.1237%2013.0122%2015.4328%2012.2954%2014.5982%2011.7818C14.0587%2011.4498%2013.4703%2011.2097%2012.8574%2011.0688%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "HR"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col"),
                                                                                                        tag: "div"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent", "is-solutions-end"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Industries"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/industries/retail"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1809)%22%3E%3Cpath%20d%3D%22M13.5%2014.625H6.06C5.79405%2014.6251%205.53657%2014.5311%205.33332%2014.3594C5.13015%2014.1878%204.99432%2013.9497%204.95%2013.6875L3%202.06243C2.95492%201.795%202.81467%201.55286%202.6052%201.3806C2.39572%201.20833%202.13112%201.11754%201.86%201.12493H1.11%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.1396%2016.8823C12.295%2016.8823%2012.4209%2016.7564%2012.4209%2016.6011C12.4209%2016.4457%2012.295%2016.3198%2012.1396%2016.3198%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M12.1396%2016.8823C11.9843%2016.8823%2011.8584%2016.7564%2011.8584%2016.6011C11.8584%2016.4457%2011.9843%2016.3198%2012.1396%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M6.46094%2016.8823C6.61626%2016.8823%206.74219%2016.7564%206.74219%2016.6011C6.74219%2016.4457%206.61626%2016.3198%206.46094%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M6.46094%2016.8823C6.30561%2016.8823%206.17969%2016.7564%206.17969%2016.6011C6.17969%2016.4457%206.30561%2016.3198%206.46094%2016.3198%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M4.4996%2011.25H13.5896C14.0872%2011.2451%2014.5692%2011.0753%2014.96%2010.7672C15.3508%2010.4591%2015.6285%2010.0302%2015.7496%209.5475L16.8596%205.1975C16.8785%205.11469%2016.8788%205.02874%2016.8607%204.94578C16.8425%204.8628%2016.8063%204.78486%2016.7546%204.7175C16.7022%204.65002%2016.6351%204.59537%2016.5584%204.55768C16.4818%204.52%2016.3975%204.50027%2016.3121%204.5H3.3896%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.50014%204.50022L7.31264%201.68772C7.57806%201.42483%207.93657%201.27734%208.31014%201.27734C8.68372%201.27734%209.04222%201.42483%209.30764%201.68772L12.1201%204.50022%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.1175%202.50477L13.4175%201.53727C13.5943%201.48451%2013.7798%201.46734%2013.9632%201.48675C14.1467%201.50616%2014.3245%201.56176%2014.4863%201.65035C14.6481%201.73893%2014.7908%201.85874%2014.906%202.00283C15.0212%202.14691%2015.1067%202.31242%2015.1575%202.48977L15.75%204.49977%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1809%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%20transform%3D%22matrix(-1%200%200%201%2018%200)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Retail"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/industries/media"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3598)%22%3E%3Cpath%20d%3D%22M2.5%201.5H15.5C15.5%201.5%2016.5%201.5%2016.5%202.5V15.5C16.5%2015.5%2016.5%2016.5%2015.5%2016.5H2.5C2.5%2016.5%201.5%2016.5%201.5%2015.5V2.5C1.5%202.5%201.5%201.5%202.5%201.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M7.82533%2011.44C7.73833%2011.4833%207.64169%2011.5038%207.54457%2011.4993C7.44745%2011.4949%207.35307%2011.4657%207.2704%2011.4146C7.18773%2011.3634%207.11949%2011.292%207.07217%2011.2071C7.02485%2011.1221%207.00001%2011.0265%207%2010.9293V7.07064C7.00001%206.97342%207.02485%206.87781%207.07217%206.79288C7.11949%206.70796%207.18773%206.63653%207.2704%206.58538C7.35307%206.53422%207.44745%206.50504%207.54457%206.5006C7.64169%206.49615%207.73833%206.51658%207.82533%206.55997L11.6847%208.49C11.7795%208.53726%2011.8591%208.61006%2011.9149%208.70013C11.9706%208.7902%2012.0001%208.89406%2012.0001%209C12.0001%209.10586%2011.9706%209.20973%2011.9149%209.2998C11.8591%209.38986%2011.7795%209.46266%2011.6847%209.51L7.82533%2011.44Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%204H16.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.5%2014H16.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.17647%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3598%22%3E%3Crect%20width%3D%2216%22%20height%3D%2216%22%20fill%3D%22white%22%20transform%3D%22translate(1%201)%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Media"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/construction"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_589_3199)%22%3E%3Cpath%20d%3D%22M15.5%2017.4999C14.5787%2014.8211%2012.0197%2012.8635%209.05118%2012.8635C6.08268%2012.8635%203.42126%2014.8211%202.5%2017.4999%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.94837%203.59091V0.5M3.31836%206.57878H14.5782M4.75143%207.71212C4.85379%209.97879%206.6963%2011.8333%208.94827%2011.8333C11.3026%2011.8333%2013.1451%209.97879%2013.1451%207.60909V5.75455C13.1451%203.38485%2011.3026%201.5303%208.94827%201.5303C6.6963%201.5303%204.85379%203.38485%204.75143%205.65152V7.71212Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-miterlimit%3D%2210%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_589_3199%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Construction"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-footer"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((TrustNav_module_default()), "group_header-buttons"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "signup",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "#"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Get Started"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "header-links-divider"),
                                                                                                    tag: "div"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "homepage-contact-sales",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "https://monday.com/sales/contact-us"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Contact sales"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "close-trig"),
                                                                                tag: "div"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                className: utils.cx((TrustNav_module_default()), "m_nav_link-full-parent"),
                                                                tag: "div",
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DOM, {
                                                                        className: utils.cx((TrustNav_module_default()), "m_nav_link-full"),
                                                                        tag: "button",
                                                                        slot: "",
                                                                        id: "",
                                                                        "data-link-item-with-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                tag: "div",
                                                                                "data-link-item-text": "",
                                                                                children: "Resources"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                className: utils.cx((TrustNav_module_default()), "chevron-down"),
                                                                                value: "%3Csvg%20width%3D%2210%22%20height%3D%227%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-full-wrap"),
                                                                        tag: "div",
                                                                        "data-header-item-menu": "",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-full-child"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "shadow-on-list"),
                                                                                        tag: "div"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-top"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Learn"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/p/about/"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2220%22%20height%3D%2218%22%20viewBox%3D%220%200%2020%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20d%3D%22M3.48346%2014.2369C2.67081%2014.2361%201.92258%2013.813%201.52927%2013.1316C1.13596%2012.4503%201.15953%2011.6182%201.59083%2010.9583L5.61505%204.80302C6.02839%204.13279%206.78876%203.73021%207.601%203.75154C8.41324%203.77287%209.14944%204.21477%209.52383%204.90569C9.89822%205.59661%209.85184%206.42775%209.40269%207.07648L5.38086%2013.2318C4.9718%2013.858%204.25458%2014.238%203.48346%2014.2369Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M9.84016%2014.2369C9.02884%2014.2361%208.28183%2013.814%207.88916%2013.1343C7.4965%2012.4546%207.52003%2011.6244%207.95063%2010.9661L11.9671%204.82543C12.3739%204.14542%2013.137%203.7332%2013.9553%203.75131C14.7736%203.76941%2015.516%204.21493%2015.8896%204.9122C16.2632%205.60947%2016.2081%206.44659%2015.7461%207.09349L11.7297%2013.2342C11.3222%2013.8576%2010.6083%2014.2364%209.84016%2014.2369V14.2369Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3Cpath%20d%3D%22M16.5247%2014.2495C17.7538%2014.2495%2018.7501%2013.2549%2018.7501%2012.0279C18.7501%2010.801%2017.7538%209.8064%2016.5247%209.8064C15.2957%209.8064%2014.2993%2010.801%2014.2993%2012.0279C14.2993%2013.2549%2015.2957%2014.2495%2016.5247%2014.2495Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%2F%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "About us"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/whats-new"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1921)%22%3E%3Cpath%20d%3D%22M2.25%2011.8125V6.1875L4.5%2011.8125V6.1875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2011.8125H7.875C7.57663%2011.8125%207.29048%2011.694%207.0795%2011.483C6.86853%2011.272%206.75%2010.9859%206.75%2010.6875V7.3125C6.75%207.01413%206.86853%206.72798%207.0795%206.517C7.29048%206.30603%207.57663%206.1875%207.875%206.1875H9%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.75%209.5625H9%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.25%206.1875V7.70025C11.2498%208.5589%2011.4137%209.40967%2011.733%2010.2068L12.375%2011.8125L13.5%207.875L14.625%2011.8125L15.267%2010.2068C15.586%209.40957%2015.7499%208.55887%2015.75%207.70025V6.1875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M17.4375%2014.0625V16.3125C17.4375%2016.6109%2017.319%2016.897%2017.108%2017.108C16.897%2017.319%2016.6109%2017.4375%2016.3125%2017.4375H1.6875C1.38913%2017.4375%201.10298%2017.319%200.892005%2017.108C0.681026%2016.897%200.5625%2016.6109%200.5625%2016.3125V14.0625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M0.5625%203.9375V1.6875C0.5625%201.38913%200.681026%201.10298%200.892005%200.892005C1.10298%200.681026%201.38913%200.5625%201.6875%200.5625H16.3125C16.6109%200.5625%2016.897%200.681026%2017.108%200.892005C17.319%201.10298%2017.4375%201.38913%2017.4375%201.6875V3.9375%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1921%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "What's new"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/blog"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1930)%22%3E%3Cpath%20d%3D%22M14.8861%2013.7731L8.4308%208.89062L7.4873%206.18237L10.3501%206.35262L16.8046%2011.2351C16.9707%2011.3608%2017.1105%2011.5179%2017.2159%2011.6976C17.3214%2011.8773%2017.3904%2012.076%2017.419%2012.2824C17.4476%2012.4888%2017.4353%2012.6987%2017.3828%2012.9003C17.3302%2013.1019%2017.2385%2013.2912%2017.1128%2013.4574L17.1068%2013.4649C16.8532%2013.8002%2016.4767%2014.0211%2016.0603%2014.0789C15.6438%2014.1367%2015.2214%2014.0267%2014.8861%2013.7731Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.8096%204.53149V2.28149C11.8096%201.98313%2011.691%201.69698%2011.4801%201.486C11.2691%201.27502%2010.9829%201.15649%2010.6846%201.15649H1.68457C1.3862%201.15649%201.10005%201.27502%200.889075%201.486C0.678097%201.69698%200.55957%201.98313%200.55957%202.28149V13.5315C0.55957%2013.8299%200.678097%2014.116%200.889075%2014.327C1.10005%2014.538%201.3862%2014.6565%201.68457%2014.6565H6.93457L9.55957%2016.9065V14.6565H10.6846C10.8935%2014.6566%2011.0984%2014.5984%2011.2761%2014.4886C11.4539%2014.3788%2011.5976%2014.2216%2011.6911%2014.0347%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%203.40649H6.18457%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.49707%203.40649V6.78149%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%209.59399H5.62207%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.80957%2011.844H7.30957%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1930%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Blog"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/p/certificate/"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1939)%22%3E%3Cpath%20d%3D%22M16.2628%207.04254C16.1938%207.29575%2016.0534%207.5238%2015.8585%207.69954L15.1295%208.35804C14.9871%208.48658%2014.8733%208.64359%2014.7953%208.8189C14.7174%208.99422%2014.6771%209.18393%2014.6771%209.37579C14.6771%209.56764%2014.7174%209.75736%2014.7953%209.93267C14.8733%2010.108%2014.9871%2010.265%2015.1295%2010.3935L15.8585%2011.052C16.0689%2011.2417%2016.2153%2011.4919%2016.2776%2011.7682C16.34%2012.0445%2016.3153%2012.3333%2016.2069%2012.595C16.0984%2012.8566%2015.9116%2013.0783%2015.6721%2013.2295C15.4326%2013.3807%2015.1521%2013.454%2014.8693%2013.4393L13.8883%2013.389C13.6967%2013.3793%2013.5053%2013.4099%2013.3263%2013.4789C13.1474%2013.5478%2012.9849%2013.6535%2012.8493%2013.7891C12.7137%2013.9247%2012.6081%2014.0873%2012.5393%2014.2663C12.4705%2014.4453%2012.44%2014.6368%2012.4498%2014.8283L12.5%2015.8093C12.5152%2016.0924%2012.4423%2016.3733%2012.2912%2016.6133C12.1401%2016.8533%2011.9183%2017.0405%2011.6564%2017.1491C11.3945%2017.2578%2011.1053%2017.2826%2010.8287%2017.2201C10.5521%2017.1575%2010.3017%2017.0108%2010.112%2016.8L9.45353%2016.071C9.32498%2015.9286%209.16798%2015.8148%208.99266%2015.7368C8.81735%2015.6589%208.62763%2015.6186%208.43578%2015.6186C8.24393%2015.6186%208.05421%2015.6589%207.87889%2015.7368C7.70358%2015.8148%207.54657%2015.9286%207.41803%2016.071L6.75953%2016.8C6.56975%2017.0105%206.31942%2017.157%206.04298%2017.2193C5.76654%2017.2817%205.47757%2017.2568%205.21583%2017.1482C4.95409%2017.0396%204.73244%2016.8525%204.58138%2016.6127C4.43032%2016.373%204.35727%2016.0923%204.37228%2015.8093L4.42478%2014.8283C4.43458%2014.6367%204.40406%2014.4452%204.3352%2014.2661C4.26634%2014.0871%204.16066%2013.9245%204.02501%2013.7888C3.88936%2013.6531%203.72675%2013.5475%203.54769%2013.4786C3.36864%2013.4098%203.17712%2013.3792%202.98553%2013.389L2.00453%2013.4393C1.72167%2013.454%201.44121%2013.3807%201.2017%2013.2295C0.962181%2013.0783%200.77537%2012.8566%200.66694%2012.595C0.55851%2012.3333%200.533783%2012.0445%200.596158%2011.7682C0.658533%2011.4919%200.804948%2011.2417%201.01528%2011.052L1.74428%2010.3935C1.8867%2010.265%202.00056%2010.108%202.07848%209.93267C2.15641%209.75736%202.19668%209.56764%202.19668%209.37579C2.19668%209.18393%202.15641%208.99422%202.07848%208.8189C2.00056%208.64359%201.8867%208.48658%201.74428%208.35804L1.01528%207.69954C0.805136%207.50996%200.658814%207.25999%200.596395%206.98394C0.533975%206.70789%200.558518%206.41928%200.666653%206.15774C0.774789%205.89619%200.961218%205.67452%201.20035%205.52315C1.43949%205.37177%201.71961%205.29812%202.00228%205.31229L2.98328%205.36254C3.17505%205.37266%203.36682%205.34239%203.54614%205.27367C3.72547%205.20496%203.88836%205.09933%204.02426%204.96364C4.16016%204.82796%204.26604%204.66523%204.33503%204.48601C4.40403%204.30679%204.43461%204.11508%204.42478%203.92329L4.37228%202.94229C4.35693%202.65917%204.42974%202.37826%204.58067%202.13824C4.73161%201.89822%204.95324%201.7109%205.21506%201.60207C5.47688%201.49325%205.766%201.46828%206.0426%201.53059C6.3192%201.59291%206.56967%201.73945%206.75953%201.95004L7.41803%202.67904C7.54645%202.82167%207.70341%202.93571%207.87874%203.01377C8.05407%203.09184%208.24386%203.13218%208.43578%203.13218C8.6277%203.13218%208.81748%203.09184%208.99281%203.01377C9.16814%202.93571%209.32511%202.82167%209.45353%202.67904L10.112%201.95004C10.3022%201.7404%2010.5525%201.59472%2010.8287%201.53295C11.1049%201.47119%2011.3935%201.49637%2011.6548%201.60504%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M5.7002%207.98073L7.58495%2010.494C7.68654%2010.6294%207.81737%2010.7401%207.96769%2010.8179C8.11801%2010.8957%208.28394%2010.9385%208.45313%2010.9433C8.62232%2010.948%208.7904%2010.9146%208.94486%2010.8453C9.09931%2010.7761%209.23616%2010.6729%209.3452%2010.5435L17.4362%200.938232%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1939%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Get certified"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/customers"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1944)%22%3E%3Cpath%20d%3D%22M8.4375%2011.8125H10.6875V15.1875L14.0625%2011.8125H16.3125C16.6108%2011.8125%2016.897%2011.694%2017.108%2011.483C17.319%2011.2721%2017.4375%2010.9858%2017.4375%2010.6875V1.6875C17.4375%201.38914%2017.319%201.10298%2017.108%200.892005C16.897%200.681026%2016.6108%200.5625%2016.3125%200.5625H7.3125C7.01414%200.5625%206.72798%200.681026%206.517%200.892005C6.30603%201.10298%206.1875%201.38914%206.1875%201.6875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%205.0625C1.125%205.65924%201.36205%206.23153%201.78401%206.65349C2.20597%207.07545%202.77826%207.3125%203.375%207.3125C3.97174%207.3125%204.54403%207.07545%204.96599%206.65349C5.38795%206.23153%205.625%205.65924%205.625%205.0625C5.625%204.46576%205.38795%203.89347%204.96599%203.47151C4.54403%203.04955%203.97174%202.8125%203.375%202.8125C2.77826%202.8125%202.20597%203.04955%201.78401%203.47151C1.36205%203.89347%201.125%204.46576%201.125%205.0625Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.7153%204.18188L11.5403%207.08738C11.4919%207.15179%2011.4302%207.20507%2011.3595%207.24359C11.2887%207.28212%2011.2106%207.305%2011.1302%207.3107C11.0498%207.31638%2010.9692%207.30475%2010.8937%207.27657C10.8182%207.24839%2010.7497%207.20434%2010.6927%207.14738L9.56775%206.02238M6.1875%2012.9374V11.2499C6.1875%2010.504%205.89118%209.78856%205.36374%209.26116C4.83629%208.73369%204.12092%208.43736%203.375%208.43736C2.62908%208.43736%201.91371%208.73369%201.38626%209.26116C0.858818%209.78856%200.5625%2010.504%200.5625%2011.2499V12.9374H1.6875L2.25%2017.4374H4.5L5.0625%2012.9374H6.1875Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1944%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Customer stories"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Support"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/helpcenter/"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3565)%22%3E%3Cpath%20d%3D%22M16.3125%2011.8125V14.0625%22%20stroke%3D%22%23676879%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.6875%2014.0625V6.1875C1.6875%205.88914%201.80603%205.60298%202.01701%205.39201C2.22798%205.18103%202.51414%205.0625%202.8125%205.0625H5.625%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.938%2014.0625C10.7428%2014.4042%2010.4607%2014.6882%2010.1204%2014.8857C9.78%2015.0833%209.39352%2015.1873%209%2015.1873C8.60648%2015.1873%208.22%2015.0833%207.87965%2014.8857C7.5393%2014.6882%207.25721%2014.4042%207.062%2014.0625H0.5625V15.1875C0.5625%2015.7842%200.799553%2016.3565%201.22151%2016.7785C1.64347%2017.2004%202.21576%2017.4375%202.8125%2017.4375H15.1875C15.7842%2017.4375%2016.3565%2017.2004%2016.7785%2016.7785C17.2004%2016.3565%2017.4375%2015.7842%2017.4375%2015.1875V14.0625H10.938Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M14.0666%200.762293C13.184%200.498585%2012.2441%200.495875%2011.3602%200.754485C10.4762%201.0131%209.68596%201.52199%209.08476%202.21975C8.48356%202.91752%208.09716%203.77433%207.97206%204.68683C7.84704%205.59934%207.98871%206.52853%208.38006%207.36229L6.83203%2010.5041L10.3743%209.53655C10.6868%209.71558%2011.0186%209.85823%2011.3636%209.9618C12.5764%2010.2972%2013.8725%2010.1422%2014.9721%209.53033C16.0718%208.91848%2016.8867%207.89878%2017.2412%206.69135C17.5955%205.4839%2017.461%204.18551%2016.8665%203.0764C16.272%201.96729%2015.2653%201.1364%2014.0636%200.763043L14.0666%200.762293Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.3281%204.24683C11.3281%203.96869%2011.4106%203.69681%2011.5651%203.46556C11.7196%203.2343%2011.9393%203.05405%2012.1962%202.94762C12.4532%202.84119%2012.736%202.81333%2013.0087%202.8676C13.2815%202.92186%2013.5321%203.0558%2013.7287%203.25246C13.9255%203.44913%2014.0593%203.6997%2014.1136%203.97248C14.1679%204.24526%2014.14%204.52801%2014.0336%204.78498C13.9272%205.04194%2013.7469%205.26156%2013.5157%205.41608C13.2844%205.5706%2013.0125%205.65307%2012.7344%205.65307%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M12.7344%207.90311C12.579%207.90311%2012.4531%207.77719%2012.4531%207.62186C12.4531%207.4665%2012.579%207.34058%2012.7344%207.34058%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3Cpath%20d%3D%22M12.7344%207.90311C12.8897%207.90311%2013.0156%207.77719%2013.0156%207.62186C13.0156%207.4665%2012.8897%207.34058%2012.7344%207.34058%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3565%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Help center"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/helpcenter/contact-support"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3573)%22%3E%3Cpath%20d%3D%22M3.375%2013.5H2.8125C2.21576%2013.5%201.64347%2013.2629%201.22151%2012.841C0.799553%2012.419%200.5625%2011.8467%200.5625%2011.25V9C0.5625%208.4033%200.799553%207.83098%201.22151%207.40901C1.64347%206.98705%202.21576%206.75%202.8125%206.75H3.375C3.52418%206.75%203.66726%206.80927%203.77275%206.91475C3.87824%207.02024%203.9375%207.16332%203.9375%207.3125V12.9375C3.9375%2013.0867%203.87824%2013.2298%203.77275%2013.3352C3.66726%2013.4408%203.52418%2013.5%203.375%2013.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M15.1875%2013.5H14.625C14.4758%2013.5%2014.3327%2013.4408%2014.2273%2013.3352C14.1217%2013.2298%2014.0625%2013.0867%2014.0625%2012.9375V7.3125C14.0625%207.16332%2014.1217%207.02024%2014.2273%206.91475C14.3327%206.80927%2014.4758%206.75%2014.625%206.75H15.1875C15.7842%206.75%2016.3565%206.98705%2016.7785%207.40901C17.2004%207.83098%2017.4375%208.4033%2017.4375%209V11.25C17.4375%2011.8467%2017.2004%2012.419%2016.7785%2012.841C16.3565%2013.2629%2015.7842%2013.5%2015.1875%2013.5Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M2.8125%206.75C2.8125%205.10897%203.46439%203.53515%204.62478%202.37478C5.78515%201.21439%207.35897%200.5625%209%200.5625C10.641%200.5625%2012.2149%201.21439%2013.3752%202.37478C14.5356%203.53515%2015.1875%205.10897%2015.1875%206.75%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.25%2016.3125H12.9375C13.5342%2016.3125%2014.1065%2016.0754%2014.5285%2015.6535C14.9504%2015.2315%2015.1875%2014.6592%2015.1875%2014.0625V13.5%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.125%2017.4375H9C8.70165%2017.4375%208.41545%2017.319%208.20447%2017.108C7.9935%2016.897%207.875%2016.6108%207.875%2016.3125C7.875%2016.0142%207.9935%2015.728%208.20447%2015.517C8.41545%2015.306%208.70165%2015.1875%209%2015.1875H10.125C10.4233%2015.1875%2010.7096%2015.306%2010.9205%2015.517C11.1315%2015.728%2011.25%2016.0142%2011.25%2016.3125C11.25%2016.6108%2011.1315%2016.897%2010.9205%2017.108C10.7096%2017.319%2010.4233%2017.4375%2010.125%2017.4375Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.75%206.18756C6.75008%205.77508%206.86354%205.37056%207.07799%205.01821C7.29244%204.66586%207.5996%204.37924%207.96597%204.18967C8.33227%204.00011%208.74372%203.91489%209.15517%203.94335C9.5667%203.9718%209.96247%204.11282%2010.2992%204.351C10.636%204.58917%2010.9008%204.91534%2011.0647%205.29385C11.2286%205.67236%2011.2853%206.08865%2011.2286%206.49721C11.1719%206.90577%2011.0041%207.2909%2010.7433%207.6105C10.4825%207.93008%2010.1389%208.1718%209.75%208.30928C9.53055%208.3869%209.34057%208.5306%209.20625%208.72065C9.07192%208.91078%208.99985%209.1378%209%209.37053V9.56253%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2012.375C8.84467%2012.375%208.71875%2012.2491%208.71875%2012.0938C8.71875%2011.9384%208.84467%2011.8125%209%2011.8125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3Cpath%20d%3D%22M9%2012.375C9.15533%2012.375%209.28125%2012.2491%209.28125%2012.0938C9.28125%2011.9384%209.15533%2011.8125%209%2011.8125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3573%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "24/7 support"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/w/partnership"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3558)%22%3E%3Cpath%20d%3D%22M8.4375%2016.875C6.34892%2016.875%204.34588%2016.0454%202.86904%2014.5685C1.39219%2013.0916%200.5625%2011.0886%200.5625%209C0.5625%206.91142%201.39219%204.90838%202.86904%203.43153C4.34588%201.95469%206.34892%201.125%208.4375%201.125%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.4375%201.125C8.4375%201.125%204.5%203.375%204.5%209C4.5%2014.625%208.4375%2016.875%208.4375%2016.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43707%205.625H1.32031%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M8.43707%2012.375H1.32031%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M11.8125%203.375C11.8125%203.97174%2012.0496%204.54403%2012.4715%204.96599C12.8935%205.38795%2013.4658%205.625%2014.0625%205.625C14.6592%205.625%2015.2315%205.38795%2015.6535%204.96599C16.0754%204.54403%2016.3125%203.97174%2016.3125%203.375C16.3125%202.77826%2016.0754%202.20597%2015.6535%201.78401C15.2315%201.36205%2014.6592%201.125%2014.0625%201.125C13.4658%201.125%2012.8935%201.36205%2012.4715%201.78401C12.0496%202.20597%2011.8125%202.77826%2011.8125%203.375Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M16.02%207.38452L14.0625%2010.125L12.105%207.38452C11.6672%207.69516%2011.3102%208.10594%2011.0636%208.58271C10.817%209.05941%2010.688%209.58824%2010.6875%2010.125V12.375C10.6875%2012.6734%2010.806%2012.9596%2011.017%2013.1705C11.2279%2013.3815%2011.5142%2013.5%2011.8125%2013.5H12.375V15.75C12.375%2016.0484%2012.4935%2016.3346%2012.7045%2016.5455C12.9155%2016.7565%2013.2017%2016.875%2013.5%2016.875H14.625C14.9233%2016.875%2015.2095%2016.7565%2015.4205%2016.5455C15.6315%2016.3346%2015.75%2016.0484%2015.75%2015.75V13.5H16.3125C16.6108%2013.5%2016.897%2013.3815%2017.108%2013.1705C17.319%2012.9596%2017.4375%2012.6734%2017.4375%2012.375V10.125C17.437%209.58824%2017.308%209.05941%2017.0614%208.58271C16.8149%208.10594%2016.4578%207.69516%2016.02%207.38452Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.24528%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3558%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Partners"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                className: utils.cx((TrustNav_module_default()), "group_nav-col-parent", "is-products-end"),
                                                                                                tag: "div",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "nav-group-col-h"),
                                                                                                        tag: "div",
                                                                                                        children: "Build"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "group_nav-col", "_w-big-gap"),
                                                                                                        tag: "div",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/templates"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_595_3582)%22%3E%3Cpath%20d%3D%22M2.25%201.1228H15.75C15.75%201.1228%2016.875%201.1228%2016.875%202.2478V15.7478C16.875%2015.7478%2016.875%2016.8728%2015.75%2016.8728H2.25C2.25%2016.8728%201.125%2016.8728%201.125%2015.7478V2.2478C1.125%202.2478%201.125%201.1228%202.25%201.1228Z%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%205.6228H16.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M9%2016.8728V5.6228%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M1.125%2011.2478H16.875%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_595_3582%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "Template center"
                                                                                                                    })
                                                                                                                ]
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                                className: utils.cx((TrustNav_module_default()), "m_dt-nav-link"),
                                                                                                                button: false,
                                                                                                                "data-header-sub-menu-link": "",
                                                                                                                block: "inline",
                                                                                                                options: {
                                                                                                                    href: "https://monday.com/appdeveloper"
                                                                                                                },
                                                                                                                children: [
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                                        className: utils.cx((TrustNav_module_default()), "m_dt-nav-link-icon-parent"),
                                                                                                                        value: "%3Csvg%20width%3D%2218%22%20height%3D%2218%22%20viewBox%3D%220%200%2018%2018%22%20fill%3D%22none%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cg%20clip-path%3D%22url(%23clip0_562_1968)%22%3E%3Cpath%20d%3D%22M10.1496%2012.2625L15.8084%2011.8313C16.0139%2011.8155%2016.22%2011.8546%2016.4056%2011.9445C16.5912%2012.0344%2016.7496%2012.1719%2016.8647%2012.343C16.9797%2012.5141%2017.0473%2012.7127%2017.0606%2012.9185C17.0738%2013.1242%2017.0323%2013.3298%2016.9401%2013.5143C16.8081%2013.7773%2016.5818%2013.9808%2016.3064%2014.0843L8.48085%2017.0183C7.99885%2017.1994%207.46922%2017.2092%206.98085%2017.046L0.985352%2015.048%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M4.92285%2012.798H9.26385C9.47386%2012.798%209.67853%2012.7319%209.84893%2012.6092C10.0193%2012.4864%2010.1468%2012.3132%2010.2134%2012.114C10.2563%2011.9849%2010.2724%2011.8484%2010.2609%2011.7128C10.2493%2011.5773%2010.2102%2011.4455%2010.1459%2011.3255C10.0817%2011.2056%209.99372%2011.1%209.88732%2011.0152C9.78092%2010.9304%209.65835%2010.8681%209.5271%2010.8323L5.0736%209.61803C4.60361%209.48943%204.11139%209.46384%203.6306%209.54303L0.985352%209.98403%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M6.54735%202.22461L3.79785%204.28711L6.54735%206.34961%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M13.4229%202.22461L16.1731%204.28711L13.4229%206.34961%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3Cpath%20d%3D%22M10.6726%200.849121L9.29785%207.72437%22%20stroke%3D%22currentcolor%22%20stroke-width%3D%221.25%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22clip0_562_1968%22%3E%3Crect%20width%3D%2218%22%20height%3D%2218%22%20fill%3D%22white%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E"
                                                                                                                    }),
                                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                                        tag: "div",
                                                                                                                        children: "App development"
                                                                                                                    })
                                                                                                                ]
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "group-nav-content-footer"),
                                                                                        tag: "div",
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                            className: utils.cx((TrustNav_module_default()), "group_header-buttons"),
                                                                                            tag: "div",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "signup",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "#"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Get Started"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "header-links-divider"),
                                                                                                    tag: "div"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                    className: utils.cx((TrustNav_module_default()), "m_button-link-2", "in-headre"),
                                                                                                    button: false,
                                                                                                    "data-button-type": "homepage-contact-sales",
                                                                                                    block: "inline",
                                                                                                    options: {
                                                                                                        href: "https://monday.com/sales/contact-us"
                                                                                                    },
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                            tag: "div",
                                                                                                            children: "Contact sales"
                                                                                                        }),
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                            className: utils.cx((TrustNav_module_default()), "m_button-arrow"),
                                                                                                            value: "%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2210%22%20viewBox%3D%220%200%2012%2010%22%20fill%3D%22none%22%3E%0A%20%20%3Cg%20clip-path%3D%22url(%23clip0_2450_390)%22%3E%0A%20%20%20%20%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M7.03033%200.21967C6.73744%20-0.0732233%206.26256%20-0.0732233%205.96967%200.21967C5.67678%200.512563%205.67678%200.987437%205.96967%201.28033L8.93934%204.25H1C0.585786%204.25%200.25%204.58579%200.25%205C0.25%205.41421%200.585786%205.75%201%205.75H8.93934L5.96967%208.71967C5.67678%209.01256%205.67678%209.48744%205.96967%209.78033C6.26256%2010.0732%206.73744%2010.0732%207.03033%209.78033L11.6339%205.17678C11.7315%205.07915%2011.7315%204.92085%2011.6339%204.82322L7.03033%200.21967Z%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%3C%2Fg%3E%0A%20%20%3Cdefs%3E%0A%20%20%20%20%3CclipPath%20id%3D%22clip0_2450_390%22%3E%0A%20%20%20%20%20%20%3Crect%20width%3D%2212%22%20height%3D%2210%22%20fill%3D%22currentcolor%22%2F%3E%0A%20%20%20%20%3C%2FclipPath%3E%0A%20%20%3C%2Fdefs%3E%0A%3C%2Fsvg%3E"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "close-trig"),
                                                                                tag: "div"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                "data-header-link": "",
                                                                options: {
                                                                    href: "https://monday.com/w/enterprise"
                                                                },
                                                                children: "Enterprise"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "nav-full-content-end"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                "data-button-type": "login",
                                                                options: {
                                                                    href: "https://auth.monday.com/auth/login_monday/"
                                                                },
                                                                children: "Log in"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full", "is-header-cs"),
                                                                "data-button-type": "homepage-contact-sales",
                                                                options: {
                                                                    href: "https://monday.com/sales/contact-us"
                                                                },
                                                                children: "Request a demo"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "primary-button-10", "_w-arrow", "in-nav"),
                                                                button: false,
                                                                "data-button-type": "signup",
                                                                "data-product-id": "crm",
                                                                "data-existing-account-cta-override": "Go to my account",
                                                                "data-existing-account-url-override": "/",
                                                                block: "inline",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        "data-signup-button-text": "",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((TrustNav_module_default()), "", "arrow-embed-full"),
                                                                        value: "%3Csvg%20class%3D%22btn-arrow%22%20width%3D%2212%22%20height%3D%22auto%22%20fill%3D%22currentcolor%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%2F%3E%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                className: utils.cx((TrustNav_module_default()), "comp_switcher", "light-103"),
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle, {
                                                                        className: utils.cx((TrustNav_module_default()), "switcher-toggle", "light-24"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "icon_switcher", "light-65"),
                                                                            value: "%3Cimg%20alt%3D%22switcher%20icon%20hp%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fremote_mondaycom_static%2Fuploads%2FYotam_Ron%2Fswitcher-icon-hp.png%22%3E"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((TrustNav_module_default()), "switcher-list", "light-26"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-h", "light-107"),
                                                                                tag: "div",
                                                                                children: "Explore featured products"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/work-management"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Work%20Management%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FWM.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Work management"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22CRM%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FCRM.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "CRM"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/dev"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Dev%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FDEV.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Dev"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/service"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Service%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FSVC.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Service "
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "group_switcher-bottom", "light-116"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-h", "light-107", "is--grey", "light-97"),
                                                                                        tag: "div",
                                                                                        children: "More products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-bottom-end", "light-118"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                button: false,
                                                                                                block: "inline",
                                                                                                options: {
                                                                                                    href: "https://workforms.com/"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                        value: "%3Cimg%20alt%3D%22WorkForms%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fforms.png%22%3E"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "WorkForms"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                button: false,
                                                                                                block: "inline",
                                                                                                options: {
                                                                                                    href: "https://workcanvas.com/"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                        value: "%3Cimg%20alt%3D%22WorkCanvas%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fcanvas.png%22%3E"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "WorkCanvas"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "mobile-menu-trigger", "is-shown"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-top"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-middle"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-bottom"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                className: utils.cx((TrustNav_module_default()), "nav-full-minisite", "for-ms"),
                                tag: "div",
                                config: {
                                    easing: "ease",
                                    easing2: "ease",
                                    duration: 400,
                                    docHeight: false,
                                    noScroll: false,
                                    animation: "default",
                                    collapse: "medium"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "shadow-on-nav"),
                                        tag: "div"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "nav-container-full"),
                                        tag: "div",
                                        "data-header": "",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                className: utils.cx((TrustNav_module_default()), "header-logo-link", "for-minisite", "for--svc"),
                                                button: false,
                                                block: "inline",
                                                options: {
                                                    href: "https://monday.com/crm"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((TrustNav_module_default()), "minisite-logo", "for--trust"),
                                                    width: "238",
                                                    height: "23",
                                                    loading: "lazy",
                                                    alt: "monday.com trust center logo",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6900cadb56ace210c273faf2_monday-trust-center-logo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "nav-full-content", "for--"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "nav-full-content-start", "for-minisite"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: "Security"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "https://monday.com/trustcenter/privacy"
                                                                },
                                                                children: "Privacy"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: "Compliance"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: "Legal"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: "Uptime & Reliability"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                button: false,
                                                                block: "",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: "AI trust center"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "nav-full-content-end"),
                                                        tag: "div",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full"),
                                                                "data-button-type": "login",
                                                                options: {
                                                                    href: "https://auth.monday.com/auth/login_monday/"
                                                                },
                                                                children: "Log in"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarLink, {
                                                                className: utils.cx((TrustNav_module_default()), "nav_link-full", "is-header-cs"),
                                                                "data-button-type": "homepage-contact-sales",
                                                                options: {
                                                                    href: "https://monday.com/sales/contact-us"
                                                                },
                                                                children: "Request a demo"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                className: utils.cx((TrustNav_module_default()), "primary-button-10", "_w-arrow", "in-nav"),
                                                                button: false,
                                                                "data-button-type": "signup",
                                                                block: "inline",
                                                                options: {
                                                                    href: "#"
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                        tag: "div",
                                                                        "signup-button-text-position": "header-main",
                                                                        children: "Get Started"
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                        className: utils.cx((TrustNav_module_default()), "", "arrow-embed-full"),
                                                                        value: "%3Csvg%20class%3D%22btn-arrow%22%20width%3D%2212%22%20height%3D%22auto%22%20fill%3D%22currentcolor%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%2F%3E%3C%2Fsvg%3E"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownWrapper, {
                                                                className: utils.cx((TrustNav_module_default()), "comp_switcher", "light-103"),
                                                                tag: "div",
                                                                delay: 0,
                                                                hover: false,
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DropdownToggle, {
                                                                        className: utils.cx((TrustNav_module_default()), "switcher-toggle", "light-24"),
                                                                        tag: "div",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "icon_switcher", "light-65"),
                                                                            value: "%3Cimg%20alt%3D%22switcher%20icon%20hp%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fremote_mondaycom_static%2Fuploads%2FYotam_Ron%2Fswitcher-icon-hp.png%22%3E"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(DropdownList, {
                                                                        className: utils.cx((TrustNav_module_default()), "switcher-list", "light-26"),
                                                                        tag: "nav",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-h", "light-107"),
                                                                                tag: "div",
                                                                                children: "Explore featured products"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/work-management"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Work%20Management%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FWM.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Work management"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/crm"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22CRM%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FCRM.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "CRM"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/dev"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Dev%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FDEV.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Dev"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                button: false,
                                                                                block: "inline",
                                                                                options: {
                                                                                    href: "https://monday.com/w/service"
                                                                                },
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon", "light-55"),
                                                                                        value: "%3Cimg%20alt%3D%22Service%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FSVC.svg%22%3E"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        tag: "div",
                                                                                        children: "Service "
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                className: utils.cx((TrustNav_module_default()), "group_switcher-bottom", "light-116"),
                                                                                tag: "div",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-h", "light-107", "is--grey", "light-97"),
                                                                                        tag: "div",
                                                                                        children: "More products"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-bottom-end", "light-118"),
                                                                                        tag: "div",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                button: false,
                                                                                                block: "inline",
                                                                                                options: {
                                                                                                    href: "https://workforms.com/"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                        value: "%3Cimg%20alt%3D%22WorkForms%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fforms.png%22%3E"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "WorkForms"
                                                                                                    })
                                                                                                ]
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                                className: utils.cx((TrustNav_module_default()), "switcher-product-link", "light-41"),
                                                                                                button: false,
                                                                                                block: "inline",
                                                                                                options: {
                                                                                                    href: "https://workcanvas.com/"
                                                                                                },
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                                                        className: utils.cx((TrustNav_module_default()), "switcher-app-icon-small", "light-102"),
                                                                                                        value: "%3Cimg%20alt%3D%22WorkCanvas%22%20class%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2FGenerator_featured%2520images%2FHomepage%2520-%25202024%2Fcanvas.png%22%3E"
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                                        tag: "div",
                                                                                                        children: "WorkCanvas"
                                                                                                    })
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "mobile-menu-trigger", "is-shown"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-top"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-middle"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-2", "is-bottom"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                className: utils.cx((TrustNav_module_default()), "nav-full-minisite-bottom"),
                                tag: "div",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "nav-container-full"),
                                    tag: "div",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "nav-minisite-group"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                className: utils.cx((TrustNav_module_default()), "minisite-logo-link"),
                                                button: false,
                                                block: "inline",
                                                options: {
                                                    href: "https://monday.com/lp/newtrustcenter"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((TrustNav_module_default()), "minisite-logo", "for--trust"),
                                                    width: "238",
                                                    height: "23",
                                                    loading: "lazy",
                                                    alt: "monday.com trust center logo",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6900cadb56ace210c273faf2_monday-trust-center-logo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "minisite-links-group"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://monday.com/lp/trust-center-security"
                                                        },
                                                        children: "Security"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://monday.com/trustcenter/privacy"
                                                        },
                                                        children: "Privacy"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://monday.com/lp/trust/compliance"
                                                        },
                                                        children: "Compliance"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://monday.com/l/"
                                                        },
                                                        children: "Legal"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://status.monday.com/"
                                                        },
                                                        children: "Uptime & Reliability"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                                        button: false,
                                                        block: "",
                                                        options: {
                                                            href: "https://monday.com/w/ai-trust-center"
                                                        },
                                                        children: "AI trust center"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "minisite-nav-mb", "is-static", "is-100vw"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavbarWrapper, {
                                className: utils.cx((TrustNav_module_default()), "mobile-nav-ms"),
                                tag: "div",
                                config: {
                                    easing: "ease",
                                    easing2: "ease",
                                    duration: 400,
                                    docHeight: false,
                                    noScroll: false,
                                    animation: "default",
                                    collapse: "all"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "nav-container-lp"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                className: utils.cx((TrustNav_module_default()), "header-logo-link-mb"),
                                                button: false,
                                                block: "inline",
                                                options: {
                                                    href: "https://monday.com/crm"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                    className: utils.cx((TrustNav_module_default()), "minisite-logo-mb", "is-small"),
                                                    width: "auto",
                                                    height: "auto",
                                                    loading: "lazy",
                                                    alt: "monday.com trust center logo",
                                                    src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6900cadb56ace210c273faf2_monday-trust-center-logo.svg"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "nav_menu-mobile"),
                                                tag: "div",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                    className: utils.cx((TrustNav_module_default()), "nav_menu-mobile-content"),
                                                    tag: "div",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-text"),
                                                                            tag: "div",
                                                                            children: "Products"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "chevron"),
                                                                            value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "group-child", "_23-rem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "Tailored to your teams' needs"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "_w-icon"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "https://monday.com/work-management"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((TrustNav_module_default()), "mobile-menu-ucon"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b574_WM_Symbol.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "monday work management"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "_w-icon"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "https://monday.com/crm"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((TrustNav_module_default()), "mobile-menu-ucon"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b573_CRM_Symbol.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "monday CRM"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "_w-icon"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "https://monday.com/w/dev"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((TrustNav_module_default()), "mobile-menu-ucon"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b572_DEV_Symbol.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "monday dev"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "_w-icon"),
                                                                                    button: false,
                                                                                    block: "inline",
                                                                                    options: {
                                                                                        href: "/w/service"
                                                                                    },
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                            className: utils.cx((TrustNav_module_default()), "mobile-menu-ucon"),
                                                                                            width: "auto",
                                                                                            height: "auto",
                                                                                            loading: "lazy",
                                                                                            alt: "",
                                                                                            src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b571_SVC_Symbol.svg"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                            tag: "div",
                                                                                            children: "monday service"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "More by monday.com"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#",
                                                                                        target: "_blank"
                                                                                    },
                                                                                    children: "WorkForms"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#",
                                                                                        target: "_blank"
                                                                                    },
                                                                                    children: "WorkCanvas"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-text"),
                                                                            tag: "div",
                                                                            children: "Teams"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "chevron"),
                                                                            value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "group-child", "_28-rem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "By team"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Marketing"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Project management"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Sales"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Product development"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Operations"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "IT"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "HR"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "By business size"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Enterprise"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Small business"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Nonprofit"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "By industry"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Retail"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Media"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Construction"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Government"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-text"),
                                                                            tag: "div",
                                                                            children: "Features"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "chevron"),
                                                                            value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "group-child", "_24-rem"),
                                                                    tag: "div",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                        className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                        tag: "div",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Dashboards"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Integrations"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Automations"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "AI"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Gantt"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Kanban"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Docs"
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                button: false,
                                                                                block: "",
                                                                                options: {
                                                                                    href: "#"
                                                                                },
                                                                                children: "Forms"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-text"),
                                                                            tag: "div",
                                                                            children: "Resources"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "chevron"),
                                                                            value: "%3Csvg%20width%3D%22256%22%20height%3D%22256%22%20viewBox%3D%220%200%20256%20256%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22link-with-menu-title-icon%22%3E%3Cpath%20d%3D%22M0%2066.73c0%202.66.981%205.33%202.955%207.41l117.332%20123.323a10.64%2010.64%200%200%200%207.712%203.314c2.912%200%205.696-1.19%207.712-3.314L253.043%2074.14c4.074-4.278%203.914-11.077-.331-15.163a10.627%2010.627%200%200%200-15.083.333L128%20174.536%2018.379%2059.32c-4.075-4.279-10.827-4.429-15.083-.343A10.76%2010.76%200%200%200%200%2066.73z%22%20fill%3D%22currentcolor%22%20fill-rule%3D%22nonzero%22%2F%3E%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "group-child", "_50-rem"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "Learn"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Help center"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "What's new"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "About us"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Blog"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Certifications"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "Connect"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "24/7 support"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Partners"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Global events"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Community"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                            className: utils.cx((TrustNav_module_default()), "sub-group", "bottom-margin"),
                                                                            tag: "div",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link", "is-title"),
                                                                                    tag: "div",
                                                                                    children: "Build"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "App development"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Template center"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                                    className: utils.cx((TrustNav_module_default()), "mobile-link"),
                                                                                    button: false,
                                                                                    block: "",
                                                                                    options: {
                                                                                        href: "#"
                                                                                    },
                                                                                    children: "Spaces"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom", "_w--icon"),
                                                            button: false,
                                                            block: "inline",
                                                            options: {
                                                                href: "#"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                    tag: "div",
                                                                    children: "Discover AI"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                    className: utils.cx((TrustNav_module_default()), "mb-menu-ai-icon"),
                                                                    width: "auto",
                                                                    height: "auto",
                                                                    loading: "lazy",
                                                                    alt: "",
                                                                    src: "https://cdn.prod.website-files.com/656da6fea306219773d04208/680793b5784dff59f274e76d_icon-ai.svg"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                            button: false,
                                                            block: "",
                                                            options: {
                                                                href: "https://monday.com/pricing"
                                                            },
                                                            children: "Pricing"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                            button: false,
                                                            "data-button-type": "homepage-contact-sales",
                                                            block: "",
                                                            options: {
                                                                href: "https://monday.com/sales/contact-us?from=header&source=Website%20-%20Contact%20Sales"
                                                            },
                                                            children: "Contact sales"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                            className: utils.cx((TrustNav_module_default()), "mobile_menu-group-h-standalone", "_w-border-bottom"),
                                                            button: false,
                                                            block: "",
                                                            options: {
                                                                href: "https://auth.monday.com/login"
                                                            },
                                                            children: "Log in"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                            className: utils.cx((TrustNav_module_default()), "appstore-wrap"),
                                                            tag: "div",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                                    className: utils.cx((TrustNav_module_default()), "badges-wrap"),
                                                                    tag: "div",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                            className: utils.cx((TrustNav_module_default()), "appstore-badge"),
                                                                            button: false,
                                                                            block: "inline",
                                                                            options: {
                                                                                href: "https://apps.apple.com/us/app/monday-com-work-management/id1290128888",
                                                                                target: "_blank"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((TrustNav_module_default()), "appstore-badge-img"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b570_appstore.svg"
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                                                            className: utils.cx((TrustNav_module_default()), "appstore-badge"),
                                                                            button: false,
                                                                            block: "inline",
                                                                            options: {
                                                                                href: "https://play.google.com/store/apps/details?id=com.monday.monday&hl=en&gl=US",
                                                                                target: "_blank"
                                                                            },
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                                                                className: utils.cx((TrustNav_module_default()), "appstore-badge-img"),
                                                                                width: "auto",
                                                                                height: "auto",
                                                                                loading: "lazy",
                                                                                alt: "",
                                                                                src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b56f_Play.svg"
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                                                    className: utils.cx((TrustNav_module_default()), "go-to-hp-btn"),
                                                                    button: false,
                                                                    block: "inline",
                                                                    options: {
                                                                        href: "https://monday.com/"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "go-to-hp-logo"),
                                                                            value: "%3Cimg%20alt%3D%22Monday%22%20class%3D%22jsx-4212101279%22%20src%3D%22https%3A%2F%2Fdapulse-res.cloudinary.com%2Fimage%2Fupload%2Fmobile_menu%2FMonday.png%22%3E"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                                            tag: "div",
                                                                            children: "Go to homepage"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlEmbed, {
                                                                            className: utils.cx((TrustNav_module_default()), "go-to-hp-arrow"),
                                                                            value: "%3Csvg%20width%3D%2212%22%20height%3D%2214%22%20viewBox%3D%220%200%209%207%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.628.616a.5.5%200%201%200-.64.768L6.203%203.23H.5a.5.5%200%200%200%200%201h5.612L3.988%206a.5.5%200%201%200%20.64.769l3.23-2.693a.5.5%200%200%200%200-.768L4.628.616z%22%20fill%3D%22currentcolor%22%2F%3E%3C%2Fsvg%3E"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                                className: utils.cx((TrustNav_module_default()), "full_mobile-menu-trigger", "is-open"),
                                                tag: "div",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-full", "is-top"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-full", "is-middle"),
                                                        tag: "div"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                                        className: utils.cx((TrustNav_module_default()), "hamburger-dash-full", "is-bottom"),
                                                        tag: "div"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "shadow-on-nav"),
                                        tag: "div"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                className: utils.cx((TrustNav_module_default()), "minisite-links-group"),
                                tag: "div",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://monday.com/lp/trust-center-security"
                                        },
                                        children: "Security"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://monday.com/trustcenter/privacy"
                                        },
                                        children: "Privacy"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://monday.com/lp/trust/compliance"
                                        },
                                        children: "Compliance"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://monday.com/l/"
                                        },
                                        children: "Legal"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://status.monday.com/"
                                        },
                                        children: "Uptime & Reliability"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                        className: utils.cx((TrustNav_module_default()), "nav_link-ms"),
                                        button: false,
                                        block: "",
                                        options: {
                                            href: "https://monday.com/w/ai-trust-center"
                                        },
                                        children: "AI trust center"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "nav_link-list-tb", "for--products"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                children: "monday"
                                            }),
                                            " CRM"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/w/crm/campaigns"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                children: "monday"
                                            }),
                                            " campaigns"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "nav_link-list-tb", "for--pricing"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm/pricing"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b576_logo-pos-campaigns.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                children: "monday"
                                            }),
                                            " CRM pricing"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm/campaigns/pricing"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, {
                                        width: "auto",
                                        height: "auto",
                                        loading: "lazy",
                                        alt: "",
                                        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68c6a6ff64299d7d05a1b575_logo-pos-crm.svg"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                                        className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                        tag: "div",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Strong, {
                                                children: "monday"
                                            }),
                                            " campaigns pricing"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "nav_link-list-tb", "for--overview"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm/features"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Features"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm/marketplace"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Templates"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Integrations"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Block, {
                        className: utils.cx((TrustNav_module_default()), "nav_link-list-tb", "for--resources"),
                        tag: "div",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/crm/whats-new"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "What’s new?"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "https://monday.com/blog/crm-and-sales"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Blog"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Knowledge base"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "CRM Academy"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Webinars & videos"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Events"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "Guides"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Basic_Link, {
                                className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-2"),
                                button: false,
                                block: "inline",
                                options: {
                                    href: "#"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                                    className: utils.cx((TrustNav_module_default()), "dropdown-link-inner-text"),
                                    tag: "div",
                                    children: "CRMcare"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Block, {
                className: utils.cx((TrustNav_module_default()), "nav-spacer"),
                tag: "div"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./devlink/index.js
"use client";
console.warn("⚠️ Avoid importing components from 'index.js' for better performance. This practice is deprecated and may be removed in the future.");





































// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/aiagents-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var aiagents_config = ({
    buttonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    card1Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Text",
        translatable: true
    },
    card1Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Title",
        translatable: true
    },
    card2Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Text",
        translatable: true
    },
    card2Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Title",
        translatable: true
    },
    card3Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Text",
        translatable: true
    },
    card3Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Title",
        translatable: true
    },
    card4Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 4 Text",
        translatable: true
    },
    card4Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 4 Title",
        translatable: true
    },
    card5Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 5 Text",
        translatable: true
    },
    card5Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 5 Title",
        translatable: true
    },
    card6Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 6 Text",
        translatable: true
    },
    card6Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 6 Title",
        translatable: true
    },
    comingSoon: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Coming Soon",
        translatable: true
    },
    secondButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Second Button Text",
        translatable: true
    },
    subTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Sub Title",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    card1ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 1 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card2ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 2 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card3ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 3 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card4ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 4 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card5ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 5 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    card6ImageOnHover: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card 6 Image On Hover",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/aiteamsimpact-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var aiteamsimpact_config = ({
    cta: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "CTA",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    sectionVisibility: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Section Visibility",
        translatable: false
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/aiteamsimpactlang-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var aiteamsimpactlang_config = ({
    buttonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    impactTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Impact Title",
        translatable: true
    },
    slide1Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Slide 1 Title",
        translatable: true
    },
    slide2Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Slide 2 Title",
        translatable: true
    },
    slide3Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Slide 3 Title",
        translatable: true
    },
    slide4Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Slide 4 Title",
        translatable: true
    },
    slide5Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Slide 5 Title",
        translatable: true
    },
    tab1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 4 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 5 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    sectionVisibility: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Section Visibility",
        translatable: false
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/casestudies-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var casestudies_config = ({
    buttonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Button Text",
        translatable: true
    },
    case1Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 1 Link",
        translatable: true
    },
    case1Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 1 Number",
        translatable: true
    },
    case1Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 1 Tag",
        translatable: true
    },
    case2Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 2 Link",
        translatable: true
    },
    case2Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 2 Number",
        translatable: true
    },
    case2Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 2 Tag",
        translatable: true
    },
    case2Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 2 Text",
        translatable: true
    },
    case3Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 3 Link",
        translatable: true
    },
    case3Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 3 Number",
        translatable: true
    },
    case3Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 3 Tag",
        translatable: true
    },
    case3Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 3 Text",
        translatable: true
    },
    case4Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 4 Link",
        translatable: true
    },
    case4Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 4 Number",
        translatable: true
    },
    case4Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 4 Tag",
        translatable: true
    },
    case4Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 4 Text",
        translatable: true
    },
    case5Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 5 Link",
        translatable: true
    },
    case5Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 5 Number",
        translatable: true
    },
    case5Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 5 Tag",
        translatable: true
    },
    case5Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 5 Text",
        translatable: true
    },
    case6Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 6 Link",
        translatable: true
    },
    case6Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 6 Number",
        translatable: true
    },
    case6Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 6 Tag",
        translatable: true
    },
    case6Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 6 Text",
        translatable: true
    },
    case7Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 7 Link",
        translatable: true
    },
    case7Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 7 Number",
        translatable: true
    },
    case7Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 7 Tag",
        translatable: true
    },
    case7Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 7 Text",
        translatable: true
    },
    case8Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 8 Link",
        translatable: true
    },
    case8Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 8 Number",
        translatable: true
    },
    case8Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 8 Tag",
        translatable: true
    },
    case8Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 8 Text",
        translatable: true
    },
    case9Link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 9 Link",
        translatable: true
    },
    case9Number: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 9 Number",
        translatable: true
    },
    case9Tag: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 9 Tag",
        translatable: true
    },
    case9Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Case 9 Text",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    case1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case1Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 1 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 2 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case3Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 3 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case4Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 4 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case4Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 4 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case5Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 5 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case5Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 5 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case6Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 6 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case6Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 6 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case7Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 7 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case7Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 7 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case8Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 8 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case8Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 8 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case9Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 9 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case9Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 9 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    case2UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 2 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case3UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 3 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case4UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 4 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case5UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 5 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case6UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 6 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case7UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 7 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case8UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 8 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    case9UrlLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Case 9 URL Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/closerllama-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var closerllama_config = ({
    blackButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Black Button Text",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    whiteButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "White Button Text",
        translatable: true
    },
    blackButtonLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Black Button Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/mondaydifference-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var mondaydifference_config = ({
    card1ClientTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Client Title",
        translatable: true
    },
    card1Testimonial: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Testimonial",
        translatable: true
    },
    card1Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Text",
        translatable: true
    },
    card1Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 1 Title",
        translatable: true
    },
    card2ClientTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Client Title",
        translatable: true
    },
    card2Testimonial: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Testimonial",
        translatable: true
    },
    card2Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Text",
        translatable: true
    },
    card2Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 2 Title",
        translatable: true
    },
    card3ClientTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Client Title",
        translatable: true
    },
    card3Testimonial: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Testimonial",
        translatable: true
    },
    card3Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Text",
        translatable: true
    },
    card3Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card 3 Title",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    customer1Headshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 1 Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer1Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 1 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer2Headshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 2 Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer2Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 2 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer3Headshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 3 Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    customer3Logo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Customer 3 Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/products-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var products_config = ({
    blackButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Black Button Text",
        translatable: true
    },
    crmBold1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Bold 1",
        translatable: true
    },
    crmBold2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Bold 2",
        translatable: true
    },
    crmBold3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Bold 3",
        translatable: true
    },
    crmButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Button Text",
        translatable: true
    },
    crmPopupButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Popup Button Text",
        translatable: true
    },
    crmText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Text",
        translatable: true
    },
    crmText1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Text 1",
        translatable: true
    },
    crmText2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Text 2",
        translatable: true
    },
    crmText3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Text 3",
        translatable: true
    },
    crmTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Crm Title",
        translatable: true
    },
    devBold1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Bold 1",
        translatable: true
    },
    devBold2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Bold 2",
        translatable: true
    },
    devBold3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Bold 3",
        translatable: true
    },
    devButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Button Text",
        translatable: true
    },
    devPopupButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Popup Button Text",
        translatable: true
    },
    devText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Text",
        translatable: true
    },
    devText1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Text 1",
        translatable: true
    },
    devText2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Text 2",
        translatable: true
    },
    devText3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Text 3",
        translatable: true
    },
    devTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Dev Title",
        translatable: true
    },
    servBold1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Bold 1",
        translatable: true
    },
    servBold2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Bold 2",
        translatable: true
    },
    servBold3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Bold 3",
        translatable: true
    },
    servButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Button Text",
        translatable: true
    },
    servText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Text",
        translatable: true
    },
    servText1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Text 1",
        translatable: true
    },
    servText2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Text 2",
        translatable: true
    },
    servText3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Text 3",
        translatable: true
    },
    servTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Serv Title",
        translatable: true
    },
    subTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Sub Title",
        translatable: true
    },
    svcPopupButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Svc Popup Button Text",
        translatable: true
    },
    tag1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag 1",
        translatable: true
    },
    tag2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag 2",
        translatable: true
    },
    tag3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag 3",
        translatable: true
    },
    tag4: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag 4",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    whitebuttonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Whitebutton Text",
        translatable: true
    },
    wmBold1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Bold 1",
        translatable: true
    },
    wmBold2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Bold 2",
        translatable: true
    },
    wmBold3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Bold 3",
        translatable: true
    },
    wmButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Button Text",
        translatable: true
    },
    wmPopupButtonText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Popup Button Text",
        translatable: true
    },
    wmText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Text",
        translatable: true
    },
    wmText1: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Text 1",
        translatable: true
    },
    wmText2: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Text 2",
        translatable: true
    },
    wmText3: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Text 3",
        translatable: true
    },
    wmTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Wm Title",
        translatable: true
    },
    crmPopupTab1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmPopupTab2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    crmPopupTab3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Crm Popup Tab 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    devPopupTab3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Dev Popup Tab 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    svcPopupTab3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Svc Popup Tab 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab1Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 1 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab2Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 2 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    wmPopupTab3Image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Wm Popup Tab 3 Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    blackButtonLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Black Button Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    crmLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Crm Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    devLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Dev Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    servLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Serv Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    whiteButtonLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "White Button Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    wmLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Wm Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/security-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var security_config = ({
    linktext: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Linktext",
        translatable: true
    },
    text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    link: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/trust-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var trust_config = ({
    forresterLinkText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Forrester Link Text",
        translatable: true
    },
    forresterText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Forrester Text",
        translatable: true
    },
    g2Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "G 2 Text",
        translatable: true
    },
    gartnerLinkText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Gartner Link Text",
        translatable: true
    },
    gartnerText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Gartner Text",
        translatable: true
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        translatable: true
    },
    forresterLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Forrester Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    },
    gartnerLinkLink: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Gartner Link Link",
        fields: {
            href: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "URL",
                translatable: true
            },
            target: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Target",
                translatable: false
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/departments-config.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js

/* harmony default export */ var departments_config = ({
    client1Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 1 Stat",
        translatable: true
    },
    client2Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 2 Stat",
        translatable: true
    },
    client3Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 3 Stat",
        translatable: true
    },
    client4Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 4 Stat",
        translatable: true
    },
    client5Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 5 Stat",
        translatable: true
    },
    client6Stat: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Client 6 Stat",
        translatable: true
    },
    mainTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Main Title",
        translatable: true
    },
    tab1NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Name Client",
        translatable: true
    },
    tab1QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Quote Client",
        translatable: true
    },
    tab1Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Text",
        translatable: true
    },
    tab1TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Text Button",
        translatable: true
    },
    tab1Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Title",
        translatable: true
    },
    tab1TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 1 Title Client",
        translatable: true
    },
    tab2NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Name Client",
        translatable: true
    },
    tab2QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Quote Client",
        translatable: true
    },
    tab2Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Text",
        translatable: true
    },
    tab2TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Text Button",
        translatable: true
    },
    tab2Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Title",
        translatable: true
    },
    tab2TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 2 Title Client",
        translatable: true
    },
    tab3NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Name Client",
        translatable: true
    },
    tab3QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Quote Client",
        translatable: true
    },
    tab3Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Text",
        translatable: true
    },
    tab3TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Text Button",
        translatable: true
    },
    tab3Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Title",
        translatable: true
    },
    tab3TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 3 Title Client",
        translatable: true
    },
    tab4NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Name Client",
        translatable: true
    },
    tab4QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Quote Client",
        translatable: true
    },
    tab4Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Text",
        translatable: true
    },
    tab4TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Text Button",
        translatable: true
    },
    tab4Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Title",
        translatable: true
    },
    tab4TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 4 Title Client",
        translatable: true
    },
    tab5NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Name Client",
        translatable: true
    },
    tab5QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Quote Client",
        translatable: true
    },
    tab5Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Text",
        translatable: true
    },
    tab5TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Text Button",
        translatable: true
    },
    tab5Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Title",
        translatable: true
    },
    tab5TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 5 Title Client",
        translatable: true
    },
    tab6NameClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Name Client",
        translatable: true
    },
    tab6QuoteClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Quote Client",
        translatable: true
    },
    tab6Text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Text",
        translatable: true
    },
    tab6TextButton: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Text Button",
        translatable: true
    },
    tab6Title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Title",
        translatable: true
    },
    tab6TitleClient: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tab 6 Title Client",
        translatable: true
    },
    tab1ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 1 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab1ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 1 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab1ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 1 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 2 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 2 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab2ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 2 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 3 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 3 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab3ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 3 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 4 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 4 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab4ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 4 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 5 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 5 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab5ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 5 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ClientHeadshot: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 6 Client Headshot",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ClientLogo: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 6 Client Logo",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    },
    tab6ImageUrl: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tab 6 Image URL",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Image",
                translatable: false
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)",
                translatable: true
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/departments-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var departments_default_props = ({
    client1Stat: "$4M saved with optimized processes",
    client2Stat: "18x ROI achieved <br /> inthe first year",
    client3Stat: "300% increase in creative output",
    client4Stat: "55 hours saved <br /> per month <br />",
    client5Stat: "28% faster time <br /> to market",
    client6Stat: "11% efficiency gained <br /> per month",
    mainTitle: "Solutions for every team. Powered by one platform.",
    tab1ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/687362114a8e19b70c857667_Jason.png",
        alt: ""
    },
    tab1ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg",
        alt: ""
    },
    tab1ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050978/Generator_featured%20images/hp-2025/departments/bento/drive-execution-at-scale-v4.png",
        alt: "Drive execution at scale"
    },
    tab1NameClient: "Jason Doan",
    tab1QuoteClient: "“monday.com gives us the visibility to get everyone on the same page and track all the moving parts of our projects.”",
    tab1Text: "Deliver projects, programs, and portfolios with full resource visibility and AI-powered risk detection.",
    tab1TextButton: "Get Started",
    tab1Title: "Drive execution at scale",
    tab1TitleClient: "VP of Operations, HOLT CAT",
    tab2ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6873627106c54dca6fa8aeaa_Christopher.png",
        alt: ""
    },
    tab2ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860e2ec0f057ce07046a649_logo-height-kc.png",
        alt: ""
    },
    tab2ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050977/Generator_featured%20images/hp-2025/departments/bento/accelerate-revenue-growth-v4.png",
        alt: "Accelerate revenue growth"
    },
    tab2NameClient: "Christopher Stone",
    tab2QuoteClient: '"“As a VP, trying to look at a 30,000-ft view, I can see the percentage of successful opportunities and know-how to analyze the market.”" <br />',
    tab2Text: "Free your teams from data entry to focus on sales and nurture, with AI actions and code-free automations.",
    tab2TextButton: "Get Started",
    tab2Title: "Accelerate revenue growth",
    tab2TitleClient: "VP Business Development, KC Petroleum",
    tab3ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/65b62e80a3a89609079c247a/670ba85ec4442a965eb743d8_Vic%20Diesta.jpeg",
        alt: ""
    },
    tab3ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg",
        alt: ""
    },
    tab3ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050983/Generator_featured%20images/hp-2025/departments/bento/unify-marketing-to-amplify-impact-v4.png",
        alt: "Amplify marketing impact"
    },
    tab3NameClient: "Vic Diesta",
    tab3QuoteClient: "“monday.com isn’t just another tool in the mix, but a work operating system that supports our need for efficiency at scale.”",
    tab3Text: "Align marketing around shared goals with AI that streamlines briefs, flags delays, and drives campaign impact.",
    tab3TextButton: "Get Started",
    tab3Title: "Amplify marketing impact",
    tab3TitleClient: "Creative Operations Lead, Canva",
    tab4ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f221b5a054ab91f528af_image.png",
        alt: ""
    },
    tab4ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6860f49dd0c89f06fbf3217c_logo-height-zopa.png",
        alt: ""
    },
    tab4ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050985/Generator_featured%20images/hp-2025/departments/bento/scale-exceptiona-service-v4.png",
        alt: "Scale exceptional service"
    },
    tab4NameClient: "Clive Camilleri",
    tab4QuoteClient: '"With monday service, 98% of our tickets are automatically categorized and assigned by AI. We resolve each 6-7 mins faster."',
    tab4Text: "Empower teams to resolve requests faster with AI that triages, routes, and guides each issue to resolution.",
    tab4TextButton: "Get Started",
    tab4Title: "Scale exceptional service",
    tab4TitleClient: "Head of People & Ops, Zopa Bank",
    tab5ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/686f8152e8fbbe7cb4f5c720_departments-headshot-6.png",
        alt: ""
    },
    tab5ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg",
        alt: ""
    },
    tab5ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050979/Generator_featured%20images/hp-2025/departments/bento/launch-quality-products-faster-v4.png",
        alt: "Launch quality products faster"
    },
    tab5NameClient: "Alan Schmoll",
    tab5QuoteClient: '"monday dev ensures clear alignment between what we’re building and market demand. Does it help us move faster? Without a doubt."',
    tab5Text: "Plan roadmaps, execute sprints, and ship with precision using AI-powered guidance.",
    tab5TextButton: "Get Started",
    tab5Title: "Launch quality products faster",
    tab5TitleClient: "Executive VP, Vistra Platform",
    tab6ClientHeadshot: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6840979a2eb950be4600b697_VML-avatar.png",
        alt: ""
    },
    tab6ClientLogo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg",
        alt: ""
    },
    tab6ImageUrl: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1752050981/Generator_featured%20images/hp-2025/departments/bento/lead-with-clear-foresight-v4.webp",
        alt: "Lead with clear foresight"
    },
    tab6NameClient: "Paul Willie",
    tab6QuoteClient: "“Now in real-time, we can identify health metrics and risks, whether they’re coming from our side or the client side.”",
    tab6Text: "Keep strategic goals on track with AI risk flagging and cross-org data to make real-time decisions.",
    tab6TextButton: "Get Started",
    tab6Title: "Lead with clear foresight",
    tab6TitleClient: "COO, VML"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/aiagents-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var aiagents_default_props = ({
    buttonText: "Get Started",
    card1ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-1.avif",
        alt: ""
    },
    card1Text: "Proactively sources, enriches, and scores new leads, 24/7.",
    card1Title: "SDR Expert",
    card2ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-2.avif",
        alt: ""
    },
    card2Text: "Generates market research and trend reports, daily.",
    card2Title: "Competitor Analyzer",
    card3ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-4.avif",
        alt: ""
    },
    card3Text: "Just ask. The assistant handles your work for you.",
    card3Title: "monday sidekick <br />",
    card4ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-3.avif",
        alt: ""
    },
    card4Text: "Flags risks and automates project processes, in real time.",
    card4Title: "Project Assistant",
    card5ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-5.avif",
        alt: ""
    },
    card5Text: "Automatically triages and resolves support tickets.",
    card5Title: "Service Agent",
    card6ImageOnHover: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751804077/Generator_featured%20images/hp-2025/agents/after/hp-ai-board-hp-6.avif",
        alt: ""
    },
    card6Text: "Plans sprints, assigns work, and flags blockers.",
    card6Title: "Scrum Master",
    comingSoon: "Coming soon",
    secondButtonText: "Visit our AI Trust Center",
    subTitle: "Describe the job. Your custom AI assistant is created, ready to work 24/7.",
    title: "Meet your AI assistants"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/aiteamsimpact-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var aiteamsimpact_default_props = ({
    cta: "Learn more about monday's AI offering",
    sectionVisibility: true,
    title: "Your teams’ impact. Multiplied by AI."
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/aiteamsimpactlang-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var aiteamsimpactlang_default_props = ({
    buttonText: "Learn more about monday's AI offering",
    impactTitle: "Your teams’ impact. Multiplied by AI.",
    sectionVisibility: true,
    slide1Title: "Predict risks early",
    slide2Title: "Scale marketing output",
    slide3Title: "Boost sales velocity",
    slide4Title: "Resolve tickets faster",
    slide5Title: "Drive quality sprints",
    tab1Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab2Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab3Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab4Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    },
    tab5Image: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68f495e6a755bfe36047f776_Screenshot%202025-10-19%20at%2010.40.10.png",
        alt: ""
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/casestudies-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var casestudies_default_props = ({
    buttonText: "Contact sales",
    case1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-1.avif",
        alt: ""
    },
    case1Link: "See the case study",
    case1Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734d99fde1ee8d76038_logo-height-mcdonalds.svg",
        alt: ""
    },
    case1Number: "615%",
    case1Tag: "Retail & CPG",
    case2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-2.avif",
        alt: ""
    },
    case2Link: "See the case study",
    case2Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973449a1ded6476c7c6b_logo-height-holt.svg",
        alt: ""
    },
    case2Number: "105K",
    case2Tag: "Manufacturing",
    case2Text: "Hours saved annually ",
    case2UrlLink: {
        href: "https://www.youtube.com/watch?v=OU1IVTMX4ZI",
        target: "_self"
    },
    case3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-3.avif",
        alt: ""
    },
    case3Link: "See the case study",
    case3Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734adc281438a689cd3_logo-height-canva.svg",
        alt: ""
    },
    case3Number: "300%",
    case3Tag: "Advertising",
    case3Text: "Saved yearly to reinvest",
    case3UrlLink: {
        href: "https://monday.com/w/customer-stories/canva",
        target: "_self"
    },
    case4Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-4.avif",
        alt: ""
    },
    case4Link: "See the case study",
    case4Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/6859973471a781f640b90d09_logo-height-vistra.svg",
        alt: ""
    },
    case4Number: "28%",
    case4Tag: "Technology",
    case4Text: "Faster time to market",
    case4UrlLink: {
        href: "https://monday.com/w/customer-stories/vistra",
        target: "_self"
    },
    case5Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-5.avif",
        alt: ""
    },
    case5Link: "See the case study",
    case5Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997346fd24ab09e1a1264_logo-height-universal.svg",
        alt: ""
    },
    case5Number: "517%",
    case5Tag: "Entertainment",
    case5Text: "Growth in annual accounts",
    case5UrlLink: {
        href: "https://www.youtube.com/watch?v=qytqG3VwLlg",
        target: "_self"
    },
    case6Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-6.avif",
        alt: ""
    },
    case6Link: "See the case study",
    case6Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734e774c48a76e64d64_logo-height-compass.svg",
        alt: ""
    },
    case6Number: "$173K",
    case6Tag: "Real estate",
    case6Text: "Saved per month",
    case6UrlLink: {
        href: "https://monday.com/w/customer-stories/compass",
        target: "_self"
    },
    case7Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-7.avif",
        alt: ""
    },
    case7Link: "See the case study",
    case7Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734447ec43a43f5474e_logo-height-vml.svg",
        alt: ""
    },
    case7Number: "$250K",
    case7Tag: "Advertising",
    case7Text: "Saved yearly to reinvest",
    case7UrlLink: {
        href: "https://monday.com/w/customer-stories/vml",
        target: "_self"
    },
    case8Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-8.avif",
        alt: ""
    },
    case8Link: "See the case study",
    case8Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/68599734626e8d76fb98b8ef_logo-height-callbox.svg",
        alt: ""
    },
    case8Number: "66%",
    case8Tag: "Technology",
    case8Text: "Decrease in post-release bugs",
    case8UrlLink: {
        href: "https://monday.com/w/customer-stories/call-box",
        target: "_self"
    },
    case9Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750420516/Generator_featured%20images/hp-2025/hp_cusromers-srory-9.avif",
        alt: ""
    },
    case9Link: "See the case study",
    case9Logo: {
        src: "https://cdn.prod.website-files.com/6836d5600e01e03c6cdf81d6/685997344e69395c270955c1_logo-height-deezer.svg",
        alt: ""
    },
    case9Number: "142%",
    case9Tag: "Technology",
    case9Text: "More weekly campaigns",
    case9UrlLink: {
        href: "https://monday.com/w/customer-stories/deezer",
        target: "_self"
    },
    title: "Leading brands drive efficient growth with monday.com"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/closerllama-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var closerllama_default_props = ({
    blackButtonLink: {
        href: "/sales/contact-us",
        target: "_self"
    },
    blackButtonText: "Contact Sales",
    title: "The AI work platform your team will love to use",
    whiteButtonText: "Get Started"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/mondaydifference-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var mondaydifference_default_props = ({
    card1ClientTitle: "Senior Director of Product Innovation, Zippo",
    card1Testimonial: ' It’ll take its shape and wrap around whatever you need it to do."',
    card1Text: "Build custom workflows with a no-code interface, while defining admin controls to maintain cross-org consistency.",
    card1Title: "Flexible yet standardized",
    card2ClientTitle: "Global Client Solutions Director, Black Mountain",
    card2Testimonial: "Almost immediately, we hear ' and how much value it brings.\"'",
    card2Text: "Onboard your entire organization with intuitive products they’ll love to use.",
    card2Title: "Products teams love to use",
    card3ClientTitle: "Director of Treasury, Citizens Bank <br />",
    card3Testimonial: " It's like an iPhone in a way in that you just know how and what you want to do next.\\",
    card3Text: "See value fast with products that are quick to implement and even easier to learn.",
    card3Title: "Fast time to value",
    customer1Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-3.png",
        alt: ""
    },
    customer1Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-1.png",
        alt: ""
    },
    customer2Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-2.png",
        alt: ""
    },
    customer2Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-2.png",
        alt: ""
    },
    customer3Headshot: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332192/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-customer-headshot-1.png",
        alt: ""
    },
    customer3Logo: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1750332191/growth-marketing/web-experience/hp-jun-25/monday-difference/diff-logo-3.png",
        alt: ""
    },
    title: "The monday.com difference"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/products-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var products_default_props = ({
    blackButtonLink: {
        href: "#",
        target: "_self"
    },
    blackButtonText: "Get Started",
    crmBold1: "AI deal prioritization",
    crmBold2: "Connected communication",
    crmBold3: "Post-sales & account management",
    crmButtonText: "Learn more",
    crmLink: {
        href: "#",
        target: "_self"
    },
    crmPopupButtonText: "Get Started",
    crmPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/AI_deal_prioritization.avif",
        alt: ""
    },
    crmPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Connected_communication.avif",
        alt: ""
    },
    crmPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Post-sales_account_management.avif",
        alt: ""
    },
    crmText: "Automate full customer journeys with AI actions",
    crmText1: "Score deal health and close probability with monday CRM, so teams can focus on converting.",
    crmText2: '"Centralize outreach, lead activity, and performance analytics, so nothing falls through the cracks." <br />',
    crmText3: "Monitor account health, communicate and engage <br /> with clients to nurture key relationships.",
    crmTitle: "Automate full customer journeys with AI actions",
    devBold1: "AI developer assistance",
    devBold2: "Multi-method execution <br />",
    devBold3: "Agile insights",
    devButtonText: "Learn more",
    devLink: {
        href: "#",
        target: "_self"
    },
    devPopupButtonText: "Get Started",
    devPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/AI_developer_assistant.avif",
        alt: ""
    },
    devPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281665/Generator_featured%20images/hp-2025/products/popup-assets/Sprint_management.avif",
        alt: ""
    },
    devPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751281664/Generator_featured%20images/hp-2025/products/popup-assets/Agile_insights.avif",
        alt: ""
    },
    devText: "Ship quality software with AI-guided sprints",
    devText1: "Resolve bugs and incidents faster with AI-surfaced context on related code, tasks, and documentation.",
    devText2: "Run sprints with Scrum, Kanban, or hybrid methods to move faster without admin blocks.",
    devText3: "Get real-time metrics like cycle time and sprint <br /> velocity to ensure predictable delivery.",
    devTitle: "Ship quality software with AI-guided sprints",
    servBold1: "AI ticket triage",
    servBold2: "AI ticket resolutions",
    servBold3: "Customer portal",
    servButtonText: "Learn more",
    servLink: {
        href: "#",
        target: "_self"
    },
    servText: "Deliver standout service with AI ticket handling",
    servText1: "Automatically categorize, prioritize, and route tickets <br /> with AI to speed up resolution times.",
    servText2: "Resolve repetitive requests instantly with AI-powered auto-replies based on past cases.",
    servText3: "Launch a dynamic portal for users to submit requests, track tickets, and access self-serve resources.",
    servTitle: "Deliver standout service with AI ticket handling",
    subTitle: "Each product solves departmental needs, and together, they power seamless operations across your organization.",
    svcPopupButtonText: "Get Started",
    svcPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/triage-v2.avif",
        alt: ""
    },
    svcPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751885866/Generator_featured%20images/hp-2025/products/popup-assets/AI_ticket_resolutions-v2.avif",
        alt: ""
    },
    svcPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751528122/Generator_featured%20images/hp-2025/products/Customer_portal.avif",
        alt: ""
    },
    tag1: "Sales",
    tag2: "Engineering",
    tag3: "IT",
    tag4: "Marketing",
    title: "Solve work challenges <br /> with AI-first products",
    whiteButtonLink: {
        href: "/sales/contact-us",
        target: "_self"
    },
    whitebuttonText: "Request a demo",
    wmBold1: "AI-powered risk identification",
    wmBold2: "Project and portfolio management",
    wmBold3: "Resource management",
    wmButtonText: "Learn more",
    wmLink: {
        href: "#",
        target: "_self"
    },
    wmPopupButtonText: "Get Started",
    wmPopupTab1Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751872278/Generator_featured%20images/hp-2025/products/popup-assets/ai-powered-risk-identification-v2.avif",
        alt: ""
    },
    wmPopupTab2Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751885711/Generator_featured%20images/hp-2025/products/popup-assets/Project_and_portfolio_management-v3-.avif",
        alt: ""
    },
    wmPopupTab3Image: {
        src: "https://dapulse-res.cloudinary.com/image/upload/v1751538698/Generator_featured%20images/hp-2025/products/popup-assets/resource-managment-v4.avif",
        alt: ""
    },
    wmText: "Drive projects and processes forward with AI insights",
    wmText1: "Use AI to flag risks early to make informed decisions across your entire portfolio.",
    wmText2: "Gain visibility into risks and dependencies to ensure fast and precise project delivery.",
    wmText3: "Use AI to assign the right people to every project based on skills, availability, and real-time capacity.",
    wmTitle: "Drive projects and processes forward with AI insights"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/security-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var security_default_props = ({
    link: {
        href: "https://monday.com/trustcenter",
        target: "_self"
    },
    linktext: "Explore our Trust Center",
    text: "Keep your company's data secure and compliant with industry-leading security standards and certifications.",
    title: "Enterprise-grade security"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/default-props/trust-default-props.js
// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
/* harmony default export */ var trust_default_props = ({
    forresterLink: {
        href: "https://monday.com/lp/motorola-forrester-report",
        target: "_self"
    },
    forresterLinkText: "Learn more",
    forresterText: "Motorola achieved 346% ROI according to Forrester’s Total Economic Impact™ research.",
    g2Text: "Leader in the <br /> G2 Enterprise Grid\xae Report Spring 2025",
    gartnerLinkLink: {
        href: "https://monday.com/w/gartner-mq/leader-3x",
        target: "_self"
    },
    gartnerLinkText: "Learn more",
    gartnerText: "The only Leader in 3 Work Management Gartner\xae Magic Quadrant™ reports.",
    title: "A leader you can trust"
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/components/devlink-magic/devlink-magic-config.js

var CTA_COLORS = {
    MAGIC: "Base",
    PURPLE: "Purple"
};
/* harmony default export */ var devlink_magic_config = ({
    mainHeadlineText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Header",
        translatable: true
    },
    subHeadline: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Subheader",
        translatable: true
    },
    runningPrompts: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Running prompts",
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                text: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Prompt text",
                    translatable: true
                }
            }
        }
    },
    tagsTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tags title",
        translatable: true
    },
    tags: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tags",
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                tagText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                tagPrompt: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Prompt",
                    translatable: true
                }
            }
        }
    },
    cta: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Magic CTA",
        fields: {
            text: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "CTA text",
                translatable: true
            },
            color: {
                type: template_field_type.FIELD_TYPES.COMBO,
                label: "Color",
                options: [
                    {
                        value: CTA_COLORS.MAGIC,
                        text: "Magic"
                    },
                    {
                        value: CTA_COLORS.PURPLE,
                        text: "Purple"
                    }
                ]
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/components/l-hero-hover/l-hero-hover-config.js

/* harmony default export */ var l_hero_hover_config = ({
    creditCardVisibility: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show main CTA additional text"
    },
    whatWouldVisibility: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show CTA subtitle text"
    }
});

// EXTERNAL MODULE: ./client/components/system/monday-markup-language/monday-markup-language-component.js + 11 modules
var monday_markup_language_component = __webpack_require__(36239);
;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/components/devlink-magic/utils.js



var RUNNING_PROMPTS_SEPARATOR = "|";
var convertToMagicTag = function(tag, tagIndex) {
    var _obj;
    return _obj = {}, (0,src_define_property/* default */.Z)(_obj, "tag".concat(tagIndex + 1, "Text"), tag.tagText), (0,src_define_property/* default */.Z)(_obj, "tag".concat(tagIndex + 1, "Prompt"), tag.tagPrompt), (0,src_define_property/* default */.Z)(_obj, "tag".concat(tagIndex + 1, "Visibility"), true), _obj;
};
var wrapTextInMarkupLanguage = function(text) {
    return text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(monday_markup_language_component/* default */.Z, {
        text: text
    }) : undefined;
};
var getRunningPromptsText = function(runningPrompts) {
    if (!runningPrompts || !Array.isArray(runningPrompts)) {
        return "";
    }
    return runningPrompts.map(function(prompt) {
        return prompt.text;
    }).join(RUNNING_PROMPTS_SEPARATOR);
};

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/components/devlink-magic/default-props.js
/* harmony default export */ var default_props = ({
    termsAndConditions: {
        href: "https://monday.com/l/legal/ai/",
        target: "_blank"
    },
    termOfService: {
        href: "https://monday.com/trustcenter",
        target: "_blank"
    },
    privacyPolicy: {
        href: "https://monday.com/l/privacy/privacy-policy/",
        target: "_blank"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/components/devlink-magic/devlink-magic-component.js
function devlink_magic_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function devlink_magic_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            devlink_magic_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function devlink_magic_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function devlink_magic_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        devlink_magic_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function devlink_magic_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = devlink_magic_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function devlink_magic_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





function DevlinkMagicComponent(_param) {
    var _tags = _param.tags, tags = _tags === void 0 ? [] : _tags, runningPrompts = _param.runningPrompts, mainHeadlineText = _param.mainHeadlineText, subHeadline = _param.subHeadline, tagsTitle = _param.tagsTitle, cta = _param.cta, props = devlink_magic_component_object_without_properties(_param, [
        "tags",
        "runningPrompts",
        "mainHeadlineText",
        "subHeadline",
        "tagsTitle",
        "cta"
    ]);
    var magicTags = (0,react.useMemo)(function() {
        return tags.reduce(function(acc, tag, index) {
            return devlink_magic_component_object_spread({}, acc, convertToMagicTag(tag, index));
        }, {});
    }, [
        tags
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Magic, devlink_magic_component_object_spread(devlink_magic_component_object_spread_props(devlink_magic_component_object_spread({}, props), {
        variant: cta === null || cta === void 0 ? void 0 : cta.color,
        runningPrompts: getRunningPromptsText(runningPrompts),
        mainHeadlineText: wrapTextInMarkupLanguage(mainHeadlineText),
        subHeadline: wrapTextInMarkupLanguage(subHeadline),
        tagsTitle: wrapTextInMarkupLanguage(tagsTitle),
        ctaText: wrapTextInMarkupLanguage(cta === null || cta === void 0 ? void 0 : cta.text)
    }), magicTags));
}
DevlinkMagicComponent.defaultProps = default_props;
/* harmony default export */ var devlink_magic_component = (DevlinkMagicComponent);

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/configs/hero-fu-config.js

/* harmony default export */ var hero_fu_config = ({
    variant: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Color",
        options: [
            {
                value: "Base",
                text: "Base"
            },
            {
                value: "PurpleCTA",
                text: "Purple"
            }
        ]
    }
});

;// CONCATENATED MODULE: ./segments/desktop/devlink/layouts/dynamic-devlink/constants/devlink-component-types.js


























var DEVLINK_COMPONENT_CONFIGS = {
    Hero: {
        component: Hero,
        props: {
            buttonBottomLabel: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Button Bottom Label",
                translatable: true
            },
            buttonLabelVisibility: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Button Label"
            }
        }
    },
    HeroFu: {
        component: HeroFu,
        props: hero_fu_config
    },
    Products: {
        component: Products,
        props: products_config,
        defaultProps: products_default_props
    },
    Departments: {
        component: Departments,
        props: departments_config,
        defaultProps: departments_default_props
    },
    DepartmentsProjectsTest: {
        component: DepartmentsProjectsTest,
        props: {}
    },
    AiTeamsImpact: {
        component: AiTeamsImpact,
        props: aiteamsimpact_config,
        defaultProps: aiteamsimpact_default_props
    },
    AiTeamsImpactLang: {
        component: AiTeamsImpactLang,
        props: aiteamsimpactlang_config,
        defaultProps: aiteamsimpactlang_default_props
    },
    Trust: {
        component: Trust,
        props: trust_config,
        defaultProps: trust_default_props
    },
    Security: {
        component: Security,
        props: security_config,
        defaultProps: security_default_props
    },
    AiAgents: {
        component: AiAgents,
        props: aiagents_config,
        defaultProps: aiagents_default_props
    },
    CaseStudies: {
        component: CaseStudies,
        props: casestudies_config,
        defaultProps: casestudies_default_props
    },
    MondayDifference: {
        component: MondayDifference,
        props: mondaydifference_config,
        defaultProps: mondaydifference_default_props
    },
    Closer: {
        component: Closer,
        props: {}
    },
    Logos: {
        component: Logos,
        props: {}
    },
    Magic: {
        component: devlink_magic_component,
        props: devlink_magic_config
    },
    BrightHeroLeftPannel: {
        component: BrightHeroLeftPannel,
        props: {}
    },
    CloserLlama: {
        component: CloserLlama,
        props: closerllama_config,
        defaultProps: closerllama_default_props
    },
    LotemHero: {
        component: LotemHero,
        props: {}
    },
    CrmNav: {
        component: CrmNav,
        props: {}
    },
    LHeroHover: {
        component: LHeroHover,
        props: l_hero_hover_config
    },
    LHeroVideos: {
        component: LHeroVideos,
        props: {}
    },
    HeroEldadVarB: {
        component: HeroEldadVarB,
        props: {}
    },
    HeroEldadVarC: {
        component: HeroEldadVarC,
        props: {}
    },
    ShorterHero1: {
        component: ShorterHero1,
        props: {}
    },
    ShorterHero2: {
        component: ShorterHero2,
        props: {}
    },
    Gartner: {
        component: Gartner,
        props: {}
    },
    TrustNav: {
        component: TrustNav,
        props: {}
    },
    HeroV8LeftPannel: {
        component: HeroV8LeftPannel,
        props: {}
    },
    HeroV8OldImages: {
        component: HeroV8OldImages,
        props: {}
    }
};


/***/ }),

/***/ 16848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var _constants_devlink_component_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58975);


/**
 * Dynamically generates default props for all Devlink components.
 * Reads from DEVLINK_COMPONENT_CONFIGS as single source of truth.
 * Creates lowercase component keys matching runtime behavior.
 * 
 * Example result: { componentType: "Departments", departments: {...}, products: {...}, aiagents: {...} }
 */ var buildDevlinkDefaultProps = function() {
    var defaultProps = {
        componentType: "Departments"
    };
    Object.entries(_constants_devlink_component_types__WEBPACK_IMPORTED_MODULE_0__/* .DEVLINK_COMPONENT_CONFIGS */ .N).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 2), componentName = _param[0], config = _param[1];
        if (config.defaultProps) {
            var componentKey = componentName.toLowerCase();
            defaultProps[componentKey] = config.defaultProps;
        }
    });
    return defaultProps;
};
/* harmony default export */ __webpack_exports__["Z"] = ({
    devlinkComponent: buildDevlinkDefaultProps()
});


/***/ }),

/***/ 95129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ embedded; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/contact-options-embedded/contact-options-embedded-config.js
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var buttonTopMargin = fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, textColor = fields_config/* default.textColor */.Z.textColor, topicBottomMargin = fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonConfig = fields_config/* default.buttonConfig */.Z.buttonConfig, assetUnderParagraph = fields_config/* default.assetUnderParagraph */.Z.assetUnderParagraph, restOfParagraphConfig = _object_without_properties(fields_config/* default */.Z, [
    "buttonTopMargin",
    "textColor",
    "topicBottomMargin",
    "buttonConfig",
    "assetUnderParagraph"
]);
/* harmony default export */ var contact_options_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Contact Options",
    fields: {
        howToConnectParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: restOfParagraphConfig
        },
        getCallButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Get a call button text",
            defaultValue: "Get a call now"
        },
        setMeetingButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Book a meeting button text",
            defaultValue: "Book a meeting"
        },
        setMeetingUrl: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "url to redirect for book a meeting",
            defaultValue: "/sales/book-a-meeting"
        },
        getCallThankYouUrl: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "url to redirect after get a call click",
            defaultValue: "/sales/thank-you-get-call"
        },
        minAmandaCallLoadingTime: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Time for the Amanda Fetch call (in milliseconds)",
            defaultValue: "2000"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/contact-options-embedded/contact-options-embedded-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var contact_options_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        enableLoader: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Enable loader"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/contact-options-embedded/index.js

var ContactOptionsEmbeddedComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8962).then(__webpack_require__.bind(__webpack_require__, 58962));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58962)
            ];
        }
    }
});


/* harmony default export */ var contact_options_embedded = ({
    ContactOptionsEmbeddedComponent: ContactOptionsEmbeddedComponent,
    ContactOptionsEmbeddedConfig: contact_options_embedded_config,
    ContactOptionsEmbeddedAdvancedConfig: contact_options_embedded_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/book-a-meeting-embedded/book-a-meeting-embedded-config.js
function book_a_meeting_embedded_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = book_a_meeting_embedded_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function book_a_meeting_embedded_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var book_a_meeting_embedded_config_buttonTopMargin = fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, book_a_meeting_embedded_config_textColor = fields_config/* default.textColor */.Z.textColor, book_a_meeting_embedded_config_topicBottomMargin = fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, book_a_meeting_embedded_config_buttonConfig = fields_config/* default.buttonConfig */.Z.buttonConfig, book_a_meeting_embedded_config_assetUnderParagraph = fields_config/* default.assetUnderParagraph */.Z.assetUnderParagraph, book_a_meeting_embedded_config_restOfParagraphConfig = book_a_meeting_embedded_config_object_without_properties(fields_config/* default */.Z, [
    "buttonTopMargin",
    "textColor",
    "topicBottomMargin",
    "buttonConfig",
    "assetUnderParagraph"
]);
/* harmony default export */ var book_a_meeting_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Book A Meeting",
    fields: {
        findTimeParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Find Time Full Paragraph",
            fields: book_a_meeting_embedded_config_restOfParagraphConfig
        },
        bookingConfirmedParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Booking Confirmed Full Paragraph",
            fields: book_a_meeting_embedded_config_restOfParagraphConfig
        },
        anotherOptionParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Another Option Paragraph",
            fields: paragraph_fields_config/* default */.Z
        },
        fallbackUrl: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Fallback url"
        },
        hyperLink: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Hyperlink",
            fields: {
                text: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text",
                    translatable: true
                },
                href: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "href"
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/desktop/embedded/layouts/book-a-meeting-embedded/book-a-meeting-embedded-consts.js
var book_a_meeting_embedded_consts = __webpack_require__(82420);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/book-a-meeting-embedded/book-a-meeting-embedded-advanced-config.js
function book_a_meeting_embedded_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function book_a_meeting_embedded_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            book_a_meeting_embedded_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function book_a_meeting_embedded_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function book_a_meeting_embedded_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        book_a_meeting_embedded_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var book_a_meeting_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: book_a_meeting_embedded_advanced_config_object_spread_props(book_a_meeting_embedded_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        anotherOptionAdvancedParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Another Option Paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        backToConnectUrl: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Back to connect URL",
            defaultValue: book_a_meeting_embedded_consts/* BACK_BUTTON_URL_DEFAULT */.Pb
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/book-a-meeting-embedded/index.js

var BookAMeetingEmbeddedComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9058).then(__webpack_require__.bind(__webpack_require__, 69058));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69058)
            ];
        }
    }
});


/* harmony default export */ var book_a_meeting_embedded = ({
    BookAMeetingEmbeddedComponent: BookAMeetingEmbeddedComponent,
    BookAMeetingEmbeddedConfig: book_a_meeting_embedded_config,
    BookAMeetingEmbeddedAdvancedConfig: book_a_meeting_embedded_advanced_config
});

// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-config.js


/* harmony default export */ var whats_new_items_list_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Whats New Items List",
    fields: {
        productFilterValue: {
            label: "Product Filter Value",
            type: template_field_type.FIELD_TYPES.COMBO,
            options: products/* PRODUCT_OPTIONS */.ey
        },
        hideProductFilter: {
            label: "Hide Product Filter",
            type: template_field_type.FIELD_TYPES.BOOLEAN
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-advanced-config.js
function whats_new_items_list_embedded_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_items_list_embedded_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_items_list_embedded_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var whats_new_items_list_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: whats_new_items_list_embedded_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./server/services/monday-service/monday-api-service.js
var monday_api_service = __webpack_require__(42495);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/whats-new-items-list-embedded-dynamics-fetch.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var BOARD_ID = 3749556763;
var query = "{\n  boards(ids: ".concat(BOARD_ID, ") {\n    items_page (limit: 500) {\n      items {\n        name\n        column_values {\n          id\n          column{title}\n          value\n        }\n      }\n    }\n  }\n}");
/* harmony default export */ var whats_new_items_list_embedded_dynamics_fetch = ([
    {
        propsPropertyName: "mondayConfig",
        shouldFetch: function() {
            return false;
        },
        fetch: /*#__PURE__*/ _async_to_generator(function() {
            var mondayConfig, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,monday_api_service.getMondayConfig)({
                                query: query,
                                boardId: BOARD_ID
                            })
                        ];
                    case 1:
                        mondayConfig = _state.sent();
                        return [
                            2,
                            mondayConfig
                        ];
                    case 2:
                        e = _state.sent();
                        esm_exports/* captureMessage */.uT("What's new embedded component api call failed: ".concat(e.message));
                        return [
                            2,
                            null
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/whats-new-items-list-embedded/index.js

var WhatsNewItemsListEmbeddedComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3966), __webpack_require__.e(9832)]).then(__webpack_require__.bind(__webpack_require__, 12357));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12357)
            ];
        }
    }
});



/* harmony default export */ var whats_new_items_list_embedded = ({
    WhatsNewItemsListEmbeddedComponent: WhatsNewItemsListEmbeddedComponent,
    WhatsNewItemsListEmbeddedConfig: whats_new_items_list_embedded_config,
    WhatsNewItemsListEmbeddedAdvancedConfig: whats_new_items_list_embedded_advanced_config,
    WhatsNewItemsListEmbeddedDynamicsFetch: whats_new_items_list_embedded_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/markdown/fields-config.js

/* harmony default export */ var markdown_fields_config = ({
    input: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Markdown content",
        textArea: true,
        rows: 15
    }
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-config.js
function markdown_embedded_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function markdown_embedded_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            markdown_embedded_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var markdown_embedded_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Markdown",
    fields: markdown_embedded_config_object_spread({}, markdown_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/markdown-embedded-advanced-config.js
function markdown_embedded_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function markdown_embedded_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            markdown_embedded_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var markdown_embedded_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: markdown_embedded_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/markdown-embedded/index.js



var MarkdownEmbeddedComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8840).then(__webpack_require__.bind(__webpack_require__, 8840));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8840)
            ];
        }
    }
});
/* harmony default export */ var markdown_embedded = ({
    MarkdownEmbeddedComponent: MarkdownEmbeddedComponent,
    MarkdownEmbeddedConfig: markdown_embedded_config,
    MarkdownEmbeddedAdvancedConfig: markdown_embedded_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/layouts/index.js
// plop_marker:layouts_import




/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ContactOptionsEmbedded: contact_options_embedded,
    BookAMeetingEmbedded: book_a_meeting_embedded,
    WhatsNewItemsListEmbedded: whats_new_items_list_embedded,
    MarkdownEmbedded: markdown_embedded
});

;// CONCATENATED MODULE: ./segments/desktop/embedded/index.js

var ContactOptionsEmbedded = layouts.ContactOptionsEmbedded, BookAMeetingEmbedded = layouts.BookAMeetingEmbedded, WhatsNewItemsListEmbedded = layouts.WhatsNewItemsListEmbedded, MarkdownEmbedded = layouts.MarkdownEmbedded;
/* harmony default export */ var embedded = ({
    // plop_marker:segment_index_add_layout
    ContactOptionsEmbeddedComponent: {
        type: "ContactOptionsEmbeddedComponent",
        title: "Contact Options",
        imgSrc: "/static/img/segments/layouts/contact-options-embedded.png",
        config: ContactOptionsEmbedded.ContactOptionsEmbeddedConfig,
        advancedConfig: ContactOptionsEmbedded.ContactOptionsEmbeddedAdvancedConfig,
        component: ContactOptionsEmbedded.ContactOptionsEmbeddedComponent
    },
    BookAMeetingEmbeddedComponent: {
        type: "BookAMeetingEmbeddedComponent",
        title: "Book A Meeting",
        imgSrc: "/static/img/segments/layouts/book-a-meeting-embedded.png",
        config: BookAMeetingEmbedded.BookAMeetingEmbeddedConfig,
        advancedConfig: BookAMeetingEmbedded.BookAMeetingEmbeddedAdvancedConfig,
        component: BookAMeetingEmbedded.BookAMeetingEmbeddedComponent
    },
    WhatsNewItemsListEmbeddedComponent: {
        type: "WhatsNewItemsListEmbeddedComponent",
        title: "Whats New Items List",
        imgSrc: "/static/img/segments/layouts/whats-new-items-list-embedded.png",
        config: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedConfig,
        advancedConfig: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedAdvancedConfig,
        component: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedComponent,
        dynamicsFetch: WhatsNewItemsListEmbedded.WhatsNewItemsListEmbeddedDynamicsFetch
    },
    MarkdownEmbeddedComponent: {
        type: "MarkdownEmbeddedComponent",
        title: "Markdown",
        imgSrc: "/static/img/segments/layouts/markdown-embedded.png",
        config: MarkdownEmbedded.MarkdownEmbeddedConfig,
        advancedConfig: MarkdownEmbedded.MarkdownEmbeddedAdvancedConfig,
        component: MarkdownEmbedded.MarkdownEmbeddedComponent
    }
});


/***/ }),

/***/ 82420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JF": function() { return /* binding */ CHILIPIPER_TIMEOUT; },
/* harmony export */   "PB": function() { return /* binding */ IFRAME_HEIGHT; },
/* harmony export */   "Pb": function() { return /* binding */ BACK_BUTTON_URL_DEFAULT; },
/* harmony export */   "Yt": function() { return /* binding */ CHILIPIPER_URL; },
/* harmony export */   "aK": function() { return /* binding */ CHILLI_PIPER_EVENT_ACTION_KEY; },
/* harmony export */   "bq": function() { return /* binding */ THANK_YOU_PAGE; },
/* harmony export */   "el": function() { return /* binding */ CHILLI_PIPER_EVENTS; },
/* harmony export */   "id": function() { return /* binding */ IFRAME_WIDTH; },
/* harmony export */   "yV": function() { return /* binding */ CHILIPIPER_LINK_TIMESTAMP; }
/* harmony export */ });
var CHILIPIPER_URL = "chilipiperUrl";
var CHILIPIPER_TIMEOUT = "chilipiperTimeout";
var CHILIPIPER_LINK_TIMESTAMP = "chilipiperLinkTimestamp";
var THANK_YOU_PAGE = "/contact-sales-thank-you";
var BACK_BUTTON_URL_DEFAULT = "/test/get-a-call";
var CHILLI_PIPER_EVENT_ACTION_KEY = "action";
var IFRAME_WIDTH = 740;
var IFRAME_HEIGHT = 600;
var CHILLI_PIPER_EVENTS = {
    BOOKING_CONFIRMED: "booking-confirmed",
    RESCHEDULED: "rescheduled",
    AVAILABILITY_LOADED: "availability-loaded"
};


/***/ }),

/***/ 26647:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ enterprise; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var proof_and_badges_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Proof And Badges",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        proofsSection: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Proofs Section",
            fields: {
                backgroundImage: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Background Image"
                },
                proofs: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Proofs",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: _object_spread({}, fields_config/* default */.Z, advanced_fields_config/* default */.Z)
                    }
                }
            }
        },
        badgesSection: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Badges Section",
            fields: {
                badgesSections: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Badges Sections",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            icon: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Icon"
                            },
                            title: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Title"
                            },
                            description: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Description"
                            },
                            badges: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Badges",
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        badgeImage: {
                                            type: template_field_type.FIELD_TYPES.GALLERY,
                                            label: "Badge"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/proof-and-badges-enterprise-advanced-config.js
function proof_and_badges_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function proof_and_badges_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            proof_and_badges_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function proof_and_badges_enterprise_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function proof_and_badges_enterprise_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        proof_and_badges_enterprise_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var proof_and_badges_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: proof_and_badges_enterprise_advanced_config_object_spread_props(proof_and_badges_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        sideBySideAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Side by side advanced props",
            fields: proof_and_badges_enterprise_advanced_config_object_spread({}, advanced_field_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/proof-and-badges-enterprise/index.js

var ProofAndBadgesEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8451).then(__webpack_require__.bind(__webpack_require__, 68451));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68451)
            ];
        }
    }
});


/* harmony default export */ var proof_and_badges_enterprise = ({
    ProofAndBadgesEnterpriseComponent: ProofAndBadgesEnterpriseComponent,
    ProofAndBadgesEnterpriseConfig: proof_and_badges_enterprise_config,
    ProofAndBadgesEnterpriseAdvancedConfig: proof_and_badges_enterprise_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button-tag/fields-config.js
var button_tag_fields_config = __webpack_require__(24662);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/sales-phone-enterprise-config.js
function sales_phone_enterprise_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sales_phone_enterprise_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sales_phone_enterprise_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function sales_phone_enterprise_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function sales_phone_enterprise_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        sales_phone_enterprise_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var sales_phone_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sales Phone (NOT DISPLAYED IN THE US)",
    fields: sales_phone_enterprise_config_object_spread_props(sales_phone_enterprise_config_object_spread({}, title_fields_config/* default */.Z), {
        phoneLinks: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Phone numbers",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: sales_phone_enterprise_config_object_spread({}, button_tag_fields_config/* default */.Z)
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/sales-phone-enterprise-advanced-config.js
function sales_phone_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sales_phone_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sales_phone_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var sales_phone_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sales_phone_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/sales-phone-enterprise/index.js



var SalesPhoneEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7398).then(__webpack_require__.bind(__webpack_require__, 7398));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7398)
            ];
        }
    }
});
/* harmony default export */ var sales_phone_enterprise = ({
    SalesPhoneEnterpriseComponent: SalesPhoneEnterpriseComponent,
    SalesPhoneEnterpriseConfig: sales_phone_enterprise_config,
    SalesPhoneEnterpriseAdvancedConfig: sales_phone_enterprise_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-config.js
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}


var selectedFullParagraphFields = _extends({}, _object_destructuring_empty(fields_config/* default */.Z));
/* harmony default export */ var asymmetric_enterprise_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Asymmetric",
    fields: {
        topColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Top Color"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/asymmetric-enterprise-advanced-config.js
function asymmetric_enterprise_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_enterprise_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_enterprise_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var asymmetric_enterprise_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: asymmetric_enterprise_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/asymmetric-enterprise/index.js



var AsymmetricEnterpriseComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3640).then(__webpack_require__.bind(__webpack_require__, 43640));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43640)
            ];
        }
    }
});
/* harmony default export */ var asymmetric_enterprise = ({
    AsymmetricEnterpriseComponent: AsymmetricEnterpriseComponent,
    AsymmetricEnterpriseConfig: asymmetric_enterprise_config,
    AsymmetricEnterpriseAdvancedConfig: asymmetric_enterprise_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/layouts/index.js
// plop_marker:layouts_import



/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ProofAndBadgesEnterprise: proof_and_badges_enterprise,
    SalesPhoneEnterprise: sales_phone_enterprise,
    AsymmetricEnterprise: asymmetric_enterprise
});

;// CONCATENATED MODULE: ./segments/desktop/enterprise/index.js

var ProofAndBadgesEnterprise = layouts.ProofAndBadgesEnterprise, SalesPhoneEnterprise = layouts.SalesPhoneEnterprise, AsymmetricEnterprise = layouts.AsymmetricEnterprise;
/* harmony default export */ var enterprise = ({
    // plop_marker:segment_index_add_layout
    ProofAndBadgesEnterpriseComponent: {
        type: "ProofAndBadgesEnterpriseComponent",
        title: "Proof And Badges",
        imgSrc: "/static/img/segments/layouts/proof-and-badges-enterprise.png",
        config: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseConfig,
        advancedConfig: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseAdvancedConfig,
        component: ProofAndBadgesEnterprise.ProofAndBadgesEnterpriseComponent
    },
    SalesPhoneEnterpriseComponent: {
        type: "SalesPhoneEnterpriseComponent",
        title: "Sales Phone",
        imgSrc: "/static/img/segments/layouts/sales-phone-enterprise.png",
        config: SalesPhoneEnterprise.SalesPhoneEnterpriseConfig,
        advancedConfig: SalesPhoneEnterprise.SalesPhoneEnterpriseAdvancedConfig,
        component: SalesPhoneEnterprise.SalesPhoneEnterpriseComponent
    },
    AsymmetricEnterpriseComponent: {
        type: "AsymmetricEnterpriseComponent",
        title: "Asymmetric",
        imgSrc: "/static/img/segments/layouts/asymmetric-enterprise.png",
        config: AsymmetricEnterprise.AsymmetricEnterpriseConfig,
        advancedConfig: AsymmetricEnterprise.AsymmetricEnterpriseAdvancedConfig,
        component: AsymmetricEnterprise.AsymmetricEnterpriseComponent
    }
});


/***/ }),

/***/ 75508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_form; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
// EXTERNAL MODULE: ./client/services/hubspot-service/contact-form-config.js + 1 modules
var contact_form_config = __webpack_require__(49228);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/fields-config.js



var CONTACT_SALES_TEXT = "Contact Sales (".concat(contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD, ")");
var REQUEST_A_DEMO_TEXT = "Request a Demo (".concat(contact_form_config/* REQUEST_A_DEMO_HUBSPOT_FORM_ID */.pO, ")");
var REPORT_FORM_TEXT = "Download form (".concat(contact_form_config/* REPORT_FORM_ID */.F0, ")");
var NURTURE_CONTUCT_US_TEXT = "Nurture - contact us form (".concat(contact_form_config/* NURTURE_CONTACT_US_FORM_ID */.f, ")");
var EMAIL_ONLY_TEXT = "Email only - contact us form (".concat(contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo, ")");
var EVENTS_TEXT = "Events - contact us form (".concat(contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo, ")");
/* harmony default export */ var fields_config = ({
    formId: {
        type: template_field_type.FIELD_TYPES.COMBO,
        options: [
            {
                value: contact_form_config/* CONTACT_SALES_HUBSPOT_FORM_ID */.PD,
                text: CONTACT_SALES_TEXT
            },
            {
                value: contact_form_config/* REQUEST_A_DEMO_HUBSPOT_FORM_ID */.pO,
                text: REQUEST_A_DEMO_TEXT
            },
            {
                value: contact_form_config/* REPORT_FORM_ID */.F0,
                text: REPORT_FORM_TEXT
            },
            {
                value: contact_form_config/* NURTURE_CONTACT_US_FORM_ID */.f,
                text: NURTURE_CONTUCT_US_TEXT
            },
            {
                value: contact_form_config/* EMAIL_ONLY_FORM_ID */.Qo,
                text: EMAIL_ONLY_TEXT
            },
            {
                value: contact_form_config/* EVENTS_HUBSPOT_FORM_ID */.yF,
                text: EVENTS_TEXT
            }
        ],
        label: "Form ID"
    },
    source: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Lead Source",
        options: hubspot_constants/* leadSourceConfigList */.L_
    },
    formTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Form Title"
    },
    formSubTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Form SubTitle"
    },
    urlToRedirectAfterSubmission: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "URL to redirect after submission"
    },
    urlToRedirectAfterSubmissionForSmallBusinesses: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "URL to redirect after submission for small businesses"
    },
    dontRenderPostFormSubmit: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Don't render post form submit"
    },
    timeoutForEnrichment: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Timeout for enrichment (in test - don't use)"
    },
    sendEmailToEnrichment: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Send email to enrichment"
    },
    preSelectedProduct: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Pre Selected Product",
        options: [
            {
                value: "Work & project management",
                text: "Work management (Work & project management)"
            },
            {
                value: "Sales & CRM",
                text: "CRM (Sales & CRM)"
            },
            {
                value: "Product management;Software development",
                text: "Dev (Product management;Software development)"
            },
            {
                value: "Ticketing & service management",
                text: "Service (Ticketing & service management)"
            }
        ]
    }
});

// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-form/hubspot-form-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var hubspot_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot",
    fields: _object_spread({}, fields_config)
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/sales/campaigns.js
var campaigns = __webpack_require__(44363);
;// CONCATENATED MODULE: ./segments/desktop/core-components/hubspot-contact-form/advanced-fields-config.js


/* harmony default export */ var advanced_fields_config = ({
    overrideCampaignId: {
        type: template_field_type.FIELD_TYPES.COMBO,
        options: [
            {
                value: campaigns/* IPO_CAMPAIGN_ID */.Q,
                text: "IPO promotion"
            },
            {
                value: campaigns/* GARTNER_CAMPAIGN_ID */.S,
                text: "Gartner campaign"
            }
        ],
        label: "Override campaign"
    },
    lastNameFirst: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Place Last Name before First Name"
    },
    bookAMeetingFlowUrl: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Book a meeting flow URL"
    },
    contactDetailsUrl: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Contact details flow URL"
    },
    bamTimeout: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Book a meeting call timeout (in milliseconds)"
    },
    enableLoader: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Enable loader"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-form/hubspot-form-advanced-config.js

function hubspot_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var hubspot_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(hubspot_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config), {
        disableShadow: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable shadow"
        },
        horizontalMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form horizontal margin"
        },
        mobileHorizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Mobile form horizontal padding"
        },
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form max width"
        },
        ctaProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "CTA props",
            fields: {
                overrideText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Override CTA text"
                },
                color: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "CTA color",
                    possibleColors: (0,_to_consumable_array/* default */.Z)(button_service/* buttonColors */.Is).concat([
                        color_consts.BRAND_BLACK_BACKGROUND_COLOR
                    ])
                },
                invert: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Outlined CTA"
                }
            }
        },
        privacyNoticeText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Privacy notice text"
        },
        singleLineFieldBreakpoint: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min screen width for enforced single line field (in px)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-form/index.js

var HubspotFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7784), __webpack_require__.e(8160), __webpack_require__.e(4764)]).then(__webpack_require__.bind(__webpack_require__, 84764));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84764)
            ];
        }
    }
});


/* harmony default export */ var hubspot_form = ({
    HubspotFormComponent: HubspotFormComponent,
    HubspotFormConfig: hubspot_form_config,
    HubspotFormAdvancedConfig: hubspot_form_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-config.js
function hubspot_on_dark_background_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_on_dark_background_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_on_dark_background_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_on_dark_background_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_on_dark_background_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_on_dark_background_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_on_dark_background_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot On Dark Background",
    fields: hubspot_on_dark_background_form_config_object_spread_props(hubspot_on_dark_background_form_config_object_spread({}, fields_config), {
        LeftSideContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Left Side Content",
            fields: {
                title: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title"
                },
                valuesList: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Values List",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            value: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Value"
                            }
                        }
                    }
                },
                textUnderSeparator: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text Under Separator"
                },
                customerQuote: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fields: {
                        quote: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Quote"
                        },
                        name: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Name"
                        },
                        jobDescription: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Job Description"
                        },
                        companyName: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Company Name"
                        },
                        facePicture: {
                            type: template_field_type.FIELD_TYPES.GALLERY,
                            label: "Face Picture"
                        }
                    }
                },
                sentenceAboveLogos: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Sentence Above Logos"
                },
                logos: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Logos",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: hubspot_on_dark_background_form_config_object_spread({}, asset_fields_config/* default.image.fields */.Z.image.fields)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/hubspot-on-dark-background-form-advanced-config.js
function hubspot_on_dark_background_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_on_dark_background_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_on_dark_background_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var hubspot_on_dark_background_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_on_dark_background_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-on-dark-background-form/index.js

var HubspotOnDarkBackgroundFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7784), __webpack_require__.e(8160), __webpack_require__.e(493)]).then(__webpack_require__.bind(__webpack_require__, 40493));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40493)
            ];
        }
    }
});


/* harmony default export */ var hubspot_on_dark_background_form = ({
    HubspotOnDarkBackgroundFormComponent: HubspotOnDarkBackgroundFormComponent,
    HubspotOnDarkBackgroundFormConfig: hubspot_on_dark_background_form_config,
    HubspotOnDarkBackgroundFormAdvancedConfig: hubspot_on_dark_background_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/monday-form-form-config.js

/* harmony default export */ var monday_form_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Form",
    fields: {
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Monday form ID",
            labelDescription: "Monday form ID is the identifier you could find in the monday form url: https://forms.monday.com/forms/<formId>"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/iframe/advanced-field-config.js
var advanced_field_config = __webpack_require__(32377);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/monday-form-form-advanced-config.js
function monday_form_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_form_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_form_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var height = advanced_field_config/* default.height */.Z.height, otherIFrameAdvancedFieldsConfig = _object_without_properties(advanced_field_config/* default */.Z, [
    "height"
]);
/* harmony default export */ var monday_form_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_form_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, otherIFrameAdvancedFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/monday-form-form/index.js



var MondayFormFormComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4314).then(__webpack_require__.bind(__webpack_require__, 84314));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84314)
            ];
        }
    }
});
/* harmony default export */ var monday_form_form = ({
    MondayFormFormComponent: MondayFormFormComponent,
    MondayFormFormConfig: monday_form_form_config,
    MondayFormFormAdvancedConfig: monday_form_form_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./constants/customer-quotes.js
var customer_quotes = __webpack_require__(64265);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-config.js
function hubspot_with_bullets_side_by_side_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_with_bullets_side_by_side_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_with_bullets_side_by_side_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_with_bullets_side_by_side_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_with_bullets_side_by_side_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_with_bullets_side_by_side_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var titleSize = title_advanced_field_config/* default.titleSize */.Z.titleSize;
var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.mobileSwapTextAndAssetPosition */.Z.mobileSwapTextAndAssetPosition;
/* harmony default export */ var hubspot_with_bullets_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot With Bullets Side By Side",
    fields: hubspot_with_bullets_side_by_side_form_config_object_spread_props(hubspot_with_bullets_side_by_side_form_config_object_spread({}, fields_config), {
        swapTextAndAssetPosition: swapTextAndAssetPosition,
        mobileSwapTextAndAssetPosition: mobileSwapTextAndAssetPosition,
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            translatable: true
        },
        titleSize: titleSize,
        benefits: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Benefits",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    icon: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    description: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Description",
                        translatable: true
                    }
                }
            }
        },
        hideSupportStatement: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide support statement"
        },
        hideLogos: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide logos"
        },
        customerQuoteKey: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Customer Quote",
            options: [
                {
                    value: customer_quotes/* CUSTOMER_KEY_OSCAR */.Nz,
                    text: "Oscar - Work OS saves time and money"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_THE_STUDENT_HOTEL */.iV,
                    text: "The Student Hotel - Work OS provides a trustful overview"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_TELEFONICA */.tx,
                    text: "Telefonica - 30% more efficient in campaign delivering"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_ZIPPO */.bd,
                    text: "Zippo - launch projects and expand to new markets in less time"
                },
                {
                    value: customer_quotes/* CUSTOMER_KEY_NISSAN */.vK,
                    text: "Nissan - been given confidence to provide management information"
                }
            ]
        },
        logosTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos title",
            fields: logos_title_fields_config/* default */.Z
        },
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/hubspot-with-bullets-side-by-side-form-advanced-config.js
function hubspot_with_bullets_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_with_bullets_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_with_bullets_side_by_side_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_with_bullets_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread_props(hubspot_with_bullets_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), advanced_fields_config), {
        backgroundLayers: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Background layers",
            options: [
                {
                    value: 0,
                    text: "0"
                },
                {
                    value: 1,
                    text: "1"
                },
                {
                    value: 2,
                    text: "2"
                },
                {
                    value: 3,
                    text: "3"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-with-bullets-side-by-side-form/index.js



var HubspotWithBulletsSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9112), __webpack_require__.e(7784), __webpack_require__.e(8160), __webpack_require__.e(6565), __webpack_require__.e(3176)]).then(__webpack_require__.bind(__webpack_require__, 93176));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93176)
            ];
        }
    }
});
/* harmony default export */ var hubspot_with_bullets_side_by_side_form = ({
    HubspotWithBulletsSideBySideFormComponent: HubspotWithBulletsSideBySideFormComponent,
    HubspotWithBulletsSideBySideFormConfig: hubspot_with_bullets_side_by_side_form_config,
    HubspotWithBulletsSideBySideFormAdvancedConfig: hubspot_with_bullets_side_by_side_form_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/logos-const.js
var logos_const = __webpack_require__(83971);
;// CONCATENATED MODULE: ./segments/desktop/core-components/paragraph-and-logos/fields-config.js




logos_fields_config/* default.numberOfCompanies.options */.Z.numberOfCompanies.options = logos_const/* SUPPORTED_LOGOS_NUMBER_FOR_NARROW_DISPLAY_OPTIONS */.WX; // override options
/* harmony default export */ var paragraph_and_logos_fields_config = ({
    fullParagraph: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Paragraph",
        fields: full_paragraph_fields_config/* default */.Z
    },
    logos: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Logos",
        fields: logos_fields_config/* default */.Z
    },
    marginBetweenParagraphAndLogos: {
        // Not in advanced since the import of advanced doesn't work well with nested
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Margin between paragraph and logos"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-config.js
function hubspot_and_logos_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_and_logos_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_and_logos_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_and_logos_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_and_logos_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_and_logos_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_and_logos_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot And Logos",
    fields: hubspot_and_logos_form_config_object_spread_props(hubspot_and_logos_form_config_object_spread({}, fields_config), {
        paragraphAndLogos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph and Logos",
            fields: paragraph_and_logos_fields_config
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var logos_advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/hubspot-and-logos-form-advanced-config.js
function hubspot_and_logos_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_and_logos_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_and_logos_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_and_logos_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_and_logos_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_and_logos_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var hubspot_and_logos_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_and_logos_form_advanced_config_object_spread_props(hubspot_and_logos_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config), {
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: logos_advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-and-logos-form/index.js



var HubspotAndLogosFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(9112), __webpack_require__.e(7784), __webpack_require__.e(8160), __webpack_require__.e(3882)]).then(__webpack_require__.bind(__webpack_require__, 80569));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80569)
            ];
        }
    }
});
/* harmony default export */ var hubspot_and_logos_form = ({
    HubspotAndLogosFormComponent: HubspotAndLogosFormComponent,
    HubspotAndLogosFormConfig: hubspot_and_logos_form_config,
    HubspotAndLogosFormAdvancedConfig: hubspot_and_logos_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-config.js
function zendesk_side_by_side_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = zendesk_side_by_side_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function zendesk_side_by_side_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, selectedSideBySideTextAndAssetFieldsConfig = zendesk_side_by_side_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "fullParagraph"
]);
/* harmony default export */ var zendesk_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Zendesk Side By Side",
    fields: selectedSideBySideTextAndAssetFieldsConfig
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/zendesk-side-by-side-form-advanced-config.js
function zendesk_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function zendesk_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            zendesk_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var zendesk_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: zendesk_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-side-by-side-form/index.js



var ZendeskSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7784), __webpack_require__.e(4454)]).then(__webpack_require__.bind(__webpack_require__, 84454));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84454)
            ];
        }
    }
});
/* harmony default export */ var zendesk_side_by_side_form = ({
    ZendeskSideBySideFormComponent: ZendeskSideBySideFormComponent,
    ZendeskSideBySideFormConfig: zendesk_side_by_side_form_config,
    ZendeskSideBySideFormAdvancedConfig: zendesk_side_by_side_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/zendesk-form-config.js

/* harmony default export */ var zendesk_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Zendesk",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/zendesk-form-advanced-config.js
function zendesk_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function zendesk_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            zendesk_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var zendesk_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: zendesk_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/zendesk-form/index.js



var ZendeskFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7784), __webpack_require__.e(1441)]).then(__webpack_require__.bind(__webpack_require__, 11441));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11441)
            ];
        }
    }
});
/* harmony default export */ var zendesk_form = ({
    ZendeskFormComponent: ZendeskFormComponent,
    ZendeskFormConfig: zendesk_form_config,
    ZendeskFormAdvancedConfig: zendesk_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-config.js
function hubspot_side_by_side_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_side_by_side_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_side_by_side_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_side_by_side_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hubspot_side_by_side_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hubspot_side_by_side_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var hubspot_side_by_side_form_config_fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, hubspot_side_by_side_form_config_selectedSideBySideTextAndAssetFieldsConfig = hubspot_side_by_side_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "fullParagraph"
]);
/* harmony default export */ var hubspot_side_by_side_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot Form Side By Side",
    fields: hubspot_side_by_side_form_config_object_spread({}, fields_config, hubspot_side_by_side_form_config_selectedSideBySideTextAndAssetFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/hubspot-side-by-side-form-advanced-config.js
function hubspot_side_by_side_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_side_by_side_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_side_by_side_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_side_by_side_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_side_by_side_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_side_by_side_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_side_by_side_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_side_by_side_form_advanced_config_object_spread(hubspot_side_by_side_form_advanced_config_object_spread_props(hubspot_side_by_side_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    }), advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/hubspot-side-by-side-form/index.js



var HubspotSideBySideFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5990), __webpack_require__.e(7784), __webpack_require__.e(8160), __webpack_require__.e(4420)]).then(__webpack_require__.bind(__webpack_require__, 34420));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34420)
            ];
        }
    }
});
/* harmony default export */ var hubspot_side_by_side_form = ({
    HubspotSideBySideFormComponent: HubspotSideBySideFormComponent,
    HubspotSideBySideFormConfig: hubspot_side_by_side_form_config,
    HubspotSideBySideFormAdvancedConfig: hubspot_side_by_side_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/form/layouts/index.js
// plop_marker:layouts_import








/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    HubspotForm: hubspot_form,
    HubspotOnDarkBackgroundForm: hubspot_on_dark_background_form,
    MondayFormForm: monday_form_form,
    HubspotWithBulletsSideBySideForm: hubspot_with_bullets_side_by_side_form,
    HubspotAndLogosForm: hubspot_and_logos_form,
    ZendeskSideBySideForm: zendesk_side_by_side_form,
    ZendeskForm: zendesk_form,
    HubspotSideBySideForm: hubspot_side_by_side_form
});

;// CONCATENATED MODULE: ./segments/desktop/form/index.js

var HubspotForm = layouts.HubspotForm, HubspotOnDarkBackgroundForm = layouts.HubspotOnDarkBackgroundForm, MondayFormForm = layouts.MondayFormForm, HubspotWithBulletsSideBySideForm = layouts.HubspotWithBulletsSideBySideForm, HubspotAndLogosForm = layouts.HubspotAndLogosForm, ZendeskSideBySideForm = layouts.ZendeskSideBySideForm, ZendeskForm = layouts.ZendeskForm, HubspotSideBySideForm = layouts.HubspotSideBySideForm;
/* harmony default export */ var desktop_form = ({
    // plop_marker:segment_index_add_layout
    HubspotFormComponent: {
        type: "HubspotFormComponent",
        title: "Hubspot",
        imgSrc: "/static/img/segments/layouts/hubspot-form.png",
        config: HubspotForm.HubspotFormConfig,
        advancedConfig: HubspotForm.HubspotFormAdvancedConfig,
        component: HubspotForm.HubspotFormComponent
    },
    HubspotOnDarkBackgroundFormComponent: {
        type: "HubspotOnDarkBackgroundFormComponent",
        title: "Hubspot On Dark Background",
        imgSrc: "/static/img/segments/layouts/hubspot-on-dark-background-form.png",
        config: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormConfig,
        advancedConfig: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormAdvancedConfig,
        component: HubspotOnDarkBackgroundForm.HubspotOnDarkBackgroundFormComponent
    },
    MondayFormFormComponent: {
        type: "MondayFormFormComponent",
        title: "Monday Form",
        imgSrc: "/static/img/segments/layouts/monday-form-form.png",
        config: MondayFormForm.MondayFormFormConfig,
        advancedConfig: MondayFormForm.MondayFormFormAdvancedConfig,
        component: MondayFormForm.MondayFormFormComponent
    },
    HubspotWithBulletsSideBySideFormComponent: {
        type: "HubspotWithBulletsSideBySideFormComponent",
        title: "Hubspot With Bullets Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-with-bullets-side-by-side-form.png",
        config: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormConfig,
        advancedConfig: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormAdvancedConfig,
        component: HubspotWithBulletsSideBySideForm.HubspotWithBulletsSideBySideFormComponent
    },
    HubspotAndLogosFormComponent: {
        type: "HubspotAndLogosFormComponent",
        title: "Hubspot And Logos",
        imgSrc: "/static/img/segments/layouts/hubspot-and-logos-form.png",
        config: HubspotAndLogosForm.HubspotAndLogosFormConfig,
        advancedConfig: HubspotAndLogosForm.HubspotAndLogosFormAdvancedConfig,
        component: HubspotAndLogosForm.HubspotAndLogosFormComponent
    },
    ZendeskSideBySideFormComponent: {
        type: "ZendeskSideBySideFormComponent",
        title: "Zendesk Side By Side",
        imgSrc: "/static/img/segments/layouts/zendesk-side-by-side-form.png",
        config: ZendeskSideBySideForm.ZendeskSideBySideFormConfig,
        advancedConfig: ZendeskSideBySideForm.ZendeskSideBySideFormAdvancedConfig,
        component: ZendeskSideBySideForm.ZendeskSideBySideFormComponent
    },
    ZendeskFormComponent: {
        type: "ZendeskFormComponent",
        title: "Zendesk",
        imgSrc: "/static/img/segments/layouts/zendesk-form.png",
        config: ZendeskForm.ZendeskFormConfig,
        advancedConfig: ZendeskForm.ZendeskFormAdvancedConfig,
        component: ZendeskForm.ZendeskFormComponent
    },
    HubspotSideBySideFormComponent: {
        type: "HubspotSideBySideFormComponent",
        title: "Hubspot Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-side-by-side-form.png",
        config: HubspotSideBySideForm.HubspotSideBySideFormConfig,
        advancedConfig: HubspotSideBySideForm.HubspotSideBySideFormAdvancedConfig,
        component: HubspotSideBySideForm.HubspotSideBySideFormComponent
    }
});


/***/ }),

/***/ 15348:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ grid; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tag/fields-config.js
var fields_config = __webpack_require__(82778);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var galleryImage = fields_config/* default.galleryImage */.Z.galleryImage, initiallySelected = fields_config/* default.initiallySelected */.Z.initiallySelected, tagValue = fields_config/* default.tagValue */.Z.tagValue, tagBackgroundColor = fields_config/* default.tagBackgroundColor */.Z.tagBackgroundColor, tagConfig = _object_without_properties(fields_config/* default */.Z, [
    "galleryImage",
    "initiallySelected",
    "tagValue",
    "tagBackgroundColor"
]);
/* harmony default export */ var carousel_selectable_product_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel Selectable Product Cards",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Card tag",
                fields: {
                    tag: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: tagConfig
                    },
                    cardAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Asset"
                    },
                    cardBackgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Card Background Color"
                    },
                    ctaButtonColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "CTA Button Color"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use cases",
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                useCase: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Use cases"
                                }
                            }
                        }
                    },
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    },
                    productIcon: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Override Product Icon"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/carousel-selectable-product-cards-grid-advanced-config.js
function carousel_selectable_product_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_selectable_product_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_selectable_product_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_selectable_product_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_selectable_product_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_selectable_product_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var autoPlay = {
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Carousel auto play",
    conditionalKeyName: "enable",
    options: [
        {
            text: "True",
            fieldsConfig: {
                autoplaySpeed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Auto play speed"
                },
                speed: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Transition speed"
                }
            }
        }
    ]
};
var cardConfig = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Card config",
    fields: {
        cardPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Padding"
        },
        spaceBetweenCardDetails: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Space Between Card Back to Maximum"
        },
        spaceBetweenCardContent: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Space Between Card Front to Maximum"
        },
        cardContentTextColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card Front Text Color"
        },
        cardHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Height"
        },
        cardDetailsProductIconHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Back Product Icon Height"
        },
        cardContentProductIconHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Front Product Icon Height"
        }
    }
};
/* harmony default export */ var carousel_selectable_product_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_selectable_product_cards_grid_advanced_config_object_spread_props(carousel_selectable_product_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        autoPlay: autoPlay,
        cardConfig: cardConfig
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/carousel-selectable-product-cards-grid/index.js

var CarouselSelectableProductCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3850).then(__webpack_require__.bind(__webpack_require__, 13850));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13850)
            ];
        }
    }
});


/* harmony default export */ var carousel_selectable_product_cards_grid = ({
    CarouselSelectableProductCardsGridComponent: CarouselSelectableProductCardsGridComponent,
    CarouselSelectableProductCardsGridConfig: carousel_selectable_product_cards_grid_config,
    CarouselSelectableProductCardsGridAdvancedConfig: carousel_selectable_product_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/card-button/button-types.js
var button_types = __webpack_require__(96800);
// EXTERNAL MODULE: ./constants/video-types.js
var video_types = __webpack_require__(39832);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-config.js
function background_image_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_image_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_image_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_image_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_image_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_image_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function background_image_cards_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = background_image_cards_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function background_image_cards_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, topic = full_paragraph_fields_config/* default.topic */.Z.topic, buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, resOfParagraphConfig = background_image_cards_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
var background_image_cards_grid_config_button = {
    type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
    label: "Button",
    conditionalKeyName: "buttonType",
    options: [
        {
            text: button_types/* ButtonTypes.PRODUCT_SIGNUP_AND_LEARN_MORE */.q.PRODUCT_SIGNUP_AND_LEARN_MORE,
            fieldsConfig: {
                productType: {
                    label: "Product",
                    type: template_field_type.FIELD_TYPES.PRODUCTS
                },
                buttonColor: {
                    label: "Button color",
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER
                },
                invert: {
                    label: "Invert",
                    type: template_field_type.FIELD_TYPES.BOOLEAN
                },
                withArrow: {
                    label: "With arrow",
                    type: template_field_type.FIELD_TYPES.BOOLEAN
                }
            },
            type: template_field_type.FIELD_TYPES.NESTED
        },
        {
            text: button_types/* ButtonTypes.LABEL */.q.LABEL,
            fieldsConfig: {
                text: {
                    label: "Text",
                    type: template_field_type.FIELD_TYPES.TEXT
                },
                borderColor: {
                    label: "Border color",
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER
                }
            },
            type: template_field_type.FIELD_TYPES.NESTED
        }
    ]
};
/* harmony default export */ var background_image_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Background Image Cards",
    fields: background_image_cards_grid_config_object_spread_props(background_image_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cardHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Height"
        },
        cardsGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Cards gap (default 12px)"
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    backgroundImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Fallback background image (if no video supplied)"
                    },
                    backgroundVideo: {
                        type: template_field_type.FIELD_TYPES.CLOUDINARY_VIDEO_PICKER,
                        label: "Background video (on hover)",
                        videoType: video_types/* PARAGRAPH_AND_ASSET_VIDEOS */.rB
                    },
                    mobileBackgroundImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Mobile image"
                    },
                    paragraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Paragraph",
                        fields: background_image_cards_grid_config_object_spread({
                            topic: background_image_cards_grid_config_object_spread_props(background_image_cards_grid_config_object_spread({}, topic), {
                                fields: {
                                    image: topic.fields.image
                                }
                            })
                        }, resOfParagraphConfig)
                    },
                    button: background_image_cards_grid_config_button,
                    marginLeft: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin left"
                    },
                    marginRight: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin right"
                    },
                    marginTop: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin top"
                    },
                    marginBottom: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin bottom"
                    },
                    borderRadius: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Border radius"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/background-image-cards-grid-advanced-config.js
function background_image_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function background_image_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            background_image_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function background_image_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function background_image_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        background_image_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var background_image_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: background_image_cards_grid_advanced_config_object_spread_props(background_image_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: background_image_cards_grid_advanced_config_object_spread_props(background_image_cards_grid_advanced_config_object_spread({}, advanced_fields_config/* default */.Z), {
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin from top"
                }
            })
        },
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Horizontal padding (For mobile)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/background-image-cards-grid/index.js

var BackgroundImageCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4185).then(__webpack_require__.bind(__webpack_require__, 34185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34185)
            ];
        }
    }
});


/* harmony default export */ var background_image_cards_grid = ({
    BackgroundImageCardsGridComponent: BackgroundImageCardsGridComponent,
    BackgroundImageCardsGridConfig: background_image_cards_grid_config,
    BackgroundImageCardsGridAdvancedConfig: background_image_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-config.js
function animated_icons_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animated_icons_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animated_icons_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function animated_icons_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function animated_icons_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        animated_icons_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var animated_icons_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Animated Icons",
    fields: animated_icons_grid_config_object_spread_props(animated_icons_grid_config_object_spread({}, theme_config/* default */.Z), {
        iconsArray: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    iconAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon",
                        defaultImagesKeys: []
                    },
                    animationDuration: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Animation duration (seconds)"
                    },
                    initialOffset: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Initial offset (px)"
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/animated-icons-grid-advanced-config.js
function animated_icons_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animated_icons_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animated_icons_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var animated_icons_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: animated_icons_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/animated-icons-grid/index.js

var AnimatedIconsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8501).then(__webpack_require__.bind(__webpack_require__, 88501));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88501)
            ];
        }
    }
});


/* harmony default export */ var animated_icons_grid = ({
    AnimatedIconsGridComponent: AnimatedIconsGridComponent,
    AnimatedIconsGridConfig: animated_icons_grid_config,
    AnimatedIconsGridAdvancedConfig: animated_icons_grid_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-config.js
function marquee_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var marquee_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Marquee Cards",
    fields: marquee_cards_grid_config_object_spread_props(marquee_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    cardAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Asset"
                    },
                    cardLogoAsset: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Card Logo Asset"
                    },
                    titleText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use cases",
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                useCase: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Use cases"
                                }
                            }
                        }
                    },
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/marquee-cards-grid-advanced-config.js
function marquee_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var marquee_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: marquee_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-cards-grid/index.js

var MarqueeCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2165).then(__webpack_require__.bind(__webpack_require__, 32165));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32165)
            ];
        }
    }
});


/* harmony default export */ var marquee_cards_grid = ({
    MarqueeCardsGridComponent: MarqueeCardsGridComponent,
    MarqueeCardsGridConfig: marquee_cards_grid_config,
    MarqueeCardsGridAdvancedConfig: marquee_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-config.js

function hoverable_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hoverable_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hoverable_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hoverable_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hoverable_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hoverable_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function hoverable_cards_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hoverable_cards_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hoverable_cards_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, hoverable_cards_grid_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, titleButtonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, hoverable_cards_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, hoverable_cards_grid_config_resOfParagraphConfig = hoverable_cards_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "buttonConfig",
    "titleColor",
    "textColor",
    "bodyColor"
]);
/* harmony default export */ var hoverable_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hoverable Cards",
    fields: hoverable_cards_grid_config_object_spread_props(hoverable_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        defaultHoveredCard: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Default hovered card"
        },
        defaultColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(theme_config/* default.theme.possibleColors */.Z.theme.possibleColors).concat([
                color_consts.RACKLEY_BLUE
            ])
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    hoveredColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Hovered color",
                        possibleColors: (0,_to_consumable_array/* default */.Z)(theme_config/* default.theme.possibleColors */.Z.theme.possibleColors).concat([
                            color_consts.SPRING_GREEN,
                            color_consts.ROUGE_RED
                        ])
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: asset_fields_config/* default */.Z
                    },
                    hoveredAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Hovered asset",
                        fields: hoverable_cards_grid_config_object_spread_props(hoverable_cards_grid_config_object_spread({}, asset_fields_config/* default */.Z), {
                            hideControls: {
                                type: template_field_type.FIELD_TYPES.BOOLEAN,
                                label: "Hide controls",
                                defaultValue: true
                            }
                        })
                    },
                    paragraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Paragraph",
                        fields: hoverable_cards_grid_config_resOfParagraphConfig
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/hoverable-cards-grid-advanced-config.js
function hoverable_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hoverable_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hoverable_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hoverable_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hoverable_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hoverable_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function hoverable_cards_grid_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = hoverable_cards_grid_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function hoverable_cards_grid_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, textSize = advanced_fields_config/* default.textSize */.Z.textSize, restOfParagraphConfig = hoverable_cards_grid_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "buttonTopMargin",
    "topicBottomMargin",
    "textSize"
]);
/* harmony default export */ var hoverable_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hoverable_cards_grid_advanced_config_object_spread_props(hoverable_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: hoverable_cards_grid_advanced_config_object_spread({}, restOfParagraphConfig)
        },
        textResizeConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Advanced Text Resize Config",
            fields: {
                resizeFactor: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Resize Factor",
                    default: 1
                },
                minimumFont: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Minimum title font",
                    default: 1
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/hoverable-cards-grid/index.js

var HoverableCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7790).then(__webpack_require__.bind(__webpack_require__, 17790));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17790)
            ];
        }
    }
});


/* harmony default export */ var hoverable_cards_grid = ({
    HoverableCardsGridComponent: HoverableCardsGridComponent,
    HoverableCardsGridConfig: hoverable_cards_grid_config,
    HoverableCardsGridAdvancedConfig: hoverable_cards_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/marquee-grid-config.js
function marquee_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var marquee_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Marquee",
    fields: marquee_grid_config_object_spread_props(marquee_grid_config_object_spread({}, theme_config/* default */.Z), {
        textBoxText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text Box Text"
        },
        titleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Config",
            fields: marquee_grid_config_object_spread({}, title_fields_config/* default */.Z)
        },
        subTitleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "subTitle config",
            fields: marquee_grid_config_object_spread({}, paragraph_fields_config/* default */.Z)
        },
        tagsLines: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags Lines",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    items: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Tags",
                        maxLimit: 15,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                },
                                image: {
                                    type: template_field_type.FIELD_TYPES.GALLERY,
                                    label: "Image"
                                },
                                backgroundColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Background Color"
                                },
                                hoverTextAndBorderColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Hover Text Color"
                                },
                                selectedTextAndBorderColor: {
                                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                    label: "Select Text Color"
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/marquee-grid-advanced-config.js
function marquee_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function marquee_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            marquee_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function marquee_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function marquee_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        marquee_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var marquee_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: marquee_grid_advanced_config_object_spread_props(marquee_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        titleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: marquee_grid_advanced_config_object_spread({}, advanced_field_config/* default */.Z)
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: marquee_grid_advanced_config_object_spread({}, paragraph_advanced_fields_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/marquee-grid/index.js

var MarqueeGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1810).then(__webpack_require__.bind(__webpack_require__, 11810));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11810)
            ];
        }
    }
});


/* harmony default export */ var marquee_grid = ({
    MarqueeGridComponent: MarqueeGridComponent,
    MarqueeGridConfig: marquee_grid_config,
    MarqueeGridAdvancedConfig: marquee_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/badges-grid/index.js + 2 modules
var badges_grid = __webpack_require__(89138);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/sliding-card-grid/index.js + 2 modules
var sliding_card_grid = __webpack_require__(92186);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-config.js
var title_only_paragraph_config = __webpack_require__(68566);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/press-grid/press-consts.js
var press_consts = __webpack_require__(6795);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/press-grid-config.js
function press_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function press_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            press_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function press_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function press_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        press_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function press_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = press_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function press_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FlexibleCardsGridConfig_fields = flexible_cards_grid_config/* default.fields */.Z.fields, gridItems = _FlexibleCardsGridConfig_fields.gridItems, resConfig = press_grid_config_object_without_properties(_FlexibleCardsGridConfig_fields, [
    "gridItems"
]);
var _TitleOnlyParagraphConfig_fields = title_only_paragraph_config/* default.fields */.Z.fields, theme = _TitleOnlyParagraphConfig_fields.theme, press_grid_config_buttonConfig = _TitleOnlyParagraphConfig_fields.buttonConfig, resTitleConfig = press_grid_config_object_without_properties(_TitleOnlyParagraphConfig_fields, [
    "theme",
    "buttonConfig"
]);
var titleSize = advanced_field_config/* default.titleSize */.Z.titleSize;
/* harmony default export */ var press_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Press Component",
    fields: press_grid_config_object_spread_props(press_grid_config_object_spread({
        location: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Location",
            options: [
                {
                    value: press_consts/* ISRAEL_LOCATION */.RE,
                    text: "Israel"
                },
                {
                    value: press_consts/* GLOBAL_LOCATION */.Q4,
                    text: "Global"
                }
            ]
        }
    }, resConfig), {
        titleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Config",
            fields: press_grid_config_object_spread_props(press_grid_config_object_spread({}, resTitleConfig), {
                titleSize: titleSize
            })
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/press-grid-advanced-config.js
function press_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function press_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            press_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var press_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: press_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/press-grid/index.js



var PressGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6608).then(__webpack_require__.bind(__webpack_require__, 16608));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16608)
            ];
        }
    }
});
/* harmony default export */ var press_grid = ({
    PressGridComponent: PressGridComponent,
    PressGridConfig: press_grid_config,
    PressGridAdvancedConfig: press_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-paragraph-with-image/fields-config.js
var grid_paragraph_with_image_fields_config = __webpack_require__(41667);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-config.js
function connected_products_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function connected_products_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            connected_products_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var connected_products_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Connected products",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: connected_products_grid_config_object_spread({}, grid_paragraph_with_image_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/connected-products-grid-advanced-config.js
function connected_products_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function connected_products_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            connected_products_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var connected_products_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: connected_products_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/connected-products-grid/index.js



var ConnectedProductsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3879).then(__webpack_require__.bind(__webpack_require__, 3879));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3879)
            ];
        }
    }
});
/* harmony default export */ var connected_products_grid = ({
    ConnectedProductsGridComponent: ConnectedProductsGridComponent,
    ConnectedProductsGridConfig: connected_products_grid_config,
    ConnectedProductsGridAdvancedConfig: connected_products_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/index.js + 1 modules
var flexible_cards_grid = __webpack_require__(84420);
// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/fields-config.js
var square_tags_fields_config = __webpack_require__(22333);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-config.js
function square_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var square_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Square Tags",
    fields: square_tags_grid_config_object_spread({}, square_tags_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/square-tags/advanced-fields-config.js
var square_tags_advanced_fields_config = __webpack_require__(73498);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/square-tags-grid-advanced-config.js
function square_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function square_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            square_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var square_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: square_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, square_tags_advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/square-tags-grid/index.js



var SquareTagsGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4913)]).then(__webpack_require__.bind(__webpack_require__, 74913));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74913)
            ];
        }
    }
});
/* harmony default export */ var square_tags_grid = ({
    SquareTagsGridComponent: SquareTagsGridComponent,
    SquareTagsGridConfig: square_tags_grid_config,
    SquareTagsGridAdvancedConfig: square_tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 7 modules
var button_fields_config = __webpack_require__(59440);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/core-configs/products-config.js


/* harmony default export */ var products_config = ({
    productType: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Product type",
        options: products/* PRODUCT_TYPES */.Pm
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-config.js
function product_cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var options = button_fields_config/* default.options */.Z.options;
var product_cards_grid_config_image = asset_fields_config/* default.image */.Z.image;
var productCardButtonOptions = options.filter(function(option) {
    return [
        button_consts/* SIGNUP_BUTTON_TYPE */.ge,
        button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
        button_consts/* SECONDARY_BUTTON_TYPE */.jE
    ].includes(option.text);
});
/* harmony default export */ var product_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Product Cards",
    fields: product_cards_grid_config_object_spread_props(product_cards_grid_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Card Items",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: product_cards_grid_config_object_spread_props(product_cards_grid_config_object_spread({}, products_config), {
                    overrideLogo: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Override Logo",
                        fields: {
                            image: product_cards_grid_config_image
                        }
                    },
                    isHighlighted: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Is highlighted"
                    },
                    showOpen: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Show card open in mobile version"
                    },
                    header: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Header",
                        fields: {
                            subtitleText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            mobileSubTitleText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Mobile subtitle text",
                                translatable: true
                            }
                        }
                    },
                    body: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Body",
                        fields: {
                            bodyText: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            }
                        }
                    },
                    showDivider: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Show divider"
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Use cases",
                        fields: {
                            text: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Text",
                                translatable: true
                            },
                            list: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Use cases list",
                                maxLimit: 6,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Text",
                                            translatable: true
                                        }
                                    }
                                }
                            }
                        }
                    },
                    buttonConfig: {
                        type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
                        label: "Button",
                        conditionalKeyName: "buttonType",
                        options: productCardButtonOptions
                    },
                    isV2: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Is V2"
                    }
                })
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/product-cards-grid-advanced-config.js
function product_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var product_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: product_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/product-cards-grid/index.js



var ProductCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9185).then(__webpack_require__.bind(__webpack_require__, 79185));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79185)
            ];
        }
    }
});
/* harmony default export */ var product_cards_grid = ({
    ProductCardsGridComponent: ProductCardsGridComponent,
    ProductCardsGridConfig: product_cards_grid_config,
    ProductCardsGridAdvancedConfig: product_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-config.js
function masonry_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function masonry_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            masonry_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function masonry_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function masonry_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        masonry_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function masonry_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = masonry_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function masonry_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var video = asset_fields_config/* default.video */.Z.video;
var _video_fields = video.fields, loop = _video_fields.loop, playWhenVisible = _video_fields.playWhenVisible, rest = masonry_grid_config_object_without_properties(_video_fields, [
    "loop",
    "playWhenVisible"
]);
/* harmony default export */ var masonry_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Masonry",
    fields: {
        assets: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Assets",
            maxLimit: 9,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: masonry_grid_config_object_spread_props(masonry_grid_config_object_spread({}, asset_fields_config/* default */.Z), {
                            video: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Video",
                                fields: masonry_grid_config_object_spread_props(masonry_grid_config_object_spread({}, rest), {
                                    startAfter: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Start After"
                                    },
                                    poster: {
                                        type: template_field_type.FIELD_TYPES.GALLERY,
                                        label: "Select an poster"
                                    }
                                })
                            }
                        })
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/masonry-grid-advanced-config.js
function masonry_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function masonry_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            masonry_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function masonry_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function masonry_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        masonry_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var masonry_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: masonry_grid_advanced_config_object_spread_props(masonry_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/masonry-grid/index.js



var MasonryGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8890).then(__webpack_require__.bind(__webpack_require__, 68890));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68890)
            ];
        }
    }
});
/* harmony default export */ var masonry_grid = ({
    MasonryGridComponent: MasonryGridComponent,
    MasonryGridConfig: masonry_grid_config,
    MasonryGridAdvancedConfig: masonry_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js + 1 modules
var tag_items_grid_config = __webpack_require__(48127);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-advanced-config.js
var tag_items_grid_advanced_config = __webpack_require__(14061);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/index.js



var TagItemsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7798).then(__webpack_require__.bind(__webpack_require__, 37798));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(37798)
            ];
        }
    }
});
/* harmony default export */ var tag_items_grid = ({
    TagItemsGridComponent: TagItemsGridComponent,
    TagItemsGridConfig: tag_items_grid_config/* default */.Z,
    TagItemsGridAdvancedConfig: tag_items_grid_advanced_config/* default */.Z
});

// EXTERNAL MODULE: ./segments/desktop/core-components/grid-image/fields-config.js
var grid_image_fields_config = __webpack_require__(78739);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/icon-with-paragraph-grid-config.js
function icon_with_paragraph_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icon_with_paragraph_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icon_with_paragraph_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function icon_with_paragraph_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function icon_with_paragraph_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        icon_with_paragraph_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function icon_with_paragraph_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = icon_with_paragraph_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function icon_with_paragraph_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var icon_with_paragraph_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, icon_with_paragraph_grid_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, selectedFullParagraphFields = icon_with_paragraph_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor",
    "textAlign"
]);
/* harmony default export */ var icon_with_paragraph_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Icon With Paragraph",
    fields: {
        iconWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon width"
        },
        iconHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon height"
        },
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                },
                {
                    value: sizes/* XXL */.T3,
                    text: "80px"
                }
            ]
        },
        textSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Body Size",
            options: [
                {
                    value: sizes.MS,
                    text: "16px"
                },
                {
                    value: sizes.MD,
                    text: "20px"
                },
                {
                    value: sizes.LG,
                    text: "24px"
                }
            ]
        },
        imagesGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Images gap"
        },
        images: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: icon_with_paragraph_grid_config_object_spread_props(icon_with_paragraph_grid_config_object_spread({}, grid_image_fields_config/* default */.Z), {
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: selectedFullParagraphFields
                    }
                })
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/images-grid/images-grid-service.js
var images_grid_service = __webpack_require__(72898);
;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/advanced-fields-config.js


var advanced_fields_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign;

/* harmony default export */ var images_grid_advanced_fields_config = ({
    imagePosition: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Image Position",
        options: [
            {
                value: images_grid_service/* positionTypes.TOP_LEFT */.b.TOP_LEFT,
                text: "Top Left"
            },
            {
                value: images_grid_service/* positionTypes.TOP_CENTER */.b.TOP_CENTER,
                text: "Top Center"
            },
            {
                value: images_grid_service/* positionTypes.TOP_RIGHT */.b.TOP_RIGHT,
                text: "Top Right"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_LEFT */.b.CENTER_LEFT,
                text: "Center Left"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_CENTER */.b.CENTER_CENTER,
                text: "Center Center"
            },
            {
                value: images_grid_service/* positionTypes.CENTER_RIGHT */.b.CENTER_RIGHT,
                text: "Center Right"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_LEFT */.b.BOTTOM_LEFT,
                text: "Bottom Left"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_CENTER */.b.BOTTOM_CENTER,
                text: "Bottom Center"
            },
            {
                value: images_grid_service/* positionTypes.BOTTOM_RIGHT */.b.BOTTOM_RIGHT,
                text: "Bottom Right"
            }
        ]
    },
    textAlign: advanced_fields_config_textAlign
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/icon-with-paragraph-grid-advanced-config.js
function icon_with_paragraph_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function icon_with_paragraph_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            icon_with_paragraph_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



var ref = icon_with_paragraph_grid_advanced_config_object_spread({}, images_grid_advanced_fields_config), imagePosition = ref.imagePosition, icon_with_paragraph_grid_advanced_config_textAlign = ref.textAlign;
/* harmony default export */ var icon_with_paragraph_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: icon_with_paragraph_grid_advanced_config_object_spread({
        imagePosition: imagePosition,
        textAlign: icon_with_paragraph_grid_advanced_config_textAlign,
        disableFixedWidth: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Disable auto width"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/icon-with-paragraph-grid/index.js



var IconWithParagraphGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9515).then(__webpack_require__.bind(__webpack_require__, 9515));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9515)
            ];
        }
    }
});
/* harmony default export */ var icon_with_paragraph_grid = ({
    IconWithParagraphGridComponent: IconWithParagraphGridComponent,
    IconWithParagraphGridConfig: icon_with_paragraph_grid_config,
    IconWithParagraphGridAdvancedConfig: icon_with_paragraph_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/fields-config.js
var selectable_tags_grid_fields_config = __webpack_require__(1117);
// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/fields-config.js
var carousel_fields_config = __webpack_require__(33751);
// EXTERNAL MODULE: ./constants/align-types.js
var align_types = __webpack_require__(79409);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-config.js
function selectable_tags_with_carousel_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_with_carousel_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_with_carousel_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var selectable_tags_with_carousel_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags With Carousel",
    fields: selectable_tags_with_carousel_grid_config_object_spread({
        tagsAlign: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags Align",
            options: [
                {
                    value: align_types.ALIGN_TYPES.LEFT,
                    text: align_types.ALIGN_LABELS.LEFT
                },
                {
                    value: align_types.ALIGN_TYPES.CENTER,
                    text: align_types.ALIGN_LABELS.CENTER
                },
                {
                    value: align_types.ALIGN_TYPES.RIGHT,
                    text: align_types.ALIGN_LABELS.RIGHT
                }
            ]
        }
    }, carousel_fields_config/* default */.Z, selectable_tags_grid_fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/core-components/carousel/advanced-fields-config.js
var carousel_advanced_fields_config = __webpack_require__(1270);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/selectable-tags-with-carousel-grid-advanced-config.js
function selectable_tags_with_carousel_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_with_carousel_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_with_carousel_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var selectable_tags_with_carousel_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: selectable_tags_with_carousel_grid_advanced_config_object_spread({}, carousel_advanced_fields_config/* default */.Z, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-with-carousel-grid/index.js



var SelectableTagsWithCarouselGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4222), __webpack_require__.e(8393)]).then(__webpack_require__.bind(__webpack_require__, 88393));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88393)
            ];
        }
    }
});
/* harmony default export */ var selectable_tags_with_carousel_grid = ({
    SelectableTagsWithCarouselGridComponent: SelectableTagsWithCarouselGridComponent,
    SelectableTagsWithCarouselGridConfig: selectable_tags_with_carousel_grid_config,
    SelectableTagsWithCarouselGridAdvancedConfig: selectable_tags_with_carousel_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/constants.js
var constants = __webpack_require__(72606);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/blog-card-item-footer/fields-config.js


/* harmony default export */ var blog_card_item_footer_fields_config = ({
    writerImageSrc: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select Writer Image (".concat(constants/* default.WRITER_AVATAR_IMAGE_WIDTH */.Z.WRITER_AVATAR_IMAGE_WIDTH, "x").concat(constants/* default.WRITER_AVATAR_IMAGE_HEIGHT */.Z.WRITER_AVATAR_IMAGE_HEIGHT, ")")
    },
    writerName: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Writer Name"
    },
    articleDate: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Article Date",
        translatable: true
    },
    minutesToRead: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Minutes",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-card-item/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var fields_config_link = grid_image_fields_config/* default.link */.Z.link, src = grid_image_fields_config/* default.src */.Z.src, restFieldsConfig = fields_config_object_without_properties(grid_image_fields_config/* default */.Z, [
    "link",
    "src"
]);
var newSrc = fields_config_object_spread_props(fields_config_object_spread({}, src), {
    label: "select an image (".concat(constants/* default.CARD_WIDTH */.Z.CARD_WIDTH, "X").concat(constants/* default.IMAGE_HEIGHT */.Z.IMAGE_HEIGHT, ")")
});
var selectedGridImageFieldsConfig = fields_config_object_spread({
    src: newSrc
}, restFieldsConfig);
/* harmony default export */ var blog_card_item_fields_config = (fields_config_object_spread_props(fields_config_object_spread({
    link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Blog Link"
    },
    openInNewTab: {
        type: "boolean",
        label: "Should Open In New Tab"
    },
    image: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Image",
        fields: fields_config_object_spread({}, selectedGridImageFieldsConfig)
    }
}, title_fields_config/* default */.Z), {
    footer: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Card Footer",
        fields: blog_card_item_footer_fields_config
    }
}));

// EXTERNAL MODULE: ./segments/desktop/core-components/button/regular-button/fields-config.js
var regular_button_fields_config = __webpack_require__(64054);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/secondary-button/fields-config.js
var secondary_button_fields_config = __webpack_require__(54237);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var signup_button_fields_config = __webpack_require__(96587);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-config.js






/* harmony default export */ var blog_cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Blog Cards",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 100,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: blog_card_item_fields_config
            }
        },
        buttonConfig: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Button",
            conditionalKeyName: "buttonType",
            options: [
                {
                    text: button_consts/* REGULAR_BUTTON_TYPE */.ys,
                    fieldsConfig: regular_button_fields_config/* default */.Z
                },
                {
                    text: button_consts/* SECONDARY_BUTTON_TYPE */.jE,
                    fieldsConfig: secondary_button_fields_config/* default */.Z
                },
                {
                    text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    fieldsConfig: signup_button_fields_config/* default */.Z
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/blog-cards-grid-advanced-config.js
function blog_cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function blog_cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            blog_cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function blog_cards_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function blog_cards_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        blog_cards_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var blog_cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: blog_cards_grid_advanced_config_object_spread_props(blog_cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        hideFooter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide footer"
        },
        imageMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Image Max Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/blog-cards-grid/index.js

var BlogCardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7373).then(__webpack_require__.bind(__webpack_require__, 97373));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97373)
            ];
        }
    }
});


/* harmony default export */ var blog_cards_grid = ({
    BlogCardsGridComponent: BlogCardsGridComponent,
    BlogCardsGridConfig: blog_cards_grid_config,
    BlogCardsGridAdvancedConfig: blog_cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/components/button-image-tag/fields-config.js

/* harmony default export */ var button_image_tag_fields_config = ({
    tagImg: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Image Tag",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select an Tag Image"
            }
        }
    },
    link: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Link (New)"
    },
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag Text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/button-image-tags-grid-config.js
function button_image_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_image_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_image_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_image_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Button Image Tags",
    fields: {
        isOpenLinkInNewTab: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Open Link In New Tab"
        },
        gridButtonTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Button Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: button_image_tags_grid_config_object_spread({}, button_image_tag_fields_config)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/button-image-tags-grid-advanced-config.js
function button_image_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_image_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_image_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_image_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: button_image_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-image-tags-grid/index.js

var ButtonImageTagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1396).then(__webpack_require__.bind(__webpack_require__, 1396));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1396)
            ];
        }
    }
});


/* harmony default export */ var button_image_tags_grid = ({
    ButtonImageTagsGridComponent: ButtonImageTagsGridComponent,
    ButtonImageTagsGridConfig: button_image_tags_grid_config,
    ButtonImageTagsGridAdvancedConfig: button_image_tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button-tag/fields-config.js
var button_tag_fields_config = __webpack_require__(24662);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-config.js
function button_tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Button Tags",
    fields: {
        isOpenLinkInNewTab: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Open Link In New Tab"
        },
        gridButtonTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Button Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: button_tags_grid_config_object_spread({}, button_tag_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-advanced-config.js
function button_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function button_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            button_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var button_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: button_tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/index.js

var ButtonTagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5408).then(__webpack_require__.bind(__webpack_require__, 15408));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(15408)
            ];
        }
    }
});


/* harmony default export */ var button_tags_grid = ({
    ButtonTagsGridComponent: ButtonTagsGridComponent,
    ButtonTagsGridConfig: button_tags_grid_config,
    ButtonTagsGridAdvancedConfig: button_tags_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/cards-grid-config.js
function cards_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var cards_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Cards",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: cards_grid_config_object_spread({}, grid_paragraph_with_image_fields_config/* default */.Z)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/cards-grid-advanced-config.js
function cards_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function cards_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            cards_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var cards_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: cards_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/cards-grid/index.js

var CardsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5485).then(__webpack_require__.bind(__webpack_require__, 85485));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85485)
            ];
        }
    }
});


/* harmony default export */ var cards_grid = ({
    CardsGridComponent: CardsGridComponent,
    CardsGridConfig: cards_grid_config,
    CardsGridAdvancedConfig: cards_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/components/tag/fields-config.js

/* harmony default export */ var tag_fields_config = ({
    color: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Color"
    },
    text: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/grid-tag/fields-config.js
function grid_tag_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function grid_tag_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            grid_tag_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function grid_tag_fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = grid_tag_fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function grid_tag_fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var fields_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, fields_config_buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, fields_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, fields_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFieldsConfig = grid_tag_fields_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "buttonConfig",
    "textAlign",
    "textColor"
]);
/* harmony default export */ var grid_tag_fields_config = ({
    tag: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tag",
        fields: grid_tag_fields_config_object_spread({}, tag_fields_config)
    },
    fullParagraph: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Full Paragraph",
        fields: grid_tag_fields_config_object_spread({}, selectedFullParagraphFieldsConfig)
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-config.js
function tags_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var tags_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags",
    fields: {
        gridItems: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Items",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: tags_grid_config_object_spread({}, grid_tag_fields_config)
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/tags-grid-advanced-config.js
function tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: tags_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tags-grid/index.js

var TagsGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4115).then(__webpack_require__.bind(__webpack_require__, 84115));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84115)
            ];
        }
    }
});


/* harmony default export */ var tags_grid = ({
    TagsGridComponent: TagsGridComponent,
    TagsGridConfig: tags_grid_config,
    TagsGridAdvancedConfig: tags_grid_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-config.js
var selectable_tags_grid_config = __webpack_require__(96817);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-advanced-config.js
function selectable_tags_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function selectable_tags_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            selectable_tags_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function selectable_tags_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function selectable_tags_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        selectable_tags_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var selectable_tags_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: selectable_tags_grid_advanced_config_object_spread_props(selectable_tags_grid_advanced_config_object_spread({}, selectable_tags_grid_advanced_field_config/* default */.Z, shared_advanced_fields_config/* default */.ZP), {
        IsInCrmUseCasesTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Crm use case tags AB Test"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/index.js

var SelectableTagsGridComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4222), __webpack_require__.e(6747)]).then(__webpack_require__.bind(__webpack_require__, 66747));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66747)
            ];
        }
    }
});


/* harmony default export */ var selectable_tags_grid = ({
    SelectableTagsGridComponent: SelectableTagsGridComponent,
    SelectableTagsGridConfig: selectable_tags_grid_config/* default */.Z,
    SelectableTagsGridAdvancedConfig: selectable_tags_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-config.js
function image_with_paragraph_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_with_paragraph_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_with_paragraph_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function image_with_paragraph_grid_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_with_paragraph_grid_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_with_paragraph_grid_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function image_with_paragraph_grid_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = image_with_paragraph_grid_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function image_with_paragraph_grid_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var image_with_paragraph_grid_config_textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, image_with_paragraph_grid_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, image_with_paragraph_grid_config_selectedFullParagraphFields = image_with_paragraph_grid_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor",
    "textAlign"
]);
/* harmony default export */ var image_with_paragraph_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Image With Paragraph",
    fields: image_with_paragraph_grid_config_object_spread_props(image_with_paragraph_grid_config_object_spread({}, theme_config/* default */.Z), {
        images: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Images",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: image_with_paragraph_grid_config_object_spread_props(image_with_paragraph_grid_config_object_spread({}, grid_image_fields_config/* default */.Z), {
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: image_with_paragraph_grid_config_selectedFullParagraphFields
                    }
                })
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/image-with-paragraph-grid-advanced-config.js
function image_with_paragraph_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function image_with_paragraph_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            image_with_paragraph_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function image_with_paragraph_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function image_with_paragraph_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        image_with_paragraph_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var image_with_paragraph_grid_advanced_config_imagePosition = images_grid_advanced_fields_config.imagePosition, image_with_paragraph_grid_advanced_config_textAlign = images_grid_advanced_fields_config.textAlign;
/* harmony default export */ var image_with_paragraph_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: image_with_paragraph_grid_advanced_config_object_spread_props(image_with_paragraph_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z), {
        imagePosition: image_with_paragraph_grid_advanced_config_imagePosition,
        alignButtons: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align buttons"
        },
        autoHeight: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Auto height for cards"
        },
        textAlign: image_with_paragraph_grid_advanced_config_textAlign
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/image-with-paragraph-grid/index.js

var ImageWithParagraphGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3753).then(__webpack_require__.bind(__webpack_require__, 3753));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3753)
            ];
        }
    }
});


/* harmony default export */ var image_with_paragraph_grid = ({
    ImageWithParagraphGridComponent: ImageWithParagraphGridComponent,
    ImageWithParagraphGridConfig: image_with_paragraph_grid_config,
    ImageWithParagraphGridAdvancedConfig: image_with_paragraph_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/images-grid/fields-config.js


/* harmony default export */ var images_grid_fields_config = ({
    imagesGap: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Images gap"
    },
    images: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Images",
        maxLimit: 12,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: grid_image_fields_config/* default */.Z
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-config.js


/* harmony default export */ var only_image_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Only Image",
    fields: images_grid_fields_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/only-image-grid-advanced-config.js
function only_image_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function only_image_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            only_image_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function only_image_grid_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function only_image_grid_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        only_image_grid_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var only_image_grid_advanced_config_imagePosition = images_grid_advanced_fields_config.imagePosition;
/* harmony default export */ var only_image_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: only_image_grid_advanced_config_object_spread_props(only_image_grid_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        imagePosition: only_image_grid_advanced_config_imagePosition
    })
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/only-image-grid/index.js

var OnlyImageGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8672).then(__webpack_require__.bind(__webpack_require__, 28672));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28672)
            ];
        }
    }
});


/* harmony default export */ var only_image_grid = ({
    OnlyImageGridComponent: OnlyImageGridComponent,
    OnlyImageGridConfig: only_image_grid_config,
    OnlyImageGridAdvancedConfig: only_image_grid_advanced_config
});

;// CONCATENATED MODULE: ./components/core/pill/fields-config.js


/* harmony default export */ var pill_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Pill Component",
    fields: {
        label: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Pill Text"
        },
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        },
        borderColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Border Color"
        },
        borderThickness: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border Thickness"
        },
        borderRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border Radius"
        },
        textColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Text Color"
        },
        fontSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Font Size",
            options: [
                {
                    value: sizes.SM,
                    text: "14px"
                },
                {
                    value: sizes.MS,
                    text: "16px"
                },
                {
                    value: sizes.MD,
                    text: "18px"
                }
            ]
        },
        padding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text Padding"
        },
        margin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Pill Margin"
        },
        hoverOpacity: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Hover Opacity"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/components/asset-content-card/asset-content-card-config.js
function asset_content_card_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asset_content_card_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asset_content_card_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function asset_content_card_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function asset_content_card_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        asset_content_card_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var enhancedButtonConfig = asset_content_card_config_object_spread_props(asset_content_card_config_object_spread({}, button_fields_config/* default */.Z), {
    options: button_fields_config/* default.options.map */.Z.options.map(function(option) {
        if (option.text === "Signup") {
            return asset_content_card_config_object_spread_props(asset_content_card_config_object_spread({}, option), {
                fieldsConfig: asset_content_card_config_object_spread_props(asset_content_card_config_object_spread({}, option.fieldsConfig), {
                    buttonSize: {
                        type: template_field_type.FIELD_TYPES.COMBO,
                        label: "Button Size",
                        options: [
                            {
                                value: sizes.XS,
                                text: "Small"
                            },
                            {
                                value: sizes.SM,
                                text: "Medium"
                            },
                            {
                                value: sizes.LG,
                                text: "Large"
                            }
                        ]
                    }
                })
            });
        }
        return option;
    })
});
/* harmony default export */ var asset_content_card_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Asset Content Card",
    fields: {
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: asset_fields_config/* default */.Z
        },
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title Text",
            translatable: true
        },
        titleFontSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "22px"
                },
                {
                    value: sizes.SM,
                    text: "28px (formerly 32px)"
                },
                {
                    value: sizes.MD,
                    text: "36px (formerly 40px)"
                },
                {
                    value: sizes.LG,
                    text: "44px (formerly 50px)"
                }
            ]
        },
        titleFontWeight: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Font Weight",
            options: [
                {
                    value: 400,
                    text: "Normal (400)"
                },
                {
                    value: 500,
                    text: "Medium (500)"
                },
                {
                    value: 600,
                    text: "Semibold (600)"
                },
                {
                    value: 700,
                    text: "Bold (700)"
                }
            ]
        },
        minWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Minimum Width",
            description: "Enter minimum width (e.g., '200px' or '20rem')"
        },
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Maximum Width",
            description: "Enter maximum width (e.g., '800px' or '80rem')"
        },
        borderRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border Radius"
        },
        borderThickness: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border Thickness"
        },
        borderColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Border Color"
        },
        cardPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Padding"
        },
        contentPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content Padding"
        },
        assetBottomMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset Bottom Margin"
        },
        titleBottomMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title Bottom Margin"
        },
        contentType: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Content Type",
            conditionalKeyName: "type",
            options: [
                {
                    text: "Pills",
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fieldsConfig: {
                        pills: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Pills",
                            nestedConfig: asset_content_card_config_object_spread({}, pill_fields_config)
                        }
                    }
                }
            ]
        },
        buttonPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Button Padding"
        },
        dividerConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Divider Config",
            fields: {
                backgroundColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Divider Color"
                },
                borderThickness: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Divider Thickness"
                }
            }
        },
        buttonConfig: enhancedButtonConfig
    }
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/dynamic-grid/grid-item-types.js
var grid_item_types = __webpack_require__(8244);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/dynamic-grid-config.js
function dynamic_grid_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_grid_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_grid_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var dynamic_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Dynamic Grid",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        gridPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Grid Padding"
        },
        horizontalGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Horizontal Gap"
        },
        verticalGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Vertical Gap"
        },
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        },
        borderRadius: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Border Radius"
        },
        itemMinWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Item Minimum Width",
            tooltip: "Override the default minimum width for all items"
        },
        gridItems: {
            type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
            label: "Grid items",
            conditionalKeyName: "type",
            options: [
                {
                    text: grid_item_types/* GRID_ITEM_TYPES.ASSET_CONTENT_CARD */.qE.ASSET_CONTENT_CARD,
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fieldsConfig: {
                        cards: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Asset Content Cards",
                            nestedConfig: dynamic_grid_config_object_spread({}, asset_content_card_config)
                        }
                    }
                }
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/dynamic-grid-advanced-config.js
function dynamic_grid_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function dynamic_grid_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            dynamic_grid_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var dynamic_grid_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: dynamic_grid_advanced_config_object_spread({
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/dynamic-grid/index.js



var DynamicGridComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2905).then(__webpack_require__.bind(__webpack_require__, 52905));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52905)
            ];
        }
    }
});
/* harmony default export */ var dynamic_grid = ({
    DynamicGridComponent: DynamicGridComponent,
    DynamicGridConfig: dynamic_grid_config,
    DynamicGridAdvancedConfig: dynamic_grid_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/index.js
// plop_marker:layouts_import


























/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    CarouselSelectableProductCardsGrid: carousel_selectable_product_cards_grid,
    BackgroundImageCardsGrid: background_image_cards_grid,
    AnimatedIconsGrid: animated_icons_grid,
    MarqueeCardsGrid: marquee_cards_grid,
    HoverableCardsGrid: hoverable_cards_grid,
    MarqueeGrid: marquee_grid,
    BadgesGrid: badges_grid/* default */.Z,
    SlidingCardGrid: sliding_card_grid/* default */.Z,
    PressGrid: press_grid,
    ConnectedProductsGrid: connected_products_grid,
    FlexibleCardsGrid: flexible_cards_grid/* default */.Z,
    SquareTagsGrid: square_tags_grid,
    ProductCardsGrid: product_cards_grid,
    MasonryGrid: masonry_grid,
    TagItemsGrid: tag_items_grid,
    IconWithParagraphGrid: icon_with_paragraph_grid,
    SelectableTagsWithCarouselGrid: selectable_tags_with_carousel_grid,
    BlogCardsGrid: blog_cards_grid,
    ButtonImageTagsGrid: button_image_tags_grid,
    ButtonTagsGrid: button_tags_grid,
    CardsGrid: cards_grid,
    TagsGrid: tags_grid,
    SelectableTagsGrid: selectable_tags_grid,
    ImageWithParagraphGrid: image_with_paragraph_grid,
    OnlyImageGrid: only_image_grid,
    DynamicGridComponent: dynamic_grid
});

;// CONCATENATED MODULE: ./segments/desktop/grid/index.js

var CarouselSelectableProductCardsGrid = layouts.CarouselSelectableProductCardsGrid, BackgroundImageCardsGrid = layouts.BackgroundImageCardsGrid, AnimatedIconsGrid = layouts.AnimatedIconsGrid, MarqueeCardsGrid = layouts.MarqueeCardsGrid, HoverableCardsGrid = layouts.HoverableCardsGrid, MarqueeGrid = layouts.MarqueeGrid, BadgesGrid = layouts.BadgesGrid, SlidingCardGrid = layouts.SlidingCardGrid, ConnectedProductsGrid = layouts.ConnectedProductsGrid, FlexibleCardsGrid = layouts.FlexibleCardsGrid, SquareTagsGrid = layouts.SquareTagsGrid, ProductCardsGrid = layouts.ProductCardsGrid, MasonryGrid = layouts.MasonryGrid, TagItemsGrid = layouts.TagItemsGrid, IconWithParagraphGrid = layouts.IconWithParagraphGrid, SelectableTagsWithCarouselGrid = layouts.SelectableTagsWithCarouselGrid, BlogCardsGrid = layouts.BlogCardsGrid, ButtonImageTagsGrid = layouts.ButtonImageTagsGrid, ButtonTagsGrid = layouts.ButtonTagsGrid, CardsGrid = layouts.CardsGrid, TagsGrid = layouts.TagsGrid, SelectableTagsGrid = layouts.SelectableTagsGrid, ImageWithParagraphGrid = layouts.ImageWithParagraphGrid, OnlyImageGrid = layouts.OnlyImageGrid, PressGrid = layouts.PressGrid, grid_DynamicGridComponent = layouts.DynamicGridComponent;
/* harmony default export */ var grid = ({
    // plop_marker:segment_index_add_layout
    CarouselSelectableProductCardsGridComponent: {
        type: "CarouselSelectableProductCardsGridComponent",
        title: "Carousel Selectable Product Cards",
        imgSrc: "/static/img/segments/layouts/carousel-selectable-product-cards-grid.png",
        config: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridConfig,
        advancedConfig: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridAdvancedConfig,
        component: CarouselSelectableProductCardsGrid.CarouselSelectableProductCardsGridComponent
    },
    BackgroundImageCardsGridComponent: {
        type: "BackgroundImageCardsGridComponent",
        title: "Background Image Cards",
        imgSrc: "/static/img/segments/layouts/background-image-cards-grid.png",
        config: BackgroundImageCardsGrid.BackgroundImageCardsGridConfig,
        advancedConfig: BackgroundImageCardsGrid.BackgroundImageCardsGridAdvancedConfig,
        component: BackgroundImageCardsGrid.BackgroundImageCardsGridComponent
    },
    AnimatedIconsGridComponent: {
        type: "AnimatedIconsGridComponent",
        title: "Animated Icons",
        imgSrc: "/static/img/segments/layouts/animated-icons-grid.png",
        config: AnimatedIconsGrid.AnimatedIconsGridConfig,
        advancedConfig: AnimatedIconsGrid.AnimatedIconsGridAdvancedConfig,
        component: AnimatedIconsGrid.AnimatedIconsGridComponent
    },
    MarqueeCardsGridComponent: {
        type: "MarqueeCardsGridComponent",
        title: "Marquee Cards",
        imgSrc: "/static/img/segments/layouts/marquee-cards-grid.png",
        config: MarqueeCardsGrid.MarqueeCardsGridConfig,
        advancedConfig: MarqueeCardsGrid.MarqueeCardsGridAdvancedConfig,
        component: MarqueeCardsGrid.MarqueeCardsGridComponent
    },
    HoverableCardsGridComponent: {
        type: "HoverableCardsGridComponent",
        title: "Hoverable Cards",
        imgSrc: "/static/img/segments/layouts/hoverable-cards-grid.png",
        config: HoverableCardsGrid.HoverableCardsGridConfig,
        advancedConfig: HoverableCardsGrid.HoverableCardsGridAdvancedConfig,
        component: HoverableCardsGrid.HoverableCardsGridComponent
    },
    MarqueeGridComponent: {
        type: "MarqueeGridComponent",
        title: "Marquee",
        imgSrc: "/static/img/segments/layouts/marquee-grid.png",
        config: MarqueeGrid.MarqueeGridConfig,
        advancedConfig: MarqueeGrid.MarqueeGridAdvancedConfig,
        component: MarqueeGrid.MarqueeGridComponent
    },
    BadgesGridComponent: {
        type: "BadgesGridComponent",
        title: "Badges",
        imgSrc: "/static/img/segments/layouts/badges-grid.png",
        config: BadgesGrid.BadgesGridConfig,
        advancedConfig: BadgesGrid.BadgesGridAdvancedConfig,
        component: BadgesGrid.BadgesGridComponent
    },
    SlidingCardGridComponent: {
        type: "SlidingCardGridComponent",
        title: "Sliding Card",
        imgSrc: "/static/img/segments/layouts/sliding-card-grid.png",
        config: SlidingCardGrid.SlidingCardGridConfig,
        advancedConfig: SlidingCardGrid.SlidingCardGridAdvancedConfig,
        component: SlidingCardGrid.SlidingCardGridComponent
    },
    PressGridComponent: {
        type: "PressGridComponent",
        title: "Press",
        imgSrc: "/static/img/segments/layouts/press-grid.png",
        config: PressGrid.PressGridConfig,
        advancedConfig: PressGrid.PressGridAdvancedConfig,
        component: PressGrid.PressGridComponent
    },
    ConnectedProductsGridComponent: {
        type: "ConnectedProductsGridComponent",
        title: "Connected Products",
        imgSrc: "/static/img/segments/layouts/connected-products-grid.png",
        config: ConnectedProductsGrid.ConnectedProductsGridConfig,
        advancedConfig: ConnectedProductsGrid.ConnectedProductsGridAdvancedConfig,
        component: ConnectedProductsGrid.ConnectedProductsGridComponent
    },
    FlexibleCardsGridComponent: {
        type: "FlexibleCardsGridComponent",
        title: "Flexible Cards",
        imgSrc: "/static/img/segments/layouts/flexible-cards-grid.png",
        config: FlexibleCardsGrid.FlexibleCardsGridConfig,
        advancedConfig: FlexibleCardsGrid.FlexibleCardsGridAdvancedConfig,
        component: FlexibleCardsGrid.FlexibleCardsGridComponent
    },
    SquareTagsGridComponent: {
        type: "SquareTagsGridComponent",
        title: "Square Tags",
        imgSrc: "/static/img/segments/layouts/square-tags-grid.png",
        config: SquareTagsGrid.SquareTagsGridConfig,
        advancedConfig: SquareTagsGrid.SquareTagsGridAdvancedConfig,
        component: SquareTagsGrid.SquareTagsGridComponent
    },
    ProductCardsGridComponent: {
        type: "ProductCardsGridComponent",
        title: "Product Cards",
        imgSrc: "/static/img/segments/layouts/product-cards-grid.png",
        config: ProductCardsGrid.ProductCardsGridConfig,
        advancedConfig: ProductCardsGrid.ProductCardsGridAdvancedConfig,
        component: ProductCardsGrid.ProductCardsGridComponent
    },
    MasonryGridComponent: {
        type: "MasonryGridComponent",
        title: "Masonry",
        imgSrc: "/static/img/segments/layouts/masonry-grid.png",
        config: MasonryGrid.MasonryGridConfig,
        advancedConfig: MasonryGrid.MasonryGridAdvancedConfig,
        component: MasonryGrid.MasonryGridComponent
    },
    TagItemsGridComponent: {
        type: "TagItemsGridComponent",
        title: "Tag Items",
        imgSrc: "/static/img/segments/layouts/tag-items-grid.png",
        config: TagItemsGrid.TagItemsGridConfig,
        advancedConfig: TagItemsGrid.TagItemsGridAdvancedConfig,
        component: TagItemsGrid.TagItemsGridComponent
    },
    IconWithParagraphGridComponent: {
        type: "IconWithParagraphGridComponent",
        title: "Icon With Paragraph",
        imgSrc: "/static/img/segments/layouts/icon-with-paragraph-grid.png",
        config: IconWithParagraphGrid.IconWithParagraphGridConfig,
        advancedConfig: IconWithParagraphGrid.IconWithParagraphGridAdvancedConfig,
        component: IconWithParagraphGrid.IconWithParagraphGridComponent
    },
    SelectableTagsWithCarouselGridComponent: {
        type: "SelectableTagsWithCarouselGridComponent",
        title: "Selectable Tags With Carousel",
        imgSrc: "/static/img/segments/layouts/selectable-tags-with-carousel-grid.png",
        config: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridConfig,
        advancedConfig: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridAdvancedConfig,
        component: SelectableTagsWithCarouselGrid.SelectableTagsWithCarouselGridComponent
    },
    BlogCardsGridComponent: {
        type: "BlogCardsGridComponent",
        title: "Blog Cards",
        imgSrc: "/static/img/segments/layouts/blog-cards-grid.png",
        config: BlogCardsGrid.BlogCardsGridConfig,
        advancedConfig: BlogCardsGrid.BlogCardsGridAdvancedConfig,
        component: BlogCardsGrid.BlogCardsGridComponent
    },
    ButtonImageTagsGridComponent: {
        type: "ButtonImageTagsGridComponent",
        title: "Button Image Tags",
        imgSrc: "/static/img/segments/layouts/button-image-tags-grid.png",
        config: ButtonImageTagsGrid.ButtonImageTagsGridConfig,
        advancedConfig: ButtonImageTagsGrid.ButtonImageTagsGridAdvancedConfig,
        component: ButtonImageTagsGrid.ButtonImageTagsGridComponent
    },
    ButtonTagsGridComponent: {
        type: "ButtonTagsGridComponent",
        title: "Button Tags",
        imgSrc: "/static/img/segments/layouts/button-tags-grid.png",
        config: ButtonTagsGrid.ButtonTagsGridConfig,
        advancedConfig: ButtonTagsGrid.ButtonTagsGridAdvancedConfig,
        component: ButtonTagsGrid.ButtonTagsGridComponent
    },
    CardsGridComponent: {
        type: "CardsGridComponent",
        title: "Cards",
        imgSrc: "/static/img/segments/layouts/cards-grid.png",
        config: CardsGrid.CardsGridConfig,
        advancedConfig: CardsGrid.CardsGridAdvancedConfig,
        component: CardsGrid.CardsGridComponent
    },
    TagsGridComponent: {
        type: "TagsGridComponent",
        title: "Tags",
        imgSrc: "/static/img/segments/layouts/tags-grid.png",
        config: TagsGrid.TagsGridConfig,
        advancedConfig: TagsGrid.TagsGridAdvancedConfig,
        component: TagsGrid.TagsGridComponent
    },
    SelectableTagsGridComponent: {
        type: "SelectableTagsGridComponent",
        title: "Selectable Tags Grid",
        imgSrc: "/static/img/segments/layouts/selectable-tags-grid.png",
        config: SelectableTagsGrid.SelectableTagsGridConfig,
        advancedConfig: SelectableTagsGrid.SelectableTagsGridAdvancedConfig,
        component: SelectableTagsGrid.SelectableTagsGridComponent
    },
    ImageWithParagraphGridComponent: {
        type: "ImageWithParagraphGridComponent",
        title: "Image With Paragraph",
        imgSrc: "/static/img/segments/layouts/image-with-paragraph-grid.png",
        config: ImageWithParagraphGrid.ImageWithParagraphGridConfig,
        advancedConfig: ImageWithParagraphGrid.ImageWithParagraphGridAdvancedConfig,
        component: ImageWithParagraphGrid.ImageWithParagraphGridComponent
    },
    OnlyImageGridComponent: {
        type: "OnlyImageGridComponent",
        title: "Only Image",
        imgSrc: "/static/img/segments/layouts/only-image-grid.png",
        config: OnlyImageGrid.OnlyImageGridConfig,
        advancedConfig: OnlyImageGrid.OnlyImageGridAdvancedConfig,
        component: OnlyImageGrid.OnlyImageGridComponent
    },
    DynamicGridComponent: {
        type: "DynamicGridComponent",
        title: "Dynamic Grid",
        imgSrc: "/static/img/segments/layouts/only-image-grid.png",
        config: grid_DynamicGridComponent.DynamicGridConfig,
        advancedConfig: grid_DynamicGridComponent.DynamicGridAdvancedConfig,
        component: grid_DynamicGridComponent.DynamicGridComponent
    }
});


/***/ }),

/***/ 96800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ ButtonTypes; }
/* harmony export */ });
var ButtonTypes = {
    LABEL: "Label",
    PRODUCT_SIGNUP_AND_LEARN_MORE: "Product signup and learn more"
};


/***/ }),

/***/ 72606:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({
    CARD_WIDTH: 390,
    IMAGE_HEIGHT: 188,
    WRITER_AVATAR_IMAGE_HEIGHT: 40,
    WRITER_AVATAR_IMAGE_WIDTH: 40
});


/***/ }),

/***/ 8244:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fe": function() { return /* binding */ DEFAULT_MIN_WIDTH; },
/* harmony export */   "qE": function() { return /* binding */ GRID_ITEM_TYPES; }
/* harmony export */ });
var DEFAULT_MIN_WIDTH = "250px";
var GRID_ITEM_TYPES = {
    ASSET_CONTENT_CARD: "Asset Content Card"
};
Object.freeze(GRID_ITEM_TYPES);
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (GRID_ITEM_TYPES)));


/***/ }),

/***/ 6795:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Nc": function() { return /* binding */ cardsProps; },
/* harmony export */   "Q4": function() { return /* binding */ GLOBAL_LOCATION; },
/* harmony export */   "RE": function() { return /* binding */ ISRAEL_LOCATION; },
/* harmony export */   "dP": function() { return /* binding */ israelGridItems; },
/* harmony export */   "mz": function() { return /* binding */ globalGridItems; }
/* harmony export */ });
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77869);

var ISRAEL_LOCATION = "israel";
var GLOBAL_LOCATION = "global";
var cardsProps = {
    shadowCards: true,
    removeShadowOnHover: false,
    gridAlignment: "center",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_0__.XS
};
var israelGridItems = [
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Fast_company_logo_small.png"
                }
            },
            title: "<b>With apps for forms and whiteboards, monday.com is building a suite</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png"
        },
        link: {
            href: "https://www.fastcompany.com/90724310/monday-com-workforms-canvas"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Protocol_logo_small.png"
                }
            },
            title: "<b>Why monday thinks it can win the future of work</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png"
        },
        link: {
            href: "https://www.protocol.com/workplace/monday-app-ipo"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Maariv_logo_small.png"
                }
            },
            title: "<b>monday.com is the 5th Best Place to work in Israel - Dun's 100</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Maariv_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Maariv_thumbnail.png"
        },
        link: {
            href: "https://www.maariv.co.il/business/tech/Article-958561"
        }
    }
];
var globalGridItems = [
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Fast_company_logo_small.png"
                }
            },
            title: "<b>With apps for forms and whiteboards, monday.com is building a suite</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Fast_company_thumbnail.png"
        },
        link: {
            href: "https://www.fastcompany.com/90724310/monday-com-workforms-canvas"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Protocol_logo_small.png"
                }
            },
            title: "<b>Why monday thinks it can win the future of work</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Protocol_thumbnail.png"
        },
        link: {
            href: "https://www.protocol.com/workplace/monday-app-ipo"
        }
    },
    {
        cardNumOfColumnsWidth: 1.2,
        height: 300,
        width: 300,
        fullParagraph: {
            topic: {
                image: {
                    src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/small%20logos/Great_placel_logo_small.png"
                }
            },
            title: "<b>Great place to work certified</b>",
            body: ""
        },
        src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Great_place_to_work_thumbnail.png",
        mobileImage: {
            src: "https://dapulse-res.cloudinary.com/image/upload/remote_mondaycom_static/uploads/recruitment/thumbnails/Great_place_to_work_thumbnail.png"
        },
        link: {
            href: "https://www.maariv.co.il/business/tech/Article-958561"
        }
    }
];


/***/ }),

/***/ 96817:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_selectable_tags_grid_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1117);


/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Selectable tags layout",
    fields: segments_desktop_core_components_selectable_tags_grid_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
});


/***/ }),

/***/ 14061:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69223);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(_object_spread({
        width: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Max Width (%)"
        }
    }, segments_desktop_shared_advanced_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP), {
        noImageWidth: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.BOOLEAN,
            label: "No Image Width"
        },
        tagTextSize: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.TEXT,
            label: "Tag Text Size"
        }
    })
});


/***/ }),

/***/ 48127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ tag_items_grid_config; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/core-components/tag/fields-config.js

/* harmony default export */ var fields_config = ({
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Text",
        translatable: true
    },
    tagIconsrc: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        label: "Select an Image"
    },
    href: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Href"
    },
    openInNewTab: {
        type: "boolean",
        label: "Should Open In New Tab"
    }
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var tag_items_grid_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags Grid",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        gridTagsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tags background color",
            possibleColors: (0,_to_consumable_array/* default */.Z)(color_picker_constants.newBrandColors).concat([
                color_consts.TRANSPARENT_COLOR_NAME
            ])
        },
        gridTagsImageHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tag images height"
        },
        gridTags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tag",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: _object_spread({}, fields_config)
            }
        }
    })
});


/***/ }),

/***/ 78764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ homepage_first_fold; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tag/fields-config.js
var selectable_tag_fields_config = __webpack_require__(82778);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/consts.js + 11 modules
var consts = __webpack_require__(7861);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-config.js

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var tagValue = selectable_tag_fields_config/* default.tagValue */.Z.tagValue, galleryImage = selectable_tag_fields_config/* default.galleryImage */.Z.galleryImage, initiallySelected = selectable_tag_fields_config/* default.initiallySelected */.Z.initiallySelected, tagBackgroundColor = selectable_tag_fields_config/* default.tagBackgroundColor */.Z.tagBackgroundColor, restOfTagsConfig = _object_without_properties(selectable_tag_fields_config/* default */.Z, [
    "tagValue",
    "galleryImage",
    "initiallySelected",
    "tagBackgroundColor"
]);
var TAGS_ICON_OPTIONS = Object.keys(consts/* NAME_TO_ICON */.qs).map(function(name) {
    return {
        text: name,
        value: name
    };
});
/* harmony default export */ var side_by_side_paragraph_and_tags_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Paragraph And Tags",
    fields: {
        tagsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags Title"
        },
        gap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Space between paragraph and tags"
        },
        useTagsClusterCTA: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Use tags cluster CTA"
        },
        tags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Grid Selectable Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: _object_spread_props(_object_spread({}, restOfTagsConfig), {
                    tagColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Color",
                        possibleColors: (0,_to_consumable_array/* default */.Z)(color_picker_constants.newBrandColors).concat([
                            color_consts.LAVENDER_PURPLE_COLOR_NAME,
                            "lipstick",
                            "bubble",
                            color_consts.TURQUOISE_BRIGHT_COLOR_NAME,
                            "purple",
                            "orange",
                            color_consts.AZURE_RADIANCE
                        ])
                    },
                    tagImage: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tag Image",
                        fields: _object_spread({}, asset_fields_config/* default.image.fields */.Z.image.fields)
                    },
                    tagIconName: {
                        type: template_field_type.FIELD_TYPES.COMBO,
                        label: "Tag Icon",
                        options: TAGS_ICON_OPTIONS
                    }
                })
            }
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: fields_config/* default */.Z
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/side-by-side-paragraph-and-tags-homepage-first-fold-advanced-config.js
function side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        tagsTitleFontSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags title text size",
            options: [
                {
                    value: 14,
                    text: "14px"
                },
                {
                    value: 16,
                    text: "16px (default)"
                },
                {
                    value: 18,
                    text: "18px"
                },
                {
                    value: 20,
                    text: "20px"
                },
                {
                    value: 22,
                    text: "22px"
                }
            ]
        },
        tagsTitleAlignment: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags title alignment",
            options: [
                {
                    value: "left",
                    text: "Left"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "right",
                    text: "Right"
                }
            ]
        },
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        },
        fullParagraphTopMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Full Paragraph top margin"
        },
        defaultImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tag default Image",
            fields: side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, asset_fields_config/* default */.Z)
        },
        blurDefaultImage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Blur default image"
        },
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min height"
        },
        showSelectedProduct: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Show latest selected product"
        },
        flipUseCasesAndAssets: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Flip use cases and assets"
        },
        verticalView: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Vertical view"
        },
        imageMaxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Image max width (default is 900px)"
        },
        useCasesTopMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Use cases top margin"
        },
        resizingFactor: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Resizing factor"
        },
        assetsAndTagsExtraSpace: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Assets and tags extra space (default is 10vw)"
        },
        startAtCenter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Start at center"
        },
        enabledDefaultImageAnimation: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Enable default image animation"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/index.js

var SideBySideParagraphAndTagsHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6424).then(__webpack_require__.bind(__webpack_require__, 66424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(66424)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_paragraph_and_tags_homepage_first_fold = ({
    SideBySideParagraphAndTagsHomepageFirstFoldComponent: SideBySideParagraphAndTagsHomepageFirstFoldComponent,
    SideBySideParagraphAndTagsHomepageFirstFoldConfig: side_by_side_paragraph_and_tags_homepage_first_fold_config,
    SideBySideParagraphAndTagsHomepageFirstFoldAdvancedConfig: side_by_side_paragraph_and_tags_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/platform-interactive-experience-homepage-first-fold-config.js
function platform_interactive_experience_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function platform_interactive_experience_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_interactive_experience_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function platform_interactive_experience_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function platform_interactive_experience_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        platform_interactive_experience_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var platform_interactive_experience_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Platform Interactive Experience",
    fields: platform_interactive_experience_homepage_first_fold_config_object_spread_props(platform_interactive_experience_homepage_first_fold_config_object_spread({}, theme_config/* default */.Z), {
        backgroundImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Background Image"
        },
        backgroundSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Background Size"
        },
        glowImage: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Glow Image",
            fields: {
                src: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Image"
                },
                width: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Width"
                },
                positionTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Position Top"
                },
                positionLeft: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Position Left"
                }
            }
        },
        interactions: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Interactions",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    label: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Label"
                    },
                    icon: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Icon"
                    },
                    image: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Image",
                        fields: {
                            src: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Image"
                            },
                            width: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Width"
                            }
                        }
                    },
                    actionAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Action asset",
                        fields: platform_interactive_experience_homepage_first_fold_config_object_spread({}, asset_fields_config/* default */.Z, advanced_field_config/* default */.Z)
                    },
                    position: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Position",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    secondaryPosition: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Secondary Position (optional)",
                        fields: {
                            top: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Top"
                            },
                            left: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Left"
                            }
                        }
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Content",
                        fields: platform_interactive_experience_homepage_first_fold_config_object_spread({}, fields_config/* default */.Z, advanced_fields_config/* default */.Z)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/platform-interactive-experience-homepage-first-fold-advanced-config.js
function platform_interactive_experience_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            platform_interactive_experience_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function platform_interactive_experience_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        platform_interactive_experience_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var platform_interactive_experience_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: platform_interactive_experience_homepage_first_fold_advanced_config_object_spread_props(platform_interactive_experience_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        segmentHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Height"
        },
        segmentMaxHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Segment Max Height"
        },
        rippleEffectAnimationDuration: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Ripple Effect Animation Duration (s)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/platform-interactive-experience-homepage-first-fold/index.js



var PlatformInteractiveExperienceHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2617), __webpack_require__.e(6212)]).then(__webpack_require__.bind(__webpack_require__, 56212));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56212)
            ];
        }
    }
});
/* harmony default export */ var platform_interactive_experience_homepage_first_fold = ({
    PlatformInteractiveExperienceHomepageFirstFoldComponent: PlatformInteractiveExperienceHomepageFirstFoldComponent,
    PlatformInteractiveExperienceHomepageFirstFoldConfig: platform_interactive_experience_homepage_first_fold_config,
    PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig: platform_interactive_experience_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-config.js
function tags_by_product_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function tags_by_product_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_by_product_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function tags_by_product_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        tags_by_product_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = tags_by_product_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function tags_by_product_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var restOfTitleConfig = _extends({}, _object_destructuring_empty(title_fields_config/* default */.Z));
var restOfParagraphConfig = _extends({}, _object_destructuring_empty(paragraph_fields_config/* default */.Z));
var textAlign = fields_config/* default.textAlign */.Z.textAlign, mobileTextAlign = fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, textColor = fields_config/* default.textColor */.Z.textColor, topic = fields_config/* default.topic */.Z.topic, tags_by_product_homepage_first_fold_config_button = fields_config/* default.buttonConfig */.Z.buttonConfig, restFullParagraphFieldsConfig = tags_by_product_homepage_first_fold_config_object_without_properties(fields_config/* default */.Z, [
    "textAlign",
    "mobileTextAlign",
    "textColor",
    "topic",
    "buttonConfig"
]);
/* harmony default export */ var tags_by_product_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Tags By Product",
    fields: tags_by_product_homepage_first_fold_config_object_spread_props(tags_by_product_homepage_first_fold_config_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: restFullParagraphFieldsConfig
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        },
        tabsPaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs padding top"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab title",
                        fields: tags_by_product_homepage_first_fold_config_object_spread({
                            productImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Product logo image"
                            },
                            selectedProductImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Selected product logo image"
                            }
                        }, restOfTitleConfig, restOfParagraphConfig)
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            clusters: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Clusters",
                                maxLimit: 9,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Text",
                                            translatable: true
                                        },
                                        image: {
                                            type: template_field_type.FIELD_TYPES.GALLERY,
                                            label: "Image"
                                        },
                                        colorName: {
                                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                            label: "Color"
                                        },
                                        clusterId: {
                                            type: template_field_type.FIELD_TYPES.CLUSTERS,
                                            label: "Cluster Id"
                                        },
                                        useCaseId: {
                                            type: template_field_type.FIELD_TYPES.SUB_CLUSTERS,
                                            label: "Usecase Id"
                                        },
                                        initiallySelected: {
                                            type: template_field_type.FIELD_TYPES.BOOLEAN,
                                            label: "Initially selected"
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progress Bar Color"
        },
        isV2: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is V2"
        },
        excludeFromWMHighIntentExperienceTest: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Exclude from WN high intent test (don't use)"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/tags-by-product-homepage-first-fold-advanced-config.js
function tags_by_product_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function tags_by_product_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            tags_by_product_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function tags_by_product_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = tags_by_product_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function tags_by_product_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, restOfParagraphAdvancedConfig = tags_by_product_homepage_first_fold_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin"
]);
/* harmony default export */ var tags_by_product_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: tags_by_product_homepage_first_fold_advanced_config_object_spread({
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: restOfParagraphAdvancedConfig
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_advanced_field_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/tags-by-product-homepage-first-fold/index.js

var TagsByProductHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(6416), __webpack_require__.e(2948), __webpack_require__.e(3744)]).then(__webpack_require__.bind(__webpack_require__, 43744));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(43744)
            ];
        }
    }
});


/* harmony default export */ var tags_by_product_homepage_first_fold = ({
    TagsByProductHomepageFirstFoldComponent: TagsByProductHomepageFirstFoldComponent,
    TagsByProductHomepageFirstFoldConfig: tags_by_product_homepage_first_fold_config,
    TagsByProductHomepageFirstFoldAdvancedConfig: tags_by_product_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/products-by-use-cases-homepage-first-fold-config.js

function products_by_use_cases_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_by_use_cases_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_by_use_cases_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_by_use_cases_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_by_use_cases_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = products_by_use_cases_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FullWithBulletsParagraphConfig_fields = full_with_bullets_paragraph_config/* default.fields */.Z.fields, products_by_use_cases_homepage_first_fold_config_topic = _FullWithBulletsParagraphConfig_fields.topic, buttonConfig = _FullWithBulletsParagraphConfig_fields.buttonConfig, body = _FullWithBulletsParagraphConfig_fields.body, theme = _FullWithBulletsParagraphConfig_fields.theme, products_by_use_cases_homepage_first_fold_config_mobileTextAlign = _FullWithBulletsParagraphConfig_fields.mobileTextAlign, bodyColor = _FullWithBulletsParagraphConfig_fields.bodyColor, titleColor = _FullWithBulletsParagraphConfig_fields.titleColor, bulletsConfig = _FullWithBulletsParagraphConfig_fields.bulletsConfig, restOfFullWithBulletsParagraphConfigFields = products_by_use_cases_homepage_first_fold_config_object_without_properties(_FullWithBulletsParagraphConfig_fields, [
    "topic",
    "buttonConfig",
    "body",
    "theme",
    "mobileTextAlign",
    "bodyColor",
    "titleColor",
    "bulletsConfig"
]);
/* harmony default export */ var products_by_use_cases_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products By Use Cases",
    fields: {
        horizontalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Products horizontal padding"
        },
        tagsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags title",
            textArea: true,
            translatable: true
        },
        sideBarTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Use cases side bar title",
            textArea: true,
            translatable: true
        },
        useCases: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tag: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            text: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Tag text",
                                translatable: true
                            },
                            color: {
                                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                label: "Tag Color",
                                possibleColors: (0,_to_consumable_array/* default */.Z)(color_picker_constants.newBrandColors).concat([
                                    "orange"
                                ])
                            }
                        }
                    },
                    clusterId: {
                        type: template_field_type.FIELD_TYPES.CLUSTERS,
                        label: "Cluster Id"
                    },
                    product: {
                        label: "Product",
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: products_by_use_cases_homepage_first_fold_config_object_spread_props(products_by_use_cases_homepage_first_fold_config_object_spread({}, restOfFullWithBulletsParagraphConfigFields), {
                            productType: {
                                type: template_field_type.FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            },
                            bulletsConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Product use cases",
                                fields: {
                                    bullets: bulletsConfig.fields.bullets
                                }
                            },
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: asset_fields_config/* default */.Z
                            }
                        })
                    }
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/products-by-use-cases-homepage-first-fold-advanced-config.js
function products_by_use_cases_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_by_use_cases_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_by_use_cases_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var products_by_use_cases_homepage_first_fold_advanced_config_bulletsConfig = full_with_bullets_paragraph_config/* default.fields.bulletsConfig */.Z.fields.bulletsConfig;
var _FullWithBulletsParagraphAdvancedConfig_fields = full_with_bullets_paragraph_advanced_config/* default.fields */.Z.fields, topTriangle = _FullWithBulletsParagraphAdvancedConfig_fields.topTriangle, bottomTriangle = _FullWithBulletsParagraphAdvancedConfig_fields.bottomTriangle, segmentId = _FullWithBulletsParagraphAdvancedConfig_fields.segmentId, segmentMinHeight = _FullWithBulletsParagraphAdvancedConfig_fields.segmentMinHeight, restOfParagraph = products_by_use_cases_homepage_first_fold_advanced_config_object_without_properties(_FullWithBulletsParagraphAdvancedConfig_fields, [
    "topTriangle",
    "bottomTriangle",
    "segmentId",
    "segmentMinHeight"
]);
/* harmony default export */ var products_by_use_cases_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: products_by_use_cases_homepage_first_fold_advanced_config_object_spread_props(products_by_use_cases_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        parallaxSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Parallax speed"
        },
        tagsTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tags title",
            fields: title_advanced_field_config/* default */.Z
        },
        tagsVerticalPadding: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tags vertical padding"
        },
        hidePanel: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Hide upper tags panel"
        },
        tagsFontSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Tags text size",
            options: [
                {
                    value: "0.8125rem",
                    text: "13px"
                },
                {
                    value: "0.875rem",
                    text: "14px"
                }
            ]
        },
        productAdvanceConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product advanced config",
            fields: {
                productDetailsVerticalPadding: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Product details left padding"
                },
                useCasesAdvancedConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Product use cases",
                    fields: {
                        horizontalPadding: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Horizontal padding"
                        },
                        productParagraph: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            label: "Product paragraph",
                            fields: restOfParagraph
                        },
                        bulletTextSize: products_by_use_cases_homepage_first_fold_advanced_config_bulletsConfig.fields.bulletTextSize
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/products-by-use-cases-homepage-first-fold/index.js



var ProductsByUseCasesHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2160).then(__webpack_require__.bind(__webpack_require__, 12160));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12160)
            ];
        }
    }
});
/* harmony default export */ var products_by_use_cases_homepage_first_fold = ({
    ProductsByUseCasesHomepageFirstFoldComponent: ProductsByUseCasesHomepageFirstFoldComponent,
    ProductsByUseCasesHomepageFirstFoldConfig: products_by_use_cases_homepage_first_fold_config,
    ProductsByUseCasesHomepageFirstFoldAdvancedConfig: products_by_use_cases_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/button/signup-button/fields-config.js
var signup_button_fields_config = __webpack_require__(96587);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js + 3 modules
var monday_products_homepage_first_fold_consts = __webpack_require__(78679);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/monday-products-homepage-first-fold-config.js
function monday_products_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_products_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_products_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var signupWithsolutionAppReferenceId = signup_button_fields_config/* default.signupWithsolutionAppReferenceId */.Z.signupWithsolutionAppReferenceId, signupClusterId = signup_button_fields_config/* default.signupClusterId */.Z.signupClusterId, restSignupButtonConfig = monday_products_homepage_first_fold_config_object_without_properties(signup_button_fields_config/* default */.Z, [
    "signupWithsolutionAppReferenceId",
    "signupClusterId"
]);
var textSize = paragraph_advanced_fields_config/* default.textSize */.Z.textSize;
/* harmony default export */ var monday_products_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Products",
    fields: {
        version: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Version",
            options: [
                {
                    value: monday_products_homepage_first_fold_consts/* HOSPITAL */.Lj,
                    text: "Hospital"
                },
                {
                    value: monday_products_homepage_first_fold_consts/* APPS */.ei,
                    text: "Apps"
                },
                {
                    value: monday_products_homepage_first_fold_consts/* ILLUSTRATIVE */.kr,
                    text: "Illustrative"
                }
            ]
        },
        isV2: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is V2"
        },
        checkBoxInsteadOfModal: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Checkbox Instead Of Modal"
        },
        removeCheckbox: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove checkbox"
        },
        setCardImageAsBackground: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Set Card Image As Background"
        },
        idealForAndImage: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Ideal For And Image"
        },
        IdealForInBottomPart: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Add Ideal For In Card Bottom Part"
        },
        scaleWhenSelecting: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Scale When Selecting A Card"
        },
        removeSignupButton: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove Sign Up Button"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: fields_config/* default */.Z
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_fields_config/* default */.Z
        },
        buttonConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Signup button",
            fields: restSignupButtonConfig
        },
        distanceOfBottomPartFromTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Distance of bottom part from top when hovered"
        },
        cardWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Width"
        },
        logoWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Logo Width"
        },
        cardBackSidePaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card Back Side Padding Top"
        },
        departmentsHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Departments Height"
        },
        departmentsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Departments title"
        },
        cancelFlip: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Cancel Flip"
        },
        products: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Products",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.COMBO,
                        label: "Product type",
                        options: products/* PRODUCT_OPTIONS */.ey
                    },
                    text: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Card Text",
                        translatable: true,
                        textArea: true
                    },
                    modalTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Product modal title",
                        translatable: true,
                        textArea: true
                    },
                    modalSubTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Product modal subtitle",
                        translatable: true,
                        textArea: true
                    },
                    textSize: textSize,
                    marginAboveCardText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin Above Card Text"
                    },
                    marginUnderCardText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Margin Under Card Text"
                    },
                    logoImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Logo Image"
                    },
                    productImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Image"
                    },
                    logoImageV2: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Logo Image V2 (also in modal)"
                    },
                    productImageV2: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Product Image V2"
                    },
                    cardBackImagev3: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "V3 Card Back Image"
                    },
                    productModalImage: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "V3 Product Modal Image"
                    },
                    backgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Color"
                    },
                    cardMainColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Card Main Color"
                    },
                    cardButtonColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Card Main CTA Button Color"
                    },
                    useCasesTagesTextColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Use Cases Tags Text Color"
                    },
                    useCasesTagsBackgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Use Cases Tags Background Color"
                    },
                    bottomPartBackgroundColorV2: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Bottom Part Background Color V2"
                    },
                    cardBackBackgroundColor: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "V3 Back color"
                    },
                    departments: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Departments",
                        maxLimit: 10,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                }
                            }
                        }
                    },
                    useCases: {
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        label: "Use Cases",
                        maxLimit: 10,
                        nestedConfig: {
                            type: template_field_type.FIELD_TYPES.NESTED,
                            fields: {
                                text: {
                                    type: template_field_type.FIELD_TYPES.TEXT,
                                    label: "Text",
                                    translatable: true
                                }
                            }
                        }
                    },
                    preSelect: {
                        type: template_field_type.FIELD_TYPES.BOOLEAN,
                        label: "Pre Select Card"
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/monday-products-homepage-first-fold-advanced-config.js
function monday_products_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_products_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_products_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_products_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_products_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_products_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var monday_products_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_products_homepage_first_fold_advanced_config_object_spread_props(monday_products_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        fullParagraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        subTitleAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Sub title",
            fields: title_advanced_field_config/* default */.Z
        },
        marginAboveCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin Above Cards",
            translatable: true
        },
        marginBelowCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin Below Cards",
            translatable: true
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/index.js



var MondayProductsHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6115).then(__webpack_require__.bind(__webpack_require__, 45866));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45866)
            ];
        }
    }
});
/* harmony default export */ var monday_products_homepage_first_fold = ({
    MondayProductsHomepageFirstFoldComponent: MondayProductsHomepageFirstFoldComponent,
    MondayProductsHomepageFirstFoldConfig: monday_products_homepage_first_fold_config,
    MondayProductsHomepageFirstFoldAdvancedConfig: monday_products_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/selectable-tags-grid/selectable-tags-grid-config.js
var selectable_tags_grid_config = __webpack_require__(96817);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/full-paragraph-and-tags-homepage-first-fold-config.js
function full_paragraph_and_tags_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_and_tags_homepage_first_fold_config_extends() {
    full_paragraph_and_tags_homepage_first_fold_config_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return full_paragraph_and_tags_homepage_first_fold_config_extends.apply(this, arguments);
}
function full_paragraph_and_tags_homepage_first_fold_config_object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_paragraph_and_tags_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_paragraph_and_tags_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = full_paragraph_and_tags_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var full_paragraph_and_tags_homepage_first_fold_config_textColor = fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFields = full_paragraph_and_tags_homepage_first_fold_config_object_without_properties(fields_config/* default */.Z, [
    "textColor"
]);
var selectedSelectableTagsTagsFieldsConfig = full_paragraph_and_tags_homepage_first_fold_config_extends({}, full_paragraph_and_tags_homepage_first_fold_config_object_destructuring_empty(selectable_tags_grid_config/* default */.Z));
/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Paragraph And Tags",
    fields: full_paragraph_and_tags_homepage_first_fold_config_object_spread_props(full_paragraph_and_tags_homepage_first_fold_config_object_spread({}, theme_config/* default */.Z), {
        marginAboveTags: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between paragraph and tags"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        },
        selectableTags: selectedSelectableTagsTagsFieldsConfig
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/selectable-tags-grid/advanced-field-config.js
var selectable_tags_grid_advanced_field_config = __webpack_require__(33129);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/full-paragraph-and-tags-homepage-first-fold-advanced-config.js
function full_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_paragraph_and_tags_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        full_paragraph_and_tags_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread_props(full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
        },
        selectableTags: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Selectable tags",
            fields: full_paragraph_and_tags_homepage_first_fold_advanced_config_object_spread({}, selectable_tags_grid_advanced_field_config/* default */.Z)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/full-paragraph-and-tags-homepage-first-fold/index.js



var FullParagraphAndTagsHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4222), __webpack_require__.e(9340)]).then(__webpack_require__.bind(__webpack_require__, 29340));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(29340)
            ];
        }
    }
});
/* harmony default export */ var full_paragraph_and_tags_homepage_first_fold = ({
    FullParagraphAndTagsHomepageFirstFoldComponent: FullParagraphAndTagsHomepageFirstFoldComponent,
    FullParagraphAndTagsHomepageFirstFoldConfig: full_paragraph_and_tags_homepage_first_fold_config,
    FullParagraphAndTagsHomepageFirstFoldAdvancedConfig: full_paragraph_and_tags_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./segments/button-service.js
var button_service = __webpack_require__(93833);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/live-board-homepage-first-fold-config.js

function live_board_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var live_board_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Live Board",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: (0,_to_consumable_array/* default */.Z)(segments_service/* BACKGROUND_COLOR_OPTIONS */.L6).concat([
                segments_service/* SPACE_BLUE_THEME_ID */.r8
            ])
        },
        nestedBoardItems: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Embedded Board",
            fields: {
                boardBannerText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Board Banner Text",
                    translatable: true
                },
                embeddedBoardTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Embedded Board Title",
                    translatable: true
                },
                addSecondLiveBoardSignUpButton: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Add second sign up button in the live board"
                }
            }
        },
        circleConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Circle",
            fields: {
                circleTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: " Title",
                    translatable: true
                },
                circleTitleColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Title Color"
                },
                circleTitleSize: live_board_homepage_first_fold_config_object_spread({}, title_advanced_field_config/* default.titleSize */.Z.titleSize),
                circleText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Circle Text",
                    translatable: true
                },
                circleTextColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Text Color"
                },
                circleColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Color"
                },
                buttonText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Circle Button Text",
                    translatable: true
                },
                buttonColor: {
                    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                    label: "Circle Button Color",
                    possibleColors: button_service/* buttonColors */.Is
                }
            }
        },
        backgroundImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Background Image"
        },
        boardImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Board Image"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/live-board-homepage-first-fold-advanced-config.js
function live_board_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function live_board_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            live_board_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var live_board_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: live_board_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/live-board-homepage-first-fold/index.js



var LiveBoardHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 437).then(__webpack_require__.bind(__webpack_require__, 40437));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40437)
            ];
        }
    }
});
/* harmony default export */ var live_board_homepage_first_fold = ({
    LiveBoardHomepageFirstFoldComponent: LiveBoardHomepageFirstFoldComponent,
    LiveBoardHomepageFirstFoldConfig: live_board_homepage_first_fold_config,
    LiveBoardHomepageFirstFoldAdvancedConfig: live_board_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/sign-up-with-products-cards-homepage-first-fold-config.js



/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Sign Up With Products Cards",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SIGN_UP_WITH_PRODUCTS_BACKGROUND_ID */.JB
            ]
        },
        defaultActiveProduct: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Default active product",
            options: products/* PRODUCT_OPTIONS */.ey
        },
        skipButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Skip button CTA"
        },
        continueButtonText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Continue button CTA"
        },
        titleWithProduct: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title when product type exist"
        },
        subTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle when product type exist"
        },
        titleWithoutProduct: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title when product type doesnt's exist"
        },
        textUnderButtons: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Text under button"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/sign-up-with-products-cards-homepage-first-fold-advanced-config.js
function sign_up_with_products_cards_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function sign_up_with_products_cards_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            sign_up_with_products_cards_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: sign_up_with_products_cards_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/sign-up-with-products-cards-homepage-first-fold/index.js



var SignUpWithProductsCardsHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1492).then(__webpack_require__.bind(__webpack_require__, 1492));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1492)
            ];
        }
    }
});
/* harmony default export */ var sign_up_with_products_cards_homepage_first_fold = ({
    SignUpWithProductsCardsHomepageFirstFoldComponent: SignUpWithProductsCardsHomepageFirstFoldComponent,
    SignUpWithProductsCardsHomepageFirstFoldConfig: sign_up_with_products_cards_homepage_first_fold_config,
    SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig: sign_up_with_products_cards_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/welcome-back-homepage-first-fold-config.js


/* harmony default export */ var welcome_back_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Welcome Back",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_GRADIANT_THEME_ID */.I7,
                segments_service/* SPACE_BLUE_THEME_ID */.r8
            ]
        },
        introText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Intro text"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/welcome-back-homepage-first-fold-advanced-config.js
function welcome_back_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function welcome_back_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            welcome_back_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var welcome_back_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: welcome_back_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/welcome-back-homepage-first-fold/index.js



var WelcomeBackHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(7912)]).then(__webpack_require__.bind(__webpack_require__, 77912));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(77912)
            ];
        }
    }
});
/* harmony default export */ var welcome_back_homepage_first_fold = ({
    WelcomeBackHomepageFirstFoldComponent: WelcomeBackHomepageFirstFoldComponent,
    WelcomeBackHomepageFirstFoldConfig: welcome_back_homepage_first_fold_config,
    WelcomeBackHomepageFirstFoldAdvancedConfig: welcome_back_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-universe-homepage-first-fold/index.js + 2 modules
var monday_universe_homepage_first_fold = __webpack_require__(80424);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 7 modules
var button_fields_config = __webpack_require__(59440);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./components/core/new-button/button-component.js + 1 modules
var button_component = __webpack_require__(35061);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-config.js
function scroll_parallax_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function scroll_parallax_homepage_first_fold_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        scroll_parallax_homepage_first_fold_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = scroll_parallax_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function scroll_parallax_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var scroll_parallax_homepage_first_fold_config_image = asset_fields_config/* default.image */.Z.image, video = asset_fields_config/* default.video */.Z.video;
var _video_fields = video.fields, playWhenVisible = _video_fields.playWhenVisible, loop = _video_fields.loop, videoOtherFields = scroll_parallax_homepage_first_fold_config_object_without_properties(_video_fields, [
    "playWhenVisible",
    "loop"
]);
var parallaxParagraphButtonConfig = scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, button_fields_config/* default */.Z), {
    options: [
        {
            text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
            fieldsConfig: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, signup_button_fields_config/* default */.Z), {
                invert: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Invert  color"
                },
                buttonSize: {
                    type: template_field_type.FIELD_TYPES.COMBO,
                    label: "Size",
                    options: [
                        {
                            value: button_component.SM,
                            text: "Small"
                        },
                        {
                            value: button_component.MD,
                            text: "Medium"
                        }
                    ]
                }
            }),
            type: template_field_type.FIELD_TYPES.NESTED
        }
    ]
});
/* harmony default export */ var scroll_parallax_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Scroll Parallax",
    fields: {
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color"
        },
        paragraphs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Paragraphs",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    description: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Description",
                        translatable: true
                    },
                    avatarSrc: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Avatar",
                        defaultImagesKeys: []
                    },
                    avatarAlt: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Avatar alt text",
                        translatable: true
                    },
                    testimonial: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Testimonial",
                        translatable: true
                    },
                    name: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Name"
                    },
                    jobTitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Job title",
                        translatable: true
                    },
                    companyName: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Company name"
                    },
                    buttonConfig: parallaxParagraphButtonConfig
                }
            }
        },
        topAsset: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, scroll_parallax_homepage_first_fold_config_image), {
            label: "Top asset"
        }),
        bottomAsset: scroll_parallax_homepage_first_fold_config_object_spread_props(scroll_parallax_homepage_first_fold_config_object_spread({}, video), {
            label: "Bottom asset",
            fields: videoOtherFields
        })
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/scroll-parallax-homepage-first-fold-advanced-config.js
function scroll_parallax_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function scroll_parallax_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            scroll_parallax_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function scroll_parallax_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function scroll_parallax_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        scroll_parallax_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var scroll_parallax_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: scroll_parallax_homepage_first_fold_advanced_config_object_spread_props(scroll_parallax_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/scroll-parallax-homepage-first-fold/index.js



var ScrollParallaxHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9774), __webpack_require__.e(3614), __webpack_require__.e(4617)]).then(__webpack_require__.bind(__webpack_require__, 74617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74617)
            ];
        }
    }
});
/* harmony default export */ var scroll_parallax_homepage_first_fold = ({
    ScrollParallaxHomepageFirstFoldComponent: ScrollParallaxHomepageFirstFoldComponent,
    ScrollParallaxHomepageFirstFoldConfig: scroll_parallax_homepage_first_fold_config,
    ScrollParallaxHomepageFirstFoldAdvancedConfig: scroll_parallax_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-config.js
var top_logos_config = __webpack_require__(63625);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/globe-with-top-cta-homepage-first-fold-config.js
function globe_with_top_cta_homepage_first_fold_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_with_top_cta_homepage_first_fold_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_with_top_cta_homepage_first_fold_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var globe_with_top_cta_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Globe With Top Cta",
    fields: {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: fields_config/* default */.Z
        },
        logos: globe_with_top_cta_homepage_first_fold_config_object_spread({}, top_logos_config/* default */.Z)
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/globe-with-top-cta-homepage-first-fold-advanced-config.js
function globe_with_top_cta_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_with_top_cta_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_with_top_cta_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var globe_with_top_cta_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: globe_with_top_cta_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-with-top-cta-homepage-first-fold/index.js



var GlobeWithTopCtaHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(6331)]).then(__webpack_require__.bind(__webpack_require__, 28723));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(28723)
            ];
        }
    }
});
/* harmony default export */ var globe_with_top_cta_homepage_first_fold = ({
    GlobeWithTopCtaHomepageFirstFoldComponent: GlobeWithTopCtaHomepageFirstFoldComponent,
    GlobeWithTopCtaHomepageFirstFoldConfig: globe_with_top_cta_homepage_first_fold_config,
    GlobeWithTopCtaHomepageFirstFoldAdvancedConfig: globe_with_top_cta_homepage_first_fold_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-config.js
function globe_homepage_first_fold_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = globe_homepage_first_fold_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function globe_homepage_first_fold_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = globe_homepage_first_fold_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var globe_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Globe",
    fields: selectedSideBySideTextAndAssetFieldsConfig
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/globe-homepage-first-fold-advanced-config.js
function globe_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function globe_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            globe_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function globe_homepage_first_fold_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function globe_homepage_first_fold_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        globe_homepage_first_fold_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var globe_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: globe_homepage_first_fold_advanced_config_object_spread_props(globe_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        },
        height: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/globe-homepage-first-fold/index.js



var GlobeHomepageFirstFoldComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7528).then(__webpack_require__.bind(__webpack_require__, 47528));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47528)
            ];
        }
    }
});
/* harmony default export */ var globe_homepage_first_fold = ({
    GlobeHomepageFirstFoldComponent: GlobeHomepageFirstFoldComponent,
    GlobeHomepageFirstFoldConfig: globe_homepage_first_fold_config,
    GlobeHomepageFirstFoldAdvancedConfig: globe_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/animating-board-homepage-first-fold-config.js

/* harmony default export */ var animating_board_homepage_first_fold_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Animating Board",
    fields: {
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            textArea: true,
            translatable: true
        },
        body: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Body",
            textArea: true,
            rows: 5,
            translatable: true
        },
        videoId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Video Id"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/animating-board-homepage-first-fold-advanced-config.js
function animating_board_homepage_first_fold_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function animating_board_homepage_first_fold_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            animating_board_homepage_first_fold_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var animating_board_homepage_first_fold_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: animating_board_homepage_first_fold_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/animating-board-homepage-first-fold/index.js



var AnimatingBoardHomepageFirstFoldComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4729), __webpack_require__.e(5478)]).then(__webpack_require__.bind(__webpack_require__, 45478));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45478)
            ];
        }
    }
});
/* harmony default export */ var animating_board_homepage_first_fold = ({
    AnimatingBoardHomepageFirstFoldComponent: AnimatingBoardHomepageFirstFoldComponent,
    AnimatingBoardHomepageFirstFoldConfig: animating_board_homepage_first_fold_config,
    AnimatingBoardHomepageFirstFoldAdvancedConfig: animating_board_homepage_first_fold_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/index.js
// plop_marker:layouts_import














/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SideBySideParagraphAndTagsHomepageFirstFold: side_by_side_paragraph_and_tags_homepage_first_fold,
    PlatformInteractiveExperienceHomepageFirstFold: platform_interactive_experience_homepage_first_fold,
    TagsByProductHomepageFirstFold: tags_by_product_homepage_first_fold,
    ProductsByUseCasesHomepageFirstFold: products_by_use_cases_homepage_first_fold,
    MondayProductsHomepageFirstFold: monday_products_homepage_first_fold,
    FullParagraphAndTagsHomepageFirstFold: full_paragraph_and_tags_homepage_first_fold,
    LiveBoardHomepageFirstFold: live_board_homepage_first_fold,
    SignUpWithProductsCardsHomepageFirstFold: sign_up_with_products_cards_homepage_first_fold,
    WelcomeBackHomepageFirstFold: welcome_back_homepage_first_fold,
    MondayUniverseHomepageFirstFold: monday_universe_homepage_first_fold/* default */.Z,
    ScrollParallaxHomepageFirstFold: scroll_parallax_homepage_first_fold,
    GlobeWithTopCtaHomepageFirstFold: globe_with_top_cta_homepage_first_fold,
    GlobeHomepageFirstFold: globe_homepage_first_fold,
    AnimatingBoardHomepageFirstFold: animating_board_homepage_first_fold
});

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/index.js

var SideBySideParagraphAndTagsHomepageFirstFold = layouts.SideBySideParagraphAndTagsHomepageFirstFold, PlatformInteractiveExperienceHomepageFirstFold = layouts.PlatformInteractiveExperienceHomepageFirstFold, TagsByProductHomepageFirstFold = layouts.TagsByProductHomepageFirstFold, ProductsByUseCasesHomepageFirstFold = layouts.ProductsByUseCasesHomepageFirstFold, MondayProductsHomepageFirstFold = layouts.MondayProductsHomepageFirstFold, FullParagraphAndTagsHomepageFirstFold = layouts.FullParagraphAndTagsHomepageFirstFold, LiveBoardHomepageFirstFold = layouts.LiveBoardHomepageFirstFold, SignUpWithProductsCardsHomepageFirstFold = layouts.SignUpWithProductsCardsHomepageFirstFold, WelcomeBackHomepageFirstFold = layouts.WelcomeBackHomepageFirstFold, MondayUniverseHomepageFirstFold = layouts.MondayUniverseHomepageFirstFold, ScrollParallaxHomepageFirstFold = layouts.ScrollParallaxHomepageFirstFold, GlobeWithTopCtaHomepageFirstFold = layouts.GlobeWithTopCtaHomepageFirstFold, GlobeHomepageFirstFold = layouts.GlobeHomepageFirstFold, AnimatingBoardHomepageFirstFold = layouts.AnimatingBoardHomepageFirstFold;
/* harmony default export */ var homepage_first_fold = ({
    // plop_marker:segment_index_add_layout
    SideBySideParagraphAndTagsHomepageFirstFoldComponent: {
        type: "SideBySideParagraphAndTagsHomepageFirstFoldComponent",
        title: "Side By Side Paragraph And Tags",
        imgSrc: "/static/img/segments/layouts/side-by-side-paragraph-and-tags-homepage-first-fold.png",
        config: SideBySideParagraphAndTagsHomepageFirstFold.SideBySideParagraphAndTagsHomepageFirstFoldConfig,
        advancedConfig: SideBySideParagraphAndTagsHomepageFirstFold.SideBySideParagraphAndTagsHomepageFirstFoldAdvancedConfig,
        component: SideBySideParagraphAndTagsHomepageFirstFold.SideBySideParagraphAndTagsHomepageFirstFoldComponent
    },
    PlatformInteractiveExperienceHomepageFirstFoldComponent: {
        type: "PlatformInteractiveExperienceHomepageFirstFoldComponent",
        title: "Platform Interactive Experience",
        imgSrc: "/static/img/segments/layouts/platform-interactive-experience-homepage-first-fold.png",
        config: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldConfig,
        advancedConfig: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig,
        component: PlatformInteractiveExperienceHomepageFirstFold.PlatformInteractiveExperienceHomepageFirstFoldComponent
    },
    TagsByProductHomepageFirstFoldComponent: {
        type: "TagsByProductHomepageFirstFoldComponent",
        title: "Tags By Product",
        imgSrc: "/static/img/segments/layouts/tags-by-product-homepage-first-fold.png",
        config: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldConfig,
        advancedConfig: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldAdvancedConfig,
        component: TagsByProductHomepageFirstFold.TagsByProductHomepageFirstFoldComponent
    },
    ProductsByUseCasesHomepageFirstFoldComponent: {
        type: "ProductsByUseCasesHomepageFirstFoldComponent",
        title: "Products By Use Cases",
        imgSrc: "/static/img/segments/layouts/products-by-use-cases-homepage-first-fold.png",
        config: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldConfig,
        advancedConfig: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldAdvancedConfig,
        component: ProductsByUseCasesHomepageFirstFold.ProductsByUseCasesHomepageFirstFoldComponent
    },
    MondayProductsHomepageFirstFoldComponent: {
        type: "MondayProductsHomepageFirstFoldComponent",
        title: "Monday Products",
        imgSrc: "/static/img/segments/layouts/monday-products-homepage-first-fold.png",
        config: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldConfig,
        advancedConfig: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldAdvancedConfig,
        component: MondayProductsHomepageFirstFold.MondayProductsHomepageFirstFoldComponent
    },
    FullParagraphAndTagsHomepageFirstFoldComponent: {
        type: "FullParagraphAndTagsHomepageFirstFoldComponent",
        title: "Full Paragraph And Tags",
        imgSrc: "/static/img/segments/layouts/full-paragraph-and-tags-homepage-first-fold.png",
        config: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldConfig,
        advancedConfig: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldAdvancedConfig,
        component: FullParagraphAndTagsHomepageFirstFold.FullParagraphAndTagsHomepageFirstFoldComponent
    },
    LiveBoardHomepageFirstFoldComponent: {
        type: "LiveBoardHomepageFirstFoldComponent",
        title: "Live Board",
        imgSrc: "/static/img/segments/layouts/live-board-homepage-first-fold.png",
        config: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldConfig,
        advancedConfig: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldAdvancedConfig,
        component: LiveBoardHomepageFirstFold.LiveBoardHomepageFirstFoldComponent
    },
    SignUpWithProductsCardsHomepageFirstFoldComponent: {
        type: "SignUpWithProductsCardsHomepageFirstFoldComponent",
        title: "Sign Up With Products Cards",
        imgSrc: "/static/img/segments/layouts/sign-up-with-products-cards-homepage-first-fold.png",
        config: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldConfig,
        advancedConfig: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldAdvancedConfig,
        component: SignUpWithProductsCardsHomepageFirstFold.SignUpWithProductsCardsHomepageFirstFoldComponent
    },
    WelcomeBackHomepageFirstFoldComponent: {
        type: "WelcomeBackHomepageFirstFoldComponent",
        title: "Welcome Back",
        imgSrc: "/static/img/segments/layouts/welcome-back-homepage-first-fold.png",
        config: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldConfig,
        advancedConfig: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldAdvancedConfig,
        component: WelcomeBackHomepageFirstFold.WelcomeBackHomepageFirstFoldComponent
    },
    MondayUniverseHomepageFirstFoldComponent: {
        type: "MondayUniverseHomepageFirstFoldComponent",
        title: "Monday Universe",
        imgSrc: "/static/img/segments/layouts/monday-universe-homepage-first-fold.png",
        config: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldConfig,
        advancedConfig: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldAdvancedConfig,
        component: MondayUniverseHomepageFirstFold.MondayUniverseHomepageFirstFoldComponent
    },
    GlobeWithTopCtaHomepageFirstFoldComponent: {
        type: "GlobeWithTopCtaHomepageFirstFoldComponent",
        title: "Globe With Top Cta",
        imgSrc: "/static/img/segments/layouts/globe-with-top-cta-homepage-first-fold.png",
        config: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldConfig,
        advancedConfig: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldAdvancedConfig,
        component: GlobeWithTopCtaHomepageFirstFold.GlobeWithTopCtaHomepageFirstFoldComponent
    },
    GlobeHomepageFirstFoldComponent: {
        type: "GlobeHomepageFirstFoldComponent",
        title: "Globe",
        imgSrc: "/static/img/segments/layouts/globe-homepage-first-fold.png",
        config: GlobeHomepageFirstFold.GlobeHomepageFirstFoldConfig,
        advancedConfig: GlobeHomepageFirstFold.GlobeHomepageFirstFoldAdvancedConfig,
        component: GlobeHomepageFirstFold.GlobeHomepageFirstFoldComponent
    },
    AnimatingBoardHomepageFirstFoldComponent: {
        type: "AnimatingBoardHomepageFirstFoldComponent",
        title: "Animating Board",
        imgSrc: "/static/img/segments/layouts/animating-board-homepage-first-fold.png",
        config: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldConfig,
        advancedConfig: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldAdvancedConfig,
        component: AnimatingBoardHomepageFirstFold.AnimatingBoardHomepageFirstFoldComponent
    },
    ScrollParallaxHomepageFirstFoldComponent: {
        type: "ScrollParallaxHomepageFirstFoldComponent",
        title: "Scroll Parallax",
        imgSrc: "/static/img/segments/layouts/scroll-parallax-homepage-first-fold.png",
        config: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldConfig,
        advancedConfig: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldAdvancedConfig,
        component: ScrollParallaxHomepageFirstFold.ScrollParallaxHomepageFirstFoldComponent
    }
});


/***/ }),

/***/ 78679:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ei": function() { return /* binding */ APPS; },
  "Lj": function() { return /* binding */ HOSPITAL; },
  "kr": function() { return /* binding */ ILLUSTRATIVE; },
  "$s": function() { return /* binding */ cookieValues; },
  "uK": function() { return /* binding */ getViIcon; },
  "Oh": function() { return /* binding */ procuctIdToCluster; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
// EXTERNAL MODULE: ./constants/cookies.js
var cookies = __webpack_require__(13019);
// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./static/svg/crm-vi1.svg
var _path;
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

var SvgCrmVi1 = function SvgCrmVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), _path || (_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#006278",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var crm_vi1 = (SvgCrmVi1);

;// CONCATENATED MODULE: ./static/svg/dev-vi1.svg
var dev_vi1_path;
function dev_vi1_extends() {
    dev_vi1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return dev_vi1_extends.apply(this, arguments);
}

var SvgDevVi1 = function SvgDevVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", dev_vi1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), dev_vi1_path || (dev_vi1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#025231",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var dev_vi1 = (SvgDevVi1);

;// CONCATENATED MODULE: ./static/svg/wm-vi1.svg
var wm_vi1_path;
function wm_vi1_extends() {
    wm_vi1_extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return wm_vi1_extends.apply(this, arguments);
}

var SvgWmVi1 = function SvgWmVi1(props) {
    return /*#__PURE__*/ react.createElement("svg", wm_vi1_extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18"
    }, props), wm_vi1_path || (wm_vi1_path = /*#__PURE__*/ react.createElement("path", {
        fill: "#311CAC",
        fillRule: "evenodd",
        d: "M17.087 8.543A8.544 8.544 0 1 1 0 8.543a8.544 8.544 0 0 1 17.087 0m-8.544 7.044a7.044 7.044 0 1 0 0-14.087 7.044 7.044 0 0 0 0 14.087m3.412-9.683a.75.75 0 0 1 .142 1.05l-3.919 5.14-2.558-3.07a.75.75 0 1 1 1.152-.96l1.354 1.624 2.778-3.643a.75.75 0 0 1 1.05-.141",
        clipRule: "evenodd"
    })));
};
/* harmony default export */ var wm_vi1 = (SvgWmVi1);

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/monday-products-homepage-first-fold/consts.js








var _obj;
var cookieValues = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: false
    }
]), (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, [
    {
        key: cookies.CRM_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
        value: "new_with_big_signup_modal_for_products"
    },
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, [
    {
        key: cookies.DEV_BIG_SIGNUP_MODAL_FOR_PRODUCTS_AB_TEST,
        value: "new_with_big_signup_modal_for_products"
    },
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* CRM_PRODUCT_ID */.$, "_").concat(products/* WORK_MANAGEMENT_PRODUCT_ID */.py), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* DEV_PRODUCT_ID */.xi, "_").concat(products/* WORK_MANAGEMENT_PRODUCT_ID */.py), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), (0,_define_property/* default */.Z)(_obj, "".concat(products/* CRM_PRODUCT_ID */.$, "_").concat(products/* DEV_PRODUCT_ID */.xi), [
    {
        key: cookies.INSTALL_PRODUCTS_FLOW,
        value: true
    }
]), _obj);
var _obj1;
var procuctIdToCluster = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, products/* CRM_PRODUCT_ID */.$, clusters.CRM), (0,_define_property/* default */.Z)(_obj1, products/* DEV_PRODUCT_ID */.xi, clusters.SOFTWARE), _obj1);
var getViIcon = function(productId) {
    var _obj;
    var ViMap = (_obj = {}, (0,_define_property/* default */.Z)(_obj, products/* CRM_PRODUCT_ID */.$, /*#__PURE__*/ (0,jsx_runtime.jsx)(crm_vi1, {})), (0,_define_property/* default */.Z)(_obj, products/* DEV_PRODUCT_ID */.xi, /*#__PURE__*/ (0,jsx_runtime.jsx)(dev_vi1, {})), (0,_define_property/* default */.Z)(_obj, products/* WORK_MANAGEMENT_PRODUCT_ID */.py, /*#__PURE__*/ (0,jsx_runtime.jsx)(wm_vi1, {})), _obj);
    return Object.keys(ViMap).includes(productId) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "vi-sign",
        children: ViMap[productId]
    }) : null;
};
var HOSPITAL = "Hospital";
var APPS = "Apps";
var ILLUSTRATIVE = "Illustrative";


/***/ }),

/***/ 7861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Ho": function() { return /* binding */ CLUSTER_TO_TAG_ICON_MAP; },
  "qs": function() { return /* binding */ NAME_TO_ICON; },
  "Uz": function() { return /* binding */ getClusterProduct; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/hr-icon.js

var HrIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54262)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M3.86963 6.35416C3.86963 7.13427 4.17953 7.88242 4.73115 8.43405C5.28278 8.98569 6.03095 9.29559 6.81106 9.29559C7.59118 9.29559 8.33935 8.98569 8.89096 8.43405C9.4426 7.88242 9.7525 7.13427 9.7525 6.35416C9.7525 5.57404 9.4426 4.82587 8.89096 4.27424C8.33935 3.72262 7.59118 3.41272 6.81106 3.41272C6.03095 3.41272 5.28278 3.72262 4.73115 4.27424C4.17953 4.82587 3.86963 5.57404 3.86963 6.35416Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.99756 15.1715C1.99756 13.895 2.50467 12.6707 3.40733 11.768C4.30999 10.8654 5.53426 10.3583 6.81082 10.3583C8.08737 10.3583 9.31165 10.8654 10.2143 11.768C11.1169 12.6707 11.6241 13.895 11.6241 15.1715",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.6973 7.95424C11.6973 8.59251 11.9508 9.20462 12.4021 9.65599C12.8534 10.1073 13.4655 10.3609 14.1038 10.3609C14.7422 10.3609 15.3543 10.1073 15.8056 9.65599C16.257 9.20462 16.5105 8.59251 16.5105 7.95424C16.5105 7.31596 16.257 6.70382 15.8056 6.25249C15.3543 5.80116 14.7422 5.54761 14.1038 5.54761C13.4655 5.54761 12.8534 5.80116 12.4021 6.25249C11.9508 6.70382 11.6973 7.31596 11.6973 7.95424Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.739 11.4793C13.3345 11.2598 13.9741 11.1874 14.6036 11.2683C15.2331 11.3491 15.8337 11.5807 16.3544 11.9435C16.8751 12.3064 17.3005 12.7896 17.5943 13.3521C17.8881 13.9146 18.0418 14.5398 18.0422 15.1744",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54262",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "17.1138",
                        height: "17.1138",
                        fill: "white",
                        transform: "translate(1.46265 0.731323)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/it-icon.js

var ItIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54236)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M16.6401 11.9388V5.14156C16.6401 4.86422 16.53 4.59822 16.3338 4.40211C16.1377 4.206 15.8717 4.09583 15.5944 4.09583H5.13704C4.8597 4.09583 4.59371 4.206 4.3976 4.40211C4.20149 4.59822 4.09131 4.86422 4.09131 5.14156V11.9388H16.6401Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M18.1184 15.1721C18.1891 15.3314 18.219 15.5057 18.2052 15.6794C18.1914 15.8531 18.1345 16.0206 18.0395 16.1666C17.9446 16.3128 17.8146 16.4328 17.6615 16.5158C17.5083 16.5989 17.3369 16.6424 17.1626 16.6424H3.56809C3.39385 16.6424 3.22238 16.5989 3.06924 16.5158C2.91611 16.4328 2.78615 16.3128 2.69119 16.1666C2.59623 16.0206 2.53927 15.8531 2.52549 15.6794C2.51171 15.5057 2.54155 15.3314 2.61228 15.1721L4.09095 11.9366H16.6397L18.1184 15.1721Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M9.3208 14.5527H11.4123",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54236",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16.7317",
                        height: "16.7317",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/crm-icon.js

var CrmIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1518_54207)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M11.8333 12.673V15.173L14.8333 12.673H16.8333C17.0985 12.673 17.3529 12.5677 17.5404 12.3802C17.7279 12.1926 17.8333 11.9382 17.8333 11.673V3.67303C17.8333 3.40782 17.7279 3.15346 17.5404 2.96593C17.3529 2.77839 17.0985 2.67303 16.8333 2.67303H8.83325C8.56804 2.67303 8.31368 2.77839 8.12615 2.96593C7.93861 3.15346 7.83325 3.40782 7.83325 3.67303",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.98389 8.38837C2.80415 9.23838 3.86385 9.81838 5.02193 10.0512C6.18 10.284 7.38152 10.1586 8.46659 9.69171",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M1.49976 10.168C1.49976 11.0962 1.8685 11.9864 2.52488 12.6428C3.18126 13.2992 4.0715 13.668 4.99976 13.668C5.92802 13.668 6.81825 13.2992 7.47463 12.6428C8.13102 11.9864 8.49976 11.0962 8.49976 10.168C8.49976 9.2397 8.13102 8.34948 7.47463 7.6931C6.81825 7.03672 5.92802 6.66797 4.99976 6.66797C4.0715 6.66797 3.18126 7.03672 2.52488 7.6931C1.8685 8.34948 1.49976 9.2397 1.49976 10.168Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.1164 17.6691C9.12289 16.3927 7.68802 15.534 6.09364 15.2616C4.49926 14.9893 2.86065 15.3229 1.49976 16.1971",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.6667 9.99524H10.3334",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M14.9998 5.33551H12.8664V10.0022H14.9998V5.33551Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M12.8674 7.04608H10.7341V10.0016H12.8674V7.04608Z",
                        stroke: color || "#676879",
                        strokeWidth: "1.2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1518_54207",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "18",
                        height: "16",
                        fill: "white",
                        transform: "translate(1 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/product-icon.js

var ProductIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8139 15.8139C16.8139 16.0567 16.7175 16.2895 16.5458 16.4611C16.3742 16.6327 16.1413 16.7292 15.8986 16.7292H4.91528C4.67253 16.7292 4.43972 16.6327 4.26808 16.4611C4.09643 16.2895 4 16.0567 4 15.8139V3.91528C4 3.67253 4.09643 3.43972 4.26808 3.26808C4.43972 3.09643 4.67253 3 4.91528 3H14.0955C14.3345 3.00003 14.564 3.09354 14.735 3.26055L16.5381 5.0191C16.6255 5.10442 16.6948 5.20635 16.7422 5.3189C16.7896 5.43144 16.814 5.55233 16.8139 5.67444V15.8139Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.8066 8.04395L14.0948 10.3321L11.8066 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M9.06163 8.04395L6.77344 10.3321L9.06163 12.6203",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/operations-icon.js

var OperationsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4163 10.0533C13.4033 10.8686 13.0704 11.6461 12.4893 12.218C11.9082 12.7899 11.1255 13.1105 10.3102 13.1105C9.49483 13.1105 8.71221 12.7899 8.13111 12.218C7.55001 11.6461 7.21706 10.8686 7.2041 10.0533",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6875 10.0393V11.207L16.3525 11.474C16.1985 12.1212 15.9404 12.7391 15.5885 13.3036L16.3494 14.4376L14.7003 16.0866L13.5672 15.3257C13.0025 15.6807 12.3833 15.9405 11.7344 16.0945L11.4706 17.4224H9.14618L8.88154 16.0945C8.23284 15.9403 7.61391 15.6806 7.0495 15.3257L5.91322 16.0835L4.26417 14.4344L5.02509 13.3005C4.67286 12.736 4.41455 12.1181 4.26024 11.4708L2.92529 11.2039V10.0393",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.4163 9.57697C13.4033 8.7617 13.0704 7.98421 12.4893 7.41231C11.9082 6.8404 11.1255 6.51986 10.3102 6.51986C9.49483 6.51986 8.71221 6.8404 8.13111 7.41231C7.55001 7.98421 7.21706 8.7617 7.2041 9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M17.6875 9.57697V8.40928L16.3525 8.14229C16.1985 7.49507 15.9404 6.87715 15.5885 6.31262L16.3494 5.1787L14.7003 3.52965L13.5672 4.29057C13.0025 3.93555 12.3833 3.67579 11.7344 3.5218L11.4706 2.19392H9.14618L8.88154 3.5218C8.23284 3.67594 7.61391 3.93563 7.0495 4.29057L5.91322 3.53279L4.26417 5.18184L5.02509 6.31577C4.67286 6.88029 4.41455 7.49821 4.26024 8.14543L2.92529 8.41242V9.57697",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/marketing-icon.js

var MarketingIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87023 11.7385H4.17756C3.42936 11.7385 2.71179 11.4412 2.18273 10.9122C1.65367 10.3831 1.35645 9.6656 1.35645 8.91737C1.35645 8.16913 1.65367 7.4516 2.18273 6.92254C2.71179 6.39348 3.42936 6.09625 4.17756 6.09625H5.87023V11.7385Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87012 11.735C9.18105 11.7353 12.418 12.7153 15.173 14.5516L16.0261 15.1204V2.70746L15.173 3.2762C12.418 5.11251 9.18105 6.09252 5.87012 6.0928V11.735Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M18.2825 7.78906V10.046",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M5.87012 11.7385C5.86964 12.4772 6.01945 13.2083 6.31045 13.8873C6.60144 14.5663 7.02753 15.179 7.56279 15.6881",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/design-icon.js

var DesignIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M10.9521 16.8926H3.92617C3.68054 16.8926 3.44496 16.795 3.27127 16.6214C3.09758 16.4477 3 16.212 3 15.9664V3.92617C3 3.68054 3.09758 3.44496 3.27127 3.27127C3.44496 3.09758 3.68054 3 3.92617 3H15.9664C16.212 3 16.4477 3.09758 16.6214 3.27127C16.795 3.44496 16.8926 3.68054 16.8926 3.92617V10.9521C16.8925 11.1976 16.795 11.433 16.6215 11.6066L11.6066 16.6215C11.433 16.795 11.1976 16.8925 10.9521 16.8926Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.3362 16.8124V12.2649C11.3362 12.0193 11.4337 11.7837 11.6074 11.61C11.7811 11.4363 12.0167 11.3387 12.2624 11.3387H16.8099",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.70483 6.70087H14.1142",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M6.70483 9.48566H9.94644",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/tasks-icon.js

var TasksIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M3.87871 2.92523H16.2731C16.2731 2.92523 17.2265 2.92523 17.2265 3.87865V16.273C17.2265 16.273 17.2265 17.2264 16.2731 17.2264H3.87871C3.87871 17.2264 2.92529 17.2264 2.92529 16.273V3.87865C2.92529 3.87865 2.92529 2.92523 3.87871 2.92523Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.24429 6.10449L6.41373 8.54523L5.19336 7.32487",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5059 7.68658H14.3661",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M8.24429 11.5956L6.41373 14.0364L5.19336 12.816",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.5059 13.4136H14.3661",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/projects-icon.js

var ProjectsIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.88281 1.87549H13.1328C13.1328 1.87549 14.3828 1.87549 14.3828 3.12549V11.8755C14.3828 11.8755 14.3828 13.1255 13.1328 13.1255H1.88281C1.88281 13.1255 0.632812 13.1255 0.632812 11.8755V3.12549C0.632812 3.12549 0.632812 1.87549 1.88281 1.87549Z",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M0.632812 5.61993H14.3828",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.8823 5.61993V14.3699C16.8823 14.7015 16.7507 15.0194 16.5162 15.2538C16.2818 15.4882 15.9638 15.6199 15.6323 15.6199H4.38232",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.3826 8.11621V16.8662C19.3826 17.1978 19.2509 17.5157 19.0165 17.7501C18.7821 17.9845 18.4641 18.1162 18.1326 18.1162H6.88257",
                stroke: color || "#676879",
                strokeWidth: "1.2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/software-icon.js

var SoftwareIcon = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_1953_322815)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10 15.3059H17.4286",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M15.3065 13.1835L17.429 15.3059L15.3065 17.4283",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.75574 4.16329C5.75574 4.58551 5.92347 4.99045 6.22202 5.289C6.52058 5.58756 6.92551 5.75529 7.34774 5.75529C7.76996 5.75529 8.17489 5.58756 8.47345 5.289C8.77201 4.99045 8.93974 4.58551 8.93974 4.16329C8.93974 3.74106 8.77201 3.33613 8.47345 3.03758C8.17489 2.73902 7.76996 2.57129 7.34774 2.57129C6.92551 2.57129 6.52058 2.73902 6.22202 3.03758C5.92347 3.33613 5.75574 3.74106 5.75574 4.16329Z",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10 9.4695C10 9.89173 10.1677 10.2967 10.4663 10.5952C10.7648 10.8938 11.1698 11.0615 11.592 11.0615C12.0142 11.0615 12.4192 10.8938 12.7177 10.5952C13.0163 10.2967 13.184 9.89173 13.184 9.4695C13.184 9.04728 13.0163 8.64235 12.7177 8.34379C12.4192 8.04523 12.0142 7.8775 11.592 7.8775C11.1698 7.8775 10.7648 8.04523 10.4663 8.34379C10.1677 8.64235 10 9.04728 10 9.4695Z",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M6.81677 15.3062C6.81677 15.7285 6.9845 16.1334 7.28306 16.4319C7.58162 16.7305 7.98655 16.8982 8.40877 16.8982C8.831 16.8982 9.23593 16.7305 9.53449 16.4319C9.83304 16.1334 10.0008 15.7285 10.0008 15.3062C10.0008 14.884 9.83304 14.4791 9.53449 14.1805C9.23593 13.882 8.831 13.7142 8.40877 13.7142C7.98655 13.7142 7.58162 13.882 7.28306 14.1805C6.9845 14.4791 6.81677 14.884 6.81677 15.3062Z",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M10.0004 9.46973H5.49015C3.87838 9.46973 2.57178 10.7763 2.57178 12.3881C2.57178 13.9999 3.87838 15.3065 5.49015 15.3065H6.81669",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M13.184 9.46953H14.7759C16.2411 9.46953 17.4289 8.28171 17.4289 6.81645C17.4289 5.35121 16.2411 4.16339 14.7759 4.16339H8.93909",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M5.75547 4.16339H2.57178",
                        stroke: color || "#676879",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_1953_322815",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "16",
                        height: "16",
                        fill: "white",
                        transform: "translate(2 2)"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/icons/index.js











// EXTERNAL MODULE: ./constants/clusters.js
var clusters = __webpack_require__(16961);
// EXTERNAL MODULE: ./constants/products.js
var products = __webpack_require__(84074);
;// CONCATENATED MODULE: ./segments/desktop/homepage-first-fold/layouts/side-by-side-paragraph-and-tags-homepage-first-fold/consts.js




var _obj;
var CLUSTER_TO_PRODUCT_MAP = (_obj = {}, (0,_define_property/* default */.Z)(_obj, clusters.SOFTWARE, products/* DEV_PRODUCT_ID */.xi), (0,_define_property/* default */.Z)(_obj, clusters.IT, products/* SERVICE_PRODUCT_ID */.Ai), (0,_define_property/* default */.Z)(_obj, clusters.CRM, products/* CRM_PRODUCT_ID */.$), _obj);
var ICONS_NAMES = {
    PROJECTS: "Projects",
    TASKS: "Tasks",
    MARKETING: "Marketing",
    DESIGN: "Design",
    CRM: "CRM",
    PRODUCT: "Product",
    IT: "IT",
    OPERATIONS: "Operations",
    SOFTWARE: "Software",
    HR: "HR"
};
var _obj1;
var NAME_TO_ICON = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.PROJECTS, ProjectsIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.TASKS, TasksIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.MARKETING, MarketingIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.DESIGN, DesignIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.CRM, CrmIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.PRODUCT, ProductIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.IT, ItIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.OPERATIONS, OperationsIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.SOFTWARE, SoftwareIcon), (0,_define_property/* default */.Z)(_obj1, ICONS_NAMES.HR, HrIcon), _obj1);
var _obj2;
var CLUSTER_TO_TAG_ICON_MAP = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, clusters.SOFTWARE, ProductIcon), (0,_define_property/* default */.Z)(_obj2, clusters.TASK_MANAGEMENT, TasksIcon), (0,_define_property/* default */.Z)(_obj2, clusters.CRM, CrmIcon), (0,_define_property/* default */.Z)(_obj2, clusters.HR, HrIcon), (0,_define_property/* default */.Z)(_obj2, clusters.MARKETING, MarketingIcon), (0,_define_property/* default */.Z)(_obj2, clusters.DESIGN_AND_CREATIVE, DesignIcon), (0,_define_property/* default */.Z)(_obj2, clusters.IT, ItIcon), (0,_define_property/* default */.Z)(_obj2, clusters.OPERATIONS, OperationsIcon), (0,_define_property/* default */.Z)(_obj2, clusters.PRODUCT_MANAGEMENT, ProjectsIcon), _obj2);
var getClusterProduct = function(cluster) {
    return CLUSTER_TO_PRODUCT_MAP[cluster] || null;
};


/***/ }),

/***/ 77860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ iframe; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-test-iframe/ada-chatbot-test-iframe-config.js

/* harmony default export */ var ada_chatbot_test_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Ada Chatbot",
    fields: {
        chatbotHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Chatbot Height"
        },
        chatbotWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Chatbot Width"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-test-iframe/ada-chatbot-test-iframe-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var ada_chatbot_test_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-test-iframe/index.js

var AdaChatbotTestIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7805).then(__webpack_require__.bind(__webpack_require__, 47805));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(47805)
            ];
        }
    }
});


/* harmony default export */ var ada_chatbot_test_iframe = ({
    AdaChatbotTestIframeComponent: AdaChatbotTestIframeComponent,
    AdaChatbotTestIframeConfig: ada_chatbot_test_iframe_config,
    AdaChatbotTestIframeAdvancedConfig: ada_chatbot_test_iframe_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-iframe/ada-chatbot-iframe-config.js


/* harmony default export */ var ada_chatbot_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Ada Chatbot",
    fields: {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: fields_config/* default */.Z
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-iframe/ada-chatbot-iframe-advanced-config.js
function ada_chatbot_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function ada_chatbot_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            ada_chatbot_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var ada_chatbot_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: ada_chatbot_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/ada-chatbot-iframe/index.js

var AdaChatbotIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 197).then(__webpack_require__.bind(__webpack_require__, 50197));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(50197)
            ];
        }
    }
});


/* harmony default export */ var ada_chatbot_iframe = ({
    AdaChatbotIframeComponent: AdaChatbotIframeComponent,
    AdaChatbotIframeConfig: ada_chatbot_iframe_config,
    AdaChatbotIframeAdvancedConfig: ada_chatbot_iframe_advanced_config
});

// EXTERNAL MODULE: ./client/services/hubspot-service/hubspot-constants.js
var hubspot_constants = __webpack_require__(22638);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/components/fields-config.js


/* harmony default export */ var components_fields_config = ({
    source: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "Lead Source",
        options: hubspot_constants/* leadSourceConfigList */.L_
    },
    withPrivacyNotice: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "With Privacy Notice"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/hubspot-dynamic-form-iframe-config.js
function hubspot_dynamic_form_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_dynamic_form_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_dynamic_form_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var hubspot_dynamic_form_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot Dynamic Form",
    fields: hubspot_dynamic_form_iframe_config_object_spread({
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form ID"
        },
        formWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form Width (specify units: px/%)"
        },
        urlToRedirectAfterSubmission: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "URL to redirect after submission (In Webflow)"
        },
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background Color",
            defaultValue: "white"
        },
        textColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Text Color",
            defaultValue: "black"
        },
        textSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "text Size",
            defaultValue: "0.875rem"
        },
        ctaButtonColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "CTA Button Color",
            defaultValue: "workos-iris"
        },
        ctaTextColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "CTA Text Color",
            defaultValue: "white"
        },
        formShadow: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Form with shadow",
            defaultValue: true
        }
    }, components_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/hubspot-dynamic-form-iframe-advanced-config.js
function hubspot_dynamic_form_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_dynamic_form_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_dynamic_form_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var hubspot_dynamic_form_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread_props(hubspot_dynamic_form_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        formMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Form Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-iframe/index.js

var HubspotDynamicFormIframeComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(571), __webpack_require__.e(5990), __webpack_require__.e(9419), __webpack_require__.e(1547)]).then(__webpack_require__.bind(__webpack_require__, 81547));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(81547)
            ];
        }
    }
});


/* harmony default export */ var hubspot_dynamic_form_iframe = ({
    HubspotDynamicFormIframeComponent: HubspotDynamicFormIframeComponent,
    HubspotDynamicFormIframeConfig: hubspot_dynamic_form_iframe_config,
    HubspotDynamicFormIframeAdvancedConfig: hubspot_dynamic_form_iframe_advanced_config
});

// EXTERNAL MODULE: ./constants/customer-quotes.js
var customer_quotes = __webpack_require__(64265);
// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-with-bullets-side-by-side-iframe/hubspot-dynamic-form-with-bullets-side-by-side-iframe-config.js
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_dynamic_form_with_bullets_side_by_side_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}







var titleSize = advanced_field_config/* default.titleSize */.Z.titleSize;
var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, mobileSwapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.mobileSwapTextAndAssetPosition */.Z.mobileSwapTextAndAssetPosition;
/* harmony default export */ var hubspot_dynamic_form_with_bullets_side_by_side_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Hubspot Dynamic Form With Bullets Side By Side",
    fields: {
        swapTextAndAssetPosition: swapTextAndAssetPosition,
        mobileSwapTextAndAssetPosition: mobileSwapTextAndAssetPosition,
        form: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Hubspot Dynamic Form",
            fields: hubspot_dynamic_form_with_bullets_side_by_side_iframe_config_object_spread({
                formId: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Form ID"
                },
                formWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Form Width (specify units: px/%)"
                },
                urlToRedirectAfterSubmission: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "URL to redirect after submission (In Webflow)"
                }
            }, components_fields_config)
        },
        content: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Content",
            fields: {
                title: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title",
                    translatable: true
                },
                titleSize: titleSize,
                benefits: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Benefits",
                    maxLimit: 3,
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            icon: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Icon"
                            },
                            title: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Title",
                                translatable: true
                            },
                            description: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Description",
                                translatable: true
                            }
                        }
                    }
                },
                hideSupportStatement: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Hide support statement"
                },
                hideLogos: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Hide logos"
                },
                customerQuoteKey: {
                    type: template_field_type.FIELD_TYPES.COMBO,
                    label: "Customer Quote",
                    options: [
                        {
                            value: customer_quotes/* CUSTOMER_KEY_OSCAR */.Nz,
                            text: "Oscar - Work OS saves time and money"
                        },
                        {
                            value: customer_quotes/* CUSTOMER_KEY_THE_STUDENT_HOTEL */.iV,
                            text: "The Student Hotel - Work OS provides a trustful overview"
                        },
                        {
                            value: customer_quotes/* CUSTOMER_KEY_TELEFONICA */.tx,
                            text: "Telefonica - 30% more efficient in campaign delivering"
                        },
                        {
                            value: customer_quotes/* CUSTOMER_KEY_ZIPPO */.bd,
                            text: "Zippo - launch projects and expand to new markets in less time"
                        },
                        {
                            value: customer_quotes/* CUSTOMER_KEY_NISSAN */.vK,
                            text: "Nissan - been given confidence to provide management information"
                        }
                    ]
                },
                logosTitle: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Logos title",
                    fields: logos_title_fields_config/* default */.Z
                },
                logos: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Logos",
                    fields: logos_fields_config/* default */.Z
                }
            }
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-with-bullets-side-by-side-iframe/hubspot-dynamic-form-with-bullets-side-by-side-iframe-advanced-config.js
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_object_spread_props(hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        formMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Form Height"
        },
        assetAndParagraphGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset And Paragraph Gap"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/hubspot-dynamic-form-with-bullets-side-by-side-iframe/index.js

var HubspotDynamicFormWithBulletsSideBySideIframeComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(571), __webpack_require__.e(5990), __webpack_require__.e(9112), __webpack_require__.e(9419), __webpack_require__.e(6565), __webpack_require__.e(1128)]).then(__webpack_require__.bind(__webpack_require__, 71128));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71128)
            ];
        }
    }
});


/* harmony default export */ var hubspot_dynamic_form_with_bullets_side_by_side_iframe = ({
    HubspotDynamicFormWithBulletsSideBySideIframeComponent: HubspotDynamicFormWithBulletsSideBySideIframeComponent,
    HubspotDynamicFormWithBulletsSideBySideIframeConfig: hubspot_dynamic_form_with_bullets_side_by_side_iframe_config,
    HubspotDynamicFormWithBulletsSideBySideIframeAdvancedConfig: hubspot_dynamic_form_with_bullets_side_by_side_iframe_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/embedded-board/fields-config.js

/* harmony default export */ var embedded_board_fields_config = ({
    sharableLink: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Shareable link",
        labelDescription: "Copy link from board share inside the monday platform"
    },
    boardIdAndToken: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Board id and token",
        labelDescription: "Old prop please use 'sharable link' instead - this will be deleted soon"
    },
    tooltipText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tooltip text",
        translatable: true
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-config.js
function embedded_board_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_board_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_board_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = fields_config/* default.textColor */.Z.textColor, textAlign = fields_config/* default.textAlign */.Z.textAlign, topic = fields_config/* default.topic */.Z.topic, buttonConfig = fields_config/* default.buttonConfig */.Z.buttonConfig, selectedFullParagraphFields = _object_without_properties(fields_config/* default */.Z, [
    "textColor",
    "textAlign",
    "topic",
    "buttonConfig"
]);
/* harmony default export */ var embedded_board_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Embedded Board",
    fields: embedded_board_iframe_config_object_spread({
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: selectedFullParagraphFields
        }
    }, embedded_board_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/embedded-board-iframe-advanced-config.js
function embedded_board_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function embedded_board_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            embedded_board_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var embedded_board_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: embedded_board_iframe_advanced_config_object_spread({
        embeddedBoardHeight: {
            type: "text",
            label: "Board Height"
        },
        embeddedBoardWidth: {
            type: "text",
            label: "Board Width"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/embedded-board-iframe/index.js



var EmbeddedBoardIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3341).then(__webpack_require__.bind(__webpack_require__, 33341));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33341)
            ];
        }
    }
});
/* harmony default export */ var embedded_board_iframe = ({
    EmbeddedBoardIframeComponent: EmbeddedBoardIframeComponent,
    EmbeddedBoardIframeConfig: embedded_board_iframe_config,
    EmbeddedBoardIframeAdvancedConfig: embedded_board_iframe_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/side-by-side-hubspot-form-config.js
function side_by_side_hubspot_form_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hubspot_form_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hubspot_form_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hubspot_form_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hubspot_form_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hubspot_form_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_hubspot_form_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_hubspot_form_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_hubspot_form_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var _asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, position = _asset.fields.position, restOfAssetFields = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default.asset.fields */.Z.asset.fields, [
    "position"
]), restOfAssetConfig = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, [
    "fields"
]), selectedSideBySideTextAndAssetFieldsConfig = side_by_side_hubspot_form_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var side_by_side_hubspot_form_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Hubspot",
    fields: side_by_side_hubspot_form_config_object_spread_props(side_by_side_hubspot_form_config_object_spread({
        formId: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Form ID"
        },
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Max Width"
        }
    }, components_fields_config, selectedSideBySideTextAndAssetFieldsConfig), {
        asset: side_by_side_hubspot_form_config_object_spread({
            fields: side_by_side_hubspot_form_config_object_spread({}, restOfAssetFields)
        }, restOfAssetConfig)
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/side-by-side-hubspot-form-advanced-config.js
function side_by_side_hubspot_form_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hubspot_form_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hubspot_form_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hubspot_form_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hubspot_form_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hubspot_form_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_hubspot_form_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_hubspot_form_advanced_config_object_spread_props(side_by_side_hubspot_form_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        formMinHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Form Height"
        },
        assetAndParagraphGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Asset And Paragraph Gap"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/side-by-side-hubspot-form/index.js



var SideBySideHubspotFormComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(571), __webpack_require__.e(5990), __webpack_require__.e(9419), __webpack_require__.e(1230)]).then(__webpack_require__.bind(__webpack_require__, 31230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31230)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_hubspot_form = ({
    SideBySideHubspotFormComponent: SideBySideHubspotFormComponent,
    SideBySideHubspotFormConfig: side_by_side_hubspot_form_config,
    SideBySideHubspotFormAdvancedConfig: side_by_side_hubspot_form_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/iframe/fields-config.js

/* harmony default export */ var iframe_fields_config = ({
    src: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Iframe URL"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-config.js
function iframe_dynamic_width_iframe_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_dynamic_width_iframe_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_dynamic_width_iframe_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function iframe_dynamic_width_iframe_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        iframe_dynamic_width_iframe_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var iframe_dynamic_width_iframe_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Basic Iframe",
    fields: iframe_dynamic_width_iframe_config_object_spread_props(iframe_dynamic_width_iframe_config_object_spread({}, iframe_fields_config), {
        width: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Width"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/iframe/advanced-field-config.js
var iframe_advanced_field_config = __webpack_require__(32377);
;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/iframe-dynamic-width-iframe-advanced-config.js
function iframe_dynamic_width_iframe_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function iframe_dynamic_width_iframe_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            iframe_dynamic_width_iframe_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function iframe_dynamic_width_iframe_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        iframe_dynamic_width_iframe_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = iframe_dynamic_width_iframe_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function iframe_dynamic_width_iframe_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var borderWidth = iframe_advanced_field_config/* default.borderWidth */.Z.borderWidth, borderColor = iframe_advanced_field_config/* default.borderColor */.Z.borderColor, selectedAdvancedConfig = iframe_dynamic_width_iframe_advanced_config_object_without_properties(iframe_advanced_field_config/* default */.Z, [
    "borderWidth",
    "borderColor"
]); //	border is hidden for now, will show if needed
/* harmony default export */ var iframe_dynamic_width_iframe_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: iframe_dynamic_width_iframe_advanced_config_object_spread_props(iframe_dynamic_width_iframe_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, selectedAdvancedConfig), {
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            lable: "Max Width"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/iframe-dynamic-width-iframe/index.js



var IframeDynamicWidthIframeComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2281).then(__webpack_require__.bind(__webpack_require__, 62281));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62281)
            ];
        }
    }
});
/* harmony default export */ var iframe_dynamic_width_iframe = ({
    IframeDynamicWidthIframeComponent: IframeDynamicWidthIframeComponent,
    IframeDynamicWidthIframeConfig: iframe_dynamic_width_iframe_config,
    IframeDynamicWidthIframeAdvancedConfig: iframe_dynamic_width_iframe_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/layouts/index.js
// plop_marker:layouts_import







/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    AdaChatbotTestIframe: ada_chatbot_test_iframe,
    AdaChatbotIframe: ada_chatbot_iframe,
    HubspotDynamicFormIframe: hubspot_dynamic_form_iframe,
    HubspotDynamicFormWithBulletsSideBySideIframe: hubspot_dynamic_form_with_bullets_side_by_side_iframe,
    EmbeddedBoardIframe: embedded_board_iframe,
    SideBySideHubspotForm: side_by_side_hubspot_form,
    IframeDynamicWidthIframe: iframe_dynamic_width_iframe
});

;// CONCATENATED MODULE: ./segments/desktop/iframe/index.js

var AdaChatbotTestIframe = layouts.AdaChatbotTestIframe, AdaChatbotIframe = layouts.AdaChatbotIframe, HubspotDynamicFormIframe = layouts.HubspotDynamicFormIframe, HubspotDynamicFormWithBulletsSideBySideIframe = layouts.HubspotDynamicFormWithBulletsSideBySideIframe, EmbeddedBoardIframe = layouts.EmbeddedBoardIframe, SideBySideHubspotForm = layouts.SideBySideHubspotForm, IframeDynamicWidthIframe = layouts.IframeDynamicWidthIframe;
/* harmony default export */ var iframe = ({
    // plop_marker:segment_index_add_layout
    AdaChatbotTestIframeComponent: {
        type: "AdaChatbotTestIframeComponent",
        title: "Ada Chatbot Test",
        imgSrc: "/static/img/segments/layouts/ada-chatbot-test-iframe.png",
        config: AdaChatbotTestIframe.AdaChatbotTestIframeConfig,
        advancedConfig: AdaChatbotTestIframe.AdaChatbotTestIframeAdvancedConfig,
        component: AdaChatbotTestIframe.AdaChatbotTestIframeComponent
    },
    AdaChatbotIframeComponent: {
        type: "AdaChatbotIframeComponent",
        title: "Ada Chatbot",
        imgSrc: "/static/img/segments/layouts/ada-chatbot-iframe.png",
        config: AdaChatbotIframe.AdaChatbotIframeConfig,
        advancedConfig: AdaChatbotIframe.AdaChatbotIframeAdvancedConfig,
        component: AdaChatbotIframe.AdaChatbotIframeComponent
    },
    HubspotDynamicFormIframeComponent: {
        type: "HubspotDynamicFormIframeComponent",
        title: "Hubspot Dynamic Form",
        imgSrc: "/static/img/segments/layouts/hubspot-dynamic-form-iframe.png",
        config: HubspotDynamicFormIframe.HubspotDynamicFormIframeConfig,
        advancedConfig: HubspotDynamicFormIframe.HubspotDynamicFormIframeAdvancedConfig,
        component: HubspotDynamicFormIframe.HubspotDynamicFormIframeComponent
    },
    HubspotDynamicFormWithBulletsSideBySideIframeComponent: {
        type: "HubspotDynamicFormWithBulletsSideBySideIframeComponent",
        title: "Hubspot Dynamic Form With Bullets Side By Side",
        imgSrc: "/static/img/segments/layouts/hubspot-dynamic-form-with-bullets-side-by-side-iframe.png",
        config: HubspotDynamicFormWithBulletsSideBySideIframe.HubspotDynamicFormWithBulletsSideBySideIframeConfig,
        advancedConfig: HubspotDynamicFormWithBulletsSideBySideIframe.HubspotDynamicFormWithBulletsSideBySideIframeAdvancedConfig,
        component: HubspotDynamicFormWithBulletsSideBySideIframe.HubspotDynamicFormWithBulletsSideBySideIframeComponent
    },
    EmbeddedBoardIframeComponent: {
        type: "EmbeddedBoardIframeComponent",
        title: "Embedded Board",
        imgSrc: "/static/img/segments/layouts/embedded-board-iframe.png",
        config: EmbeddedBoardIframe.EmbeddedBoardIframeConfig,
        advancedConfig: EmbeddedBoardIframe.EmbeddedBoardIframeAdvancedConfig,
        component: EmbeddedBoardIframe.EmbeddedBoardIframeComponent
    },
    SideBySideHubspotFormComponent: {
        type: "SideBySideHubspotFormComponent",
        title: "Hubspot old form (Use only in case of custom form id)",
        imgSrc: "/static/img/segments/layouts/side-by-side-hubspot-form.png",
        config: SideBySideHubspotForm.SideBySideHubspotFormConfig,
        advancedConfig: SideBySideHubspotForm.SideBySideHubspotFormAdvancedConfig,
        component: SideBySideHubspotForm.SideBySideHubspotFormComponent
    },
    IframeDynamicWidthIframeComponent: {
        type: "IframeDynamicWidthIframeComponent",
        title: "Basic Iframe",
        imgSrc: "/static/img/segments/layouts/iframe-dynamic-width-iframe.png",
        config: IframeDynamicWidthIframe.IframeDynamicWidthIframeConfig,
        advancedConfig: IframeDynamicWidthIframe.IframeDynamicWidthIframeAdvancedConfig,
        component: IframeDynamicWidthIframe.IframeDynamicWidthIframeComponent
    }
});


/***/ }),

/***/ 29107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop; }
});

// EXTERNAL MODULE: ./segments/desktop/devlink/index.js + 4 modules
var devlink = __webpack_require__(31110);
// EXTERNAL MODULE: ./segments/desktop/templates/index.js + 10 modules
var templates = __webpack_require__(34102);
// EXTERNAL MODULE: ./segments/desktop/pricing/index.js
var pricing = __webpack_require__(49643);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/simpo-customer-success-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var simpo_customer_success_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Simpo",
    fields: _object_spread({}, fields_config/* default */.Z, theme_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/simpo-customer-success-advanced-config.js
function simpo_customer_success_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function simpo_customer_success_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            simpo_customer_success_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var simpo_customer_success_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: simpo_customer_success_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/simpo-customer-success/index.js



var SimpoCustomerSuccessComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4230).then(__webpack_require__.bind(__webpack_require__, 94230));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94230)
            ];
        }
    }
});
/* harmony default export */ var simpo_customer_success = ({
    SimpoCustomerSuccessComponent: SimpoCustomerSuccessComponent,
    SimpoCustomerSuccessConfig: simpo_customer_success_config,
    SimpoCustomerSuccessAdvancedConfig: simpo_customer_success_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SimpoCustomerSuccess: simpo_customer_success
});

;// CONCATENATED MODULE: ./segments/desktop/customer-success/index.js

var SimpoCustomerSuccess = layouts.SimpoCustomerSuccess;
/* harmony default export */ var customer_success = ({
    // plop_marker:segment_index_add_layout
    SimpoCustomerSuccessComponent: {
        type: "SimpoCustomerSuccessComponent",
        title: "Simpo",
        imgSrc: "/static/img/segments/layouts/simpo-customer-success.png",
        config: SimpoCustomerSuccess.SimpoCustomerSuccessConfig,
        advancedConfig: SimpoCustomerSuccess.SimpoCustomerSuccessAdvancedConfig,
        component: SimpoCustomerSuccess.SimpoCustomerSuccessComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/form/index.js + 28 modules
var desktop_form = __webpack_require__(75508);
// EXTERNAL MODULE: ./segments/desktop/blog/index.js + 4 modules
var blog = __webpack_require__(24646);
// EXTERNAL MODULE: ./segments/desktop/iframe/index.js + 25 modules
var iframe = __webpack_require__(77860);
;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/developers-apps-menu-static-config.js

/* harmony default export */ var developers_apps_menu_static_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Developers Apps Menu",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/developers-apps-menu-static-advanced-config.js
function developers_apps_menu_static_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function developers_apps_menu_static_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            developers_apps_menu_static_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var developers_apps_menu_static_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: developers_apps_menu_static_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/developers-apps-menu-static/index.js

var DevelopersAppsMenuStaticComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9300).then(__webpack_require__.bind(__webpack_require__, 59300));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59300)
            ];
        }
    }
});


/* harmony default export */ var developers_apps_menu_static = ({
    DevelopersAppsMenuStaticComponent: DevelopersAppsMenuStaticComponent,
    DevelopersAppsMenuStaticConfig: developers_apps_menu_static_config,
    DevelopersAppsMenuStaticAdvancedConfig: developers_apps_menu_static_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/static/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var static_layouts = ({
    // plop_marker:layouts_add_layout
    DevelopersAppsMenuStatic: developers_apps_menu_static
});

;// CONCATENATED MODULE: ./segments/desktop/static/index.js

var DevelopersAppsMenuStatic = static_layouts.DevelopersAppsMenuStatic;
/* harmony default export */ var desktop_static = ({
    // plop_marker:segment_index_add_layout
    DevelopersAppsMenuStaticComponent: {
        type: "DevelopersAppsMenuStaticComponent",
        title: "Developers Apps Menu",
        imgSrc: "/static/img/segments/layouts/developers-apps-menu-static.png",
        config: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticConfig,
        advancedConfig: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticAdvancedConfig,
        component: DevelopersAppsMenuStatic.DevelopersAppsMenuStaticComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/embedded/index.js + 15 modules
var embedded = __webpack_require__(95129);
// EXTERNAL MODULE: ./segments/desktop/banner/index.js + 1 modules
var banner = __webpack_require__(12101);
// EXTERNAL MODULE: ./segments/desktop/homepage-first-fold/index.js + 40 modules
var homepage_first_fold = __webpack_require__(78764);
// EXTERNAL MODULE: ./segments/desktop/integrations/index.js + 7 modules
var integrations = __webpack_require__(17082);
// EXTERNAL MODULE: ./segments/desktop/button/index.js + 4 modules
var desktop_button = __webpack_require__(3993);
// EXTERNAL MODULE: ./segments/desktop/enterprise/index.js + 10 modules
var enterprise = __webpack_require__(26647);
// EXTERNAL MODULE: ./segments/desktop/asset/index.js + 25 modules
var asset = __webpack_require__(58830);
// EXTERNAL MODULE: ./segments/desktop/security/index.js + 4 modules
var security = __webpack_require__(71380);
// EXTERNAL MODULE: ./segments/desktop/tabs/index.js + 59 modules
var tabs = __webpack_require__(73573);
// EXTERNAL MODULE: ./segments/desktop/header/index.js + 16 modules
var header = __webpack_require__(90382);
// EXTERNAL MODULE: ./segments/desktop/careers/index.js + 8 modules
var careers = __webpack_require__(33960);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-background-text-and-asset/fields-config.js
var full_background_text_and_asset_fields_config = __webpack_require__(55782);
;// CONCATENATED MODULE: ./segments/core-configs/topbar-config.js

/* harmony default export */ var topbar_config = ({
    topbar: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Top Bar",
        fields: {
            showMenu: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Show Menu"
            },
            shortHeader: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Short Header"
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/full-background-hero/full-background-hero-config.js
function full_background_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function full_background_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            full_background_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var full_background_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Full Background",
    fields: _object_spread_props(full_background_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: full_background_text_and_asset_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/full-background-hero/index.js


var FullBackgroundHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(870)]).then(__webpack_require__.bind(__webpack_require__, 68706));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68706)
            ];
        }
    }
});
/* harmony default export */ var full_background_hero = ({
    FullBackgroundHeroComponent: FullBackgroundHeroComponent,
    FullBackgroundHeroConfig: full_background_hero_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-with-background-hero/side-by-side-with-background-hero-config.js
function side_by_side_with_background_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_background_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_background_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_background_hero_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_background_hero_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_background_hero_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "background"
]);
/* harmony default export */ var side_by_side_with_background_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Background",
    fields: side_by_side_with_background_hero_config_object_spread_props(side_by_side_with_background_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: side_by_side_with_background_hero_config_object_spread({
                background: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Background",
                    fields: {
                        color: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Color",
                            possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
                        }
                    }
                }
            }, selectedSideBySideTextAndAssetFieldsConfig)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-with-background-hero/index.js


var SideBySideWithBackgroundHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(7128)]).then(__webpack_require__.bind(__webpack_require__, 14414));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14414)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_with_background_hero = ({
    SideBySideWithBackgroundHeroComponent: SideBySideWithBackgroundHeroComponent,
    SideBySideWithBackgroundHeroConfig: side_by_side_with_background_hero_config
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-hero/side-by-side-hero-config.js
function side_by_side_hero_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_hero_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_hero_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_hero_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_hero_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_hero_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_hero_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_hero_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_hero_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var side_by_side_hero_config_swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, side_by_side_hero_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_hero_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_hero_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "background"
]);
/* harmony default export */ var side_by_side_hero_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side",
    fields: side_by_side_hero_config_object_spread_props(side_by_side_hero_config_object_spread({}, topbar_config), {
        textAndAsset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Text And Asset",
            fields: side_by_side_hero_config_selectedSideBySideTextAndAssetFieldsConfig
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/side-by-side-hero/index.js


var SideBySideHeroComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(1882), __webpack_require__.e(4938)]).then(__webpack_require__.bind(__webpack_require__, 74743));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(74743)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_hero = ({
    SideBySideHeroComponent: SideBySideHeroComponent,
    SideBySideHeroConfig: side_by_side_hero_config
});

;// CONCATENATED MODULE: ./segments/desktop/hero/layouts/index.js
// plop_marker:layouts_import



/* harmony default export */ var hero_layouts = ({
    // plop_marker:layouts_add_layout
    FullBackgroundHero: full_background_hero,
    SideBySideWithBackgroundHero: side_by_side_with_background_hero,
    SideBySideHero: side_by_side_hero
});

;// CONCATENATED MODULE: ./segments/desktop/hero/index.js

var FullBackgroundHero = hero_layouts.FullBackgroundHero, SideBySideWithBackgroundHero = hero_layouts.SideBySideWithBackgroundHero, SideBySideHero = hero_layouts.SideBySideHero;
/* harmony default export */ var hero = ({
    // plop_marker:segment_index_add_layout
    FullBackgroundHeroComponent: {
        type: "FullBackgroundHeroComponent",
        title: "Full Background",
        imgSrc: "/static/img/segments/layouts/full-background-hero.png",
        config: FullBackgroundHero.FullBackgroundHeroConfig,
        component: FullBackgroundHero.FullBackgroundHeroComponent
    },
    SideBySideWithBackgroundHeroComponent: {
        type: "SideBySideWithBackgroundHeroComponent",
        title: "Side By Side With Background",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-background-hero.png",
        config: SideBySideWithBackgroundHero.SideBySideWithBackgroundHeroConfig,
        component: SideBySideWithBackgroundHero.SideBySideWithBackgroundHeroComponent
    },
    SideBySideHeroComponent: {
        type: "SideBySideHeroComponent",
        title: "Side By Side",
        imgSrc: "/static/img/segments/layouts/side-by-side-hero.png",
        config: SideBySideHero.SideBySideHeroConfig,
        component: SideBySideHero.SideBySideHeroComponent
    }
});

// EXTERNAL MODULE: ./segments/desktop/footer/index.js + 13 modules
var footer = __webpack_require__(31627);
// EXTERNAL MODULE: ./segments/desktop/grid/index.js + 77 modules
var grid = __webpack_require__(15348);
// EXTERNAL MODULE: ./segments/desktop/testimonials/index.js + 8 modules
var testimonials = __webpack_require__(35341);
// EXTERNAL MODULE: ./segments/desktop/logos/index.js + 18 modules
var logos = __webpack_require__(20906);
// EXTERNAL MODULE: ./segments/desktop/reviews/index.js + 17 modules
var reviews = __webpack_require__(80411);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/index.js + 45 modules
var text_and_asset = __webpack_require__(95033);
// EXTERNAL MODULE: ./segments/desktop/paragraph/index.js + 20 modules
var paragraph = __webpack_require__(9938);
;// CONCATENATED MODULE: ./segments/desktop/index.js
// plop_marker:segments_import
function desktop_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function desktop_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            desktop_define_property(target, key, source[key]);
        });
    }
    return target;
}



























/* harmony default export */ var desktop = (desktop_object_spread({}, devlink/* default */.Z, templates/* default */.Z, careers/* default */.Z, pricing/* default */.Z, customer_success, desktop_form/* default */.Z, blog/* default */.Z, iframe/* default */.Z, desktop_static, embedded/* default */.Z, banner/* default */.Z, homepage_first_fold/* default */.Z, integrations/* default */.Z, desktop_button/* default */.Z, enterprise/* default */.Z, asset/* default */.Z, security/* default */.Z, tabs/* default */.Z, header/* default */.Z, hero, footer/* default */.Z, grid/* default */.Z, testimonials/* default */.Z, logos/* default */.Z, reviews/* default */.Z, text_and_asset/* default */.Z, paragraph/* default */.Z));


/***/ }),

/***/ 17082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ integrations; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var monday_integrations_connections_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Integrations",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        componentTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            translatable: true
        },
        beforeAnimationSubTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle- before animation",
            translatable: true
        },
        afterAnimationSubTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Subtitle- after animation",
            translatable: true
        },
        switchRightPhrase: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Right phrase of switch",
            translatable: true
        },
        switchLeftPhrase: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left phrase of switch",
            translatable: true
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/monday-integrations-connections-advanced-config.js
function monday_integrations_connections_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_integrations_connections_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_integrations_connections_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var monday_integrations_connections_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_integrations_connections_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/monday-integrations-connections/index.js



var MondayIntegrationsConnectionsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1348).then(__webpack_require__.bind(__webpack_require__, 91348));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91348)
            ];
        }
    }
});
/* harmony default export */ var monday_integrations_connections = ({
    MondayIntegrationsConnectionsComponent: MondayIntegrationsConnectionsComponent,
    MondayIntegrationsConnectionsConfig: monday_integrations_connections_config,
    MondayIntegrationsConnectionsAdvancedConfig: monday_integrations_connections_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-config.js

/* harmony default export */ var floating_integrations_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Floating",
    fields: {}
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/floating-integrations-advanced-config.js
function floating_integrations_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function floating_integrations_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            floating_integrations_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var floating_integrations_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: floating_integrations_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/floating-integrations/index.js



var FloatingIntegrationsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5942).then(__webpack_require__.bind(__webpack_require__, 55942));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55942)
            ];
        }
    }
});
/* harmony default export */ var floating_integrations = ({
    FloatingIntegrationsComponent: FloatingIntegrationsComponent,
    FloatingIntegrationsConfig: floating_integrations_config,
    FloatingIntegrationsAdvancedConfig: floating_integrations_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    MondayIntegrationsConnections: monday_integrations_connections,
    FloatingIntegrations: floating_integrations
});

;// CONCATENATED MODULE: ./segments/desktop/integrations/index.js

var MondayIntegrationsConnections = layouts.MondayIntegrationsConnections, FloatingIntegrations = layouts.FloatingIntegrations;
/* harmony default export */ var integrations = ({
    // plop_marker:segment_index_add_layout
    MondayIntegrationsConnectionsComponent: {
        type: "MondayIntegrationsConnectionsComponent",
        title: "Monday Integrations",
        imgSrc: "/static/img/segments/layouts/monday-integrations-connections.png",
        config: MondayIntegrationsConnections.MondayIntegrationsConnectionsConfig,
        advancedConfig: MondayIntegrationsConnections.MondayIntegrationsConnectionsAdvancedConfig,
        component: MondayIntegrationsConnections.MondayIntegrationsConnectionsComponent
    },
    FloatingIntegrationsComponent: {
        type: "FloatingIntegrationsComponent",
        title: "Floating",
        imgSrc: "/static/img/segments/layouts/floating-integrations.png",
        config: FloatingIntegrations.FloatingIntegrationsConfig,
        advancedConfig: FloatingIntegrations.FloatingIntegrationsAdvancedConfig,
        component: FloatingIntegrations.FloatingIntegrationsComponent
    }
});


/***/ }),

/***/ 74606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65621);
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77869);
/* harmony import */ var segments_segments_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(861);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_title_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
    theme: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COLOR_PICKER,
        label: "Theme",
        possibleColors: segments_segments_service__WEBPACK_IMPORTED_MODULE_2__/* .BACKGROUND_COLOR_OPTIONS */ .L6
    },
    titleSize: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Title Size",
        options: [
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .XXS */ .Mp,
                text: "11px (formerly 12px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .XS_M */ .g4,
                text: "14px (formerly 16px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.XS,
                text: "22px (formerly 24px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.SM,
                text: "28px (formerly 32px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.MD,
                text: "36px (formerly 40px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.LG,
                text: "44px (formerly 50px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__/* .LGR */ .Re,
                text: "54px (formerly 60px)"
            },
            {
                value: constants_sizes__WEBPACK_IMPORTED_MODULE_3__.XL,
                text: "64px (formerly 72px)"
            }
        ]
    },
    textAlign: {
        type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.COMBO,
        label: "Text Align",
        options: [
            {
                value: "left",
                text: "Left"
            },
            {
                value: "center",
                text: "Center"
            },
            {
                value: "right",
                text: "Right"
            }
        ]
    }
}));


/***/ }),

/***/ 20906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/logos/fields-config.js
var logos_fields_config = __webpack_require__(97909);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/logos-and-paragraph-logos-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



var SUPPORTED_LOGOS_NUMBER_OPTIONS = [
    "12"
];
var numberOfCompaniesConfig = {
    numberOfCompanies: _object_spread_props(_object_spread({}, logos_fields_config/* default.numberOfCompanies */.Z.numberOfCompanies), {
        options: SUPPORTED_LOGOS_NUMBER_OPTIONS
    })
};
/* harmony default export */ var logos_and_paragraph_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos and Paragraph",
    fields: {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: _object_spread({}, logos_fields_config/* default */.Z, numberOfCompaniesConfig)
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: _object_spread({}, fields_config/* default */.Z)
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/core-components/logos/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(53315);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/logos-and-paragraph-logos-advanced-config.js


/* harmony default export */ var logos_and_paragraph_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos And Paragraph",
    fields: {
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/logos-and-paragraph-logos/index.js



var LogosAndParagraphLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(9039)]).then(__webpack_require__.bind(__webpack_require__, 75647));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(75647)
            ];
        }
    }
});
/* harmony default export */ var logos_and_paragraph_logos = ({
    LogosAndParagraphLogosComponent: LogosAndParagraphLogosComponent,
    LogosAndParagraphLogosConfig: logos_and_paragraph_logos_config,
    LogosAndParagraphLogosAdvancedConfig: logos_and_paragraph_logos_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/components/logos-title/fields-config.js
var logos_title_fields_config = __webpack_require__(74606);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/slim-logos-config.js
function slim_logos_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slim_logos_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            slim_logos_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function slim_logos_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function slim_logos_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        slim_logos_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var slim_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Slim Logos",
    fields: slim_logos_config_object_spread_props(slim_logos_config_object_spread({}, logos_title_fields_config/* default */.Z), {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/slim-logos-advanced-config.js
function slim_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function slim_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            slim_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var slim_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: slim_logos_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/slim-logos/index.js



var SlimLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(7201)]).then(__webpack_require__.bind(__webpack_require__, 67858));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(67858)
            ];
        }
    }
});
/* harmony default export */ var slim_logos = ({
    SlimLogosComponent: SlimLogosComponent,
    SlimLogosConfig: slim_logos_config,
    SlimLogosAdvancedConfig: slim_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/all-logos-logos-config.js

/* harmony default export */ var all_logos_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "All Logos",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                "riverstone",
                "gradiant-gray"
            ]
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/all-logos-logos-advanced-config.js
function all_logos_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function all_logos_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            all_logos_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var all_logos_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: all_logos_logos_advanced_config_object_spread({
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/all-logos-logos/index.js



var AllLogosLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(7242)]).then(__webpack_require__.bind(__webpack_require__, 38688));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(38688)
            ];
        }
    }
});
/* harmony default export */ var all_logos_logos = ({
    AllLogosLogosComponent: AllLogosLogosComponent,
    AllLogosLogosConfig: all_logos_logos_config,
    AllLogosLogosAdvancedConfig: all_logos_logos_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-config.js
var top_logos_config = __webpack_require__(63625);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/top-logos-advanced-config.js
function top_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function top_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            top_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var top_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: top_logos_advanced_config_object_spread({
        textAndLogosMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Space between text and logo"
        },
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/top-logos/index.js

var TopLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(1222)]).then(__webpack_require__.bind(__webpack_require__, 36238));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(36238)
            ];
        }
    }
});


/* harmony default export */ var top_logos = ({
    TopLogosComponent: TopLogosComponent,
    TopLogosConfig: top_logos_config/* default */.Z,
    TopLogosAdvancedConfig: top_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/bottom-logos-config.js
function bottom_logos_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_logos_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_logos_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function bottom_logos_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function bottom_logos_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        bottom_logos_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var bottom_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Bottom",
    fields: bottom_logos_config_object_spread_props(bottom_logos_config_object_spread({}, logos_title_fields_config/* default */.Z), {
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/bottom-logos-advanced-config.js
function bottom_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function bottom_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            bottom_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var bottom_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: bottom_logos_advanced_config_object_spread({
        textAndLogosMargin: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Space between text and logo"
        },
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/bottom-logos/index.js



var BottomLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(6030)]).then(__webpack_require__.bind(__webpack_require__, 11486));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11486)
            ];
        }
    }
});
/* harmony default export */ var bottom_logos = ({
    BottomLogosComponent: BottomLogosComponent,
    BottomLogosConfig: bottom_logos_config,
    BottomLogosAdvancedConfig: bottom_logos_advanced_config
});

// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/images-logos-config.js



/* harmony default export */ var images_logos_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Images",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                "riverstone",
                "gradiant-gray",
                color_consts.BACKGROUND_GRAY_COLOR_NAME
            ]
        },
        logos: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: logos_fields_config/* default */.Z
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/images-logos-advanced-config.js
function images_logos_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function images_logos_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            images_logos_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var images_logos_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: images_logos_advanced_config_object_spread({
        logosAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Logos Advanced Props",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/images-logos/index.js



var ImagesLogosComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9112), __webpack_require__.e(4737)]).then(__webpack_require__.bind(__webpack_require__, 24939));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24939)
            ];
        }
    }
});
/* harmony default export */ var images_logos = ({
    ImagesLogosComponent: ImagesLogosComponent,
    ImagesLogosConfig: images_logos_config,
    ImagesLogosAdvancedConfig: images_logos_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/logos/layouts/index.js
// plop_marker:layouts_import






/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    LogosAndParagraphLogos: logos_and_paragraph_logos,
    SlimLogos: slim_logos,
    AllLogosLogos: all_logos_logos,
    TopLogos: top_logos,
    BottomLogos: bottom_logos,
    ImagesLogos: images_logos
});

;// CONCATENATED MODULE: ./segments/desktop/logos/index.js

var LogosAndParagraphLogos = layouts.LogosAndParagraphLogos, SlimLogos = layouts.SlimLogos, AllLogosLogos = layouts.AllLogosLogos, TopLogos = layouts.TopLogos, BottomLogos = layouts.BottomLogos, ImagesLogos = layouts.ImagesLogos;
/* harmony default export */ var logos = ({
    // plop_marker:segment_index_add_layout
    LogosAndParagraphLogosComponent: {
        type: "LogosAndParagraphLogosComponent",
        title: "Logos And Paragraph",
        imgSrc: "/static/img/segments/layouts/logos-and-paragraph-logos.png",
        config: LogosAndParagraphLogos.LogosAndParagraphLogosConfig,
        advancedConfig: LogosAndParagraphLogos.LogosAndParagraphLogosAdvancedConfig,
        component: LogosAndParagraphLogos.LogosAndParagraphLogosComponent
    },
    SlimLogosComponent: {
        type: "SlimLogosComponent",
        title: "Slim",
        imgSrc: "/static/img/segments/layouts/slim-logos.png",
        config: SlimLogos.SlimLogosConfig,
        advancedConfig: SlimLogos.SlimLogosAdvancedConfig,
        component: SlimLogos.SlimLogosComponent
    },
    AllLogosLogosComponent: {
        type: "AllLogosLogosComponent",
        title: "All Logos",
        imgSrc: "/static/img/segments/layouts/all-logos-logos.png",
        config: AllLogosLogos.AllLogosLogosConfig,
        advancedConfig: AllLogosLogos.AllLogosLogosAdvancedConfig,
        component: AllLogosLogos.AllLogosLogosComponent
    },
    TopLogosComponent: {
        type: "TopLogosComponent",
        title: "Top",
        imgSrc: "/static/img/segments/layouts/top-logos.png",
        config: TopLogos.TopLogosConfig,
        advancedConfig: TopLogos.TopLogosAdvancedConfig,
        component: TopLogos.TopLogosComponent
    },
    BottomLogosComponent: {
        type: "BottomLogosComponent",
        title: "Bottom",
        imgSrc: "/static/img/segments/layouts/bottom-logos.png",
        config: BottomLogos.BottomLogosConfig,
        advancedConfig: BottomLogos.BottomLogosAdvancedConfig,
        component: BottomLogos.BottomLogosComponent
    },
    ImagesLogosComponent: {
        type: "ImagesLogosComponent",
        title: "Images",
        imgSrc: "/static/img/segments/layouts/images-logos.png",
        config: ImagesLogos.ImagesLogosConfig,
        advancedConfig: ImagesLogos.ImagesLogosAdvancedConfig,
        component: ImagesLogos.ImagesLogosComponent
    }
});


/***/ }),

/***/ 63625:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_logos_components_logos_title_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74606);
/* harmony import */ var segments_desktop_core_components_logos_fields_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97909);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Top Logos",
    fields: _object_spread_props(_object_spread({}, segments_desktop_logos_components_logos_title_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z), {
        logos: {
            type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
            label: "Logos",
            fields: segments_desktop_core_components_logos_fields_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z
        }
    })
});


/***/ }),

/***/ 9938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ paragraph; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
// EXTERNAL MODULE: ./constants/color-picker-constants.js
var color_picker_constants = __webpack_require__(95947);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var fullParagraph = fields_config/* default.fullParagraph */.Z.fullParagraph, asset = fields_config/* default.asset */.Z.asset, titleSize = fields_config/* default.titleSize */.Z.titleSize, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(fields_config/* default */.Z, [
    "fullParagraph",
    "asset",
    "titleSize"
]);
var customFullParagraph = _object_spread_props(_object_spread({}, fullParagraph), {
    fields: _object_spread_props(_object_spread({}, fullParagraph.fields), {
        paragraphVerticalColoredLineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Paragraph vertical colored line color",
            possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
        }
    })
});
/* harmony default export */ var side_by_side_with_paragraphs_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Paragraphs",
    fields: _object_spread_props(_object_spread({}, selectedSideBySideTextAndAssetFieldsConfig), {
        primaryParagraph: _object_spread_props(_object_spread({}, customFullParagraph), {
            label: "Primary paragraph"
        }),
        leftSectionBottomText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left section bottom text"
        },
        leftSectionBottomTextColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Left section bottom text color",
            possibleColors: color_picker_constants.textColorOptions
        },
        paragraphs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Right section paragraphs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    fullParagraph: _object_spread_props(_object_spread({}, customFullParagraph), {
                        label: "Full paragraph"
                    })
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/side-by-side-with-paragraphs-paragraph-advanced-config.js
function side_by_side_with_paragraphs_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_paragraphs_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_paragraphs_paragraph_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_paragraphs_paragraph_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_with_paragraphs_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_paragraphs_paragraph_advanced_config_object_spread_props(side_by_side_with_paragraphs_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        leftSectionParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Left section paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        rightSectionParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Right section paragraphs",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-with-paragraphs-paragraph/index.js



var SideBySideWithParagraphsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2759).then(__webpack_require__.bind(__webpack_require__, 32759));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32759)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_with_paragraphs_paragraph = ({
    SideBySideWithParagraphsParagraphComponent: SideBySideWithParagraphsParagraphComponent,
    SideBySideWithParagraphsParagraphConfig: side_by_side_with_paragraphs_paragraph_config,
    SideBySideWithParagraphsParagraphAdvancedConfig: side_by_side_with_paragraphs_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-config.js
function two_paragraphs_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_paragraphs_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_paragraphs_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_paragraphs_paragraph_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_paragraphs_paragraph_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_paragraphs_paragraph_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function two_paragraphs_paragraph_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = two_paragraphs_paragraph_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function two_paragraphs_paragraph_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var two_paragraphs_paragraph_config_fullParagraph = fields_config/* default.fullParagraph */.Z.fullParagraph, two_paragraphs_paragraph_config_asset = fields_config/* default.asset */.Z.asset, two_paragraphs_paragraph_config_titleSize = fields_config/* default.titleSize */.Z.titleSize, two_paragraphs_paragraph_config_selectedSideBySideTextAndAssetFieldsConfig = two_paragraphs_paragraph_config_object_without_properties(fields_config/* default */.Z, [
    "fullParagraph",
    "asset",
    "titleSize"
]);
var paragraphVerticalColoredLineColor = {
    type: template_field_type.FIELD_TYPES.COLOR_PICKER,
    label: "Paragraph vertical colored line color",
    possibleColors: segments_service/* BACKGROUND_COLOR_OPTIONS */.L6
};
var two_paragraphs_paragraph_config_customFullParagraph = two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_fullParagraph), {
    fields: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_fullParagraph.fields), {
        paragraphVerticalColoredLineColor: paragraphVerticalColoredLineColor
    })
});
/* harmony default export */ var two_paragraphs_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Two Paragraphs",
    fields: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, theme_config/* default */.Z, two_paragraphs_paragraph_config_selectedSideBySideTextAndAssetFieldsConfig), {
        primaryParagraph: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_customFullParagraph), {
            label: "Primary paragraph"
        }),
        secondaryParagraph: two_paragraphs_paragraph_config_object_spread_props(two_paragraphs_paragraph_config_object_spread({}, two_paragraphs_paragraph_config_customFullParagraph), {
            label: "Secondary paragraph"
        })
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/two-paragraphs-paragraph-advanced-config.js
function two_paragraphs_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_paragraphs_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_paragraphs_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var two_paragraphs_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_paragraphs_paragraph_advanced_config_object_spread({
        primaryParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Primary paragraph",
            fields: advanced_fields_config/* default */.Z
        },
        secondaryParagraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Secondary paragraph",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/two-paragraphs-paragraph/index.js



var TwoParagraphsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 518).then(__webpack_require__.bind(__webpack_require__, 60518));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60518)
            ];
        }
    }
});
/* harmony default export */ var two_paragraphs_paragraph = ({
    TwoParagraphsParagraphComponent: TwoParagraphsParagraphComponent,
    TwoParagraphsParagraphConfig: two_paragraphs_paragraph_config,
    TwoParagraphsParagraphAdvancedConfig: two_paragraphs_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/universe-paragraph-config.js
function universe_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function universe_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            universe_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var universe_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Universe Paragraph",
    fields: universe_paragraph_config_object_spread({
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme",
            possibleColors: [
                segments_service/* SPACE_BLUE_VIDEO_THEME_ID */.xn
            ]
        }
    }, full_paragraph_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/universe-paragraph-advanced-config.js
function universe_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function universe_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            universe_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var universe_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: universe_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/universe-paragraph/index.js



var UniverseParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3885).then(__webpack_require__.bind(__webpack_require__, 63885));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63885)
            ];
        }
    }
});
/* harmony default export */ var universe_paragraph = ({
    UniverseParagraphComponent: UniverseParagraphComponent,
    UniverseParagraphConfig: universe_paragraph_config,
    UniverseParagraphAdvancedConfig: universe_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var title_fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-config.js
function side_by_side_title_paragraph_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_title_paragraph_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_title_paragraph_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_title_paragraph_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_title_paragraph_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_title_paragraph_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_title_paragraph_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_title_paragraph_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_title_paragraph_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var topic = full_paragraph_fields_config/* default.topic */.Z.topic, title = full_paragraph_fields_config/* default.title */.Z.title, restParagraphProps = side_by_side_title_paragraph_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "topic",
    "title"
]);
/* harmony default export */ var side_by_side_title_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Title and Paragraph",
    fields: side_by_side_title_paragraph_config_object_spread_props(side_by_side_title_paragraph_config_object_spread({}, theme_config/* default */.Z), {
        titleProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: title_fields_config/* default */.Z
        },
        paragraphProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: restParagraphProps
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var paragraph_advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/side-by-side-title-paragraph-advanced-config.js
function side_by_side_title_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_title_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_title_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_title_paragraph_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_title_paragraph_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_title_paragraph_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_title_paragraph_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var titleWidth = title_advanced_field_config/* default.titleWidth */.Z.titleWidth, restTitleAdvancedProps = side_by_side_title_paragraph_advanced_config_object_without_properties(title_advanced_field_config/* default */.Z, [
    "titleWidth"
]);
/* harmony default export */ var side_by_side_title_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_title_paragraph_advanced_config_object_spread_props(side_by_side_title_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_theme_config/* default */.Z), {
        titleAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title",
            fields: restTitleAdvancedProps
        },
        paragraphAdvancedProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: paragraph_advanced_fields_config/* default */.Z
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        paragraphVerticalAlignment: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Paragraph vertical alignment",
            options: [
                {
                    value: "baseline",
                    text: "Top"
                },
                {
                    value: "center",
                    text: "Center"
                },
                {
                    value: "end",
                    text: "Bottom"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/side-by-side-title-paragraph/index.js



var SideBySideTitleParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 833).then(__webpack_require__.bind(__webpack_require__, 80833));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80833)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_title_paragraph = ({
    SideBySideTitleParagraphComponent: SideBySideTitleParagraphComponent,
    SideBySideTitleParagraphConfig: side_by_side_title_paragraph_config,
    SideBySideTitleParagraphAdvancedConfig: side_by_side_title_paragraph_advanced_config
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/rotating-title-paragraph-config.js


/* harmony default export */ var rotating_title_paragraph_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Rotating Title",
    fields: {
        title: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Title",
            textArea: true,
            translatable: true
        },
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        },
        rotatingWords: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Rotating words",
            maxLimit: 10,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    text: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Text",
                        translatable: true
                    },
                    color: {
                        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                        label: "Text Color"
                    }
                }
            }
        },
        infiniteRotation: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "infinite rotationn"
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/rotating-title-paragraph-advanced-config.js
function rotating_title_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function rotating_title_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            rotating_title_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var rotating_title_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: rotating_title_paragraph_advanced_config_object_spread({
        animationDuration: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Animation Duration"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/rotating-title-paragraph/index.js



var RotatingTitleParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5812).then(__webpack_require__.bind(__webpack_require__, 55812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(55812)
            ];
        }
    }
});
/* harmony default export */ var rotating_title_paragraph = ({
    RotatingTitleParagraphComponent: RotatingTitleParagraphComponent,
    RotatingTitleParagraphConfig: rotating_title_paragraph_config,
    RotatingTitleParagraphAdvancedConfig: rotating_title_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/index.js + 1 modules
var full_paragraph = __webpack_require__(52514);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-config.js
var title_only_paragraph_config = __webpack_require__(68566);
;// CONCATENATED MODULE: ./segments/desktop/core-components/title-only-paragraph/fields-advanced-config.js
function fields_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}

/* harmony default export */ var fields_advanced_config = (fields_advanced_config_object_spread({}, title_advanced_field_config/* default */.Z));

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/title-only-paragraph-advanced-config.js
function title_only_paragraph_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function title_only_paragraph_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            title_only_paragraph_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var title_only_paragraph_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: title_only_paragraph_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, fields_advanced_config)
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/title-only-paragraph/index.js

var TitleOnlyParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6601).then(__webpack_require__.bind(__webpack_require__, 96601));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96601)
            ];
        }
    }
});


/* harmony default export */ var title_only_paragraph = ({
    TitleOnlyParagraphComponent: TitleOnlyParagraphComponent,
    TitleOnlyParagraphConfig: title_only_paragraph_config/* default */.Z,
    TitleOnlyParagraphAdvancedConfig: title_only_paragraph_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-config.js
var full_with_bullets_paragraph_config = __webpack_require__(87313);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/full-with-bullets-paragraph-advanced-config.js
var full_with_bullets_paragraph_advanced_config = __webpack_require__(29737);
;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/full-with-bullets-paragraph/index.js

var FullWithBulletsParagraphComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3174).then(__webpack_require__.bind(__webpack_require__, 53174));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(53174)
            ];
        }
    }
});


/* harmony default export */ var full_with_bullets_paragraph = ({
    FullWithBulletsParagraphComponent: FullWithBulletsParagraphComponent,
    FullWithBulletsParagraphConfig: full_with_bullets_paragraph_config/* default */.Z,
    FullWithBulletsParagraphAdvancedConfig: full_with_bullets_paragraph_advanced_config/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/layouts/index.js
// plop_marker:layouts_import








/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    SideBySideWithParagraphsParagraph: side_by_side_with_paragraphs_paragraph,
    TwoParagraphsParagraph: two_paragraphs_paragraph,
    UniverseParagraph: universe_paragraph,
    SideBySideTitleParagraph: side_by_side_title_paragraph,
    RotatingTitleParagraph: rotating_title_paragraph,
    FullParagraph: full_paragraph/* default */.Z,
    TitleOnlyParagraph: title_only_paragraph,
    FullWithBulletsParagraph: full_with_bullets_paragraph
});

;// CONCATENATED MODULE: ./segments/desktop/paragraph/index.js

var SideBySideWithParagraphsParagraph = layouts.SideBySideWithParagraphsParagraph, TwoParagraphsParagraph = layouts.TwoParagraphsParagraph, UniverseParagraph = layouts.UniverseParagraph, SideBySideTitleParagraph = layouts.SideBySideTitleParagraph, RotatingTitleParagraph = layouts.RotatingTitleParagraph, FullWithBulletsParagraph = layouts.FullWithBulletsParagraph, FullParagraph = layouts.FullParagraph, TitleOnlyParagraph = layouts.TitleOnlyParagraph;
/* harmony default export */ var paragraph = ({
    // plop_marker:segment_index_add_layout
    SideBySideWithParagraphsParagraphComponent: {
        type: "SideBySideWithParagraphsParagraphComponent",
        title: "Side By Side With Paragraphs",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-paragraphs-paragraph.png",
        config: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphConfig,
        advancedConfig: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphAdvancedConfig,
        component: SideBySideWithParagraphsParagraph.SideBySideWithParagraphsParagraphComponent
    },
    TwoParagraphsParagraphComponent: {
        type: "TwoParagraphsParagraphComponent",
        title: "Two Paragraphs",
        imgSrc: "/static/img/segments/layouts/two-paragraphs-paragraph.png",
        config: TwoParagraphsParagraph.TwoParagraphsParagraphConfig,
        advancedConfig: TwoParagraphsParagraph.TwoParagraphsParagraphAdvancedConfig,
        component: TwoParagraphsParagraph.TwoParagraphsParagraphComponent
    },
    UniverseParagraphComponent: {
        type: "UniverseParagraphComponent",
        title: "Universe mobile",
        imgSrc: "/static/img/segments/layouts/universe-paragraph.png",
        config: UniverseParagraph.UniverseParagraphConfig,
        advancedConfig: UniverseParagraph.UniverseParagraphAdvancedConfig,
        component: UniverseParagraph.UniverseParagraphComponent
    },
    SideBySideTitleParagraphComponent: {
        type: "SideBySideTitleParagraphComponent",
        title: "Side By Side Title",
        imgSrc: "/static/img/segments/layouts/side-by-side-title-paragraph.png",
        config: SideBySideTitleParagraph.SideBySideTitleParagraphConfig,
        advancedConfig: SideBySideTitleParagraph.SideBySideTitleParagraphAdvancedConfig,
        component: SideBySideTitleParagraph.SideBySideTitleParagraphComponent
    },
    RotatingTitleParagraphComponent: {
        type: "RotatingTitleParagraphComponent",
        title: "Rotating Title",
        imgSrc: "/static/img/segments/layouts/rotating-title-paragraph.png",
        config: RotatingTitleParagraph.RotatingTitleParagraphConfig,
        advancedConfig: RotatingTitleParagraph.RotatingTitleParagraphAdvancedConfig,
        component: RotatingTitleParagraph.RotatingTitleParagraphComponent
    },
    FullWithBulletsParagraphComponent: {
        type: "FullWithBulletsParagraphComponent",
        title: "Full With Bullets",
        imgSrc: "/static/img/segments/layouts/full-with-bullets-paragraph.png",
        config: FullWithBulletsParagraph.FullWithBulletsParagraphConfig,
        advancedConfig: FullWithBulletsParagraph.FullWithBulletsParagraphAdvancedConfig,
        component: FullWithBulletsParagraph.FullWithBulletsParagraphComponent
    },
    FullParagraphComponent: {
        type: "FullParagraphComponent",
        title: "Full",
        imgSrc: "/static/img/segments/layouts/full-paragraph.png",
        config: FullParagraph.FullParagraphConfig,
        advancedConfig: FullParagraph.FullParagraphAdvancedConfig,
        component: FullParagraph.FullParagraphComponent
    },
    TitleOnlyParagraphComponent: {
        type: "TitleOnlyParagraphComponent",
        title: "Title Only",
        imgSrc: "/static/img/segments/layouts/title-only-paragraph.png",
        config: TitleOnlyParagraph.TitleOnlyParagraphConfig,
        advancedConfig: TitleOnlyParagraph.TitleOnlyParagraphAdvancedConfig,
        component: TitleOnlyParagraph.TitleOnlyParagraphComponent
    }
});


/***/ }),

/***/ 68566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(60633);
/* harmony import */ var segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(17702);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var textColor = segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"].textColor */ .Z.textColor, selectedTitleOnlyParagraphFields = _object_without_properties(segments_desktop_core_components_title_only_paragraph_fields_config_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, [
    "textColor"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Title Only Paragraph",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, selectedTitleOnlyParagraphFields)
});


/***/ }),

/***/ 49643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41305);

var MultiProductsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].MultiProductsPricing */ .Z.MultiProductsPricing, FeaturesTablePricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FeaturesTablePricing */ .Z.FeaturesTablePricing, PricesAndFeaturesCardsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].PricesAndFeaturesCardsPricing */ .Z.PricesAndFeaturesCardsPricing, FrequentlyAskedQuestionsPricing = _layouts_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FrequentlyAskedQuestionsPricing */ .Z.FrequentlyAskedQuestionsPricing;
/* harmony default export */ __webpack_exports__["Z"] = ({
    // plop_marker:segment_index_add_layout
    MultiProductsPricingComponent: {
        type: "MultiProductsPricingComponent",
        title: "Multi Products Pricing",
        imgSrc: "/static/img/segments/layouts/multi-products-pricing.png",
        config: MultiProductsPricing.MultiProductsPricingConfig,
        advancedConfig: MultiProductsPricing.MultiProductsPricingAdvancedConfig,
        component: MultiProductsPricing.MultiProductsPricingComponent
    },
    FeaturesTablePricingComponent: {
        type: "FeaturesTablePricingComponent",
        title: "Features Table",
        imgSrc: "/static/img/segments/layouts/features-table-pricing.png",
        config: FeaturesTablePricing.FeaturesTablePricingConfig,
        advancedConfig: FeaturesTablePricing.FeaturesTablePricingAdvancedConfig,
        component: FeaturesTablePricing.FeaturesTablePricingComponent
    },
    PricesAndFeaturesCardsPricingComponent: {
        type: "PricesAndFeaturesCardsPricingComponent",
        title: "Prices And Features Cards",
        imgSrc: "/static/img/segments/layouts/prices-and-features-cards-pricing.png",
        config: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingConfig,
        advancedConfig: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingAdvancedConfig,
        component: PricesAndFeaturesCardsPricing.PricesAndFeaturesCardsPricingComponent
    },
    FrequentlyAskedQuestionsPricingComponent: {
        type: "FrequentlyAskedQuestionsPricingComponent",
        title: "Frequently Asked Questions",
        imgSrc: "/static/img/segments/layouts/frequently-asked-questions-pricing.png",
        config: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingConfig,
        advancedConfig: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingAdvancedConfig,
        component: FrequentlyAskedQuestionsPricing.FrequentlyAskedQuestionsPricingComponent
    }
});


/***/ }),

/***/ 80411:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ reviews; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, selectedFullParagraphFields = _object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "textColor"
]);
var review_cards_reviews_config_image = fields_config/* default.image */.Z.image;
/* harmony default export */ var review_cards_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Review Cards",
    fields: _object_spread_props(_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: selectedFullParagraphFields
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Cards",
            maxLimit: 4,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    image: review_cards_reviews_config_image,
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title"
                    },
                    subtitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Subtitle"
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/review-cards-reviews-advanced-config.js
function review_cards_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_cards_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_cards_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function review_cards_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function review_cards_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        review_cards_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var review_cards_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: review_cards_reviews_advanced_config_object_spread_props(review_cards_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z), {
        marginAboveCards: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above cards"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/review-cards-reviews/index.js



var ReviewCardsReviewsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9938).then(__webpack_require__.bind(__webpack_require__, 79938));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79938)
            ];
        }
    }
});
/* harmony default export */ var review_cards_reviews = ({
    ReviewCardsReviewsComponent: ReviewCardsReviewsComponent,
    ReviewCardsReviewsConfig: review_cards_reviews_config,
    ReviewCardsReviewsAdvancedConfig: review_cards_reviews_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/fields-config.js
var person_textual_info_fields_config = __webpack_require__(81828);
;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews-carousel/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var fields_config_image = fields_config/* default.image */.Z.image;
var color = person_textual_info_fields_config/* default.color */.Z.color, selectedTextualInfoFields = fields_config_object_without_properties(person_textual_info_fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var reviews_carousel_fields_config = ({
    autoplay: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Auto-play definitions",
        fields: {
            shouldAutoPlay: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Should auto-play reviews"
            },
            interval: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Interval (number of milliseconds)"
            }
        }
    },
    reviews: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Reviews",
        maxLimit: 15,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: fields_config_object_spread_props(fields_config_object_spread({
                quote: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Quote",
                    textArea: true,
                    translatable: true
                }
            }, selectedTextualInfoFields), {
                companyLogo: fields_config_object_spread_props(fields_config_object_spread({}, fields_config_image), {
                    label: "Company Logo"
                }),
                customerImage: fields_config_object_spread_props(fields_config_object_spread({}, fields_config_image), {
                    label: "Customer Image",
                    labelDescription: "Please select an image with 100x100 dimensions."
                })
            })
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-config.js
function paragraph_and_carousel_reviews_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_and_carousel_reviews_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_and_carousel_reviews_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = paragraph_and_carousel_reviews_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function paragraph_and_carousel_reviews_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var _TwoThirdsTextAndAssetConfig_fields = two_thirds_text_and_asset_config/* default.fields */.Z.fields, asset = _TwoThirdsTextAndAssetConfig_fields.asset, selectedTwoThirdsTextAndAssetConfig = paragraph_and_carousel_reviews_config_object_without_properties(_TwoThirdsTextAndAssetConfig_fields, [
    "asset"
]);
/* harmony default export */ var paragraph_and_carousel_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Paragraph And Carousel",
    fields: paragraph_and_carousel_reviews_config_object_spread_props(paragraph_and_carousel_reviews_config_object_spread({}, selectedTwoThirdsTextAndAssetConfig), {
        carousel: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Carousel",
            fields: paragraph_and_carousel_reviews_config_object_spread({}, reviews_carousel_fields_config)
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/paragraph-and-carousel-reviews-advanced-config.js
function paragraph_and_carousel_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function paragraph_and_carousel_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            paragraph_and_carousel_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function paragraph_and_carousel_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function paragraph_and_carousel_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        paragraph_and_carousel_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var paragraph_and_carousel_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: paragraph_and_carousel_reviews_advanced_config_object_spread_props(paragraph_and_carousel_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z), {
        removeQuoteSigns: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Remove carousel texts quote signs"
        },
        mobileMarginBetweenParagraphAndCarousel: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above carousel"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/paragraph-and-carousel-reviews/index.js



var ParagraphAndCarouselReviewsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6605).then(__webpack_require__.bind(__webpack_require__, 76605));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76605)
            ];
        }
    }
});
/* harmony default export */ var paragraph_and_carousel_reviews = ({
    ParagraphAndCarouselReviewsComponent: ParagraphAndCarouselReviewsComponent,
    ParagraphAndCarouselReviewsConfig: paragraph_and_carousel_reviews_config,
    ParagraphAndCarouselReviewsAdvancedConfig: paragraph_and_carousel_reviews_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/fields-config.js
function review_card_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function review_card_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            review_card_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function review_card_fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = review_card_fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function review_card_fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var fields_config_color = person_textual_info_fields_config/* default.color */.Z.color, fields_config_selectedTextualInfoFields = review_card_fields_config_object_without_properties(person_textual_info_fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var review_card_fields_config = (review_card_fields_config_object_spread({
    decorationColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Decoration Color"
    },
    title: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Title",
        textArea: true,
        translatable: true
    },
    showStars: {
        type: "boolean",
        label: "Show Stars"
    },
    starsCount: {
        type: template_field_type.FIELD_TYPES.COMBO,
        label: "How many stars",
        options: [
            "1",
            "2",
            "3",
            "4",
            "5"
        ]
    }
}, fields_config_selectedTextualInfoFields));

;// CONCATENATED MODULE: ./segments/desktop/core-components/reviews/fields-config.js


/* harmony default export */ var reviews_fields_config = ({
    reviews: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Reviews",
        maxLimit: 2,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: review_card_fields_config
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/regular-reviews-config.js


/* harmony default export */ var regular_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: reviews_fields_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/review-card/shared-advanced-fields-config.js

/* harmony default export */ var review_card_shared_advanced_fields_config = ({
    cardFontSize: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Card Font Size"
    },
    reviewCardOverrideHeight: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Review Card Height"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/regular-reviews-advanced-config.js
function regular_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var regular_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, review_card_shared_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/regular-reviews/index.js

var RegularReviewsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3395), __webpack_require__.e(3750)]).then(__webpack_require__.bind(__webpack_require__, 63750));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(63750)
            ];
        }
    }
});


/* harmony default export */ var regular_reviews = ({
    RegularReviewsComponent: RegularReviewsComponent,
    RegularReviewsConfig: regular_reviews_config,
    RegularReviewsAdvancedConfig: regular_reviews_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title-only-paragraph/fields-config.js
var title_only_paragraph_fields_config = __webpack_require__(17702);
;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/with-title-reviews-config.js
function with_title_reviews_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function with_title_reviews_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            with_title_reviews_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var with_title_reviews_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "With Title",
    fields: with_title_reviews_config_object_spread({
        titleOnlyParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title Only",
            fields: title_only_paragraph_fields_config/* default */.Z
        }
    }, reviews_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/with-title-reviews-advanced-config.js
function with_title_reviews_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function with_title_reviews_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            with_title_reviews_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function with_title_reviews_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function with_title_reviews_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        with_title_reviews_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var with_title_reviews_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: with_title_reviews_advanced_config_object_spread_props(with_title_reviews_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, review_card_shared_advanced_fields_config), {
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Override Minimum Height"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/with-title-reviews/index.js

var WithTitleReviewsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(3395), __webpack_require__.e(2660)]).then(__webpack_require__.bind(__webpack_require__, 12660));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(12660)
            ];
        }
    }
});


/* harmony default export */ var with_title_reviews = ({
    WithTitleReviewsComponent: WithTitleReviewsComponent,
    WithTitleReviewsConfig: with_title_reviews_config,
    WithTitleReviewsAdvancedConfig: with_title_reviews_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/layouts/index.js
// plop_marker:layouts_import




/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ReviewCardsReviews: review_cards_reviews,
    ParagraphAndCarouselReviews: paragraph_and_carousel_reviews,
    RegularReviews: regular_reviews,
    WithTitleReviews: with_title_reviews
});

;// CONCATENATED MODULE: ./segments/desktop/reviews/index.js

var ReviewCardsReviews = layouts.ReviewCardsReviews, ParagraphAndCarouselReviews = layouts.ParagraphAndCarouselReviews, RegularReviews = layouts.RegularReviews, WithTitleReviews = layouts.WithTitleReviews;
/* harmony default export */ var reviews = ({
    // plop_marker:segment_index_add_layout
    ReviewCardsReviewsComponent: {
        type: "ReviewCardsReviewsComponent",
        title: "Review Cards",
        imgSrc: "/static/img/segments/layouts/review-cards-reviews.png",
        config: ReviewCardsReviews.ReviewCardsReviewsConfig,
        advancedConfig: ReviewCardsReviews.ReviewCardsReviewsAdvancedConfig,
        component: ReviewCardsReviews.ReviewCardsReviewsComponent
    },
    ParagraphAndCarouselReviewsComponent: {
        type: "ParagraphAndCarouselReviewsComponent",
        title: "Paragraph And Carousel",
        imgSrc: "/static/img/segments/layouts/paragraph-and-carousel-reviews.png",
        config: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsConfig,
        advancedConfig: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsAdvancedConfig,
        component: ParagraphAndCarouselReviews.ParagraphAndCarouselReviewsComponent
    },
    RegularReviewsComponent: {
        type: "RegularReviewsComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-reviews.png",
        config: RegularReviews.RegularReviewsConfig,
        advancedConfig: RegularReviews.RegularReviewsAdvancedConfig,
        component: RegularReviews.RegularReviewsComponent
    },
    WithTitleReviewsComponent: {
        type: "WithTitleReviewsComponent",
        title: "With Title",
        imgSrc: "/static/img/segments/layouts/with-title-reviews.png",
        config: WithTitleReviews.WithTitleReviewsConfig,
        advancedConfig: WithTitleReviews.WithTitleReviewsAdvancedConfig,
        component: WithTitleReviews.WithTitleReviewsComponent
    }
});


/***/ }),

/***/ 71380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ security; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var logos_and_header_security_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Logos And Header",
    fields: _object_spread({}, fields_config/* default */.Z)
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/logos-and-header-security-advanced-config.js
function logos_and_header_security_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function logos_and_header_security_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            logos_and_header_security_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var logos_and_header_security_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: logos_and_header_security_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/security/layouts/logos-and-header-security/index.js

var LogosAndHeaderSecurityComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9502).then(__webpack_require__.bind(__webpack_require__, 49502));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49502)
            ];
        }
    }
});


/* harmony default export */ var logos_and_header_security = ({
    LogosAndHeaderSecurityComponent: LogosAndHeaderSecurityComponent,
    LogosAndHeaderSecurityConfig: logos_and_header_security_config,
    LogosAndHeaderSecurityAdvancedConfig: logos_and_header_security_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/security/layouts/index.js
// plop_marker:layouts_import

/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    LogosAndHeaderSecurity: logos_and_header_security
});

;// CONCATENATED MODULE: ./segments/desktop/security/index.js

var LogosAndHeaderSecurity = layouts.LogosAndHeaderSecurity;
/* harmony default export */ var security = ({
    // plop_marker:segment_index_add_layout
    LogosAndHeaderSecurityComponent: {
        type: "LogosAndHeaderSecurityComponent",
        title: "Logos And Header",
        imgSrc: "/static/img/segments/layouts/logos-and-header-security.png",
        config: LogosAndHeaderSecurity.LogosAndHeaderSecurityConfig,
        advancedConfig: LogosAndHeaderSecurity.LogosAndHeaderSecurityAdvancedConfig,
        component: LogosAndHeaderSecurity.LogosAndHeaderSecurityComponent
    }
});


/***/ }),

/***/ 73573:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ desktop_tabs; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/multi-cards-carousel-tabs/multi-cards-carousel-tabs-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


var cardFieldsConfig = {
    type: template_field_type.FIELD_TYPES.NESTED,
    fields: {
        isProductCard: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Is product card"
        },
        image: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Card image"
        },
        backImage: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Back image"
        },
        cardText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Card text"
        },
        backgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Background color"
        }
    }
};
/* harmony default export */ var multi_cards_carousel_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Multi Cards Carousel",
    fields: {
        carouselTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Title with arrows",
            fields: _object_spread_props(_object_spread({}, fields_config/* default */.Z), {
                marginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin bottom"
                },
                withArrows: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "With arrows"
                }
            })
        },
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Carousel Cards",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    firstRowCards: {
                        label: "First row cards",
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        maxLimit: 4,
                        nestedConfig: cardFieldsConfig
                    },
                    secondRowCards: {
                        label: "Second row cards",
                        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                        maxLimit: 4,
                        nestedConfig: cardFieldsConfig
                    }
                }
            }
        },
        wideCardImageWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Wide Card Image Width"
        },
        wideCardTextSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Wide Card Text Size"
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/multi-cards-carousel-tabs/multi-cards-carousel-tabs-advanced-config.js
function multi_cards_carousel_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_cards_carousel_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_cards_carousel_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var multi_cards_carousel_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: multi_cards_carousel_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/multi-cards-carousel-tabs/index.js

var MultiCardsCarouselTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9342), __webpack_require__.e(6713)]).then(__webpack_require__.bind(__webpack_require__, 96713));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(96713)
            ];
        }
    }
});


/* harmony default export */ var multi_cards_carousel_tabs = ({
    MultiCardsCarouselTabsComponent: MultiCardsCarouselTabsComponent,
    MultiCardsCarouselTabsConfig: multi_cards_carousel_tabs_config,
    MultiCardsCarouselTabsAdvancedConfig: multi_cards_carousel_tabs_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/testimonial/fields-config.js
var testimonial_fields_config = __webpack_require__(61543);
// EXTERNAL MODULE: ./segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-config.js
var full_paragraph_config = __webpack_require__(723);
// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/panorama-cards-carousel-tabs-config.js
function panorama_cards_carousel_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function panorama_cards_carousel_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            panorama_cards_carousel_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function panorama_cards_carousel_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function panorama_cards_carousel_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        panorama_cards_carousel_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var _FullParagraphConfig_fields = full_paragraph_config/* default.fields */.Z.fields, topic = _FullParagraphConfig_fields.topic, mobileTextAlign = _FullParagraphConfig_fields.mobileTextAlign, theme = _FullParagraphConfig_fields.theme, textAlign = _FullParagraphConfig_fields.textAlign, buttonConfig = _FullParagraphConfig_fields.buttonConfig, titleColor = _FullParagraphConfig_fields.titleColor, bodyColor = _FullParagraphConfig_fields.bodyColor, restOfParagraphConfig = _object_without_properties(_FullParagraphConfig_fields, [
    "topic",
    "mobileTextAlign",
    "theme",
    "textAlign",
    "buttonConfig",
    "titleColor",
    "bodyColor"
]);
var _TestimonialConfig_fields = testimonial_fields_config/* default.fields */.Z.fields, backgroundColor = _TestimonialConfig_fields.backgroundColor, restOfTestimonialConfig = _object_without_properties(_TestimonialConfig_fields, [
    "backgroundColor"
]);
/* harmony default export */ var panorama_cards_carousel_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel Tabs",
    fields: panorama_cards_carousel_tabs_config_object_spread_props(panorama_cards_carousel_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs Title",
            translatable: true
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            tabTitleImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Tab title image",
                                translatable: true
                            },
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Background asset",
                                fields: asset_fields_config/* default */.Z
                            },
                            testimonial: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Testimonial",
                                fields: panorama_cards_carousel_tabs_config_object_spread_props(panorama_cards_carousel_tabs_config_object_spread({}, restOfTestimonialConfig), {
                                    button: {
                                        type: template_field_type.FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            buttonText: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button text"
                                            },
                                            buttonUrl: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button url"
                                            }
                                        }
                                    }
                                })
                            },
                            stats: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Stats",
                                maxLimit: 4,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: restOfParagraphConfig
                                }
                            },
                            cardImageHeight: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Card image height"
                            }
                        }
                    }
                }
            }
        },
        autoplay: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Autoplay"
        },
        autoplaySpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Autoplay Speed"
        },
        inCardVersion: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "In card version - in test, don't use"
        }
    })
});

// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(25289);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/panorama-cards-carousel-tabs-advanced-config.js
function panorama_cards_carousel_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function panorama_cards_carousel_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            panorama_cards_carousel_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function panorama_cards_carousel_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function panorama_cards_carousel_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        panorama_cards_carousel_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function panorama_cards_carousel_tabs_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = panorama_cards_carousel_tabs_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function panorama_cards_carousel_tabs_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, withDynamicParagraphSubtitle = advanced_fields_config/* default.withDynamicParagraphSubtitle */.Z.withDynamicParagraphSubtitle, withDynamicParagraphTitle = advanced_fields_config/* default.withDynamicParagraphTitle */.Z.withDynamicParagraphTitle, gradientTheme = advanced_fields_config/* default.gradientTheme */.Z.gradientTheme, restOfAdvancedParagraphConfig = panorama_cards_carousel_tabs_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin",
    "withDynamicParagraphSubtitle",
    "withDynamicParagraphTitle",
    "gradientTheme"
]);
/* harmony default export */ var panorama_cards_carousel_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: panorama_cards_carousel_tabs_advanced_config_object_spread_props(panorama_cards_carousel_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        advancedAssetProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Advanced asset config",
            fields: advanced_field_config/* default */.Z
        },
        transitionSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Carousel slides transition speed (in milliseconds)"
        },
        tabAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab advanced config",
            fields: {
                advancedStatsConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fields: panorama_cards_carousel_tabs_advanced_config_object_spread({}, restOfAdvancedParagraphConfig),
                    label: "Advanced stats config"
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/panorama-cards-carousel-tabs/index.js

var PanoramaCardsCarouselTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8655).then(__webpack_require__.bind(__webpack_require__, 78655));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78655)
            ];
        }
    }
});


/* harmony default export */ var panorama_cards_carousel_tabs = ({
    PanoramaCardsCarouselTabsComponent: PanoramaCardsCarouselTabsComponent,
    PanoramaCardsCarouselTabsConfig: panorama_cards_carousel_tabs_config,
    PanoramaCardsCarouselTabsAdvancedConfig: panorama_cards_carousel_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-config.js
function carousel_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function carousel_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = carousel_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function carousel_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var carousel_tabs_config_FullParagraphConfig_fields = full_paragraph_config/* default.fields */.Z.fields, carousel_tabs_config_topic = carousel_tabs_config_FullParagraphConfig_fields.topic, carousel_tabs_config_mobileTextAlign = carousel_tabs_config_FullParagraphConfig_fields.mobileTextAlign, carousel_tabs_config_theme = carousel_tabs_config_FullParagraphConfig_fields.theme, carousel_tabs_config_textAlign = carousel_tabs_config_FullParagraphConfig_fields.textAlign, carousel_tabs_config_buttonConfig = carousel_tabs_config_FullParagraphConfig_fields.buttonConfig, carousel_tabs_config_restOfParagraphConfig = carousel_tabs_config_object_without_properties(carousel_tabs_config_FullParagraphConfig_fields, [
    "topic",
    "mobileTextAlign",
    "theme",
    "textAlign",
    "buttonConfig"
]);
/* harmony default export */ var carousel_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Carousel Tabs",
    fields: carousel_tabs_config_object_spread_props(carousel_tabs_config_object_spread({}, theme_config/* default */.Z), {
        containerGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs and carousel gap (default 32px)"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.GALLERY,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Background asset",
                                fields: asset_fields_config/* default */.Z
                            },
                            testimonial: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Testimonial",
                                fields: carousel_tabs_config_object_spread_props(carousel_tabs_config_object_spread({}, testimonial_fields_config/* default.fields */.Z.fields), {
                                    button: {
                                        type: template_field_type.FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            buttonText: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button text"
                                            },
                                            color: {
                                                type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                                label: "Button color"
                                            },
                                            buttonUrl: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Button url"
                                            }
                                        }
                                    }
                                })
                            },
                            stats: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Stats",
                                maxLimit: 4,
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: carousel_tabs_config_object_spread_props(carousel_tabs_config_object_spread({}, carousel_tabs_config_restOfParagraphConfig), {
                                        lineColor: {
                                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                                            label: "Line color"
                                        }
                                    })
                                }
                            }
                        }
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/core-configs/advanced-theme-config.js
var advanced_theme_config = __webpack_require__(42711);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/carousel-tabs-advanced-config.js
function carousel_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function carousel_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            carousel_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function carousel_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function carousel_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        carousel_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function carousel_tabs_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = carousel_tabs_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function carousel_tabs_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}





var carousel_tabs_advanced_config_topicBottomMargin = advanced_fields_config/* default.topicBottomMargin */.Z.topicBottomMargin, carousel_tabs_advanced_config_buttonTopMargin = advanced_fields_config/* default.buttonTopMargin */.Z.buttonTopMargin, carousel_tabs_advanced_config_withDynamicParagraphSubtitle = advanced_fields_config/* default.withDynamicParagraphSubtitle */.Z.withDynamicParagraphSubtitle, carousel_tabs_advanced_config_withDynamicParagraphTitle = advanced_fields_config/* default.withDynamicParagraphTitle */.Z.withDynamicParagraphTitle, carousel_tabs_advanced_config_restOfAdvancedParagraphConfig = carousel_tabs_advanced_config_object_without_properties(advanced_fields_config/* default */.Z, [
    "topicBottomMargin",
    "buttonTopMargin",
    "withDynamicParagraphSubtitle",
    "withDynamicParagraphTitle"
]);
/* harmony default export */ var carousel_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: carousel_tabs_advanced_config_object_spread_props(carousel_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_theme_config/* default */.Z), {
        advancedAssetProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Advanced asset config",
            fields: advanced_field_config/* default */.Z
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progressbar color"
        },
        tabLabelHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab label height (default 32px)"
        },
        transitionTime: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Transition time (ms) between slides - also set auto play"
        },
        tabContentGap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin between testimonial and stats (default 40px)"
        },
        autoPlayWhenVisible: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Auto play when visible (make sure visibility sensor config is on)"
        },
        tabAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tab advanced config",
            fields: {
                testimonialMaxWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Testimonial max width"
                },
                advancedStatsConfig: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    fields: carousel_tabs_advanced_config_object_spread_props(carousel_tabs_advanced_config_object_spread({}, carousel_tabs_advanced_config_restOfAdvancedParagraphConfig), {
                        lineMargin: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "Margin between line and stats"
                        }
                    }),
                    label: "Advanced stats config"
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/carousel-tabs/index.js

var CarouselTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 642).then(__webpack_require__.bind(__webpack_require__, 10642));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(10642)
            ];
        }
    }
});


/* harmony default export */ var carousel_tabs = ({
    CarouselTabsComponent: CarouselTabsComponent,
    CarouselTabsConfig: carousel_tabs_config,
    CarouselTabsAdvancedConfig: carousel_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/scrollable-tabs/fields-config.js


/* harmony default export */ var scrollable_tabs_fields_config = ({
    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
    label: "Use cases",
    nestedConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        fields: {
            label: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Case label"
            },
            iconAsset: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                label: "Case icon",
                defaultImagesKeys: []
            },
            asset: {
                type: template_field_type.FIELD_TYPES.NESTED,
                label: "Case asset",
                fields: asset_fields_config/* default */.Z
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-config.js
function usecases_gallery_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usecases_gallery_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usecases_gallery_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function usecases_gallery_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function usecases_gallery_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        usecases_gallery_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var usecases_gallery_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Usecases Gallery",
    fields: usecases_gallery_tabs_config_object_spread_props(usecases_gallery_tabs_config_object_spread({}, theme_config/* default */.Z), {
        withDividerLine: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "With divider line"
        },
        selectedIconBackground: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Selected icon background"
        },
        defaultSelectedTabLabel: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Default selected tab label"
        },
        usecases: scrollable_tabs_fields_config
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/usecases-gallery-tabs-advanced-config.js
function usecases_gallery_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function usecases_gallery_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            usecases_gallery_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var usecases_gallery_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: usecases_gallery_tabs_advanced_config_object_spread({
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        maxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Max width (px)"
        },
        tabWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab width (px)"
        },
        contentMarginTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Content margin top (px)"
        },
        tabContentMaxWidth: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tab content max width"
        },
        iconSize: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Icon size (px)"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/usecases-gallery-tabs/index.js



var UsecasesGalleryTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2617), __webpack_require__.e(3956)]).then(__webpack_require__.bind(__webpack_require__, 93956));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93956)
            ];
        }
    }
});
/* harmony default export */ var usecases_gallery_tabs = ({
    UsecasesGalleryTabsComponent: UsecasesGalleryTabsComponent,
    UsecasesGalleryTabsConfig: usecases_gallery_tabs_config,
    UsecasesGalleryTabsAdvancedConfig: usecases_gallery_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
;// CONCATENATED MODULE: ./segments/desktop/core-components/products-tabs/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function fields_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = fields_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function fields_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var fields_config_titleColor = fields_config/* default.titleColor */.Z.titleColor, restOfTitleConfig = fields_config_object_without_properties(fields_config/* default */.Z, [
    "titleColor"
]);
var fields_config_bodyColor = paragraph_fields_config/* default.bodyColor */.Z.bodyColor, fields_config_restOfParagraphConfig = fields_config_object_without_properties(paragraph_fields_config/* default */.Z, [
    "bodyColor"
]);
/* harmony default export */ var products_tabs_fields_config = ({
    tabsTitle: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Title",
        fields: fields_config/* default */.Z
    },
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                productType: {
                    type: template_field_type.FIELD_TYPES.PRODUCTS,
                    label: "Product type"
                },
                title: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Tab title",
                    fields: fields_config_object_spread_props(fields_config_object_spread({
                        productImage: {
                            type: template_field_type.FIELD_TYPES.GALLERY,
                            label: "Product logo image"
                        }
                    }, restOfTitleConfig, fields_config_restOfParagraphConfig), {
                        useCases: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Use cases",
                            nestedConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                fields: {
                                    useCase: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Use cases"
                                    }
                                }
                            }
                        },
                        useCasesColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Use Cases Color"
                        },
                        useCasesTextColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Use Cases Text Color",
                            possibleColors: [
                                color_consts.WHITE_COLOR_NAME,
                                color_consts.BRAND_BLACK_TEXT_COLOR
                            ]
                        }
                    })
                },
                content: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Product content",
                    fields: {
                        features: {
                            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                            label: "Features",
                            nestedConfig: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                fields: {
                                    feature: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Feature"
                                    }
                                }
                            }
                        },
                        ctaText: {
                            type: template_field_type.FIELD_TYPES.TEXT,
                            label: "CTA text"
                        },
                        featursBulltesColor: {
                            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
                            label: "Features Bulltes Color"
                        }
                    }
                }
            }
        }
    },
    tabTitleConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Tabs titles",
        fields: {
            textWidth: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Text max width"
            },
            titleWidth: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Title max width"
            },
            spaceFromParagraph: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Margin between title and text"
            }
        }
    },
    isV2: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Is V2"
    },
    largerTags: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Larger Tags"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/side-by-side-product-switcher-with-product-tabs-config.js
function side_by_side_product_switcher_with_product_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_product_switcher_with_product_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_product_switcher_with_product_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_product_switcher_with_product_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_product_switcher_with_product_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_product_switcher_with_product_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_product_switcher_with_product_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var tabs = products_tabs_fields_config.tabs, ProductTabsRestOfProps = side_by_side_product_switcher_with_product_tabs_config_object_without_properties(products_tabs_fields_config, [
    "tabs"
]);
var side_by_side_product_switcher_with_product_tabs_config_bodyColor = full_paragraph_fields_config/* default.bodyColor */.Z.bodyColor, side_by_side_product_switcher_with_product_tabs_config_titleColor = full_paragraph_fields_config/* default.titleColor */.Z.titleColor, textColor = full_paragraph_fields_config/* default.textColor */.Z.textColor, side_by_side_product_switcher_with_product_tabs_config_topic = full_paragraph_fields_config/* default.topic */.Z.topic, side_by_side_product_switcher_with_product_tabs_config_mobileTextAlign = full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign, side_by_side_product_switcher_with_product_tabs_config_textAlign = full_paragraph_fields_config/* default.textAlign */.Z.textAlign, side_by_side_product_switcher_with_product_tabs_config_buttonConfig = full_paragraph_fields_config/* default.buttonConfig */.Z.buttonConfig, side_by_side_product_switcher_with_product_tabs_config_restOfParagraphConfig = side_by_side_product_switcher_with_product_tabs_config_object_without_properties(full_paragraph_fields_config/* default */.Z, [
    "bodyColor",
    "titleColor",
    "textColor",
    "topic",
    "mobileTextAlign",
    "textAlign",
    "buttonConfig"
]);
/* harmony default export */ var side_by_side_product_switcher_with_product_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Product Switcher With Product",
    fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({}, theme_config/* default */.Z), {
        reverseOrder: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Reverse side by side order"
        },
        productTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product tabs",
            fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({}, ProductTabsRestOfProps), {
                tabs: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Tabs",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({
                            productType: {
                                type: template_field_type.FIELD_TYPES.PRODUCTS,
                                label: "Product type"
                            }
                        }, tabs.nestedConfig.fields), {
                            fullParagraph: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Full paragraph",
                                fields: side_by_side_product_switcher_with_product_tabs_config_object_spread_props(side_by_side_product_switcher_with_product_tabs_config_object_spread({
                                    marginTop: {
                                        type: template_field_type.FIELD_TYPES.TEXT,
                                        label: "Margin top"
                                    }
                                }, side_by_side_product_switcher_with_product_tabs_config_restOfParagraphConfig), {
                                    buttonConfig: {
                                        type: template_field_type.FIELD_TYPES.NESTED,
                                        label: "Button",
                                        fields: {
                                            additionalText: {
                                                type: template_field_type.FIELD_TYPES.TEXT,
                                                label: "Additional text (monday markup supported)"
                                            }
                                        }
                                    }
                                })
                            }
                        })
                    }
                }
            })
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/side-by-side-product-switcher-with-product-tabs-advanced-config.js
function side_by_side_product_switcher_with_product_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_product_switcher_with_product_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_product_switcher_with_product_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_product_switcher_with_product_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_product_switcher_with_product_tabs_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min height"
        },
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-product-switcher-with-product-tabs/index.js

var SideBySideProductSwitcherWithProductTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1285), __webpack_require__.e(7458)]).then(__webpack_require__.bind(__webpack_require__, 27458));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(27458)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_product_switcher_with_product_tabs = ({
    SideBySideProductSwitcherWithProductTabsComponent: SideBySideProductSwitcherWithProductTabsComponent,
    SideBySideProductSwitcherWithProductTabsConfig: side_by_side_product_switcher_with_product_tabs_config,
    SideBySideProductSwitcherWithProductTabsAdvancedConfig: side_by_side_product_switcher_with_product_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-config.js
function products_horizontal_timer_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _object_destructuring_empty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function products_horizontal_timer_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_horizontal_timer_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function products_horizontal_timer_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function products_horizontal_timer_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        products_horizontal_timer_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var products_horizontal_timer_tabs_config_restOfTitleConfig = _extends({}, _object_destructuring_empty(fields_config/* default */.Z));
var products_horizontal_timer_tabs_config_restOfParagraphConfig = _extends({}, _object_destructuring_empty(paragraph_fields_config/* default */.Z));
/* harmony default export */ var products_horizontal_timer_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Horizontal Timer",
    fields: products_horizontal_timer_tabs_config_object_spread_props(products_horizontal_timer_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Tabs Title",
            fields: {
                titleText: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title"
                },
                titleMarginBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title margin bottom"
                }
            }
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    productType: {
                        type: template_field_type.FIELD_TYPES.PRODUCTS,
                        label: "Product type"
                    },
                    title: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab title",
                        fields: products_horizontal_timer_tabs_config_object_spread({
                            productImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Product logo image"
                            },
                            selectedProductImage: {
                                type: template_field_type.FIELD_TYPES.GALLERY,
                                label: "Selected product logo image"
                            }
                        }, products_horizontal_timer_tabs_config_restOfTitleConfig, products_horizontal_timer_tabs_config_restOfParagraphConfig)
                    },
                    tabContent: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab content",
                        fields: {
                            productTags: {
                                type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                                label: "Product tags",
                                nestedConfig: {
                                    type: template_field_type.FIELD_TYPES.NESTED,
                                    fields: {
                                        text: {
                                            type: template_field_type.FIELD_TYPES.TEXT,
                                            label: "Tag"
                                        }
                                    }
                                }
                            },
                            asset: {
                                type: template_field_type.FIELD_TYPES.NESTED,
                                label: "Asset",
                                fields: asset_fields_config/* default */.Z
                            }
                        }
                    }
                }
            }
        },
        progressbarColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Progress Bar Color"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/two-thirds-text-and-products-horizontal-tabs-config.js
function two_thirds_text_and_products_horizontal_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_products_horizontal_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_products_horizontal_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_products_horizontal_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_products_horizontal_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_products_horizontal_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Two Thirds Text And Products Horizontal",
    fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread_props(two_thirds_text_and_products_horizontal_tabs_config_object_spread({}, theme_config/* default */.Z), {
        gap: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Gap"
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, full_paragraph_fields_config/* default */.Z)
        },
        productsTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Products Tabs",
            fields: two_thirds_text_and_products_horizontal_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, products_horizontal_timer_tabs_config.fields)
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/two-thirds-text-and-products-horizontal-tabs-advanced-config.js
function two_thirds_text_and_products_horizontal_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_products_horizontal_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_products_horizontal_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread_props(two_thirds_text_and_products_horizontal_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/two-thirds-text-and-products-horizontal-tabs/index.js

var TwoThirdsTextAndProductsHorizontalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(2948), __webpack_require__.e(5424)]).then(__webpack_require__.bind(__webpack_require__, 45424));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(45424)
            ];
        }
    }
});


/* harmony default export */ var two_thirds_text_and_products_horizontal_tabs = ({
    TwoThirdsTextAndProductsHorizontalTabsComponent: TwoThirdsTextAndProductsHorizontalTabsComponent,
    TwoThirdsTextAndProductsHorizontalTabsConfig: two_thirds_text_and_products_horizontal_tabs_config,
    TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig: two_thirds_text_and_products_horizontal_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/products-horizontal-timer-tabs-advanced-config.js
function products_horizontal_timer_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function products_horizontal_timer_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            products_horizontal_timer_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var products_horizontal_timer_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: products_horizontal_timer_tabs_advanced_config_object_spread({
        timerEnabled: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Timer Enabled"
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/products-horizontal-timer-tabs/index.js

var ProductsHorizontalTimerTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(2948)]).then(__webpack_require__.bind(__webpack_require__, 32948));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32948)
            ];
        }
    }
});


/* harmony default export */ var products_horizontal_timer_tabs = ({
    ProductsHorizontalTimerTabsComponent: ProductsHorizontalTimerTabsComponent,
    ProductsHorizontalTimerTabsConfig: products_horizontal_timer_tabs_config,
    ProductsHorizontalTimerTabsAdvancedConfig: products_horizontal_timer_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/side-by-side-paragraph-and-products-tabs-config.js
function side_by_side_paragraph_and_products_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_products_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_products_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_paragraph_and_products_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_paragraph_and_products_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_paragraph_and_products_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var side_by_side_paragraph_and_products_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Paragraph And Products",
    fields: side_by_side_paragraph_and_products_tabs_config_object_spread_props(side_by_side_paragraph_and_products_tabs_config_object_spread({}, theme_config/* default */.Z), {
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full paragraph",
            fields: side_by_side_paragraph_and_products_tabs_config_object_spread({
                marginTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Margin top"
                }
            }, full_paragraph_fields_config/* default */.Z)
        },
        productTabs: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Product tabs",
            fields: products_tabs_fields_config
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/side-by-side-paragraph-and-products-tabs-advanced-config.js
function side_by_side_paragraph_and_products_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_paragraph_and_products_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_paragraph_and_products_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_paragraph_and_products_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_paragraph_and_products_tabs_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min height"
        },
        paragraphAdvancedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph Advanced Config",
            fields: advanced_fields_config/* default */.Z
        }
    }, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-paragraph-and-products-tabs/index.js

var SideBySideParagraphAndProductsTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1285), __webpack_require__.e(2175)]).then(__webpack_require__.bind(__webpack_require__, 62175));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(62175)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_paragraph_and_products_tabs = ({
    SideBySideParagraphAndProductsTabsComponent: SideBySideParagraphAndProductsTabsComponent,
    SideBySideParagraphAndProductsTabsConfig: side_by_side_paragraph_and_products_tabs_config,
    SideBySideParagraphAndProductsTabsAdvancedConfig: side_by_side_paragraph_and_products_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/timeline-titled-tab-tabs/index.js + 2 modules
var timeline_titled_tab_tabs = __webpack_require__(39750);
// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-process-tabs/index.js + 3 modules
var side_by_side_tabs_and_process_tabs = __webpack_require__(16434);
// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/side-by-side-tabs-and-testimonial-tabs/index.js + 2 modules
var side_by_side_tabs_and_testimonial_tabs = __webpack_require__(30788);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-config.js + 1 modules
var tag_items_grid_config = __webpack_require__(48127);
// EXTERNAL MODULE: ./segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-config.js
var flexible_cards_grid_config = __webpack_require__(73767);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-config.js
function personas_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function personas_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            personas_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function personas_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function personas_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        personas_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






/* harmony default export */ var personas_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Personas",
    fields: personas_tabs_config_object_spread_props(personas_tabs_config_object_spread({}, theme_config/* default */.Z), {
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        tabsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs background color"
        },
        alignToLogo: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to logo (New)"
        },
        swapTagsWithTextAndAssets: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Swap Tags with Text and Asset  (Temporary for test)"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 6,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    timer: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Timer Length (in milliseconds)"
                    },
                    textAndAssetTwoThirds: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: personas_tabs_config_object_spread({
                            textAndAssetPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, two_thirds_text_and_asset_config/* default.fields */.Z.fields)
                    },
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: personas_tabs_config_object_spread({
                            fullParagraphPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, full_paragraph_config/* default.fields */.Z.fields)
                    },
                    tagItems: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: personas_tabs_config_object_spread({
                            tagItemsPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            }
                        }, tag_items_grid_config/* default.fields */.Z.fields)
                    },
                    flexibleCards: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: personas_tabs_config_object_spread({
                            flexibleCardsPaddingTop: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding top"
                            },
                            imagePaddingBottom: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Padding Bottom (under the image)"
                            }
                        }, flexible_cards_grid_config/* default.fields */.Z.fields)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-advanced-config.js
function regular_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/* harmony default export */ var regular_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: regular_tabs_advanced_config_object_spread_props(regular_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        autoTransition: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Auto Transition (milliseconds)"
        },
        scrollOnTabClick: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Should scroll to content on tab click"
        },
        scrollSpeed: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Scroll speed on tab click"
        },
        distanceFromTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Distance to stop when scrolling (fixed header height)"
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-advanced-config.js
var tag_items_grid_advanced_config = __webpack_require__(14061);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var side_by_side_text_and_asset_advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/personas-tabs-advanced-config.js
function personas_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function personas_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            personas_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function personas_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function personas_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        personas_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var width = tag_items_grid_advanced_config/* default.fields.width */.Z.fields.width;
/* harmony default export */ var personas_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: personas_tabs_advanced_config_object_spread_props(personas_tabs_advanced_config_object_spread({}, regular_tabs_advanced_config.fields), {
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    textAndAssetTwoThirds: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z, advanced_field_config/* default */.Z, side_by_side_text_and_asset_advanced_field_config/* default */.Z)
                    },
                    fullParagraph: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Full Paragraph",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
                    },
                    tagItems: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tag Items",
                        fields: {
                            width: width
                        }
                    },
                    flexibleCards: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Flexible Cards",
                        fields: personas_tabs_advanced_config_object_spread({}, advanced_fields_config/* default */.Z)
                    }
                }
            }
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/personas-tabs/index.js



var PersonasTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 8663).then(__webpack_require__.bind(__webpack_require__, 88663));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88663)
            ];
        }
    }
});
/* harmony default export */ var personas_tabs = ({
    PersonasTabsComponent: PersonasTabsComponent,
    PersonasTabsConfig: personas_tabs_config,
    PersonasTabsAdvancedConfig: personas_tabs_advanced_config
});

// EXTERNAL MODULE: ./components/templates-generator/config/components/asset/asset-config.js
var asset_config = __webpack_require__(81338);
;// CONCATENATED MODULE: ./segments/desktop/core-components/board-views-tab/fields-config.js
function board_views_tab_fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_views_tab_fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_views_tab_fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function board_views_tab_fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function board_views_tab_fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        board_views_tab_fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var fields_config_image = asset_config/* asset.fields.image */.p.fields.image;
/* harmony default export */ var board_views_tab_fields_config = (board_views_tab_fields_config_object_spread_props(board_views_tab_fields_config_object_spread({}, theme_config/* default */.Z), {
    tabs: {
        type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
        label: "Tabs",
        maxLimit: 5,
        nestedConfig: {
            type: template_field_type.FIELD_TYPES.NESTED,
            fields: {
                image: board_views_tab_fields_config_object_spread_props(board_views_tab_fields_config_object_spread({}, fields_config_image), {
                    label: "Icon Image"
                }),
                tabLabel: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Label",
                    translatable: true
                },
                tabId: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Tab Id"
                },
                asset: {
                    type: template_field_type.FIELD_TYPES.NESTED,
                    label: "Asset",
                    fields: asset_fields_config/* default */.Z
                }
            }
        }
    }
}));

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-config.js
function side_by_side_board_views_component_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var side_by_side_board_views_component_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side Board Views Component",
    fields: side_by_side_board_views_component_tabs_config_object_spread({
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Full Paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        }
    }, board_views_tab_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/side-by-side-board-views-component-tabs-advanced-config.js
function side_by_side_board_views_component_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_board_views_component_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_board_views_component_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var side_by_side_board_views_component_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_board_views_component_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/side-by-side-board-views-component-tabs/index.js



var SideBySideBoardViewsComponentTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1652).then(__webpack_require__.bind(__webpack_require__, 11652));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11652)
            ];
        }
    }
});
/* harmony default export */ var side_by_side_board_views_component_tabs = ({
    SideBySideBoardViewsComponentTabsComponent: SideBySideBoardViewsComponentTabsComponent,
    SideBySideBoardViewsComponentTabsConfig: side_by_side_board_views_component_tabs_config,
    SideBySideBoardViewsComponentTabsAdvancedConfig: side_by_side_board_views_component_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/tabs/layouts/use-cases-tabs/index.js + 2 modules
var use_cases_tabs = __webpack_require__(94087);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/fields-config.js + 7 modules
var button_fields_config = __webpack_require__(59440);
// EXTERNAL MODULE: ./segments/segments-service.js
var segments_service = __webpack_require__(861);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-config.js
function monday_demo_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function monday_demo_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function monday_demo_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        monday_demo_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function monday_demo_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = monday_demo_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function monday_demo_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var video = asset_fields_config/* default.video */.Z.video;
var fields = video.fields;
var loop = fields.loop, playWhenVisible = fields.playWhenVisible, restVideoFields = monday_demo_tabs_config_object_without_properties(fields, [
    "loop",
    "playWhenVisible"
]);
/* harmony default export */ var monday_demo_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Monday Demo",
    fields: {
        theme: monday_demo_tabs_config_object_spread({}, theme_config/* default.theme */.Z.theme),
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Paragraph",
            fields: full_paragraph_fields_config/* default */.Z
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: {
                            video: monday_demo_tabs_config_object_spread_props(monday_demo_tabs_config_object_spread({}, video), {
                                fields: monday_demo_tabs_config_object_spread({}, restVideoFields)
                            })
                        }
                    }
                }
            }
        },
        buttonConfig: button_fields_config/* default */.Z
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/monday-demo-tabs-advanced-config.js
function monday_demo_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function monday_demo_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            monday_demo_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var monday_demo_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: monday_demo_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/monday-demo-tabs/index.js



var MondayDemoTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 968).then(__webpack_require__.bind(__webpack_require__, 20968));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20968)
            ];
        }
    }
});
/* harmony default export */ var monday_demo_tabs = ({
    MondayDemoTabsComponent: MondayDemoTabsComponent,
    MondayDemoTabsConfig: monday_demo_tabs_config,
    MondayDemoTabsAdvancedConfig: monday_demo_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-config.js
function building_blocks_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function building_blocks_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function building_blocks_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        building_blocks_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function building_blocks_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = building_blocks_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function building_blocks_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields = two_thirds_text_and_asset_config/* default.fields.fullParagraph.fields */.Z.fields.fullParagraph.fields, building_blocks_tabs_config_titleColor = _TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields.titleColor, fullParagraphFields = building_blocks_tabs_config_object_without_properties(_TwoThirdsTextAndAssetConfig_fields_fullParagraph_fields, [
    "titleColor"
]); // title color is controlled from theme
var textAndAssetFields = building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields */.Z.fields), {
    asset: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.asset */.Z.fields.asset), {
        fields: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.asset.fields */.Z.fields.asset.fields), {
            useWindowMask: {
                type: template_field_type.FIELD_TYPES.BOOLEAN,
                label: "Use window mask"
            }
        })
    }),
    fullParagraph: building_blocks_tabs_config_object_spread_props(building_blocks_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields.fullParagraph */.Z.fields.fullParagraph), {
        fields: building_blocks_tabs_config_object_spread({}, fullParagraphFields)
    })
});
/* harmony default export */ var building_blocks_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Building Blocks",
    fields: {
        buildingBlocksTabsTheme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    // Should be added after cloudinary-service.js is refactored
                    // tabIcon: {
                    //   type: FIELD_TYPES.GALLERY,
                    //   defaultImagesKeys: [],
                    //   label: "Select an Icon"
                    // },
                    textAndAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: textAndAssetFields
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/building-blocks-tabs-advanced-config.js
function building_blocks_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function building_blocks_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            building_blocks_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var building_blocks_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: building_blocks_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/building-blocks-tabs/index.js



var BuildingBlocksTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(2617), __webpack_require__.e(349)]).then(__webpack_require__.bind(__webpack_require__, 40349));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(40349)
            ];
        }
    }
});
/* harmony default export */ var building_blocks_tabs = ({
    BuildingBlocksTabsComponent: BuildingBlocksTabsComponent,
    BuildingBlocksTabsConfig: building_blocks_tabs_config,
    BuildingBlocksTabsAdvancedConfig: building_blocks_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/board-tabs/fields-config.js
var board_tabs_fields_config = __webpack_require__(55209);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/board-tabs-config.js
function board_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var board_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Board",
    fields: board_tabs_config_object_spread({}, board_tabs_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/board-tabs-advanced-config.js
function board_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var board_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: board_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/board-tabs/index.js



var BoardTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6661).then(__webpack_require__.bind(__webpack_require__, 76661));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76661)
            ];
        }
    }
});
/* harmony default export */ var board_tabs = ({
    BoardTabsComponent: BoardTabsComponent,
    BoardTabsConfig: board_tabs_config,
    BoardTabsAdvancedConfig: board_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-tabs/fields-config.js
var vertical_tabs_fields_config = __webpack_require__(92607);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-config.js
function timeline_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timeline_tabs_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = timeline_tabs_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function timeline_tabs_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}


var timeline_tabs_config_backgroundColor = vertical_tabs_fields_config/* default.backgroundColor */.Z.backgroundColor, timeline_tabs_config_theme = vertical_tabs_fields_config/* default.theme */.Z.theme, tabsColor = vertical_tabs_fields_config/* default.tabsColor */.Z.tabsColor, resconfig = timeline_tabs_config_object_without_properties(vertical_tabs_fields_config/* default */.Z, [
    "backgroundColor",
    "theme",
    "tabsColor"
]);
/* harmony default export */ var timeline_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timeline",
    fields: timeline_tabs_config_object_spread({
        theme: timeline_tabs_config_theme,
        tabsColor: tabsColor,
        lineColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Menu line Color"
        }
    }, resconfig)
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/vertical-tabs/advanced-fields-config.js

/* harmony default export */ var vertical_tabs_advanced_fields_config = ({
    autoTransition: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Auto Transition (milliseconds)"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/timeline-tabs-advanced-config.js
function timeline_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timeline_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timeline_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var timeline_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timeline_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, vertical_tabs_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timeline-tabs/index.js



var TimelineTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4837), __webpack_require__.e(1534)]).then(__webpack_require__.bind(__webpack_require__, 21534));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(21534)
            ];
        }
    }
});
/* harmony default export */ var timeline_tabs = ({
    TimelineTabsComponent: TimelineTabsComponent,
    TimelineTabsConfig: timeline_tabs_config,
    TimelineTabsAdvancedConfig: timeline_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-config.js
var vertical_timer_tabs_fields_config = __webpack_require__(32983);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-config.js
function colored_timer_vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function colored_timer_vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            colored_timer_vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function colored_timer_vertical_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function colored_timer_vertical_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        colored_timer_vertical_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var colored_timer_vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Colored Timer Vertical",
    fields: colored_timer_vertical_tabs_config_object_spread_props(colored_timer_vertical_tabs_config_object_spread({}, vertical_timer_tabs_fields_config/* default */.Z), {
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 5,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Title",
                        translatable: true
                    },
                    content: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Tab Full Paragraph",
                        fields: full_paragraph_fields_config/* default */.Z
                    },
                    timer: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Timer Length (in milliseconds)"
                    },
                    badgeText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Badge text (if needed)",
                        translatable: true
                    },
                    asset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Asset",
                        fields: asset_fields_config/* default */.Z
                    }
                }
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/vertical-timer-tabs/fields-advanced-config.js
var fields_advanced_config = __webpack_require__(74790);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/colored-timer-vertical-tabs-advanced-config.js
function colored_timer_vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function colored_timer_vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            colored_timer_vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var colored_timer_vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: colored_timer_vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, fields_advanced_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/colored-timer-vertical-tabs/index.js



var ColoredTimerVerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(1365)]).then(__webpack_require__.bind(__webpack_require__, 71365));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71365)
            ];
        }
    }
});
/* harmony default export */ var colored_timer_vertical_tabs = ({
    ColoredTimerVerticalTabsComponent: ColoredTimerVerticalTabsComponent,
    ColoredTimerVerticalTabsConfig: colored_timer_vertical_tabs_config,
    ColoredTimerVerticalTabsAdvancedConfig: colored_timer_vertical_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-config.js
function timer_vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var timer_vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Timer Vertical",
    fields: timer_vertical_tabs_config_object_spread({}, vertical_timer_tabs_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/timer-vertical-tabs-advanced-config.js
function timer_vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function timer_vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            timer_vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function timer_vertical_tabs_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function timer_vertical_tabs_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        timer_vertical_tabs_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var timer_vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: timer_vertical_tabs_advanced_config_object_spread_props(timer_vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, fields_advanced_config/* default */.Z), {
        isAlignedToCenter: {
            type: template_field_type.FIELD_TYPES.BOOLEAN,
            label: "Align to center"
        },
        tabsSpace: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Tabs space"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/timer-vertical-tabs/index.js



var TimerVerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4069), __webpack_require__.e(4864), __webpack_require__.e(9918)]).then(__webpack_require__.bind(__webpack_require__, 99918));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(99918)
            ];
        }
    }
});
/* harmony default export */ var timer_vertical_tabs = ({
    TimerVerticalTabsComponent: TimerVerticalTabsComponent,
    TimerVerticalTabsConfig: timer_vertical_tabs_config,
    TimerVerticalTabsAdvancedConfig: timer_vertical_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-config.js
function vertical_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var vertical_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Vertical",
    fields: vertical_tabs_config_object_spread({}, vertical_tabs_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/vertical-tabs-advanced-config.js
function vertical_tabs_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function vertical_tabs_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            vertical_tabs_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var vertical_tabs_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: vertical_tabs_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, vertical_tabs_advanced_fields_config)
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/vertical-tabs/index.js



var VerticalTabsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(4837), __webpack_require__.e(4316)]).then(__webpack_require__.bind(__webpack_require__, 94316));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94316)
            ];
        }
    }
});
/* harmony default export */ var vertical_tabs = ({
    VerticalTabsComponent: VerticalTabsComponent,
    VerticalTabsConfig: vertical_tabs_config,
    VerticalTabsAdvancedConfig: vertical_tabs_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/fields-config.js
var bullets_fields_config = __webpack_require__(61204);
;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/regular-tabs-config.js
function regular_tabs_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function regular_tabs_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            regular_tabs_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function regular_tabs_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function regular_tabs_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        regular_tabs_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var regular_tabs_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Regular",
    fields: {
        theme: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Theme"
        },
        tabsBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs background color"
        },
        tabsColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Tabs color"
        },
        tabs: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tabs",
            maxLimit: 8,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    tabLabel: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Label",
                        translatable: true
                    },
                    tabId: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Tab Id"
                    },
                    textAndAsset: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        label: "Text and asset",
                        fields: regular_tabs_config_object_spread_props(regular_tabs_config_object_spread({}, two_thirds_text_and_asset_config/* default.fields */.Z.fields), {
                            bulletsConfig: bullets_fields_config/* default */.Z
                        })
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/regular-tabs/index.js

var RegularTabsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2776).then(__webpack_require__.bind(__webpack_require__, 52776));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52776)
            ];
        }
    }
});


/* harmony default export */ var regular_tabs = ({
    RegularTabsComponent: RegularTabsComponent,
    RegularTabsConfig: regular_tabs_config,
    RegularTabsAdvancedConfig: regular_tabs_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/layouts/index.js
// plop_marker:layouts_import






















/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    MultiCardsCarouselTabs: multi_cards_carousel_tabs,
    PanoramaCardsCarouselTabs: panorama_cards_carousel_tabs,
    CarouselTabs: carousel_tabs,
    UsecasesGalleryTabs: usecases_gallery_tabs,
    SideBySideProductSwitcherWithProductTabs: side_by_side_product_switcher_with_product_tabs,
    TwoThirdsTextAndProductsHorizontalTabs: two_thirds_text_and_products_horizontal_tabs,
    ProductsHorizontalTimerTabs: products_horizontal_timer_tabs,
    SideBySideParagraphAndProductsTabs: side_by_side_paragraph_and_products_tabs,
    TimelineTitledTabTabs: timeline_titled_tab_tabs/* default */.Z,
    SideBySideTabsAndProcessTabs: side_by_side_tabs_and_process_tabs/* default */.Z,
    SideBySideTabsAndTestimonialTabs: side_by_side_tabs_and_testimonial_tabs/* default */.Z,
    PersonasTabs: personas_tabs,
    SideBySideBoardViewsComponentTabs: side_by_side_board_views_component_tabs,
    UseCasesTabs: use_cases_tabs/* default */.Z,
    MondayDemoTabs: monday_demo_tabs,
    BuildingBlocksTabs: building_blocks_tabs,
    BoardTabs: board_tabs,
    TimelineTabs: timeline_tabs,
    ColoredTimerVerticalTabs: colored_timer_vertical_tabs,
    TimerVerticalTabs: timer_vertical_tabs,
    VerticalTabs: vertical_tabs,
    RegularTabs: regular_tabs
});

;// CONCATENATED MODULE: ./segments/desktop/tabs/index.js

var MultiCardsCarouselTabs = layouts.MultiCardsCarouselTabs, PanoramaCardsCarouselTabs = layouts.PanoramaCardsCarouselTabs, CarouselTabs = layouts.CarouselTabs, UsecasesGalleryTabs = layouts.UsecasesGalleryTabs, SideBySideProductSwitcherWithProductTabs = layouts.SideBySideProductSwitcherWithProductTabs, TwoThirdsTextAndProductsHorizontalTabs = layouts.TwoThirdsTextAndProductsHorizontalTabs, ProductsHorizontalTimerTabs = layouts.ProductsHorizontalTimerTabs, SideBySideParagraphAndProductsTabs = layouts.SideBySideParagraphAndProductsTabs, TimelineTitledTabTabs = layouts.TimelineTitledTabTabs, SideBySideTabsAndProcessTabs = layouts.SideBySideTabsAndProcessTabs, SideBySideTabsAndTestimonialTabs = layouts.SideBySideTabsAndTestimonialTabs, PersonasTabs = layouts.PersonasTabs, SideBySideBoardViewsComponentTabs = layouts.SideBySideBoardViewsComponentTabs, UseCasesTabs = layouts.UseCasesTabs, MondayDemoTabs = layouts.MondayDemoTabs, BuildingBlocksTabs = layouts.BuildingBlocksTabs, BoardTabs = layouts.BoardTabs, TimelineTabs = layouts.TimelineTabs, ColoredTimerVerticalTabs = layouts.ColoredTimerVerticalTabs, TimerVerticalTabs = layouts.TimerVerticalTabs, VerticalTabs = layouts.VerticalTabs, RegularTabs = layouts.RegularTabs;
/* harmony default export */ var desktop_tabs = ({
    // plop_marker:segment_index_add_layout
    MultiCardsCarouselTabsComponent: {
        type: "MultiCardsCarouselTabsComponent",
        title: "Multi Cards Carousel",
        imgSrc: "/static/img/segments/layouts/multi-cards-carousel-tabs.png",
        config: MultiCardsCarouselTabs.MultiCardsCarouselTabsConfig,
        advancedConfig: MultiCardsCarouselTabs.MultiCardsCarouselTabsAdvancedConfig,
        component: MultiCardsCarouselTabs.MultiCardsCarouselTabsComponent
    },
    PanoramaCardsCarouselTabsComponent: {
        type: "PanoramaCardsCarouselTabsComponent",
        title: "Panorama Cards Carousel",
        imgSrc: "/static/img/segments/layouts/panorama-cards-carousel-tabs.png",
        config: PanoramaCardsCarouselTabs.PanoramaCardsCarouselTabsConfig,
        advancedConfig: PanoramaCardsCarouselTabs.PanoramaCardsCarouselTabsAdvancedConfig,
        component: PanoramaCardsCarouselTabs.PanoramaCardsCarouselTabsComponent
    },
    CarouselTabsComponent: {
        type: "CarouselTabsComponent",
        title: "Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-tabs.png",
        config: CarouselTabs.CarouselTabsConfig,
        advancedConfig: CarouselTabs.CarouselTabsAdvancedConfig,
        component: CarouselTabs.CarouselTabsComponent
    },
    UsecasesGalleryTabsComponent: {
        type: "UsecasesGalleryTabsComponent",
        title: "Usecases Gallery",
        imgSrc: "/static/img/segments/layouts/usecases-gallery-tabs.png",
        config: UsecasesGalleryTabs.UsecasesGalleryTabsConfig,
        advancedConfig: UsecasesGalleryTabs.UsecasesGalleryTabsAdvancedConfig,
        component: UsecasesGalleryTabs.UsecasesGalleryTabsComponent
    },
    SideBySideProductSwitcherWithProductTabsComponent: {
        type: "SideBySideProductSwitcherWithProductTabsComponent",
        title: "Side By Side Product Switcher With Product",
        imgSrc: "/static/img/segments/layouts/side-by-side-product-switcher-with-product-tabs.png",
        config: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsConfig,
        advancedConfig: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsAdvancedConfig,
        component: SideBySideProductSwitcherWithProductTabs.SideBySideProductSwitcherWithProductTabsComponent
    },
    TwoThirdsTextAndProductsHorizontalTabsComponent: {
        type: "TwoThirdsTextAndProductsHorizontalTabsComponent",
        title: "Two Thirds Text And Products Horizontal",
        imgSrc: "/static/img/segments/layouts/two-thirds-text-and-products-horizontal-tabs.png",
        config: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsConfig,
        advancedConfig: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsAdvancedConfig,
        component: TwoThirdsTextAndProductsHorizontalTabs.TwoThirdsTextAndProductsHorizontalTabsComponent
    },
    ProductsHorizontalTimerTabsComponent: {
        type: "ProductsHorizontalTimerTabsComponent",
        title: "Products Horizontal Timer",
        imgSrc: "/static/img/segments/layouts/products-horizontal-timer-tabs.png",
        config: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsConfig,
        advancedConfig: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsAdvancedConfig,
        component: ProductsHorizontalTimerTabs.ProductsHorizontalTimerTabsComponent
    },
    SideBySideParagraphAndProductsTabsComponent: {
        type: "SideBySideParagraphAndProductsTabsComponent",
        title: "Side By Side Paragraph And Products",
        imgSrc: "/static/img/segments/layouts/side-by-side-paragraph-and-products-tabs.png",
        config: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsConfig,
        advancedConfig: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsAdvancedConfig,
        component: SideBySideParagraphAndProductsTabs.SideBySideParagraphAndProductsTabsComponent
    },
    TimelineTitledTabTabsComponent: {
        type: "TimelineTitledTabTabsComponent",
        title: "Timeline Titled Tab",
        imgSrc: "/static/img/segments/layouts/timeline-titled-tab-tabs.png",
        config: TimelineTitledTabTabs.TimelineTitledTabTabsConfig,
        advancedConfig: TimelineTitledTabTabs.TimelineTitledTabTabsAdvancedConfig,
        component: TimelineTitledTabTabs.TimelineTitledTabTabsComponent
    },
    SideBySideTabsAndProcessTabsComponent: {
        type: "SideBySideTabsAndProcessTabsComponent",
        title: "Side By Side Tabs And Process",
        imgSrc: "/static/img/segments/layouts/side-by-side-tabs-and-process-tabs.png",
        config: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsConfig,
        advancedConfig: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsAdvancedConfig,
        component: SideBySideTabsAndProcessTabs.SideBySideTabsAndProcessTabsComponent
    },
    SideBySideTabsAndTestimonialTabsComponent: {
        type: "SideBySideTabsAndTestimonialTabsComponent",
        title: "Side By Side Tabs And Testimonial",
        imgSrc: "/static/img/segments/layouts/side-by-side-tabs-and-testimonial-tabs.png",
        config: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsConfig,
        advancedConfig: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsAdvancedConfig,
        component: SideBySideTabsAndTestimonialTabs.SideBySideTabsAndTestimonialTabsComponent
    },
    PersonasTabsComponent: {
        type: "PersonasTabsComponent",
        title: "Personas",
        imgSrc: "/static/img/segments/layouts/personas-tabs.png",
        config: PersonasTabs.PersonasTabsConfig,
        advancedConfig: PersonasTabs.PersonasTabsAdvancedConfig,
        component: PersonasTabs.PersonasTabsComponent
    },
    SideBySideBoardViewsComponentTabsComponent: {
        type: "SideBySideBoardViewsComponentTabsComponent",
        title: "Side By Side Board Views Component",
        imgSrc: "/static/img/segments/layouts/side-by-side-board-views-component-tabs.png",
        config: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsConfig,
        advancedConfig: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsAdvancedConfig,
        component: SideBySideBoardViewsComponentTabs.SideBySideBoardViewsComponentTabsComponent
    },
    UseCasesTabsComponent: {
        type: "UseCasesTabsComponent",
        title: "Use Cases",
        imgSrc: "/static/img/segments/layouts/use-cases-tabs.png",
        config: UseCasesTabs.UseCasesTabsConfig,
        advancedConfig: UseCasesTabs.UseCasesTabsAdvancedConfig,
        component: UseCasesTabs.UseCasesTabsComponent
    },
    MondayDemoTabsComponent: {
        type: "MondayDemoTabsComponent",
        title: "Monday Demo",
        imgSrc: "/static/img/segments/layouts/monday-demo-tabs.png",
        config: MondayDemoTabs.MondayDemoTabsConfig,
        advancedConfig: MondayDemoTabs.MondayDemoTabsAdvancedConfig,
        component: MondayDemoTabs.MondayDemoTabsComponent
    },
    BuildingBlocksTabsComponent: {
        type: "BuildingBlocksTabsComponent",
        title: "Building Blocks",
        imgSrc: "/static/img/segments/layouts/building-blocks-tabs.png",
        config: BuildingBlocksTabs.BuildingBlocksTabsConfig,
        advancedConfig: BuildingBlocksTabs.BuildingBlocksTabsAdvancedConfig,
        component: BuildingBlocksTabs.BuildingBlocksTabsComponent
    },
    BoardTabsComponent: {
        type: "BoardTabsComponent",
        title: "Board",
        imgSrc: "/static/img/segments/layouts/board-tabs.png",
        config: BoardTabs.BoardTabsConfig,
        advancedConfig: BoardTabs.BoardTabsAdvancedConfig,
        component: BoardTabs.BoardTabsComponent
    },
    TimelineTabsComponent: {
        type: "TimelineTabsComponent",
        title: "Timeline",
        imgSrc: "/static/img/segments/layouts/timeline-tabs.png",
        config: TimelineTabs.TimelineTabsConfig,
        advancedConfig: TimelineTabs.TimelineTabsAdvancedConfig,
        component: TimelineTabs.TimelineTabsComponent
    },
    ColoredTimerVerticalTabsComponent: {
        type: "ColoredTimerVerticalTabsComponent",
        title: "Colored Timer Vertical",
        imgSrc: "/static/img/segments/layouts/colored-timer-vertical-tabs.png",
        config: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsConfig,
        advancedConfig: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsAdvancedConfig,
        component: ColoredTimerVerticalTabs.ColoredTimerVerticalTabsComponent
    },
    TimerVerticalTabsComponent: {
        type: "TimerVerticalTabsComponent",
        title: "Timer Vertical",
        imgSrc: "/static/img/segments/layouts/timer-vertical-tabs.png",
        config: TimerVerticalTabs.TimerVerticalTabsConfig,
        advancedConfig: TimerVerticalTabs.TimerVerticalTabsAdvancedConfig,
        component: TimerVerticalTabs.TimerVerticalTabsComponent
    },
    VerticalTabsComponent: {
        type: "VerticalTabsComponent",
        title: "Vertical",
        imgSrc: "/static/img/segments/layouts/vertical-tabs.png",
        config: VerticalTabs.VerticalTabsConfig,
        advancedConfig: VerticalTabs.VerticalTabsAdvancedConfig,
        component: VerticalTabs.VerticalTabsComponent
    },
    RegularTabsComponent: {
        type: "RegularTabsComponent",
        title: "Regular",
        imgSrc: "/static/img/segments/layouts/regular-tabs.png",
        config: RegularTabs.RegularTabsConfig,
        advancedConfig: RegularTabs.RegularTabsAdvancedConfig,
        component: RegularTabs.RegularTabsComponent
    }
});


/***/ }),

/***/ 34102:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ templates; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(50342);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/core-configs/template-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}








var selectTemplateConfig = {
    solutionId: {
        type: template_field_type.FIELD_TYPES.SOLUTION,
        label: "Template"
    },
    showTitle: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show title"
    },
    showDescription: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show description"
    },
    showImageShadow: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Show image shadow"
    },
    overrideTitle: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Default Template Title"
    },
    overrideDescription: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Override Default Template Description",
        textArea: true
    },
    overrideImage: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Override Default Image",
        fields: asset_fields_config/* default */.Z
    },
    topicText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Topic"
    },
    buttonSelect: {
        type: template_field_type.FIELD_TYPES.CONDITIONAL_NESTED,
        label: "Button",
        conditionalKeyName: "buttonType",
        options: [
            {
                type: template_field_type.FIELD_TYPES.NESTED,
                text: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                fieldsConfig: {
                    signupButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Signup Button Text"
                    }
                }
            },
            {
                type: template_field_type.FIELD_TYPES.NESTED,
                text: button_consts/* SIGNUP_COMBO_BUTTONS_TYPE */.ae,
                fieldsConfig: {
                    signupButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Signup Button Text"
                    },
                    seconderyButtonText: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Secondery Button Text"
                    }
                }
            }
        ]
    }
};
var advancedTemplateConfig = {
    textSize: _object_spread_props(_object_spread({}, advanced_fields_config/* default.textSize */.Z.textSize), {
        label: "Template Description Text Size"
    }),
    titleSize: _object_spread_props(_object_spread({}, fields_config/* default.titleSize */.Z.titleSize), {
        label: "Template Title Text Size"
    }),
    mobileTextAlign: full_paragraph_fields_config/* default.mobileTextAlign */.Z.mobileTextAlign,
    hideOnMobile: shared_advanced_fields_config/* default.hideOnMobile */.ZP.hideOnMobile,
    alignToLogo: _object_spread({}, advanced_field_config/* default.alignToLogo */.Z.alignToLogo)
};

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-config.js
function multi_templates_templates_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_templates_templates_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_templates_templates_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function multi_templates_templates_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function multi_templates_templates_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        multi_templates_templates_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var multi_templates_templates_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Multi Templates",
    fields: {
        solutionsInfo: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Templates",
            maxLimit: 3,
            minLimit: 1,
            defaultValue: {
                buttonSelect: {
                    buttonType: button_consts/* SIGNUP_BUTTON_TYPE */.ge,
                    signupButtonText: "Use template",
                    seconderyButtonText: "Learn more"
                },
                showTitle: true,
                showDescription: true,
                showImageShadow: true
            },
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: multi_templates_templates_config_object_spread_props(multi_templates_templates_config_object_spread({}, selectTemplateConfig), {
                    overrideImage: multi_templates_templates_config_object_spread_props(multi_templates_templates_config_object_spread({}, selectTemplateConfig.overrideImage), {
                        fields: {
                            image: asset_fields_config/* default.image */.Z.image
                        }
                    })
                })
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-advanced-config.js
function multi_templates_templates_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function multi_templates_templates_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            multi_templates_templates_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var multi_templates_templates_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: multi_templates_templates_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advancedTemplateConfig)
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./server/services/solutions/solutions-api-service.js
var solutions_api_service = __webpack_require__(40469);
// EXTERNAL MODULE: ./services/templates-generator/api-service.js
var api_service = __webpack_require__(90215);
;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/multi-templates-templates-dynamics-fetch.js

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


var hasSameIds = function(solutionsInfo, prevSolutionsInfo) {
    return !solutionsInfo.find(function(param) {
        var solutionId = param.solutionId;
        return !prevSolutionsInfo.find(function(param) {
            var prevSolutionId = param.solutionId;
            return solutionId === prevSolutionId;
        });
    });
};
/* harmony default export */ var multi_templates_templates_dynamics_fetch = ([
    {
        propsPropertyName: "solutions",
        shouldFetch: function(param) {
            var props = param.props, previousProps = param.previousProps, pageConfig = param.pageConfig, previousPageConfig = param.previousPageConfig;
            var _props_solutionsInfo;
            var res = false;
            // Has ids
            if (((_props_solutionsInfo = props.solutionsInfo) === null || _props_solutionsInfo === void 0 ? void 0 : _props_solutionsInfo.length) > 0) {
                var _previousProps_solutionsInfo;
                // Add/Remove ids
                if (props.solutionsInfo.length !== ((_previousProps_solutionsInfo = previousProps.solutionsInfo) === null || _previousProps_solutionsInfo === void 0 ? void 0 : _previousProps_solutionsInfo.length)) {
                    res = true;
                // Id has changed
                } else if (!hasSameIds(props.solutionsInfo, previousProps.solutionsInfo)) {
                    res = true;
                // Locale has changed
                } else if (pageConfig.localeId !== previousPageConfig.localeId) {
                    res = true;
                }
            }
            return res;
        },
        fetch: function() {
            var _ref = _async_to_generator(function(param) {
                var props, pageConfig, isClientFetch, solutionsInfo, localeId, path, solutionRequests, solutions;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            props = param.props, pageConfig = param.pageConfig, isClientFetch = param.isClientFetch;
                            solutionsInfo = props.solutionsInfo;
                            localeId = pageConfig.localeId, path = pageConfig.path;
                            solutionRequests = solutionsInfo.map(function() {
                                var _ref = _async_to_generator(function(info) {
                                    var solutionId, solution, res;
                                    return (0,tslib_es6.__generator)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                solutionId = info.solutionId;
                                                if (!solutionId) return [
                                                    3,
                                                    5
                                                ];
                                                if (!isClientFetch) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    (0,api_service/* getSolutionById */.zt)({
                                                        solutionId: solutionId,
                                                        localeId: localeId
                                                    })
                                                ];
                                            case 1:
                                                res = _state.sent();
                                                solution = res.solution;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    (0,solutions_api_service.getMondaySolutionById)({
                                                        solutionId: solutionId,
                                                        localeId: localeId
                                                    })
                                                ];
                                            case 3:
                                                solution = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                if (!solution) {
                                                    throw new Error("solution (id: ".concat(solutionId, ") can't be found in page ").concat(path));
                                                }
                                                return [
                                                    2,
                                                    solution
                                                ];
                                            case 5:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(info) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            return [
                                4,
                                Promise.all(solutionRequests)
                            ];
                        case 1:
                            solutions = _state.sent();
                            return [
                                2,
                                solutions
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/multi-templates-templates/index.js




var MultiTemplatesTemplatesComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4296).then(__webpack_require__.bind(__webpack_require__, 14296));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14296)
            ];
        }
    }
});
/* harmony default export */ var multi_templates_templates = ({
    MultiTemplatesTemplatesComponent: MultiTemplatesTemplatesComponent,
    MultiTemplatesTemplatesConfig: multi_templates_templates_config,
    MultiTemplatesTemplatesAdvancedConfig: multi_templates_templates_advanced_config,
    MultiTemplatesTemplatesDynamicsFetch: multi_templates_templates_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-config.js
function single_template_templates_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_template_templates_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_template_templates_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var single_template_templates_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Single Template",
    fields: single_template_templates_config_object_spread({}, selectTemplateConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-advanced-config.js
function single_template_templates_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function single_template_templates_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            single_template_templates_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var single_template_templates_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: single_template_templates_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advancedTemplateConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/single-template-templates-dynamics-fetch.js

function single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function single_template_templates_dynamics_fetch_async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                single_template_templates_dynamics_fetch_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}


/* harmony default export */ var single_template_templates_dynamics_fetch = ([
    {
        propsPropertyName: "solution",
        shouldFetch: function(param) {
            var props = param.props, previousProps = param.previousProps, pageConfig = param.pageConfig, previousPageConfig = param.previousPageConfig;
            return props.solutionId && (props.solutionId !== previousProps.solutionId || pageConfig.localeId !== previousPageConfig.localeId);
        },
        fetch: function() {
            var _ref = single_template_templates_dynamics_fetch_async_to_generator(function(param) {
                var props, pageConfig, isClientFetch, solutionId, localeId, path, solution, res;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            props = param.props, pageConfig = param.pageConfig, isClientFetch = param.isClientFetch;
                            solutionId = props.solutionId;
                            localeId = pageConfig.localeId, path = pageConfig.path;
                            if (!isClientFetch) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                (0,api_service/* getSolutionById */.zt)({
                                    solutionId: solutionId,
                                    localeId: localeId
                                })
                            ];
                        case 1:
                            res = _state.sent();
                            solution = res.solution;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                (0,solutions_api_service.getMondaySolutionById)({
                                    solutionId: solutionId,
                                    localeId: localeId
                                })
                            ];
                        case 3:
                            solution = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (!solution) {
                                throw new Error("solution (id: ".concat(solutionId, ") can't be found in page ").concat(path));
                            }
                            return [
                                2,
                                solution
                            ];
                    }
                });
            });
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }()
    }
]);

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/single-template-templates/index.js




var SingleTemplateTemplatesComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7595).then(__webpack_require__.bind(__webpack_require__, 97595));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97595)
            ];
        }
    }
});
/* harmony default export */ var single_template_templates = ({
    SingleTemplateTemplatesComponent: SingleTemplateTemplatesComponent,
    SingleTemplateTemplatesConfig: single_template_templates_config,
    SingleTemplateTemplatesAdvancedConfig: single_template_templates_advanced_config,
    SingleTemplateTemplatesDynamicsFetch: single_template_templates_dynamics_fetch
});

;// CONCATENATED MODULE: ./segments/desktop/templates/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    MultiTemplatesTemplates: multi_templates_templates,
    SingleTemplateTemplates: single_template_templates
});

;// CONCATENATED MODULE: ./segments/desktop/templates/index.js

var MultiTemplatesTemplates = layouts.MultiTemplatesTemplates, SingleTemplateTemplates = layouts.SingleTemplateTemplates;
/* harmony default export */ var templates = ({
    // plop_marker:segment_index_add_layout
    MultiTemplatesTemplatesComponent: {
        type: "MultiTemplatesTemplatesComponent",
        title: "Multi Templates",
        imgSrc: "/static/img/segments/layouts/multi-templates-templates.png",
        config: MultiTemplatesTemplates.MultiTemplatesTemplatesConfig,
        advancedConfig: MultiTemplatesTemplates.MultiTemplatesTemplatesAdvancedConfig,
        component: MultiTemplatesTemplates.MultiTemplatesTemplatesComponent,
        dynamicsFetch: MultiTemplatesTemplates.MultiTemplatesTemplatesDynamicsFetch
    },
    SingleTemplateTemplatesComponent: {
        type: "SingleTemplateTemplatesComponent",
        title: "Single Template",
        imgSrc: "/static/img/segments/layouts/single-template-templates.png",
        config: SingleTemplateTemplates.SingleTemplateTemplatesConfig,
        advancedConfig: SingleTemplateTemplates.SingleTemplateTemplatesAdvancedConfig,
        component: SingleTemplateTemplates.SingleTemplateTemplatesComponent,
        dynamicsFetch: SingleTemplateTemplates.SingleTemplateTemplatesDynamicsFetch
    }
});


/***/ }),

/***/ 35341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ testimonials; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-config.js

var testimonialConfig = {
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Single company testimonial",
    fields: {
        name: {
            label: "Company name",
            type: template_field_type.FIELD_TYPES.TEXT
        },
        testimonialText: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Testimonial text",
            translatable: true
        },
        personName: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Quote sayer's name"
        },
        personRole: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Quote sayer's role",
            translatable: true
        },
        image: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Company logo",
            fields: {
                src: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    defaultImagesKeys: [
                        "static/img/templates/long-template/boards/"
                    ],
                    label: "Select an image (max 290px width, 90px height)"
                },
                alt: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Image description (alt)",
                    translatable: true
                },
                isDecorative: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Decorative image(no alt)"
                }
            }
        }
    }
};
/* harmony default export */ var carousel_testimonials_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Testimonials carousel",
    fields: {
        textNote: {
            type: template_field_type.FIELD_TYPES.CONSTANT,
            label: "Note about texts:",
            text: "You can either use translation keys for translated text, or enter English text directly, which will be untranslated."
        },
        autoplay: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Auto-play definitions",
            fields: {
                shouldAutoPlay: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Should auto-play testimonial slides"
                },
                interval: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Interval (number of milliseconds)"
                }
            }
        },
        testimonials: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Testimonials",
            nestedConfig: testimonialConfig
        }
    }
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/carousel-testimonials-advanced-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var carousel_testimonials_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: _object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/carousel-testimonials/index.js

var CarouselTestimonialsComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6499), __webpack_require__.e(1997)]).then(__webpack_require__.bind(__webpack_require__, 51997));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(51997)
            ];
        }
    }
});


/* harmony default export */ var carousel_testimonials = ({
    CarouselTestimonialsComponent: CarouselTestimonialsComponent,
    CarouselTestimonialsConfig: carousel_testimonials_config,
    CarouselTestimonialsAdvancedConfig: carousel_testimonials_advanced_config
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
// EXTERNAL MODULE: ./segments/desktop/core-components/person-textual-info/fields-config.js
var fields_config = __webpack_require__(81828);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/components/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var color = fields_config/* default.color */.Z.color, selectedTextualInfoFields = _object_without_properties(fields_config/* default */.Z, [
    "color"
]);
/* harmony default export */ var components_fields_config = (fields_config_object_spread(_object_spread_props(fields_config_object_spread({}, theme_config/* default */.Z), {
    companyImage: {
        type: template_field_type.FIELD_TYPES.GALLERY,
        defaultImagesKeys: [],
        label: "Select an Image"
    },
    alt: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Image description (alt)",
        translatable: true
    },
    quote: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Quote",
        textArea: true,
        translatable: true
    }
}), selectedTextualInfoFields));

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-config.js


/* harmony default export */ var plain_classic_testimonials_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Plain Classic",
    fields: {
        testimonialCard: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Testominal Card",
            fields: components_fields_config
        }
    }
});

// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/plain-classic-testimonials-advanced-config.js
function plain_classic_testimonials_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function plain_classic_testimonials_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            plain_classic_testimonials_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function plain_classic_testimonials_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function plain_classic_testimonials_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        plain_classic_testimonials_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var plain_classic_testimonials_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: plain_classic_testimonials_advanced_config_object_spread_props(plain_classic_testimonials_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP), {
        titleSize: {
            type: template_field_type.FIELD_TYPES.COMBO,
            label: "Title Size",
            options: [
                {
                    value: sizes.XS,
                    text: "24px"
                },
                {
                    value: sizes.SM,
                    text: "32px"
                },
                {
                    value: sizes.MD,
                    text: "40px"
                },
                {
                    value: sizes.LG,
                    text: "50px"
                },
                {
                    value: sizes/* LGR */.Re,
                    text: "60px"
                },
                {
                    value: sizes.XL,
                    text: "72px"
                }
            ]
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/plain-classic-testimonials/index.js

var PlainClassicTestimonialsComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4124).then(__webpack_require__.bind(__webpack_require__, 69799));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(69799)
            ];
        }
    }
});


/* harmony default export */ var plain_classic_testimonials = ({
    PlainClassicTestimonialsComponent: PlainClassicTestimonialsComponent,
    PlainClassicTestimonialsConfig: plain_classic_testimonials_config,
    PlainClassicTestimonialsAdvancedConfig: plain_classic_testimonials_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/layouts/index.js
// plop_marker:layouts_import


/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    CarouselTestimonials: carousel_testimonials,
    PlainClassicTestimonials: plain_classic_testimonials
});

;// CONCATENATED MODULE: ./segments/desktop/testimonials/index.js

var CarouselTestimonials = layouts.CarouselTestimonials, PlainClassicTestimonials = layouts.PlainClassicTestimonials;
/* harmony default export */ var testimonials = ({
    // plop_marker:segment_index_add_layout
    CarouselTestimonialsComponent: {
        type: "CarouselTestimonialsComponent",
        title: "Testimonials Carousel",
        imgSrc: "/static/img/segments/layouts/carousel-testimonials.png",
        config: CarouselTestimonials.CarouselTestimonialsConfig,
        advancedConfig: CarouselTestimonials.CarouselTestimonialsAdvancedConfig,
        component: CarouselTestimonials.CarouselTestimonialsComponent
    },
    PlainClassicTestimonialsComponent: {
        type: "PlainClassicTestimonialsComponent",
        title: "Plain Classic",
        imgSrc: "/static/img/segments/layouts/plain-classic-testimonials.png",
        config: PlainClassicTestimonials.PlainClassicTestimonialsConfig,
        advancedConfig: PlainClassicTestimonials.PlainClassicTestimonialsAdvancedConfig,
        component: PlainClassicTestimonials.PlainClassicTestimonialsComponent
    }
});


/***/ }),

/***/ 95033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ text_and_asset; }
});

// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./constants/template-field-type.js
var template_field_type = __webpack_require__(40559);
// EXTERNAL MODULE: ./segments/desktop/core-components/title/fields-config.js
var fields_config = __webpack_require__(65621);
// EXTERNAL MODULE: ./segments/desktop/core-components/paragraph/fields-config.js
var paragraph_fields_config = __webpack_require__(49496);
;// CONCATENATED MODULE: ./segments/desktop/core-components/product-card/fields-config.js
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var titleColor = fields_config/* default.titleColor */.Z.titleColor, restOfTitleConfig = _object_without_properties(fields_config/* default */.Z, [
    "titleColor"
]);
var bodyColor = paragraph_fields_config/* default.bodyColor */.Z.bodyColor, restOfParagraphConfig = _object_without_properties(paragraph_fields_config/* default */.Z, [
    "bodyColor"
]);
/* harmony default export */ var product_card_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Cards",
    fields: {
        cardBackgroundColor: {
            type: template_field_type.FIELD_TYPES.COLOR_PICKER,
            label: "Card background color"
        },
        productType: {
            type: template_field_type.FIELD_TYPES.PRODUCTS,
            label: "Product type"
        },
        cardTitle: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Card title",
            fields: _object_spread({
                productImage: {
                    type: template_field_type.FIELD_TYPES.GALLERY,
                    label: "Product logo image"
                }
            }, restOfTitleConfig, restOfParagraphConfig)
        },
        cardContent: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Card content",
            fields: _object_spread_props(_object_spread({}, restOfTitleConfig, restOfParagraphConfig), {
                textWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Text max width"
                },
                titleWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Title max width"
                },
                useCasesWidth: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Use case max width"
                },
                isUseCasesReadonly: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Is use cases read only"
                },
                showUseCasesVertically: {
                    type: template_field_type.FIELD_TYPES.BOOLEAN,
                    label: "Show Use Cases Vertically"
                },
                cardPaddingTop: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Card Padding Top"
                },
                cardPaddingBottom: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Card Padding Bottom"
                },
                spaceUnderTitle: {
                    type: template_field_type.FIELD_TYPES.TEXT,
                    label: "Space Under Title"
                },
                useCases: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Use cases",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            useCase: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Use cases"
                            },
                            overridePageCluster: {
                                type: template_field_type.FIELD_TYPES.CLUSTERS,
                                label: "Cluster key",
                                labelDescription: "Key which represents the selected tag cluster"
                            },
                            overridePageSubCluster: {
                                type: template_field_type.FIELD_TYPES.SUB_CLUSTERS,
                                label: "Use Case key",
                                labelDescription: "Key which represents the selected tag use case"
                            }
                        }
                    }
                },
                features: {
                    type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
                    label: "Features",
                    nestedConfig: {
                        type: template_field_type.FIELD_TYPES.NESTED,
                        fields: {
                            feature: {
                                type: template_field_type.FIELD_TYPES.TEXT,
                                label: "Feature"
                            }
                        }
                    }
                }
            })
        },
        cardAsset: {
            type: template_field_type.FIELD_TYPES.GALLERY,
            label: "Card asset"
        }
    }
});

// EXTERNAL MODULE: ./segments/core-configs/theme-config.js
var theme_config = __webpack_require__(60633);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-config.js
function product_cards_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function product_cards_side_by_side_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function product_cards_side_by_side_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        product_cards_side_by_side_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ var product_cards_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Products Cards",
    fields: product_cards_side_by_side_text_and_asset_config_object_spread_props(product_cards_side_by_side_text_and_asset_config_object_spread({}, theme_config/* default */.Z), {
        cards: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Use cases",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: product_card_fields_config.fields
            }
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/shared-advanced-fields-config.js
var shared_advanced_fields_config = __webpack_require__(69223);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/product-cards-side-by-side-text-and-asset-advanced-config.js
function product_cards_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function product_cards_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            product_cards_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}


/* harmony default export */ var product_cards_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: product_cards_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/product-cards-side-by-side-text-and-asset/index.js

var ProductCardsSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(6416), __webpack_require__.e(4222), __webpack_require__.e(6)]).then(__webpack_require__.bind(__webpack_require__, 80006));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80006)
            ];
        }
    }
});


/* harmony default export */ var product_cards_side_by_side_text_and_asset = ({
    ProductCardsSideBySideTextAndAssetComponent: ProductCardsSideBySideTextAndAssetComponent,
    ProductCardsSideBySideTextAndAssetConfig: product_cards_side_by_side_text_and_asset_config,
    ProductCardsSideBySideTextAndAssetAdvancedConfig: product_cards_side_by_side_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./components/core/asset/fields-config.js
var asset_fields_config = __webpack_require__(13225);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/fields-config.js
var full_paragraph_fields_config = __webpack_require__(24586);
;// CONCATENATED MODULE: ./segments/desktop/core-components/card-tag/fields-config.js

/* harmony default export */ var card_tag_fields_config = ({
    tagText: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Tag Text"
    },
    tagColor: {
        type: template_field_type.FIELD_TYPES.COLOR_PICKER,
        label: "Tag Color"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/whats-new-inner-page-side-by-side-text-and-asset-config.js
function whats_new_inner_page_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_inner_page_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function whats_new_inner_page_side_by_side_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        whats_new_inner_page_side_by_side_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Whats New Inner Page Side By Side",
    fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread_props(whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, full_paragraph_fields_config/* default */.Z), {
        date: {
            type: template_field_type.FIELD_TYPES.CALENDAR,
            label: "Date"
        },
        tags: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Tags",
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, card_tag_fields_config)
            }
        },
        rightSectionPaddingTop: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Left Section Padding Top"
        },
        asset: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Asset",
            fields: whats_new_inner_page_side_by_side_text_and_asset_config_object_spread({}, asset_fields_config/* default */.Z)
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/advanced-fields-config.js
var advanced_fields_config = __webpack_require__(47285);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/whats-new-inner-page-side-by-side-text-and-asset-advanced-config.js
function whats_new_inner_page_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function whats_new_inner_page_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            whats_new_inner_page_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: whats_new_inner_page_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/whats-new-inner-page-side-by-side-text-and-asset/index.js



var WhatsNewInnerPageSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3139).then(__webpack_require__.bind(__webpack_require__, 20821));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(20821)
            ];
        }
    }
});
/* harmony default export */ var whats_new_inner_page_side_by_side_text_and_asset = ({
    WhatsNewInnerPageSideBySideTextAndAssetComponent: WhatsNewInnerPageSideBySideTextAndAssetComponent,
    WhatsNewInnerPageSideBySideTextAndAssetConfig: whats_new_inner_page_side_by_side_text_and_asset_config,
    WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig: whats_new_inner_page_side_by_side_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/fields-config.js
var side_by_side_text_and_asset_fields_config = __webpack_require__(93097);
// EXTERNAL MODULE: ./components/core/youtube-video-with-poster/fields-config.js
var youtube_video_with_poster_fields_config = __webpack_require__(93494);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/youtube-text-and-asset-config.js
function youtube_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function youtube_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = youtube_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function youtube_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, selectedSideBySideTextAndAssetFieldsConfig = youtube_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var youtube_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube",
    fields: youtube_text_and_asset_config_object_spread_props(youtube_text_and_asset_config_object_spread({}, theme_config/* default */.Z, selectedSideBySideTextAndAssetFieldsConfig), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/side-by-side-text-and-asset/advanced-field-config.js
var advanced_field_config = __webpack_require__(77374);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/youtube-text-and-asset-advanced-config.js
function youtube_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var youtube_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-text-and-asset/index.js



var YoutubeTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6121).then(__webpack_require__.bind(__webpack_require__, 76121));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(76121)
            ];
        }
    }
});
/* harmony default export */ var youtube_text_and_asset = ({
    YoutubeTextAndAssetComponent: YoutubeTextAndAssetComponent,
    YoutubeTextAndAssetConfig: youtube_text_and_asset_config,
    YoutubeTextAndAssetAdvancedConfig: youtube_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./components/enhancements/responsive-hoc/responsive-hoc-component.js + 1 modules
var responsive_hoc_component = __webpack_require__(27190);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/side-by-side-text-and-asset-component.js
var side_by_side_text_and_asset_component = __webpack_require__(8150);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-dekstop-component.scss.js

var StyledSideBySideWithIconsTextAndAssetDekstopComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jcgcfs0"
})("display:flex;.side-by-side-asset-wrapper{flex-grow:1;.side-by-side-text-and-asset-component{height:100%;}}");

// EXTERNAL MODULE: ./segments/desktop/core-components/icons/default-props.js
var default_props = __webpack_require__(80564);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button-consts.js
var button_consts = __webpack_require__(75650);
// EXTERNAL MODULE: ./styles/color-consts.js
var color_consts = __webpack_require__(273);
// EXTERNAL MODULE: ./constants/sizes.js
var sizes = __webpack_require__(77869);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/default-props.js
function default_props_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function default_props_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            default_props_define_property(target, key, source[key]);
        });
    }
    return target;
}
function default_props_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function default_props_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        default_props_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





/* harmony default export */ var side_by_side_with_icons_text_and_asset_default_props = (default_props_object_spread_props(default_props_object_spread({
    iconsConfig: default_props/* default */.Z
}, side_by_side_text_and_asset_component["default"].defaultProps), {
    asset: {
        image: {
            src: "https://dapulse-res.cloudinary.com/image/upload/Generator_featured%20images/Home%20Page%20-%202022%20Rebrand/customer-support/support_globe.png"
        }
    },
    fullParagraph: {
        topic: {},
        title: "Supporting <light>your growth<br>every step of the way</light>",
        body: "Our support superheroes are a click away to help you get the most out of monday.com, so you can focus on working without limits.",
        buttonConfig: {
            buttonType: button_consts/* TWO_LINK_BUTTONS_TYPE */.Q_,
            swapButtonsOrder: true,
            regularButtonConfig: {
                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                buttonText: "Get in touch",
                url: "https://monday.com/helpcenter/contact-support"
            },
            secondaryButtonConfig: {
                color: color_consts.WORK_OS_IRIS_COLOR_NAME,
                buttonText: "Visit our support center",
                url: "https://support.monday.com/hc/en-us"
            }
        }
    },
    titleSize: sizes.LG,
    leftSizeWidth: "60%",
    rightSizeWidth: "40%",
    mobileMarginBetweenAssetAndButton: "48px"
}));

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-dekstop-component.js
function side_by_side_with_icons_text_and_asset_dekstop_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_dekstop_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_dekstop_component_define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideWithIconsTextAndAssetDekstopComponent = function(props) {
    var getStyle = function() {
        var minHeight = props.minHeight;
        if (!minHeight) return {};
        return {
            minHeight: minHeight
        };
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledSideBySideWithIconsTextAndAssetDekstopComponent, {
        className: "side-by-side-with-icons-text-and-asset-component",
        style: getStyle(),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "side-by-side-asset-wrapper",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(side_by_side_text_and_asset_component["default"], side_by_side_with_icons_text_and_asset_dekstop_component_object_spread({}, props))
        })
    });
};
SideBySideWithIconsTextAndAssetDekstopComponent.defaultProps = side_by_side_with_icons_text_and_asset_default_props;
/* harmony default export */ var side_by_side_with_icons_text_and_asset_dekstop_component = (SideBySideWithIconsTextAndAssetDekstopComponent);

// EXTERNAL MODULE: ./components/core/asset/asset-component.js + 2 modules
var asset_component = __webpack_require__(24961);
// EXTERNAL MODULE: ./segments/desktop/core-components/button/button.js + 22 modules
var button_button = __webpack_require__(16430);
// EXTERNAL MODULE: ./segments/desktop/core-components/full-paragraph/full-paragraph.js + 6 modules
var full_paragraph = __webpack_require__(13211);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-mobile-component.scss.js

var StyledSideBySideWithIconsTextAndAssetMobileComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eetub0m0"
})("display:flex;flex-direction:column;align-items:center;padding:0 32px 40px;.full-paragraph{.icons-wrapper{margin-bottom:8px;}}.button-wrapper{margin-top:var(--margin-between-asset-and-button);}.two-link-buttons-button.swap-buttons-order{flex-direction:column-reverse;}");

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-mobile-component.js
function side_by_side_with_icons_text_and_asset_mobile_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_mobile_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_mobile_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var SideBySideWithIconsTextAndAssetMobileComponent = function(props) {
    var iconsConfig = props.iconsConfig, asset = props.asset, fullParagraph = props.fullParagraph, mobileMarginBetweenAssetAndButton = props.mobileMarginBetweenAssetAndButton, mobileMarginUnderButton = props.mobileMarginUnderButton;
    var buttonConfig = fullParagraph.buttonConfig, fullParagraphRest = side_by_side_with_icons_text_and_asset_mobile_component_object_without_properties(fullParagraph, [
        "buttonConfig"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSideBySideWithIconsTextAndAssetMobileComponent, {
        className: "side-by-side-with-icons-text-and-asset-mobile-component",
        style: {
            "--margin-between-asset-and-button": mobileMarginBetweenAssetAndButton
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "full-paragraph",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(full_paragraph/* default */.ZP, side_by_side_with_icons_text_and_asset_mobile_component_object_spread_props(side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, fullParagraphRest), {
                    textAlign: "center",
                    titleSize: sizes.XS,
                    textSize: sizes/* XXS */.Mp,
                    iconsConfig: iconsConfig
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_component/* default */.Z, side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, asset)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "button-wrapper",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_button/* default */.Z, side_by_side_with_icons_text_and_asset_mobile_component_object_spread({}, buttonConfig))
            })
        ]
    });
};
SideBySideWithIconsTextAndAssetMobileComponent.defaultProps = side_by_side_with_icons_text_and_asset_default_props;
/* harmony default export */ var side_by_side_with_icons_text_and_asset_mobile_component = (SideBySideWithIconsTextAndAssetMobileComponent);

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-component.js




var SideBySideWithIconsTextAndAsset = (0,responsive_hoc_component/* default */.Z)(side_by_side_with_icons_text_and_asset_dekstop_component, side_by_side_with_icons_text_and_asset_mobile_component);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_component = (SideBySideWithIconsTextAndAsset);
SideBySideWithIconsTextAndAsset.defaultProps = side_by_side_with_icons_text_and_asset_default_props;

;// CONCATENATED MODULE: ./segments/desktop/core-components/icons/fields-config.js


var fields_config_image = asset_fields_config/* default.image */.Z.image;
/* harmony default export */ var icons_fields_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Icons",
    fields: {
        icons: {
            type: template_field_type.FIELD_TYPES.MULTIPLE_NESTED,
            label: "Icons",
            maxLimit: 3,
            nestedConfig: {
                type: template_field_type.FIELD_TYPES.NESTED,
                fields: {
                    image: fields_config_image,
                    title: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Title",
                        translatable: true
                    },
                    subtitle: {
                        type: template_field_type.FIELD_TYPES.TEXT,
                        label: "Subtitle",
                        translatable: true
                    }
                }
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-config.js
function side_by_side_with_icons_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_with_icons_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_icons_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Icons",
    fields: side_by_side_with_icons_text_and_asset_config_object_spread_props(side_by_side_with_icons_text_and_asset_config_object_spread({}, side_by_side_with_icons_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        iconsConfig: icons_fields_config
    })
});

// EXTERNAL MODULE: ./components/core/asset/advanced-field-config.js
var asset_advanced_field_config = __webpack_require__(25289);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/side-by-side-with-icons-text-and-asset-advanced-config.js
function side_by_side_with_icons_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_icons_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_icons_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, side_by_side_with_icons_text_and_asset_advanced_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, side_by_side_with_icons_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_icons_text_and_asset_advanced_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "fullParagraph",
    "asset"
]);
/* harmony default export */ var side_by_side_with_icons_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_icons_text_and_asset_advanced_config_object_spread_props(side_by_side_with_icons_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, side_by_side_with_icons_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig, advanced_field_config/* default */.Z), {
        mobileMarginBetweenAssetAndButton: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Margin above button in mobile version"
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-icons-text-and-asset/index.js



/* harmony default export */ var side_by_side_with_icons_text_and_asset = ({
    SideBySideWithIconsTextAndAssetComponent: side_by_side_with_icons_text_and_asset_component,
    SideBySideWithIconsTextAndAssetConfig: side_by_side_with_icons_text_and_asset_config,
    SideBySideWithIconsTextAndAssetAdvancedConfig: side_by_side_with_icons_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/board-tabs/fields-config.js
var board_tabs_fields_config = __webpack_require__(55209);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/board-tab-text-and-asset-config.js
function board_tab_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tab_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tab_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function board_tab_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function board_tab_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        board_tab_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function board_tab_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = board_tab_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function board_tab_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var board_tab_text_and_asset_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, board_tab_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = board_tab_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var board_tab_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Board tab side by side",
    fields: board_tab_text_and_asset_config_object_spread_props(board_tab_text_and_asset_config_object_spread({}, theme_config/* default */.Z, board_tab_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        boardTabsProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Board tabs",
            fields: board_tabs_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/board-tab-text-and-asset-advanced-config.js
function board_tab_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function board_tab_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            board_tab_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var board_tab_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: board_tab_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z, advanced_fields_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/board-tab-text-and-asset/index.js



var BoardTabTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 3663).then(__webpack_require__.bind(__webpack_require__, 13663));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(13663)
            ];
        }
    }
});
/* harmony default export */ var board_tab_text_and_asset = ({
    BoardTabTextAndAssetComponent: BoardTabTextAndAssetComponent,
    BoardTabTextAndAssetConfig: board_tab_text_and_asset_config,
    BoardTabTextAndAssetAdvancedConfig: board_tab_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/youtube-two-thirds-text-and-asset-config.js
function youtube_two_thirds_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_two_thirds_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_two_thirds_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function youtube_two_thirds_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        youtube_two_thirds_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = youtube_two_thirds_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function youtube_two_thirds_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}




var youtube_two_thirds_text_and_asset_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, youtube_two_thirds_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = youtube_two_thirds_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "asset"
]);
/* harmony default export */ var youtube_two_thirds_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Youtube Two Thirds",
    fields: youtube_two_thirds_text_and_asset_config_object_spread_props(youtube_two_thirds_text_and_asset_config_object_spread({}, theme_config/* default */.Z, youtube_two_thirds_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        }
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/youtube-two-thirds-text-and-asset-advanced-config.js
function youtube_two_thirds_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function youtube_two_thirds_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            youtube_two_thirds_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}



/* harmony default export */ var youtube_two_thirds_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: youtube_two_thirds_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/youtube-two-thirds-text-and-asset/index.js

var YoutubeTwoThirdsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9129).then(__webpack_require__.bind(__webpack_require__, 79129));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(79129)
            ];
        }
    }
});


/* harmony default export */ var youtube_two_thirds_text_and_asset = ({
    YoutubeTwoThirdsTextAndAssetComponent: YoutubeTwoThirdsTextAndAssetComponent,
    YoutubeTwoThirdsTextAndAssetConfig: youtube_two_thirds_text_and_asset_config,
    YoutubeTwoThirdsTextAndAssetAdvancedConfig: youtube_two_thirds_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-config.js
function asymmetric_side_by_side_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_side_by_side_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_side_by_side_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function asymmetric_side_by_side_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = asymmetric_side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function asymmetric_side_by_side_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var asymmetric_side_by_side_text_and_asset_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, asymmetric_side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = asymmetric_side_by_side_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var asymmetric_side_by_side_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Asymmetric Side By Side",
    fields: asymmetric_side_by_side_text_and_asset_config_object_spread({}, theme_config/* default */.Z, asymmetric_side_by_side_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/asymmetric-side-by-side-text-and-asset-advanced-config.js
function asymmetric_side_by_side_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function asymmetric_side_by_side_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            asymmetric_side_by_side_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var asymmetric_side_by_side_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: asymmetric_side_by_side_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/asymmetric-side-by-side-text-and-asset/index.js

var AsymmetricSideBySideTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6071).then(__webpack_require__.bind(__webpack_require__, 56071));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(56071)
            ];
        }
    }
});


/* harmony default export */ var asymmetric_side_by_side_text_and_asset = ({
    AsymmetricSideBySideTextAndAssetComponent: AsymmetricSideBySideTextAndAssetComponent,
    AsymmetricSideBySideTextAndAssetConfig: asymmetric_side_by_side_text_and_asset_config,
    AsymmetricSideBySideTextAndAssetAdvancedConfig: asymmetric_side_by_side_text_and_asset_advanced_config
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/person-info/fields-config.js

/* harmony default export */ var person_info_fields_config = ({
    name: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Person Name"
    },
    jobDescription: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Job Description",
        translatable: true
    },
    personImg: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Person Image",
        fields: {
            src: {
                type: template_field_type.FIELD_TYPES.GALLERY,
                defaultImagesKeys: [],
                label: "Select Person Image"
            },
            alt: {
                type: template_field_type.FIELD_TYPES.TEXT,
                label: "Image description (alt)"
            }
        }
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/testimonials-quote/fields-config.js

/* harmony default export */ var testimonials_quote_fields_config = ({
    testimonial: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonials",
        textArea: true,
        translatable: true
    },
    removeQuote: {
        type: template_field_type.FIELD_TYPES.BOOLEAN,
        label: "Remove quote background"
    },
    quoteFontSize: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial font size"
    },
    quoteLineHeight: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial line height"
    }
});

;// CONCATENATED MODULE: ./segments/desktop/core-components/full-testimonials-quote/fields-config.js
function fields_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function fields_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            fields_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function fields_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function fields_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        fields_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var full_testimonials_quote_fields_config = (fields_config_object_spread_props(fields_config_object_spread({}, fields_config/* default */.Z), {
    testimonialsConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Testimonials config",
        fields: testimonials_quote_fields_config
    },
    personConfig: {
        type: template_field_type.FIELD_TYPES.NESTED,
        label: "Person config",
        fields: person_info_fields_config
    },
    maxWidth: {
        type: template_field_type.FIELD_TYPES.TEXT,
        label: "Testimonial max width"
    }
}));

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-config.js
function testimonials_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonials_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonials_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function testimonials_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function testimonials_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        testimonials_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/* harmony default export */ var testimonials_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Testimonials Side By Side",
    fields: testimonials_text_and_asset_config_object_spread_props(testimonials_text_and_asset_config_object_spread({}, side_by_side_text_and_asset_fields_config/* default */.Z), {
        youtubeWithPosterProps: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "Youtube video",
            fields: youtube_video_with_poster_fields_config/* default */.Z
        },
        fullParagraph: {
            type: template_field_type.FIELD_TYPES.NESTED,
            label: "FullTestimonialsQuoteFieldsConfig",
            fields: full_testimonials_quote_fields_config
        }
    })
});

// EXTERNAL MODULE: ./segments/desktop/core-components/title/advanced-field-config.js
var title_advanced_field_config = __webpack_require__(95760);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/testimonials-text-and-asset-advanced-config.js
function testimonials_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function testimonials_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            testimonials_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}




/* harmony default export */ var testimonials_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: testimonials_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, title_advanced_field_config/* default */.Z, asset_advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/testimonials-text-and-asset/index.js

var TestimonialsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7979).then(__webpack_require__.bind(__webpack_require__, 17979));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17979)
            ];
        }
    }
});


/* harmony default export */ var testimonials_text_and_asset = ({
    TestimonialsTextAndAssetComponent: TestimonialsTextAndAssetComponent,
    TestimonialsTextAndAssetConfig: testimonials_text_and_asset_config,
    TestimonialsTextAndAssetAdvancedConfig: testimonials_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/core-components/bullets/fields-config.js
var bullets_fields_config = __webpack_require__(61204);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/side-by-side-with-bullets-text-and-asset-config.js
function side_by_side_with_bullets_text_and_asset_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_bullets_text_and_asset_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_bullets_text_and_asset_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function side_by_side_with_bullets_text_and_asset_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        side_by_side_with_bullets_text_and_asset_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_bullets_text_and_asset_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var side_by_side_with_bullets_text_and_asset_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background, side_by_side_with_bullets_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_bullets_text_and_asset_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "background"
]);
/* harmony default export */ var side_by_side_with_bullets_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side with Bullets",
    fields: side_by_side_with_bullets_text_and_asset_config_object_spread_props(side_by_side_with_bullets_text_and_asset_config_object_spread({}, side_by_side_with_bullets_text_and_asset_config_selectedSideBySideTextAndAssetFieldsConfig), {
        bulletsConfig: bullets_fields_config/* default */.Z
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/side-by-side-with-bullets-text-and-asset-advanced-config.js
function side_by_side_with_bullets_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_bullets_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}






var side_by_side_with_bullets_text_and_asset_advanced_config_swapTextAndAssetPosition = side_by_side_text_and_asset_fields_config/* default.swapTextAndAssetPosition */.Z.swapTextAndAssetPosition, side_by_side_with_bullets_text_and_asset_advanced_config_fullParagraph = side_by_side_text_and_asset_fields_config/* default.fullParagraph */.Z.fullParagraph, side_by_side_with_bullets_text_and_asset_advanced_config_asset = side_by_side_text_and_asset_fields_config/* default.asset */.Z.asset, side_by_side_with_bullets_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig = side_by_side_with_bullets_text_and_asset_advanced_config_object_without_properties(side_by_side_text_and_asset_fields_config/* default */.Z, [
    "swapTextAndAssetPosition",
    "fullParagraph",
    "asset"
]);
/* harmony default export */ var side_by_side_with_bullets_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_bullets_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, side_by_side_with_bullets_text_and_asset_advanced_config_selectedSideBySideTextAndAssetFieldsConfig, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-bullets-text-and-asset/index.js

var SideBySideWithBulletsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 7095).then(__webpack_require__.bind(__webpack_require__, 97095));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97095)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_with_bullets_text_and_asset = ({
    SideBySideWithBulletsTextAndAssetComponent: SideBySideWithBulletsTextAndAssetComponent,
    SideBySideWithBulletsTextAndAssetConfig: side_by_side_with_bullets_text_and_asset_config,
    SideBySideWithBulletsTextAndAssetAdvancedConfig: side_by_side_with_bullets_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-config.js
var two_thirds_text_and_asset_config = __webpack_require__(49133);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-advanced-config.js
function two_thirds_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function two_thirds_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            two_thirds_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}
function two_thirds_text_and_asset_advanced_config_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function two_thirds_text_and_asset_advanced_config_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        two_thirds_text_and_asset_advanced_config_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var two_thirds_text_and_asset_advanced_config_background = side_by_side_text_and_asset_fields_config/* default.background */.Z.background;
/* harmony default export */ var two_thirds_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: two_thirds_text_and_asset_advanced_config_object_spread_props(two_thirds_text_and_asset_advanced_config_object_spread({}, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z), {
        background: two_thirds_text_and_asset_advanced_config_background
    })
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/index.js

var TwoThirdsTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 2968).then(__webpack_require__.bind(__webpack_require__, 32968));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(32968)
            ];
        }
    }
});


/* harmony default export */ var two_thirds_text_and_asset = ({
    TwoThirdsTextAndAssetComponent: TwoThirdsTextAndAssetComponent,
    TwoThirdsTextAndAssetConfig: two_thirds_text_and_asset_config/* default */.Z,
    TwoThirdsTextAndAssetAdvancedConfig: two_thirds_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/full-background-text-and-asset/index.js + 2 modules
var full_background_text_and_asset = __webpack_require__(74793);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-config.js


/* harmony default export */ var side_by_side_with_background_text_and_asset_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "Side By Side With Background",
    fields: side_by_side_text_and_asset_fields_config/* default */.Z
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/side-by-side-with-background-text-and-asset-advanced-config.js
function side_by_side_with_background_text_and_asset_advanced_config_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function side_by_side_with_background_text_and_asset_advanced_config_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            side_by_side_with_background_text_and_asset_advanced_config_define_property(target, key, source[key]);
        });
    }
    return target;
}





/* harmony default export */ var side_by_side_with_background_text_and_asset_advanced_config = ({
    type: template_field_type.FIELD_TYPES.NESTED,
    label: "",
    fields: side_by_side_with_background_text_and_asset_advanced_config_object_spread({
        minHeight: {
            type: template_field_type.FIELD_TYPES.TEXT,
            label: "Min Height (new)"
        }
    }, shared_advanced_fields_config/* default */.ZP, advanced_fields_config/* default */.Z, asset_advanced_field_config/* default */.Z, advanced_field_config/* default */.Z)
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-with-background-text-and-asset/index.js

var SideBySideWithBackgroundTextAndAssetComponent = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 5600).then(__webpack_require__.bind(__webpack_require__, 95600));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(95600)
            ];
        }
    }
});


/* harmony default export */ var side_by_side_with_background_text_and_asset = ({
    SideBySideWithBackgroundTextAndAssetComponent: SideBySideWithBackgroundTextAndAssetComponent,
    SideBySideWithBackgroundTextAndAssetConfig: side_by_side_with_background_text_and_asset_config,
    SideBySideWithBackgroundTextAndAssetAdvancedConfig: side_by_side_with_background_text_and_asset_advanced_config
});

// EXTERNAL MODULE: ./segments/desktop/text-and-asset/layouts/side-by-side-text-and-asset/index.js + 2 modules
var side_by_side_text_and_asset = __webpack_require__(25514);
;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/layouts/index.js
// plop_marker:layouts_import













/* harmony default export */ var layouts = ({
    // plop_marker:layouts_add_layout
    ProductCardsSideBySideTextAndAsset: product_cards_side_by_side_text_and_asset,
    WhatsNewInnerPageSideBySideTextAndAsset: whats_new_inner_page_side_by_side_text_and_asset,
    YoutubeTextAndAsset: youtube_text_and_asset,
    SideBySideWithIconsTextAndAsset: side_by_side_with_icons_text_and_asset,
    BoardTabTextAndAsset: board_tab_text_and_asset,
    TwoThirdsTextAndAsset: two_thirds_text_and_asset,
    FullBackgroundTextAndAsset: full_background_text_and_asset/* default */.Z,
    SideBySideWithBackgroundTextAndAsset: side_by_side_with_background_text_and_asset,
    SideBySideTextAndAsset: side_by_side_text_and_asset/* default */.Z,
    YoutubeTwoThirdsTextAndAsset: youtube_two_thirds_text_and_asset,
    AsymmetricSideBySideTextAndAsset: asymmetric_side_by_side_text_and_asset,
    SideBySideWithBulletsTextAndAsset: side_by_side_with_bullets_text_and_asset,
    TestimonialsTextAndAsset: testimonials_text_and_asset
});

;// CONCATENATED MODULE: ./segments/desktop/text-and-asset/index.js

var ProductCardsSideBySideTextAndAsset = layouts.ProductCardsSideBySideTextAndAsset, WhatsNewInnerPageSideBySideTextAndAsset = layouts.WhatsNewInnerPageSideBySideTextAndAsset, YoutubeTextAndAsset = layouts.YoutubeTextAndAsset, text_and_asset_SideBySideWithIconsTextAndAsset = layouts.SideBySideWithIconsTextAndAsset, BoardTabTextAndAsset = layouts.BoardTabTextAndAsset, YoutubeTwoThirdsTextAndAsset = layouts.YoutubeTwoThirdsTextAndAsset, AsymmetricSideBySideTextAndAsset = layouts.AsymmetricSideBySideTextAndAsset, TestimonialsTextAndAsset = layouts.TestimonialsTextAndAsset, SideBySideWithBulletsTextAndAsset = layouts.SideBySideWithBulletsTextAndAsset, TwoThirdsTextAndAsset = layouts.TwoThirdsTextAndAsset, FullBackgroundTextAndAsset = layouts.FullBackgroundTextAndAsset, SideBySideWithBackgroundTextAndAsset = layouts.SideBySideWithBackgroundTextAndAsset, SideBySideTextAndAsset = layouts.SideBySideTextAndAsset;
/* harmony default export */ var text_and_asset = ({
    // plop_marker:segment_index_add_layout
    ProductCardsSideBySideTextAndAssetComponent: {
        type: "ProductCardsSideBySideTextAndAssetComponent",
        title: "Product Cards Side By Side",
        imgSrc: "/static/img/segments/layouts/product-cards-side-by-side-text-and-asset.png",
        config: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetConfig,
        advancedConfig: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetAdvancedConfig,
        component: ProductCardsSideBySideTextAndAsset.ProductCardsSideBySideTextAndAssetComponent
    },
    WhatsNewInnerPageSideBySideTextAndAssetComponent: {
        type: "WhatsNewInnerPageSideBySideTextAndAssetComponent",
        title: "Whats New Inner Page Side By Side",
        imgSrc: "/static/img/segments/layouts/whats-new-inner-page-side-by-side-text-and-asset.png",
        config: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetConfig,
        advancedConfig: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetAdvancedConfig,
        component: WhatsNewInnerPageSideBySideTextAndAsset.WhatsNewInnerPageSideBySideTextAndAssetComponent
    },
    YoutubeTextAndAssetComponent: {
        type: "YoutubeTextAndAssetComponent",
        title: "Youtube",
        imgSrc: "/static/img/segments/layouts/youtube-text-and-asset.png",
        config: YoutubeTextAndAsset.YoutubeTextAndAssetConfig,
        advancedConfig: YoutubeTextAndAsset.YoutubeTextAndAssetAdvancedConfig,
        component: YoutubeTextAndAsset.YoutubeTextAndAssetComponent
    },
    SideBySideWithIconsTextAndAssetComponent: {
        type: "SideBySideWithIconsTextAndAssetComponent",
        title: "Side By Side With Icons",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-icons-text-and-asset.png",
        config: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetConfig,
        advancedConfig: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetAdvancedConfig,
        component: text_and_asset_SideBySideWithIconsTextAndAsset.SideBySideWithIconsTextAndAssetComponent
    },
    BoardTabTextAndAssetComponent: {
        type: "BoardTabTextAndAssetComponent",
        title: "Board Tab",
        imgSrc: "/static/img/segments/layouts/board-tab-text-and-asset.png",
        config: BoardTabTextAndAsset.BoardTabTextAndAssetConfig,
        advancedConfig: BoardTabTextAndAsset.BoardTabTextAndAssetAdvancedConfig,
        component: BoardTabTextAndAsset.BoardTabTextAndAssetComponent
    },
    YoutubeTwoThirdsTextAndAssetComponent: {
        type: "YoutubeTwoThirdsTextAndAssetComponent",
        title: "Youtube Two Thirds",
        imgSrc: "/static/img/segments/layouts/youtube-two-thirds-text-and-asset.png",
        config: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetConfig,
        advancedConfig: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetAdvancedConfig,
        component: YoutubeTwoThirdsTextAndAsset.YoutubeTwoThirdsTextAndAssetComponent
    },
    AsymmetricSideBySideTextAndAssetComponent: {
        type: "AsymmetricSideBySideTextAndAssetComponent",
        title: "Asymmetric Side By Side",
        imgSrc: "/static/img/segments/layouts/asymmetric-side-by-side-text-and-asset.png",
        config: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetConfig,
        advancedConfig: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetAdvancedConfig,
        component: AsymmetricSideBySideTextAndAsset.AsymmetricSideBySideTextAndAssetComponent
    },
    TestimonialsTextAndAssetComponent: {
        type: "TestimonialsTextAndAssetComponent",
        title: "Testimonials",
        imgSrc: "/static/img/segments/layouts/testimonials-text-and-asset.png",
        config: TestimonialsTextAndAsset.TestimonialsTextAndAssetConfig,
        advancedConfig: TestimonialsTextAndAsset.TestimonialsTextAndAssetAdvancedConfig,
        component: TestimonialsTextAndAsset.TestimonialsTextAndAssetComponent
    },
    SideBySideWithBulletsTextAndAssetComponent: {
        type: "SideBySideWithBulletsTextAndAssetComponent",
        title: "Side By Side With Bullets",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-bullets-text-and-asset.png",
        config: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetConfig,
        advancedConfig: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetAdvancedConfig,
        component: SideBySideWithBulletsTextAndAsset.SideBySideWithBulletsTextAndAssetComponent
    },
    TwoThirdsTextAndAssetComponent: {
        type: "TwoThirdsTextAndAssetComponent",
        title: "Two Thirds",
        imgSrc: "/static/img/segments/layouts/two-thirds-text-and-asset.png",
        config: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetConfig,
        advancedConfig: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetAdvancedConfig,
        component: TwoThirdsTextAndAsset.TwoThirdsTextAndAssetComponent
    },
    FullBackgroundTextAndAssetComponent: {
        type: "FullBackgroundTextAndAssetComponent",
        title: "Full Background",
        imgSrc: "/static/img/segments/layouts/full-background-text-and-asset.png",
        config: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetConfig,
        advancedConfig: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetAdvancedConfig,
        component: FullBackgroundTextAndAsset.FullBackgroundTextAndAssetComponent
    },
    SideBySideWithBackgroundTextAndAssetComponent: {
        type: "SideBySideWithBackgroundTextAndAssetComponent",
        title: "Side By Side With Background",
        imgSrc: "/static/img/segments/layouts/side-by-side-with-background-text-and-asset.png",
        config: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetConfig,
        advancedConfig: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetAdvancedConfig,
        component: SideBySideWithBackgroundTextAndAsset.SideBySideWithBackgroundTextAndAssetComponent
    },
    SideBySideTextAndAssetComponent: {
        type: "SideBySideTextAndAssetComponent",
        title: "Side By Side",
        imgSrc: "/static/img/segments/layouts/side-by-side-text-and-asset.png",
        config: SideBySideTextAndAsset.SideBySideTextAndAssetConfig,
        advancedConfig: SideBySideTextAndAsset.SideBySideTextAndAssetAdvancedConfig,
        component: SideBySideTextAndAsset.SideBySideTextAndAssetComponent
    }
});


/***/ }),

/***/ 38305:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_sizes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77869);
/* harmony import */ var constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65832);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91841);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



/* harmony default export */ __webpack_exports__["Z"] = (_object_spread_props(_object_spread({}, segments_desktop_core_components_side_by_side_text_and_asset_default_props__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z), {
    paddingTop: "64px",
    paddingBottom: "64px",
    titleSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    textSize: constants_sizes__WEBPACK_IMPORTED_MODULE_1__.MD,
    assetQuality: constants_cloudinary_asset_qualities__WEBPACK_IMPORTED_MODULE_2__.AUTO,
    nestedBoardItems: {
        //props that are relevant only if the live board experience is added
        addLiveBoardTextAndAsset: false,
        boardBannerText: "Sign up for free to gain full access to all features",
        embeddedBoardTitle: "Project plan",
        addSecondLiveBoardSignUpButton: false
    }
}));


/***/ }),

/***/ 8150:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ SideBySideTextAndAssetComponent; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59526);
/* harmony import */ var _default_props__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38305);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}




var SideBySideTextAndAssetComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent);
    function SideBySideTextAndAssetComponent() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(this, SideBySideTextAndAssetComponent);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(SideBySideTextAndAssetComponent, [
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "side-by-side-text-and-asset-component",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(segments_desktop_core_components_side_by_side_text_and_asset_side_by_side_text_and_asset__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, _object_spread({}, this.props))
                });
            }
        }
    ]);
    return SideBySideTextAndAssetComponent;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);

SideBySideTextAndAssetComponent.defaultProps = _default_props__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z;


/***/ }),

/***/ 49133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40559);
/* harmony import */ var constants_template_field_type__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93097);
/* harmony import */ var segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60633);
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}



var background = segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"].background */ .Z.background, selectedSideBySideTextAndAssetFieldsConfig = _object_without_properties(segments_desktop_core_components_side_by_side_text_and_asset_fields_config__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, [
    "background"
]);
/* harmony default export */ __webpack_exports__["Z"] = ({
    type: constants_template_field_type__WEBPACK_IMPORTED_MODULE_0__.FIELD_TYPES.NESTED,
    label: "Two Thirds",
    fields: _object_spread({}, segments_core_configs_theme_config__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, selectedSideBySideTextAndAssetFieldsConfig)
});


/***/ }),

/***/ 80724:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60460);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10092);





function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var MONDAY_CONFIG_FETCH_ERROR = (__webpack_require__(65023).MONDAY_CONFIG_FETCH_ERROR);
var REFRESH_INTERVAL_MINUTES = 15 * 60;
var MONDAY_API_URL = "https://api.monday.com/v2";
var MONDAY_API_TOKEN_NAME = "monday_api_token";
var getMondayServiceAPIKey = function() {
    var _ref = _async_to_generator(function() {
        var get;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
            get = (__webpack_require__(61217).get);
            return [
                2,
                get(MONDAY_API_TOKEN_NAME)
            ];
        });
    });
    return function getMondayServiceAPIKey() {
        return _ref.apply(this, arguments);
    };
}();
var MondayBoardConfigProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(MondayBoardConfigProvider, BaseDataProvider);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(MondayBoardConfigProvider);
    function MondayBoardConfigProvider(params) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(this, MondayBoardConfigProvider);
        return _super.call(this, params);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(MondayBoardConfigProvider, [
        {
            key: "key",
            value: function key() {
                var boardId = this.params().boardId;
                return "".concat(ProviderKeys.MONDAY_BOARD_CONFIG, "_board_").concat(boardId);
            }
        },
        {
            key: "refreshInterval",
            value: function refreshInterval() {
                return REFRESH_INTERVAL_MINUTES;
            }
        },
        {
            key: "validate",
            value: function validate(value) {
                var _value_data_boards__items_page, _value_data_boards_, _value_data_boards, _value_data;
                var items = value === null || value === void 0 ? void 0 : (_value_data = value.data) === null || _value_data === void 0 ? void 0 : (_value_data_boards = _value_data.boards) === null || _value_data_boards === void 0 ? void 0 : (_value_data_boards_ = _value_data_boards[0]) === null || _value_data_boards_ === void 0 ? void 0 : (_value_data_boards__items_page = _value_data_boards_.items_page) === null || _value_data_boards__items_page === void 0 ? void 0 : _value_data_boards__items_page.items;
                return (items === null || items === void 0 ? void 0 : items.length) >= 20;
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var query, MONDAY_SERVICE_API_KEY, res, response, e;
                    return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_0__.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                query = _this.params().query;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    ,
                                    8
                                ]);
                                return [
                                    4,
                                    getMondayServiceAPIKey()
                                ];
                            case 2:
                                MONDAY_SERVICE_API_KEY = _state.sent();
                                return [
                                    4,
                                    fetch(MONDAY_API_URL, {
                                        method: "post",
                                        headers: {
                                            "Content-Type": "application/json",
                                            Authorization: MONDAY_SERVICE_API_KEY,
                                            "API-Version": "2024-04"
                                        },
                                        body: JSON.stringify({
                                            query: query
                                        })
                                    })
                                ];
                            case 3:
                                res = _state.sent();
                                if (!((res === null || res === void 0 ? void 0 : res.status) === 200)) return [
                                    3,
                                    5
                                ];
                                return [
                                    4,
                                    res.json()
                                ];
                            case 4:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 5:
                                throw new Error(res.statusText);
                            case 6:
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                e = _state.sent();
                                trackBigBrainEventOnServer(MONDAY_CONFIG_FETCH_ERROR, {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return MondayBoardConfigProvider;
}(BaseDataProvider);
/* harmony default export */ __webpack_exports__["default"] = (MondayBoardConfigProvider);


/***/ }),

/***/ 28586:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _classCallCheck = (__webpack_require__(79658)/* ["default"] */ .Z);
var _createClass = (__webpack_require__(7222)/* ["default"] */ .Z);
var _inherits = (__webpack_require__(97788)/* ["default"] */ .Z);
var _createSuper = (__webpack_require__(37735)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var trackBigBrainEventOnServer = (__webpack_require__(75422).trackBigBrainEventOnServer);
var BaseDataProvider = (__webpack_require__(73645).BaseDataProvider);
var ProviderKeys = __webpack_require__(15071);
var PLATFORM_SERVICE_HOST = "https://auth.monday.com";
var MONDAY_SOLUTIONS_ENDPOINT = "monday_solutions";
var MONDAY_SOLUTIONS_FETCH_SUCCESS = "monday_solutions_fetch_success";
var MONDAY_SOLUTIONS_FETCH_ERROR = "monday_solutions_fetch_error";
var LOCALE_PARAM_NAME = "locale";
var SolutionsDataProvider = /*#__PURE__*/ function(BaseDataProvider) {
    "use strict";
    _inherits(SolutionsDataProvider, BaseDataProvider);
    var _super = _createSuper(SolutionsDataProvider);
    function SolutionsDataProvider(params) {
        _classCallCheck(this, SolutionsDataProvider);
        return _super.call(this, params);
    }
    _createClass(SolutionsDataProvider, [
        {
            key: "key",
            value: function key() {
                var localeId = this.params().localeId;
                return "".concat(ProviderKeys.SOLUTIONS_DATA, "_locale_").concat(localeId);
            }
        },
        {
            key: "getData",
            value: function getData() {
                var _this = this;
                return _async_to_generator(function() {
                    var localeId, options, url, res, response, e;
                    return _tsGenerator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                localeId = _this.params().localeId;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    ,
                                    7
                                ]);
                                options = {
                                    headers: {
                                        "Content-Type": "application/json"
                                    },
                                    method: "GET"
                                };
                                url = new URL("".concat(MONDAY_SOLUTIONS_ENDPOINT, "?").concat(LOCALE_PARAM_NAME, "=").concat(localeId), PLATFORM_SERVICE_HOST).href;
                                return [
                                    4,
                                    fetch(url, options)
                                ];
                            case 2:
                                res = _state.sent();
                                if (!(res.status === 200)) return [
                                    3,
                                    4
                                ];
                                trackBigBrainEventOnServer(MONDAY_SOLUTIONS_FETCH_SUCCESS);
                                return [
                                    4,
                                    res.json()
                                ];
                            case 3:
                                response = _state.sent();
                                return [
                                    2,
                                    response
                                ];
                            case 4:
                                throw new Error(res.statusText);
                            case 5:
                                return [
                                    3,
                                    7
                                ];
                            case 6:
                                e = _state.sent();
                                trackBigBrainEventOnServer(MONDAY_SOLUTIONS_FETCH_ERROR, {
                                    direct_object: e.message
                                });
                                console.error(e.message);
                                throw e;
                            case 7:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return SolutionsDataProvider;
}(BaseDataProvider);
module.exports = SolutionsDataProvider;


/***/ }),

/***/ 42495:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
var _bigbrainTrackingService = __webpack_require__(75422);
var _mondayBoardConfigProvider = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(80724));
var _baseDataProvider = __webpack_require__(73645);
var _bigbrainEventTypes = __webpack_require__(65023);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var getMondayConfig = function() {
    var _ref = _async_to_generator(function(param) {
        var query, boardId, mondayConfig, provider, exception;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, boardId = param.boardId;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    provider = new _mondayBoardConfigProvider.default({
                        query: query,
                        boardId: boardId
                    });
                    return [
                        4,
                        (0, _baseDataProvider.getCachedData)(provider)
                    ];
                case 2:
                    mondayConfig = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    exception = _state.sent();
                    (0, _bigbrainTrackingService.trackBigBrainEventOnServer)(_bigbrainEventTypes.MONDAY_CONFIG_INTERNAL_ERROR, {
                        info1: exception.message,
                        info2: query,
                        info3: boardId
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2,
                        mondayConfig
                    ];
            }
        });
    });
    return function getMondayConfig(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getMondayConfig: getMondayConfig
};


/***/ }),

/***/ 40469:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _tsGenerator = (__webpack_require__(32401)/* ["default"] */ .Z);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SolutionsDataProvider = __webpack_require__(28586);
var getCachedData = (__webpack_require__(73645).getCachedData);
var getMondaySolutionData = function() {
    var _ref = _async_to_generator(function(localeId) {
        var provider, data;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    provider = new SolutionsDataProvider({
                        localeId: localeId
                    });
                    return [
                        4,
                        getCachedData(provider)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return function getMondaySolutionData(localeId) {
        return _ref.apply(this, arguments);
    };
}();
var getMondaySolutionById = function() {
    var _ref = _async_to_generator(function(param) {
        var localeId, solutionId, solutions, solution;
        return _tsGenerator(this, function(_state) {
            switch(_state.label){
                case 0:
                    localeId = param.localeId, solutionId = param.solutionId;
                    return [
                        4,
                        getMondaySolutionData(localeId)
                    ];
                case 1:
                    solutions = _state.sent().solutions;
                    solution = solutions.find(function(param) {
                        var id = param.id;
                        return "".concat(id) === "".concat(solutionId);
                    });
                    return [
                        2,
                        solution
                    ];
            }
        });
    });
    return function getMondaySolutionById(_) {
        return _ref.apply(this, arguments);
    };
}();
module.exports = {
    getMondaySolutionData: getMondaySolutionData,
    getMondaySolutionById: getMondaySolutionById
};


/***/ }),

/***/ 90215:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Aq": function() { return /* binding */ migrateExistingTranslations; },
/* harmony export */   "Ed": function() { return /* binding */ getPageExists; },
/* harmony export */   "IS": function() { return /* binding */ restorePage; },
/* harmony export */   "OP": function() { return /* binding */ fetchAbTestsData; },
/* harmony export */   "Po": function() { return /* binding */ startAbTest; },
/* harmony export */   "RC": function() { return /* binding */ createAbTest; },
/* harmony export */   "Sz": function() { return /* binding */ getSolutions; },
/* harmony export */   "U$": function() { return /* binding */ fetchTranslatedPages; },
/* harmony export */   "YS": function() { return /* binding */ createTranslationJobs; },
/* harmony export */   "fD": function() { return /* binding */ removePage; },
/* harmony export */   "fx": function() { return /* binding */ getPage; },
/* harmony export */   "r7": function() { return /* binding */ refreshTranslationJobsStatus; },
/* harmony export */   "rK": function() { return /* binding */ getOrCreatePageModel; },
/* harmony export */   "st": function() { return /* binding */ publishPage; },
/* harmony export */   "xK": function() { return /* binding */ stopAbTest; },
/* harmony export */   "zM": function() { return /* binding */ fetchDraftConfig; },
/* harmony export */   "zt": function() { return /* binding */ getSolutionById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10092);
/* harmony import */ var _base_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20012);

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

var LOCAL_URL_BASE = "http://localhost:5000";
var getPage = function(path, options) {
    var isServer = !true;
    var baseUrl = isServer ? LOCAL_URL_BASE : _base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L;
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(baseUrl, "/get-page-config?path=").concat(path));
};
var getPageExists = function(path, options) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/generated-page-exists?path=").concat(path));
};
var removePage = function(path) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/remove-page?path=").concat(path), {
        method: "POST"
    });
};
var publishPage = function(pageConfig) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/publish"), {
        method: "POST",
        body: JSON.stringify({
            pageConfig: pageConfig
        })
    });
};
var restorePage = function(path, historyIndex) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/restore-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            historyIndex: historyIndex
        })
    });
};
var getOrCreatePageModel = function(path) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/get-or-create-page"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var migrateExistingTranslations = function(path) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/migrate-existing-translations"), {
        method: "POST",
        body: JSON.stringify({
            path: path
        })
    });
};
var fetchTranslatedPages = function(filter) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/get-translated-pages?filter=").concat(filter), {
        method: "GET"
    });
};
var createTranslationJobs = function(path, languages, translationStrategy) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/create-translation-jobs"), {
        method: "POST",
        body: JSON.stringify({
            path: path,
            languages: languages,
            translationStrategy: translationStrategy
        })
    });
};
var refreshTranslationJobsStatus = function() {
    var _ref = _async_to_generator(function() {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            return [
                2,
                (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/refresh-translation-jobs-status"), {
                    method: "POST"
                })
            ];
        });
    });
    return function refreshTranslationJobsStatus() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDraftConfig = function(translationJobId) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/get-translation-job/").concat(translationJobId, "/draft-config"), {
        method: "GET"
    });
};
var createAbTest = function(abTestData) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/create-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestData: abTestData
        })
    });
};
var fetchAbTestsData = function() {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/fetch-ab-tests-data"), {
        method: "GET"
    });
};
var startAbTest = function(abTestId) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/start-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var stopAbTest = function(abTestId) {
    return (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/stop-ab-test"), {
        method: "POST",
        body: JSON.stringify({
            abTestId: abTestId
        })
    });
};
var getSolutions = function() {
    var _ref = _async_to_generator(function() {
        var res, solutions;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/get-solutions"), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solutions = _state.sent();
                    return [
                        2,
                        solutions
                    ];
            }
        });
    });
    return function getSolutions() {
        return _ref.apply(this, arguments);
    };
}();
var getSolutionById = function() {
    var _ref = _async_to_generator(function(param) {
        var solutionId, localeId, res, solution;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    solutionId = param.solutionId, localeId = param.localeId;
                    return [
                        4,
                        (0,_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .baseFetch */ .H)("".concat(_base_fetch__WEBPACK_IMPORTED_MODULE_0__/* .URL_BASE */ .L, "/dynamic/templates-generator/get-solution?localeId=").concat(localeId, "&solutionId=").concat(solutionId), {
                            method: "GET"
                        })
                    ];
                case 1:
                    res = _state.sent();
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    solution = _state.sent();
                    return [
                        2,
                        solution
                    ];
            }
        });
    });
    return function getSolutionById(_) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 49169:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-specialists":"AiAgents_sec-specialists__4BPwP","m_padding-global":"AiAgents_m_padding-global__mzsLN","m_padding-section-medium":"AiAgents_m_padding-section-medium__sYMwK","m_padding-section-small":"AiAgents_m_padding-section-small__N2Zos","m_padding-section-large":"AiAgents_m_padding-section-large__VsRfp","m_container-large":"AiAgents_m_container-large__eBy10","for--departments":"AiAgents_for--departments__GABf6","group_sec-h-center":"AiAgents_group_sec-h-center__QG_u5","labe-gradient-parent":"AiAgents_labe-gradient-parent__6r2UO","labe-gradient-inner":"AiAgents_labe-gradient-inner__dwWj5","fw1_section-headline-parent":"AiAgents_fw1_section-headline-parent__wVbtI","is--center":"AiAgents_is--center__K36Ha","fw1_section-title":"AiAgents_fw1_section-title__ucgyh","is--short":"AiAgents_is--short__sg7yS","is--shorter":"AiAgents_is--shorter__S7h83","m_text-color-white":"AiAgents_m_text-color-white__UEwjZ","sec-sub-center-par":"AiAgents_sec-sub-center-par__1rWeL","comp_ai-spec":"AiAgents_comp_ai-spec__6BdK8","comp_ai-spec-moving":"AiAgents_comp_ai-spec-moving__TR6S_","for--edit":"AiAgents_for--edit__Muzrl","ai-specialist-card":"AiAgents_ai-specialist-card___xpqG","is-open":"AiAgents_is-open__GSd8Y","agent-card-6":"AiAgents_agent-card-6__u79gg","agent-card-3":"AiAgents_agent-card-3__gBKZ3","ai-teams-card-top":"AiAgents_ai-teams-card-top__BXP3W","ai-teams-card-title":"AiAgents_ai-teams-card-title__nxXWV","ai-teams-card-par":"AiAgents_ai-teams-card-par__4l3mk","is-short":"AiAgents_is-short__HwtG2","is-short-2":"AiAgents_is-short-2__5_3tq","ai-spec-card-img-before-parent":"AiAgents_ai-spec-card-img-before-parent__1JZL8","ai-teams-card-img-before":"AiAgents_ai-teams-card-img-before__mqMaU","ai-spec-card-img-after-parent":"AiAgents_ai-spec-card-img-after-parent__kh3Zz","ai-teams-card-img-after":"AiAgents_ai-teams-card-img-after__ncgvp","fw1_button-combo":"AiAgents_fw1_button-combo__pyoqN","for--agents":"AiAgents_for--agents__SUvhQ","m_button":"AiAgents_m_button__mdQxy","m_button-dev":"AiAgents_m_button-dev__bNQZN","for--hero":"AiAgents_for--hero__itL6d","for--modal":"AiAgents_for--modal__uhkKA","m_button-primary":"AiAgents_m_button-primary__IMZP2","for--mb-hp":"AiAgents_for--mb-hp__6rWMn","m_button-primary-white":"AiAgents_m_button-primary-white__6Orm7","btn-gradient":"AiAgents_btn-gradient__vKZEd","hero-btn-project":"AiAgents_hero-btn-project__el23D","is-visible":"AiAgents_is-visible__wbP0D","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"AiAgents_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__TfmkT","hero-btn-crm":"AiAgents_hero-btn-crm__M5aG6","hero-btn-dev":"AiAgents_hero-btn-dev__3nzvo","hero-btn-svc":"AiAgents_hero-btn-svc__VWwc2","hero-btn-marketing":"AiAgents_hero-btn-marketing__Wb4cU","hero-btn-ops":"AiAgents_hero-btn-ops__HCRr7","m_button-crm":"AiAgents_m_button-crm__xqohB","m_button-svc":"AiAgents_m_button-svc__B0_L_","for--magic":"AiAgents_for--magic__M4TxX","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"AiAgents_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__A6vNb","hero-btn-purple":"AiAgents_hero-btn-purple__Jw0H2","m_button-arrow":"AiAgents_m_button-arrow__ajo77","m_button-link":"AiAgents_m_button-link__aBU9i","m_button-link-white":"AiAgents_m_button-link-white__HaKV_","push-to-bottom":"AiAgents_push-to-bottom__7SHGO","m_link-underline":"AiAgents_m_link-underline__yj003","link-underline-white":"AiAgents_link-underline-white__clXDv","bg-color-white":"AiAgents_bg-color-white__IoTAG"};

/***/ }),

/***/ 98516:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-teams":"AiTeamsImpact_sec-teams__SruSz","m_padding-global":"AiTeamsImpact_m_padding-global__LGOyG","m_padding-section-medium":"AiTeamsImpact_m_padding-section-medium__LIrVN","m_padding-section-small":"AiTeamsImpact_m_padding-section-small__EUjTF","m_padding-section-large":"AiTeamsImpact_m_padding-section-large__enwm2","m_container-large":"AiTeamsImpact_m_container-large__ouRz3","for--departments":"AiTeamsImpact_for--departments__aIprY","group_sec-h-center":"AiTeamsImpact_group_sec-h-center__rOHRN","ai-impact-star":"AiTeamsImpact_ai-impact-star__PIKbJ","fw1_section-headline-parent":"AiTeamsImpact_fw1_section-headline-parent__Gj5qm","is--center":"AiTeamsImpact_is--center__aP9Gk","fw1_section-title-lr":"AiTeamsImpact_fw1_section-title-lr__2orER","is--short":"AiTeamsImpact_is--short__clzXC","is--shorter":"AiTeamsImpact_is--shorter__dRCUd","m_text-color-white":"AiTeamsImpact_m_text-color-white__G2W4L","for--cta":"AiTeamsImpact_for--cta__XV3lj","with-llama-closer-text":"AiTeamsImpact_with-llama-closer-text__Un_AP","is-smaller-headline":"AiTeamsImpact_is-smaller-headline__T4EI8","fw1_button-parent":"AiTeamsImpact_fw1_button-parent__vo0_H","for--impact":"AiTeamsImpact_for--impact__XyrWl","m_button-link":"AiTeamsImpact_m_button-link__PPNcR","m_button-link-white":"AiTeamsImpact_m_button-link-white__y6QoC","push-to-bottom":"AiTeamsImpact_push-to-bottom__v4Jmn","m_button-arrow":"AiTeamsImpact_m_button-arrow__xuXkb","for--magic":"AiTeamsImpact_for--magic__Ilq_l","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"AiTeamsImpact_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__4WQhS","m_link-underline":"AiTeamsImpact_m_link-underline__UQXw_","link-underline-white":"AiTeamsImpact_link-underline-white__O0bxV","bg-color-white":"AiTeamsImpact_bg-color-white__YBzZr","comp_teams-tabs":"AiTeamsImpact_comp_teams-tabs___fP9h","hp_teams-fade":"AiTeamsImpact_hp_teams-fade__KfgUH","is--right":"AiTeamsImpact_is--right__ItPSZ","ai-teams-layout":"AiTeamsImpact_ai-teams-layout__Pnlr_","ai-teams-left":"AiTeamsImpact_ai-teams-left__774aX","ai-teams-left-child":"AiTeamsImpact_ai-teams-left-child__pSO90","splide":"AiTeamsImpact_splide__ZheLF","_w--arrow-bottom":"AiTeamsImpact__w--arrow-bottom__HRdMm","for--tabs":"AiTeamsImpact_for--tabs__Rybbp","for--tab-content":"AiTeamsImpact_for--tab-content__R_Il_","comp_hp-hero-tabs-splide":"AiTeamsImpact_comp_hp-hero-tabs-splide__edRwz","splide__list":"AiTeamsImpact_splide__list__CECGU","for--tabs-hero":"AiTeamsImpact_for--tabs-hero__KeX3v","for--hero-tab-content":"AiTeamsImpact_for--hero-tab-content__rMctD","_w--video":"AiTeamsImpact__w--video__vNjHA","for--impact-lang":"AiTeamsImpact_for--impact-lang__UzUFv","ai-teams-tabs-menu":"AiTeamsImpact_ai-teams-tabs-menu__FbGMP","splide__track":"AiTeamsImpact_splide__track__Bdt42","ai-teams-tabs-list":"AiTeamsImpact_ai-teams-tabs-list__mf3Ae","ai-impact-tab-link-parent":"AiTeamsImpact_ai-impact-tab-link-parent__VHO_h","last--child":"AiTeamsImpact_last--child__FEpgY","splide__slide":"AiTeamsImpact_splide__slide__ikP_s","is-active":"AiTeamsImpact_is-active__coxf5","ai-impact-tab-link-inner":"AiTeamsImpact_ai-impact-tab-link-inner__P9bzT","ai-impact-tab-link-child":"AiTeamsImpact_ai-impact-tab-link-child__GI0Iy","ai_impact-icon-parent":"AiTeamsImpact_ai_impact-icon-parent__OxZGN","first--child":"AiTeamsImpact_first--child__u9gvD","ai_impact-icon":"AiTeamsImpact_ai_impact-icon__kcIK3","ai-impact-tab-h":"AiTeamsImpact_ai-impact-tab-h__KHI_R","ai-teams-right":"AiTeamsImpact_ai-teams-right__YGlMZ","for--tabs-content":"AiTeamsImpact_for--tabs-content__Sb695","for--tabs-content-hero":"AiTeamsImpact_for--tabs-content-hero__OuJ56","is--full":"AiTeamsImpact_is--full___Er6U","for--edit":"AiTeamsImpact_for--edit__g5mwb","hp-hero-tabs-list":"AiTeamsImpact_hp-hero-tabs-list___r3hj","is--full-height":"AiTeamsImpact_is--full-height__jrHrV","for--ana":"AiTeamsImpact_for--ana__tQqQ_","for--tab-pane":"AiTeamsImpact_for--tab-pane__vvJly","for-3-perview":"AiTeamsImpact_for-3-perview__2wjld","ai-blocks-vid-embed":"AiTeamsImpact_ai-blocks-vid-embed__JxK3E","w-node-_08c9486e-f209-18cb-67c7-4107f41fcc35-83da2f7a":"AiTeamsImpact_w-node-_08c9486e-f209-18cb-67c7-4107f41fcc35-83da2f7a__z7UER"};

/***/ }),

/***/ 96663:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-teams":"AiTeamsImpactLang_sec-teams__NxwCc","m_padding-global":"AiTeamsImpactLang_m_padding-global__xQc8r","m_padding-section-medium":"AiTeamsImpactLang_m_padding-section-medium__2HHeM","m_padding-section-small":"AiTeamsImpactLang_m_padding-section-small__bNN_Y","m_padding-section-large":"AiTeamsImpactLang_m_padding-section-large__g2fL6","m_container-large":"AiTeamsImpactLang_m_container-large__nvbJr","for--departments":"AiTeamsImpactLang_for--departments__ipKIS","group_sec-h-center":"AiTeamsImpactLang_group_sec-h-center__O3ooe","ai-impact-star":"AiTeamsImpactLang_ai-impact-star__UfCFk","fw1_section-headline-parent":"AiTeamsImpactLang_fw1_section-headline-parent__J_NtL","is--center":"AiTeamsImpactLang_is--center__7Obb9","fw1_section-title-lr":"AiTeamsImpactLang_fw1_section-title-lr__ing1T","is--short":"AiTeamsImpactLang_is--short__0MdPS","is--shorter":"AiTeamsImpactLang_is--shorter__uhmG3","m_text-color-white":"AiTeamsImpactLang_m_text-color-white__jHAwU","for--cta":"AiTeamsImpactLang_for--cta__W3DDs","with-llama-closer-text":"AiTeamsImpactLang_with-llama-closer-text___rtEE","is-smaller-headline":"AiTeamsImpactLang_is-smaller-headline__EYlG8","fw1_button-parent":"AiTeamsImpactLang_fw1_button-parent__5ovRE","for--impact":"AiTeamsImpactLang_for--impact__105Ny","m_button-link":"AiTeamsImpactLang_m_button-link__5zuhy","m_button-link-white":"AiTeamsImpactLang_m_button-link-white__84hTH","push-to-bottom":"AiTeamsImpactLang_push-to-bottom__kLdr_","m_button-arrow":"AiTeamsImpactLang_m_button-arrow__ydsnW","for--magic":"AiTeamsImpactLang_for--magic__HeMPo","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"AiTeamsImpactLang_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__R_lmH","m_link-underline":"AiTeamsImpactLang_m_link-underline__p8OIp","link-underline-white":"AiTeamsImpactLang_link-underline-white__sKyvU","bg-color-white":"AiTeamsImpactLang_bg-color-white__8hU73","comp_teams-tabs":"AiTeamsImpactLang_comp_teams-tabs__CzpBa","hp_teams-fade":"AiTeamsImpactLang_hp_teams-fade__a71oX","is--right":"AiTeamsImpactLang_is--right__9MrLA","ai-teams-layout":"AiTeamsImpactLang_ai-teams-layout__ZC7I4","ai-teams-left":"AiTeamsImpactLang_ai-teams-left__AVVdH","ai-teams-left-child":"AiTeamsImpactLang_ai-teams-left-child__69819","splide":"AiTeamsImpactLang_splide__fknyg","_w--arrow-bottom":"AiTeamsImpactLang__w--arrow-bottom__JR9Ra","for--tabs":"AiTeamsImpactLang_for--tabs__ClJcB","for--tab-content":"AiTeamsImpactLang_for--tab-content__EaZuT","comp_hp-hero-tabs-splide":"AiTeamsImpactLang_comp_hp-hero-tabs-splide__JxDIk","splide__list":"AiTeamsImpactLang_splide__list__QQn9c","for--tabs-hero":"AiTeamsImpactLang_for--tabs-hero__9YSaY","for--hero-tab-content":"AiTeamsImpactLang_for--hero-tab-content__xjOrW","_w--video":"AiTeamsImpactLang__w--video__WOxyi","for--impact-lang":"AiTeamsImpactLang_for--impact-lang__yDQX2","ai-teams-tabs-menu":"AiTeamsImpactLang_ai-teams-tabs-menu__keDKn","splide__track":"AiTeamsImpactLang_splide__track__MS067","ai-teams-tabs-list":"AiTeamsImpactLang_ai-teams-tabs-list__9utDm","ai-impact-tab-link-parent":"AiTeamsImpactLang_ai-impact-tab-link-parent__kVEnL","last--child":"AiTeamsImpactLang_last--child__Bc8zU","splide__slide":"AiTeamsImpactLang_splide__slide__2Byb9","is-active":"AiTeamsImpactLang_is-active__ACLmx","ai-impact-tab-link-inner":"AiTeamsImpactLang_ai-impact-tab-link-inner__qOEx6","ai-impact-tab-link-child":"AiTeamsImpactLang_ai-impact-tab-link-child__WOTR1","ai_impact-icon-parent":"AiTeamsImpactLang_ai_impact-icon-parent__LN0HY","first--child":"AiTeamsImpactLang_first--child__AHxvV","ai_impact-icon":"AiTeamsImpactLang_ai_impact-icon__kFuv8","ai-impact-tab-h":"AiTeamsImpactLang_ai-impact-tab-h__JzdYv","ai-teams-right":"AiTeamsImpactLang_ai-teams-right__5LfX2","for--tabs-content":"AiTeamsImpactLang_for--tabs-content__Xsi0v","for--tabs-content-hero":"AiTeamsImpactLang_for--tabs-content-hero__s_d2W","is--full":"AiTeamsImpactLang_is--full__ivRRL","for--edit":"AiTeamsImpactLang_for--edit__azUKV","hp-hero-tabs-list":"AiTeamsImpactLang_hp-hero-tabs-list__dkIuD","is--full-height":"AiTeamsImpactLang_is--full-height__yAtk1","for--ana":"AiTeamsImpactLang_for--ana__3Z9uK","for--tab-pane":"AiTeamsImpactLang_for--tab-pane__Io2o1","for-3-perview":"AiTeamsImpactLang_for-3-perview__lZ_3M","lang-impact-img":"AiTeamsImpactLang_lang-impact-img__AwvM_","w-node-a09da984-2486-1b52-5bee-08a9cb2e2dc4-cb2e2dbb":"AiTeamsImpactLang_w-node-a09da984-2486-1b52-5bee-08a9cb2e2dc4-cb2e2dbb__tPJCI"};

/***/ }),

/***/ 51480:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"white-sec-hero":"BrightHeroLeftPannel_white-sec-hero__vyJDr","m_padding-global-big-cards":"BrightHeroLeftPannel_m_padding-global-big-cards__SwLeg","m_padding-section-small":"BrightHeroLeftPannel_m_padding-section-small__3HQDh","m_padding-section-big-card":"BrightHeroLeftPannel_m_padding-section-big-card__uVHtc","m_padding-section-large":"BrightHeroLeftPannel_m_padding-section-large__BoI59","m_full-card-bright-hero":"BrightHeroLeftPannel_m_full-card-bright-hero__LsPiT","m_container-xl-w":"BrightHeroLeftPannel_m_container-xl-w__sosOi","group_hero-center-all":"BrightHeroLeftPannel_group_hero-center-all__eimFS","m_hero-title-parent":"BrightHeroLeftPannel_m_hero-title-parent___qxUd","fw1_hero-title-black":"BrightHeroLeftPannel_fw1_hero-title-black__d4Oik","is--short":"BrightHeroLeftPannel_is--short__02hFY","is--shorter":"BrightHeroLeftPannel_is--shorter__WLvbE","m_text-color-white":"BrightHeroLeftPannel_m_text-color-white__orS9L","subtitle-white-test-max-width":"BrightHeroLeftPannel_subtitle-white-test-max-width__f2cU_","fw1_hero-sub-black":"BrightHeroLeftPannel_fw1_hero-sub-black__WoGKf","hp-hero-btnsparent":"BrightHeroLeftPannel_hp-hero-btnsparent__kQI7T","m_button":"BrightHeroLeftPannel_m_button__wQdts","m_button-dev":"BrightHeroLeftPannel_m_button-dev__oqU4F","for--hero":"BrightHeroLeftPannel_for--hero__Y0zvc","for--modal":"BrightHeroLeftPannel_for--modal__LWHO_","m_button-primary":"BrightHeroLeftPannel_m_button-primary__TCiX9","for--mb-hp":"BrightHeroLeftPannel_for--mb-hp__6obPW","m_button-primary-white":"BrightHeroLeftPannel_m_button-primary-white___ejKk","btn-gradient":"BrightHeroLeftPannel_btn-gradient__zo8eS","hero-btn-project":"BrightHeroLeftPannel_hero-btn-project__Milil","is-visible":"BrightHeroLeftPannel_is-visible__6RvRA","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"BrightHeroLeftPannel_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__p_aeP","hero-btn-crm":"BrightHeroLeftPannel_hero-btn-crm__DHpVn","hero-btn-dev":"BrightHeroLeftPannel_hero-btn-dev__x5_XM","hero-btn-svc":"BrightHeroLeftPannel_hero-btn-svc__DNPqO","hero-btn-marketing":"BrightHeroLeftPannel_hero-btn-marketing__NhfR5","hero-btn-ops":"BrightHeroLeftPannel_hero-btn-ops__xJcSJ","m_button-crm":"BrightHeroLeftPannel_m_button-crm__mXPpq","m_button-svc":"BrightHeroLeftPannel_m_button-svc__G1aOM","for--magic":"BrightHeroLeftPannel_for--magic__JRxX3","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"BrightHeroLeftPannel_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__atQIg","hero-btn-purple":"BrightHeroLeftPannel_hero-btn-purple__Wu4aa","m_button-arrow":"BrightHeroLeftPannel_m_button-arrow__lb24W","hp-hero-btn-label":"BrightHeroLeftPannel_hp-hero-btn-label__jRhAR","hide":"BrightHeroLeftPannel_hide__aBuwz","m_spacer-3rem":"BrightHeroLeftPannel_m_spacer-3rem___3EBT","comp_hp-hero-tabs":"BrightHeroLeftPannel_comp_hp-hero-tabs__JTnJc","hero-star-1":"BrightHeroLeftPannel_hero-star-1__umPjM","hero-star-2-white":"BrightHeroLeftPannel_hero-star-2-white__uskMl","hp_hero-tabs-fu":"BrightHeroLeftPannel_hp_hero-tabs-fu__jLfX7","hp_hero-tabs-menu-white":"BrightHeroLeftPannel_hp_hero-tabs-menu-white__Fa03Y","hero-card-gradient-white":"BrightHeroLeftPannel_hero-card-gradient-white__ZVG_8","hero-card-gradient-inner-white":"BrightHeroLeftPannel_hero-card-gradient-inner-white__e8cZa","hero-card-gradient-inner-headshot-white":"BrightHeroLeftPannel_hero-card-gradient-inner-headshot-white__1wzcG","hp_hero-tabs-content-fu":"BrightHeroLeftPannel_hp_hero-tabs-content-fu__fPx3t","hp_hero-tab-inner":"BrightHeroLeftPannel_hp_hero-tab-inner__CJNsO","hp_hero-tab-board-parent-white-fu":"BrightHeroLeftPannel_hp_hero-tab-board-parent-white-fu__aYzZZ","hp_hero-tab-board-parent-white":"BrightHeroLeftPannel_hp_hero-tab-board-parent-white__RcrdL","hero_tabs-btn-parent-white":"BrightHeroLeftPannel_hero_tabs-btn-parent-white__ovg3k","hp-hero-tabs-menu-top-white":"BrightHeroLeftPannel_hp-hero-tabs-menu-top-white__8rVJ7","hero-tabs-menu-top-h-white":"BrightHeroLeftPannel_hero-tabs-menu-top-h-white__hdbat","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431337-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431337-1b4312fb__TO51D","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43133e-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43133e-1b4312fb__63s4q","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431340-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431340-1b4312fb__NpaUg","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431347-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431347-1b4312fb__tuiTr","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431349-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431349-1b4312fb__zvAXj","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431350-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431350-1b4312fb__Bgvhk","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431352-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431352-1b4312fb__Kbw_y","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431359-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431359-1b4312fb__i839k","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43135b-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b43135b-1b4312fb__ob1zU","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431362-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431362-1b4312fb__SQ4ub","w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431364-1b4312fb":"BrightHeroLeftPannel_w-node-_40cd5288-9fcf-2667-79c3-c0ed1b431364-1b4312fb__Dx2zq"};

/***/ }),

/***/ 64122:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-case-studies":"CaseStudies_sec-case-studies__vYBdF","m_padding-global":"CaseStudies_m_padding-global__Zjy_x","m_padding-section-medium":"CaseStudies_m_padding-section-medium__6doLi","m_padding-section-small":"CaseStudies_m_padding-section-small__NYLXI","m_padding-section-large":"CaseStudies_m_padding-section-large__jgrHj","m_container-large":"CaseStudies_m_container-large__oZE8x","for--departments":"CaseStudies_for--departments__C9vzG","group_sec-h-sbs":"CaseStudies_group_sec-h-sbs__V2h7j","for-quotes":"CaseStudies_for-quotes__3zSm6","sec-h-sbs-start":"CaseStudies_sec-h-sbs-start__Zfitq","fw1_section-title":"CaseStudies_fw1_section-title__q0JfX","is--short":"CaseStudies_is--short__9i_c9","is--shorter":"CaseStudies_is--shorter__s7Xku","m_text-color-white":"CaseStudies_m_text-color-white__5pK_S","sec-h-sbs-end":"CaseStudies_sec-h-sbs-end__2Y4nz","fw1_button-combo":"CaseStudies_fw1_button-combo__5FnKX","for--agents":"CaseStudies_for--agents__MvAbg","m_button":"CaseStudies_m_button__dDrNB","m_button-dev":"CaseStudies_m_button-dev__CgvCO","for--hero":"CaseStudies_for--hero__fiIZW","for--modal":"CaseStudies_for--modal__wrmWs","m_button-primary":"CaseStudies_m_button-primary___C_L2","for--mb-hp":"CaseStudies_for--mb-hp__ukf64","m_button-primary-white":"CaseStudies_m_button-primary-white__1G6mI","btn-gradient":"CaseStudies_btn-gradient__mb0En","hero-btn-project":"CaseStudies_hero-btn-project__KhVPJ","is-visible":"CaseStudies_is-visible__woBkr","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"CaseStudies_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__kEq24","hero-btn-crm":"CaseStudies_hero-btn-crm__nzTYD","hero-btn-dev":"CaseStudies_hero-btn-dev__moYeY","hero-btn-svc":"CaseStudies_hero-btn-svc__Un5z4","hero-btn-marketing":"CaseStudies_hero-btn-marketing__p_r83","hero-btn-ops":"CaseStudies_hero-btn-ops__Y_72C","m_button-crm":"CaseStudies_m_button-crm__lkKqc","m_button-svc":"CaseStudies_m_button-svc__qEXnd","for--magic":"CaseStudies_for--magic__7d0Cm","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"CaseStudies_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__9bsu9","hero-btn-purple":"CaseStudies_hero-btn-purple__SZ96f","m_button-arrow":"CaseStudies_m_button-arrow__W8iOY","splide":"CaseStudies_splide__R1b3m","_w--arrow-bottom":"CaseStudies__w--arrow-bottom__5YPGe","for--tabs":"CaseStudies_for--tabs__Yd5Lb","for--tab-content":"CaseStudies_for--tab-content__ufRDO","comp_hp-hero-tabs-splide":"CaseStudies_comp_hp-hero-tabs-splide__TYFkO","splide__list":"CaseStudies_splide__list__hAhqV","for--tabs-hero":"CaseStudies_for--tabs-hero__OvfuC","for--hero-tab-content":"CaseStudies_for--hero-tab-content___V6j2","splide__track":"CaseStudies_splide__track__mT1CR","for--tabs-content":"CaseStudies_for--tabs-content__XyQZ7","for--tabs-content-hero":"CaseStudies_for--tabs-content-hero__Y3TlT","is--full":"CaseStudies_is--full__SSBos","for--edit":"CaseStudies_for--edit__RvwQA","hp-hero-tabs-list":"CaseStudies_hp-hero-tabs-list__r3tpc","is--full-height":"CaseStudies_is--full-height__8yexx","fw1_case-card":"CaseStudies_fw1_case-card___WMhs","splide__slide":"CaseStudies_splide__slide__lTlI3","fw1_case-card-top":"CaseStudies_fw1_case-card-top__6ND3g","hp_tab-customer-logo":"CaseStudies_hp_tab-customer-logo__8YwTG","m_button-link-small":"CaseStudies_m_button-link-small__6vPP1","m_button-link-white":"CaseStudies_m_button-link-white__uX4Be","m_link-underline":"CaseStudies_m_link-underline__V_KG9","link-underline-white":"CaseStudies_link-underline-white__b__6v","bg-color-white":"CaseStudies_bg-color-white___tJjw","fw1_case-cover":"CaseStudies_fw1_case-cover__k2IAP","group_case-card-number":"CaseStudies_group_case-card-number__rCLn7","fw1_case-card-number":"CaseStudies_fw1_case-card-number__2NBVG","fw1_case-card-number-text":"CaseStudies_fw1_case-card-number-text__jU3uf","fw1_case-card-bottom":"CaseStudies_fw1_case-card-bottom__FpDJK","fw1_case-card-industry-label":"CaseStudies_fw1_case-card-industry-label__uc0wb","splide__arrows":"CaseStudies_splide__arrows__ndMkm","custom-arrows-1":"CaseStudies_custom-arrows-1__Ide8F","splide__arrow":"CaseStudies_splide__arrow__Neq2g","splide-arrow-icon":"CaseStudies_splide-arrow-icon__SUm_Q","is--left":"CaseStudies_is--left__Au5od","w-node-_6a9d9fd9-a184-bbcb-60b9-4a53d48c7416-d48c740c":"CaseStudies_w-node-_6a9d9fd9-a184-bbcb-60b9-4a53d48c7416-d48c740c__9G3Mu"};

/***/ }),

/***/ 94302:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-closer":"Closer_sec-closer__w8I7f","_w--video":"Closer__w--video___wZ_U","_w--video-llama":"Closer__w--video-llama__liC1y","hp-closer-video-parent":"Closer_hp-closer-video-parent__Q8_Pr","play-video-onscroll":"Closer_play-video-onscroll__SNTzb","group_sec-h-center-closer":"Closer_group_sec-h-center-closer__Bt1Su","fw1_section-headline-parent":"Closer_fw1_section-headline-parent__IIrK8","is--center":"Closer_is--center__rdG6R","fw1_section-title-lr":"Closer_fw1_section-title-lr__z_W6X","is--short":"Closer_is--short__MeKdh","is--shorter":"Closer_is--shorter__LUPNK","m_text-color-white":"Closer_m_text-color-white__N7yq0","for--cta":"Closer_for--cta___nhoY","with-llama-closer-text":"Closer_with-llama-closer-text__8F11H","is-smaller-headline":"Closer_is-smaller-headline__OiuYW","fw1_button-combo":"Closer_fw1_button-combo__blU7D","for--agents":"Closer_for--agents__rSFzT","m_button":"Closer_m_button__Evj5v","m_button-dev":"Closer_m_button-dev__YmRoo","for--hero":"Closer_for--hero__T4KUK","for--modal":"Closer_for--modal__ud8hw","m_button-primary":"Closer_m_button-primary__iCzC_","for--mb-hp":"Closer_for--mb-hp__Aw0z1","m_button-primary-white":"Closer_m_button-primary-white__nR1Lr","btn-gradient":"Closer_btn-gradient__7Uhfk","hero-btn-project":"Closer_hero-btn-project__b49qM","is-visible":"Closer_is-visible__ytAIi","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"Closer_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__MuiKX","hero-btn-crm":"Closer_hero-btn-crm__Ckv8A","hero-btn-dev":"Closer_hero-btn-dev__A8oVP","hero-btn-svc":"Closer_hero-btn-svc__HWb_R","hero-btn-marketing":"Closer_hero-btn-marketing__9quUz","hero-btn-ops":"Closer_hero-btn-ops__rqu1C","m_button-crm":"Closer_m_button-crm__L1qMq","m_button-svc":"Closer_m_button-svc__zyFCM","for--magic":"Closer_for--magic__YC_ie","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Closer_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__W11Xa","hero-btn-purple":"Closer_hero-btn-purple__ylcEo","m_button-arrow":"Closer_m_button-arrow__XEgrd","m_button-outline":"Closer_m_button-outline__r1VaE","m_button-outline-white":"Closer_m_button-outline-white__xhk0v","m_button-outline-primary":"Closer_m_button-outline-primary__n4ee6","w-node-_9e8038b7-c991-e8dc-10ce-de463640a45b-3640a443":"Closer_w-node-_9e8038b7-c991-e8dc-10ce-de463640a45b-3640a443__ei987"};

/***/ }),

/***/ 3715:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-closer":"CloserLlama_sec-closer__meqVi","_w--video":"CloserLlama__w--video__ji0Fx","_w--video-llama":"CloserLlama__w--video-llama__cJ8I4","hp-closer-video-parent":"CloserLlama_hp-closer-video-parent__sCFKf","play-video-onscroll":"CloserLlama_play-video-onscroll__01MZ_","group_sec-h-llama-closer-absolute":"CloserLlama_group_sec-h-llama-closer-absolute__5z2JS","fw1_section-headline-parent":"CloserLlama_fw1_section-headline-parent__QLSsC","is--center":"CloserLlama_is--center__3UD4z","fw1_section-title-lr":"CloserLlama_fw1_section-title-lr__iJLtw","is--short":"CloserLlama_is--short__MOYiI","is--shorter":"CloserLlama_is--shorter__rb5P4","m_text-color-white":"CloserLlama_m_text-color-white__zW9lI","for--cta":"CloserLlama_for--cta__xkoAd","with-llama-closer-text":"CloserLlama_with-llama-closer-text__4luxp","is-smaller-headline":"CloserLlama_is-smaller-headline__oJdkD","fw1_button-combo":"CloserLlama_fw1_button-combo__xQcJX","for--agents":"CloserLlama_for--agents__arlOA","m_button":"CloserLlama_m_button__jyqkd","m_button-dev":"CloserLlama_m_button-dev___m3ye","for--hero":"CloserLlama_for--hero__1puPL","for--modal":"CloserLlama_for--modal__KxroV","m_button-primary":"CloserLlama_m_button-primary___5_eH","for--mb-hp":"CloserLlama_for--mb-hp__qRXhR","m_button-primary-white":"CloserLlama_m_button-primary-white__QTIhm","btn-gradient":"CloserLlama_btn-gradient__OfeTs","hero-btn-project":"CloserLlama_hero-btn-project__tXIAS","is-visible":"CloserLlama_is-visible__vQgjF","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"CloserLlama_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__Hemzp","hero-btn-crm":"CloserLlama_hero-btn-crm__D3uDG","hero-btn-dev":"CloserLlama_hero-btn-dev__kXHA7","hero-btn-svc":"CloserLlama_hero-btn-svc___ZfbY","hero-btn-marketing":"CloserLlama_hero-btn-marketing__9GASf","hero-btn-ops":"CloserLlama_hero-btn-ops__VX0GS","m_button-crm":"CloserLlama_m_button-crm__BzXrl","m_button-svc":"CloserLlama_m_button-svc__ENItV","for--magic":"CloserLlama_for--magic__342Ca","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"CloserLlama_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__i4YNr","hero-btn-purple":"CloserLlama_hero-btn-purple__jqoCa","m_button-arrow":"CloserLlama_m_button-arrow__CdRkW","m_button-outline":"CloserLlama_m_button-outline__JetdY","m_button-outline-white":"CloserLlama_m_button-outline-white__TvkwW","m_button-outline-primary":"CloserLlama_m_button-outline-primary__TJAJx","w-node-_3094b515-2cda-d411-aab6-f2004b18a529-4b18a51e":"CloserLlama_w-node-_3094b515-2cda-d411-aab6-f2004b18a529-4b18a51e__6MJmC"};

/***/ }),

/***/ 45998:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"crm-nav-component":"CrmNav_crm-nav-component___uKH2","is-sticky":"CrmNav_is-sticky__8m2vY","position-fixed":"CrmNav_position-fixed__KmlYR","m_mandatory-css":"CrmNav_m_mandatory-css__Ztj1j","minisite-nav":"CrmNav_minisite-nav__cgsiL","is-static":"CrmNav_is-static__MaqsM","nav-full-minisite":"CrmNav_nav-full-minisite__KUP2v","for-ms":"CrmNav_for-ms__HJ2Lp","for-edit":"CrmNav_for-edit__vnZNJ","for-general":"CrmNav_for-general__4SWJj","shadow-on-nav":"CrmNav_shadow-on-nav__CkBgB","m_nav-container-full":"CrmNav_m_nav-container-full__wX_cG","m_header-logo-desktop":"CrmNav_m_header-logo-desktop__qgXcU","group_nav-full-content":"CrmNav_group_nav-full-content__3Sk4M","nav-full-content-start":"CrmNav_nav-full-content-start__ZdbzL","for-minisite":"CrmNav_for-minisite__rcVt1","m_nav_link-full":"CrmNav_m_nav_link-full__CIoRF","chevron-down":"CrmNav_chevron-down__EFg3L","for--dd":"CrmNav_for--dd__vSmmQ","group_nav-full-wrap":"CrmNav_group_nav-full-wrap__1XxOZ","group_nav-full-child":"CrmNav_group_nav-full-child__1kQ71","shadow-on-list":"CrmNav_shadow-on-list__u05at","group-nav-content-top":"CrmNav_group-nav-content-top__ivBC2","group_nav-col-parent":"CrmNav_group_nav-col-parent__2bF6C","is-solutions-end":"CrmNav_is-solutions-end__30AKE","is-solutions-start":"CrmNav_is-solutions-start__5k_HX","is-solutions-center":"CrmNav_is-solutions-center__rajyl","is-products-end":"CrmNav_is-products-end__aXYg4","nav-group-col-h":"CrmNav_nav-group-col-h__ee69I","for-product":"CrmNav_for-product__42jFu","group_nav-col":"CrmNav_group_nav-col__1SmZ5","_w-big-gap":"CrmNav__w-big-gap__nWmZD","m_dt-nav-link":"CrmNav_m_dt-nav-link___4c_g","less-line-height":"CrmNav_less-line-height__KxbD5","m_dt-nav-link-icon-parent":"CrmNav_m_dt-nav-link-icon-parent__cbUed","is-product":"CrmNav_is-product__U0s03","grid_nav-products":"CrmNav_grid_nav-products__Iopjb","_w-one-col":"CrmNav__w-one-col__oiNgh","m_dt-nav-link-title":"CrmNav_m_dt-nav-link-title__Fufre","is-compani-size":"CrmNav_is-compani-size__Hznk3","m_dt-nav-link-sub":"CrmNav_m_dt-nav-link-sub__d7c1E","_w-br":"CrmNav__w-br__FwMM0","group-nav-content-footer":"CrmNav_group-nav-content-footer__M68xJ","group_header-buttons":"CrmNav_group_header-buttons__xzRXs","m_button-link-2":"CrmNav_m_button-link-2__alBmP","in-headre":"CrmNav_in-headre__riPj5","m_button-arrow":"CrmNav_m_button-arrow__sT3ku","for--magic":"CrmNav_for--magic__wZAIO","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"CrmNav_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__IW5XN","header-links-divider":"CrmNav_header-links-divider__pvXcp","close-trig":"CrmNav_close-trig__LTwEY","grid_nav-teams":"CrmNav_grid_nav-teams__Ki7Zh","nav_link-full":"CrmNav_nav_link-full__1eWj4","is-drop":"CrmNav_is-drop__pm2Sf","is-header-cs":"CrmNav_is-header-cs__xAFkl","nav-full-content-end":"CrmNav_nav-full-content-end__BsZz2","primary-button-10":"CrmNav_primary-button-10__QTlGr","_w-arrow":"CrmNav__w-arrow__hCS02","in-nav":"CrmNav_in-nav__gF3EJ","arrow-embed-full":"CrmNav_arrow-embed-full__KYyU3","comp_switcher":"CrmNav_comp_switcher__WnMbY","switcher-toggle":"CrmNav_switcher-toggle__0IhPl","icon_switcher":"CrmNav_icon_switcher__E4Exo","switcher-list":"CrmNav_switcher-list__WnORX","switcher-h":"CrmNav_switcher-h__5RO7l","is--grey":"CrmNav_is--grey__BKW_9","light-97":"CrmNav_light-97__KeiP_","switcher-product-link":"CrmNav_switcher-product-link__VOo3r","switcher-app-icon":"CrmNav_switcher-app-icon__KpkdL","group_switcher-bottom":"CrmNav_group_switcher-bottom__m5enj","switcher-bottom-end":"CrmNav_switcher-bottom-end__saK0S","switcher-app-icon-small":"CrmNav_switcher-app-icon-small__ewQkS","mobile-menu-trigger":"CrmNav_mobile-menu-trigger__oxk8S","hamburger-dash-2":"CrmNav_hamburger-dash-2__AoZyC","nav-container-full":"CrmNav_nav-container-full__lvI3N","header-logo-link":"CrmNav_header-logo-link__oBich","minisite-logo":"CrmNav_minisite-logo__sHr_f","is--large":"CrmNav_is--large__UsS8f","is--small":"CrmNav_is--small__S3SwA","nav-full-content":"CrmNav_nav-full-content__WBvW1","for--crm":"CrmNav_for--crm__Hvggt","nav_link-ms-dd-top-parent":"CrmNav_nav_link-ms-dd-top-parent__z8CJT","nav_link-list":"CrmNav_nav_link-list__Hcjv1","for--top":"CrmNav_for--top__Dq_1_","is--wider":"CrmNav_is--wider__Lckhi","for--mb":"CrmNav_for--mb__bIcCM","is--tb":"CrmNav_is--tb__1DdrT","dropdown-link-inner":"CrmNav_dropdown-link-inner__fP5Sk","dropdown-link-inner-text":"CrmNav_dropdown-link-inner-text__SDKTl","nav_link-ms-dd-parent":"CrmNav_nav_link-ms-dd-parent__TEfit","nav_link-ms":"CrmNav_nav_link-ms__ohXHH","nav-full-minisite-bottom":"CrmNav_nav-full-minisite-bottom__FzXUD","nav-minisite-group":"CrmNav_nav-minisite-group__GI4Gd","minisite-links-group":"CrmNav_minisite-links-group__dzAqc","is-crm":"CrmNav_is-crm__0KE41","minisite-nav-mb":"CrmNav_minisite-nav-mb__17wn_","is-100vw":"CrmNav_is-100vw__StBPv","mobile-nav-ms":"CrmNav_mobile-nav-ms__cHTP1","nav-container-lp":"CrmNav_nav-container-lp___JV2_","header-logo-link-mb":"CrmNav_header-logo-link-mb__pzJWX","minisite-logo-mb":"CrmNav_minisite-logo-mb__1BQEO","is-small":"CrmNav_is-small__5M_I_","is-wm-copy":"CrmNav_is-wm-copy__U_3PK","nav_menu-mobile":"CrmNav_nav_menu-mobile__9LaGJ","for--edit":"CrmNav_for--edit__N9wsL","nav_menu-mobile-content":"CrmNav_nav_menu-mobile-content__zhmSn","mobile_menu-group":"CrmNav_mobile_menu-group__UqoPF","mobile_menu-group-h":"CrmNav_mobile_menu-group-h__dUZHV","is-active":"CrmNav_is-active__E_8HE","mobile_menu-group-h-text":"CrmNav_mobile_menu-group-h-text__RMj9O","chevron":"CrmNav_chevron__heErO","group-child":"CrmNav_group-child__GKh6x","_50-rem":"CrmNav__50-rem__IpS61","_23-rem":"CrmNav__23-rem__EJgLr","_28-rem":"CrmNav__28-rem__ZhkRi","_24-rem":"CrmNav__24-rem__TKvkK","sub-group":"CrmNav_sub-group__xDoeB","bottom-margin":"CrmNav_bottom-margin__4na8P","mobile-link":"CrmNav_mobile-link__wAQyr","_w-icon":"CrmNav__w-icon__DfgIV","is-title":"CrmNav_is-title__1cSw4","mobile-menu-ucon":"CrmNav_mobile-menu-ucon__4JaFP","mobile_menu-group-h-standalone":"CrmNav_mobile_menu-group-h-standalone__dyRCK","_w-border-bottom":"CrmNav__w-border-bottom__m9qrl","_w--icon":"CrmNav__w--icon__S6nK4","mb-menu-ai-icon":"CrmNav_mb-menu-ai-icon__DIlCz","appstore-wrap":"CrmNav_appstore-wrap__xuCuF","badges-wrap":"CrmNav_badges-wrap__NoSKr","appstore-badge":"CrmNav_appstore-badge__Q_D0v","appstore-badge-img":"CrmNav_appstore-badge-img__k_gw6","go-to-hp-btn":"CrmNav_go-to-hp-btn__s1oVf","go-to-hp-logo":"CrmNav_go-to-hp-logo__lqOzW","go-to-hp-arrow":"CrmNav_go-to-hp-arrow__8x5vV","full_mobile-menu-trigger":"CrmNav_full_mobile-menu-trigger__RHcHn","hamburger-dash-full":"CrmNav_hamburger-dash-full__iPLDj","overflow-x-auto":"CrmNav_overflow-x-auto__chZCV","nav_link-list-tb":"CrmNav_nav_link-list-tb__gdTmU","for--products":"CrmNav_for--products__VKNlX","for--pricing":"CrmNav_for--pricing__3Qlk8","for--overview":"CrmNav_for--overview__3rzIK","for--resources":"CrmNav_for--resources___ieoV","dropdown-link-inner-2":"CrmNav_dropdown-link-inner-2__kjwdh","nav-spacer":"CrmNav_nav-spacer__GDaXa","w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707127e-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707127e-d0e88002__i5RiP","w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071285-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071285-d0e88002__qY4Qf","w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707128c-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d6423707128c-d0e88002__IyO_a","w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071293-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d64237071293-d0e88002__2d_Yg","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712b4-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712b4-d0e88002__cba5v","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712bb-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712bb-d0e88002__eJxhI","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712c6-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712c6-d0e88002__22xnB","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ca-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ca-d0e88002__lBUJr","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ce-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712ce-d0e88002__h0n9v","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d2-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d2-d0e88002__K3mFR","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d6-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712d6-d0e88002__CyQC0","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712da-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712da-d0e88002__Mwd4v","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712de-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712de-d0e88002__cOkqa","w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712e2-d0e88002":"CrmNav_w-node-_5fc65d0a-04a2-e85e-e4b1-d642370712e2-d0e88002__lFQ_T"};

/***/ }),

/***/ 65789:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-departments":"Departments_sec-departments___eIfW","m_padding-global":"Departments_m_padding-global__bstOP","m_padding-section-medium":"Departments_m_padding-section-medium__yA9rE","m_padding-section-small":"Departments_m_padding-section-small__nZ3ge","m_padding-section-large":"Departments_m_padding-section-large__ni4SP","m_container-large":"Departments_m_container-large__X9K6Q","for--departments":"Departments_for--departments__olASE","group_sec-h-center":"Departments_group_sec-h-center__A4bfl","fw1_section-headline-parent":"Departments_fw1_section-headline-parent__bPul6","is--center":"Departments_is--center__yVcoS","fw1_section-title":"Departments_fw1_section-title__E7OPl","is--short":"Departments_is--short__EDCUK","is--shorter":"Departments_is--shorter__jfwzx","m_text-color-white":"Departments_m_text-color-white__6bZ37","comp_products":"Departments_comp_products__oZ6aX","splide":"Departments_splide__WPgpJ","_w--arrow-bottom":"Departments__w--arrow-bottom__Ria32","for--tabs":"Departments_for--tabs__tk0yH","for--tab-content":"Departments_for--tab-content__FDVhT","comp_hp-hero-tabs-splide":"Departments_comp_hp-hero-tabs-splide__w6E7w","splide__list":"Departments_splide__list__1PT4W","for--tabs-hero":"Departments_for--tabs-hero__HtKnf","for--hero-tab-content":"Departments_for--hero-tab-content__jc8B_","products_tabs-menu":"Departments_products_tabs-menu__xI8uZ","splide__track":"Departments_splide__track__ThBa6","tabs_nav-list":"Departments_tabs_nav-list__o0iIw","product_tab-link":"Departments_product_tab-link__iMzWy","for--pmo":"Departments_for--pmo__cNnNg","is-active":"Departments_is-active__spunO","splide__slide":"Departments_splide__slide__qOpAS","for--sales":"Departments_for--sales__hByNF","for--marketing":"Departments_for--marketing__Phqw0","for--service":"Departments_for--service__Y0YtT","for--dev":"Departments_for--dev__qTbsg","for--leadership":"Departments_for--leadership__4iOrg","product_tab-link-button":"Departments_product_tab-link-button__KhoRr","for--tabs-content":"Departments_for--tabs-content__DBDQ9","for--tabs-content-hero":"Departments_for--tabs-content-hero__t1ZEV","is--full":"Departments_is--full__jWbVw","for--edit":"Departments_for--edit__o5swZ","hp-hero-tabs-list":"Departments_hp-hero-tabs-list__ibxyD","is--full-height":"Departments_is--full-height__It79r","for--ana":"Departments_for--ana__qDmpX","for--tab-pane":"Departments_for--tab-pane__CVA7I","for-3-perview":"Departments_for-3-perview__ypnPP","group-hp-tab-content":"Departments_group-hp-tab-content__Iich_","hp_tab-bento-big":"Departments_hp_tab-bento-big__sHCwE","is--primary":"Departments_is--primary__R_9Rg","is--crm":"Departments_is--crm__STbeT","is--black":"Departments_is--black__3QKeE","is--marketing":"Departments_is--marketing__q06Ka","is--svc":"Departments_is--svc__t1_4K","is--dev":"Departments_is--dev__LHWJa","hp_tab-bento-big-left":"Departments_hp_tab-bento-big-left__AHTL7","hp_tab-product-logo":"Departments_hp_tab-product-logo__DIWpT","hp_tab-bento-h":"Departments_hp_tab-bento-h__LocWg","hp_tab-bento-par":"Departments_hp_tab-bento-par__bI15m","m_button":"Departments_m_button__W2uJL","m_button-dev":"Departments_m_button-dev__fDLFF","for--hero":"Departments_for--hero__a3P2t","for--modal":"Departments_for--modal__a7RwS","m_button-primary":"Departments_m_button-primary__OjJrG","for--mb-hp":"Departments_for--mb-hp__JYZWd","m_button-primary-white":"Departments_m_button-primary-white__bbC8D","btn-gradient":"Departments_btn-gradient__C4UuJ","hero-btn-project":"Departments_hero-btn-project__6dOvA","is-visible":"Departments_is-visible__HUWLa","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"Departments_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__xtmmv","hero-btn-crm":"Departments_hero-btn-crm__eBEbH","hero-btn-dev":"Departments_hero-btn-dev__Gg7U4","hero-btn-svc":"Departments_hero-btn-svc__r9cey","hero-btn-marketing":"Departments_hero-btn-marketing__Hl8Nn","hero-btn-ops":"Departments_hero-btn-ops__9wWyM","m_button-crm":"Departments_m_button-crm__Sp8fV","m_button-svc":"Departments_m_button-svc__kh50R","for--magic":"Departments_for--magic__FD7UO","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Departments_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__gxMkz","hero-btn-purple":"Departments_hero-btn-purple__EDdi7","m_button-arrow":"Departments_m_button-arrow__DTBzn","hp_tab-bento-right":"Departments_hp_tab-bento-right__iPuPi","hp_tab-bento-sm":"Departments_hp_tab-bento-sm__74hKf","is--bottom":"Departments_is--bottom__97KAX","hp_tab-customer-logo":"Departments_hp_tab-customer-logo__ymlC7","hp_tab-bento-logo-h":"Departments_hp_tab-bento-logo-h__x2bwJ","hp_tab-bento-logo-quote":"Departments_hp_tab-bento-logo-quote__of81u","is--small":"Departments_is--small__XxCt8","hp_tab-bento-logo-quote-bottom":"Departments_hp_tab-bento-logo-quote-bottom__9wD0m","group-bento-headshot":"Departments_group-bento-headshot__xnmj_","hp_tab-bento-headshot":"Departments_hp_tab-bento-headshot__OtKm5","is-hidden":"Departments_is-hidden__v0wS3","quote-headshot-name":"Departments_quote-headshot-name__Lxavs","quote-headshot-title":"Departments_quote-headshot-title__mRxyC","w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4d9-1885c9b1":"Departments_w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4d9-1885c9b1__JFQ_g","w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e0-1885c9b1":"Departments_w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e0-1885c9b1__MwsAU","w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e6-1885c9b1":"Departments_w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4e6-1885c9b1__nKz6y","w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4ec-1885c9b1":"Departments_w-node-_15b3ccd5-63b4-2fa1-3e10-1b1c8af9f4ec-1885c9b1__JbJS2","w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc42-1885c9b1":"Departments_w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc42-1885c9b1__x5TGb","w-node-_3059929e-be66-5200-04cb-01b96a9f9f91-1885c9b1":"Departments_w-node-_3059929e-be66-5200-04cb-01b96a9f9f91-1885c9b1__oUGcW","w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc4f-1885c9b1":"Departments_w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc4f-1885c9b1__s0Nwk","w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc55-1885c9b1":"Departments_w-node-f5cc9625-2840-7c85-e618-3dab2bc9bc55-1885c9b1__1Ns9v","w-node-_2c0611a3-724d-48c2-5870-1877aef88c47-1885c9b1":"Departments_w-node-_2c0611a3-724d-48c2-5870-1877aef88c47-1885c9b1__VTQfX","w-node-_2c0611a3-724d-48c2-5870-1877aef88c4e-1885c9b1":"Departments_w-node-_2c0611a3-724d-48c2-5870-1877aef88c4e-1885c9b1__oJYBE","w-node-_2c0611a3-724d-48c2-5870-1877aef88c54-1885c9b1":"Departments_w-node-_2c0611a3-724d-48c2-5870-1877aef88c54-1885c9b1___Tl5J","w-node-_2c0611a3-724d-48c2-5870-1877aef88c5a-1885c9b1":"Departments_w-node-_2c0611a3-724d-48c2-5870-1877aef88c5a-1885c9b1__CF6I8","w-node-_2c0611a3-724d-48c2-5870-1877aef88c5f-1885c9b1":"Departments_w-node-_2c0611a3-724d-48c2-5870-1877aef88c5f-1885c9b1__5bmqc","w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d774-1885c9b1":"Departments_w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d774-1885c9b1__K8dRv","w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d77b-1885c9b1":"Departments_w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d77b-1885c9b1__5f_Ip","w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d781-1885c9b1":"Departments_w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d781-1885c9b1__lwEFs","w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d78a-1885c9b1":"Departments_w-node-_50d5dd77-3f2e-bc8f-151c-f4a02c03d78a-1885c9b1__xNjsw","w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc831-1885c9b1":"Departments_w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc831-1885c9b1__Rf_k9","w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc838-1885c9b1":"Departments_w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc838-1885c9b1__Z0Dr7","w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc83e-1885c9b1":"Departments_w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc83e-1885c9b1__0i0y7","w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc846-1885c9b1":"Departments_w-node-f8111eb5-3c4d-f56f-264a-c2b0f62cc846-1885c9b1__NVw95","w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30d6-1885c9b1":"Departments_w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30d6-1885c9b1__SyjC_","w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30dd-1885c9b1":"Departments_w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30dd-1885c9b1__QWJl4","w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30e3-1885c9b1":"Departments_w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30e3-1885c9b1__a3sGk","w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30eb-1885c9b1":"Departments_w-node-_52c74cc4-8e74-3231-5be9-67d37f6c30eb-1885c9b1__2PXbR"};

/***/ }),

/***/ 81973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-departments":"DepartmentsProjectsTest_sec-departments__eCT5j","m_padding-global":"DepartmentsProjectsTest_m_padding-global__sCrq1","m_padding-section-medium":"DepartmentsProjectsTest_m_padding-section-medium__hgxwM","m_padding-section-small":"DepartmentsProjectsTest_m_padding-section-small__eYgdR","m_padding-section-large":"DepartmentsProjectsTest_m_padding-section-large__ZOEYE","m_container-large":"DepartmentsProjectsTest_m_container-large__RWN8o","for--departments":"DepartmentsProjectsTest_for--departments__5kwoV","group_sec-h-center":"DepartmentsProjectsTest_group_sec-h-center__i5Gvs","fw1_section-headline-parent":"DepartmentsProjectsTest_fw1_section-headline-parent__untsz","is--center":"DepartmentsProjectsTest_is--center__Dv3Aa","fw1_section-title":"DepartmentsProjectsTest_fw1_section-title__NHmsj","is--short":"DepartmentsProjectsTest_is--short__L0vWz","is--shorter":"DepartmentsProjectsTest_is--shorter__zzrGZ","m_text-color-white":"DepartmentsProjectsTest_m_text-color-white__LwMqh","comp_products":"DepartmentsProjectsTest_comp_products__52wVL","splide":"DepartmentsProjectsTest_splide__vhk5w","_w--arrow-bottom":"DepartmentsProjectsTest__w--arrow-bottom__CJh8n","for--tabs":"DepartmentsProjectsTest_for--tabs__W7nDi","for--tab-content":"DepartmentsProjectsTest_for--tab-content__HRfQq","comp_hp-hero-tabs-splide":"DepartmentsProjectsTest_comp_hp-hero-tabs-splide__z23xS","splide__list":"DepartmentsProjectsTest_splide__list__uSd0y","for--tabs-hero":"DepartmentsProjectsTest_for--tabs-hero__0D9Y4","for--hero-tab-content":"DepartmentsProjectsTest_for--hero-tab-content__7RynX","products_tabs-menu":"DepartmentsProjectsTest_products_tabs-menu__Nk8Tb","splide__track":"DepartmentsProjectsTest_splide__track__egluq","tabs_nav-list":"DepartmentsProjectsTest_tabs_nav-list__MRBe_","product_tab-link":"DepartmentsProjectsTest_product_tab-link__da0eR","for--pmo":"DepartmentsProjectsTest_for--pmo__99aFi","is-active":"DepartmentsProjectsTest_is-active__4IgCX","splide__slide":"DepartmentsProjectsTest_splide__slide__IWXSY","for--sales":"DepartmentsProjectsTest_for--sales__kn3WP","for--marketing":"DepartmentsProjectsTest_for--marketing__eSOXp","for--service":"DepartmentsProjectsTest_for--service__Vu50F","for--dev":"DepartmentsProjectsTest_for--dev__XLMbv","for--leadership":"DepartmentsProjectsTest_for--leadership__BjA4z","product_tab-link-button":"DepartmentsProjectsTest_product_tab-link-button__Heiv9","for--tabs-content":"DepartmentsProjectsTest_for--tabs-content__76Q4T","for--tabs-content-hero":"DepartmentsProjectsTest_for--tabs-content-hero__WCzMA","is--full":"DepartmentsProjectsTest_is--full__NN7Bi","for--edit":"DepartmentsProjectsTest_for--edit__8rKvS","hp-hero-tabs-list":"DepartmentsProjectsTest_hp-hero-tabs-list__nTcqx","is--full-height":"DepartmentsProjectsTest_is--full-height__G1aUa","for--ana":"DepartmentsProjectsTest_for--ana__rLbqU","for--tab-pane":"DepartmentsProjectsTest_for--tab-pane__5v2jm","for-3-perview":"DepartmentsProjectsTest_for-3-perview__yoWS3","group-hp-tab-content":"DepartmentsProjectsTest_group-hp-tab-content__3oN03","hp_tab-bento-big":"DepartmentsProjectsTest_hp_tab-bento-big__bL_xb","is--primary":"DepartmentsProjectsTest_is--primary__DpfK_","is--crm":"DepartmentsProjectsTest_is--crm__g_k0C","is--black":"DepartmentsProjectsTest_is--black__1Cz_r","is--marketing":"DepartmentsProjectsTest_is--marketing__WISvx","is--svc":"DepartmentsProjectsTest_is--svc___mpMX","is--dev":"DepartmentsProjectsTest_is--dev__yiUaS","hp_tab-bento-big-left":"DepartmentsProjectsTest_hp_tab-bento-big-left__zV_5t","hp_tab-product-logo":"DepartmentsProjectsTest_hp_tab-product-logo__rWJbo","hp_tab-bento-h":"DepartmentsProjectsTest_hp_tab-bento-h__x08y1","hp_tab-bento-par":"DepartmentsProjectsTest_hp_tab-bento-par__O0yIi","m_button":"DepartmentsProjectsTest_m_button__8L61B","m_button-dev":"DepartmentsProjectsTest_m_button-dev__VwMy3","for--hero":"DepartmentsProjectsTest_for--hero__VFaQ7","for--modal":"DepartmentsProjectsTest_for--modal__yubdr","m_button-primary":"DepartmentsProjectsTest_m_button-primary___fAA3","for--mb-hp":"DepartmentsProjectsTest_for--mb-hp__SFCi6","m_button-primary-white":"DepartmentsProjectsTest_m_button-primary-white__4fQLi","btn-gradient":"DepartmentsProjectsTest_btn-gradient___179_","hero-btn-project":"DepartmentsProjectsTest_hero-btn-project__y3_Fi","is-visible":"DepartmentsProjectsTest_is-visible__NiMCY","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"DepartmentsProjectsTest_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__4k2Rt","hero-btn-crm":"DepartmentsProjectsTest_hero-btn-crm__6yjgN","hero-btn-dev":"DepartmentsProjectsTest_hero-btn-dev__xTnEP","hero-btn-svc":"DepartmentsProjectsTest_hero-btn-svc__3mfNR","hero-btn-marketing":"DepartmentsProjectsTest_hero-btn-marketing__YpDfs","hero-btn-ops":"DepartmentsProjectsTest_hero-btn-ops__cqykz","m_button-crm":"DepartmentsProjectsTest_m_button-crm__zzoTA","m_button-svc":"DepartmentsProjectsTest_m_button-svc__bNCV2","for--magic":"DepartmentsProjectsTest_for--magic__URMto","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"DepartmentsProjectsTest_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__xa3Oc","hero-btn-purple":"DepartmentsProjectsTest_hero-btn-purple__207k_","m_button-arrow":"DepartmentsProjectsTest_m_button-arrow__8vgIy","hp_tab-bento-right":"DepartmentsProjectsTest_hp_tab-bento-right__qzrI5","hp_tab-bento-sm":"DepartmentsProjectsTest_hp_tab-bento-sm__6HUX6","is--bottom":"DepartmentsProjectsTest_is--bottom__xzYTG","hp_tab-customer-logo":"DepartmentsProjectsTest_hp_tab-customer-logo__dCMcV","hp_tab-bento-logo-h":"DepartmentsProjectsTest_hp_tab-bento-logo-h__HldAV","span--semi":"DepartmentsProjectsTest_span--semi__y_tT4","hp_tab-bento-logo-quote":"DepartmentsProjectsTest_hp_tab-bento-logo-quote__faqB7","is--small":"DepartmentsProjectsTest_is--small__UsGjj","hp_tab-bento-logo-quote-bottom":"DepartmentsProjectsTest_hp_tab-bento-logo-quote-bottom__voVch","group-bento-headshot":"DepartmentsProjectsTest_group-bento-headshot__0lGTx","hp_tab-bento-headshot":"DepartmentsProjectsTest_hp_tab-bento-headshot__58_FW","is-hidden":"DepartmentsProjectsTest_is-hidden__brCvC","quote-headshot-name":"DepartmentsProjectsTest_quote-headshot-name__1DXd9","quote-headshot-title":"DepartmentsProjectsTest_quote-headshot-title__WqC_d","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1729-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1729-50ec16ff__AU4pd","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1730-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1730-50ec16ff__oqDbb","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1736-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1736-50ec16ff__u408X","w-node-cad196ad-ae9a-45db-5b94-7b2950ec173c-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec173c-50ec16ff__NcImg","w-node-cad196ad-ae9a-45db-5b94-7b2950ec176b-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec176b-50ec16ff__Dyicu","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1772-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1772-50ec16ff__P5LLO","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1778-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1778-50ec16ff__Iegaq","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1780-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1780-50ec16ff__D0Pbv","w-node-cad196ad-ae9a-45db-5b94-7b2950ec178e-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec178e-50ec16ff__U5D0c","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1795-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1795-50ec16ff__xCNQs","w-node-cad196ad-ae9a-45db-5b94-7b2950ec179b-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec179b-50ec16ff__qObve","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a1-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a1-50ec16ff__ouiox","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a6-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17a6-50ec16ff__0TdK8","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17ae-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17ae-50ec16ff__8oNn8","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17b5-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17b5-50ec16ff__xJ0X7","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17bb-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17bb-50ec16ff__CrYl7","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17c4-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17c4-50ec16ff__mcThw","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d1-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d1-50ec16ff__ROPnR","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d8-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17d8-50ec16ff__zU4jo","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17de-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17de-50ec16ff__ipmU7","w-node-cad196ad-ae9a-45db-5b94-7b2950ec17e6-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec17e6-50ec16ff__SY99f","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1749-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1749-50ec16ff__tkJH_","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1750-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1750-50ec16ff__IiT5k","w-node-cad196ad-ae9a-45db-5b94-7b2950ec1756-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec1756-50ec16ff__535Mk","w-node-cad196ad-ae9a-45db-5b94-7b2950ec175e-50ec16ff":"DepartmentsProjectsTest_w-node-cad196ad-ae9a-45db-5b94-7b2950ec175e-50ec16ff__7377u"};

/***/ }),

/***/ 75572:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"gartner":"Gartner_gartner__sH3J3","m_padding-global":"Gartner_m_padding-global__v_1kG","m_padding-section-medium":"Gartner_m_padding-section-medium__afRfm","m_padding-section-small":"Gartner_m_padding-section-small__4m7i3","m_padding-section-large":"Gartner_m_padding-section-large__r60Jr","m_container-large":"Gartner_m_container-large__OHt5v","for--departments":"Gartner_for--departments__L5ENQ","gartner-banner":"Gartner_gartner-banner__fFK0I","gartner-card-wrapper":"Gartner_gartner-card-wrapper__B92hU","max-width-gartner-logo":"Gartner_max-width-gartner-logo__iDBdA","gartner-text-wrapper":"Gartner_gartner-text-wrapper___CjV_","m_text-color-white":"Gartner_m_text-color-white__FjO1_","m_fontweight-semibold":"Gartner_m_fontweight-semibold__DKZiI","m_text-style-22":"Gartner_m_text-style-22__FVWZA","m_spacer-1rem":"Gartner_m_spacer-1rem__2XY80","m_button-outline":"Gartner_m_button-outline__zz2q1","m_button-outline-white":"Gartner_m_button-outline-white__TsY3L","m_button-outline-primary":"Gartner_m_button-outline-primary__w88vI","w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dc9-bb0a1dc5":"Gartner_w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dc9-bb0a1dc5__ND3ab","w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dd5-bb0a1dc5":"Gartner_w-node-_19cd9238-87f0-ea46-7823-e0fdbb0a1dd5-bb0a1dc5__2218I"};

/***/ }),

/***/ 27805:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-hero":"Hero_sec-hero__7eXCR","m_padding-global":"Hero_m_padding-global__haD8Q","m_padding-section-medium":"Hero_m_padding-section-medium__3IzEf","m_container-large":"Hero_m_container-large__xzcu6","for--departments":"Hero_for--departments__w_ym_","fw1_hero-title-parent":"Hero_fw1_hero-title-parent__RLuo1","fw1_hero-title-white":"Hero_fw1_hero-title-white__LANXb","is--short":"Hero_is--short__y_tUe","is--shorter":"Hero_is--shorter__3LmIq","m_text-color-white":"Hero_m_text-color-white__R_C3M","fw1_hero-sub-white":"Hero_fw1_hero-sub-white___XngR","hp-hero-btnsparent":"Hero_hp-hero-btnsparent__esWXa","m_button":"Hero_m_button__A_VfW","m_button-dev":"Hero_m_button-dev__6ZkmE","for--hero":"Hero_for--hero__mQVpf","for--modal":"Hero_for--modal__5NDXC","m_button-primary":"Hero_m_button-primary__bsxQ4","m_button-primary-white":"Hero_m_button-primary-white__2DEfD","btn-gradient":"Hero_btn-gradient__BQVUU","hero-btn-crm":"Hero_hero-btn-crm__cmIaC","hero-btn-dev":"Hero_hero-btn-dev__BcfKa","hero-btn-svc":"Hero_hero-btn-svc__GoYCP","hero-btn-marketing":"Hero_hero-btn-marketing__jPVIr","hero-btn-ops":"Hero_hero-btn-ops__yZgqc","m_button-crm":"Hero_m_button-crm__i54xs","m_button-svc":"Hero_m_button-svc__3fByQ","for--magic":"Hero_for--magic__24ZMk","m_button-arrow":"Hero_m_button-arrow__87aFv","hp-hero-btn-label":"Hero_hp-hero-btn-label__uaug_","comp_hp-hero-tabs":"Hero_comp_hp-hero-tabs__K5Yr_","hero-star-1":"Hero_hero-star-1__y8rF3","hero-star-2":"Hero_hero-star-2__CpV06","hero-star-3":"Hero_hero-star-3__QqGvf","hp-hero-tabs-menu-top":"Hero_hp-hero-tabs-menu-top__Ailsh","hero-tabs-menu-top-h":"Hero_hero-tabs-menu-top-h__wLKG_","what--span":"Hero_what--span___j_bN","hp_hero-tabs":"Hero_hp_hero-tabs__WbpYA","hp_hero-tabs-menu":"Hero_hp_hero-tabs-menu__yesZ7","hero-card-gradient":"Hero_hero-card-gradient__2Rcdv","hero-card-gradient-inner":"Hero_hero-card-gradient-inner__ml8yw","hero-card-gradient-inner-headshot":"Hero_hero-card-gradient-inner-headshot__pQu4r","m_tab-arrow":"Hero_m_tab-arrow__SZRMD","hp_hero-tabs-content":"Hero_hp_hero-tabs-content__tMIZF","hp_hero-tab-inner":"Hero_hp_hero-tab-inner__XTQXh","hp_hero-tab-board-parent":"Hero_hp_hero-tab-board-parent__tgpLd","ai-blocks-vid-embed":"Hero_ai-blocks-vid-embed__N2p8Q","hero_tabs-btn-parent":"Hero_hero_tabs-btn-parent__IHFta","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a7-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a7-7019405f__049hZ","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a9-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3a9-7019405f__MREZU","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b0-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b0-7019405f__hNFg7","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b2-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b2-7019405f__vVymN","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b9-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3b9-7019405f__ncc41","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3bb-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3bb-7019405f__2ITz_","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c2-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c2-7019405f__JqnjG","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c4-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3c4-7019405f__Oec2z","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cb-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cb-7019405f__IXdZk","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cd-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3cd-7019405f__qEqCg","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d4-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d4-7019405f__wpVC7","w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d6-7019405f":"Hero_w-node-dee24b6d-c244-8de3-7c50-a7801bf8f3d6-7019405f__D8tg1"};

/***/ }),

/***/ 66172:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"HeroEldadVarB_lotem-hero__A9kJ_","group_hero-center-all":"HeroEldadVarB_group_hero-center-all__GUo_3","m_hero-title-parent":"HeroEldadVarB_m_hero-title-parent__g6VGU","fw1_hero-title-black-lotem":"HeroEldadVarB_fw1_hero-title-black-lotem__7vonS","is--short":"HeroEldadVarB_is--short__RhR3Y","is--shorter":"HeroEldadVarB_is--shorter__V05Z4","m_text-color-white":"HeroEldadVarB_m_text-color-white___m5SO","subtitle-white-test-max-width":"HeroEldadVarB_subtitle-white-test-max-width__H5fiT","fw1_hero-sub-black":"HeroEldadVarB_fw1_hero-sub-black__XC3km","hp-hero-btnsparent":"HeroEldadVarB_hp-hero-btnsparent__CSnuT","fw1_button-parent":"HeroEldadVarB_fw1_button-parent__qnjnP","for--impact":"HeroEldadVarB_for--impact__3_plq","m_button":"HeroEldadVarB_m_button__Xf_DF","m_button-dev":"HeroEldadVarB_m_button-dev__OjFeu","for--hero":"HeroEldadVarB_for--hero__Fq_le","for--modal":"HeroEldadVarB_for--modal__wteHH","m_button-primary":"HeroEldadVarB_m_button-primary__uLzqy","for--mb-hp":"HeroEldadVarB_for--mb-hp__P1MW0","m_button-primary-white":"HeroEldadVarB_m_button-primary-white__wEGuD","btn-gradient":"HeroEldadVarB_btn-gradient__oqGPM","hero-btn-project":"HeroEldadVarB_hero-btn-project__lcprZ","is-visible":"HeroEldadVarB_is-visible___g4pD","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"HeroEldadVarB_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__VX1x9","hero-btn-crm":"HeroEldadVarB_hero-btn-crm__OzJTi","hero-btn-dev":"HeroEldadVarB_hero-btn-dev__xrbSL","hero-btn-svc":"HeroEldadVarB_hero-btn-svc__4gGL4","hero-btn-marketing":"HeroEldadVarB_hero-btn-marketing__8Ntqz","hero-btn-ops":"HeroEldadVarB_hero-btn-ops__U256P","m_button-crm":"HeroEldadVarB_m_button-crm__KLdgD","m_button-svc":"HeroEldadVarB_m_button-svc__PB_gx","for--magic":"HeroEldadVarB_for--magic__Gq97I","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"HeroEldadVarB_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__z5Cf7","hero-btn-purple":"HeroEldadVarB_hero-btn-purple__rz1_Z","m_button-arrow":"HeroEldadVarB_m_button-arrow__DvHRa","no-credit-label":"HeroEldadVarB_no-credit-label__iWcOI","hp-hero-btn-label":"HeroEldadVarB_hp-hero-btn-label__SuQlp","hide":"HeroEldadVarB_hide__j2gPb","m_spacer-3rem":"HeroEldadVarB_m_spacer-3rem__auHeX","lotem-tabs-parent":"HeroEldadVarB_lotem-tabs-parent__uzm9u","lotem-tabs-what-would":"HeroEldadVarB_lotem-tabs-what-would__q1TU4","lotem-hero-tabs-holder":"HeroEldadVarB_lotem-hero-tabs-holder__r3G3_","tabs-group-lotem-hero":"HeroEldadVarB_tabs-group-lotem-hero__1mDuY","tab-lotem-hero-hover":"HeroEldadVarB_tab-lotem-hero-hover__5GDIF","thumbnail-tab-image":"HeroEldadVarB_thumbnail-tab-image__V0yNU","headshot-hero-video":"HeroEldadVarB_headshot-hero-video__LhIvA","tab-hero-text-lotem":"HeroEldadVarB_tab-hero-text-lotem__HClCY","lotem-hero-tab-content":"HeroEldadVarB_lotem-hero-tab-content__1WjID","lotem-hero-tab-pane":"HeroEldadVarB_lotem-hero-tab-pane__XzR4f","lotem-hero-asset-flexbox":"HeroEldadVarB_lotem-hero-asset-flexbox__qVLQw","asset-image-lotem-hero":"HeroEldadVarB_asset-image-lotem-hero__F6WAf","right-pane-lotem-hero":"HeroEldadVarB_right-pane-lotem-hero__4nhwB","logo-wrapper":"HeroEldadVarB_logo-wrapper__pqL9r","lotem-hero-asset-info-text":"HeroEldadVarB_lotem-hero-asset-info-text__SCMZ0","logo-svg":"HeroEldadVarB_logo-svg__qP56r","m_spacer-2rem":"HeroEldadVarB_m_spacer-2rem__b1wtt","lotem-hero-asset-tiny-text":"HeroEldadVarB_lotem-hero-asset-tiny-text__T2cCh","products-logos-wrapper":"HeroEldadVarB_products-logos-wrapper__6eMfd","ai-star-hero":"HeroEldadVarB_ai-star-hero__IzIVg","ai-star-hero-2":"HeroEldadVarB_ai-star-hero-2__nddUn"};

/***/ }),

/***/ 52716:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"HeroEldadVarC_lotem-hero__RK8LL","group_hero-center-all":"HeroEldadVarC_group_hero-center-all__20Wc9","m_hero-title-parent":"HeroEldadVarC_m_hero-title-parent__b0Ho0","fw1_hero-title-black-lotem":"HeroEldadVarC_fw1_hero-title-black-lotem__hJWdk","is--short":"HeroEldadVarC_is--short__Ygn4O","is--shorter":"HeroEldadVarC_is--shorter__w1lxK","m_text-color-white":"HeroEldadVarC_m_text-color-white__aIfJI","subtitle-white-test-max-width":"HeroEldadVarC_subtitle-white-test-max-width__BSGnX","fw1_hero-sub-black":"HeroEldadVarC_fw1_hero-sub-black__ZxBJN","hp-hero-btnsparent":"HeroEldadVarC_hp-hero-btnsparent__NNdtd","fw1_button-parent":"HeroEldadVarC_fw1_button-parent__M7bbK","for--impact":"HeroEldadVarC_for--impact__6qTiz","m_button":"HeroEldadVarC_m_button__Z9WCD","m_button-dev":"HeroEldadVarC_m_button-dev__EkXki","for--hero":"HeroEldadVarC_for--hero__nM0y_","for--modal":"HeroEldadVarC_for--modal__U78nk","m_button-primary":"HeroEldadVarC_m_button-primary__HDvJB","for--mb-hp":"HeroEldadVarC_for--mb-hp__4UL8D","m_button-primary-white":"HeroEldadVarC_m_button-primary-white__9VN69","btn-gradient":"HeroEldadVarC_btn-gradient__0I7Qt","hero-btn-project":"HeroEldadVarC_hero-btn-project__yOPWi","is-visible":"HeroEldadVarC_is-visible__DwoIu","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"HeroEldadVarC_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__8gqle","hero-btn-crm":"HeroEldadVarC_hero-btn-crm__D9j1m","hero-btn-dev":"HeroEldadVarC_hero-btn-dev__vENjs","hero-btn-svc":"HeroEldadVarC_hero-btn-svc__t_PFi","hero-btn-marketing":"HeroEldadVarC_hero-btn-marketing__62QpS","hero-btn-ops":"HeroEldadVarC_hero-btn-ops__cYHC5","m_button-crm":"HeroEldadVarC_m_button-crm__N_RGF","m_button-svc":"HeroEldadVarC_m_button-svc__r1yOM","for--magic":"HeroEldadVarC_for--magic__tOvKX","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"HeroEldadVarC_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__LRhPs","hero-btn-purple":"HeroEldadVarC_hero-btn-purple__OzsIH","m_button-arrow":"HeroEldadVarC_m_button-arrow__FL6kf","no-credit-label":"HeroEldadVarC_no-credit-label__LsEhH","hp-hero-btn-label":"HeroEldadVarC_hp-hero-btn-label__Xbs_o","hide":"HeroEldadVarC_hide__GNrWt","m_spacer-3rem":"HeroEldadVarC_m_spacer-3rem__V85w1","lotem-tabs-parent":"HeroEldadVarC_lotem-tabs-parent__S5UWN","lotem-tabs-what-would":"HeroEldadVarC_lotem-tabs-what-would__vTsF_","lotem-hero-tabs-holder":"HeroEldadVarC_lotem-hero-tabs-holder__pLck_","tabs-group-lotem-hero":"HeroEldadVarC_tabs-group-lotem-hero__wRlLB","tab_eldad-hero-hover":"HeroEldadVarC_tab_eldad-hero-hover__eZEPs","tab_eldad-inner":"HeroEldadVarC_tab_eldad-inner__4mgpi","thumbnail-tab-image":"HeroEldadVarC_thumbnail-tab-image__OHm_J","headshot-hero-video":"HeroEldadVarC_headshot-hero-video__8V6C3","tab-hero-text-lotem":"HeroEldadVarC_tab-hero-text-lotem__RR0nq","lotem-hero-tab-content":"HeroEldadVarC_lotem-hero-tab-content__xdkAb","lotem-hero-tab-pane":"HeroEldadVarC_lotem-hero-tab-pane__qtp2H","lotem-hero-asset-flexbox":"HeroEldadVarC_lotem-hero-asset-flexbox__aOlrJ","asset-image-lotem-hero":"HeroEldadVarC_asset-image-lotem-hero__9fLBw","right-pane-lotem-hero":"HeroEldadVarC_right-pane-lotem-hero__tdYBZ","logo-wrapper":"HeroEldadVarC_logo-wrapper__tkSl7","lotem-hero-asset-info-text":"HeroEldadVarC_lotem-hero-asset-info-text__rTl2I","logo-svg":"HeroEldadVarC_logo-svg__yvaXE","m_spacer-2rem":"HeroEldadVarC_m_spacer-2rem__JgeF_","lotem-hero-asset-tiny-text":"HeroEldadVarC_lotem-hero-asset-tiny-text__lI3Og","products-logos-wrapper":"HeroEldadVarC_products-logos-wrapper__s_1f5","ai-star-hero":"HeroEldadVarC_ai-star-hero__5ts1Y","ai-star-hero-2":"HeroEldadVarC_ai-star-hero-2__9qDuF"};

/***/ }),

/***/ 32860:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-hero":"HeroFu_sec-hero__VgZWS","m_padding-global":"HeroFu_m_padding-global__ovVSb","m_padding-section-medium":"HeroFu_m_padding-section-medium__sjDsd","m_padding-section-small":"HeroFu_m_padding-section-small__hYIGk","m_container-large":"HeroFu_m_container-large__AZR_0","for--departments":"HeroFu_for--departments__OdiTo","fw1_hero-title-parent":"HeroFu_fw1_hero-title-parent__l1l_k","fw1_hero-title-white":"HeroFu_fw1_hero-title-white__qcrwV","is--short":"HeroFu_is--short__uEzPP","is--shorter":"HeroFu_is--shorter__1C_so","m_text-color-white":"HeroFu_m_text-color-white__CG5nj","fw1_hero-sub-white":"HeroFu_fw1_hero-sub-white__KuP4e","hp-hero-btnsparent":"HeroFu_hp-hero-btnsparent__cgnwb","m_button":"HeroFu_m_button__bn3MU","m_button-dev":"HeroFu_m_button-dev__nyGSz","for--hero":"HeroFu_for--hero__WnVwX","for--modal":"HeroFu_for--modal__ETTtW","m_button-primary":"HeroFu_m_button-primary__hOUjs","m_button-primary-white":"HeroFu_m_button-primary-white__zGbvA","btn-gradient":"HeroFu_btn-gradient__pf_Dl","hero-btn-project":"HeroFu_hero-btn-project__lLiHs","is-visible":"HeroFu_is-visible___kpv_","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"HeroFu_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__dpi32","hero-btn-crm":"HeroFu_hero-btn-crm__Ff8NZ","hero-btn-dev":"HeroFu_hero-btn-dev__FoAUM","hero-btn-svc":"HeroFu_hero-btn-svc__gz1Tn","hero-btn-marketing":"HeroFu_hero-btn-marketing__KhJ9T","hero-btn-ops":"HeroFu_hero-btn-ops__RPRaC","m_button-crm":"HeroFu_m_button-crm__E07CT","m_button-svc":"HeroFu_m_button-svc__ntaIv","for--magic":"HeroFu_for--magic__3Qq41","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"HeroFu_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__cVhSG","is-disabled":"HeroFu_is-disabled__66dNA","m_button-arrow":"HeroFu_m_button-arrow__hHA4e","hp-hero-btn-label":"HeroFu_hp-hero-btn-label__1U_sl","hide":"HeroFu_hide__DETjy","comp_hp-hero-tabs":"HeroFu_comp_hp-hero-tabs__1qdwk","hp-hero-tabs-blur":"HeroFu_hp-hero-tabs-blur__wlozS","hero-star-1":"HeroFu_hero-star-1__s7uJT","hero-star-2":"HeroFu_hero-star-2__Px9N8","hp_hero-tabs-fu":"HeroFu_hp_hero-tabs-fu__MZ_LH","hp_hero-tabs-menu-fu":"HeroFu_hp_hero-tabs-menu-fu__D7eGE","hero-card-gradient-fu":"HeroFu_hero-card-gradient-fu__Reoez","hero-card-gradient-inner-fu":"HeroFu_hero-card-gradient-inner-fu__0HgYl","hero-card-gradient-inner-headshot-fu":"HeroFu_hero-card-gradient-inner-headshot-fu__hdeLr","m_tab-arrow":"HeroFu_m_tab-arrow__JwvyN","hp_hero-tabs-content-fu":"HeroFu_hp_hero-tabs-content-fu__u9Gwx","hp_hero-tab-inner":"HeroFu_hp_hero-tab-inner__LX09y","hp_hero-tab-board-parent-fu":"HeroFu_hp_hero-tab-board-parent-fu__PyHUH","hp_hero-tab-board-parent-fu-ouline":"HeroFu_hp_hero-tab-board-parent-fu-ouline__YAY0v","hero_tabs-btn-parent-fu":"HeroFu_hero_tabs-btn-parent-fu__nVJaX","hp-hero-tabs-menu-top-fu":"HeroFu_hp-hero-tabs-menu-top-fu__Gv24r","hero-tabs-menu-top-h-fu":"HeroFu_hero-tabs-menu-top-h-fu__i7V0q","w-node-cc333ce5-50da-6e72-d1c6-dca7380364a2-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364a2-38036462__tmePw","w-node-cc333ce5-50da-6e72-d1c6-dca7380364a4-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364a4-38036462__lcgMv","w-node-cc333ce5-50da-6e72-d1c6-dca7380364ab-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364ab-38036462__ZTp08","w-node-cc333ce5-50da-6e72-d1c6-dca7380364ad-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364ad-38036462__6eJyE","w-node-cc333ce5-50da-6e72-d1c6-dca7380364b4-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364b4-38036462__eG3Ff","w-node-cc333ce5-50da-6e72-d1c6-dca7380364b6-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364b6-38036462__7wHl4","w-node-cc333ce5-50da-6e72-d1c6-dca7380364bd-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364bd-38036462__wIka_","w-node-cc333ce5-50da-6e72-d1c6-dca7380364bf-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364bf-38036462__rtqxO","w-node-cc333ce5-50da-6e72-d1c6-dca7380364c6-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364c6-38036462__W19CE","w-node-cc333ce5-50da-6e72-d1c6-dca7380364c8-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364c8-38036462__GCSVx","w-node-cc333ce5-50da-6e72-d1c6-dca7380364cf-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364cf-38036462__gek99","w-node-cc333ce5-50da-6e72-d1c6-dca7380364d1-38036462":"HeroFu_w-node-cc333ce5-50da-6e72-d1c6-dca7380364d1-38036462__W1Nn3"};

/***/ }),

/***/ 71433:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"HeroV8LeftPannel_lotem-hero__NgjBE","m_padding-global":"HeroV8LeftPannel_m_padding-global__PvJ7U","m_padding-section-medium":"HeroV8LeftPannel_m_padding-section-medium__TMjxy","m_padding-section-small":"HeroV8LeftPannel_m_padding-section-small__9n4zq","group_hero-center-all":"HeroV8LeftPannel_group_hero-center-all__EO8CW","m_hero-title-parent":"HeroV8LeftPannel_m_hero-title-parent__VBPEw","fw1_hero-title-black-lotem":"HeroV8LeftPannel_fw1_hero-title-black-lotem__lGXIh","is--short":"HeroV8LeftPannel_is--short__VSA7e","is--shorter":"HeroV8LeftPannel_is--shorter__1fagb","m_text-color-white":"HeroV8LeftPannel_m_text-color-white__WT9b9","subtitle-white-test-max-width":"HeroV8LeftPannel_subtitle-white-test-max-width__HH41K","fw2_hero-sub-black":"HeroV8LeftPannel_fw2_hero-sub-black__TDrYp","hp-hero-btnsparent":"HeroV8LeftPannel_hp-hero-btnsparent__MF0nD","m_button":"HeroV8LeftPannel_m_button__xfSgc","m_button-dev":"HeroV8LeftPannel_m_button-dev__dIElf","for--hero":"HeroV8LeftPannel_for--hero__E5I7I","for--modal":"HeroV8LeftPannel_for--modal__e3HW0","m_button-primary":"HeroV8LeftPannel_m_button-primary__aTVNs","for--mb-hp":"HeroV8LeftPannel_for--mb-hp__Z6zQ2","m_button-primary-white":"HeroV8LeftPannel_m_button-primary-white__7_4mv","btn-gradient":"HeroV8LeftPannel_btn-gradient__k2rhY","hero-btn-project":"HeroV8LeftPannel_hero-btn-project__GpKHx","is-visible":"HeroV8LeftPannel_is-visible__tcOlH","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"HeroV8LeftPannel_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__50LAi","hero-btn-crm":"HeroV8LeftPannel_hero-btn-crm__qe2bT","hero-btn-dev":"HeroV8LeftPannel_hero-btn-dev__0aynq","hero-btn-svc":"HeroV8LeftPannel_hero-btn-svc__QY55w","hero-btn-marketing":"HeroV8LeftPannel_hero-btn-marketing__iQhkZ","hero-btn-ops":"HeroV8LeftPannel_hero-btn-ops__3IXsD","m_button-crm":"HeroV8LeftPannel_m_button-crm__f6Z6v","m_button-svc":"HeroV8LeftPannel_m_button-svc__lbS1c","for--magic":"HeroV8LeftPannel_for--magic__6FzLR","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"HeroV8LeftPannel_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__Lwd7W","hero-btn-purple":"HeroV8LeftPannel_hero-btn-purple__cqedQ","m_button-arrow":"HeroV8LeftPannel_m_button-arrow__CfDjm","hp-hero-btn-label":"HeroV8LeftPannel_hp-hero-btn-label__WhTIg","hide":"HeroV8LeftPannel_hide__aqaPl","m_spacer-1rem":"HeroV8LeftPannel_m_spacer-1rem__GI5y2","lotem-hero-asset-tiny-text":"HeroV8LeftPannel_lotem-hero-asset-tiny-text__s5Ow_","m_spacer-2rem":"HeroV8LeftPannel_m_spacer-2rem__HlxxV","m_container-xlarge":"HeroV8LeftPannel_m_container-xlarge__3G3JA","for--departments":"HeroV8LeftPannel_for--departments__F9X6d","tabs-shorter-hero-wrapper-2":"HeroV8LeftPannel_tabs-shorter-hero-wrapper-2__2dLdJ","opening-question":"HeroV8LeftPannel_opening-question___1Axg","tabs-group-lotem-hero-wide":"HeroV8LeftPannel_tabs-group-lotem-hero-wide__EDz8t","short-hero-tab-stroke":"HeroV8LeftPannel_short-hero-tab-stroke__Scbcj","short-thumbnail-tab-image":"HeroV8LeftPannel_short-thumbnail-tab-image__cDWKs","lotem-hero-tab-content":"HeroV8LeftPannel_lotem-hero-tab-content__0A84U","no-top-radius-corners":"HeroV8LeftPannel_no-top-radius-corners__I5HUQ","lotem-hero-tab-pane":"HeroV8LeftPannel_lotem-hero-tab-pane__yY7m_","short-lotem-hero-asset-flexbox":"HeroV8LeftPannel_short-lotem-hero-asset-flexbox__X3Z08","left-pane-lotem-hero-shorter":"HeroV8LeftPannel_left-pane-lotem-hero-shorter__FGcP1","logo-wrapper":"HeroV8LeftPannel_logo-wrapper__6JyCH","lotem-hero-asset-info-text":"HeroV8LeftPannel_lotem-hero-asset-info-text__fcZ_L","logo-svg":"HeroV8LeftPannel_logo-svg__1e3Pu","products-logos-wrapper":"HeroV8LeftPannel_products-logos-wrapper__0P7bD","asset-image-lotem-hero":"HeroV8LeftPannel_asset-image-lotem-hero__Sn9Ta","ai-star-hero":"HeroV8LeftPannel_ai-star-hero__UtRCk","ai-star-hero-2":"HeroV8LeftPannel_ai-star-hero-2__KHIXI"};

/***/ }),

/***/ 94285:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"HeroV8OldImages_lotem-hero__WvIhm","m_padding-global":"HeroV8OldImages_m_padding-global__0D7UA","m_padding-section-medium":"HeroV8OldImages_m_padding-section-medium__V_WO3","m_padding-section-small":"HeroV8OldImages_m_padding-section-small__6n120","group_hero-center-all":"HeroV8OldImages_group_hero-center-all__nw_jo","m_hero-title-parent":"HeroV8OldImages_m_hero-title-parent__F70ac","fw1_hero-title-black-lotem":"HeroV8OldImages_fw1_hero-title-black-lotem__DCzFw","is--short":"HeroV8OldImages_is--short__yRwSb","is--shorter":"HeroV8OldImages_is--shorter__nyMCK","m_text-color-white":"HeroV8OldImages_m_text-color-white__XJz4d","subtitle-white-test-max-width":"HeroV8OldImages_subtitle-white-test-max-width__QYSmJ","fw2_hero-sub-black":"HeroV8OldImages_fw2_hero-sub-black__rIse7","hp-hero-btnsparent":"HeroV8OldImages_hp-hero-btnsparent__84MAv","m_button":"HeroV8OldImages_m_button__YlHja","m_button-dev":"HeroV8OldImages_m_button-dev__iwIAm","for--hero":"HeroV8OldImages_for--hero__zOMqA","for--modal":"HeroV8OldImages_for--modal__KohmU","m_button-primary":"HeroV8OldImages_m_button-primary__ubSAu","for--mb-hp":"HeroV8OldImages_for--mb-hp__PQ9RB","m_button-primary-white":"HeroV8OldImages_m_button-primary-white__BqfXB","btn-gradient":"HeroV8OldImages_btn-gradient__Zzyfv","hero-btn-project":"HeroV8OldImages_hero-btn-project__k0d3f","is-visible":"HeroV8OldImages_is-visible__br97M","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"HeroV8OldImages_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__VBXqW","hero-btn-crm":"HeroV8OldImages_hero-btn-crm__r3Uk7","hero-btn-dev":"HeroV8OldImages_hero-btn-dev__E7XLS","hero-btn-svc":"HeroV8OldImages_hero-btn-svc__fUFhT","hero-btn-marketing":"HeroV8OldImages_hero-btn-marketing__6kbkW","hero-btn-ops":"HeroV8OldImages_hero-btn-ops__zN63d","m_button-crm":"HeroV8OldImages_m_button-crm__dh3cj","m_button-svc":"HeroV8OldImages_m_button-svc__LaIlr","for--magic":"HeroV8OldImages_for--magic__L0BcK","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"HeroV8OldImages_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__ICAi_","hero-btn-purple":"HeroV8OldImages_hero-btn-purple__vatI2","m_button-arrow":"HeroV8OldImages_m_button-arrow__byYDw","hp-hero-btn-label":"HeroV8OldImages_hp-hero-btn-label__cAyhp","hide":"HeroV8OldImages_hide__Iobxl","m_spacer-1rem":"HeroV8OldImages_m_spacer-1rem__DuGkc","lotem-hero-asset-tiny-text":"HeroV8OldImages_lotem-hero-asset-tiny-text___w0w5","m_spacer-2rem":"HeroV8OldImages_m_spacer-2rem__6_eDr","m_container-xlarge":"HeroV8OldImages_m_container-xlarge__ZJFXs","for--departments":"HeroV8OldImages_for--departments__veoTk","tabs-shorter-hero-wrapper-2":"HeroV8OldImages_tabs-shorter-hero-wrapper-2__jlRIz","opening-question":"HeroV8OldImages_opening-question__bk1Ns","tabs-group-lotem-hero-wide":"HeroV8OldImages_tabs-group-lotem-hero-wide__Zunjt","short-hero-tab-stroke":"HeroV8OldImages_short-hero-tab-stroke__N3Y45","short-thumbnail-tab-image":"HeroV8OldImages_short-thumbnail-tab-image__2tJvD","lotem-hero-tab-content":"HeroV8OldImages_lotem-hero-tab-content__2LjTO","no-top-radius-corners":"HeroV8OldImages_no-top-radius-corners__Jo_3L","lotem-hero-tab-pane":"HeroV8OldImages_lotem-hero-tab-pane__fQAIq","short-lotem-hero-asset-flexbox":"HeroV8OldImages_short-lotem-hero-asset-flexbox__TO4ki","asset-image-lotem-hero":"HeroV8OldImages_asset-image-lotem-hero__ppDRx","right-pane-lotem-hero-shorter":"HeroV8OldImages_right-pane-lotem-hero-shorter__pcyW9","logo-wrapper":"HeroV8OldImages_logo-wrapper__a5WED","lotem-hero-asset-info-text":"HeroV8OldImages_lotem-hero-asset-info-text__GRhKF","logo-svg":"HeroV8OldImages_logo-svg__P0FNk","products-logos-wrapper":"HeroV8OldImages_products-logos-wrapper__7CueC","ai-star-hero":"HeroV8OldImages_ai-star-hero__LbIzI","ai-star-hero-2":"HeroV8OldImages_ai-star-hero-2__BLwAF"};

/***/ }),

/***/ 85294:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"LHeroHover_lotem-hero__24a7U","group_hero-center-all":"LHeroHover_group_hero-center-all__T3SKP","m_hero-title-parent":"LHeroHover_m_hero-title-parent__hkSmT","fw1_hero-title-black-lotem":"LHeroHover_fw1_hero-title-black-lotem__BiV_P","is--short":"LHeroHover_is--short__ae5tE","is--shorter":"LHeroHover_is--shorter__AJWOy","m_text-color-white":"LHeroHover_m_text-color-white__MKJNo","subtitle-white-test-max-width":"LHeroHover_subtitle-white-test-max-width__YHX0q","fw1_hero-sub-black":"LHeroHover_fw1_hero-sub-black__K4iUp","hp-hero-btnsparent":"LHeroHover_hp-hero-btnsparent__IOekr","fw1_button-parent":"LHeroHover_fw1_button-parent__PsW55","for--impact":"LHeroHover_for--impact__X_adD","m_button":"LHeroHover_m_button__BSnu_","m_button-dev":"LHeroHover_m_button-dev__h9gDB","for--hero":"LHeroHover_for--hero__5qlNV","for--modal":"LHeroHover_for--modal__g_YUa","m_button-primary":"LHeroHover_m_button-primary__qRUdT","for--mb-hp":"LHeroHover_for--mb-hp__pIbiE","m_button-primary-white":"LHeroHover_m_button-primary-white__BUZ9U","btn-gradient":"LHeroHover_btn-gradient__cO68h","hero-btn-project":"LHeroHover_hero-btn-project__CmKKQ","is-visible":"LHeroHover_is-visible__swGGj","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"LHeroHover_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__p0ak2","hero-btn-crm":"LHeroHover_hero-btn-crm__DocN_","hero-btn-dev":"LHeroHover_hero-btn-dev__d2NfY","hero-btn-svc":"LHeroHover_hero-btn-svc__PjAjI","hero-btn-marketing":"LHeroHover_hero-btn-marketing__UdlqQ","hero-btn-ops":"LHeroHover_hero-btn-ops__OZH_Z","m_button-crm":"LHeroHover_m_button-crm__ZiMSR","m_button-svc":"LHeroHover_m_button-svc__5bG68","for--magic":"LHeroHover_for--magic__kokdJ","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"LHeroHover_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__1uDiC","hero-btn-purple":"LHeroHover_hero-btn-purple__33FZe","m_button-arrow":"LHeroHover_m_button-arrow__km51e","no-credit-label":"LHeroHover_no-credit-label__2fAOO","hp-hero-btn-label":"LHeroHover_hp-hero-btn-label__4h8Hx","hide":"LHeroHover_hide__yEKje","m_spacer-3rem":"LHeroHover_m_spacer-3rem__RtYNX","lotem-tabs-parent":"LHeroHover_lotem-tabs-parent__pISPy","lotem-tabs-what-would":"LHeroHover_lotem-tabs-what-would__eFI2M","lotem-hero-tabs-holder":"LHeroHover_lotem-hero-tabs-holder__HNp4N","tabs-group-lotem-hero":"LHeroHover_tabs-group-lotem-hero__vvjZC","tab-lotem-hero-hover":"LHeroHover_tab-lotem-hero-hover__HZUAN","thumbnail-tab-image":"LHeroHover_thumbnail-tab-image__KHHQi","headshot-hero-video":"LHeroHover_headshot-hero-video__0gIj3","lotem-hero-tab-content":"LHeroHover_lotem-hero-tab-content__v6bmd","lotem-hero-tab-pane":"LHeroHover_lotem-hero-tab-pane__Pp7Z5","lotem-hero-asset-flexbox":"LHeroHover_lotem-hero-asset-flexbox__1CxGi","asset-image-lotem-hero":"LHeroHover_asset-image-lotem-hero__igipB","right-pane-lotem-hero":"LHeroHover_right-pane-lotem-hero__CR96Y","logo-wrapper":"LHeroHover_logo-wrapper__0Tdvc","lotem-hero-asset-info-text":"LHeroHover_lotem-hero-asset-info-text__SB1qC","logo-svg":"LHeroHover_logo-svg__qpJaT","m_spacer-2rem":"LHeroHover_m_spacer-2rem__XlTil","lotem-hero-asset-tiny-text":"LHeroHover_lotem-hero-asset-tiny-text__SNvTP","products-logos-wrapper":"LHeroHover_products-logos-wrapper__IR1bx","ai-star-hero":"LHeroHover_ai-star-hero__I5ZPq","ai-star-hero-2":"LHeroHover_ai-star-hero-2__MlydR"};

/***/ }),

/***/ 41050:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"LHeroVideos_lotem-hero__4AhVb","group_hero-center-all":"LHeroVideos_group_hero-center-all__6P7Q1","m_hero-title-parent":"LHeroVideos_m_hero-title-parent__CCo5D","fw1_hero-title-black-lotem":"LHeroVideos_fw1_hero-title-black-lotem__6iy0N","is--short":"LHeroVideos_is--short__YLlb6","is--shorter":"LHeroVideos_is--shorter__svSqx","m_text-color-white":"LHeroVideos_m_text-color-white__ScyTk","subtitle-white-test-max-width":"LHeroVideos_subtitle-white-test-max-width__sPRKt","fw1_hero-sub-black":"LHeroVideos_fw1_hero-sub-black__Zxh0x","hp-hero-btnsparent":"LHeroVideos_hp-hero-btnsparent__2YcP5","m_button":"LHeroVideos_m_button__x5Z0U","m_button-dev":"LHeroVideos_m_button-dev__gHaOB","for--hero":"LHeroVideos_for--hero__EJR0e","for--modal":"LHeroVideos_for--modal__wxQO2","m_button-primary":"LHeroVideos_m_button-primary__bf6mh","for--mb-hp":"LHeroVideos_for--mb-hp__v_2KT","m_button-primary-white":"LHeroVideos_m_button-primary-white__mIlib","btn-gradient":"LHeroVideos_btn-gradient__Zl2g9","hero-btn-project":"LHeroVideos_hero-btn-project__QEicm","is-visible":"LHeroVideos_is-visible__kT76N","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"LHeroVideos_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__dTdE_","hero-btn-crm":"LHeroVideos_hero-btn-crm__P3EZm","hero-btn-dev":"LHeroVideos_hero-btn-dev__EJTw6","hero-btn-svc":"LHeroVideos_hero-btn-svc__eVIf1","hero-btn-marketing":"LHeroVideos_hero-btn-marketing___avrs","hero-btn-ops":"LHeroVideos_hero-btn-ops__HAqV4","m_button-crm":"LHeroVideos_m_button-crm__T9cey","m_button-svc":"LHeroVideos_m_button-svc__PYEJd","for--magic":"LHeroVideos_for--magic__Mv8Zm","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"LHeroVideos_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__0C8XX","hero-btn-purple":"LHeroVideos_hero-btn-purple__PkwsU","m_button-arrow":"LHeroVideos_m_button-arrow__y6mM_","hp-hero-btn-label":"LHeroVideos_hp-hero-btn-label__1_5y4","hide":"LHeroVideos_hide__WimGH","m_spacer-3rem":"LHeroVideos_m_spacer-3rem__Fh4lB","lotem-hero-tabs-holder":"LHeroVideos_lotem-hero-tabs-holder__rugQ9","tabs-group-lotem-hero":"LHeroVideos_tabs-group-lotem-hero__5suc5","tab-lotem-hero-hover":"LHeroVideos_tab-lotem-hero-hover__mWnmJ","thumbnail-tab-image":"LHeroVideos_thumbnail-tab-image__9l7WA","headshot-hero-video":"LHeroVideos_headshot-hero-video__pZ76M","lotem-hero-tab-content":"LHeroVideos_lotem-hero-tab-content___j6kL","lotem-hero-tab-pane":"LHeroVideos_lotem-hero-tab-pane__dm1d5","lotem-hero-asset-flexbox":"LHeroVideos_lotem-hero-asset-flexbox__fac7V","asset-image-lotem-hero":"LHeroVideos_asset-image-lotem-hero__NEsuZ","right-pane-lotem-hero":"LHeroVideos_right-pane-lotem-hero__t6GHx","logo-wrapper":"LHeroVideos_logo-wrapper__Dv8J4","lotem-hero-asset-info-text":"LHeroVideos_lotem-hero-asset-info-text__Lv3cA","logo-svg":"LHeroVideos_logo-svg__rHE0T","m_spacer-2rem":"LHeroVideos_m_spacer-2rem__FZo7d","lotem-hero-asset-tiny-text":"LHeroVideos_lotem-hero-asset-tiny-text__Mb_KM","products-logos-wrapper":"LHeroVideos_products-logos-wrapper__9w1Et","ai-star-hero":"LHeroVideos_ai-star-hero__qWLzd","ai-star-hero-2":"LHeroVideos_ai-star-hero-2__b43i_"};

/***/ }),

/***/ 62463:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-logos":"Logos_sec-logos__lvIWb","m_padding-global":"Logos_m_padding-global__KHXyB","m_padding-section-medium":"Logos_m_padding-section-medium__nua0W","m_padding-section-small":"Logos_m_padding-section-small__xAV_u","m_padding-section-large":"Logos_m_padding-section-large__LrRlm","m_container-large":"Logos_m_container-large__mI5cn","for--departments":"Logos_for--departments__UPjIM","comp_hp-logos":"Logos_comp_hp-logos__IP8Hk","fw1_trusted-label":"Logos_fw1_trusted-label__0fLAe","fw1_hero-logos-mask":"Logos_fw1_hero-logos-mask__hrmWC","fw1_hero-logos-moving":"Logos_fw1_hero-logos-moving__im0xA","fw1_hero-logos-slide":"Logos_fw1_hero-logos-slide__1wSfJ","fw1_hero-logo":"Logos_fw1_hero-logo__242Ip","hp_logos-fade":"Logos_hp_logos-fade__A1Tyz","is--right":"Logos_is--right__nH_V8"};

/***/ }),

/***/ 95507:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"LotemHero_lotem-hero__dCcp3","group_hero-center-all":"LotemHero_group_hero-center-all__Ux8Kj","m_hero-title-parent":"LotemHero_m_hero-title-parent__mW6mv","fw1_hero-title-black-lotem":"LotemHero_fw1_hero-title-black-lotem__IQo1x","is--short":"LotemHero_is--short__AerlY","is--shorter":"LotemHero_is--shorter__KZ4bz","m_text-color-white":"LotemHero_m_text-color-white__9T1XC","subtitle-white-test-max-width":"LotemHero_subtitle-white-test-max-width__YBE6_","fw1_hero-sub-black":"LotemHero_fw1_hero-sub-black__ykk1y","hp-hero-btnsparent":"LotemHero_hp-hero-btnsparent__BOTwV","m_button":"LotemHero_m_button__SS_P9","m_button-dev":"LotemHero_m_button-dev__T6XYC","for--hero":"LotemHero_for--hero__csEr_","for--modal":"LotemHero_for--modal__FetuJ","m_button-primary":"LotemHero_m_button-primary__kXzgr","for--mb-hp":"LotemHero_for--mb-hp__MGIR_","m_button-primary-white":"LotemHero_m_button-primary-white__KoYo2","btn-gradient":"LotemHero_btn-gradient__fYkNX","hero-btn-project":"LotemHero_hero-btn-project__X5XbV","is-visible":"LotemHero_is-visible__buhbS","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"LotemHero_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__Jd5qm","hero-btn-crm":"LotemHero_hero-btn-crm__7Srqy","hero-btn-dev":"LotemHero_hero-btn-dev__iSrZg","hero-btn-svc":"LotemHero_hero-btn-svc__69qxg","hero-btn-marketing":"LotemHero_hero-btn-marketing__0gnLK","hero-btn-ops":"LotemHero_hero-btn-ops__4hQpj","m_button-crm":"LotemHero_m_button-crm__Av2n5","m_button-svc":"LotemHero_m_button-svc__ePQ2_","for--magic":"LotemHero_for--magic__ggA4V","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"LotemHero_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__cX8Ii","hero-btn-purple":"LotemHero_hero-btn-purple____BDN","m_button-arrow":"LotemHero_m_button-arrow__q0gCL","hp-hero-btn-label":"LotemHero_hp-hero-btn-label__g4QR2","hide":"LotemHero_hide__ssowI","m_spacer-3rem":"LotemHero_m_spacer-3rem__BQtt_","lotem-hero-tabs-holder":"LotemHero_lotem-hero-tabs-holder__cSv78","tabs-group-lotem-hero":"LotemHero_tabs-group-lotem-hero__RZlQv","tab-lotem-hero":"LotemHero_tab-lotem-hero__1dv9y","thumbnail-tab-image":"LotemHero_thumbnail-tab-image__DYPYB","lotem-hero-tab-content":"LotemHero_lotem-hero-tab-content__NxP0S","lotem-hero-tab-pane":"LotemHero_lotem-hero-tab-pane__IfWey","lotem-hero-asset-flexbox":"LotemHero_lotem-hero-asset-flexbox__rpsDq","asset-image-lotem-hero":"LotemHero_asset-image-lotem-hero__n3QZA","right-pane-lotem-hero":"LotemHero_right-pane-lotem-hero__O4daH","logo-wrapper":"LotemHero_logo-wrapper__fRNaV","lotem-hero-asset-info-text":"LotemHero_lotem-hero-asset-info-text__oDhEq","logo-svg":"LotemHero_logo-svg___WiUm","m_spacer-2rem":"LotemHero_m_spacer-2rem__T50E2","lotem-hero-asset-tiny-text":"LotemHero_lotem-hero-asset-tiny-text__JJ85P","products-logos-wrapper":"LotemHero_products-logos-wrapper__BVA5v","ai-star-hero":"LotemHero_ai-star-hero__G7wmi","ai-star-hero-2":"LotemHero_ai-star-hero-2__Getbc"};

/***/ }),

/***/ 81374:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"ap-gragient-sec":"Magic_ap-gragient-sec__gFxEk","m_padding-global":"Magic_m_padding-global__HaV1Z","m_padding-section-medium":"Magic_m_padding-section-medium__J_kOh","m_padding-section-small":"Magic_m_padding-section-small__8_aUA","fw1_container-large":"Magic_fw1_container-large__kh0p3","magic_hero-content":"Magic_magic_hero-content__ecCJJ","group_magic-top":"Magic_group_magic-top__FY7jd","magic_main-h":"Magic_magic_main-h__lfjXY","magic_sub-h":"Magic_magic_sub-h___Hffa","length-1":"Magic_length-1__UyAAh","magic_prompt-parent":"Magic_magic_prompt-parent__Xx4U8","magic_prompt-inner":"Magic_magic_prompt-inner__EfQrm","magic_textarea":"Magic_magic_textarea__eodlX","magic_button-parent":"Magic_magic_button-parent___QxTn","magic_disclaimer":"Magic_magic_disclaimer__pGQJI","magic_disclaimer-link":"Magic_magic_disclaimer-link__tP6XY","m_button":"Magic_m_button__998y9","m_button-dev":"Magic_m_button-dev__Wt5Vh","for--hero":"Magic_for--hero__Pq2zd","for--modal":"Magic_for--modal__Crtvn","m_button-primary":"Magic_m_button-primary__rKp_Y","for--mb-hp":"Magic_for--mb-hp__siAUp","m_button-primary-white":"Magic_m_button-primary-white__Q4E6f","btn-gradient":"Magic_btn-gradient__AO3KH","hero-btn-project":"Magic_hero-btn-project__k_vjR","is-visible":"Magic_is-visible__Tsq_m","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"Magic_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__dbjdK","hero-btn-crm":"Magic_hero-btn-crm__F0GaY","hero-btn-dev":"Magic_hero-btn-dev__rOpfY","hero-btn-svc":"Magic_hero-btn-svc__xuFCY","hero-btn-marketing":"Magic_hero-btn-marketing__Mo70y","hero-btn-ops":"Magic_hero-btn-ops__7sUb7","m_button-crm":"Magic_m_button-crm__VlDcE","m_button-svc":"Magic_m_button-svc__36Fqd","for--magic":"Magic_for--magic__zw6Nt","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Magic_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__zyMc8","hero-btn-purple":"Magic_hero-btn-purple__nVj0B","magic-btn-icon":"Magic_magic-btn-icon__m7K3O","m_button-arrow":"Magic_m_button-arrow__PL1Pm","magic-clear":"Magic_magic-clear__bsBSk","magic-clear-icon":"Magic_magic-clear-icon__CuXMH","paragraph":"Magic_paragraph__jZARo","spacer-1rem":"Magic_spacer-1rem__u1vd0","nagic_tags-wrap":"Magic_nagic_tags-wrap__KkjLQ","magic-cb":"Magic_magic-cb__lUK2F","is-active":"Magic_is-active__4br93","magic-cb-inner":"Magic_magic-cb-inner__jYjd5","hover-on-tag":"Magic_hover-on-tag__cdsXj","hero-star-1-2":"Magic_hero-star-1-2__vMobX","hero-star-2-2":"Magic_hero-star-2-2__mfKoP"};

/***/ }),

/***/ 46945:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-difference":"MondayDifference_sec-difference__S0P78","m_padding-global":"MondayDifference_m_padding-global__EKn7Q","m_padding-section-medium":"MondayDifference_m_padding-section-medium__TU1C7","m_padding-section-small":"MondayDifference_m_padding-section-small__zKt_u","m_padding-section-large":"MondayDifference_m_padding-section-large__oRpDi","m_container-large":"MondayDifference_m_container-large__sw8wY","for--departments":"MondayDifference_for--departments__Ypqu3","group_sec-h-center":"MondayDifference_group_sec-h-center__amS7h","fw1_section-headline-parent":"MondayDifference_fw1_section-headline-parent__Xpbgf","is--center":"MondayDifference_is--center__EkKxr","fw1_section-title":"MondayDifference_fw1_section-title__Eikwd","is--short":"MondayDifference_is--short__uAT_8","is--shorter":"MondayDifference_is--shorter__UAzjh","m_text-color-white":"MondayDifference_m_text-color-white__rJ0UR","conp_hp-difference":"MondayDifference_conp_hp-difference__BDCuH","hp-difference-item":"MondayDifference_hp-difference-item__th7b_","hp-difference-card-parent-small":"MondayDifference_hp-difference-card-parent-small__Z__Co","difference-item-card-back":"MondayDifference_difference-item-card-back__dFczI","is--green":"MondayDifference_is--green__E38_J","is--pink":"MondayDifference_is--pink__RYME5","is--primary":"MondayDifference_is--primary__iAdco","is--sm":"MondayDifference_is--sm__KoK1w","hp_diff-vid":"MondayDifference_hp_diff-vid___99Y_","difference-item-card-front":"MondayDifference_difference-item-card-front__2sdkw","is--child-1":"MondayDifference_is--child-1__GwFFD","is-child-3":"MondayDifference_is-child-3__LU2Cg","is-child-2":"MondayDifference_is-child-2__2strv","diff-show-on-hover":"MondayDifference_diff-show-on-hover__7Qmba","for--edit":"MondayDifference_for--edit__BKyHL","difference-after-number":"MondayDifference_difference-after-number__ja3tq","is--black":"MondayDifference_is--black__IUp_4","difference-sm-after-par":"MondayDifference_difference-sm-after-par__yMURy","hp-difference-card-parent":"MondayDifference_hp-difference-card-parent__6b6i1","difference-before-h":"MondayDifference_difference-before-h__tlsum","difference-before-par":"MondayDifference_difference-before-par__l4UVx","group-diff-headshot":"MondayDifference_group-diff-headshot__oi4ok","hp_tab-bento-headshot":"MondayDifference_hp_tab-bento-headshot__9qiAt","is-hidden":"MondayDifference_is-hidden__jjPH_","quote-headshot-name":"MondayDifference_quote-headshot-name__Fax9E","quote-headshot-title":"MondayDifference_quote-headshot-title__4WM02","difference-after-quote":"MondayDifference_difference-after-quote__ZgFxN","difference-after-logo-parent":"MondayDifference_difference-after-logo-parent__JDHMl","difference-after-logo":"MondayDifference_difference-after-logo__pRLT0","w-node-c21a2de5-40c8-4872-5aa0-462f6509739b-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f6509739b-6509738e__foLv0","w-node-c21a2de5-40c8-4872-5aa0-462f6509739d-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f6509739d-6509738e__TnZdK","w-node-c21a2de5-40c8-4872-5aa0-462f650973b5-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973b5-6509738e__9tO5A","w-node-c21a2de5-40c8-4872-5aa0-462f650973b0-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973b0-6509738e__MsQqg","w-node-c21a2de5-40c8-4872-5aa0-462f650973bc-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973bc-6509738e__F4bvq","w-node-c21a2de5-40c8-4872-5aa0-462f650973cc-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973cc-6509738e__xL4Ed","w-node-c21a2de5-40c8-4872-5aa0-462f650973d0-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973d0-6509738e__Inm62","w-node-c21a2de5-40c8-4872-5aa0-462f650973d2-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973d2-6509738e__fcl85","w-node-c21a2de5-40c8-4872-5aa0-462f650973d6-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973d6-6509738e__6Kpyc","w-node-c21a2de5-40c8-4872-5aa0-462f650973d9-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973d9-6509738e__kaXtG","w-node-c21a2de5-40c8-4872-5aa0-462f650973db-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973db-6509738e__0hGWP","w-node-c21a2de5-40c8-4872-5aa0-462f650973e3-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973e3-6509738e__43fhG","w-node-c21a2de5-40c8-4872-5aa0-462f650973f3-6509738e":"MondayDifference_w-node-c21a2de5-40c8-4872-5aa0-462f650973f3-6509738e__RkNIW"};

/***/ }),

/***/ 62090:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-products":"Products_sec-products___5Vpy","m_padding-global":"Products_m_padding-global__RY73M","m_padding-section-medium":"Products_m_padding-section-medium__e7Oqw","m_padding-section-small":"Products_m_padding-section-small__0mzPz","m_padding-section-large":"Products_m_padding-section-large__4RCdI","m_container-large":"Products_m_container-large__auIgv","for--departments":"Products_for--departments__IZWhN","group_sec-h-sbs":"Products_group_sec-h-sbs__RYoRg","for-quotes":"Products_for-quotes__gRX_3","sec-h-sbs-start":"Products_sec-h-sbs-start__mIOrO","fw1_section-title":"Products_fw1_section-title__1BbKt","is--short":"Products_is--short__jEaa2","is--shorter":"Products_is--shorter__h2TdJ","m_text-color-white":"Products_m_text-color-white__utV6I","sec-h-sbs-end":"Products_sec-h-sbs-end__QEIeF","sec-h-sbs-par":"Products_sec-h-sbs-par__0hIlc","fw1_button-combo":"Products_fw1_button-combo__0DFKL","for--agents":"Products_for--agents__X5LNj","m_button":"Products_m_button__R3_nd","m_button-dev":"Products_m_button-dev__dhqoU","for--hero":"Products_for--hero__Mopvg","for--modal":"Products_for--modal__D7bwx","m_button-primary":"Products_m_button-primary__1wFWs","for--mb-hp":"Products_for--mb-hp__hSYk2","m_button-primary-white":"Products_m_button-primary-white__ILRUW","btn-gradient":"Products_btn-gradient__T1Y7g","hero-btn-project":"Products_hero-btn-project__MJQgA","is-visible":"Products_is-visible__h5kJb","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"Products_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__p6gy5","hero-btn-crm":"Products_hero-btn-crm__3S_Jq","hero-btn-dev":"Products_hero-btn-dev__JtaJh","hero-btn-svc":"Products_hero-btn-svc__tIiZ4","hero-btn-marketing":"Products_hero-btn-marketing__1zOQ6","hero-btn-ops":"Products_hero-btn-ops__Erg46","m_button-crm":"Products_m_button-crm__XYaw9","m_button-svc":"Products_m_button-svc__qa1il","for--magic":"Products_for--magic__tkboY","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Products_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__UF0do","hero-btn-purple":"Products_hero-btn-purple__KKAo3","m_button-arrow":"Products_m_button-arrow__mjBo9","m_button-outline":"Products_m_button-outline__vtoZ5","m_button-outline-white":"Products_m_button-outline-white__AgzIz","m_button-outline-primary":"Products_m_button-outline-primary__xQj22","comp_ai-powered":"Products_comp_ai-powered__tDqBh","ai-powered-card-parent":"Products_ai-powered-card-parent__JTXY0","ai-powered-card-gradient":"Products_ai-powered-card-gradient__aiV2r","ai-powered-card-content":"Products_ai-powered-card-content__KPgQl","ai-powered-product-logo":"Products_ai-powered-product-logo__O6Wxc","ai-powered-card-text":"Products_ai-powered-card-text__w9tQ8","m_button-link":"Products_m_button-link___RNCo","m_button-link-white":"Products_m_button-link-white__vINtv","push-to-bottom":"Products_push-to-bottom__ehYJL","ai-powered-modal":"Products_ai-powered-modal__sFqa5","for--edit":"Products_for--edit__WhZAC","close-modal-trigger":"Products_close-modal-trigger__U9BB0","ai-powered-modal-content":"Products_ai-powered-modal-content__cgeCY","ai-powered-modal-top":"Products_ai-powered-modal-top__iTnLK","ai-powered-product-modal-logo":"Products_ai-powered-product-modal-logo__6wRei","ai-powered-modal-h":"Products_ai-powered-modal-h__YaBD3","ai-powered-modal-bottom":"Products_ai-powered-modal-bottom__EPF7Q","ai-powered-modal-tabs":"Products_ai-powered-modal-tabs__EdLSm","ai-powered-modal-tab-menu":"Products_ai-powered-modal-tab-menu__DbTsZ","ai-powered-tab-link":"Products_ai-powered-tab-link__qCGaJ","last--child":"Products_last--child__zaEYo","ai-powered-tab-header":"Products_ai-powered-tab-header__78WA3","ai-powered-arrow":"Products_ai-powered-arrow__r4tzi","ai-powered-tab-h":"Products_ai-powered-tab-h__7EboV","ai-powered-tab-body":"Products_ai-powered-tab-body__8YOl1","ai-powered-tab-par":"Products_ai-powered-tab-par__3efhB","ch-option-1":"Products_ch-option-1__Smc3Y","ch-option-2":"Products_ch-option-2__PCLqo","ch-option-3":"Products_ch-option-3__Gteio","ai-powered-modal-tab-content":"Products_ai-powered-modal-tab-content__lQORh","for--crm":"Products_for--crm__VxHA2","for--dev":"Products_for--dev__2V3jU","for--svc":"Products_for--svc__NJLZw","ai-powered-modal-img-parent":"Products_ai-powered-modal-img-parent__teW3Y","is--dev":"Products_is--dev__jmU36","product_acc-img-parent":"Products_product_acc-img-parent__ietFI","popup-btn-parent":"Products_popup-btn-parent__Ina1a","modal-close-icon":"Products_modal-close-icon__v6uUA","comp_ai-powered-img-parent":"Products_comp_ai-powered-img-parent__GLjrV","comp_ai-powered-img":"Products_comp_ai-powered-img__3iWJC","ai-powered-label":"Products_ai-powered-label__Bmug_","is--sales":"Products_is--sales__UIqQ6","is--engeeniring":"Products_is--engeeniring__8tQT5","is--marketing":"Products_is--marketing__nlKJy","is--it":"Products_is--it__cqmSo","w-node-cf2d881b-657f-37eb-bd70-d4947c946ebe-7c946eb0":"Products_w-node-cf2d881b-657f-37eb-bd70-d4947c946ebe-7c946eb0__b15_O","w-node-cf2d881b-657f-37eb-bd70-d4947c946ec2-7c946eb0":"Products_w-node-cf2d881b-657f-37eb-bd70-d4947c946ec2-7c946eb0__9bUrQ","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be6f0-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be6f0-7c946eb0__DFYte","w-node-_8b01caa0-89de-ef3b-dafc-52ade8070e76-7c946eb0":"Products_w-node-_8b01caa0-89de-ef3b-dafc-52ade8070e76-7c946eb0__MrA3E","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be722-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be722-7c946eb0__LdGlC","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be728-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be728-7c946eb0__TQApP","w-node-bc2ce7a2-ee27-55be-e04a-11cc37ce6c7c-7c946eb0":"Products_w-node-bc2ce7a2-ee27-55be-e04a-11cc37ce6c7c-7c946eb0__iEz9j","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be75a-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be75a-7c946eb0__5q5AA","w-node-_53f028b6-b1c8-5885-6d49-c4ac62b4ff88-7c946eb0":"Products_w-node-_53f028b6-b1c8-5885-6d49-c4ac62b4ff88-7c946eb0___QQBf","w-node-_6fe3afdd-fe16-05b3-6cd1-68686862e69d-7c946eb0":"Products_w-node-_6fe3afdd-fe16-05b3-6cd1-68686862e69d-7c946eb0__CoLwi","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be761-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be761-7c946eb0__XMyP9","w-node-_8020e102-67aa-5ef2-df13-b91c8b1a2b0b-7c946eb0":"Products_w-node-_8020e102-67aa-5ef2-df13-b91c8b1a2b0b-7c946eb0__YH6sB","w-node-_7b1e2cad-e967-be08-6698-cc19ff5be799-7c946eb0":"Products_w-node-_7b1e2cad-e967-be08-6698-cc19ff5be799-7c946eb0__3xaF7","w-node-d8a64295-5013-1751-e509-9f790321a065-7c946eb0":"Products_w-node-d8a64295-5013-1751-e509-9f790321a065-7c946eb0__0l_0_","w-node-f126183e-c5c8-5d35-05e8-2994c0106aa2-7c946eb0":"Products_w-node-f126183e-c5c8-5d35-05e8-2994c0106aa2-7c946eb0__PPNjH"};

/***/ }),

/***/ 57343:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-security":"Security_sec-security__d32vA","m_padding-global":"Security_m_padding-global__bTU_M","m_padding-section-medium":"Security_m_padding-section-medium__S1bDk","m_padding-section-small":"Security_m_padding-section-small__9sgUP","m_padding-section-large":"Security_m_padding-section-large___4w33","m_container-large":"Security_m_container-large__FT7Ae","for--departments":"Security_for--departments__9Eq__","group_sec-h-center":"Security_group_sec-h-center__6DtP6","fw1_section-headline-parent":"Security_fw1_section-headline-parent__depOw","is--center":"Security_is--center__F7G6_","fw1_section-title":"Security_fw1_section-title__eOkRI","is--short":"Security_is--short__H2Ddf","is--shorter":"Security_is--shorter__mKAdg","m_text-color-white":"Security_m_text-color-white__lWTut","comp_hp-security":"Security_comp_hp-security__H_NEn","group_security-logos":"Security_group_security-logos__AtFbo","hp_security-logo":"Security_hp_security-logo__HlrY2","group_security-content":"Security_group_security-content__t1oPn","security-content-par":"Security_security-content-par__9GZE9","m_button-link":"Security_m_button-link__4H0nD","m_button-link-white":"Security_m_button-link-white__uYUrX","push-to-bottom":"Security_push-to-bottom__7BzHt","m_button-arrow":"Security_m_button-arrow__a7NgI","for--magic":"Security_for--magic__XazAU","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Security_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__6bzXx","m_link-underline":"Security_m_link-underline__fFFHU","link-underline-white":"Security_link-underline-white___BruW","bg-color-white":"Security_bg-color-white__vsCjR"};

/***/ }),

/***/ 81819:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"ShorterHero1_lotem-hero__xeTre","m_padding-global":"ShorterHero1_m_padding-global__FOntd","m_padding-section-medium":"ShorterHero1_m_padding-section-medium__8Opyy","m_padding-section-small":"ShorterHero1_m_padding-section-small__44Qtd","group_hero-center-all":"ShorterHero1_group_hero-center-all__3mSQ_","m_hero-title-parent":"ShorterHero1_m_hero-title-parent__DE0_n","fw1_hero-title-black-lotem":"ShorterHero1_fw1_hero-title-black-lotem__vhzHR","is--short":"ShorterHero1_is--short__llSJ2","is--shorter":"ShorterHero1_is--shorter__0aJ_G","m_text-color-white":"ShorterHero1_m_text-color-white__e8WrI","subtitle-white-test-max-width":"ShorterHero1_subtitle-white-test-max-width__AiN_B","fw2_hero-sub-black":"ShorterHero1_fw2_hero-sub-black__XuUZz","hp-hero-btnsparent":"ShorterHero1_hp-hero-btnsparent__CEQVd","m_button":"ShorterHero1_m_button__M1NhD","m_button-dev":"ShorterHero1_m_button-dev__0vg7y","for--hero":"ShorterHero1_for--hero__yFexI","for--modal":"ShorterHero1_for--modal__EiG9u","m_button-primary":"ShorterHero1_m_button-primary__JWEdc","for--mb-hp":"ShorterHero1_for--mb-hp__5Uwp0","m_button-primary-white":"ShorterHero1_m_button-primary-white__aKj0k","btn-gradient":"ShorterHero1_btn-gradient__sFfzb","hero-btn-project":"ShorterHero1_hero-btn-project__g385h","is-visible":"ShorterHero1_is-visible__Brhh3","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"ShorterHero1_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__1tpoR","hero-btn-crm":"ShorterHero1_hero-btn-crm__Shn4A","hero-btn-dev":"ShorterHero1_hero-btn-dev__ORCrU","hero-btn-svc":"ShorterHero1_hero-btn-svc__akN0P","hero-btn-marketing":"ShorterHero1_hero-btn-marketing__SzmR8","hero-btn-ops":"ShorterHero1_hero-btn-ops__T0lHl","m_button-crm":"ShorterHero1_m_button-crm__hOluR","m_button-svc":"ShorterHero1_m_button-svc__u3QUz","for--magic":"ShorterHero1_for--magic__i_UzI","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"ShorterHero1_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__0jKiA","hero-btn-purple":"ShorterHero1_hero-btn-purple__ENVXs","m_button-arrow":"ShorterHero1_m_button-arrow__7tAY5","hp-hero-btn-label":"ShorterHero1_hp-hero-btn-label__qUmGc","hide":"ShorterHero1_hide__OKun8","m_spacer-1rem":"ShorterHero1_m_spacer-1rem__jz4kp","lotem-hero-asset-tiny-text":"ShorterHero1_lotem-hero-asset-tiny-text__MVBm0","m_spacer-2rem":"ShorterHero1_m_spacer-2rem__4xr_6","m_container-xlarge":"ShorterHero1_m_container-xlarge__nDaNp","for--departments":"ShorterHero1_for--departments__nMPxO","opening-question-2":"ShorterHero1_opening-question-2__w7sE0","lotem-hero-tabs-holder":"ShorterHero1_lotem-hero-tabs-holder__MIFYv","max-width-60rem":"ShorterHero1_max-width-60rem__MVMas","tabs-group-lotem-hero-wide-2":"ShorterHero1_tabs-group-lotem-hero-wide-2__3Yr5P","short-hero-tab":"ShorterHero1_short-hero-tab__ZHRki","short-thumbnail-tab-image":"ShorterHero1_short-thumbnail-tab-image__tpRAh","lotem-hero-tab-content":"ShorterHero1_lotem-hero-tab-content___0oJk","no-top-radius-corners":"ShorterHero1_no-top-radius-corners__URTi_","lotem-hero-tab-pane":"ShorterHero1_lotem-hero-tab-pane__Mghxq","lotem-hero-asset-flexbox":"ShorterHero1_lotem-hero-asset-flexbox__einmV","asset-image-lotem-hero":"ShorterHero1_asset-image-lotem-hero__CQo0n","right-pane-lotem-hero-shorter":"ShorterHero1_right-pane-lotem-hero-shorter__ZN_pX","logo-wrapper":"ShorterHero1_logo-wrapper__aNpwS","lotem-hero-asset-info-text":"ShorterHero1_lotem-hero-asset-info-text__zFYlN","logo-svg":"ShorterHero1_logo-svg__E0taG","products-logos-wrapper":"ShorterHero1_products-logos-wrapper__lOwfl","ai-star-hero":"ShorterHero1_ai-star-hero__RIa0q","ai-star-hero-2":"ShorterHero1_ai-star-hero-2__d26iw"};

/***/ }),

/***/ 9815:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lotem-hero":"ShorterHero2_lotem-hero__52vKd","m_padding-global":"ShorterHero2_m_padding-global__DIEpJ","m_padding-section-medium":"ShorterHero2_m_padding-section-medium__4uXmQ","m_padding-section-small":"ShorterHero2_m_padding-section-small__7Wu1S","group_hero-center-all":"ShorterHero2_group_hero-center-all__Gy9pv","m_hero-title-parent":"ShorterHero2_m_hero-title-parent__dlx2P","fw1_hero-title-black-lotem":"ShorterHero2_fw1_hero-title-black-lotem__TTxgw","is--short":"ShorterHero2_is--short__uz15l","is--shorter":"ShorterHero2_is--shorter__6h5sc","m_text-color-white":"ShorterHero2_m_text-color-white__xOW3H","subtitle-white-test-max-width":"ShorterHero2_subtitle-white-test-max-width__dt2pm","fw2_hero-sub-black":"ShorterHero2_fw2_hero-sub-black__UNzaR","hp-hero-btnsparent":"ShorterHero2_hp-hero-btnsparent__AR6Z8","m_button":"ShorterHero2_m_button__xQeGD","m_button-dev":"ShorterHero2_m_button-dev__zP_gV","for--hero":"ShorterHero2_for--hero__F8xfl","for--modal":"ShorterHero2_for--modal__mrOGQ","m_button-primary":"ShorterHero2_m_button-primary__L_j14","for--mb-hp":"ShorterHero2_for--mb-hp__91CZQ","m_button-primary-white":"ShorterHero2_m_button-primary-white__ttF_x","btn-gradient":"ShorterHero2_btn-gradient__mcM9h","hero-btn-project":"ShorterHero2_hero-btn-project__dO6Ca","is-visible":"ShorterHero2_is-visible__QtzIf","w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a":"ShorterHero2_w-variant-a7c8fa42-3ce9-1700-addb-1eea1f31eb7a__iers0","hero-btn-crm":"ShorterHero2_hero-btn-crm__hOZ_a","hero-btn-dev":"ShorterHero2_hero-btn-dev__DT6zX","hero-btn-svc":"ShorterHero2_hero-btn-svc__cK9kF","hero-btn-marketing":"ShorterHero2_hero-btn-marketing__lCgYo","hero-btn-ops":"ShorterHero2_hero-btn-ops__nxSQY","m_button-crm":"ShorterHero2_m_button-crm__IwTEY","m_button-svc":"ShorterHero2_m_button-svc__T3Jdg","for--magic":"ShorterHero2_for--magic__qJ75j","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"ShorterHero2_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__dWq1M","hero-btn-purple":"ShorterHero2_hero-btn-purple__Dkqf_","m_button-arrow":"ShorterHero2_m_button-arrow__D844z","hp-hero-btn-label":"ShorterHero2_hp-hero-btn-label__96HFt","hide":"ShorterHero2_hide__yjBij","m_spacer-1rem":"ShorterHero2_m_spacer-1rem___TkxQ","lotem-hero-asset-tiny-text":"ShorterHero2_lotem-hero-asset-tiny-text__9DF4A","m_spacer-2rem":"ShorterHero2_m_spacer-2rem__LGRN0","m_container-xlarge":"ShorterHero2_m_container-xlarge__arv_Y","for--departments":"ShorterHero2_for--departments__hCim6","tabs-shorter-hero-wrapper-2":"ShorterHero2_tabs-shorter-hero-wrapper-2__xWg_U","opening-question":"ShorterHero2_opening-question__mnnb6","tabs-group-lotem-hero-wide":"ShorterHero2_tabs-group-lotem-hero-wide__EdnNR","short-hero-tab-stroke":"ShorterHero2_short-hero-tab-stroke__t8mmT","short-thumbnail-tab-image":"ShorterHero2_short-thumbnail-tab-image__jyZm_","lotem-hero-tab-content":"ShorterHero2_lotem-hero-tab-content__MiIBM","no-top-radius-corners":"ShorterHero2_no-top-radius-corners__PDycW","lotem-hero-tab-pane":"ShorterHero2_lotem-hero-tab-pane__7vzSk","short-lotem-hero-asset-flexbox":"ShorterHero2_short-lotem-hero-asset-flexbox__IaH7N","asset-image-lotem-hero":"ShorterHero2_asset-image-lotem-hero__GvQBk","right-pane-lotem-hero-shorter":"ShorterHero2_right-pane-lotem-hero-shorter__yaQIv","logo-wrapper":"ShorterHero2_logo-wrapper__vhO6j","lotem-hero-asset-info-text":"ShorterHero2_lotem-hero-asset-info-text__R2m_z","logo-svg":"ShorterHero2_logo-svg___EQLA","products-logos-wrapper":"ShorterHero2_products-logos-wrapper__sAEmF","lotem-hero-asset-flexbox":"ShorterHero2_lotem-hero-asset-flexbox__cfUD7","ai-star-hero":"ShorterHero2_ai-star-hero__MmzXn","ai-star-hero-2":"ShorterHero2_ai-star-hero-2__btvSD"};

/***/ }),

/***/ 27213:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sec-trust":"Trust_sec-trust__5W2g6","m_padding-global":"Trust_m_padding-global__L4Q0J","m_padding-section-medium":"Trust_m_padding-section-medium__0jAwQ","m_padding-section-small":"Trust_m_padding-section-small__Y4o_O","m_padding-section-large":"Trust_m_padding-section-large__kwo32","m_container-large":"Trust_m_container-large__H1EfK","for--departments":"Trust_for--departments__Xr6QL","group_sec-h-center":"Trust_group_sec-h-center__nmqqT","fw1_section-headline-parent":"Trust_fw1_section-headline-parent__OKLWd","is--center":"Trust_is--center__Sswov","fw1_section-title":"Trust_fw1_section-title__rZkX6","is--short":"Trust_is--short__YXGI0","is--shorter":"Trust_is--shorter___ni4z","m_text-color-white":"Trust_m_text-color-white__2Q0tW","comp_hp-trust":"Trust_comp_hp-trust__jHVHT","fw1_trust-card":"Trust_fw1_trust-card__Mj4Zl","splide__slide":"Trust_splide__slide__deoN8","is--gartner":"Trust_is--gartner__9Dgy_","is--g2":"Trust_is--g2__To8Od","is--forrester":"Trust_is--forrester__Th0rY","fw1_trust-card-top":"Trust_fw1_trust-card-top__MO9X0","hp_trust-card-logo":"Trust_hp_trust-card-logo__U_Xjs","hp_trust-card-par":"Trust_hp_trust-card-par__Uwb4_","fw1_trust-card-bottom":"Trust_fw1_trust-card-bottom__Hi1IT","m_button-link":"Trust_m_button-link__dkEeH","m_button-link-white":"Trust_m_button-link-white__WNbaB","push-to-bottom":"Trust_push-to-bottom__qVovA","m_button-arrow":"Trust_m_button-arrow__h7GW4","for--magic":"Trust_for--magic__mFBaE","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"Trust_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__96n6u","m_link-underline":"Trust_m_link-underline__vU4EL","link-underline-white":"Trust_link-underline-white__Vcqdp","bg-color-white":"Trust_bg-color-white__ryVwJ","hp_trust-card-badge":"Trust_hp_trust-card-badge__0oVZc","hp_trust-card-g2-logo":"Trust_hp_trust-card-g2-logo__UcVP5","w-node-_1661ab17-4844-04ac-e260-5b7c5c2708a5-5c27089b":"Trust_w-node-_1661ab17-4844-04ac-e260-5b7c5c2708a5-5c27089b___k8zj","w-node-_1661ab17-4844-04ac-e260-5b7c5c2708b0-5c27089b":"Trust_w-node-_1661ab17-4844-04ac-e260-5b7c5c2708b0-5c27089b__Vgz7f","w-node-_1661ab17-4844-04ac-e260-5b7c5c2708bc-5c27089b":"Trust_w-node-_1661ab17-4844-04ac-e260-5b7c5c2708bc-5c27089b___JtDg"};

/***/ }),

/***/ 35898:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"trust-nav-component":"TrustNav_trust-nav-component__wdDXM","is-sticky":"TrustNav_is-sticky__vwzKw","position-fixed":"TrustNav_position-fixed__WfsUF","m_mandatory-css":"TrustNav_m_mandatory-css__rMRJF","minisite-nav":"TrustNav_minisite-nav__IWSa6","is-static":"TrustNav_is-static__W9p1l","nav-full-minisite":"TrustNav_nav-full-minisite__QERNF","for-ms":"TrustNav_for-ms___hyZt","for-edit":"TrustNav_for-edit__6HqSY","for-general":"TrustNav_for-general__G_iT0","shadow-on-nav":"TrustNav_shadow-on-nav__zx_Rt","m_nav-container-full":"TrustNav_m_nav-container-full__qZHdk","m_header-logo-desktop":"TrustNav_m_header-logo-desktop__ifIjO","group_nav-full-content":"TrustNav_group_nav-full-content__3Mjcw","nav-full-content-start":"TrustNav_nav-full-content-start__pdhn2","for-minisite":"TrustNav_for-minisite__qMQy9","m_nav_link-full":"TrustNav_m_nav_link-full__lmPf3","chevron-down":"TrustNav_chevron-down__XOjCk","for--dd":"TrustNav_for--dd__4XqG6","group_nav-full-wrap":"TrustNav_group_nav-full-wrap__xlp9i","group_nav-full-child":"TrustNav_group_nav-full-child__h7WJe","shadow-on-list":"TrustNav_shadow-on-list__aIp9E","group-nav-content-top":"TrustNav_group-nav-content-top__3VNEh","group_nav-col-parent":"TrustNav_group_nav-col-parent__6rUvl","is-solutions-end":"TrustNav_is-solutions-end__9Xd5t","is-solutions-start":"TrustNav_is-solutions-start__Dzcb5","is-solutions-center":"TrustNav_is-solutions-center__uh5cB","is-products-end":"TrustNav_is-products-end__7UpH1","nav-group-col-h":"TrustNav_nav-group-col-h__Q68lG","for-product":"TrustNav_for-product__45w8Z","group_nav-col":"TrustNav_group_nav-col__WFmAd","_w-big-gap":"TrustNav__w-big-gap__SG7jQ","m_dt-nav-link":"TrustNav_m_dt-nav-link__mYEQ8","less-line-height":"TrustNav_less-line-height__1RI41","m_dt-nav-link-icon-parent":"TrustNav_m_dt-nav-link-icon-parent__PI5zy","is-product":"TrustNav_is-product__zA_gP","grid_nav-products":"TrustNav_grid_nav-products__knrQU","_w-one-col":"TrustNav__w-one-col__jAcQO","m_dt-nav-link-title":"TrustNav_m_dt-nav-link-title__dU3JQ","is-compani-size":"TrustNav_is-compani-size__xGDqR","m_dt-nav-link-sub":"TrustNav_m_dt-nav-link-sub__kGf5d","_w-br":"TrustNav__w-br__D43Ae","group-nav-content-footer":"TrustNav_group-nav-content-footer__m9kH8","group_header-buttons":"TrustNav_group_header-buttons__d05ww","m_button-link-2":"TrustNav_m_button-link-2__vxaqu","in-headre":"TrustNav_in-headre__0jmHE","m_button-arrow":"TrustNav_m_button-arrow__Ym7KS","for--magic":"TrustNav_for--magic__Xn_eZ","w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da":"TrustNav_w-variant-672985ec-5fe0-0ac2-11cf-dbdb0764b3da__lrB4G","header-links-divider":"TrustNav_header-links-divider__CKSGo","close-trig":"TrustNav_close-trig__nuT0u","grid_nav-teams":"TrustNav_grid_nav-teams__KfERa","nav_link-full":"TrustNav_nav_link-full__itLGa","is-drop":"TrustNav_is-drop___4o4H","is-header-cs":"TrustNav_is-header-cs__mCWaR","nav-full-content-end":"TrustNav_nav-full-content-end__QdSR6","primary-button-10":"TrustNav_primary-button-10__EsS44","_w-arrow":"TrustNav__w-arrow__iPy26","in-nav":"TrustNav_in-nav__Mw_Os","arrow-embed-full":"TrustNav_arrow-embed-full__LiWg4","comp_switcher":"TrustNav_comp_switcher__Xz6z2","switcher-toggle":"TrustNav_switcher-toggle__KnzX_","icon_switcher":"TrustNav_icon_switcher__0Afkv","switcher-list":"TrustNav_switcher-list__J25w_","switcher-h":"TrustNav_switcher-h__v_X2B","is--grey":"TrustNav_is--grey__2PAR7","light-97":"TrustNav_light-97__p33mW","switcher-product-link":"TrustNav_switcher-product-link__0jG9e","switcher-app-icon":"TrustNav_switcher-app-icon__mtgrD","group_switcher-bottom":"TrustNav_group_switcher-bottom__ZpnZm","switcher-bottom-end":"TrustNav_switcher-bottom-end__qDfn9","switcher-app-icon-small":"TrustNav_switcher-app-icon-small__xOH_A","mobile-menu-trigger":"TrustNav_mobile-menu-trigger__HQgDV","hamburger-dash-2":"TrustNav_hamburger-dash-2__qYQMf","nav-container-full":"TrustNav_nav-container-full__XQXnM","header-logo-link":"TrustNav_header-logo-link__nHeXw","minisite-logo":"TrustNav_minisite-logo__k2JEr","is--large":"TrustNav_is--large__jmusE","is--small":"TrustNav_is--small__Gg6TP","for--trust":"TrustNav_for--trust__OHffo","nav-full-content":"TrustNav_nav-full-content__Ubqyy","for--crm":"TrustNav_for--crm__lwGKO","for--":"TrustNav_for--__twASX","nav-full-minisite-bottom":"TrustNav_nav-full-minisite-bottom__TxyZV","nav-minisite-group":"TrustNav_nav-minisite-group__QKY6y","minisite-links-group":"TrustNav_minisite-links-group__WDpW_","is-crm":"TrustNav_is-crm__LTH0Z","nav_link-ms":"TrustNav_nav_link-ms__3oW36","minisite-nav-mb":"TrustNav_minisite-nav-mb__61d2e","is-100vw":"TrustNav_is-100vw__tvg9j","mobile-nav-ms":"TrustNav_mobile-nav-ms__9lY7l","nav-container-lp":"TrustNav_nav-container-lp__SQrXH","header-logo-link-mb":"TrustNav_header-logo-link-mb__2ryrM","minisite-logo-mb":"TrustNav_minisite-logo-mb__SmDPK","is-small":"TrustNav_is-small__UjZRA","is-wm-copy":"TrustNav_is-wm-copy__q38Da","nav_menu-mobile":"TrustNav_nav_menu-mobile__S_egK","for--edit":"TrustNav_for--edit__miM3_","nav_menu-mobile-content":"TrustNav_nav_menu-mobile-content__VpDwy","mobile_menu-group":"TrustNav_mobile_menu-group__bMQPv","mobile_menu-group-h":"TrustNav_mobile_menu-group-h__3Fvxk","is-active":"TrustNav_is-active__4vdND","mobile_menu-group-h-text":"TrustNav_mobile_menu-group-h-text__A9Bwa","chevron":"TrustNav_chevron__EehzM","group-child":"TrustNav_group-child__VbzoC","_50-rem":"TrustNav__50-rem__k9bjO","_23-rem":"TrustNav__23-rem__n2nkQ","_28-rem":"TrustNav__28-rem__5tWVq","_24-rem":"TrustNav__24-rem__IlQl3","sub-group":"TrustNav_sub-group__PxhTm","bottom-margin":"TrustNav_bottom-margin__OSdtp","mobile-link":"TrustNav_mobile-link__NIMWC","_w-icon":"TrustNav__w-icon__kjq_d","is-title":"TrustNav_is-title__oKHCe","mobile-menu-ucon":"TrustNav_mobile-menu-ucon__xbDSD","mobile_menu-group-h-standalone":"TrustNav_mobile_menu-group-h-standalone__9FEbU","_w-border-bottom":"TrustNav__w-border-bottom__956P2","_w--icon":"TrustNav__w--icon__IVu7o","mb-menu-ai-icon":"TrustNav_mb-menu-ai-icon__cVClX","appstore-wrap":"TrustNav_appstore-wrap__m8OO_","badges-wrap":"TrustNav_badges-wrap__hUOuY","appstore-badge":"TrustNav_appstore-badge__6Jhch","appstore-badge-img":"TrustNav_appstore-badge-img__b4kR0","go-to-hp-btn":"TrustNav_go-to-hp-btn__8ARVj","go-to-hp-logo":"TrustNav_go-to-hp-logo__M6vTc","go-to-hp-arrow":"TrustNav_go-to-hp-arrow__dWbK_","full_mobile-menu-trigger":"TrustNav_full_mobile-menu-trigger__83cTH","hamburger-dash-full":"TrustNav_hamburger-dash-full__llCzx","nav_link-list-tb":"TrustNav_nav_link-list-tb__UnqtL","for--top":"TrustNav_for--top__UnSbf","is--wider":"TrustNav_is--wider__wA02x","for--mb":"TrustNav_for--mb__HMrba","is--tb":"TrustNav_is--tb__ijFJh","for--products":"TrustNav_for--products__Fwv5w","for--pricing":"TrustNav_for--pricing__HxYT0","for--overview":"TrustNav_for--overview__Vu3as","for--resources":"TrustNav_for--resources__CeP6M","dropdown-link-inner":"TrustNav_dropdown-link-inner__KfAQ5","dropdown-link-inner-text":"TrustNav_dropdown-link-inner-text__a5a3C","dropdown-link-inner-2":"TrustNav_dropdown-link-inner-2__ELLLv","nav-spacer":"TrustNav_nav-spacer__iRoRo","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220a3-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220a3-d842206d__PlI2F","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220aa-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220aa-d842206d__OqNJ7","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b1-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b1-d842206d__lgfYL","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b8-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220b8-d842206d__uwyS0","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220d9-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220d9-d842206d__ULVkB","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220e0-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220e0-d842206d___6fIt","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220eb-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220eb-d842206d__TnuI9","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ef-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ef-d842206d__Vryhk","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f3-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f3-d842206d__R_IyG","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f7-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220f7-d842206d__kv0__","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220fb-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220fb-d842206d__1ySgp","w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ff-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d84220ff-d842206d__qeuwX","w-node-ec4bbef8-f006-61da-6e6f-65d4d8422103-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d8422103-d842206d__PpRC6","w-node-ec4bbef8-f006-61da-6e6f-65d4d8422107-d842206d":"TrustNav_w-node-ec4bbef8-f006-61da-6e6f-65d4d8422107-d842206d___c5qX"};

/***/ })

}]);